import * as i0 from '@angular/core';
import { input, ChangeDetectionStrategy, Component, Injectable, HostBinding, Input, ViewEncapsulation, NgModule, Directive, forwardRef, output, model, inject, effect, ChangeDetectorRef, NgZone, HostListener, ElementRef, EventEmitter, Output, TemplateRef, SecurityContext, ViewChild, Inject, Attribute, ContentChild, Pipe, contentChild, contentChildren } from '@angular/core';
import * as i1$1 from '@ngx-translate/core';
import { TranslateModule, TranslateService, TranslateLoader } from '@ngx-translate/core';
import * as i1$2 from '@angular/common';
import { CommonModule, DOCUMENT } from '@angular/common';
import { BehaviorSubject, Observable, first, throwError, Subject, takeUntil, timer, fromEvent, Subscription, of, map as map$1, tap as tap$1, catchError as catchError$1, combineLatest, EMPTY, interval, switchMap as switchMap$1 } from 'rxjs';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpParams, HttpClient, HttpResponse, HttpEventType, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { nanoid } from 'nanoid';
import * as i2 from '@angular/forms';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, NG_ASYNC_VALIDATORS, FormsModule, NgControl } from '@angular/forms';
import { DateTime, Interval } from 'luxon';
import * as i1$3 from '@angular/platform-browser';
import * as i1$4 from 'ng-qrcode';
import { QrCodeModule } from 'ng-qrcode';
import { saveAs } from 'file-saver';
import { debounceTime, switchMap, map, first as first$1, catchError, throttleTime, tap, delay, shareReplay, share, take, filter, distinctUntilChanged, retry, takeUntil as takeUntil$1, skip, mergeMap } from 'rxjs/operators';
import * as i2$1 from '@angular/router';
import { RouterModule, NavigationEnd, NavigationStart } from '@angular/router';
import * as i2$2 from 'primeng/fileupload';
import { FileUploadModule } from 'primeng/fileupload';
import * as i3 from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { SelectButtonModule } from 'primeng/selectbutton';
import * as i1$5 from 'primeng/dialog';
import { DialogModule } from 'primeng/dialog';
import { query, style, animate, animation, group, trigger, transition, useAnimation } from '@angular/animations';
import * as _ from 'underscore';
import moment from 'moment';
import * as i5 from '@angular/cdk/scrolling';
import { CdkVirtualScrollViewport, ScrollingModule } from '@angular/cdk/scrolling';
import { DataSource } from '@angular/cdk/collections';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import * as i4 from 'ngx-image-cropper';
import { base64ToFile, ImageCropperComponent } from 'ngx-image-cropper';

/*

Usage:
<wg-badge [color]='red'>2</wg-badge>
<wg-badge [color]='accent'>2</wg-badge>

*/
const _c0 = ["*"];
function WgHListLabelComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "wg-icon", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("--icon-fill", ctx_r0.leadingIconColor());
    i0.ɵɵproperty("name", ctx_r0.leadingIcon())("size", ctx_r0.leadingIconSize());
  }
}
function WgHListLabelComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.number());
  }
}
function WgHListLabelComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("color", ctx_r0.labelColor());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 3, ctx_r0.label()));
  }
}
function WgHListLinkComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "wg-icon", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("--icon-fill", ctx_r0.leadingIconColor());
    i0.ɵɵproperty("name", ctx_r0.leadingIcon())("size", ctx_r0.leadingIconSize());
  }
}
function WgHListLinkComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.number());
  }
}
function WgHListLinkComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("color", ctx_r0.labelColor());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 3, ctx_r0.label()));
  }
}
function WgSchedulerComponent_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const hour_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(hour_r1);
  }
}
function WgSchedulerComponent_For_5_For_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 8);
    i0.ɵɵlistener("pointerdown", function WgSchedulerComponent_For_5_For_5_Template_li_pointerdown_0_listener($event) {
      const ɵ$index_17_r3 = i0.ɵɵrestoreView(_r2).$index;
      const ɵ$index_9_r4 = i0.ɵɵnextContext().$index;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.gridPointerdown($event, ɵ$index_9_r4, ɵ$index_17_r3));
    })("pointerenter", function WgSchedulerComponent_For_5_For_5_Template_li_pointerenter_0_listener($event) {
      const ɵ$index_17_r3 = i0.ɵɵrestoreView(_r2).$index;
      const ɵ$index_9_r4 = i0.ɵɵnextContext().$index;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.gridPointerenter($event, ɵ$index_9_r4, ɵ$index_17_r3));
    })("pointerleave", function WgSchedulerComponent_For_5_For_5_Template_li_pointerleave_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r4 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r4.gridPointerleave($event));
    });
    i0.ɵɵelement(1, "div", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ɵ$index_17_r3 = ctx.$index;
    const ɵ$index_9_r4 = i0.ɵɵnextContext().$index;
    i0.ɵɵattribute("data-day-index", ɵ$index_9_r4)("data-segment-index", ɵ$index_17_r3);
  }
}
function WgSchedulerComponent_For_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "ul", 6)(2, "li", 7);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(4, WgSchedulerComponent_For_5_For_5_Template, 2, 2, "li", null, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const day_r6 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(day_r6.label);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(day_r6.segments);
  }
}
function WgSchedulerComponent_For_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "div", 10);
    i0.ɵɵlistener("pointerdown", function WgSchedulerComponent_For_8_Template_div_pointerdown_1_listener($event) {
      const entry_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.resizerPointerdown($event, entry_r8, ctx_r4.WgSchedulerResizerType.leading));
    })("pointerenter", function WgSchedulerComponent_For_8_Template_div_pointerenter_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.resizerPointerenter($event, ctx_r4.WgSchedulerResizerType.leading));
    })("pointerup", function WgSchedulerComponent_For_8_Template_div_pointerup_1_listener($event) {
      const entry_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.resizerPointerup($event, entry_r8, ctx_r4.WgSchedulerResizerType.leading));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span", 11)(3, "span", 12);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 13);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span", 14);
    i0.ɵɵtext(9);
    i0.ɵɵelement(10, "br");
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "span", 15);
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div", 16);
    i0.ɵɵlistener("pointerdown", function WgSchedulerComponent_For_8_Template_div_pointerdown_16_listener($event) {
      const entry_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.resizerPointerdown($event, entry_r8, ctx_r4.WgSchedulerResizerType.trailing));
    })("pointerenter", function WgSchedulerComponent_For_8_Template_div_pointerenter_16_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.resizerPointerenter($event, ctx_r4.WgSchedulerResizerType.trailing));
    })("pointerup", function WgSchedulerComponent_For_8_Template_div_pointerup_16_listener($event) {
      const entry_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.resizerPointerup($event, entry_r8, ctx_r4.WgSchedulerResizerType.trailing));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const entry_r8 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("left", entry_r8.styleLeft)("right", entry_r8.styleRight)("top", entry_r8.styleTop);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(entry_r8.durationLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", entry_r8.durationLabel, " ", i0.ɵɵpipeBind1(7, 17, ctx_r4.translationKeys.ui_common_label_hours_short), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", entry_r8.startTime, " - ", entry_r8.endTime, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", entry_r8.durationLabel, " ", i0.ɵɵpipeBind1(12, 19, ctx_r4.translationKeys.ui_common_label_hours_short), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate4("", entry_r8.startTime, " - ", entry_r8.endTime, " \u2022 ", entry_r8.durationLabel, " ", i0.ɵɵpipeBind1(15, 21, ctx_r4.translationKeys.ui_common_label_hours_short), "");
  }
}
function WgSchedulerComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "li", 9);
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("left", ctx_r4.hoverLeft)("right", ctx_r4.hoverRight)("top", ctx_r4.hoverTop);
  }
}
function WgLinkComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "wg-icon", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r0.leadingIcon());
  }
}
function WgLinkComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "wg-icon", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r0.trailingIcon());
  }
}
function WgRadioComponent_p_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 2);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r0.detailText), " ");
  }
}
const _c1 = ["button"];
function WgButtonComponent_wg_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "wg-icon", 5);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r0.icon);
  }
}
function WgButtonComponent_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵprojection(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r0.label), " ");
  }
}
function WgButtonComponent_wg_icon_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "wg-icon", 6);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r0.icon);
  }
}
function WgQrcodeBannerComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "img", 6);
    i0.ɵɵlistener("error", function WgQrcodeBannerComponent_ng_container_1_Template_img_error_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleImageLoadError());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r1.brandingLogoUrl, i0.ɵɵsanitizeUrl);
  }
}
function WgQrcodeBannerComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "h2", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", ctx_r1.titleText);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.titleText, " ");
  }
}
function WgQrcodeBannerComponent_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "span", 9);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, "qr_ssid_lbl"), ": ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", ctx_r1.ssid);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.ssid, " ");
  }
}
function WgQrcodeBannerComponent_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "span", 9);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, "qr_passphrase_lbl"), ": ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", ctx_r1.passphrase);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.passphrase, " ");
  }
}
function WgQrcodeBannerComponent_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label", 10);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", ctx_r1.footerText);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.footerText, " ");
  }
}
function WgQrcodeBannerComponent_div_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "p")(2, "a", 12);
    i0.ɵɵlistener("click", function WgQrcodeBannerComponent_div_8_Template_a_click_2_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.printQRCode());
    });
    i0.ɵɵelement(3, "wg-icon", 13);
    i0.ɵɵelementStart(4, "span", 14);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(7, "p")(8, "a", 12);
    i0.ɵɵlistener("click", function WgQrcodeBannerComponent_div_8_Template_a_click_8_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.downloadQRCode());
    });
    i0.ɵɵelement(9, "wg-icon", 15);
    i0.ɵɵelementStart(10, "span", 14);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 2, "qr_create_pdf_lbl"), " ");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 4, "qr_download_ssid_lbl"), " ");
  }
}
function LoaderComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "span", 4);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 5)(3, "defs")(4, "clipPath", 6);
    i0.ɵɵelement(5, "path", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "g", 8)(7, "clipPath", 9);
    i0.ɵɵelement(8, "path", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "g", 11);
    i0.ɵɵelement(10, "path", 12)(11, "path", 13)(12, "path", 14)(13, "path", 15)(14, "path", 16)(15, "path", 17)(16, "path", 18)(17, "path", 19)(18, "path", 20)(19, "path", 21);
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", ctx_r0.iconStyles);
  }
}
function LoaderComponent_ng_content_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 0, ["*ngIf", "isLoading"]);
  }
}
function ShowErrorsComponent_div_0_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const error_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(error_r1);
  }
}
function ShowErrorsComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, ShowErrorsComponent_div_0_span_1_Template, 2, 1, "span", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.listOfErrors());
  }
}
const _c2 = ["selector"];
const _c3 = a0 => [a0];
function WgChipsComponent_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WgChipsComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WgChipsComponent_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const regularChip_r1 = i0.ɵɵreference(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", regularChip_r1);
  }
}
function WgChipsComponent_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WgChipsComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WgChipsComponent_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const chipWithDialog_r2 = i0.ɵɵreference(6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", chipWithDialog_r2);
  }
}
function WgChipsComponent_ng_template_3_span_2_a_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 12);
    i0.ɵɵlistener("click", function WgChipsComponent_ng_template_3_span_2_a_2_Template_a_click_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const item_r6 = i0.ɵɵnextContext().$implicit;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.removeClick(item_r6, $event));
    });
    i0.ɵɵelement(1, "wg-icon", 13);
    i0.ɵɵelementEnd();
  }
}
function WgChipsComponent_ng_template_3_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, WgChipsComponent_ng_template_3_span_2_a_2_Template, 2, 0, "a", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r6 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("btn-danger", ctx_r3.invalidItem(item_r6));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r6, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r3.disabled);
  }
}
function WgChipsComponent_ng_template_3_input_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 14, 2);
    i0.ɵɵlistener("keydown", function WgChipsComponent_ng_template_3_input_3_Template_input_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.inputEvent($event));
    })("ngModelChange", function WgChipsComponent_ng_template_3_input_3_Template_input_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.onInputChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("hidden", ctx_r3.disabled)("ngModel", ctx_r3.optionInput)("placeholder", ctx_r3.placeholder);
    i0.ɵɵattribute("disabled", ctx_r3.disabled ? "disabled" : null);
  }
}
function WgChipsComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵlistener("focus", function WgChipsComponent_ng_template_3_Template_div_focus_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.focusToInput());
    });
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵtemplate(2, WgChipsComponent_ng_template_3_span_2_Template, 3, 4, "span", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, WgChipsComponent_ng_template_3_input_3_Template, 2, 4, "input", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c3, ctx_r3.className));
    i0.ɵɵadvance();
    i0.ɵɵattribute("disabled", ctx_r3.disabled ? "disabled" : null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3.chipsList);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r3.disabled);
  }
}
function WgChipsComponent_ng_template_5_span_2_ng_container_1_wg_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "wg-icon", 24);
  }
  if (rf & 2) {
    const elem_r10 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate("name", elem_r10);
    i0.ɵɵproperty("size", 20);
  }
}
function WgChipsComponent_ng_template_5_span_2_ng_container_1_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const elem_r10 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, elem_r10), " ");
  }
}
function WgChipsComponent_ng_template_5_span_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WgChipsComponent_ng_template_5_span_2_ng_container_1_wg_icon_1_Template, 1, 2, "wg-icon", 23)(2, WgChipsComponent_ng_template_5_span_2_ng_container_1_span_2_Template, 3, 3, "span", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const elem_r10 = ctx.$implicit;
    const i_r11 = ctx.index;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i_r11 === 0 && elem_r10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i_r11 === 1);
  }
}
function WgChipsComponent_ng_template_5_span_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵtemplate(1, WgChipsComponent_ng_template_5_span_2_ng_container_1_Template, 3, 2, "ng-container", 20);
    i0.ɵɵpipe(2, "slice");
    i0.ɵɵelementStart(3, "a", 21);
    i0.ɵɵlistener("click", function WgChipsComponent_ng_template_5_span_2_Template_a_click_3_listener($event) {
      const item_r12 = i0.ɵɵrestoreView(_r9).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.removeClick(item_r12, $event));
    });
    i0.ɵɵelement(4, "wg-icon", 22);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r12 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(2, 2, item_r12.split(":::"), 0, item_r12.length - 1));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("size", 20);
  }
}
function WgChipsComponent_ng_template_5_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 25);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r3.placeholder), " ");
  }
}
function WgChipsComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 7);
    i0.ɵɵtemplate(2, WgChipsComponent_ng_template_5_span_2_Template, 5, 6, "span", 16)(3, WgChipsComponent_ng_template_5_span_3_Template, 3, 3, "span", 17);
    i0.ɵɵelementStart(4, "a", 18);
    i0.ɵɵlistener("click", function WgChipsComponent_ng_template_5_Template_a_click_4_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.showSelectionPopup());
    });
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c3, ctx_r3.className));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r3.chipsList);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.chipsList.length === 0);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("disabled", ctx_r3.disabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 6, ctx_r3.selectionText), " ");
  }
}
const _c4 = ["header"];
const _c5 = ["body"];
const _c6 = ["back"];
function WgCardComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WgCardComponent_a_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 5);
    i0.ɵɵelement(1, "wg-icon", 6);
    i0.ɵɵelementEnd();
  }
}
function WgCardComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WgCardComponent_div_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WgCardComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, WgCardComponent_div_5_ng_container_1_Template, 1, 0, "ng-container", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.backTemplate);
  }
}
function WgBreadcrumbsComponent_ul_0_ng_container_1_li_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtext(1, "\xA0/\xA0");
    i0.ɵɵelementEnd();
  }
}
function WgBreadcrumbsComponent_ul_0_ng_container_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 2);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", item_r1.route);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, item_r1.label));
  }
}
function WgBreadcrumbsComponent_ul_0_ng_container_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 3);
    i0.ɵɵlistener("click", function WgBreadcrumbsComponent_ul_0_ng_container_1_ng_container_4_Template_a_click_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const item_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.clickLink($event, item_r1.arg));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, item_r1.label));
  }
}
function WgBreadcrumbsComponent_ul_0_ng_container_1_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, item_r1.label), " ");
  }
}
function WgBreadcrumbsComponent_ul_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WgBreadcrumbsComponent_ul_0_ng_container_1_li_1_Template, 2, 0, "li", 0);
    i0.ɵɵelementStart(2, "li");
    i0.ɵɵtemplate(3, WgBreadcrumbsComponent_ul_0_ng_container_1_ng_container_3_Template, 4, 4, "ng-container", 0)(4, WgBreadcrumbsComponent_ul_0_ng_container_1_ng_container_4_Template, 4, 3, "ng-container", 0)(5, WgBreadcrumbsComponent_ul_0_ng_container_1_ng_container_5_Template, 3, 3, "ng-container", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const index_r4 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", index_r4 > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", index_r4 < ctx_r2.items.length - 1 && item_r1.route);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", index_r4 < ctx_r2.items.length - 1 && !item_r1.route && item_r1.arg);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", index_r4 >= ctx_r2.items.length - 1 || !(item_r1.route || item_r1.arg));
  }
}
function WgBreadcrumbsComponent_ul_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul");
    i0.ɵɵtemplate(1, WgBreadcrumbsComponent_ul_0_ng_container_1_Template, 6, 4, "ng-container", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.items);
  }
}
const _c7 = ["fileInput"];
const _c8 = ["uploader"];
const _c9 = a0 => ({
  width: a0
});
function WgFileUploadComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("keydown.enter", function WgFileUploadComponent_ng_template_4_Template_div_keydown_enter_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const fileInput_r3 = i0.ɵɵreference(16);
      return i0.ɵɵresetView(fileInput_r3.click());
    })("keydown.space", function WgFileUploadComponent_ng_template_4_Template_div_keydown_space_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const fileInput_r3 = i0.ɵɵreference(16);
      return i0.ɵɵresetView(fileInput_r3.click());
    });
    i0.ɵɵelementStart(1, "div", 5)(2, "div", 6)(3, "a", 7);
    i0.ɵɵlistener("click", function WgFileUploadComponent_ng_template_4_Template_a_click_3_listener() {
      i0.ɵɵrestoreView(_r2);
      const fileInput_r3 = i0.ɵɵreference(16);
      return i0.ɵɵresetView(fileInput_r3.click());
    });
    i0.ɵɵelement(4, "wg-icon", 8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "p");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelement(8, "br");
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div")(12, "a", 9);
    i0.ɵɵlistener("click", function WgFileUploadComponent_ng_template_4_Template_a_click_12_listener() {
      i0.ɵɵrestoreView(_r2);
      const fileInput_r3 = i0.ɵɵreference(16);
      return i0.ɵɵresetView(fileInput_r3.click());
    });
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "input", 10, 1);
    i0.ɵɵlistener("change", function WgFileUploadComponent_ng_template_4_Template_input_change_15_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.selectFileByInput($event));
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(17, "div", 11)(18, "a", 12);
    i0.ɵɵlistener("click", function WgFileUploadComponent_ng_template_4_Template_a_click_18_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.removeFile());
    });
    i0.ɵɵelement(19, "wg-icon", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 14);
    i0.ɵɵelement(21, "wg-icon", 15);
    i0.ɵɵelementStart(22, "p", 16);
    i0.ɵɵtext(23);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("file-upload-show-details", ctx_r3.fileUpload.files[0]);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(22, _c9, ctx_r3.width));
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("disabled", ctx_r3.isDisabled);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 16, "file_upload_drag_and_drop_file"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 18, "file_upload_or"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("disabled", ctx_r3.isDisabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 20, "file_upload_select_file"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("display", "none");
    i0.ɵɵproperty("accept", ctx_r3.accept)("disabled", ctx_r3.isDisabled);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("title", ctx_r3.fileUpload.files[0] == null ? null : ctx_r3.fileUpload.files[0].name);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r3.fileUpload.files[0] == null ? null : ctx_r3.fileUpload.files[0].name, " ");
  }
}
function WgRefreshComponent_wg_loader_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "wg-loader", 3);
  }
  if (rf & 2) {
    i0.ɵɵproperty("scale", 2)("modal", true);
  }
}
function WgSelectButtonComponent_label_2_wg_icon_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "wg-icon", 7);
  }
  if (rf & 2) {
    const option_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("name", option_r2.icon);
  }
}
function WgSelectButtonComponent_label_2_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, option_r2.text));
  }
}
function WgSelectButtonComponent_label_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 3);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementStart(2, "input", 4);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵlistener("click", function WgSelectButtonComponent_label_2_Template_input_click_2_listener() {
      const option_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onButtonClick(option_r2));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, WgSelectButtonComponent_label_2_wg_icon_4_Template, 1, 1, "wg-icon", 5)(5, WgSelectButtonComponent_label_2_span_5_Template, 3, 3, "span", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r2 = ctx.$implicit;
    i0.ɵɵclassMap(option_r2.cssClass);
    i0.ɵɵclassProp("active", option_r2.selected)("disabled", option_r2.disabled);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 11, option_r2.tooltip || option_r2.text || ""));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(3, 13, option_r2.tooltip || option_r2.text || ""))("disabled", option_r2.disabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", option_r2.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", option_r2.text);
  }
}
const _c10 = [[["", 8, "header"]], [["", 8, "content"]]];
const _c11 = [".header", ".content"];
const _c12 = [[["", "dialog-content", ""]], [["", "dialog-title", ""]], [["", "dialog-footer", ""]]];
const _c13 = ["[dialog-content]", "[dialog-title]", "[dialog-footer]"];
function WgDialogComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
function WgDialogComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 2);
  }
}
function WgConfirmDialogComponent_ng_container_5_p_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p", 10);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const c_r2 = ctx.$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, c_r2), i0.ɵɵsanitizeHtml);
  }
}
function WgConfirmDialogComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WgConfirmDialogComponent_ng_container_5_p_1_Template, 2, 3, "p", 9);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.content);
  }
}
function WgConfirmDialogComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p", 10);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, ctx_r2.content.toString()), i0.ɵɵsanitizeHtml);
  }
}
function WgConfirmProgressDialogComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "wg-progress");
    i0.ɵɵelement(2, "wg-progress-bar", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p", 10);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", ctx_r0.progressValue)("striped", true)("animated", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 4, ctx_r0.progressDescription.toString()), i0.ɵɵsanitizeHtml);
  }
}
function WgConfirmProgressDialogComponent_ng_container_6_ng_container_1_p_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p", 10);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const c_r2 = ctx.$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, c_r2), i0.ɵɵsanitizeHtml);
  }
}
function WgConfirmProgressDialogComponent_ng_container_6_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WgConfirmProgressDialogComponent_ng_container_6_ng_container_1_p_1_Template, 2, 3, "p", 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.content);
  }
}
function WgConfirmProgressDialogComponent_ng_container_6_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p", 10);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, ctx_r0.content.toString()), i0.ɵɵsanitizeHtml);
  }
}
function WgConfirmProgressDialogComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WgConfirmProgressDialogComponent_ng_container_6_ng_container_1_Template, 2, 1, "ng-container", 11)(2, WgConfirmProgressDialogComponent_ng_container_6_ng_template_2_Template, 2, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const singleContent_r3 = i0.ɵɵreference(3);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.multipleContents())("ngIfElse", singleContent_r3);
  }
}
function WgConfirmProgressDialogComponent_button_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵlistener("click", function WgConfirmProgressDialogComponent_button_9_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.dialogDeny());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", !ctx_r0.cancelBtnStr ? i0.ɵɵpipeBind1(2, 1, "ui_common_label_no") : i0.ɵɵpipeBind1(3, 3, ctx_r0.cancelBtnStr), " ");
  }
}
function WgConfirmProgressDialogComponent_button_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function WgConfirmProgressDialogComponent_button_10_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.dialogConfirm());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", "btn-" + ctx_r0.confirmBtnClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", !ctx_r0.confirmBtnStr ? i0.ɵɵpipeBind1(2, 2, "ui_common_label_yes") : i0.ɵɵpipeBind1(3, 4, ctx_r0.confirmBtnStr), " ");
  }
}
const _c14 = (a0, a1) => ({
  "disabled": a0,
  "show-password": a1
});
const _c15 = ["image"];
const _c16 = a0 => ({
  "disabled": a0
});
function MainContentComponent_ng_template_1_Template(rf, ctx) {}
const _c17 = a0 => ({
  "has-nav-buttons": a0
});
const _c18 = a0 => ({
  "active": a0
});
function DeviceBannerComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3)(2, "a", 4);
    i0.ɵɵlistener("click", function DeviceBannerComponent_ng_container_3_Template_a_click_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.openLiveStatus());
    });
    i0.ɵɵtext(3, "Live Status ");
    i0.ɵɵelement(4, "wg-icon", 5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
}
function DeviceBannerComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 6)(2, "button", 7);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 7);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("routerLink", "/" + ctx_r1.getRouterLink("reports/", ctx_r1.firstRoute));
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c18, ctx_r1.firstActive));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 6, ctx_r1.firstLabel), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("routerLink", "/" + ctx_r1.getRouterLink("services/", ctx_r1.secondRoute));
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c18, ctx_r1.secondActive));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 8, ctx_r1.secondLabel), " ");
  }
}
const _c19 = ["contentContainer"];
const _c20 = ["resizer"];
const _c21 = ["secondaryContainer"];
const _c22 = ["treeContainer"];
const _c23 = [[["section", 8, "content"]], [["section", 8, "tree"]], [["section", 8, "secondary"]]];
const _c24 = ["section.content", "section.tree", "section.secondary"];
const _c25 = a0 => ({
  collapsed: a0
});
function LayoutTscComponent_ng_content_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1, ["*ngIf", "!this.collapsed"]);
  }
}
function LayoutTscComponent_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12, 3);
    i0.ɵɵprojection(2, 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("left", ctx_r1.secondaryLeft);
  }
}
const _c26 = ["selectedOptionsContainer"];
const _c27 = a0 => ({
  "toggled-height": a0
});
function WgSelectorComponent_span_3_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const selectedOption_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", selectedOption_r3[ctx_r3.tag], " ");
  }
}
function WgSelectorComponent_span_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 10)(1, "a", 11);
    i0.ɵɵlistener("click", function WgSelectorComponent_span_3_Template_a_click_1_listener() {
      const selectedOption_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.emitClickedOptionEvent(selectedOption_r3));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, WgSelectorComponent_span_3_span_4_Template, 2, 1, "span", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "a", 13);
    i0.ɵɵlistener("click", function WgSelectorComponent_span_3_Template_a_click_5_listener() {
      const selectedOption_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.remove(selectedOption_r3));
    });
    i0.ɵɵelement(6, "wg-icon", 14);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const selectedOption_r3 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("not-clickable", ctx_r3.selectedOptionClick.observers.length === 0);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, selectedOption_r3[ctx_r3.label]), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.tag && selectedOption_r3[ctx_r3.tag]);
  }
}
function WgSelectorComponent_ul_9_ng_container_1_li_2_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const selectorOption_r7 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, selectorOption_r7.item[ctx_r3.tag]), " ");
  }
}
function WgSelectorComponent_ul_9_ng_container_1_li_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 20);
    i0.ɵɵlistener("click", function WgSelectorComponent_ul_9_ng_container_1_li_2_Template_li_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.setOption());
    })("mousedown", function WgSelectorComponent_ul_9_ng_container_1_li_2_Template_li_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.preventDefault($event));
    })("mouseenter", function WgSelectorComponent_ul_9_ng_container_1_li_2_Template_li_mouseenter_0_listener() {
      const selectorOption_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.mouseOver(selectorOption_r7));
    })("mouseleave", function WgSelectorComponent_ul_9_ng_container_1_li_2_Template_li_mouseleave_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.clearFocus());
    });
    i0.ɵɵelement(1, "span", 21);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "highlight");
    i0.ɵɵtemplate(4, WgSelectorComponent_ul_9_ng_container_1_li_2_span_4_Template, 3, 3, "span", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const selectorOption_r7 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(selectorOption_r7.item.cssClass);
    i0.ɵɵclassProp("focused", selectorOption_r7.focused);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(3, 8, i0.ɵɵpipeBind1(2, 6, selectorOption_r7.item[ctx_r3.label]), ctx_r3.inputValue), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r3.tag && selectorOption_r7.item[ctx_r3.tag]);
  }
}
function WgSelectorComponent_ul_9_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "cdk-virtual-scroll-viewport", 18);
    i0.ɵɵtemplate(2, WgSelectorComponent_ul_9_ng_container_1_li_2_Template, 5, 11, "li", 19);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const availableLength_r8 = ctx.ngIf;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("height", ctx_r3.getHeight(availableLength_r8));
    i0.ɵɵproperty("itemSize", ctx_r3.itemHeightPx);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cdkVirtualForOf", i0.ɵɵpipeBind1(3, 4, ctx_r3.lists$).availableItems);
  }
}
function WgSelectorComponent_ul_9_ng_template_3_li_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r3.noneFound, " ");
  }
}
function WgSelectorComponent_ul_9_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, WgSelectorComponent_ul_9_ng_template_3_li_0_Template, 2, 1, "li", 22);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r3.noneFound);
  }
}
function WgSelectorComponent_ul_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 16);
    i0.ɵɵtemplate(1, WgSelectorComponent_ul_9_ng_container_1_Template, 4, 6, "ng-container", 17);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, WgSelectorComponent_ul_9_ng_template_3_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_4_0;
    const noneFoundTemplate_r9 = i0.ɵɵreference(4);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (tmp_4_0 = i0.ɵɵpipeBind1(2, 2, ctx_r3.lists$).availableItems) == null ? null : tmp_4_0.length)("ngIfElse", noneFoundTemplate_r9);
  }
}
const _c28 = [[["wg-panel-header-left"]], [["wg-panel-header-right"]]];
const _c29 = ["wg-panel-header-left", "wg-panel-header-right"];
function WgPanelHeaderComponent_Conditional_1_Conditional_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "wg-toggle", 4);
    i0.ɵɵtwoWayListener("toggleChange", function WgPanelHeaderComponent_Conditional_1_Conditional_1_Conditional_0_Template_wg_toggle_toggleChange_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r1.toggleValue, $event) || (ctx_r1.toggleValue = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵtwoWayProperty("toggle", ctx_r1.toggleValue);
  }
}
function WgPanelHeaderComponent_Conditional_1_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "wg-icon", 5);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵstyleProp("--icon-fill", ctx_r1.leadingIconColor());
    i0.ɵɵproperty("name", ctx_r1.leadingIcon())("size", ctx_r1.leadingIconSize());
  }
}
function WgPanelHeaderComponent_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, WgPanelHeaderComponent_Conditional_1_Conditional_1_Conditional_0_Template, 1, 1, "wg-toggle", 2)(1, WgPanelHeaderComponent_Conditional_1_Conditional_1_Conditional_1_Template, 1, 4, "wg-icon", 3);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r1.toggle() ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.leadingIcon() ? 1 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, ctx_r1.titleLabel()));
  }
}
function WgPanelHeaderComponent_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function WgPanelHeaderComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵtemplate(1, WgPanelHeaderComponent_Conditional_1_Conditional_1_Template, 5, 5)(2, WgPanelHeaderComponent_Conditional_1_Conditional_2_Template, 1, 0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.titleLabel() ? 1 : 2);
  }
}
function WgPanelHeaderComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
  }
}
const _c30 = [[["wg-panel-content"]], [["wg-panel-header"]], "*"];
const _c31 = ["wg-panel-content", "wg-panel-header", "*"];
function WgPanelComponent_Conditional_0_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "wg-icon", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", ctx_r1.collapsibleIcon);
  }
}
function WgPanelComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "header", 2);
    i0.ɵɵlistener("click", function WgPanelComponent_Conditional_0_Conditional_1_Template_header_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.toggleCollapsed());
    });
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵprojection(2, 1);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, WgPanelComponent_Conditional_0_Conditional_1_Conditional_3_Template, 2, 1, "div");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("wgComponentStateLayer", ctx_r1.collapsible());
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.collapsible() ? 3 : -1);
  }
}
function WgPanelComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, WgPanelComponent_Conditional_0_Conditional_1_Template, 4, 2, "header", 1);
    i0.ɵɵelementStart(2, "section")(3, "div");
    i0.ɵɵprojection(4);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.header() ? 1 : -1);
  }
}
function WgPanelComponent_Conditional_1_Conditional_1_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WgPanelComponent_Conditional_1_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, WgPanelComponent_Conditional_1_Conditional_1_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 4);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.contentChildHeaderTemplate());
  }
}
function WgPanelComponent_Conditional_1_Conditional_1_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WgPanelComponent_Conditional_1_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, WgPanelComponent_Conditional_1_Conditional_1_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 4);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.headerTemplate());
  }
}
function WgPanelComponent_Conditional_1_Conditional_1_Conditional_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "wg-icon", 3);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("name", ctx_r1.headerIcon());
  }
}
function WgPanelComponent_Conditional_1_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, WgPanelComponent_Conditional_1_Conditional_1_Conditional_3_Conditional_0_Template, 1, 1, "wg-icon", 3);
    i0.ɵɵelementStart(1, "h5");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵconditional(ctx_r1.headerIcon() ? 0 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, ctx_r1.headerTitle()));
  }
}
function WgPanelComponent_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "header");
    i0.ɵɵtemplate(1, WgPanelComponent_Conditional_1_Conditional_1_Conditional_1_Template, 1, 1, "ng-container")(2, WgPanelComponent_Conditional_1_Conditional_1_Conditional_2_Template, 1, 1, "ng-container")(3, WgPanelComponent_Conditional_1_Conditional_1_Conditional_3_Template, 4, 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.contentChildHeaderTemplate() ? 1 : ctx_r1.headerTemplate() ? 2 : 3);
  }
}
function WgPanelComponent_Conditional_1_Conditional_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WgPanelComponent_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, WgPanelComponent_Conditional_1_Conditional_3_ng_container_0_Template, 1, 0, "ng-container", 4);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.contentChildBodyTemplate());
  }
}
function WgPanelComponent_Conditional_1_Conditional_4_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WgPanelComponent_Conditional_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, WgPanelComponent_Conditional_1_Conditional_4_ng_container_0_Template, 1, 0, "ng-container", 4);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.bodyTemplate());
  }
}
function WgPanelComponent_Conditional_1_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 2);
  }
}
function WgPanelComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵtemplate(1, WgPanelComponent_Conditional_1_Conditional_1_Template, 4, 1, "header");
    i0.ɵɵelementStart(2, "section");
    i0.ɵɵtemplate(3, WgPanelComponent_Conditional_1_Conditional_3_Template, 1, 1, "ng-container")(4, WgPanelComponent_Conditional_1_Conditional_4_Template, 1, 1, "ng-container")(5, WgPanelComponent_Conditional_1_Conditional_5_Template, 1, 0);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.contentChildHeaderTemplate() || ctx_r1.headerTemplate() || ctx_r1.headerTitle() || ctx_r1.headerIcon() ? 1 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.contentChildBodyTemplate() ? 3 : ctx_r1.bodyTemplate() ? 4 : 5);
  }
}
function WgSlideInPanelComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "header")(1, "h4");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "a", 0);
    i0.ɵɵlistener("click", function WgSlideInPanelComponent_Conditional_0_Template_a_click_4_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.hide());
    });
    i0.ɵɵelement(5, "wg-icon", 1);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, ctx_r1.title));
  }
}
function WgSlideInPanelComponent_Conditional_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WgSlideInPanelComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WgSlideInPanelComponent_Conditional_3_ng_container_1_Template, 1, 0, "ng-container", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.template);
  }
}
const _c32 = ["widgetContainer"];
function WgWidgetPanelComponent_ng_container_1_ng_template_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WgWidgetPanelComponent_ng_container_1_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, WgWidgetPanelComponent_ng_container_1_ng_template_1_ng_container_0_Template, 1, 0, "ng-container", 6);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.headerContentTemplate);
  }
}
function WgWidgetPanelComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WgWidgetPanelComponent_ng_container_1_ng_template_1_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
}
function WgWidgetPanelComponent_ng_container_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WgWidgetPanelComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WgWidgetPanelComponent_ng_container_5_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.body);
  }
}
function WgWidgetPanelComponent_ng_container_6_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WgWidgetPanelComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WgWidgetPanelComponent_ng_container_6_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.bodyTemplate);
  }
}
function WgWidgetPanelComponent_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵprojection(1);
    i0.ɵɵelementContainerEnd();
  }
}
const _c33 = ["dropdownMenu"];
function WgDropdownAsyncComponent_a_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 10);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "highlight");
    i0.ɵɵlistener("click", function WgDropdownAsyncComponent_a_11_Template_a_click_0_listener($event) {
      const item_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.itemSelected(item_r3, $event));
    })("mouseenter", function WgDropdownAsyncComponent_a_11_Template_a_mouseenter_0_listener() {
      const ctx_r4 = i0.ɵɵrestoreView(_r2);
      const item_r3 = ctx_r4.$implicit;
      const index_r6 = ctx_r4.index;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.itemHovered(item_r3, index_r6));
    })("mouseleave", function WgDropdownAsyncComponent_a_11_Template_a_mouseleave_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.itemBlurred());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("hover", item_r3.id === ctx_r3.hoveredItemId)("active", item_r3.id === ctx_r3.activeItemId)("disabled", !item_r3 || !item_r3[ctx_r3.label]);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 8, item_r3 && item_r3[ctx_r3.label] || "ui_common_loading"))("innerHTML", i0.ɵɵpipeBind2(3, 12, i0.ɵɵpipeBind1(2, 10, item_r3 && item_r3[ctx_r3.label] || "ui_common_loading"), item_r3 && item_r3[ctx_r3.label] && ctx_r3.inputValue), i0.ɵɵsanitizeHtml);
  }
}
function WgDropdownAsyncComponent_div_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "a", 12);
    i0.ɵɵlistener("click", function WgDropdownAsyncComponent_div_12_Template_a_click_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      return i0.ɵɵresetView($event.stopImmediatePropagation());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "ui_common_loading"));
  }
}
const _c34 = a0 => ({
  "ng-invalid": a0
});
const _c35 = a0 => ({
  "btn-danger": a0
});
const _c36 = a0 => ({
  show: a0
});
const _c37 = a0 => ({
  count: a0
});
const _c38 = (a0, a1, a2) => ({
  separator: a0,
  hover: a1,
  active: a2
});
function WgDropdownComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵelement(2, "wg-icon", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(ctx_r0.selectedItem.iconColorClass);
    i0.ɵɵproperty("name", ctx_r0.selectedItem.icon);
  }
}
function WgDropdownComponent_wg_icon_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "wg-icon", 13);
  }
}
function WgDropdownComponent_wg_icon_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "wg-icon", 14);
  }
}
function WgDropdownComponent_wg_icon_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "wg-icon", 15);
    i0.ɵɵlistener("click", function WgDropdownComponent_wg_icon_10_Template_wg_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.clearInputValue());
    });
    i0.ɵɵelementEnd();
  }
}
function WgDropdownComponent_div_11_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19)(1, "small");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, "enter_more_chars_to_search", i0.ɵɵpureFunction1(4, _c37, ctx_r0.maxSearchHits)));
  }
}
function WgDropdownComponent_div_11_ng_container_3_a_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 22)(1, "label", 23);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMap(item_r3.cssClass);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 3, item_r3.val));
  }
}
function WgDropdownComponent_div_11_ng_container_3_a_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "wg-icon", 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("wg-mr-5 ", item_r3.iconColorClass, "");
    i0.ɵɵproperty("name", item_r3.icon);
  }
}
function WgDropdownComponent_div_11_ng_container_3_a_2_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 27);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("innerHTML", item_r3.label ? i0.ɵɵpipeBind1(1, 1, item_r3.label) : "", i0.ɵɵsanitizeHtml);
  }
}
function WgDropdownComponent_div_11_ng_container_3_a_2_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 27);
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("innerHTML", item_r3.label ? item_r3.label : "", i0.ɵɵsanitizeHtml);
  }
}
function WgDropdownComponent_div_11_ng_container_3_a_2_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, item_r3.tag));
  }
}
function WgDropdownComponent_div_11_ng_container_3_a_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 24);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("mousedown", function WgDropdownComponent_div_11_ng_container_3_a_2_Template_a_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const item_r3 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.itemSelected($event, item_r3));
    })("mouseenter", function WgDropdownComponent_div_11_ng_container_3_a_2_Template_a_mouseenter_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const item_r3 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.itemHovered($event, item_r3, true));
    })("mouseleave", function WgDropdownComponent_div_11_ng_container_3_a_2_Template_a_mouseleave_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const item_r3 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.itemHovered($event, item_r3, false));
    });
    i0.ɵɵtemplate(2, WgDropdownComponent_div_11_ng_container_3_a_2_ng_container_2_Template, 2, 4, "ng-container", 3)(3, WgDropdownComponent_div_11_ng_container_3_a_2_span_3_Template, 2, 3, "span", 25)(4, WgDropdownComponent_div_11_ng_container_3_a_2_span_4_Template, 1, 1, "span", 25)(5, WgDropdownComponent_div_11_ng_container_3_a_2_span_5_Template, 3, 3, "span", 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(item_r3.cssClass);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 8, item_r3.val));
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(10, _c38, item_r3.separator, item_r3.hover, item_r3.active));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r3.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.translateValues);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.translateValues);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r3.tag);
  }
}
function WgDropdownComponent_div_11_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WgDropdownComponent_div_11_ng_container_3_a_1_Template, 4, 5, "a", 20)(2, WgDropdownComponent_div_11_ng_container_3_a_2_Template, 6, 14, "a", 21);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r3.categoryLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !item_r3.categoryLabel);
  }
}
function WgDropdownComponent_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16, 0);
    i0.ɵɵtemplate(2, WgDropdownComponent_div_11_div_2_Template, 4, 6, "div", 17)(3, WgDropdownComponent_div_11_ng_container_3_Template, 3, 2, "ng-container", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c36, ctx_r0.showSuggestion));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.searchMode && ctx_r0.items.length >= ctx_r0.maxSearchHits);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.items);
  }
}
const _c39 = a0 => ({
  "dropdown-menu-right": a0
});
const _c40 = a0 => ({
  disabled: a0
});
function WgInlineNotificationComponent_div_0_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WgInlineNotificationComponent_div_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WgInlineNotificationComponent_div_0_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.customTemplate);
  }
}
function WgInlineNotificationComponent_div_0_ng_container_3_h5_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h5");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r0.title));
  }
}
function WgInlineNotificationComponent_div_0_ng_container_3_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "br")(2, "br");
    i0.ɵɵelementContainerEnd();
  }
}
function WgInlineNotificationComponent_div_0_ng_container_3_a_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 7);
    i0.ɵɵlistener("click", function WgInlineNotificationComponent_div_0_ng_container_3_a_6_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.messageLinkClicked());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("routerLink", ctx_r0.messageLinkRoute);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, ctx_r0.messageLinkLabel));
  }
}
function WgInlineNotificationComponent_div_0_ng_container_3_a_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 8);
    i0.ɵɵlistener("click", function WgInlineNotificationComponent_div_0_ng_container_3_a_7_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.removeNotification());
    });
    i0.ɵɵelement(1, "wg-icon", 9);
    i0.ɵɵelementEnd();
  }
}
function WgInlineNotificationComponent_div_0_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WgInlineNotificationComponent_div_0_ng_container_3_h5_1_Template, 3, 3, "h5", 2);
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, WgInlineNotificationComponent_div_0_ng_container_3_ng_container_5_Template, 3, 0, "ng-container", 2)(6, WgInlineNotificationComponent_div_0_ng_container_3_a_6_Template, 3, 4, "a", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, WgInlineNotificationComponent_div_0_ng_container_3_a_7_Template, 2, 0, "a", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 5, ctx_r0.message), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.messageLinkLabel && ctx_r0.messageLinkLabelOnNewLine);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.messageLinkLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.allowClose);
  }
}
function WgInlineNotificationComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "wg-icon", 1);
    i0.ɵɵtemplate(2, WgInlineNotificationComponent_div_0_ng_container_2_Template, 2, 1, "ng-container", 2)(3, WgInlineNotificationComponent_div_0_ng_container_3_Template, 8, 7, "ng-container", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("notification ", ctx_r0.type, "");
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("notification-icon ", ctx_r0.type, "");
    i0.ɵɵproperty("name", ctx_r0.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.customTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.customTemplate);
  }
}
function WgNotificationsComponent_For_1_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "wg-icon", 5);
  }
  if (rf & 2) {
    const notification_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMapInterpolate1("notification-icon ", notification_r1.typeClass, "");
  }
}
function WgNotificationsComponent_For_1_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "wg-icon", 6);
  }
  if (rf & 2) {
    const notification_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMapInterpolate1("notification-icon ", notification_r1.typeClass, "");
  }
}
function WgNotificationsComponent_For_1_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "wg-icon", 7);
  }
  if (rf & 2) {
    const notification_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMapInterpolate1("notification-icon ", notification_r1.typeClass, "");
  }
}
function WgNotificationsComponent_For_1_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "wg-icon", 8);
  }
  if (rf & 2) {
    const notification_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMapInterpolate1("notification-icon ", notification_r1.typeClass, "");
  }
}
function WgNotificationsComponent_For_1_Conditional_5_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WgNotificationsComponent_For_1_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, WgNotificationsComponent_For_1_Conditional_5_ng_container_0_Template, 1, 0, "ng-container", 9);
  }
  if (rf & 2) {
    const notification_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngTemplateOutlet", notification_r1.customTemplate);
  }
}
function WgNotificationsComponent_For_1_Conditional_6_a_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 14);
    i0.ɵɵlistener("click", function WgNotificationsComponent_For_1_Conditional_6_a_3_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const notification_r1 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.messageLinkClicked(notification_r1));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const notification_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("routerLink", notification_r1.messageLinkRoute);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, notification_r1.messageLinkLabel));
  }
}
function WgNotificationsComponent_For_1_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, WgNotificationsComponent_For_1_Conditional_6_a_3_Template, 3, 4, "a", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "a", 12);
    i0.ɵɵlistener("click", function WgNotificationsComponent_For_1_Conditional_6_Template_a_click_4_listener() {
      i0.ɵɵrestoreView(_r2);
      const notification_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.hideNotification(notification_r1));
    });
    i0.ɵɵelement(5, "wg-icon", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const notification_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, notification_r1.message), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", notification_r1.messageLinkLabel);
  }
}
function WgNotificationsComponent_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, WgNotificationsComponent_For_1_Case_1_Template, 1, 3, "wg-icon", 1)(2, WgNotificationsComponent_For_1_Case_2_Template, 1, 3, "wg-icon", 2)(3, WgNotificationsComponent_For_1_Case_3_Template, 1, 3, "wg-icon", 3)(4, WgNotificationsComponent_For_1_Case_4_Template, 1, 3, "wg-icon", 4)(5, WgNotificationsComponent_For_1_Conditional_5_Template, 1, 1, "ng-container")(6, WgNotificationsComponent_For_1_Conditional_6_Template, 6, 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_13_0;
    const notification_r1 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("notification ", notification_r1.typeClass, "");
    i0.ɵɵclassProp("fade-in", notification_r1.fadeIn)("fade-out", notification_r1.fadeOut);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_13_0 = notification_r1.type) === ctx_r3.notificationTypes.Info ? 1 : tmp_13_0 === ctx_r3.notificationTypes.Success ? 2 : tmp_13_0 === ctx_r3.notificationTypes.Error ? 3 : tmp_13_0 === ctx_r3.notificationTypes.Warn ? 4 : -1);
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(notification_r1.customTemplate ? 5 : 6);
  }
}
const _c41 = a0 => ({
  bottom: a0
});
function WgAsyncReportsComponent_div_0_div_1_div_1_div_1_ng_template_2_span_0_h5_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h5");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const notification_r2 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(notification_r2.title);
  }
}
function WgAsyncReportsComponent_div_0_div_1_div_1_div_1_ng_template_2_span_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, WgAsyncReportsComponent_div_0_div_1_div_1_div_1_ng_template_2_span_0_h5_1_Template, 2, 1, "h5", 2);
    i0.ɵɵelementStart(2, "span", 8);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 9)(5, "a", 10);
    i0.ɵɵlistener("click", function WgAsyncReportsComponent_div_0_div_1_div_1_div_1_ng_template_2_span_0_Template_a_click_5_listener() {
      i0.ɵɵrestoreView(_r1);
      const notification_r2 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.reportNotificationLinkClicked(notification_r2));
    });
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "a", 11);
    i0.ɵɵlistener("click", function WgAsyncReportsComponent_div_0_div_1_div_1_div_1_ng_template_2_span_0_Template_a_click_8_listener() {
      i0.ɵɵrestoreView(_r1);
      const notification_r2 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.reportNotificationClosed(notification_r2));
    });
    i0.ɵɵelement(9, "wg-icon", 12);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const notification_r2 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.notificationObjects.length);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", notification_r2.message, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 3, notification_r2.downloadMessage), " ");
  }
}
function WgAsyncReportsComponent_div_0_div_1_div_1_div_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, WgAsyncReportsComponent_div_0_div_1_div_1_div_1_ng_template_2_span_0_Template, 10, 5, "span", 2);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("ngIf", !ctx_r2.isToasterHidden);
  }
}
function WgAsyncReportsComponent_div_0_div_1_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "wg-inline-notification", 7);
    i0.ɵɵtemplate(2, WgAsyncReportsComponent_div_0_div_1_div_1_div_1_ng_template_2_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const myTemplate_r4 = i0.ɵɵreference(3);
    const notification_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(3, _c41, notification_r2.positionVariable));
    i0.ɵɵadvance();
    i0.ɵɵproperty("customTemplate", myTemplate_r4)("type", "success");
  }
}
function WgAsyncReportsComponent_div_0_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, WgAsyncReportsComponent_div_0_div_1_div_1_div_1_Template, 4, 5, "div", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const notification_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", notification_r2["type"] === "success");
  }
}
function WgAsyncReportsComponent_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, WgAsyncReportsComponent_div_0_div_1_div_1_Template, 2, 1, "div", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const notifications_r5 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", notifications_r5);
  }
}
function WgAsyncReportsComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, WgAsyncReportsComponent_div_0_div_1_Template, 2, 1, "div", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.notificationObjects);
  }
}
function WgAsyncReportsComponent_div_1_div_1_div_1_wg_inline_notification_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "wg-inline-notification", 14);
    i0.ɵɵlistener("close", function WgAsyncReportsComponent_div_1_div_1_div_1_wg_inline_notification_2_Template_wg_inline_notification_close_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const notification_r7 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.errorNotificationClosed(notification_r7));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const notification_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("title", notification_r7.title)("message", notification_r7.message)("type", notification_r7.type)("allow-close", true);
  }
}
function WgAsyncReportsComponent_div_1_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 6);
    i0.ɵɵtemplate(2, WgAsyncReportsComponent_div_1_div_1_div_1_wg_inline_notification_2_Template, 1, 4, "wg-inline-notification", 13);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const notification_r7 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(2, _c41, notification_r7.positionVariable));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", notification_r7.numberOfFailedReports);
  }
}
function WgAsyncReportsComponent_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, WgAsyncReportsComponent_div_1_div_1_div_1_Template, 3, 4, "div", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const errNotifications_r8 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", errNotifications_r8);
  }
}
function WgAsyncReportsComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, WgAsyncReportsComponent_div_1_div_1_Template, 2, 1, "div", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.errorNotificationObject);
  }
}
function WgImageCropperComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21)(1, "p", 22);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, ctx_r1.imageDescription), " ");
  }
}
function WgImageCropperComponent_img_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 23);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("src", ctx_r1.image, i0.ɵɵsanitizeUrl);
  }
}
function WgImageCropperComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 24);
    i0.ɵɵlistener("click", function WgImageCropperComponent_ng_template_11_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const hiddenfileselect_r4 = i0.ɵɵreference(9);
      return i0.ɵɵresetView(hiddenfileselect_r4.click());
    });
    i0.ɵɵelement(1, "wg-icon", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "p", 26);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "a", 27);
    i0.ɵɵlistener("click", function WgImageCropperComponent_ng_template_11_Template_a_click_5_listener() {
      i0.ɵɵrestoreView(_r3);
      const hiddenfileselect_r4 = i0.ɵɵreference(9);
      return i0.ɵɵresetView(hiddenfileselect_r4.click());
    });
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "input", 28, 2);
    i0.ɵɵlistener("change", function WgImageCropperComponent_ng_template_11_Template_input_change_8_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onImageChanged($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 2, "image_cropper_drap_and_drop_label"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 4, "image_cropper_select_file_label"), " ");
  }
}
function WgImageCropperComponent_wg_loader_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "wg-loader", 29);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const imageCropperContainer_r5 = i0.ɵɵreference(18);
    i0.ɵɵproperty("scale", 1)("modal", true)("ovelayElement", imageCropperContainer_r5);
  }
}
class WgBadgeComponent {
  constructor() {
    this.color = input.required();
  }
  static {
    this.ɵfac = function WgBadgeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgBadgeComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgBadgeComponent,
      selectors: [["wg-badge"]],
      hostVars: 4,
      hostBindings: function WgBadgeComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("red", ctx.color() === "red")("accent", ctx.color() === "accent");
        }
      },
      inputs: {
        color: [1, "color"]
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function WgBadgeComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: [".red[_nghost-%COMP%]{background-color:var(--color-brand-primary)}.accent[_nghost-%COMP%]{background-color:var(--color-brand-accent)}[_nghost-%COMP%]{height:16px;align-items:center;display:inline-flex;box-sizing:border-box;justify-content:center;border-radius:var(--radius-md);font-size:var(--font-font-size-sm);color:var(--color-brand-on-accent);padding:0 var(--spacing-sm) 0 var(--spacing-sm);border:1px solid var(--color-surface-on-surface)}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgBadgeComponent, [{
    type: Component,
    args: [{
      selector: 'wg-badge',
      standalone: true,
      template: `<ng-content />`,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        '[class.red]': 'color() === "red"',
        '[class.accent]': 'color() === "accent"'
      },
      styles: [":host.red{background-color:var(--color-brand-primary)}:host.accent{background-color:var(--color-brand-accent)}:host{height:16px;align-items:center;display:inline-flex;box-sizing:border-box;justify-content:center;border-radius:var(--radius-md);font-size:var(--font-font-size-sm);color:var(--color-brand-on-accent);padding:0 var(--spacing-sm) 0 var(--spacing-sm);border:1px solid var(--color-surface-on-surface)}\n"]
    }]
  }], null, null);
})();
const WgDividerOrientation = {
  horizontal: 'horizontal',
  vertical: 'vertical'
};
class WgDividerComponent {
  constructor() {
    this.orientation = input(WgDividerOrientation.horizontal);
  }
  static {
    this.ɵfac = function WgDividerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgDividerComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgDividerComponent,
      selectors: [["wg-divider"]],
      hostVars: 1,
      hostBindings: function WgDividerComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("data-orientation", ctx.orientation());
        }
      },
      inputs: {
        orientation: [1, "orientation"]
      },
      decls: 0,
      vars: 0,
      template: function WgDividerComponent_Template(rf, ctx) {},
      styles: ["[_nghost-%COMP%]{background-color:var(--color-control-divider);display:block;margin:var(--spacing-md) 0;height:1px}[data-orientation=vertical][_nghost-%COMP%]{align-self:stretch;display:inline-flex;height:inherit;margin:0 var(--spacing-sm);width:1px}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgDividerComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      selector: 'wg-divider',
      imports: [],
      template: '',
      host: {
        '[attr.data-orientation]': 'orientation()'
      },
      styles: [":host{background-color:var(--color-control-divider);display:block;margin:var(--spacing-md) 0;height:1px}:host[data-orientation=vertical]{align-self:stretch;display:inline-flex;height:inherit;margin:0 var(--spacing-sm);width:1px}\n"]
    }]
  }], null, null);
})();
class WgHListComponent {
  static {
    this.ɵfac = function WgHListComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgHListComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgHListComponent,
      selectors: [["wg-h-list"]],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function WgHListComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{align-items:center;display:flex;flex-wrap:wrap;font:var(--font-standard-sm);gap:var(--spacing-xs) var(--spacing-sm)}[_nghost-%COMP%]    >.wg-h-list-item:has(+.wg-h-list-item):after{align-self:stretch;background-color:var(--color-control-divider);content:\"\";display:inline-block;margin:var(--spacing-none) var(--spacing-none) var(--spacing-none) var(--spacing-sm);width:1px}[_nghost-%COMP%]    +wg-h-list{margin-top:var(--spacing-xs)}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgHListComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      selector: 'wg-h-list',
      standalone: true,
      imports: [],
      template: "<ng-content></ng-content>\n",
      styles: [":host{align-items:center;display:flex;flex-wrap:wrap;font:var(--font-standard-sm);gap:var(--spacing-xs) var(--spacing-sm)}:host ::ng-deep>.wg-h-list-item:has(+.wg-h-list-item):after{align-self:stretch;background-color:var(--color-control-divider);content:\"\";display:inline-block;margin:var(--spacing-none) var(--spacing-none) var(--spacing-none) var(--spacing-sm);width:1px}:host ::ng-deep+wg-h-list{margin-top:var(--spacing-xs)}\n"]
    }]
  }], null, null);
})();
const WgIconSizes = {
  XS: 'xs',
  SM: 'sm',
  MD: 'md'
};
const WgIconSizeInPixels = {
  xs: 16,
  sm: 20,
  md: 24
};
const ICON_FILE_VERSION = 3;
const ALIAS_JSON_URL = `/images/wgc/svg-icons-v${ICON_FILE_VERSION}/aliases.json`;
const ICON_JSON_URL = `/images/wgc/svg-icons-v${ICON_FILE_VERSION}/icons.json`;
class WgIconService {
  constructor(http) {
    this.http = http;
    this.dataLoaded = false;
    this.icon2023FeatureFlag = false;
    this.icons = new Map();
    this.iconAliases = new Map();
    this.dataLoadedSubject = new BehaviorSubject({
      loaded: false,
      icons: this.icons
    });
    this.loadData();
  }
  getIcon(iconName) {
    return new Observable(observer => {
      if (this.dataLoaded) {
        this.retrieveIcon(observer, iconName);
        return;
      }
      this.dataLoadedSubject.subscribe(dataLoaded => {
        if (dataLoaded.loaded) {
          this.retrieveIcon(observer, iconName);
        }
      });
    });
  }
  getIcons() {
    return new Observable(observer => {
      if (this.dataLoaded) {
        observer.next(this.icons);
        observer.complete();
        return;
      }
      this.dataLoadedSubject.subscribe(dataLoaded => {
        if (dataLoaded.loaded) {
          observer.next(this.icons);
          observer.complete();
        }
      });
    });
  }
  downloadData(sessionInfo) {
    let jsonUrl = ICON_JSON_URL;
    let aliasUrl = ALIAS_JSON_URL;
    this.http.get(jsonUrl).pipe(first()).subscribe({
      next: icons => {
        this.processIcons(icons);
        this.http.get(aliasUrl).pipe(first()).subscribe({
          next: aliases => {
            this.processIconAliases(aliases);
            this.dataLoaded = true;
            this.dataLoadedSubject.next({
              loaded: true,
              icons: this.icons
            });
          },
          error: error => {
            this.dataLoaded = true;
            this.dataLoadedSubject.next({
              loaded: true,
              icons: this.icons
            });
          }
        });
      },
      error: error => throwError(() => new Error(error.json()))
    });
  }
  loadData() {
    this.downloadData();
  }
  processIcons(icons) {
    if (icons) {
      const keys = Object.keys(icons);
      if (keys && keys.length > 0) {
        keys.forEach(key => {
          const icon = {
            name: key,
            svgs: new Map()
          };
          const svgSizes = Object.keys(icons[key]);
          if (svgSizes && svgSizes.length > 0) {
            svgSizes.forEach(svgSize => {
              icon.svgs.set(svgSize, icons[key][svgSize]);
            });
          }
          this.icons.set(key, icon);
        });
      }
    }
  }
  processIconAliases(aliases) {
    if (aliases) {
      const keys = Object.keys(aliases);
      if (keys && keys.length > 0) {
        keys.forEach(key => {
          const iconAliases = aliases[key];
          // add aliases to this.icons map entry
          if (this.icons.has(key)) {
            this.icons.get(key).aliases = iconAliases;
          }
          // add aliases to a local "alias:icon name" map for quick lookups
          if (iconAliases && iconAliases.length > 0) {
            iconAliases.forEach(iconAlias => {
              this.iconAliases.set(iconAlias, key);
            });
          }
        });
      }
    }
  }
  retrieveIcon(observer, iconName, size = WgIconSizes.MD) {
    // check for aliases
    if (this.iconAliases.has(iconName)) {
      iconName = this.iconAliases.get(iconName);
    }
    observer.next(this.icons.get(iconName));
    observer.complete();
  }
  static {
    this.ɵfac = function WgIconService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgIconService)(i0.ɵɵinject(i1.HttpClient));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: WgIconService,
      factory: WgIconService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgIconService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }], null);
})();
class WgIconComponent {
  constructor(elementRef, iconService, renderer) {
    this.elementRef = elementRef;
    this.iconService = iconService;
    this.renderer = renderer;
  }
  ngAfterViewInit() {
    this.htmlElement = this.elementRef.nativeElement;
    this.iconService.dataLoadedSubject.subscribe(dataLoaded => {
      if (!dataLoaded.loaded) {
        return;
      }
      setTimeout(() => {
        if (dataLoaded.loaded) {
          // probably not needed once the 2023 new icons are deployed but won't hurt anything
          this.removeSizeClasses();
        }
      });
    });
    this.handleSizeChange();
    this.getIcon();
  }
  ngOnChanges(changes) {
    if (changes.hasOwnProperty('size') && !changes.size.firstChange && this.isNumber(changes.size.currentValue)) {
      this.iconService.dataLoadedSubject.subscribe(dataLoaded => {
        if (dataLoaded.loaded) {
          this.handleSizeChange();
        }
      });
    }
    if (changes.hasOwnProperty('name') && !changes.name.isFirstChange() || changes.hasOwnProperty('size') && !changes.size.isFirstChange()) {
      this.getIcon();
    }
  }
  getAvailableIconSize(requestedSize) {
    if (!requestedSize) {
      return WgIconSizes.MD;
    }
    switch (requestedSize) {
      case WgIconSizes.XS:
        if (this.currentIcon.svgs.has(WgIconSizes.XS)) {
          return WgIconSizes.XS;
        }
      case WgIconSizes.SM:
        if (this.currentIcon.svgs.has(WgIconSizes.SM)) {
          return WgIconSizes.SM;
        }
      default:
        return WgIconSizes.MD;
    }
  }
  getIcon() {
    this.iconService.getIcon(this.name).pipe(first()).subscribe({
      next: icon => {
        this.currentIcon = icon;
        this.updateHtml();
      },
      error: () => {
        this.currentIcon = undefined;
      }
    });
  }
  handleSizeChange() {
    if (this.size === undefined || this.size === null) {
      this.htmlElement.style.removeProperty('--icon-size');
      return;
    }
    const size = this.isNumber(this.size) ? this.size : WgIconSizeInPixels[this.size];
    this.htmlElement.style.setProperty('--icon-size', `${size}px`);
  }
  isNumber(value) {
    return Number.isFinite(value);
  }
  removeSizeClasses() {
    // probably not needed once the 2023 new icons are deployed but won't hurt anything
    if (!this.htmlElement) {
      return;
    }
    const toRemove = [];
    this.htmlElement.classList.forEach(className => {
      if (className.startsWith('size-')) {
        toRemove.push(className);
      }
    });
    toRemove.forEach(className => {
      this.renderer.removeClass(this.htmlElement, className);
    });
  }
  updateCurrentSize() {
    if (!this.isNumber(this.size)) {
      return;
    }
    const size = this.size;
    if (size <= WgIconSizeInPixels[WgIconSizes.XS]) {
      this.currentSize = WgIconSizes.XS;
    } else if (size <= WgIconSizeInPixels[WgIconSizes.SM]) {
      this.currentSize = WgIconSizes.SM;
    } else {
      this.currentSize = WgIconSizes.MD;
    }
  }
  updateHtml() {
    if (this.currentIcon) {
      this.updateCurrentSize();
      let size = this.size && !this.isNumber(this.size) ? this.size : this.currentSize;
      const svg = this.currentIcon.svgs.get(this.getAvailableIconSize(size));
      this.elementRef.nativeElement.innerHTML = svg;
      this.handleSizeChange();
    } else {
      this.elementRef.nativeElement.innerHTML = '';
    }
  }
  static {
    this.ɵfac = function WgIconComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgIconComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(WgIconService), i0.ɵɵdirectiveInject(i0.Renderer2));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgIconComponent,
      selectors: [["wg-icon"]],
      hostVars: 2,
      hostBindings: function WgIconComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("data-name", ctx.name)("data-size", ctx.size);
        }
      },
      inputs: {
        name: "name",
        size: "size"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 0,
      vars: 0,
      template: function WgIconComponent_Template(rf, ctx) {},
      styles: ["wg-icon{--icon-size: 24px;display:inline-block;height:var(--icon-height, var(--icon-size))!important;line-height:0!important;width:var(--icon-width, var(--icon-size))!important}wg-icon svg,wg-icon svg path,wg-icon svg circle{fill:var(--icon-fill, var(--color-surface-on-surface, #606060));stroke:var(--icon-stroke, transparent)}wg-icon>svg{height:var(--icon-height, var(--icon-size))!important;min-height:var(--icon-height, var(--icon-size))!important;min-width:var(--icon-width, var(--icon-size))!important;width:var(--icon-width, var(--icon-size))!important}wg-icon.rotate-90{transform:rotate(0)}wg-icon.rotate-90 svg{transform:rotate(90deg)}wg-icon.rotate-180{transform:rotate(0)}wg-icon.rotate-180 svg{transform:rotate(180deg)}wg-icon.rotate-270{transform:rotate(0)}wg-icon.rotate-270 svg{transform:rotate(270deg)}wg-icon.flex{display:inline-flex}wg-icon.color-pacific{--icon-fill: var(--color-brand-accent)}wg-icon.disabled{opacity:.6}[class^=wg-icon-],[class*=\" wg-icon-\"]{font-family:wg-icon!important;line-height:1}wg-icon[data-name^=signal-strength]{--icon-fill: var(--neutral-80);--icon-width: 37.5px;--icon-height: 24px}wg-icon[data-name^=signal-strength][class^=bars-].bars-1>svg>path:nth-child(-n+1),wg-icon[data-name^=signal-strength][class*=\" bars-\"].bars-1>svg>path:nth-child(-n+1){--icon-fill: var(--success-40)}wg-icon[data-name^=signal-strength][class^=bars-].bars-2>svg>path:nth-child(-n+2),wg-icon[data-name^=signal-strength][class*=\" bars-\"].bars-2>svg>path:nth-child(-n+2){--icon-fill: var(--success-40)}wg-icon[data-name^=signal-strength][class^=bars-].bars-3>svg>path:nth-child(-n+3),wg-icon[data-name^=signal-strength][class*=\" bars-\"].bars-3>svg>path:nth-child(-n+3){--icon-fill: var(--success-40)}wg-icon[data-name^=signal-strength][class^=bars-].bars-4>svg>path:nth-child(-n+4),wg-icon[data-name^=signal-strength][class*=\" bars-\"].bars-4>svg>path:nth-child(-n+4){--icon-fill: var(--success-40)}wg-icon[data-name^=signal-strength][class^=bars-].bars-5>svg>path:nth-child(-n+5),wg-icon[data-name^=signal-strength][class*=\" bars-\"].bars-5>svg>path:nth-child(-n+5){--icon-fill: var(--success-40)}wg-icon.task-icon.completed,.wg-dashboard wg-icon.task-icon.completed{--icon-fill: var(--success-40)}wg-icon.task-icon.pending,.wg-dashboard wg-icon.task-icon.pending{--icon-fill: var(--pumpkin-60)}wg-icon.task-icon.failed,.wg-dashboard wg-icon.task-icon.failed{--icon-fill: var(--wg-red-40)}wg-icon.task-icon.scheduled,.wg-dashboard wg-icon.task-icon.scheduled{--icon-fill: var(--pacific-70)}wg-icon[name=microsoft-excel] svg path,wg-icon[name=microsoft-excel] svg svg circle,wg-icon[ng-reflect-name=microsoft-excel] svg path,wg-icon[ng-reflect-name=microsoft-excel] svg svg circle{fill:#fff!important}wg-icon[name=microsoft-excel] svg path:nth-of-type(1),wg-icon[name=microsoft-excel] svg svg circle:nth-of-type(1),wg-icon[ng-reflect-name=microsoft-excel] svg path:nth-of-type(1),wg-icon[ng-reflect-name=microsoft-excel] svg svg circle:nth-of-type(1){fill:#4caf50!important}wg-icon[name=microsoft-excel] svg path:nth-last-of-type(2),wg-icon[name=microsoft-excel] svg svg circle:nth-last-of-type(2),wg-icon[ng-reflect-name=microsoft-excel] svg path:nth-last-of-type(2),wg-icon[ng-reflect-name=microsoft-excel] svg svg circle:nth-last-of-type(2){fill:#2e7d32!important}wg-icon[name=flag],wg-icon[ng-reflect-name=flag]{--icon-fill: var(--wg-red-40)}wg-icon[name=activated],wg-icon[ng-reflect-name=activated]{--icon-fill: var(--success-40)}wg-icon[name=circle-exclamation],wg-icon[ng-reflect-name=circle-exclamation]{--icon-fill: var(--wg-red-40)}wg-icon[name=loading],wg-icon[ng-reflect-name=loading],wg-icon[data-name=loading]{animation:wg-icon-animation-spin-clockwise 1s infinite steps(8);display:inline-block}@keyframes wg-icon-animation-spin-clockwise{0%{transform:rotate(0)}to{transform:rotate(359deg)}}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgIconComponent, [{
    type: Component,
    args: [{
      encapsulation: ViewEncapsulation.None,
      selector: 'wg-icon',
      template: '',
      standalone: false,
      styles: ["wg-icon{--icon-size: 24px;display:inline-block;height:var(--icon-height, var(--icon-size))!important;line-height:0!important;width:var(--icon-width, var(--icon-size))!important}wg-icon svg,wg-icon svg path,wg-icon svg circle{fill:var(--icon-fill, var(--color-surface-on-surface, #606060));stroke:var(--icon-stroke, transparent)}wg-icon>svg{height:var(--icon-height, var(--icon-size))!important;min-height:var(--icon-height, var(--icon-size))!important;min-width:var(--icon-width, var(--icon-size))!important;width:var(--icon-width, var(--icon-size))!important}wg-icon.rotate-90{transform:rotate(0)}wg-icon.rotate-90 svg{transform:rotate(90deg)}wg-icon.rotate-180{transform:rotate(0)}wg-icon.rotate-180 svg{transform:rotate(180deg)}wg-icon.rotate-270{transform:rotate(0)}wg-icon.rotate-270 svg{transform:rotate(270deg)}wg-icon.flex{display:inline-flex}wg-icon.color-pacific{--icon-fill: var(--color-brand-accent)}wg-icon.disabled{opacity:.6}[class^=wg-icon-],[class*=\" wg-icon-\"]{font-family:wg-icon!important;line-height:1}wg-icon[data-name^=signal-strength]{--icon-fill: var(--neutral-80);--icon-width: 37.5px;--icon-height: 24px}wg-icon[data-name^=signal-strength][class^=bars-].bars-1>svg>path:nth-child(-n+1),wg-icon[data-name^=signal-strength][class*=\" bars-\"].bars-1>svg>path:nth-child(-n+1){--icon-fill: var(--success-40)}wg-icon[data-name^=signal-strength][class^=bars-].bars-2>svg>path:nth-child(-n+2),wg-icon[data-name^=signal-strength][class*=\" bars-\"].bars-2>svg>path:nth-child(-n+2){--icon-fill: var(--success-40)}wg-icon[data-name^=signal-strength][class^=bars-].bars-3>svg>path:nth-child(-n+3),wg-icon[data-name^=signal-strength][class*=\" bars-\"].bars-3>svg>path:nth-child(-n+3){--icon-fill: var(--success-40)}wg-icon[data-name^=signal-strength][class^=bars-].bars-4>svg>path:nth-child(-n+4),wg-icon[data-name^=signal-strength][class*=\" bars-\"].bars-4>svg>path:nth-child(-n+4){--icon-fill: var(--success-40)}wg-icon[data-name^=signal-strength][class^=bars-].bars-5>svg>path:nth-child(-n+5),wg-icon[data-name^=signal-strength][class*=\" bars-\"].bars-5>svg>path:nth-child(-n+5){--icon-fill: var(--success-40)}wg-icon.task-icon.completed,.wg-dashboard wg-icon.task-icon.completed{--icon-fill: var(--success-40)}wg-icon.task-icon.pending,.wg-dashboard wg-icon.task-icon.pending{--icon-fill: var(--pumpkin-60)}wg-icon.task-icon.failed,.wg-dashboard wg-icon.task-icon.failed{--icon-fill: var(--wg-red-40)}wg-icon.task-icon.scheduled,.wg-dashboard wg-icon.task-icon.scheduled{--icon-fill: var(--pacific-70)}wg-icon[name=microsoft-excel] svg path,wg-icon[name=microsoft-excel] svg svg circle,wg-icon[ng-reflect-name=microsoft-excel] svg path,wg-icon[ng-reflect-name=microsoft-excel] svg svg circle{fill:#fff!important}wg-icon[name=microsoft-excel] svg path:nth-of-type(1),wg-icon[name=microsoft-excel] svg svg circle:nth-of-type(1),wg-icon[ng-reflect-name=microsoft-excel] svg path:nth-of-type(1),wg-icon[ng-reflect-name=microsoft-excel] svg svg circle:nth-of-type(1){fill:#4caf50!important}wg-icon[name=microsoft-excel] svg path:nth-last-of-type(2),wg-icon[name=microsoft-excel] svg svg circle:nth-last-of-type(2),wg-icon[ng-reflect-name=microsoft-excel] svg path:nth-last-of-type(2),wg-icon[ng-reflect-name=microsoft-excel] svg svg circle:nth-last-of-type(2){fill:#2e7d32!important}wg-icon[name=flag],wg-icon[ng-reflect-name=flag]{--icon-fill: var(--wg-red-40)}wg-icon[name=activated],wg-icon[ng-reflect-name=activated]{--icon-fill: var(--success-40)}wg-icon[name=circle-exclamation],wg-icon[ng-reflect-name=circle-exclamation]{--icon-fill: var(--wg-red-40)}wg-icon[name=loading],wg-icon[ng-reflect-name=loading],wg-icon[data-name=loading]{animation:wg-icon-animation-spin-clockwise 1s infinite steps(8);display:inline-block}@keyframes wg-icon-animation-spin-clockwise{0%{transform:rotate(0)}to{transform:rotate(359deg)}}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: WgIconService
  }, {
    type: i0.Renderer2
  }], {
    name: [{
      type: HostBinding,
      args: ['attr.data-name']
    }, {
      type: Input
    }],
    size: [{
      type: HostBinding,
      args: ['attr.data-size']
    }, {
      type: Input
    }]
  });
})();
class WgIconModule {
  static {
    this.ɵfac = function WgIconModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgIconModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgIconModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgIconModule, [{
    type: NgModule,
    args: [{
      exports: [WgIconComponent],
      imports: [CommonModule],
      declarations: [WgIconComponent]
    }]
  }], null, null);
})();
var WgCssColors;
(function (WgCssColors) {
  WgCssColors["brandAccent"] = "var(--color-brand-accent)";
  WgCssColors["brandAccentContainer"] = "var(--color-brand-accent-container)";
  WgCssColors["brandOnAccent"] = "var(--color-brand-on-accent)";
  WgCssColors["brandOnAccentContainer"] = "var(--color-brand-on-accent-container)";
  WgCssColors["brandOnPrimary"] = "var(--color-brand-on-primary)";
  WgCssColors["brandOnPrimaryContainer"] = "var(--color-brand-on-primary-container)";
  WgCssColors["brandOnSecondary"] = "var(--color-brand-on-secondary)";
  WgCssColors["brandOnSecondaryContainer"] = "var(--color-brand-on-secondary-container)";
  WgCssColors["brandPrimary"] = "var(--color-brand-primary)";
  WgCssColors["brandPrimaryContainer"] = "var(--color-brand-primary-container)";
  WgCssColors["brandSecondary"] = "var(--color-brand-secondary)";
  WgCssColors["brandSecondaryContainer"] = "var(--color-brand-secondary-container)";
  WgCssColors["chart00"] = "var(--color-chart-00)";
  WgCssColors["chart01"] = "var(--color-chart-01)";
  WgCssColors["chart02"] = "var(--color-chart-02)";
  WgCssColors["chart03"] = "var(--color-chart-03)";
  WgCssColors["chart04"] = "var(--color-chart-04)";
  WgCssColors["chart05"] = "var(--color-chart-05)";
  WgCssColors["chart06"] = "var(--color-chart-06)";
  WgCssColors["chart07"] = "var(--color-chart-07)";
  WgCssColors["chart08"] = "var(--color-chart-08)";
  WgCssColors["chart09"] = "var(--color-chart-09)";
  WgCssColors["chartOnChart"] = "var(--color-chart-on-chart)";
  WgCssColors["controlBorder"] = "var(--color-control-border)";
  WgCssColors["controlDivider"] = "var(--color-control-divider)";
  WgCssColors["controlInverseBorder"] = "var(--color-control-inverse-border)";
  WgCssColors["controlInverseDivider"] = "var(--color-control-inverse-divider)";
  WgCssColors["controlScrim"] = "var(--color-control-scrim)";
  WgCssColors["controlSurfaceTrack"] = "var(--color-control-surface-track)";
  WgCssColors["riskCritical"] = "var(--color-risk-critical)";
  WgCssColors["riskCriticalContainer"] = "var(--color-risk-critical-container)";
  WgCssColors["riskHigh"] = "var(--color-risk-high)";
  WgCssColors["riskHighContainer"] = "var(--color-risk-high-container)";
  WgCssColors["riskLow"] = "var(--color-risk-low)";
  WgCssColors["riskLowContainer"] = "var(--color-risk-low-container)";
  WgCssColors["riskMedium"] = "var(--color-risk-medium)";
  WgCssColors["riskMediumContainer"] = "var(--color-risk-medium-container)";
  WgCssColors["riskOnCritical"] = "var(--color-risk-on-critical)";
  WgCssColors["riskOnCriticalContainer"] = "var(--color-risk-on-critical-container)";
  WgCssColors["riskOnHigh"] = "var(--color-risk-on-high)";
  WgCssColors["riskOnHighContainer"] = "var(--color-risk-on-high-container)";
  WgCssColors["riskOnLow"] = "var(--color-risk-on-low)";
  WgCssColors["riskOnLowContainer"] = "var(--color-risk-on-low-container)";
  WgCssColors["riskOnMedium"] = "var(--color-risk-on-medium)";
  WgCssColors["riskOnMediumContainer"] = "var(--color-risk-on-medium-container)";
  WgCssColors["statusError"] = "var(--color-status-error)";
  WgCssColors["statusErrorContainer"] = "var(--color-status-error-container)";
  WgCssColors["statusInformative"] = "var(--color-status-informative)";
  WgCssColors["statusInformativeContainer"] = "var(--color-status-informative-container)";
  WgCssColors["statusNeutral"] = "var(--color-status-neutral)";
  WgCssColors["statusNeutralContainer"] = "var(--color-status-neutral-container)";
  WgCssColors["statusOnError"] = "var(--color-status-on-error)";
  WgCssColors["statusOnErrorContainer"] = "var(--color-status-on-error-container)";
  WgCssColors["statusOnInformative"] = "var(--color-status-on-informative)";
  WgCssColors["statusOnInformativeContainer"] = "var(--color-status-on-informative-container)";
  WgCssColors["statusOnNeutral"] = "var(--color-status-on-neutral)";
  WgCssColors["statusOnNeutralContainer"] = "var(--color-status-on-neutral-container)";
  WgCssColors["statusOnSuccess"] = "var(--color-status-on-success)";
  WgCssColors["statusOnSuccessContainer"] = "var(--color-status-on-success-container)";
  WgCssColors["statusOnWarning"] = "var(--color-status-on-warning)";
  WgCssColors["statusOnWarningContainer"] = "var(--color-status-on-warning-container)";
  WgCssColors["statusSuccess"] = "var(--color-status-success)";
  WgCssColors["statusSuccessContainer"] = "var(--color-status-success-container)";
  WgCssColors["statusWarning"] = "var(--color-status-warning)";
  WgCssColors["statusWarningContainer"] = "var(--color-status-warning-container)";
  WgCssColors["surfaceBackground"] = "var(--color-surface-background)";
  WgCssColors["surfaceInverse"] = "var(--color-surface-inverse)";
  WgCssColors["surfaceOnSurface"] = "var(--color-surface-on-surface)";
  WgCssColors["surfaceOnSurfaceInverse"] = "var(--color-surface-on-surface-inverse)";
  WgCssColors["surfaceOnSurfaceInverseAccent"] = "var(--color-surface-on-surface-inverse-accent)";
  WgCssColors["surfaceOnSurfaceSoft"] = "var(--color-surface-on-surface-soft)";
  WgCssColors["surfaceSurface01"] = "var(--color-surface-surface-01)";
  WgCssColors["surfaceSurface02"] = "var(--color-surface-surface-02)";
  WgCssColors["surfaceSurface03"] = "var(--color-surface-surface-03)";
})(WgCssColors || (WgCssColors = {}));
;
class WgHListItemComponent {
  static {
    this.ɵfac = function WgHListItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgHListItemComponent)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: WgHListItemComponent,
      hostVars: 2,
      hostBindings: function WgHListItemComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("wg-h-list-item", true);
        }
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgHListItemComponent, [{
    type: Directive,
    args: [{
      host: {
        '[class.wg-h-list-item]': 'true'
      }
    }]
  }], null, null);
})();
class WgHListLabelComponent extends WgHListItemComponent {
  constructor() {
    super(...arguments);
    this.label = input.required();
    this.labelColor = input(WgCssColors.surfaceOnSurface);
    this.leadingIcon = input();
    this.leadingIconColor = input(WgCssColors.brandAccent);
    this.leadingIconSize = input(WgIconSizes.MD);
    this.number = input();
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵWgHListLabelComponent_BaseFactory;
      return function WgHListLabelComponent_Factory(__ngFactoryType__) {
        return (ɵWgHListLabelComponent_BaseFactory || (ɵWgHListLabelComponent_BaseFactory = i0.ɵɵgetInheritedFactory(WgHListLabelComponent)))(__ngFactoryType__ || WgHListLabelComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgHListLabelComponent,
      selectors: [["wg-h-list-label"]],
      inputs: {
        label: [1, "label"],
        labelColor: [1, "labelColor"],
        leadingIcon: [1, "leadingIcon"],
        leadingIconColor: [1, "leadingIconColor"],
        leadingIconSize: [1, "leadingIconSize"],
        number: [1, "number"]
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: WgHListItemComponent,
        useExisting: forwardRef(() => WgHListLabelComponent)
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 3,
      vars: 3,
      consts: [[3, "name", "size", "--icon-fill"], [1, "number"], [1, "label", 3, "color"], [3, "name", "size"], [1, "label"]],
      template: function WgHListLabelComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, WgHListLabelComponent_Conditional_0_Template, 1, 4, "wg-icon", 0)(1, WgHListLabelComponent_Conditional_1_Template, 2, 1, "span", 1)(2, WgHListLabelComponent_Conditional_2_Template, 3, 5, "span", 2);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.leadingIcon() ? 0 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.number() || ctx.number() === 0 ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.label() ? 2 : -1);
        }
      },
      dependencies: [TranslateModule, i1$1.TranslatePipe, WgIconModule, WgIconComponent],
      styles: ["[_nghost-%COMP%]{align-items:center;display:inline-flex}[_nghost-%COMP%] > wg-icon[_ngcontent-%COMP%]{margin-right:var(--spacing-sm)}[_nghost-%COMP%] > .number[_ngcontent-%COMP%]{font:var(--font-standard-base);font-weight:var(--font-weight-strong);margin-right:var(--spacing-xs)}[_nghost-%COMP%] > .label[_ngcontent-%COMP%]{display:inline;width:auto;overflow:hidden;word-break:break-word}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgHListLabelComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      selector: 'wg-h-list-label',
      standalone: true,
      imports: [TranslateModule, WgIconModule],
      providers: [{
        provide: WgHListItemComponent,
        useExisting: forwardRef(() => WgHListLabelComponent)
      }],
      template: "@if (leadingIcon()) {\n  <wg-icon [name]=\"leadingIcon()\" [size]=\"leadingIconSize()\" [style.--icon-fill]=\"leadingIconColor()\"></wg-icon>\n}\n\n@if (number() || number() === 0) {\n  <span class=\"number\">{{ number() }}</span>\n}\n\n@if (label()) {\n  <span [style.color]=\"labelColor()\" class=\"label\">{{ label() | translate }}</span>\n}\n",
      styles: [":host{align-items:center;display:inline-flex}:host>wg-icon{margin-right:var(--spacing-sm)}:host>.number{font:var(--font-standard-base);font-weight:var(--font-weight-strong);margin-right:var(--spacing-xs)}:host>.label{display:inline;width:auto;overflow:hidden;word-break:break-word}\n"]
    }]
  }], null, null);
})();
class WgHListLinkComponent extends WgHListLabelComponent {
  constructor() {
    super(...arguments);
    this.labelColor = input(WgCssColors.brandAccent);
    this.linkClick = output();
  }
  clicked(event) {
    this.linkClick.emit(event);
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵWgHListLinkComponent_BaseFactory;
      return function WgHListLinkComponent_Factory(__ngFactoryType__) {
        return (ɵWgHListLinkComponent_BaseFactory || (ɵWgHListLinkComponent_BaseFactory = i0.ɵɵgetInheritedFactory(WgHListLinkComponent)))(__ngFactoryType__ || WgHListLinkComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgHListLinkComponent,
      selectors: [["wg-h-list-link"]],
      inputs: {
        labelColor: [1, "labelColor"]
      },
      outputs: {
        linkClick: "linkClick"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: WgHListItemComponent,
        useExisting: forwardRef(() => WgHListLinkComponent)
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 4,
      vars: 3,
      consts: [[3, "click"], [3, "name", "size", "--icon-fill"], [1, "number"], [3, "color"], [3, "name", "size"]],
      template: function WgHListLinkComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "a", 0);
          i0.ɵɵlistener("click", function WgHListLinkComponent_Template_a_click_0_listener($event) {
            return ctx.clicked($event);
          });
          i0.ɵɵtemplate(1, WgHListLinkComponent_Conditional_1_Template, 1, 4, "wg-icon", 1)(2, WgHListLinkComponent_Conditional_2_Template, 2, 1, "span", 2)(3, WgHListLinkComponent_Conditional_3_Template, 3, 5, "span", 3);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.leadingIcon() ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.number() || ctx.number() === 0 ? 2 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.label() ? 3 : -1);
        }
      },
      dependencies: [TranslateModule, i1$1.TranslatePipe, WgIconModule, WgIconComponent],
      styles: ["[_nghost-%COMP%]{display:inline-flex}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgHListLinkComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      selector: 'wg-h-list-link',
      standalone: true,
      imports: [TranslateModule, WgIconModule],
      providers: [{
        provide: WgHListItemComponent,
        useExisting: forwardRef(() => WgHListLinkComponent)
      }],
      template: "<a (click)=\"clicked($event)\">\n  @if (leadingIcon()) {\n    <wg-icon [name]=\"leadingIcon()\" [size]=\"leadingIconSize()\" [style.--icon-fill]=\"leadingIconColor()\"></wg-icon>\n  }\n\n  @if (number() || number() === 0) {\n    <span class=\"number\">{{ number() }}</span>\n  }\n\n  @if (label()) {\n    <span [style.color]=\"labelColor()\">{{ label() | translate }}</span>\n  }\n</a>\n",
      styles: [":host{display:inline-flex}\n"]
    }]
  }], null, null);
})();
const DEFAULT_WRAP_BREAKPOINT = '360px';
class WgLabelValueComponent {
  constructor() {
    this.label = input.required();
    this.labelWidth = input();
    this.paddingX = model();
    this.paddingY = model();
    this.value = input();
    this.wrapBreakpoint = model();
    this.id = nanoid();
    this.document = inject(DOCUMENT);
    effect(() => {
      if (this.wrapBreakpoint()) {
        this.addContainerQueryCss();
      }
    });
  }
  ngOnDestroy() {
    this.removeContainerQueryCss();
  }
  addContainerQueryCss() {
    if (this.styleElement) {
      this.removeContainerQueryCss();
    }
    const head = this.document.head;
    this.styleElement = this.document.createElement('style');
    this.styleElement.id = this.id;
    const selector = `wg-label-value[id='${this.id}']`;
    const breakpoint = this.wrapBreakpoint() ?? DEFAULT_WRAP_BREAKPOINT;
    this.styleElement.innerHTML = `
      ${selector} {
        container-name: wg-label-value_${this.id};
      }

      @container wg-label-value_${this.id} (width < ${breakpoint}) {
        ${selector} div {
          flex-direction: column;
        }

        ${selector} div > .label {
          flex: 0 0 auto;
        }

        ${selector} div > span + span {
          margin-left: 0;
        }
      }
    `;
    head.appendChild(this.styleElement);
  }
  removeContainerQueryCss() {
    if (!this.styleElement) {
      return;
    }
    const head = this.document.head;
    head?.removeChild(this.styleElement);
  }
  static {
    this.ɵfac = function WgLabelValueComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgLabelValueComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgLabelValueComponent,
      selectors: [["wg-label-value"]],
      hostVars: 7,
      hostBindings: function WgLabelValueComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("id", ctx.id);
          i0.ɵɵstyleProp("--label-width", ctx.labelWidth())("--padding-x", ctx.paddingX())("--padding-y", ctx.paddingY());
        }
      },
      inputs: {
        label: [1, "label"],
        labelWidth: [1, "labelWidth"],
        paddingX: [1, "paddingX"],
        paddingY: [1, "paddingY"],
        value: [1, "value"],
        wrapBreakpoint: [1, "wrapBreakpoint"]
      },
      outputs: {
        paddingX: "paddingXChange",
        paddingY: "paddingYChange",
        wrapBreakpoint: "wrapBreakpointChange"
      },
      decls: 7,
      vars: 6,
      consts: [[1, "label"], [1, "value"]],
      template: function WgLabelValueComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div")(1, "span", 0);
          i0.ɵɵtext(2);
          i0.ɵɵpipe(3, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "span", 1);
          i0.ɵɵtext(5);
          i0.ɵɵpipe(6, "translate");
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, ctx.label()));
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 4, ctx.value()));
        }
      },
      dependencies: [TranslateModule, i1$1.TranslatePipe],
      styles: ["wg-label-value{--label-width: 100px;--padding-x: var(--spacing-none);--padding-y: var(--spacing-none);container-type:inline-size;display:block}wg-label-value div{display:flex;padding:var(--padding-y) var(--padding-x)}wg-label-value div>.label{flex:0 0 var(--label-width);font-weight:var(--font-weight-strong);overflow:hidden;overflow-wrap:break-word}wg-label-value div>span+span{flex:1 1 auto;margin-left:var(--spacing-sm);overflow:hidden;overflow-wrap:break-word}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgLabelValueComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      selector: 'wg-label-value',
      imports: [TranslateModule],
      host: {
        '[style.--label-width]': 'labelWidth()',
        '[style.--padding-x]': 'paddingX()',
        '[style.--padding-y]': 'paddingY()',
        '[attr.id]': 'id'
      },
      template: "<div>\n  <span class=\"label\">{{ label() | translate }}</span>\n  <span class=\"value\">{{ value() | translate }}</span>\n</div>\n",
      styles: ["wg-label-value{--label-width: 100px;--padding-x: var(--spacing-none);--padding-y: var(--spacing-none);container-type:inline-size;display:block}wg-label-value div{display:flex;padding:var(--padding-y) var(--padding-x)}wg-label-value div>.label{flex:0 0 var(--label-width);font-weight:var(--font-weight-strong);overflow:hidden;overflow-wrap:break-word}wg-label-value div>span+span{flex:1 1 auto;margin-left:var(--spacing-sm);overflow:hidden;overflow-wrap:break-word}\n"]
    }]
  }], () => [], null);
})();
const WgSchedulerResizerType = {
  leading: 'leading',
  trailing: 'trailing'
};
class WgSchedulerComponent {
  constructor() {
    this.tabIndex = 0;
    this.interval = input(15);
    this.disabled = false;
    this.headerHours = [...Array(25).keys()].map(x => String(x).padStart(2, '0')); // 00 - 24
    this.translationKeys = {
      sunday_short_calendar: 'sunday_short_calendar',
      monday_short_calendar: 'monday_short_calendar',
      tuesday_short_calendar: 'tuesday_short_calendar',
      wednesday_short_calendar: 'wednesday_short_calendar',
      thursday_short_calendar: 'thursday_short_calendar',
      friday_short_calendar: 'friday_short_calendar',
      saturday_short_calendar: 'saturday_short_calendar',
      ui_common_label_hours_short: 'ui_common_label_hours_short'
    };
    this.WgSchedulerResizerType = WgSchedulerResizerType;
    this.changeDetectorRef = inject(ChangeDetectorRef);
    this.document = inject(DOCUMENT);
    this.translateService = inject(TranslateService);
    this.zone = inject(NgZone);
    this.destroy$ = new Subject();
    this.dragging = false;
    this.hoverDayIndex = null;
    this.hoverSegmentIndex = null;
    // control value accessor functions
    this.onChange = _ => {};
    this.onTouched = () => {};
  }
  /* ControlValueAccessor implementation - start */
  valueChange() {
    const entries = this.entries?.map(entry => {
      return {
        dayIndex: entry.dayIndex,
        endTime: entry.endTime,
        startTime: entry.startTime
      };
    }) || [];
    this.onChange(entries);
  }
  // ControlValueAccessor interface implementation
  writeValue(entries) {
    this.entries = entries?.map(entry => {
      return {
        dayIndex: entry.dayIndex,
        endTime: entry.endTime,
        startTime: entry.startTime,
        endIndex: this.getIndexFromEndTime(entry.endTime),
        startIndex: this.getIndexFromStartTime(entry.startTime)
      };
    }) || [];
    this.displayEntries = this.entries;
    this.updateEntries(this.displayEntries);
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  setDisabledState(disabled) {
    this.disabled = disabled;
  }
  /* ControlValueAccessor implementation - end */
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  ngOnInit() {
    this.translateService.get(Object.values(this.translationKeys)).pipe(first(), takeUntil(this.destroy$)).subscribe(translations => {
      this.translations = translations;
      this.initDays();
      this.changeDetectorRef.detectChanges();
    });
  }
  blur() {
    this.displayEntries = [...this.entries];
    this.dragging = false;
    this.hoverShow = false;
    this.pointerIsDown = false;
    this.shiftKey = false;
  }
  focus() {
    if (this.pointerIsDown) {
      return;
    }
    this.gridPointerenter(null, 0, 0);
  }
  gridPointerdown(event, dayIndex, segmentIndex) {
    const eventTarget = event?.target;
    // trick to making touch events work like a mouse
    if (eventTarget?.hasPointerCapture(event?.pointerId)) {
      eventTarget?.releasePointerCapture(event?.pointerId);
    }
    this.pointerIsDown = true;
    if (event.button !== 0) {
      // not main pointer button pressed
      return;
    }
    if (this.dragging) {
      // drag in progress, do nothing here
      return;
    }
    this.dragging = true;
    this.hoverShow = false;
    this.dragEndDayIndex = dayIndex;
    this.dragEndSegmentIndex = segmentIndex;
    if (!this.shiftKey) {
      this.dragStartDayIndex = dayIndex;
      this.dragStartSegmentIndex = segmentIndex;
      this.dragStartEnabled = this.hasBlock(this.dragStartDayIndex, this.dragStartSegmentIndex);
      this.lastDragDayIndex = dayIndex;
      this.lastDragSegmentIndex = segmentIndex;
      this.lastEnabled = this.dragStartEnabled;
    }
    this.processDrag();
  }
  gridPointerenter(event, dayIndex, segmentIndex) {
    this.dragEndDayIndex = dayIndex;
    this.dragEndSegmentIndex = segmentIndex;
    this.hoverShow = !this.dragging && !this.shiftKey;
    this.hoverDayIndex = dayIndex;
    this.hoverSegmentIndex = segmentIndex;
    this.updateHover();
    if (!this.dragging && (
    // dragging hasn't occurred yet
    !this.shiftKey || !(this.lastDragDayIndex || this.lastDragDayIndex === 0)) // shift key not held
    ) {
      return;
    }
    if (!this.dragging && this.shiftKey) {
      this.dragStartEnabled = this.lastEnabled;
      this.dragStartDayIndex = this.lastDragDayIndex;
      this.dragStartSegmentIndex = this.lastDragSegmentIndex;
    }
    this.processDrag();
  }
  gridPointerleave(event) {
    this.hoverShow = false;
    this.hoverDayIndex = null;
    this.hoverSegmentIndex = null;
  }
  keydown(event) {
    const increment = event.altKey ? 4 : 1;
    switch (event.key) {
      case 'ArrowDown':
        this.gridPointerenter(null, Math.min(this.days.length - 1, Math.max(0, this.hoverDayIndex + increment)), Math.max(0, this.hoverSegmentIndex));
        break;
      case 'ArrowLeft':
        this.gridPointerenter(null, Math.max(0, this.hoverDayIndex), Math.min(this.days[0].segments.length - 1, Math.max(0, this.hoverSegmentIndex - increment)));
        break;
      case 'ArrowRight':
        this.gridPointerenter(null, Math.max(0, this.hoverDayIndex), Math.min(this.days[0].segments.length - 1, Math.max(0, this.hoverSegmentIndex + increment)));
        break;
      case 'ArrowUp':
        this.gridPointerenter(null, Math.min(this.days.length - 1, Math.max(0, this.hoverDayIndex - increment)), Math.max(0, this.hoverSegmentIndex));
        break;
      case ' ':
      case 'Delete':
      case 'Enter':
      case 'Space':
        this.hoverShow = false;
        this.dragEndDayIndex = this.hoverDayIndex;
        this.dragEndSegmentIndex = this.hoverSegmentIndex;
        if (!this.shiftKey) {
          this.dragStartDayIndex = this.hoverDayIndex;
          this.dragStartEnabled = event.key === 'Delete' ? true : this.hasBlock(this.hoverDayIndex, this.hoverSegmentIndex);
          this.dragStartSegmentIndex = this.hoverSegmentIndex;
          this.lastDragDayIndex = this.dragEndDayIndex;
          this.lastDragSegmentIndex = this.dragEndSegmentIndex;
          this.lastEnabled = this.dragStartEnabled;
        }
        this.processDrag();
        this.pointerup(null);
        break;
      case 'Shift':
        if (this.dragging || !(this.dragEndDayIndex || this.dragEndDayIndex === 0)) {
          // drag in progress, ignore shift
          return;
        }
        this.hoverShow = false;
        this.shiftKey = true;
        this.dragStartEnabled = this.lastEnabled;
        this.dragStartDayIndex = this.lastDragDayIndex;
        this.dragStartSegmentIndex = this.lastDragSegmentIndex;
        this.processDrag();
        break;
    }
  }
  keyup(event) {
    switch (event.key) {
      case 'Shift':
        if (this.dragging) {
          // drag in progress, ignore shift
          return;
        }
        this.shiftKey = false;
        this.displayEntries = [...this.entries];
        break;
    }
  }
  pointerup(event) {
    this.pointerIsDown = false;
    if (!(this.dragStartDayIndex || this.dragStartDayIndex === 0) || !(this.dragStartSegmentIndex || this.dragStartSegmentIndex === 0) || !(this.dragEndDayIndex || this.dragEndDayIndex === 0) || !(this.dragEndSegmentIndex || this.dragEndSegmentIndex === 0)) {
      return;
    }
    this.entries = [...this.displayEntries];
    this.valueChange();
    this.lastDragDayIndex = this.dragEndDayIndex;
    this.lastDragSegmentIndex = this.dragEndSegmentIndex;
    this.dragging = false;
    this.dragStartDayIndex = null;
    this.dragStartSegmentIndex = null;
    this.dragEndDayIndex = null;
    this.dragEndSegmentIndex = null;
    this.dragStartEnabled = null;
    this.resizerCurrentEntry = null;
    this.resizerCurrentSegmentIndex = null;
    this.resizerCurrentType = null;
  }
  resizerPointerdown(event, entry, resizerType) {
    event.preventDefault();
    this.resizerCurrentEntry = entry;
    this.resizerCurrentType = resizerType;
    const gridElement = this.getGridElementUnderResizer(event, resizerType);
    if (!gridElement) {
      return;
    }
    const dayIndex = Number(gridElement.dataset.dayIndex);
    const segmentIndex = Number(gridElement.dataset.segmentIndex);
    this.resizerCurrentSegmentIndex = segmentIndex;
    this.gridPointerdown(event, dayIndex, segmentIndex);
  }
  resizerPointerenter(event, resizerType) {
    this.zone.runOutsideAngular(() => {
      const gridElement = this.getGridElementUnderResizer(event, resizerType);
      if (!gridElement) {
        return;
      }
      gridElement.dispatchEvent(this.clonePointerEvent(event));
    });
  }
  resizerPointerup(event, entry, resizerType) {
    if (this.resizerCurrentEntry?.dayIndex !== entry.dayIndex || this.resizerCurrentEntry?.startTime !== entry.startTime || this.resizerCurrentEntry?.endTime !== entry.endTime || this.resizerCurrentType !== resizerType) {
      this.resizerCurrentEntry = null;
      this.resizerCurrentType = null;
      return;
    }
    this.resizerCurrentEntry = null;
    this.resizerCurrentType = null;
    this.zone.runOutsideAngular(() => {
      const gridElement = this.getGridElementUnderResizer(event, resizerType);
      if (!gridElement) {
        return;
      }
      this.dragging = false;
      gridElement.dispatchEvent(this.clonePointerEvent(event, 'pointerdown'));
    });
  }
  touchmove(event) {
    if (event?.touches?.length > 1) {
      return;
    }
    event?.preventDefault();
  }
  touchstart(event) {
    if (event?.touches?.length > 1) {
      return;
    }
    event?.preventDefault();
  }
  addDragToEntries(entries, dragStartDayIndex, dragEndDayIndex, dragStartSegmentIndex, dragEndSegmentIndex) {
    const newEntries = [...entries];
    for (let dayIndex = dragStartDayIndex; dayIndex <= dragEndDayIndex; dayIndex++) {
      newEntries.push({
        dayIndex,
        endIndex: dragEndSegmentIndex,
        endTime: this.getSegment(dayIndex, dragEndSegmentIndex).endTime,
        startIndex: dragStartSegmentIndex,
        startTime: this.getSegment(dayIndex, dragStartSegmentIndex).startTime
      });
    }
    return newEntries;
  }
  clonePointerEvent(event, eventType) {
    return new PointerEvent(eventType || event.type, {
      clientX: event.clientX,
      clientY: event.clientY,
      screenX: event.screenX,
      screenY: event.screenY,
      button: event.button,
      buttons: event.buttons,
      ctrlKey: event.ctrlKey,
      shiftKey: event.shiftKey,
      altKey: event.altKey,
      metaKey: event.metaKey
    });
  }
  copyEntries(entries) {
    return JSON.parse(JSON.stringify(entries));
  }
  createDay(label) {
    const day = {
      label: label,
      segments: this.createSegments()
    };
    return day;
  }
  createEndTime(hour, minute) {
    if (!(hour || hour === 0) || !(minute || minute === 0)) {
      return null;
    }
    let endHour = hour;
    let endMinute;
    if (minute >= 60 - this.interval()) {
      endHour = endHour + 1;
      endMinute = 0;
    } else {
      endMinute = minute + this.interval();
    }
    return this.formatTime(endHour, endMinute);
  }
  createSegments() {
    const segments = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += this.interval()) {
        const segment = {
          startTime: this.createStartTime(hour, minute),
          endTime: this.createEndTime(hour, minute)
        };
        segments.push(segment);
      }
    }
    return segments;
  }
  createStartTime(hour, minute) {
    if (!(hour || hour === 0) || !(minute || minute === 0)) {
      return null;
    }
    return this.formatTime(hour, minute);
  }
  formatTime(hour, minute) {
    if (!(hour || hour === 0) || !(minute || minute === 0)) {
      return null;
    }
    return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
  }
  getGridElementUnderResizer(event, resizerType) {
    // Due to how the elementsFromPoint works it sometimes returns two elements beneath the cursor.
    // This offset should prevent that
    let offset = 0;
    if (resizerType === WgSchedulerResizerType.leading) {
      if (event.offsetX < 1) {
        offset = 3;
      } else {
        offset = -2;
      }
    } else if (resizerType === WgSchedulerResizerType.trailing) {
      if (event.offsetX < 1) {
        offset = 2;
      } else {
        offset = -3;
      }
    }
    // get the grid section underneath the resizer
    const elements = this.document.elementsFromPoint(event.clientX + offset, event.clientY);
    return elements.find(element => element.tagName.toLowerCase() === 'li');
  }
  getIndexFromEndTime(time) {
    if (!time) {
      return null;
    }
    return this.days[0]?.segments?.findIndex(findSegment => findSegment.endTime === time);
  }
  getIndexFromStartTime(time) {
    if (!time) {
      return null;
    }
    return this.days[0]?.segments?.findIndex(findSegment => findSegment.startTime === time);
  }
  getSegment(dayIndex, segmentIndex) {
    return this.days[dayIndex]?.segments[segmentIndex];
  }
  hasBlock(dayIndex, segmentIndex) {
    if (!this.entries?.length) {
      return false;
    }
    for (let i = 0; i < this.entries.length; i++) {
      const entry = this.entries[i];
      if (dayIndex === entry.dayIndex && segmentIndex >= entry.startIndex && segmentIndex <= entry.endIndex) {
        return true;
      }
    }
    return false;
  }
  initDays() {
    this.days = [this.createDay(this.translations[this.translationKeys.sunday_short_calendar]), this.createDay(this.translations[this.translationKeys.monday_short_calendar]), this.createDay(this.translations[this.translationKeys.tuesday_short_calendar]), this.createDay(this.translations[this.translationKeys.wednesday_short_calendar]), this.createDay(this.translations[this.translationKeys.thursday_short_calendar]), this.createDay(this.translations[this.translationKeys.friday_short_calendar]), this.createDay(this.translations[this.translationKeys.saturday_short_calendar])];
  }
  mergeEntries(entries) {
    const newEntries = [...this.sortEntries(entries)];
    for (let i = 0; i < newEntries.length; i++) {
      const entry = newEntries[i];
      const nextEntry = newEntries[i + 1];
      if (nextEntry && entry.dayIndex === nextEntry.dayIndex && entry.endIndex >= nextEntry.startIndex - 1) {
        // overlap, merge them
        entry.endTime = entry.endIndex >= nextEntry.endIndex ? entry.endTime : nextEntry.endTime;
        entry.endIndex = Math.max(entry.endIndex, nextEntry.endIndex);
        newEntries.splice(i + 1, 1);
        i--;
      }
    }
    return newEntries;
  }
  processDrag() {
    this.displayEntries = this.copyEntries(this.entries);
    let dragStartDayIndex = Math.min(this.dragStartDayIndex, this.dragEndDayIndex);
    let dragEndDayIndex = Math.max(this.dragStartDayIndex, this.dragEndDayIndex);
    let dragStartSegmentIndex = Math.min(this.dragStartSegmentIndex, this.dragEndSegmentIndex);
    let dragEndSegmentIndex = Math.max(this.dragStartSegmentIndex, this.dragEndSegmentIndex);
    if (this.resizerCurrentType === WgSchedulerResizerType.leading) {
      if (dragStartSegmentIndex < this.resizerCurrentSegmentIndex && dragEndSegmentIndex === this.resizerCurrentSegmentIndex) {
        this.dragStartEnabled = false;
      } else if (dragStartSegmentIndex === this.resizerCurrentSegmentIndex && dragEndSegmentIndex === this.resizerCurrentSegmentIndex) {
        this.dragStartEnabled = false;
      } else {
        this.dragStartEnabled = true;
        dragEndSegmentIndex--;
      }
    } else if (this.resizerCurrentType === WgSchedulerResizerType.trailing) {
      if (dragStartSegmentIndex < this.resizerCurrentSegmentIndex && dragEndSegmentIndex === this.resizerCurrentSegmentIndex) {
        this.dragStartEnabled = true;
        dragStartSegmentIndex++;
      } else if (dragStartSegmentIndex === this.resizerCurrentSegmentIndex && dragEndSegmentIndex === this.resizerCurrentSegmentIndex) {
        this.dragStartEnabled = false;
      } else {
        this.dragStartEnabled = false;
      }
    }
    if (this.dragStartEnabled) {
      // remove time from existing blocks
      this.displayEntries = [...this.removeDragFromEntries(this.displayEntries, dragStartDayIndex, dragEndDayIndex, dragStartSegmentIndex, dragEndSegmentIndex)];
    } else {
      // add block of time
      this.displayEntries = [...this.addDragToEntries(this.displayEntries, dragStartDayIndex, dragEndDayIndex, dragStartSegmentIndex, dragEndSegmentIndex)];
      this.displayEntries = [...this.mergeEntries(this.displayEntries)];
    }
    this.updateEntries(this.displayEntries);
  }
  removeDragFromEntries(entries, dragStartDayIndex, dragEndDayIndex, dragStartSegmentIndex, dragEndSegmentIndex) {
    if (!entries?.length) {
      return [];
    }
    const newEntries = [];
    entries.forEach(entry => {
      if (dragStartDayIndex > entry.dayIndex || dragEndDayIndex < entry.dayIndex || dragEndSegmentIndex < entry.startIndex || dragStartSegmentIndex > entry.endIndex) {
        // drag area doesn't affect this entry, leave it alone
        newEntries.push(entry);
        return;
      }
      if (dragStartSegmentIndex < entry.startIndex && dragEndSegmentIndex > entry.endIndex) {
        // drag area wipes out entire entry so it goes away
        return;
      }
      if (dragStartSegmentIndex > entry.startIndex && dragEndSegmentIndex < entry.endIndex) {
        // split entry into two
        newEntries.push({
          dayIndex: entry.dayIndex,
          endIndex: dragStartSegmentIndex - 1,
          endTime: this.getSegment(entry.dayIndex, dragStartSegmentIndex - 1).endTime,
          startIndex: entry.startIndex,
          startTime: entry.startTime
        });
        newEntries.push({
          dayIndex: entry.dayIndex,
          endIndex: entry.endIndex,
          endTime: entry.endTime,
          startIndex: dragEndSegmentIndex + 1,
          startTime: this.getSegment(entry.dayIndex, dragEndSegmentIndex + 1).startTime
        });
      } else if (entry.startIndex <= dragEndSegmentIndex && entry.endIndex > dragEndSegmentIndex) {
        // remove the beginning of the entry
        newEntries.push({
          dayIndex: entry.dayIndex,
          endIndex: entry.endIndex,
          endTime: entry.endTime,
          startIndex: dragEndSegmentIndex + 1,
          startTime: this.getSegment(entry.dayIndex, dragEndSegmentIndex + 1).startTime
        });
      } else if (entry.startIndex < dragStartSegmentIndex && entry.endIndex >= dragStartSegmentIndex) {
        // remove the end of the entry
        newEntries.push({
          dayIndex: entry.dayIndex,
          endIndex: dragStartSegmentIndex - 1,
          endTime: this.getSegment(entry.dayIndex, dragStartSegmentIndex - 1).endTime,
          startIndex: entry.startIndex,
          startTime: entry.startTime
        });
      }
    });
    return newEntries;
  }
  sortEntries(entries) {
    return entries?.sort((a, b) => {
      if (a.dayIndex < b.dayIndex) {
        return -1;
      } else if (a.dayIndex > b.dayIndex) {
        return 1;
      } else if (a.startIndex < b.startIndex) {
        return -1;
      } else if (a.startIndex > b.startIndex) {
        return 1;
      } else if (a.endIndex < b.endIndex) {
        return -1;
      } else if (a.endIndex > b.endIndex) {
        return 1;
      }
      return 0;
    });
  }
  updateEntries(entries) {
    entries?.forEach(entry => {
      const startTime = DateTime.fromISO(entry.startTime);
      const endTime = DateTime.fromISO(entry.endTime);
      const duration = endTime.diff(startTime, ['hours', 'minutes']);
      let hours = duration.hours === 0 ? '' : String(duration.hours);
      let minutes = duration.minutes === 0 ? '' : String(duration.minutes / 60).replace(/^0\./, '.');
      entry.durationLabel = `${hours}${minutes}`;
      entry.styleLeft = `calc((100% / 96) * ${entry.startIndex})`;
      entry.styleRight = `calc(100% - ((100% / 96) * (${entry.endIndex} + 1)))`;
      entry.styleTop = `calc((var(--segment-height) + var(--day-gap)) * ${entry.dayIndex})`;
    });
  }
  updateHover() {
    this.hoverLeft = `calc((100% / 96) * ${this.hoverSegmentIndex})`;
    this.hoverRight = `calc(100% - ((100% / 96) * (${this.hoverSegmentIndex} + 1)))`;
    this.hoverTop = `calc((var(--segment-height) + var(--day-gap)) * ${this.hoverDayIndex})`;
  }
  static {
    this.ɵfac = function WgSchedulerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgSchedulerComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgSchedulerComponent,
      selectors: [["wg-scheduler"]],
      hostVars: 1,
      hostBindings: function WgSchedulerComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("blur", function WgSchedulerComponent_blur_HostBindingHandler() {
            return ctx.blur();
          })("focus", function WgSchedulerComponent_focus_HostBindingHandler() {
            return ctx.focus();
          })("keydown", function WgSchedulerComponent_keydown_HostBindingHandler($event) {
            return ctx.keydown($event);
          })("keyup", function WgSchedulerComponent_keyup_HostBindingHandler($event) {
            return ctx.keyup($event);
          })("pointerup", function WgSchedulerComponent_pointerup_HostBindingHandler($event) {
            return ctx.pointerup($event);
          }, false, i0.ɵɵresolveDocument)("touchmove", function WgSchedulerComponent_touchmove_HostBindingHandler($event) {
            return ctx.touchmove($event);
          })("touchstart", function WgSchedulerComponent_touchstart_HostBindingHandler($event) {
            return ctx.touchstart($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("tabindex", ctx.tabIndex);
        }
      },
      inputs: {
        interval: [1, "interval"]
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => WgSchedulerComponent),
        multi: true
      }])],
      decls: 11,
      vars: 1,
      consts: [[1, "grid-wrapper"], [1, "header"], [1, "entries"], [3, "left", "right", "top"], [1, "hover"], [1, "segment", 3, "left", "right", "top"], [1, "grid"], [1, "label"], [3, "pointerdown", "pointerenter", "pointerleave"], [1, "segment"], [1, "resizer", "leading", 3, "pointerdown", "pointerenter", "pointerup"], [1, "text"], [1, "sm"], [1, "md"], [1, "lg"], [1, "xl"], [1, "resizer", "trailing", 3, "pointerdown", "pointerenter", "pointerup"]],
      template: function WgSchedulerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "ul", 0)(1, "li", 1);
          i0.ɵɵrepeaterCreate(2, WgSchedulerComponent_For_3_Template, 2, 1, "div", null, i0.ɵɵrepeaterTrackByIndex);
          i0.ɵɵelementEnd();
          i0.ɵɵrepeaterCreate(4, WgSchedulerComponent_For_5_Template, 6, 1, "li", null, i0.ɵɵrepeaterTrackByIndex);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "ul", 2);
          i0.ɵɵrepeaterCreate(7, WgSchedulerComponent_For_8_Template, 17, 23, "li", 3, i0.ɵɵrepeaterTrackByIndex);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(9, "ul", 4);
          i0.ɵɵtemplate(10, WgSchedulerComponent_Conditional_10_Template, 1, 6, "li", 5);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵrepeater(ctx.headerHours);
          i0.ɵɵadvance(2);
          i0.ɵɵrepeater(ctx.days);
          i0.ɵɵadvance(3);
          i0.ɵɵrepeater(ctx.displayEntries);
          i0.ɵɵadvance(3);
          i0.ɵɵconditional(ctx.hoverShow ? 10 : -1);
        }
      },
      dependencies: [TranslateModule, i1$1.TranslatePipe],
      styles: ["[_nghost-%COMP%]{--block-background: var(--color-status-informative);--block-color: var(--color-status-on-informative);--day-gap: 5px;--header-height: 20px;--hover-background: var(--color-surface-on-surface-inverse-accent);--hover-opacity: .7;--label-width: 50px;--resize-width: 6px;--segment-background: var(--color-surface-surface-03);--segment-color: var(--color-surface-on-surface-inverse);--segment-height: 40px;--segment-radius: var(--radius-sm);display:block;position:relative;-webkit-user-select:none;user-select:none}[_nghost-%COMP%]:focus{outline:none}[_nghost-%COMP%]   ul[_ngcontent-%COMP%]{list-style:none;margin:0;padding-left:0}[_nghost-%COMP%] > ul.grid-wrapper[_ngcontent-%COMP%] > li.header[_ngcontent-%COMP%]{display:flex;height:var(--header-height);margin-left:calc(var(--label-width))}[_nghost-%COMP%] > ul.grid-wrapper[_ngcontent-%COMP%] > li.header[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{flex:0 0 auto;left:-.5rem;position:relative;width:4.1666666667%}[_nghost-%COMP%] > ul.grid-wrapper[_ngcontent-%COMP%] > li.header[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:last-child{width:auto}[_nghost-%COMP%] > ul.grid-wrapper[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:not(.header) > ul[_ngcontent-%COMP%]{align-items:center;display:flex}[_nghost-%COMP%] > ul.grid-wrapper[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:not(.header) > ul[_ngcontent-%COMP%] > li.label[_ngcontent-%COMP%]{padding-right:var(--spacing-sm);pointer-events:none;text-align:right;width:var(--label-width)}[_nghost-%COMP%] > ul.grid-wrapper[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:not(.header) > ul[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:not(.label){cursor:pointer;padding-left:1px;width:calc((100% - var(--label-width)) / 96)}[_nghost-%COMP%] > ul.grid-wrapper[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:not(.header) > ul[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:not(.label):nth-child(4n+1){padding-right:1px}[_nghost-%COMP%] > ul.grid-wrapper[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:not(.header) > ul[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:not(.label):nth-child(4n+2){border-left:1px solid var(--color-control-border)}[_nghost-%COMP%] > ul.grid-wrapper[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:not(.header) > ul[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:not(.label):last-child{border-right:1px solid var(--color-control-border)}[_nghost-%COMP%] > ul.grid-wrapper[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:not(.header) > ul[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:not(.label) > .segment[_ngcontent-%COMP%]{background-color:var(--segment-background);border-radius:var(--segment-radius);height:var(--segment-height);width:100%}[_nghost-%COMP%] > ul.grid-wrapper[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:not(.header) + li[_ngcontent-%COMP%]{margin-top:var(--day-gap)}[_nghost-%COMP%] > ul.entries[_ngcontent-%COMP%]{bottom:0;left:var(--label-width);pointer-events:none;position:absolute;right:0;top:var(--header-height)}[_nghost-%COMP%] > ul.entries[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{align-items:flex-end;background-color:var(--block-background);border-radius:var(--segment-radius);container-type:inline-size;display:flex;height:var(--segment-height);padding:var(--spacing-xs);position:absolute}[_nghost-%COMP%] > ul.entries[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > span.text[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:var(--block-color);display:none;font:var(--font-standard-sm)}@container (width >= 21px) and (width < 56px){[_nghost-%COMP%] > ul.entries[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > span.text[_ngcontent-%COMP%]   span.sm[_ngcontent-%COMP%]{display:block}}@container (width >= 56px) and (width < 78px){[_nghost-%COMP%] > ul.entries[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > span.text[_ngcontent-%COMP%]   span.md[_ngcontent-%COMP%]{display:block}}@container (width >= 78px) and (width < 130px){[_nghost-%COMP%] > ul.entries[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > span.text[_ngcontent-%COMP%]   span.lg[_ngcontent-%COMP%]{display:block}}@container (width >= 130px){[_nghost-%COMP%] > ul.entries[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > span.text[_ngcontent-%COMP%]   span.xl[_ngcontent-%COMP%]{display:block}}[_nghost-%COMP%] > ul.entries[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > div.resizer[_ngcontent-%COMP%]{bottom:0;content:\"\";cursor:ew-resize;pointer-events:auto;position:absolute;top:0}[_nghost-%COMP%] > ul.entries[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > div.resizer.leading[_ngcontent-%COMP%]{left:-1px;right:auto;width:var(--resize-width)}[_nghost-%COMP%] > ul.entries[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > div.resizer.trailing[_ngcontent-%COMP%]{left:auto;right:0;width:var(--resize-width)}[_nghost-%COMP%] > ul.hover[_ngcontent-%COMP%]{bottom:0;left:var(--label-width);pointer-events:none;position:absolute;right:0;top:var(--header-height)}[_nghost-%COMP%] > ul.hover[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{background-color:var(--hover-background);border-radius:var(--segment-radius);height:var(--segment-height);opacity:var(--hover-opacity);position:absolute}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgSchedulerComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      selector: 'wg-scheduler',
      standalone: true,
      imports: [TranslateModule],
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => WgSchedulerComponent),
        multi: true
      }],
      template: "<ul class=\"grid-wrapper\">\n  <li class=\"header\">\n    @for (hour of headerHours; track $index) {\n      <div>{{ hour }}</div>\n    }\n  </li>\n\n  <!-- gray grid -->\n  @for (day of days; track dayIndex; let dayIndex = $index) {\n    <li>\n      <ul class=\"grid\">\n        <li class=\"label\">{{ day.label }}</li>\n\n        @for (segment of day.segments; track segmentIndex; let segmentIndex = $index) {\n          <li\n            [attr.data-day-index]=\"dayIndex\"\n            [attr.data-segment-index]=\"segmentIndex\"\n            (pointerdown)=\"gridPointerdown($event, dayIndex, segmentIndex)\"\n            (pointerenter)=\"gridPointerenter($event, dayIndex, segmentIndex)\"\n            (pointerleave)=\"gridPointerleave($event)\"\n          >\n            <div class=\"segment\"></div>\n          </li>\n        }\n      </ul>\n    </li>\n  }\n</ul>\n\n<!-- actual entries -->\n<ul class=\"entries\">\n  @for (entry of displayEntries; track $index) {\n    <li\n      [style.left]=\"entry.styleLeft\"\n      [style.right]=\"entry.styleRight\"\n      [style.top]=\"entry.styleTop\"\n    >\n      <div class=\"resizer leading\"\n        (pointerdown)=\"resizerPointerdown($event, entry, WgSchedulerResizerType.leading)\"\n        (pointerenter)=\"resizerPointerenter($event, WgSchedulerResizerType.leading)\"\n        (pointerup)=\"resizerPointerup($event, entry, WgSchedulerResizerType.leading)\"\n      ></div>\n      <span class=\"text\">\n        <span class=\"sm\">{{ entry.durationLabel }}</span>\n        <span class=\"md\">{{ entry.durationLabel }} {{ translationKeys.ui_common_label_hours_short | translate }}</span>\n        <span class=\"lg\">{{ entry.startTime }} - {{ entry.endTime }}<br>{{ entry.durationLabel }} {{ translationKeys.ui_common_label_hours_short | translate }}</span>\n        <span class=\"xl\">{{ entry.startTime }} - {{ entry.endTime }} \u2022 {{ entry.durationLabel }} {{ translationKeys.ui_common_label_hours_short | translate }}</span>\n      </span>\n      <div class=\"resizer trailing\"\n        (pointerdown)=\"resizerPointerdown($event, entry, WgSchedulerResizerType.trailing)\"\n        (pointerenter)=\"resizerPointerenter($event, WgSchedulerResizerType.trailing)\"\n        (pointerup)=\"resizerPointerup($event, entry, WgSchedulerResizerType.trailing)\"\n      ></div>\n    </li>\n  }\n</ul>\n\n<!-- hover state -->\n<ul class=\"hover\">\n  @if (hoverShow) {\n    <li class=\"segment\"\n      [style.left]=\"hoverLeft\"\n      [style.right]=\"hoverRight\"\n      [style.top]=\"hoverTop\"\n    >\n    </li>\n  }\n</ul>",
      styles: [":host{--block-background: var(--color-status-informative);--block-color: var(--color-status-on-informative);--day-gap: 5px;--header-height: 20px;--hover-background: var(--color-surface-on-surface-inverse-accent);--hover-opacity: .7;--label-width: 50px;--resize-width: 6px;--segment-background: var(--color-surface-surface-03);--segment-color: var(--color-surface-on-surface-inverse);--segment-height: 40px;--segment-radius: var(--radius-sm);display:block;position:relative;-webkit-user-select:none;user-select:none}:host:focus{outline:none}:host ul{list-style:none;margin:0;padding-left:0}:host>ul.grid-wrapper>li.header{display:flex;height:var(--header-height);margin-left:calc(var(--label-width))}:host>ul.grid-wrapper>li.header>div{flex:0 0 auto;left:-.5rem;position:relative;width:4.1666666667%}:host>ul.grid-wrapper>li.header>div:last-child{width:auto}:host>ul.grid-wrapper>li:not(.header)>ul{align-items:center;display:flex}:host>ul.grid-wrapper>li:not(.header)>ul>li.label{padding-right:var(--spacing-sm);pointer-events:none;text-align:right;width:var(--label-width)}:host>ul.grid-wrapper>li:not(.header)>ul>li:not(.label){cursor:pointer;padding-left:1px;width:calc((100% - var(--label-width)) / 96)}:host>ul.grid-wrapper>li:not(.header)>ul>li:not(.label):nth-child(4n+1){padding-right:1px}:host>ul.grid-wrapper>li:not(.header)>ul>li:not(.label):nth-child(4n+2){border-left:1px solid var(--color-control-border)}:host>ul.grid-wrapper>li:not(.header)>ul>li:not(.label):last-child{border-right:1px solid var(--color-control-border)}:host>ul.grid-wrapper>li:not(.header)>ul>li:not(.label)>.segment{background-color:var(--segment-background);border-radius:var(--segment-radius);height:var(--segment-height);width:100%}:host>ul.grid-wrapper>li:not(.header)+li{margin-top:var(--day-gap)}:host>ul.entries{bottom:0;left:var(--label-width);pointer-events:none;position:absolute;right:0;top:var(--header-height)}:host>ul.entries>li{align-items:flex-end;background-color:var(--block-background);border-radius:var(--segment-radius);container-type:inline-size;display:flex;height:var(--segment-height);padding:var(--spacing-xs);position:absolute}:host>ul.entries>li>span.text span{color:var(--block-color);display:none;font:var(--font-standard-sm)}@container (width >= 21px) and (width < 56px){:host>ul.entries>li>span.text span.sm{display:block}}@container (width >= 56px) and (width < 78px){:host>ul.entries>li>span.text span.md{display:block}}@container (width >= 78px) and (width < 130px){:host>ul.entries>li>span.text span.lg{display:block}}@container (width >= 130px){:host>ul.entries>li>span.text span.xl{display:block}}:host>ul.entries>li>div.resizer{bottom:0;content:\"\";cursor:ew-resize;pointer-events:auto;position:absolute;top:0}:host>ul.entries>li>div.resizer.leading{left:-1px;right:auto;width:var(--resize-width)}:host>ul.entries>li>div.resizer.trailing{left:auto;right:0;width:var(--resize-width)}:host>ul.hover{bottom:0;left:var(--label-width);pointer-events:none;position:absolute;right:0;top:var(--header-height)}:host>ul.hover>li{background-color:var(--hover-background);border-radius:var(--segment-radius);height:var(--segment-height);opacity:var(--hover-opacity);position:absolute}\n"]
    }]
  }], null, {
    tabIndex: [{
      type: HostBinding,
      args: ['attr.tabindex']
    }],
    blur: [{
      type: HostListener,
      args: ['blur']
    }],
    focus: [{
      type: HostListener,
      args: ['focus']
    }],
    keydown: [{
      type: HostListener,
      args: ['keydown', ['$event']]
    }],
    keyup: [{
      type: HostListener,
      args: ['keyup', ['$event']]
    }],
    pointerup: [{
      type: HostListener,
      args: ['document:pointerup', ['$event']]
    }],
    touchmove: [{
      type: HostListener,
      args: ['touchmove', ['$event']]
    }],
    touchstart: [{
      type: HostListener,
      args: ['touchstart', ['$event']]
    }]
  });
})();
const CURRENT_VERSION = 1;
class CssVersionService {
  constructor() {
    this.cssVersion = new BehaviorSubject(CURRENT_VERSION);
  }
  getCssVersion() {
    return this.cssVersion?.value;
  }
  setCssVersion(cssVersion) {
    this.cssVersion.next(cssVersion);
  }
  static {
    this.ɵfac = function CssVersionService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CssVersionService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CssVersionService,
      factory: CssVersionService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CssVersionService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/**
 * @description This directive handles the styles of the hover and pressed states of interactive components.
 * It creates a div inside the component that watches for mouseenter, mouseleave, mousedown and mouseup events
 * and sets the styles of the state layer accordingly.
 *
 * To use simply add it to the `hostDirectives` entry in the Component definition. The inputs are optional and
 * only needed if you want to change from the default colors (rare).
 *
 * @Component({
 *   ...
 *   hostDirectives: [{
 *     directive: ComponentStateLayerDirective,
 *       inputs: [    // optional inputs
 *         'wgComponentStateLayer',
 *         'wgComponentStateLayerCssVersion',
 *         'hoverColor',
 *         'hoverOpacityPercent',
 *         'pressedColor',
 *         'pressedOpacityPercent'
 *       ]
 *     }
 *   ],
 *   ...
 * })
 */
class ComponentStateLayerDirective {
  get hoverColor() {
    return this._hoverColor;
  }
  set hoverColor(value) {
    this._hoverColor = value;
    this.updateStyles();
  }
  get hoverOpacityPercent() {
    return this._hoverOpacityPercent;
  }
  set hoverOpacityPercent(value) {
    this._hoverOpacityPercent = value;
    this.updateStyles();
  }
  get pressedColor() {
    return this._pressedColor;
  }
  set pressedColor(value) {
    this._pressedColor = value;
    this.updateStyles();
  }
  get pressedOpacityPercent() {
    return this._pressedOpacityPercent;
  }
  set pressedOpacityPercent(value) {
    this._pressedOpacityPercent = value;
    this.updateStyles();
  }
  constructor() {
    // set to a higher version to limit showing the component state layer only at that css version or higher
    this.wgComponentStateLayerCssVersion = 1;
    this._hoverColor = '--color-surface-on-surface';
    this._hoverOpacityPercent = 8;
    this._pressedColor = '--color-surface-on-surface';
    this._pressedOpacityPercent = 12;
    this.cssVersionService = inject(CssVersionService, {
      optional: true
    });
    this.elementRef = inject(ElementRef);
    this.states = {
      hovered: false,
      pressed: false
    };
    this.hostHtmlElement = this.elementRef.nativeElement;
    this.updateStyles();
  }
  mousedown(event) {
    if (this.suppressPressed && this.suppressPressed(event)) {
      return;
    }
    this.states.pressed = true;
    this.updateStyles();
  }
  mouseleave() {
    this.states.hovered = false;
    this.states.pressed = false;
    this.updateStyles();
  }
  mouseenter(event) {
    if (this.suppressHover && this.suppressHover(event)) {
      return;
    }
    this.states.hovered = true;
    this.updateStyles();
  }
  mouseup() {
    this.states.pressed = false;
    this.updateStyles();
  }
  getConvertedColorString(color) {
    if (color && color.startsWith('--')) {
      return `var(${color})`;
    }
    return color;
  }
  /**
   * Adds a backgroundImage that displays a background color+opacity for hover and pressed states on the host element
   */
  updateStyles() {
    if (this.wgComponentStateLayer === false) {
      return;
    }
    if (this.cssVersionService?.getCssVersion() && this.cssVersionService.getCssVersion() < this.wgComponentStateLayerCssVersion) {
      return;
    }
    if (this.states.pressed) {
      const color = `rgb(from ${this.getConvertedColorString(this.pressedColor)} r g b / ${this.pressedOpacityPercent}%)`;
      this.hostHtmlElement.style.backgroundImage = `linear-gradient(90deg, ${color} 0%, ${color} 100%)`;
    } else if (this.states.hovered) {
      const color = `rgb(from ${this.getConvertedColorString(this.hoverColor)} r g b / ${this.hoverOpacityPercent}%)`;
      this.hostHtmlElement.style.backgroundImage = `linear-gradient(90deg, ${color} 0%, ${color} 100%)`;
    } else {
      this.hostHtmlElement.style.backgroundImage = null;
    }
  }
  static {
    this.ɵfac = function ComponentStateLayerDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ComponentStateLayerDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ComponentStateLayerDirective,
      selectors: [["", "wgComponentStateLayer", ""]],
      hostBindings: function ComponentStateLayerDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("mousedown", function ComponentStateLayerDirective_mousedown_HostBindingHandler($event) {
            return ctx.mousedown($event);
          })("mouseleave", function ComponentStateLayerDirective_mouseleave_HostBindingHandler() {
            return ctx.mouseleave();
          })("mouseenter", function ComponentStateLayerDirective_mouseenter_HostBindingHandler($event) {
            return ctx.mouseenter($event);
          })("mouseup", function ComponentStateLayerDirective_mouseup_HostBindingHandler() {
            return ctx.mouseup();
          });
        }
      },
      inputs: {
        wgComponentStateLayer: "wgComponentStateLayer",
        wgComponentStateLayerCssVersion: "wgComponentStateLayerCssVersion",
        hoverColor: "hoverColor",
        hoverOpacityPercent: "hoverOpacityPercent",
        pressedColor: "pressedColor",
        pressedOpacityPercent: "pressedOpacityPercent"
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ComponentStateLayerDirective, [{
    type: Directive,
    args: [{
      selector: '[wgComponentStateLayer]',
      standalone: true
    }]
  }], () => [], {
    wgComponentStateLayer: [{
      type: Input
    }],
    wgComponentStateLayerCssVersion: [{
      type: Input
    }],
    hoverColor: [{
      type: Input
    }],
    hoverOpacityPercent: [{
      type: Input
    }],
    pressedColor: [{
      type: Input
    }],
    pressedOpacityPercent: [{
      type: Input
    }],
    mousedown: [{
      type: HostListener,
      args: ['mousedown', ['$event']]
    }],
    mouseleave: [{
      type: HostListener,
      args: ['mouseleave']
    }],
    mouseenter: [{
      type: HostListener,
      args: ['mouseenter', ['$event']]
    }],
    mouseup: [{
      type: HostListener,
      args: ['mouseup']
    }]
  });
})();

/**
 * @description
 *
 * WGLinkComponent has the ability to provide link text with a leading icon and trailing icon. Both are mandatory.
 * In order to use WgLinkComponent in a lib, you can import the module from @watchguard/wg-ng-core, and use link component below,
 *
 * <wg-link [leadingIcon]="icon1" [trailingIcon]="icon2">
 * Example Link.
 * </wg-link>
 *
 * Make sure to use "mandatory" leading and trailing icon props,
 * [leadingIcon]
 * [trailingIcon]
 *
 * The Link Component has 2 states viz. hover & pressed with different opacity percent.
 */
class WgLinkComponent {
  constructor() {
    this.leadingIcon = input();
    this.trailingIcon = input();
  }
  static {
    this.ɵfac = function WgLinkComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgLinkComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgLinkComponent,
      selectors: [["wg-link"]],
      inputs: {
        leadingIcon: [1, "leadingIcon"],
        trailingIcon: [1, "trailingIcon"]
      },
      ngContentSelectors: _c0,
      decls: 5,
      vars: 2,
      consts: [["wgComponentStateLayer", "", "hoverColor", "--color-brand-accent", "hoverOpacityPercent", "8", "pressedColor", "--color-brand-accent", "pressedOpacityPercent", "12"], ["size", "sm", 3, "name"]],
      template: function WgLinkComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "a", 0);
          i0.ɵɵtemplate(1, WgLinkComponent_Conditional_1_Template, 1, 1, "wg-icon", 1);
          i0.ɵɵelementStart(2, "div");
          i0.ɵɵprojection(3);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(4, WgLinkComponent_Conditional_4_Template, 1, 1, "wg-icon", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.leadingIcon() ? 1 : -1);
          i0.ɵɵadvance(3);
          i0.ɵɵconditional(ctx.trailingIcon() ? 4 : -1);
        }
      },
      dependencies: [ComponentStateLayerDirective, WgIconModule, WgIconComponent],
      styles: ["a[_ngcontent-%COMP%]{display:inline-flex;align-items:center}wg-icon[_ngcontent-%COMP%] + div[_ngcontent-%COMP%]{margin-left:var(--spacing-xs)}div[_ngcontent-%COMP%] + wg-icon[_ngcontent-%COMP%]{margin-left:var(--spacing-xs)}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgLinkComponent, [{
    type: Component,
    args: [{
      selector: 'wg-link',
      standalone: true,
      imports: [ComponentStateLayerDirective, WgIconModule],
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<a wgComponentStateLayer\n   hoverColor=\"--color-brand-accent\"\n   hoverOpacityPercent=\"8\"\n   pressedColor=\"--color-brand-accent\"\n   pressedOpacityPercent=\"12\"\n>\n\n  @if (leadingIcon()) {\n    <wg-icon size=\"sm\" [name]=\"leadingIcon()\"></wg-icon>\n  }\n\n  <div>\n    <ng-content></ng-content>\n  </div>\n\n  @if (trailingIcon()) {\n    <wg-icon size=\"sm\" [name]=\"trailingIcon()\"></wg-icon>\n  }\n</a>\n",
      styles: ["a{display:inline-flex;align-items:center}wg-icon+div{margin-left:var(--spacing-xs)}div+wg-icon{margin-left:var(--spacing-xs)}\n"]
    }]
  }], null, null);
})();

/**
 * @license
 * Copyright WatchGuard Technologies Inc. All Rights Reserved.
 *
 * This module exports WgRadioComponent that renders a radio button with
 * optional detail link.
 *
 * There are 3 input properties this component takes in:
 *  pillWidth: a number indicates how wide the pill should number
 *  pillProgress: a number indicates how much the pill should be filled
 *  pillClass: background color to match the pillProgress
 *
 */
class WgRadioComponent {
  constructor() {
    this.stateChangeEvent = new EventEmitter();
  }
  stateChanged(event) {
    this.stateChangeEvent.emit({
      state: event
    });
  }
  get outerColor() {
    return this.radioObj.state ? 'active' : 'in-active';
  }
  buttonClicked() {
    this.stateChangeEvent.emit({
      curState: this.radioObj.state
    });
  }
  static {
    this.ɵfac = function WgRadioComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgRadioComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgRadioComponent,
      selectors: [["wg-radio"]],
      inputs: {
        sharedStrings: "sharedStrings",
        radioObj: "radioObj",
        detailText: "detailText"
      },
      outputs: {
        stateChangeEvent: "stateChangeEvent"
      },
      standalone: false,
      decls: 5,
      vars: 5,
      consts: [["type", "radio", 3, "click", "checked"], ["class", "mt-10 ml-26", 4, "ngIf"], [1, "mt-10", "ml-26"]],
      template: function WgRadioComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "label")(1, "input", 0);
          i0.ɵɵlistener("click", function WgRadioComponent_Template_input_click_1_listener() {
            return ctx.buttonClicked();
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtext(2);
          i0.ɵɵpipe(3, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(4, WgRadioComponent_p_4_Template, 3, 3, "p", 1);
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("checked", ctx.radioObj.state);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, ctx.radioObj.text), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.detailText);
        }
      },
      dependencies: [i1$2.NgIf, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgRadioComponent, [{
    type: Component,
    args: [{
      selector: 'wg-radio',
      template: `
    <label>
    <input type="radio" (click)="buttonClicked()" [checked]="this.radioObj.state">
      {{ radioObj.text | translate }}
    </label>
    <p *ngIf="detailText"
      class="mt-10 ml-26">
      {{ detailText | translate }}
    </p>`,
      standalone: false
    }]
  }], () => [], {
    sharedStrings: [{
      type: Input
    }],
    radioObj: [{
      type: Input
    }],
    detailText: [{
      type: Input
    }],
    stateChangeEvent: [{
      type: Output
    }]
  });
})();
class WgRadioModule {
  static {
    this.ɵfac = function WgRadioModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgRadioModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgRadioModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, TranslateModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgRadioModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, TranslateModule],
      declarations: [WgRadioComponent],
      exports: [WgRadioComponent]
    }]
  }], null, null);
})();
class AutofocusDirective {
  constructor(element) {
    this.element = element;
  }
  ngAfterViewInit() {
    if (this.autofocus !== false) {
      setTimeout(() => this.element.nativeElement.focus());
    }
  }
  static {
    this.ɵfac = function AutofocusDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AutofocusDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: AutofocusDirective,
      selectors: [["", "autofocus", ""]],
      inputs: {
        autofocus: "autofocus"
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AutofocusDirective, [{
    type: Directive,
    args: [{
      // eslint-disable-next-line @angular-eslint/directive-selector
      selector: '[autofocus]',
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    autofocus: [{
      type: Input
    }]
  });
})();
class WgAutofocusModule {
  static {
    this.ɵfac = function WgAutofocusModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgAutofocusModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgAutofocusModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgAutofocusModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [AutofocusDirective],
      exports: [AutofocusDirective]
    }]
  }], null, null);
})();

/**
 * @license
 * Copyright WatchGuard Technologies Inc. All Rights Reserved.
 *
 * This directive exports the ClickOutsideDirective.
 *
 * This component tracks if user clicked outside of the target Element
 * and emits an event indicating that.
 *
 * Use this when we want to close a popup dialog when user clicks
 * outside the popup
 *
 * We want to close the dialog when user clicks outside of the popup dialog and
 * when the dialog is visible. The event that triggers the popup should be skipped
 * hence make sure to set an id attribute for the UI component
 * that triggers the dialog to show up.
 *
 *
 */
class ClickOutsideDirective {
  onClick(targetElement) {
    const emitEvent = {
      close: false,
      targetElem: targetElement.id
    };
    const clickedInside = this.elemRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      emitEvent.close = true;
      this.clickOutside.emit(emitEvent);
    } else {
      this.clickOutside.emit(emitEvent);
    }
  }
  constructor(elemRef) {
    this.elemRef = elemRef;
    this.clickOutside = new EventEmitter();
  }
  static {
    this.ɵfac = function ClickOutsideDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ClickOutsideDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ClickOutsideDirective,
      selectors: [["", "clickOutside", ""]],
      hostBindings: function ClickOutsideDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function ClickOutsideDirective_click_HostBindingHandler($event) {
            return ctx.onClick($event.target);
          }, false, i0.ɵɵresolveDocument);
        }
      },
      outputs: {
        clickOutside: "clickOutside"
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClickOutsideDirective, [{
    type: Directive,
    args: [{
      // eslint-disable-next-line @angular-eslint/directive-selector
      selector: '[clickOutside]',
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    clickOutside: [{
      type: Output
    }],
    onClick: [{
      type: HostListener,
      args: ['document:click', ['$event.target']]
    }]
  });
})();
class WgClickOutsideModule {
  static {
    this.ɵfac = function WgClickOutsideModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgClickOutsideModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgClickOutsideModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgClickOutsideModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [ClickOutsideDirective],
      exports: [ClickOutsideDirective]
    }]
  }], null, null);
})();
const SIZES = ['xs', 'sm', 'md', 'lg', 'xl'];
class ColumnSizeClassDirective {
  constructor(elementRef, renderer) {
    this.elementRef = elementRef;
    this.renderer = renderer;
  }
  ngOnInit() {
    if (this.sizes == null) {
      return;
    }
    this.htmlElement = this.elementRef.nativeElement;
    this.removeExistingClasses();
    this.addClasses();
  }
  addClasses() {
    let lastColumnCount = 12;
    SIZES.forEach(size => {
      if (this.sizes[size] != null) {
        lastColumnCount = this.sizes[size];
      }
      this.renderer.addClass(this.htmlElement, `col-${size}-${lastColumnCount}`);
    });
  }
  removeExistingClasses() {
    const classesToRemove = [];
    this.htmlElement.classList.forEach(cssClass => {
      if (cssClass.startsWith('col-xs-') || cssClass.startsWith('col-sm-') || cssClass.startsWith('col-md-') || cssClass.startsWith('col-lg-') || cssClass.startsWith('col-xl-') || cssClass === 'widget-sm' || cssClass === 'widget-md' || cssClass === 'widget-lg') {
        classesToRemove.push(cssClass);
      }
    });
    classesToRemove.forEach(cssClass => {
      this.renderer.removeClass(this.htmlElement, cssClass);
    });
  }
  static {
    this.ɵfac = function ColumnSizeClassDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ColumnSizeClassDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ColumnSizeClassDirective,
      selectors: [["", "wgColumnSizeClass", ""]],
      inputs: {
        sizes: [0, "wgColumnSizeClass", "sizes"]
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ColumnSizeClassDirective, [{
    type: Directive,
    args: [{
      selector: '[wgColumnSizeClass]',
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }], {
    sizes: [{
      type: Input,
      args: ['wgColumnSizeClass']
    }]
  });
})();
class ColumnSizeClassModule {
  static {
    this.ɵfac = function ColumnSizeClassModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ColumnSizeClassModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ColumnSizeClassModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ColumnSizeClassModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [ColumnSizeClassDirective],
      exports: [ColumnSizeClassDirective]
    }]
  }], null, null);
})();
;

/**
 * CSS taken from https://github.com/twbs/bootstrap/blob/v4.6.0/dist/css/bootstrap-grid.css
 */
const WgContainerQueryGridCss = `
.container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container, .container-sm {
    max-width: 540px;
  }
}

@media (min-width: 768px) {
  .container, .container-sm, .container-md {
    max-width: 720px;
  }
}

@media (min-width: 992px) {
  .container, .container-sm, .container-md, .container-lg {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  .container, .container-sm, .container-md, .container-lg, .container-xl {
    max-width: 1140px;
  }
}

.row {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}

.no-gutters > .col,
.no-gutters > [class*="col-"] {
  padding-right: 0;
  padding-left: 0;
}

.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col,
.col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm,
.col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md,
.col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg,
.col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl,
.col-xl-auto {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.col {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 100%;
}

.row-cols-1 > * {
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}

.row-cols-2 > * {
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.row-cols-3 > * {
  -ms-flex: 0 0 33.333333%;
  flex: 0 0 33.333333%;
  max-width: 33.333333%;
}

.row-cols-4 > * {
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}

.row-cols-5 > * {
  -ms-flex: 0 0 20%;
  flex: 0 0 20%;
  max-width: 20%;
}

.row-cols-6 > * {
  -ms-flex: 0 0 16.666667%;
  flex: 0 0 16.666667%;
  max-width: 16.666667%;
}

.col-auto {
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}

.col-1 {
  -ms-flex: 0 0 8.333333%;
  flex: 0 0 8.333333%;
  max-width: 8.333333%;
}

.col-2 {
  -ms-flex: 0 0 16.666667%;
  flex: 0 0 16.666667%;
  max-width: 16.666667%;
}

.col-3 {
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}

.col-4 {
  -ms-flex: 0 0 33.333333%;
  flex: 0 0 33.333333%;
  max-width: 33.333333%;
}

.col-5 {
  -ms-flex: 0 0 41.666667%;
  flex: 0 0 41.666667%;
  max-width: 41.666667%;
}

.col-6 {
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-7 {
  -ms-flex: 0 0 58.333333%;
  flex: 0 0 58.333333%;
  max-width: 58.333333%;
}

.col-8 {
  -ms-flex: 0 0 66.666667%;
  flex: 0 0 66.666667%;
  max-width: 66.666667%;
}

.col-9 {
  -ms-flex: 0 0 75%;
  flex: 0 0 75%;
  max-width: 75%;
}

.col-10 {
  -ms-flex: 0 0 83.333333%;
  flex: 0 0 83.333333%;
  max-width: 83.333333%;
}

.col-11 {
  -ms-flex: 0 0 91.666667%;
  flex: 0 0 91.666667%;
  max-width: 91.666667%;
}

.col-12 {
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}

.order-first {
  -ms-flex-order: -1;
  order: -1;
}

.order-last {
  -ms-flex-order: 13;
  order: 13;
}

.order-0 {
  -ms-flex-order: 0;
  order: 0;
}

.order-1 {
  -ms-flex-order: 1;
  order: 1;
}

.order-2 {
  -ms-flex-order: 2;
  order: 2;
}

.order-3 {
  -ms-flex-order: 3;
  order: 3;
}

.order-4 {
  -ms-flex-order: 4;
  order: 4;
}

.order-5 {
  -ms-flex-order: 5;
  order: 5;
}

.order-6 {
  -ms-flex-order: 6;
  order: 6;
}

.order-7 {
  -ms-flex-order: 7;
  order: 7;
}

.order-8 {
  -ms-flex-order: 8;
  order: 8;
}

.order-9 {
  -ms-flex-order: 9;
  order: 9;
}

.order-10 {
  -ms-flex-order: 10;
  order: 10;
}

.order-11 {
  -ms-flex-order: 11;
  order: 11;
}

.order-12 {
  -ms-flex-order: 12;
  order: 12;
}

.offset-1 {
  margin-left: 8.333333%;
}

.offset-2 {
  margin-left: 16.666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.333333%;
}

.offset-5 {
  margin-left: 41.666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.333333%;
}

.offset-8 {
  margin-left: 66.666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.333333%;
}

.offset-11 {
  margin-left: 91.666667%;
}

@media (min-width: 576px) {
  .col-sm {
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
    -ms-flex-positive: 1;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-sm-1 > * {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-sm-2 > * {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-sm-3 > * {
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
  .row-cols-sm-4 > * {
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-sm-5 > * {
    -ms-flex: 0 0 20%;
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-sm-6 > * {
    -ms-flex: 0 0 16.666667%;
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }
  .col-sm-auto {
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-sm-1 {
    -ms-flex: 0 0 8.333333%;
    flex: 0 0 8.333333%;
    max-width: 8.333333%;
  }
  .col-sm-2 {
    -ms-flex: 0 0 16.666667%;
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }
  .col-sm-3 {
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-sm-4 {
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
  .col-sm-5 {
    -ms-flex: 0 0 41.666667%;
    flex: 0 0 41.666667%;
    max-width: 41.666667%;
  }
  .col-sm-6 {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-sm-7 {
    -ms-flex: 0 0 58.333333%;
    flex: 0 0 58.333333%;
    max-width: 58.333333%;
  }
  .col-sm-8 {
    -ms-flex: 0 0 66.666667%;
    flex: 0 0 66.666667%;
    max-width: 66.666667%;
  }
  .col-sm-9 {
    -ms-flex: 0 0 75%;
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-sm-10 {
    -ms-flex: 0 0 83.333333%;
    flex: 0 0 83.333333%;
    max-width: 83.333333%;
  }
  .col-sm-11 {
    -ms-flex: 0 0 91.666667%;
    flex: 0 0 91.666667%;
    max-width: 91.666667%;
  }
  .col-sm-12 {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-sm-first {
    -ms-flex-order: -1;
    order: -1;
  }
  .order-sm-last {
    -ms-flex-order: 13;
    order: 13;
  }
  .order-sm-0 {
    -ms-flex-order: 0;
    order: 0;
  }
  .order-sm-1 {
    -ms-flex-order: 1;
    order: 1;
  }
  .order-sm-2 {
    -ms-flex-order: 2;
    order: 2;
  }
  .order-sm-3 {
    -ms-flex-order: 3;
    order: 3;
  }
  .order-sm-4 {
    -ms-flex-order: 4;
    order: 4;
  }
  .order-sm-5 {
    -ms-flex-order: 5;
    order: 5;
  }
  .order-sm-6 {
    -ms-flex-order: 6;
    order: 6;
  }
  .order-sm-7 {
    -ms-flex-order: 7;
    order: 7;
  }
  .order-sm-8 {
    -ms-flex-order: 8;
    order: 8;
  }
  .order-sm-9 {
    -ms-flex-order: 9;
    order: 9;
  }
  .order-sm-10 {
    -ms-flex-order: 10;
    order: 10;
  }
  .order-sm-11 {
    -ms-flex-order: 11;
    order: 11;
  }
  .order-sm-12 {
    -ms-flex-order: 12;
    order: 12;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.333333%;
  }
  .offset-sm-2 {
    margin-left: 16.666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.333333%;
  }
  .offset-sm-5 {
    margin-left: 41.666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.333333%;
  }
  .offset-sm-8 {
    margin-left: 66.666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.333333%;
  }
  .offset-sm-11 {
    margin-left: 91.666667%;
  }
}

@media (min-width: 768px) {
  .col-md {
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
    -ms-flex-positive: 1;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-md-1 > * {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-md-2 > * {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-md-3 > * {
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
  .row-cols-md-4 > * {
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-md-5 > * {
    -ms-flex: 0 0 20%;
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-md-6 > * {
    -ms-flex: 0 0 16.666667%;
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }
  .col-md-auto {
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-md-1 {
    -ms-flex: 0 0 8.333333%;
    flex: 0 0 8.333333%;
    max-width: 8.333333%;
  }
  .col-md-2 {
    -ms-flex: 0 0 16.666667%;
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }
  .col-md-3 {
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-md-4 {
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
  .col-md-5 {
    -ms-flex: 0 0 41.666667%;
    flex: 0 0 41.666667%;
    max-width: 41.666667%;
  }
  .col-md-6 {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-md-7 {
    -ms-flex: 0 0 58.333333%;
    flex: 0 0 58.333333%;
    max-width: 58.333333%;
  }
  .col-md-8 {
    -ms-flex: 0 0 66.666667%;
    flex: 0 0 66.666667%;
    max-width: 66.666667%;
  }
  .col-md-9 {
    -ms-flex: 0 0 75%;
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-md-10 {
    -ms-flex: 0 0 83.333333%;
    flex: 0 0 83.333333%;
    max-width: 83.333333%;
  }
  .col-md-11 {
    -ms-flex: 0 0 91.666667%;
    flex: 0 0 91.666667%;
    max-width: 91.666667%;
  }
  .col-md-12 {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-md-first {
    -ms-flex-order: -1;
    order: -1;
  }
  .order-md-last {
    -ms-flex-order: 13;
    order: 13;
  }
  .order-md-0 {
    -ms-flex-order: 0;
    order: 0;
  }
  .order-md-1 {
    -ms-flex-order: 1;
    order: 1;
  }
  .order-md-2 {
    -ms-flex-order: 2;
    order: 2;
  }
  .order-md-3 {
    -ms-flex-order: 3;
    order: 3;
  }
  .order-md-4 {
    -ms-flex-order: 4;
    order: 4;
  }
  .order-md-5 {
    -ms-flex-order: 5;
    order: 5;
  }
  .order-md-6 {
    -ms-flex-order: 6;
    order: 6;
  }
  .order-md-7 {
    -ms-flex-order: 7;
    order: 7;
  }
  .order-md-8 {
    -ms-flex-order: 8;
    order: 8;
  }
  .order-md-9 {
    -ms-flex-order: 9;
    order: 9;
  }
  .order-md-10 {
    -ms-flex-order: 10;
    order: 10;
  }
  .order-md-11 {
    -ms-flex-order: 11;
    order: 11;
  }
  .order-md-12 {
    -ms-flex-order: 12;
    order: 12;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.333333%;
  }
  .offset-md-2 {
    margin-left: 16.666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.333333%;
  }
  .offset-md-5 {
    margin-left: 41.666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.333333%;
  }
  .offset-md-8 {
    margin-left: 66.666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.333333%;
  }
  .offset-md-11 {
    margin-left: 91.666667%;
  }
}

@media (min-width: 992px) {
  .col-lg {
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
    -ms-flex-positive: 1;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-lg-1 > * {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-lg-2 > * {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-lg-3 > * {
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
  .row-cols-lg-4 > * {
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-lg-5 > * {
    -ms-flex: 0 0 20%;
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-lg-6 > * {
    -ms-flex: 0 0 16.666667%;
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }
  .col-lg-auto {
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-lg-1 {
    -ms-flex: 0 0 8.333333%;
    flex: 0 0 8.333333%;
    max-width: 8.333333%;
  }
  .col-lg-2 {
    -ms-flex: 0 0 16.666667%;
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }
  .col-lg-3 {
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-lg-4 {
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
  .col-lg-5 {
    -ms-flex: 0 0 41.666667%;
    flex: 0 0 41.666667%;
    max-width: 41.666667%;
  }
  .col-lg-6 {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-lg-7 {
    -ms-flex: 0 0 58.333333%;
    flex: 0 0 58.333333%;
    max-width: 58.333333%;
  }
  .col-lg-8 {
    -ms-flex: 0 0 66.666667%;
    flex: 0 0 66.666667%;
    max-width: 66.666667%;
  }
  .col-lg-9 {
    -ms-flex: 0 0 75%;
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-lg-10 {
    -ms-flex: 0 0 83.333333%;
    flex: 0 0 83.333333%;
    max-width: 83.333333%;
  }
  .col-lg-11 {
    -ms-flex: 0 0 91.666667%;
    flex: 0 0 91.666667%;
    max-width: 91.666667%;
  }
  .col-lg-12 {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-lg-first {
    -ms-flex-order: -1;
    order: -1;
  }
  .order-lg-last {
    -ms-flex-order: 13;
    order: 13;
  }
  .order-lg-0 {
    -ms-flex-order: 0;
    order: 0;
  }
  .order-lg-1 {
    -ms-flex-order: 1;
    order: 1;
  }
  .order-lg-2 {
    -ms-flex-order: 2;
    order: 2;
  }
  .order-lg-3 {
    -ms-flex-order: 3;
    order: 3;
  }
  .order-lg-4 {
    -ms-flex-order: 4;
    order: 4;
  }
  .order-lg-5 {
    -ms-flex-order: 5;
    order: 5;
  }
  .order-lg-6 {
    -ms-flex-order: 6;
    order: 6;
  }
  .order-lg-7 {
    -ms-flex-order: 7;
    order: 7;
  }
  .order-lg-8 {
    -ms-flex-order: 8;
    order: 8;
  }
  .order-lg-9 {
    -ms-flex-order: 9;
    order: 9;
  }
  .order-lg-10 {
    -ms-flex-order: 10;
    order: 10;
  }
  .order-lg-11 {
    -ms-flex-order: 11;
    order: 11;
  }
  .order-lg-12 {
    -ms-flex-order: 12;
    order: 12;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.333333%;
  }
  .offset-lg-2 {
    margin-left: 16.666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.333333%;
  }
  .offset-lg-5 {
    margin-left: 41.666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.333333%;
  }
  .offset-lg-8 {
    margin-left: 66.666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.333333%;
  }
  .offset-lg-11 {
    margin-left: 91.666667%;
  }
}

@media (min-width: 1200px) {
  .col-xl {
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
    -ms-flex-positive: 1;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-xl-1 > * {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-xl-2 > * {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-xl-3 > * {
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
  .row-cols-xl-4 > * {
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-xl-5 > * {
    -ms-flex: 0 0 20%;
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-xl-6 > * {
    -ms-flex: 0 0 16.666667%;
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }
  .col-xl-auto {
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-xl-1 {
    -ms-flex: 0 0 8.333333%;
    flex: 0 0 8.333333%;
    max-width: 8.333333%;
  }
  .col-xl-2 {
    -ms-flex: 0 0 16.666667%;
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }
  .col-xl-3 {
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-xl-4 {
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
  .col-xl-5 {
    -ms-flex: 0 0 41.666667%;
    flex: 0 0 41.666667%;
    max-width: 41.666667%;
  }
  .col-xl-6 {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-xl-7 {
    -ms-flex: 0 0 58.333333%;
    flex: 0 0 58.333333%;
    max-width: 58.333333%;
  }
  .col-xl-8 {
    -ms-flex: 0 0 66.666667%;
    flex: 0 0 66.666667%;
    max-width: 66.666667%;
  }
  .col-xl-9 {
    -ms-flex: 0 0 75%;
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-xl-10 {
    -ms-flex: 0 0 83.333333%;
    flex: 0 0 83.333333%;
    max-width: 83.333333%;
  }
  .col-xl-11 {
    -ms-flex: 0 0 91.666667%;
    flex: 0 0 91.666667%;
    max-width: 91.666667%;
  }
  .col-xl-12 {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-xl-first {
    -ms-flex-order: -1;
    order: -1;
  }
  .order-xl-last {
    -ms-flex-order: 13;
    order: 13;
  }
  .order-xl-0 {
    -ms-flex-order: 0;
    order: 0;
  }
  .order-xl-1 {
    -ms-flex-order: 1;
    order: 1;
  }
  .order-xl-2 {
    -ms-flex-order: 2;
    order: 2;
  }
  .order-xl-3 {
    -ms-flex-order: 3;
    order: 3;
  }
  .order-xl-4 {
    -ms-flex-order: 4;
    order: 4;
  }
  .order-xl-5 {
    -ms-flex-order: 5;
    order: 5;
  }
  .order-xl-6 {
    -ms-flex-order: 6;
    order: 6;
  }
  .order-xl-7 {
    -ms-flex-order: 7;
    order: 7;
  }
  .order-xl-8 {
    -ms-flex-order: 8;
    order: 8;
  }
  .order-xl-9 {
    -ms-flex-order: 9;
    order: 9;
  }
  .order-xl-10 {
    -ms-flex-order: 10;
    order: 10;
  }
  .order-xl-11 {
    -ms-flex-order: 11;
    order: 11;
  }
  .order-xl-12 {
    -ms-flex-order: 12;
    order: 12;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.333333%;
  }
  .offset-xl-2 {
    margin-left: 16.666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.333333%;
  }
  .offset-xl-5 {
    margin-left: 41.666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.333333%;
  }
  .offset-xl-8 {
    margin-left: 66.666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.333333%;
  }
  .offset-xl-11 {
    margin-left: 91.666667%;
  }
}

.d-none {
  display: none !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: -ms-flexbox !important;
  display: flex !important;
}

.d-inline-flex {
  display: -ms-inline-flexbox !important;
  display: inline-flex !important;
}

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: -ms-flexbox !important;
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: -ms-inline-flexbox !important;
    display: inline-flex !important;
  }
}

@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: -ms-flexbox !important;
    display: flex !important;
  }
  .d-md-inline-flex {
    display: -ms-inline-flexbox !important;
    display: inline-flex !important;
  }
}

@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: -ms-flexbox !important;
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: -ms-inline-flexbox !important;
    display: inline-flex !important;
  }
}

@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: -ms-flexbox !important;
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: -ms-inline-flexbox !important;
    display: inline-flex !important;
  }
}

@media print {
  .d-print-none {
    display: none !important;
  }
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: -ms-flexbox !important;
    display: flex !important;
  }
  .d-print-inline-flex {
    display: -ms-inline-flexbox !important;
    display: inline-flex !important;
  }
}

.flex-row {
  -ms-flex-direction: row !important;
  flex-direction: row !important;
}

.flex-column {
  -ms-flex-direction: column !important;
  flex-direction: column !important;
}

.flex-row-reverse {
  -ms-flex-direction: row-reverse !important;
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  -ms-flex-direction: column-reverse !important;
  flex-direction: column-reverse !important;
}

.flex-wrap {
  -ms-flex-wrap: wrap !important;
  flex-wrap: wrap !important;
}

.flex-nowrap {
  -ms-flex-wrap: nowrap !important;
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  -ms-flex-wrap: wrap-reverse !important;
  flex-wrap: wrap-reverse !important;
}

.flex-fill {
  -ms-flex: 1 1 auto !important;
  flex: 1 1 auto !important;
}

.flex-grow-0 {
  -ms-flex-positive: 0 !important;
  flex-grow: 0 !important;
}

.flex-grow-1 {
  -ms-flex-positive: 1 !important;
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  -ms-flex-negative: 0 !important;
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  -ms-flex-negative: 1 !important;
  flex-shrink: 1 !important;
}

.justify-content-start {
  -ms-flex-pack: start !important;
  justify-content: flex-start !important;
}

.justify-content-end {
  -ms-flex-pack: end !important;
  justify-content: flex-end !important;
}

.justify-content-center {
  -ms-flex-pack: center !important;
  justify-content: center !important;
}

.justify-content-between {
  -ms-flex-pack: justify !important;
  justify-content: space-between !important;
}

.justify-content-around {
  -ms-flex-pack: distribute !important;
  justify-content: space-around !important;
}

.align-items-start {
  -ms-flex-align: start !important;
  align-items: flex-start !important;
}

.align-items-end {
  -ms-flex-align: end !important;
  align-items: flex-end !important;
}

.align-items-center {
  -ms-flex-align: center !important;
  align-items: center !important;
}

.align-items-baseline {
  -ms-flex-align: baseline !important;
  align-items: baseline !important;
}

.align-items-stretch {
  -ms-flex-align: stretch !important;
  align-items: stretch !important;
}

.align-content-start {
  -ms-flex-line-pack: start !important;
  align-content: flex-start !important;
}

.align-content-end {
  -ms-flex-line-pack: end !important;
  align-content: flex-end !important;
}

.align-content-center {
  -ms-flex-line-pack: center !important;
  align-content: center !important;
}

.align-content-between {
  -ms-flex-line-pack: justify !important;
  align-content: space-between !important;
}

.align-content-around {
  -ms-flex-line-pack: distribute !important;
  align-content: space-around !important;
}

.align-content-stretch {
  -ms-flex-line-pack: stretch !important;
  align-content: stretch !important;
}

.align-self-auto {
  -ms-flex-item-align: auto !important;
  align-self: auto !important;
}

.align-self-start {
  -ms-flex-item-align: start !important;
  align-self: flex-start !important;
}

.align-self-end {
  -ms-flex-item-align: end !important;
  align-self: flex-end !important;
}

.align-self-center {
  -ms-flex-item-align: center !important;
  align-self: center !important;
}

.align-self-baseline {
  -ms-flex-item-align: baseline !important;
  align-self: baseline !important;
}

.align-self-stretch {
  -ms-flex-item-align: stretch !important;
  align-self: stretch !important;
}

@media (min-width: 576px) {
  .flex-sm-row {
    -ms-flex-direction: row !important;
    flex-direction: row !important;
  }
  .flex-sm-column {
    -ms-flex-direction: column !important;
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    -ms-flex-direction: row-reverse !important;
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    -ms-flex-direction: column-reverse !important;
    flex-direction: column-reverse !important;
  }
  .flex-sm-wrap {
    -ms-flex-wrap: wrap !important;
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    -ms-flex-wrap: nowrap !important;
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    -ms-flex-wrap: wrap-reverse !important;
    flex-wrap: wrap-reverse !important;
  }
  .flex-sm-fill {
    -ms-flex: 1 1 auto !important;
    flex: 1 1 auto !important;
  }
  .flex-sm-grow-0 {
    -ms-flex-positive: 0 !important;
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    -ms-flex-positive: 1 !important;
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    -ms-flex-negative: 0 !important;
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    -ms-flex-negative: 1 !important;
    flex-shrink: 1 !important;
  }
  .justify-content-sm-start {
    -ms-flex-pack: start !important;
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    -ms-flex-pack: end !important;
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    -ms-flex-pack: center !important;
    justify-content: center !important;
  }
  .justify-content-sm-between {
    -ms-flex-pack: justify !important;
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    -ms-flex-pack: distribute !important;
    justify-content: space-around !important;
  }
  .align-items-sm-start {
    -ms-flex-align: start !important;
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    -ms-flex-align: end !important;
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    -ms-flex-align: center !important;
    align-items: center !important;
  }
  .align-items-sm-baseline {
    -ms-flex-align: baseline !important;
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    -ms-flex-align: stretch !important;
    align-items: stretch !important;
  }
  .align-content-sm-start {
    -ms-flex-line-pack: start !important;
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    -ms-flex-line-pack: end !important;
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    -ms-flex-line-pack: center !important;
    align-content: center !important;
  }
  .align-content-sm-between {
    -ms-flex-line-pack: justify !important;
    align-content: space-between !important;
  }
  .align-content-sm-around {
    -ms-flex-line-pack: distribute !important;
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    -ms-flex-line-pack: stretch !important;
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    -ms-flex-item-align: auto !important;
    align-self: auto !important;
  }
  .align-self-sm-start {
    -ms-flex-item-align: start !important;
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    -ms-flex-item-align: end !important;
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    -ms-flex-item-align: center !important;
    align-self: center !important;
  }
  .align-self-sm-baseline {
    -ms-flex-item-align: baseline !important;
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    -ms-flex-item-align: stretch !important;
    align-self: stretch !important;
  }
}

@media (min-width: 768px) {
  .flex-md-row {
    -ms-flex-direction: row !important;
    flex-direction: row !important;
  }
  .flex-md-column {
    -ms-flex-direction: column !important;
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    -ms-flex-direction: row-reverse !important;
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    -ms-flex-direction: column-reverse !important;
    flex-direction: column-reverse !important;
  }
  .flex-md-wrap {
    -ms-flex-wrap: wrap !important;
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    -ms-flex-wrap: nowrap !important;
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    -ms-flex-wrap: wrap-reverse !important;
    flex-wrap: wrap-reverse !important;
  }
  .flex-md-fill {
    -ms-flex: 1 1 auto !important;
    flex: 1 1 auto !important;
  }
  .flex-md-grow-0 {
    -ms-flex-positive: 0 !important;
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    -ms-flex-positive: 1 !important;
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    -ms-flex-negative: 0 !important;
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    -ms-flex-negative: 1 !important;
    flex-shrink: 1 !important;
  }
  .justify-content-md-start {
    -ms-flex-pack: start !important;
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    -ms-flex-pack: end !important;
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    -ms-flex-pack: center !important;
    justify-content: center !important;
  }
  .justify-content-md-between {
    -ms-flex-pack: justify !important;
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    -ms-flex-pack: distribute !important;
    justify-content: space-around !important;
  }
  .align-items-md-start {
    -ms-flex-align: start !important;
    align-items: flex-start !important;
  }
  .align-items-md-end {
    -ms-flex-align: end !important;
    align-items: flex-end !important;
  }
  .align-items-md-center {
    -ms-flex-align: center !important;
    align-items: center !important;
  }
  .align-items-md-baseline {
    -ms-flex-align: baseline !important;
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    -ms-flex-align: stretch !important;
    align-items: stretch !important;
  }
  .align-content-md-start {
    -ms-flex-line-pack: start !important;
    align-content: flex-start !important;
  }
  .align-content-md-end {
    -ms-flex-line-pack: end !important;
    align-content: flex-end !important;
  }
  .align-content-md-center {
    -ms-flex-line-pack: center !important;
    align-content: center !important;
  }
  .align-content-md-between {
    -ms-flex-line-pack: justify !important;
    align-content: space-between !important;
  }
  .align-content-md-around {
    -ms-flex-line-pack: distribute !important;
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    -ms-flex-line-pack: stretch !important;
    align-content: stretch !important;
  }
  .align-self-md-auto {
    -ms-flex-item-align: auto !important;
    align-self: auto !important;
  }
  .align-self-md-start {
    -ms-flex-item-align: start !important;
    align-self: flex-start !important;
  }
  .align-self-md-end {
    -ms-flex-item-align: end !important;
    align-self: flex-end !important;
  }
  .align-self-md-center {
    -ms-flex-item-align: center !important;
    align-self: center !important;
  }
  .align-self-md-baseline {
    -ms-flex-item-align: baseline !important;
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    -ms-flex-item-align: stretch !important;
    align-self: stretch !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-row {
    -ms-flex-direction: row !important;
    flex-direction: row !important;
  }
  .flex-lg-column {
    -ms-flex-direction: column !important;
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    -ms-flex-direction: row-reverse !important;
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    -ms-flex-direction: column-reverse !important;
    flex-direction: column-reverse !important;
  }
  .flex-lg-wrap {
    -ms-flex-wrap: wrap !important;
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    -ms-flex-wrap: nowrap !important;
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    -ms-flex-wrap: wrap-reverse !important;
    flex-wrap: wrap-reverse !important;
  }
  .flex-lg-fill {
    -ms-flex: 1 1 auto !important;
    flex: 1 1 auto !important;
  }
  .flex-lg-grow-0 {
    -ms-flex-positive: 0 !important;
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    -ms-flex-positive: 1 !important;
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    -ms-flex-negative: 0 !important;
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    -ms-flex-negative: 1 !important;
    flex-shrink: 1 !important;
  }
  .justify-content-lg-start {
    -ms-flex-pack: start !important;
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    -ms-flex-pack: end !important;
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    -ms-flex-pack: center !important;
    justify-content: center !important;
  }
  .justify-content-lg-between {
    -ms-flex-pack: justify !important;
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    -ms-flex-pack: distribute !important;
    justify-content: space-around !important;
  }
  .align-items-lg-start {
    -ms-flex-align: start !important;
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    -ms-flex-align: end !important;
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    -ms-flex-align: center !important;
    align-items: center !important;
  }
  .align-items-lg-baseline {
    -ms-flex-align: baseline !important;
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    -ms-flex-align: stretch !important;
    align-items: stretch !important;
  }
  .align-content-lg-start {
    -ms-flex-line-pack: start !important;
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    -ms-flex-line-pack: end !important;
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    -ms-flex-line-pack: center !important;
    align-content: center !important;
  }
  .align-content-lg-between {
    -ms-flex-line-pack: justify !important;
    align-content: space-between !important;
  }
  .align-content-lg-around {
    -ms-flex-line-pack: distribute !important;
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    -ms-flex-line-pack: stretch !important;
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    -ms-flex-item-align: auto !important;
    align-self: auto !important;
  }
  .align-self-lg-start {
    -ms-flex-item-align: start !important;
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    -ms-flex-item-align: end !important;
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    -ms-flex-item-align: center !important;
    align-self: center !important;
  }
  .align-self-lg-baseline {
    -ms-flex-item-align: baseline !important;
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    -ms-flex-item-align: stretch !important;
    align-self: stretch !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-row {
    -ms-flex-direction: row !important;
    flex-direction: row !important;
  }
  .flex-xl-column {
    -ms-flex-direction: column !important;
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    -ms-flex-direction: row-reverse !important;
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    -ms-flex-direction: column-reverse !important;
    flex-direction: column-reverse !important;
  }
  .flex-xl-wrap {
    -ms-flex-wrap: wrap !important;
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    -ms-flex-wrap: nowrap !important;
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    -ms-flex-wrap: wrap-reverse !important;
    flex-wrap: wrap-reverse !important;
  }
  .flex-xl-fill {
    -ms-flex: 1 1 auto !important;
    flex: 1 1 auto !important;
  }
  .flex-xl-grow-0 {
    -ms-flex-positive: 0 !important;
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    -ms-flex-positive: 1 !important;
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    -ms-flex-negative: 0 !important;
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    -ms-flex-negative: 1 !important;
    flex-shrink: 1 !important;
  }
  .justify-content-xl-start {
    -ms-flex-pack: start !important;
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    -ms-flex-pack: end !important;
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    -ms-flex-pack: center !important;
    justify-content: center !important;
  }
  .justify-content-xl-between {
    -ms-flex-pack: justify !important;
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    -ms-flex-pack: distribute !important;
    justify-content: space-around !important;
  }
  .align-items-xl-start {
    -ms-flex-align: start !important;
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    -ms-flex-align: end !important;
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    -ms-flex-align: center !important;
    align-items: center !important;
  }
  .align-items-xl-baseline {
    -ms-flex-align: baseline !important;
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    -ms-flex-align: stretch !important;
    align-items: stretch !important;
  }
  .align-content-xl-start {
    -ms-flex-line-pack: start !important;
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    -ms-flex-line-pack: end !important;
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    -ms-flex-line-pack: center !important;
    align-content: center !important;
  }
  .align-content-xl-between {
    -ms-flex-line-pack: justify !important;
    align-content: space-between !important;
  }
  .align-content-xl-around {
    -ms-flex-line-pack: distribute !important;
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    -ms-flex-line-pack: stretch !important;
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    -ms-flex-item-align: auto !important;
    align-self: auto !important;
  }
  .align-self-xl-start {
    -ms-flex-item-align: start !important;
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    -ms-flex-item-align: end !important;
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    -ms-flex-item-align: center !important;
    align-self: center !important;
  }
  .align-self-xl-baseline {
    -ms-flex-item-align: baseline !important;
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    -ms-flex-item-align: stretch !important;
    align-self: stretch !important;
  }
}

.m-0 {
  margin: 0 !important;
}

.mt-0,
.my-0 {
  margin-top: 0 !important;
}

.mr-0,
.mx-0 {
  margin-right: 0 !important;
}

.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}

.ml-0,
.mx-0 {
  margin-left: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.mt-1,
.my-1 {
  margin-top: 0.25rem !important;
}

.mr-1,
.mx-1 {
  margin-right: 0.25rem !important;
}

.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important;
}

.ml-1,
.mx-1 {
  margin-left: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.mt-2,
.my-2 {
  margin-top: 0.5rem !important;
}

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important;
}

.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important;
}

.ml-2,
.mx-2 {
  margin-left: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.mt-3,
.my-3 {
  margin-top: 1rem !important;
}

.mr-3,
.mx-3 {
  margin-right: 1rem !important;
}

.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}

.ml-3,
.mx-3 {
  margin-left: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.mt-4,
.my-4 {
  margin-top: 1.5rem !important;
}

.mr-4,
.mx-4 {
  margin-right: 1.5rem !important;
}

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

.ml-4,
.mx-4 {
  margin-left: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.mt-5,
.my-5 {
  margin-top: 3rem !important;
}

.mr-5,
.mx-5 {
  margin-right: 3rem !important;
}

.mb-5,
.my-5 {
  margin-bottom: 3rem !important;
}

.ml-5,
.mx-5 {
  margin-left: 3rem !important;
}

.p-0 {
  padding: 0 !important;
}

.pt-0,
.py-0 {
  padding-top: 0 !important;
}

.pr-0,
.px-0 {
  padding-right: 0 !important;
}

.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}

.pl-0,
.px-0 {
  padding-left: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.pt-1,
.py-1 {
  padding-top: 0.25rem !important;
}

.pr-1,
.px-1 {
  padding-right: 0.25rem !important;
}

.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important;
}

.pl-1,
.px-1 {
  padding-left: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.pt-2,
.py-2 {
  padding-top: 0.5rem !important;
}

.pr-2,
.px-2 {
  padding-right: 0.5rem !important;
}

.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important;
}

.pl-2,
.px-2 {
  padding-left: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.pt-3,
.py-3 {
  padding-top: 1rem !important;
}

.pr-3,
.px-3 {
  padding-right: 1rem !important;
}

.pb-3,
.py-3 {
  padding-bottom: 1rem !important;
}

.pl-3,
.px-3 {
  padding-left: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.pt-4,
.py-4 {
  padding-top: 1.5rem !important;
}

.pr-4,
.px-4 {
  padding-right: 1.5rem !important;
}

.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important;
}

.pl-4,
.px-4 {
  padding-left: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.pt-5,
.py-5 {
  padding-top: 3rem !important;
}

.pr-5,
.px-5 {
  padding-right: 3rem !important;
}

.pb-5,
.py-5 {
  padding-bottom: 3rem !important;
}

.pl-5,
.px-5 {
  padding-left: 3rem !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.mt-n1,
.my-n1 {
  margin-top: -0.25rem !important;
}

.mr-n1,
.mx-n1 {
  margin-right: -0.25rem !important;
}

.mb-n1,
.my-n1 {
  margin-bottom: -0.25rem !important;
}

.ml-n1,
.mx-n1 {
  margin-left: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.mt-n2,
.my-n2 {
  margin-top: -0.5rem !important;
}

.mr-n2,
.mx-n2 {
  margin-right: -0.5rem !important;
}

.mb-n2,
.my-n2 {
  margin-bottom: -0.5rem !important;
}

.ml-n2,
.mx-n2 {
  margin-left: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.mt-n3,
.my-n3 {
  margin-top: -1rem !important;
}

.mr-n3,
.mx-n3 {
  margin-right: -1rem !important;
}

.mb-n3,
.my-n3 {
  margin-bottom: -1rem !important;
}

.ml-n3,
.mx-n3 {
  margin-left: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.mt-n4,
.my-n4 {
  margin-top: -1.5rem !important;
}

.mr-n4,
.mx-n4 {
  margin-right: -1.5rem !important;
}

.mb-n4,
.my-n4 {
  margin-bottom: -1.5rem !important;
}

.ml-n4,
.mx-n4 {
  margin-left: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.mt-n5,
.my-n5 {
  margin-top: -3rem !important;
}

.mr-n5,
.mx-n5 {
  margin-right: -3rem !important;
}

.mb-n5,
.my-n5 {
  margin-bottom: -3rem !important;
}

.ml-n5,
.mx-n5 {
  margin-left: -3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mt-auto,
.my-auto {
  margin-top: auto !important;
}

.mr-auto,
.mx-auto {
  margin-right: auto !important;
}

.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}

.ml-auto,
.mx-auto {
  margin-left: auto !important;
}

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }
  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important;
  }
  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important;
  }
  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important;
  }
  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .mt-sm-1,
  .my-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 0.25rem !important;
  }
  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .mt-sm-2,
  .my-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 0.5rem !important;
  }
  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .mt-sm-3,
  .my-sm-3 {
    margin-top: 1rem !important;
  }
  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 1rem !important;
  }
  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 1rem !important;
  }
  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .mt-sm-4,
  .my-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 1.5rem !important;
  }
  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .mt-sm-5,
  .my-sm-5 {
    margin-top: 3rem !important;
  }
  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 3rem !important;
  }
  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 3rem !important;
  }
  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 3rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important;
  }
  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important;
  }
  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important;
  }
  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .pt-sm-1,
  .py-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pr-sm-1,
  .px-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-sm-1,
  .px-sm-1 {
    padding-left: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .pt-sm-2,
  .py-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pr-sm-2,
  .px-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-sm-2,
  .px-sm-2 {
    padding-left: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .pt-sm-3,
  .py-sm-3 {
    padding-top: 1rem !important;
  }
  .pr-sm-3,
  .px-sm-3 {
    padding-right: 1rem !important;
  }
  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pl-sm-3,
  .px-sm-3 {
    padding-left: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .pt-sm-4,
  .py-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pr-sm-4,
  .px-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-sm-4,
  .px-sm-4 {
    padding-left: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .pt-sm-5,
  .py-sm-5 {
    padding-top: 3rem !important;
  }
  .pr-sm-5,
  .px-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 3rem !important;
  }
  .pl-sm-5,
  .px-sm-5 {
    padding-left: 3rem !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .mt-sm-n1,
  .my-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-sm-n1,
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-sm-n1,
  .my-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-sm-n1,
  .mx-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .mt-sm-n2,
  .my-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-sm-n2,
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-sm-n2,
  .my-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-sm-n2,
  .mx-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -1rem !important;
  }
  .mt-sm-n3,
  .my-sm-n3 {
    margin-top: -1rem !important;
  }
  .mr-sm-n3,
  .mx-sm-n3 {
    margin-right: -1rem !important;
  }
  .mb-sm-n3,
  .my-sm-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-sm-n3,
  .mx-sm-n3 {
    margin-left: -1rem !important;
  }
  .m-sm-n4 {
    margin: -1.5rem !important;
  }
  .mt-sm-n4,
  .my-sm-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-sm-n4,
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-sm-n4,
  .my-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-sm-n4,
  .mx-sm-n4 {
    margin-left: -1.5rem !important;
  }
  .m-sm-n5 {
    margin: -3rem !important;
  }
  .mt-sm-n5,
  .my-sm-n5 {
    margin-top: -3rem !important;
  }
  .mr-sm-n5,
  .mx-sm-n5 {
    margin-right: -3rem !important;
  }
  .mb-sm-n5,
  .my-sm-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-sm-n5,
  .mx-sm-n5 {
    margin-left: -3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important;
  }
  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important;
  }
  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }
  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important;
  }
  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important;
  }
  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important;
  }
  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .mt-md-1,
  .my-md-1 {
    margin-top: 0.25rem !important;
  }
  .mr-md-1,
  .mx-md-1 {
    margin-right: 0.25rem !important;
  }
  .mb-md-1,
  .my-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-md-1,
  .mx-md-1 {
    margin-left: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .mt-md-2,
  .my-md-2 {
    margin-top: 0.5rem !important;
  }
  .mr-md-2,
  .mx-md-2 {
    margin-right: 0.5rem !important;
  }
  .mb-md-2,
  .my-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-md-2,
  .mx-md-2 {
    margin-left: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .mt-md-3,
  .my-md-3 {
    margin-top: 1rem !important;
  }
  .mr-md-3,
  .mx-md-3 {
    margin-right: 1rem !important;
  }
  .mb-md-3,
  .my-md-3 {
    margin-bottom: 1rem !important;
  }
  .ml-md-3,
  .mx-md-3 {
    margin-left: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .mt-md-4,
  .my-md-4 {
    margin-top: 1.5rem !important;
  }
  .mr-md-4,
  .mx-md-4 {
    margin-right: 1.5rem !important;
  }
  .mb-md-4,
  .my-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-md-4,
  .mx-md-4 {
    margin-left: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .mt-md-5,
  .my-md-5 {
    margin-top: 3rem !important;
  }
  .mr-md-5,
  .mx-md-5 {
    margin-right: 3rem !important;
  }
  .mb-md-5,
  .my-md-5 {
    margin-bottom: 3rem !important;
  }
  .ml-md-5,
  .mx-md-5 {
    margin-left: 3rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important;
  }
  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important;
  }
  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important;
  }
  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .pt-md-1,
  .py-md-1 {
    padding-top: 0.25rem !important;
  }
  .pr-md-1,
  .px-md-1 {
    padding-right: 0.25rem !important;
  }
  .pb-md-1,
  .py-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-md-1,
  .px-md-1 {
    padding-left: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .pt-md-2,
  .py-md-2 {
    padding-top: 0.5rem !important;
  }
  .pr-md-2,
  .px-md-2 {
    padding-right: 0.5rem !important;
  }
  .pb-md-2,
  .py-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-md-2,
  .px-md-2 {
    padding-left: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .pt-md-3,
  .py-md-3 {
    padding-top: 1rem !important;
  }
  .pr-md-3,
  .px-md-3 {
    padding-right: 1rem !important;
  }
  .pb-md-3,
  .py-md-3 {
    padding-bottom: 1rem !important;
  }
  .pl-md-3,
  .px-md-3 {
    padding-left: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .pt-md-4,
  .py-md-4 {
    padding-top: 1.5rem !important;
  }
  .pr-md-4,
  .px-md-4 {
    padding-right: 1.5rem !important;
  }
  .pb-md-4,
  .py-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-md-4,
  .px-md-4 {
    padding-left: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .pt-md-5,
  .py-md-5 {
    padding-top: 3rem !important;
  }
  .pr-md-5,
  .px-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-5,
  .py-md-5 {
    padding-bottom: 3rem !important;
  }
  .pl-md-5,
  .px-md-5 {
    padding-left: 3rem !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .mt-md-n1,
  .my-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-md-n1,
  .mx-md-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-md-n1,
  .my-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-md-n1,
  .mx-md-n1 {
    margin-left: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .mt-md-n2,
  .my-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-md-n2,
  .mx-md-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-md-n2,
  .my-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-md-n2,
  .mx-md-n2 {
    margin-left: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -1rem !important;
  }
  .mt-md-n3,
  .my-md-n3 {
    margin-top: -1rem !important;
  }
  .mr-md-n3,
  .mx-md-n3 {
    margin-right: -1rem !important;
  }
  .mb-md-n3,
  .my-md-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-md-n3,
  .mx-md-n3 {
    margin-left: -1rem !important;
  }
  .m-md-n4 {
    margin: -1.5rem !important;
  }
  .mt-md-n4,
  .my-md-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-md-n4,
  .mx-md-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-md-n4,
  .my-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-md-n4,
  .mx-md-n4 {
    margin-left: -1.5rem !important;
  }
  .m-md-n5 {
    margin: -3rem !important;
  }
  .mt-md-n5,
  .my-md-n5 {
    margin-top: -3rem !important;
  }
  .mr-md-n5,
  .mx-md-n5 {
    margin-right: -3rem !important;
  }
  .mb-md-n5,
  .my-md-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-md-n5,
  .mx-md-n5 {
    margin-left: -3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important;
  }
  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important;
  }
  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important;
  }
  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }
  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important;
  }
  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important;
  }
  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important;
  }
  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 0.25rem !important;
  }
  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .mt-lg-2,
  .my-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 0.5rem !important;
  }
  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .mt-lg-3,
  .my-lg-3 {
    margin-top: 1rem !important;
  }
  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 1rem !important;
  }
  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 1rem !important;
  }
  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .mt-lg-4,
  .my-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 1.5rem !important;
  }
  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .mt-lg-5,
  .my-lg-5 {
    margin-top: 3rem !important;
  }
  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 3rem !important;
  }
  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 3rem !important;
  }
  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 3rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important;
  }
  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important;
  }
  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important;
  }
  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .pt-lg-1,
  .py-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pr-lg-1,
  .px-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-lg-1,
  .px-lg-1 {
    padding-left: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .pt-lg-2,
  .py-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pr-lg-2,
  .px-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-lg-2,
  .px-lg-2 {
    padding-left: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .pt-lg-3,
  .py-lg-3 {
    padding-top: 1rem !important;
  }
  .pr-lg-3,
  .px-lg-3 {
    padding-right: 1rem !important;
  }
  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pl-lg-3,
  .px-lg-3 {
    padding-left: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .pt-lg-4,
  .py-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pr-lg-4,
  .px-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-lg-4,
  .px-lg-4 {
    padding-left: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .pt-lg-5,
  .py-lg-5 {
    padding-top: 3rem !important;
  }
  .pr-lg-5,
  .px-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 3rem !important;
  }
  .pl-lg-5,
  .px-lg-5 {
    padding-left: 3rem !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .mt-lg-n1,
  .my-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-lg-n1,
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-lg-n1,
  .my-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-lg-n1,
  .mx-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .mt-lg-n2,
  .my-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-lg-n2,
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-lg-n2,
  .my-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-lg-n2,
  .mx-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -1rem !important;
  }
  .mt-lg-n3,
  .my-lg-n3 {
    margin-top: -1rem !important;
  }
  .mr-lg-n3,
  .mx-lg-n3 {
    margin-right: -1rem !important;
  }
  .mb-lg-n3,
  .my-lg-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-lg-n3,
  .mx-lg-n3 {
    margin-left: -1rem !important;
  }
  .m-lg-n4 {
    margin: -1.5rem !important;
  }
  .mt-lg-n4,
  .my-lg-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-lg-n4,
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-lg-n4,
  .my-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-lg-n4,
  .mx-lg-n4 {
    margin-left: -1.5rem !important;
  }
  .m-lg-n5 {
    margin: -3rem !important;
  }
  .mt-lg-n5,
  .my-lg-n5 {
    margin-top: -3rem !important;
  }
  .mr-lg-n5,
  .mx-lg-n5 {
    margin-right: -3rem !important;
  }
  .mb-lg-n5,
  .my-lg-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-lg-n5,
  .mx-lg-n5 {
    margin-left: -3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important;
  }
  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important;
  }
  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }
  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important;
  }
  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important;
  }
  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important;
  }
  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .mt-xl-1,
  .my-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 0.25rem !important;
  }
  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .mt-xl-2,
  .my-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 0.5rem !important;
  }
  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .mt-xl-3,
  .my-xl-3 {
    margin-top: 1rem !important;
  }
  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 1rem !important;
  }
  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 1rem !important;
  }
  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .mt-xl-4,
  .my-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 1.5rem !important;
  }
  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .mt-xl-5,
  .my-xl-5 {
    margin-top: 3rem !important;
  }
  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 3rem !important;
  }
  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 3rem !important;
  }
  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 3rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important;
  }
  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important;
  }
  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important;
  }
  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .pt-xl-1,
  .py-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pr-xl-1,
  .px-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-xl-1,
  .px-xl-1 {
    padding-left: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .pt-xl-2,
  .py-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pr-xl-2,
  .px-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-xl-2,
  .px-xl-2 {
    padding-left: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .pt-xl-3,
  .py-xl-3 {
    padding-top: 1rem !important;
  }
  .pr-xl-3,
  .px-xl-3 {
    padding-right: 1rem !important;
  }
  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pl-xl-3,
  .px-xl-3 {
    padding-left: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .pt-xl-4,
  .py-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pr-xl-4,
  .px-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-xl-4,
  .px-xl-4 {
    padding-left: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .pt-xl-5,
  .py-xl-5 {
    padding-top: 3rem !important;
  }
  .pr-xl-5,
  .px-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 3rem !important;
  }
  .pl-xl-5,
  .px-xl-5 {
    padding-left: 3rem !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .mt-xl-n1,
  .my-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-xl-n1,
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-xl-n1,
  .my-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-xl-n1,
  .mx-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .mt-xl-n2,
  .my-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-xl-n2,
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-xl-n2,
  .my-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-xl-n2,
  .mx-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -1rem !important;
  }
  .mt-xl-n3,
  .my-xl-n3 {
    margin-top: -1rem !important;
  }
  .mr-xl-n3,
  .mx-xl-n3 {
    margin-right: -1rem !important;
  }
  .mb-xl-n3,
  .my-xl-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-xl-n3,
  .mx-xl-n3 {
    margin-left: -1rem !important;
  }
  .m-xl-n4 {
    margin: -1.5rem !important;
  }
  .mt-xl-n4,
  .my-xl-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-xl-n4,
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-xl-n4,
  .my-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-xl-n4,
  .mx-xl-n4 {
    margin-left: -1.5rem !important;
  }
  .m-xl-n5 {
    margin: -3rem !important;
  }
  .mt-xl-n5,
  .my-xl-n5 {
    margin-top: -3rem !important;
  }
  .mr-xl-n5,
  .mx-xl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xl-n5,
  .my-xl-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-xl-n5,
  .mx-xl-n5 {
    margin-left: -3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important;
  }
  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important;
  }
  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important;
  }
}
`;

/**
 * CSS for overrides for grid within a wgContainerQuery directive
 * These are loaded after the grid css
 */
const WgContainerQueryGridOverridesPostCss = `
.container {
  margin-left: 0;
  margin-right: 0;

  padding: 0;
}

/**
 * Table
 */
.table-header-row:first-child {
  margin-bottom: 0;
  margin-left: -30px;
  margin-top: -30px;
  margin-right: -30px;
  padding: 20px 30px 20px 30px;
}

.table-header-row>:last-child:not(:first-child) wg-refresh.mr-3 {
  margin-right: 0 !important;
}

/**
 * Dashboard
 */
.wg-dashboard.v2 [class^=col-], .wg-dashboard.v2 [class*=" col-"] {
  flex-grow: 1;
  max-width: 999999px;
}

/**
 * Form
 */
.wg-form-container {
  margin-left: auto;
  margin-right: auto;
  padding: 0;
  width: 100%;
}

.wg-form-container .wg-form-row {
  display: flex;
  flex-wrap: wrap;
  margin-left: -15px;
  margin-right: -15px;
}

.wg-form-container .wg-form-row .wg-form-col {
  flex: 0 0 100%;
  max-width: 100%;
  padding-left: 15px;
  padding-right: 15px;
  position: relative;
  width: 100%;
}

@media (min-width: 768px) {
  .wg-form-container .wg-form-row .wg-form-col {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
}

@media (min-width: 992px) {
  .wg-form-container .wg-form-row .wg-form-col {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

@media (min-width: 1200px) {
  .wg-form-container .wg-form-row .wg-form-col {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
}

.ui-dialog .wg-form-container .wg-form-row .wg-form-col {
  flex: 0 0 100%;
  max-width: 100%;
}

/**
 * Widget
 */
.widget-sm,
.widget-md,
.widget-lg,
.widget-sized {
  background: #fff;
  border-bottom: 1px solid #b5b5b5;
  border-right: 1px solid #b5b5b5;
  min-height: 264px;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 30px 30px 30px 30px;
  position: relative;
  width: 100%;
}

.widget-sm.auto-height,
.widget-md.auto-height,
.widget-lg.auto-height,
.widget-sized.auto-height {
  height: auto;
  min-height: 70px;
  padding: 30px 30px 30px 30px;
}

.no-gutters > .col.widget-sm.auto-height,
.no-gutters > .col.widget-md.auto-height,
.no-gutters > .col.widget-lg.auto-height,
.no-gutters > .col.widget-sized.auto-height,
.no-gutters > [class*="col-"].widget-sm.auto-height,
.no-gutters > [class*="col-"].widget-md.auto-height,
.no-gutters > [class*="col-"].widget-lg.auto-height,
.no-gutters > [class*="col-"].widget-sized.auto-height {
  padding-left: 0;
  padding-right: 0;
}

.widget-sm {
  flex: 0 0 100%;
  max-width: 100%;
}

.widget-md {
  flex: 0 0 100%;
  max-width: 100%;
}

.widget-lg {
  flex: 0 0 100%;
  max-width: 100%
}

categories-dashboard > .container-fluid > .row wg-expander > section > div.content > .widget-container > .row > .widget-sized {
  padding: 30px;
}

@media (min-width: 576px) {
  .widget-sm {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .widget-md {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

@media (min-width: 768px) {
  .widget-sm {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .widget-md {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

@media (min-width: 992px) {
  .widget-sm {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .widget-md {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

@media (min-width: 1200px) {
  .widget-sm {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .widget-md {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

/**
 * Product Dialog Page
 */
.product-dialog-page-container .wg-dialog-inline .p-dialog .p-dialog-content .row > div,
.product-dialog-page-container-sm .wg-dialog-inline .p-dialog .p-dialog-content .row > div {
  align-items: center;
  display: flex;
  height: 285px;
  justify-content: center;
  padding: 50px 40px 50px 40px;
}
`;

/**
 * CSS for overrides for grid within a wgContainerQuery directive
 * These are loaded before the grid css
 */
const WgContainerQueryGridOverridesPreCss = `
.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col,
.col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm,
.col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md,
.col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg,
.col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl,
.col-xl-auto {
  flex: initial;
  max-width: none;
}
`;

/**
 * these values are also in Static/scss/wgc/common/_content-breakpoints.scss
 * and will also need to be updated there when these change (though content-breakpoints
 * are being deprecated in favor of wgContainerQuery)
 */
const breakpoints = [{
  size: 'XS',
  min: 0,
  max: 563.99
}, {
  size: 'SM',
  min: 564,
  max: 744.99
}, {
  size: 'MD',
  min: 745,
  max: 990.99
}, {
  size: 'LG',
  min: 991,
  max: 1170.99
}, {
  size: 'XL',
  min: 1171,
  max: Number.MAX_VALUE
}];
class WgContainerQueryService {
  constructor(rendererFactory) {
    this.rendererFactory = rendererFactory;
    this.elements = [];
    this.renderer = rendererFactory.createRenderer(null, null);
    this.resizeObserverInitialize();
  }
  ngOnDestroy() {
    this.resizeObserver.disconnect();
  }
  resizeObserverAddElement(htmlElement, eventEmitter) {
    this.elements.push({
      breakpoint: null,
      eventEmitter,
      htmlElement,
      width: -1
    });
    this.resizeObserver.observe(htmlElement);
  }
  resizeObserverRemoveElement(htmlElement) {
    this.elements = this.elements.filter(filterElement => filterElement.htmlElement.id !== htmlElement.id);
    this.resizeObserver.unobserve(htmlElement);
  }
  resizeObserverInitialize() {
    this.resizeObserver = new window.ResizeObserver(entries => {
      entries.forEach(entry => {
        this.updateSize(entry.target);
      });
    });
  }
  /**
   * updates the size of the wgContainerQuery based on the current width
   */
  updateSize(htmlElement) {
    const element = this.elements.find(findElement => findElement.htmlElement.id === htmlElement.id);
    const newWidth = htmlElement.offsetWidth;
    if (newWidth !== element.width) {
      element.width = newWidth;
      let breakpoint = breakpoints[breakpoints.length - 1];
      for (let index = 0; index < breakpoints.length; index++) {
        if (newWidth <= breakpoints[index].max) {
          breakpoint = breakpoints[index];
          break;
        }
      }
      if (element.breakpoint !== breakpoint) {
        element.breakpoint = breakpoint;
        element.eventEmitter.emit(breakpoint);
        this.renderer.setAttribute(element.htmlElement, 'data-size', breakpoint.size.toLowerCase());
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
        });
      }
    }
  }
  static {
    this.ɵfac = function WgContainerQueryService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgContainerQueryService)(i0.ɵɵinject(i0.RendererFactory2));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: WgContainerQueryService,
      factory: WgContainerQueryService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgContainerQueryService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i0.RendererFactory2
  }], null);
})();
const regexMediaLine = new RegExp('^@media \\(min\\-width\\: ([0-9]*)px\\) \\{$');
/**
 * Bootstrap already has classes that handle the following css properties, so we don't need to include them in our instance specific css
 */
const cssBaseClassPrefixesToExclude = ['.align-content-', '.align-items-', '.align-self-', '.d-', '.flex-', '.justify-', '.m-', '.mb-', '.ml-', '.mr-', '.mt-', '.mx-', '.my-', '.p-', '.pb-', '.pl-', '.pr-', '.pt-', '.px-', '.py-'];
class WgContainerQueryDirective {
  constructor(containerQueryService, elementRef, renderer) {
    this.containerQueryService = containerQueryService;
    this.elementRef = elementRef;
    this.renderer = renderer;
    this.wgCqBreakpointChange = new EventEmitter();
    this.id = `wg-cq-${nanoid(7).toLowerCase()}`;
  }
  ngOnDestroy() {
    if (this.mutationObserver != null) {
      this.mutationObserver.disconnect();
    }
    this.containerQueryService.resizeObserverRemoveElement(this.htmlElement);
    this.removeCss();
  }
  ngOnInit() {
    this.htmlElement = this.elementRef.nativeElement;
    this.htmlElement.id = this.id;
    this.generateCss();
    this.addWgCqAttributeToChildren(this.htmlElement);
    this.initializeMutationObserver();
    this.containerQueryService.resizeObserverAddElement(this.htmlElement, this.wgCqBreakpointChange);
  }
  /**
   * Loops through all the children of this wgContainerQuery (excluding nested wgContainerQuery components)
   * and sets an attribute equal to the id for the wgContainerQuery instance. This will be used to target using
   * the instance specific css rules.
   *
   * @param htmlElement
   * @returns void
   */
  addWgCqAttributeToChildren(htmlElement) {
    const children = htmlElement.children;
    if (children == null || children.length == 0) {
      return;
    }
    for (let index = 0; index < children.length; index++) {
      const child = children.item(index);
      if (child.hasAttribute('wgContainerQuery')) {
        break;
      }
      child.setAttribute(this.id, '');
      this.addWgCqAttributeToChildren(child);
    }
  }
  /**
   * Takes a css selector string and prepends a wgContainerQuery instance specific selector
   *
   * @param line
   * @param cssPrefixes
   * @returns Css selector line that includes the wgContainerQuery instance specific selectors
   */
  addSelectorsToCssClass(line, cssPrefixes) {
    const cssClass = line.trim().substring(0, line.trim().length - 1).trim();
    let css = '';
    cssPrefixes.forEach(cssPrefix => {
      css += (css === '' ? '' : ',') + `${cssPrefix} ${cssClass}[${this.id}]`;
    });
    css += line.trim().substring(line.trim().length - 1);
    return css;
  }
  /**
   * This builds and returns the instance specific css, which is needed to make sure nested wgContainerQuery's work as expected
   *
   * @returns The instance specific css string
   */
  buildCss() {
    let cssSource = `
      ${WgContainerQueryGridOverridesPreCss}
      ${WgContainerQueryGridCss}
      ${WgContainerQueryGridOverridesPostCss}
    `;
    let cssLines = cssSource.valueOf().replace(/\, \./g, ',\n.').split('\n');
    let inMediaQuery = false;
    let cssPrefixes = [`#${this.id}[data-size]`];
    let inExcludedClass = false;
    let openBracketCount = 0;
    let css = '';
    cssLines.forEach(line => {
      const regexMediaLineResults = regexMediaLine.exec(line);
      if (regexMediaLineResults != null) {
        // if we match a media query line in the css - @media (min-width...) {
        inMediaQuery = true;
        // builds list of sizes for given media query px size
        cssPrefixes.length = 0;
        switch (parseInt(regexMediaLineResults[1], 10)) {
          case 576:
            cssPrefixes.push(`#${this.id}[data-size="sm"]`);
          case 768:
            cssPrefixes.push(`#${this.id}[data-size="md"]`);
          case 992:
            cssPrefixes.push(`#${this.id}[data-size="lg"]`);
          case 1200:
            cssPrefixes.push(`#${this.id}[data-size="xl"]`);
            break;
        }
        openBracketCount++;
      } else if (line.trim() !== '') {
        // only process non-blank lines
        if (line.indexOf('{') !== -1) {
          // open bracket
          openBracketCount++;
        }
        if (line.indexOf('}') !== -1) {
          // closed bracket
          openBracketCount--;
          if (openBracketCount === 0) {
            // final closing bracket
            if (!inMediaQuery) {
              // only include final closing bracket if not closing @media (min-width...) {
              css += `${line.trim()}`;
            }
            // reset media query/sizing variables
            inMediaQuery = false;
            cssPrefixes.length = 0;
            cssPrefixes.push(`#${this.id}[data-size]`);
          } else {
            // non-final closing brackets
            css += `${line.trim()}`;
          }
        }
        if (line.trim().startsWith('.')) {
          // css selectors line. we need to add our specific wgContainerQuery selector prefixes to their selectors
          inExcludedClass = !inMediaQuery && cssBaseClassPrefixesToExclude.some(prefix => line.trim().startsWith(prefix));
          css += this.addSelectorsToCssClass(line, cssPrefixes) + '\n';
        } else if (line.indexOf('}') === -1 && !inExcludedClass) {
          // css styles
          css += `${line.trim()}\n`;
        }
      }
    });
    // remove empty rules
    css = css.replace(/[^{}]*\{\s*\}/g, '');
    return css;
  }
  /**
   * adds the wgContainerQuery instance specific css to <head>
   */
  generateCss() {
    this.styleElement = this.renderer.createElement('style');
    this.styleElement.id = `${this.id}-css`;
    this.styleElement.textContent = this.buildCss();
    this.renderer.appendChild(document.head, this.styleElement);
  }
  initializeMutationObserver() {
    this.mutationObserver = new window.MutationObserver(() => {
      this.mutationObserver.disconnect();
      this.addWgCqAttributeToChildren(this.htmlElement);
      setTimeout(() => {
        this.mutationObserver.observe(this.htmlElement, {
          subtree: true,
          childList: true,
          attributes: false
        });
      });
    });
    this.mutationObserver.observe(this.htmlElement, {
      subtree: true,
      childList: true,
      attributes: false
    });
  }
  /**
   * removes the wgContainerQuery instance specific css from <head>
   */
  removeCss() {
    this.renderer.removeChild(document.head, this.styleElement);
  }
  static {
    this.ɵfac = function WgContainerQueryDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgContainerQueryDirective)(i0.ɵɵdirectiveInject(WgContainerQueryService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: WgContainerQueryDirective,
      selectors: [["", "wgContainerQuery", ""]],
      outputs: {
        wgCqBreakpointChange: "wgCqBreakpointChange"
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgContainerQueryDirective, [{
    type: Directive,
    args: [{
      selector: '[wgContainerQuery]',
      standalone: false
    }]
  }], () => [{
    type: WgContainerQueryService
  }, {
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }], {
    wgCqBreakpointChange: [{
      type: Output
    }]
  });
})();
class WgContainerQueryModule {
  static {
    this.ɵfac = function WgContainerQueryModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgContainerQueryModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgContainerQueryModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgContainerQueryModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [WgContainerQueryDirective],
      exports: [WgContainerQueryDirective]
    }]
  }], null, null);
})();
class CssVersionDirective {
  constructor() {
    this.cssVersionService = inject(CssVersionService);
    this.cssVersionService.cssVersion.subscribe(cssVersion => {
      this.cssVersion = cssVersion;
    });
  }
  static {
    this.ɵfac = function CssVersionDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CssVersionDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: CssVersionDirective,
      selectors: [["", "wgCssVersion", ""]],
      hostVars: 1,
      hostBindings: function CssVersionDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("data-css-version", ctx.cssVersion);
        }
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CssVersionDirective, [{
    type: Directive,
    args: [{
      selector: '[wgCssVersion]',
      standalone: true
    }]
  }], () => [], {
    cssVersion: [{
      type: HostBinding,
      args: ['attr.data-css-version']
    }]
  });
})();

/**
 * @license
 * Copyright WatchGuard Technologies Inc. All Rights Reserved.
 *
 * This directive exports the WgFlexibleGridDirective. This directive should
 * be used when you need a grid of similar items layed out nicely.
 *
 */
class WgFlexibleGridDirective {
  constructor(elementRef) {
    this.elementRef = elementRef;
  }
  ngOnInit() {
    this.htmlElement = this.elementRef.nativeElement;
    this.setChildrenDimensions();
  }
  windowResize() {
    this.setChildrenDimensions();
  }
  getChildrenWidth(childrenCount) {
    const width = this.getElementWidth();
    const maxChildrenPerRow = Math.floor(width / this.minWidth);
    if (childrenCount <= maxChildrenPerRow) {
      return Math.min(this.maxWidth, width / childrenCount);
    } else {
      return width / maxChildrenPerRow;
    }
  }
  getElementWidth() {
    const computedStyles = window.getComputedStyle(this.htmlElement);
    return this.htmlElement.offsetWidth - parseInt(computedStyles.paddingLeft, 10) - parseInt(computedStyles.paddingRight, 10);
  }
  setChildrenDimensions() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      this.timeout = undefined;
      const children = this.htmlElement.children;
      const parentWidth = this.getElementWidth();
      const columnWidth = this.getChildrenWidth(children.length);
      const numberOfColumnsPerRow = Math.floor(parentWidth / columnWidth);
      this.htmlElement.style.gridAutoRows = 'auto';
      this.htmlElement.setAttribute('data-columns', numberOfColumnsPerRow.toString());
      this.htmlElement.style.gridAutoFlow = 'dense';
      // tslint:disable-next-line: max-line-length
      this.htmlElement.style.gridTemplateColumns = 'repeat(' + numberOfColumnsPerRow + ', minmax(' + this.minWidth + 'px, ' + this.maxWidth + 'px)';
    }, 500);
  }
  static {
    this.ɵfac = function WgFlexibleGridDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgFlexibleGridDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: WgFlexibleGridDirective,
      selectors: [["", "wgFlexibleGrid", ""]],
      hostBindings: function WgFlexibleGridDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("resize", function WgFlexibleGridDirective_resize_HostBindingHandler() {
            return ctx.windowResize();
          }, false, i0.ɵɵresolveWindow);
        }
      },
      inputs: {
        maxWidth: "maxWidth",
        minWidth: "minWidth"
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgFlexibleGridDirective, [{
    type: Directive,
    args: [{
      selector: '[wgFlexibleGrid]',
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    maxWidth: [{
      type: Input
    }],
    minWidth: [{
      type: Input
    }],
    windowResize: [{
      type: HostListener,
      args: ['window:resize']
    }]
  });
})();
class WgFlexibleGridModule {
  static {
    this.ɵfac = function WgFlexibleGridModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgFlexibleGridModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgFlexibleGridModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgFlexibleGridModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [WgFlexibleGridDirective],
      exports: [WgFlexibleGridDirective]
    }]
  }], null, null);
})();

/**
 * @license
 * Copyright WatchGuard Technologies Inc. All Rights Reserved.
 *
 * This directive exports the OnlyNumber.
 */
const SYSTEM_KEYS = ['ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'Backspace', 'Clear', 'Copy', 'Cut', 'Del', 'Delete', 'Down', 'End', 'Enter', 'Escape', 'Home', 'Insert', 'Left', 'PageDown', 'PageUp', 'Paste', 'Redo', 'Right', 'Tab', 'Undo', 'Up', 'Shift'];
// eslint-disable-next-line @angular-eslint/directive-class-suffix
class OnlyNumber {
  constructor(element) {
    this.element = element;
    this.typeValidation = {
      decimal: {
        pattern: /^-?[0-9]+([.,][0-9]+){0,1}$/,
        keyPattern: /[0-9]|-|,|\./,
        allowedOnce: ['.', ',', '-'],
        interchangeable: ['.', ','],
        forbidden: ['e']
      },
      integer: {
        pattern: /^-?[0-9]+$/,
        keyPattern: /[0-9]|-/,
        allowedOnce: ['-'],
        forbidden: ['e', '.', ',']
      },
      positive: {
        pattern: /^[0-9]+$/,
        keyPattern: /[0-9]/,
        allowedOnce: [],
        forbidden: ['e', '.', ',', '-']
      }
    };
  }
  ngOnInit() {
    if (this.isNumber) {
      this.element.nativeElement.addEventListener('keydown', this.onKeyDown.bind(this));
      this.element.nativeElement.addEventListener('input', this.onNumberInput.bind(this));
    } else {
      // TODO: Fix OnlyNumber directive for integer and decimal numbers on input type text (AAAS-14512)
      this.element.nativeElement.addEventListener('input', this.onInput.bind(this));
    }
  }
  ngOnChanges(changes) {
    if (changes.numberType && changes.numberType.isFirstChange()) {
      if (!changes.numberType.currentValue) {
        this.numberType = 'positive';
      }
    }
  }
  get isNumber() {
    return this.element.nativeElement.type === 'number';
  }
  get inputValue() {
    return this.element.nativeElement.value;
  }
  set inputValue(value) {
    this.element.nativeElement.value = value;
  }
  get pattern() {
    return this.typeValidation[this.numberType].pattern;
  }
  get interchangeable() {
    return this.typeValidation[this.numberType].interchangeable || [];
  }
  isAllowedOnce(key) {
    return this.typeValidation[this.numberType].allowedOnce.some(char => char === key);
  }
  isInterchangeable(key) {
    return this.interchangeable.some(char => char === key);
  }
  isNotAllowed(key) {
    return this.typeValidation[this.numberType].forbidden.some(char => char === key);
  }
  isInvalid(key) {
    return !this.typeValidation[this.numberType].keyPattern.test(key);
  }
  isSystemKey(key) {
    return SYSTEM_KEYS.indexOf(key) >= 0;
  }
  // Block keys for input type number
  onKeyDown(event) {
    const value = this.inputValue || this.value || '';
    this.lastKey = event.key;
    if (this.isSystemKey(event.key)) {
      return;
    }
    if (this.isInvalid(event.key) || this.isNotAllowed(event.key) || this.isAllowedOnce(event.key) && value.includes(event.key) || this.isInterchangeable(event.key) && this.interchangeable.some(char => value.includes(char))) {
      event.preventDefault();
    }
  }
  onNumberInput(value) {
    value = this.inputValue;
    if (!value && this.value) {
      if (this.lastKey === '.' || this.lastKey === ',') {
        if (this.value.toString().includes('.') || this.value.toString().includes(',')) {
          this.inputValue = this.value;
        }
        return;
      }
      if (this.lastKey === '-') {
        this.inputValue = this.value;
        return;
      }
    }
    this.onInput(value);
  }
  onInput(value) {
    value = this.inputValue;
    if (value && value !== this.value) {
      if (!value.toString().match(this.pattern)) {
        this.inputValue = this.value || '';
      } else {
        this.value = value.toString();
      }
    } else {
      this.value = (value || '').toString();
    }
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  static {
    this.ɵfac = function OnlyNumber_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OnlyNumber)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: OnlyNumber,
      selectors: [["", "OnlyNumber", ""]],
      inputs: {
        numberType: [0, "OnlyNumber", "numberType"]
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OnlyNumber, [{
    type: Directive,
    args: [{
      // eslint-disable-next-line @angular-eslint/directive-selector
      selector: '[OnlyNumber]',
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    numberType: [{
      type: Input,
      args: ['OnlyNumber']
    }]
  });
})();
class WgOnlyNumberModule {
  static {
    this.ɵfac = function WgOnlyNumberModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgOnlyNumberModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgOnlyNumberModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgOnlyNumberModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [OnlyNumber],
      exports: [OnlyNumber]
    }]
  }], null, null);
})();

/**
 * @license
 * Copyright WatchGuard Technologies Inc. All Rights Reserved.
 *
 * This directive exports the WgTooltip.
 *
 * This is based on pTooltip from PrimeNG. Since they do not support HTML
 * within the tooltip, we must create a custom one.
 */
class WgTooltipDirective {
  constructor(elementRef, sanitizer) {
    this.elementRef = elementRef;
    this.sanitizer = sanitizer;
    this.wgTooltipPos = 'right';
    this.body = document.body;
    this.bodyStyles = getComputedStyle(this.body);
  }
  mouseEnter(event) {
    const htmlElement = this.elementRef.nativeElement;
    const offset = this.offset(htmlElement);
    const rect = htmlElement.getBoundingClientRect();
    this.positionX = offset.left + rect.width / 2 - parseInt(this.bodyStyles.marginLeft, 10);
    this.positionY = offset.top + rect.height / 2 - parseInt(this.bodyStyles.marginTop, 10);
    this.showTooltip();
  }
  mouseLeave(event) {
    this.hideTooltip();
  }
  ngOnDestroy() {
    if (this.divContainer && this.divContainer.parentElement) {
      this.body.removeChild(this.divContainer);
    }
    this.divContainer = null;
  }
  offset(element) {
    const rect = element.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return {
      top: rect.top + scrollTop,
      left: rect.left + scrollLeft
    };
  }
  initTooltip() {
    this.divContainer = document.createElement('div');
    this.divContainer.classList.add('wg-tooltip-container');
    this.divContainer.style.left = -999 + 'px';
    this.divContainer.style.top = -999 + 'px';
    this.tooltipDiv = document.createElement('div');
    if (this.text instanceof TemplateRef) {
      const templateRef = this.text;
      const embeddedViewRef = templateRef.createEmbeddedView({});
      embeddedViewRef.detectChanges();
      // setTimeout is needed to wait for detectChanges to update the DOM
      setTimeout(() => {
        this.tooltipDiv.innerHTML = embeddedViewRef.rootNodes[0].innerHTML;
        this.divContainer.appendChild(this.tooltipDiv);
        document.body.appendChild(this.divContainer);
        this.updateTooltipMaxWidth();
        this.positionTooltip();
      });
    } else {
      if (this.wgTooltipBypassSecurity) {
        this.tooltipDiv.innerHTML = this.text;
      } else {
        this.tooltipDiv.innerHTML = this.sanitizer.sanitize(SecurityContext.HTML, this.text);
      }
      this.divContainer.appendChild(this.tooltipDiv);
      document.body.appendChild(this.divContainer);
      this.updateTooltipMaxWidth();
      this.positionTooltip();
    }
  }
  showTooltip() {
    if (this.text && !this.wgTooltipDisabled) {
      this.initTooltip();
    }
  }
  positionTooltip() {
    this.tooltipDiv.classList.add('wg-tooltip');
    const tooltipContainerRect = this.divContainer.getBoundingClientRect();
    const targetRect = this.elementRef.nativeElement.getBoundingClientRect();
    let tooltipRect;
    switch (this.wgTooltipPos) {
      case 'left':
        tooltipRect = this.calculateTooltipPosition(tooltipContainerRect, targetRect, ['left', 'right', 'top', 'bottom']);
        break;
      case 'top':
        tooltipRect = this.calculateTooltipPosition(tooltipContainerRect, targetRect, ['top', 'bottom', 'right', 'left']);
        break;
      case 'bottom':
        tooltipRect = this.calculateTooltipPosition(tooltipContainerRect, targetRect, ['bottom', 'top', 'right', 'left']);
        break;
      case 'right':
      default:
        tooltipRect = this.calculateTooltipPosition(tooltipContainerRect, targetRect, ['right', 'left', 'top', 'bottom']);
        break;
    }
    this.divContainer.style.left = tooltipRect.left + 'px';
    this.divContainer.style.top = tooltipRect.top + 'px';
  }
  // tslint:disable-next-line: max-line-length
  calculateTooltipPosition(tooltipContainerRect, targetRect, attemptToFitDirectionOrder) {
    if (!attemptToFitDirectionOrder || attemptToFitDirectionOrder.length === 0) {
      console.error('You must have at least one direction to attempt to fit on screen.');
      return {
        left: 0,
        top: 0
      };
    }
    let arrow;
    let bestArrow;
    let bestPosition;
    let bestVisibleArea = 0;
    let left;
    let top;
    // tslint:disable-next-line: prefer-for-of
    for (let index = 0; index < attemptToFitDirectionOrder.length; index++) {
      const attemptToFitDirection = attemptToFitDirectionOrder[index];
      switch (attemptToFitDirection) {
        case 'left':
          arrow = 'right';
          left = this.positionX - tooltipContainerRect.width - targetRect.width - 5;
          top = this.positionY - tooltipContainerRect.height / 2;
          break;
        case 'top':
          arrow = 'bottom';
          left = this.positionX - tooltipContainerRect.width / 2;
          top = this.positionY - tooltipContainerRect.height - targetRect.height - 4;
          break;
        case 'bottom':
          arrow = 'top';
          left = this.positionX - tooltipContainerRect.width / 2;
          top = this.positionY + targetRect.height + 4;
          break;
        case 'right':
          arrow = 'left';
          left = this.positionX + targetRect.width;
          top = this.positionY - tooltipContainerRect.height / 2;
          break;
      }
      /**
       * I know this is a lot, but I can't think of a better/cleaner way at the moment.
       *
       * visibleArea = visible tooltip width * visible tooltip height
       * visible tooltip width = tooltip width + (amount tooltip off page to left) - (amount tooltip off page to right)
       * visible tooltip height = tooltip height + (amount tooltip off top of page) - (amount tooltip off bottom of page)
       *
       * also the reason for the Math.max(this.body.clientWidth, window.innerWidth) is to handle times when
       * element with wgTooltip has a parent with position: fixed. In that case we can use the window width/height.
       */
      const visibleArea =
      // tslint:disable-next-line: max-line-length
      (tooltipContainerRect.width + Math.min(left, 0) - Math.max(left + tooltipContainerRect.width - Math.max(this.body.scrollWidth, this.body.clientWidth, window.innerWidth), 0)
      // tslint:disable-next-line: max-line-length
      ) * (tooltipContainerRect.height + Math.min(top, 0) - Math.max(top + tooltipContainerRect.height - Math.max(this.body.scrollHeight, this.body.clientHeight, window.innerHeight), 0));
      if (visibleArea > bestVisibleArea) {
        bestArrow = arrow + '';
        bestPosition = {
          left,
          top
        };
        bestVisibleArea = visibleArea;
      }
    }
    this.tooltipDiv.classList.add(`wg-tooltip-arrow-${bestArrow}`);
    return bestPosition;
  }
  hideTooltip() {
    this.ngOnDestroy();
  }
  updateTooltipMaxWidth() {
    /**
     * There is also CSS style to set max width of a tooltip.
     * At the time of this comment they are in:
     * DaaS-Common/Static/scss/wgc/common/_bootstrap-variables.scss
     *
     * If [wgTooltipMaxWidth] is not set, the max width will default to the style as defined in file above.
     */
    if (this.wgTooltipMaxWidth) {
      this.tooltipDiv.style.maxWidth = this.wgTooltipMaxWidth + 'px';
    }
  }
  static {
    this.ɵfac = function WgTooltipDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgTooltipDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1$3.DomSanitizer));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: WgTooltipDirective,
      selectors: [["", "wgTooltip", ""]],
      hostBindings: function WgTooltipDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("mouseenter", function WgTooltipDirective_mouseenter_HostBindingHandler($event) {
            return ctx.mouseEnter($event);
          })("mouseleave", function WgTooltipDirective_mouseleave_HostBindingHandler($event) {
            return ctx.mouseLeave($event);
          });
        }
      },
      inputs: {
        text: [0, "wgTooltip", "text"],
        wgTooltipBypassSecurity: "wgTooltipBypassSecurity",
        wgTooltipPos: "wgTooltipPos",
        wgTooltipMaxWidth: "wgTooltipMaxWidth",
        wgTooltipDisabled: "wgTooltipDisabled"
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgTooltipDirective, [{
    type: Directive,
    args: [{
      // eslint-disable-next-line @angular-eslint/directive-selector
      selector: '[wgTooltip]',
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i1$3.DomSanitizer
  }], {
    text: [{
      type: Input,
      args: ['wgTooltip']
    }],
    wgTooltipBypassSecurity: [{
      type: Input,
      args: ['wgTooltipBypassSecurity']
    }],
    wgTooltipPos: [{
      type: Input
    }],
    wgTooltipMaxWidth: [{
      type: Input
    }],
    wgTooltipDisabled: [{
      type: Input,
      args: ['wgTooltipDisabled']
    }],
    mouseEnter: [{
      type: HostListener,
      args: ['mouseenter', ['$event']]
    }],
    mouseLeave: [{
      type: HostListener,
      args: ['mouseleave', ['$event']]
    }]
  });
})();
class WgTooltipModule {
  static {
    this.ɵfac = function WgTooltipModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgTooltipModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgTooltipModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgTooltipModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [WgTooltipDirective],
      exports: [WgTooltipDirective]
    }]
  }], null, null);
})();

/**
 * Regex that matches 4 bytes characters
 * to avoid breaking mySQL databases with charset utf8mb3
 * (default utf8 encoding in versions lower than 8.0.28)
 * and emojis, to keep consistency on the input fields
 *
 * Regex patterns:
 * [\u{10000}-\u{10FFFF}] - Matches any 4 bytes character
 *
 * \uFE0F - Variation Selector-16 (VS16), used to force a character into the emoji form
 * eg: ❤︎ (U+2764) combined with VS16 (U+FE0F) becomes ❤️ (U+2764 U+FE0F)
 *
 * \u200D - Zero Width Joiner (ZWJ), used to combine different characters
 * eg: 😮 (U+1F62E) followed by ZWJ (U+200D) and 💨 (U+1F4A8) becomes 😮‍💨 (U+1F62E U+200D U+1F4A8)
 *
 * [\u2000-\u2FFF] - Symbols that can be combined to modify emojis
 * eg: 🐈 (U+1F408) followed by ZWJ (U+200D) and ⬛️ (U+2B1B) becomes 🐈‍⬛ (U+1F408 U+200D U+2B1B)
 * eg: ☝ (U+261D) followed by light skin marker (U+1F3FB) becomes ☝🏻
 *
 * \u20e3 - Combining Enclosing Keycap, used to put emojis in a rounded square box
 * eg: # (U+0023) followed by VS16 (U+FE0F) and U+20E3 becomes #️⃣ (U+0023 U+FE0F U+20E3)
 */
const blockedCharacters = new RegExp('(' + '(' + '.\uFE0F|' +
// Any char followed by VS16, OR
'([\u2000-\u2FFF]?[\u{10000}-\u{10FFFF}]+)' +
// Any symbol followed by at least one 4 bytes char, as ☝🏻 (U+261D U+1F3FB), or just the 4 bytes chars, as 🐈 (U+1F408)
')' + '(' + '\u20E3|' +
// Combining Enclosing Keycap, OR
'\u200D' +
// Zero Width Joiner, followed by
'(' + '[\u2000-\u2FFF]|' +
// Any symbol that can be used to modify emojis, as ♀ (U+2640), OR
'([\u2000-\u2FFF]?[\u{10000}-\u{10FFFF}]+)' +
// Any symbol followed by at least one 4 bytes char, as ☝🏻 (U+261D + U+1F3FB), or just the 4 bytes chars, as 🐈 (U+1F408)
')' + '\uFE0F?' +
// VS16 (optional)
')*' +
// The second part might not occur (as in ☝🏻 (U+261D U+1F3FB)) or occur once (as in 🐈‍⬛ (U+1F408 U+200D U+2B1B)) or more (as in 👩🏼‍❤️‍👩🏽 (U+1F469, U+1F3FC, U+200D, U+2764, U+FE0F, U+200D, U+1F469, U+1F3FC))
')|' + '[\u{10000}-\u{10FFFF}]' // Matches any 4 bytes chars that are still left to avoid breaking MySQL's utf8mb3 encoding
, 'gu');

/**
 * @license
 * Copyright WatchGuard Technologies Inc. All Rights Reserved.
 *
 * This directive exports the WgBlockEmoji.
 */
class WgBlockEmojiDirective {
  constructor(element) {
    this.element = element;
  }
  onValueChange() {
    const startIndex = this.element.nativeElement.selectionStart;
    const endIndex = this.element.nativeElement.selectionEnd;
    const match = this.inputValue.match(blockedCharacters);
    if (match) {
      const replacedLength = match.reduce((length, {
        length: matchLength
      }) => length + matchLength, 0);
      this.inputValue = this.inputValue.replace(blockedCharacters, '');
      // Set the cursor to the proper position after removing the forbidden chars
      this.element.nativeElement.selectionStart = startIndex - replacedLength;
      this.element.nativeElement.selectionEnd = endIndex - replacedLength;
      // Dispatch input again to trigger any validations and events with the new value
      this.element.nativeElement.dispatchEvent(new Event('input'));
    }
  }
  get inputValue() {
    return this.element.nativeElement.value.toString();
  }
  set inputValue(value) {
    this.element.nativeElement.value = value;
  }
  static {
    this.ɵfac = function WgBlockEmojiDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgBlockEmojiDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: WgBlockEmojiDirective,
      selectors: [["", "wgBlockEmoji", ""]],
      hostBindings: function WgBlockEmojiDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("input", function WgBlockEmojiDirective_input_HostBindingHandler() {
            return ctx.onValueChange();
          });
        }
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgBlockEmojiDirective, [{
    type: Directive,
    args: [{
      selector: '[wgBlockEmoji]',
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    onValueChange: [{
      type: HostListener,
      args: ['input']
    }]
  });
})();
class WgBlockEmojiModule {
  static {
    this.ɵfac = function WgBlockEmojiModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgBlockEmojiModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgBlockEmojiModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgBlockEmojiModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [WgBlockEmojiDirective],
      exports: [WgBlockEmojiDirective]
    }]
  }], null, null);
})();

/**
 * @license
 * Copyright WatchGuard Technologies Inc. All Rights Reserved.
 *
 * This directive exports the WgTimeInputDirective.
 */
const SECTION_SEPARATOR = ':';
const SECTION_SEPARATOR_INDEX = 2;
const TOTAL_VALUES_PER_SECTION = 2;
const PASTE_TYPE = 'insertFromPaste';
const COMPOSITION_TYPE = 'insertCompositionText';
class WgTimeInputDirective {
  constructor(element, control) {
    this.element = element;
    this.control = control;
    this.currentIndex = 0;
  }
  onFocus() {
    this.formatInput();
  }
  onBlur() {
    if (this.inputValue === '__:__') {
      this.inputValue = '';
      // Update formControl with the new value
      this.control?.control?.setValue(this.inputValue);
      // Dispatch input again to trigger any validations and events with the new value
      this.element.nativeElement.dispatchEvent(new Event('input'));
    }
  }
  onCompositionUpdate(event) {
    const data = event.data.trim().replace(/\D/g, '');
    this.currentIndex = this.parseCurrentIndex(data);
  }
  onPaste(event) {
    const pastedData = event.clipboardData.getData('Text').trim().replace(/\D/g, '');
    this.currentIndex = this.parseCurrentIndex(pastedData);
  }
  onValueChange(event) {
    if (event.isTrusted) {
      const currentValue = this.getCurrentValue();
      let index = this.getIndex(event);
      index = index > currentValue.length ? currentValue.length : index;
      this.element.nativeElement.selectionStart = index;
      this.element.nativeElement.selectionEnd = index;
      this.formatInput();
    }
  }
  parseCurrentIndex(data) {
    let index = this.element.nativeElement.selectionStart + data.length;
    if (this.hasToIncreaseIndex(this.element.nativeElement.selectionStart, data)) {
      index++;
    }
    return index;
  }
  getIndex(event) {
    let index = this.element.nativeElement.selectionStart;
    if (event.inputType === PASTE_TYPE || event.inputType === COMPOSITION_TYPE) {
      return this.currentIndex;
    }
    if (event.data) {
      const parsedData = event.data.trim().replace(/\D/g, '');
      index = index - (event.data.length - parsedData.length);
      if (this.hasToIncreaseIndex(index - parsedData.length, parsedData)) {
        index++;
      }
    }
    return index;
  }
  hasToIncreaseIndex(index, data) {
    return index <= SECTION_SEPARATOR_INDEX && index + data.length >= SECTION_SEPARATOR_INDEX;
  }
  getCurrentValue() {
    let currentValue = this.inputValue.trim().replace(/\D/g, '');
    if (currentValue.length > 1) {
      currentValue = [currentValue.slice(0, TOTAL_VALUES_PER_SECTION), SECTION_SEPARATOR, currentValue.slice(TOTAL_VALUES_PER_SECTION)].join('');
    }
    return currentValue;
  }
  formatInput() {
    const currentValue = this.getCurrentValue();
    const selectionIndex = this.element.nativeElement.selectionStart;
    const sections = currentValue.split(SECTION_SEPARATOR);
    let newValue = '';
    // Process first section
    newValue += this.getDataBySection(sections, 0);
    // Add separator
    newValue += SECTION_SEPARATOR;
    // Process second section
    newValue += this.getDataBySection(sections, 1);
    this.inputValue = newValue;
    // Update formControl with the new value
    this.control?.control?.setValue(this.inputValue);
    this.element.nativeElement.selectionStart = selectionIndex;
    this.element.nativeElement.selectionEnd = selectionIndex;
    // Dispatch input again to trigger any validations and events with the new value
    this.element.nativeElement.dispatchEvent(new Event('input'));
  }
  getDataBySection(values, index) {
    if (values.length > index && values[index].trim() !== '') {
      return values[index].length === 1 ? values[index] + '_' : values[index].substring(0, TOTAL_VALUES_PER_SECTION);
    } else {
      return '__';
    }
  }
  get inputValue() {
    return this.element.nativeElement.value.toString();
  }
  set inputValue(value) {
    this.element.nativeElement.value = value;
  }
  static {
    this.ɵfac = function WgTimeInputDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgTimeInputDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.NgControl));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: WgTimeInputDirective,
      selectors: [["", "wgTimeInput", ""]],
      hostBindings: function WgTimeInputDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("mouseup", function WgTimeInputDirective_mouseup_HostBindingHandler() {
            return ctx.onFocus();
          })("blur", function WgTimeInputDirective_blur_HostBindingHandler() {
            return ctx.onBlur();
          })("compositionupdate", function WgTimeInputDirective_compositionupdate_HostBindingHandler($event) {
            return ctx.onCompositionUpdate($event);
          })("paste", function WgTimeInputDirective_paste_HostBindingHandler($event) {
            return ctx.onPaste($event);
          })("input", function WgTimeInputDirective_input_HostBindingHandler($event) {
            return ctx.onValueChange($event);
          });
        }
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgTimeInputDirective, [{
    type: Directive,
    args: [{
      selector: '[wgTimeInput]',
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i2.NgControl
  }], {
    onFocus: [{
      type: HostListener,
      args: ['mouseup']
    }],
    onBlur: [{
      type: HostListener,
      args: ['blur']
    }],
    onCompositionUpdate: [{
      type: HostListener,
      args: ['compositionupdate', ['$event']]
    }],
    onPaste: [{
      type: HostListener,
      args: ['paste', ['$event']]
    }],
    onValueChange: [{
      type: HostListener,
      args: ['input', ['$event']]
    }]
  });
})();
class WgTimeInputModule {
  static {
    this.ɵfac = function WgTimeInputModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgTimeInputModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgTimeInputModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgTimeInputModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [WgTimeInputDirective],
      exports: [WgTimeInputDirective]
    }]
  }], null, null);
})();
class WgButtonComponent {
  constructor(elementRef) {
    this.elementRef = elementRef;
    this.color = 'secondary';
    this.disabled = false;
    this.iconPosition = 'start';
    this.type = 'button';
    this.variant = 'basic';
    this.cssClasses = [];
    this.resizing = false;
  }
  ngOnChanges() {
    this.updateCssClasses();
  }
  ngOnDestroy() {
    this.resizeObserver?.disconnect();
  }
  ngOnInit() {
    this.htmlElement = this.elementRef.nativeElement;
    this.initializeResizeObserver();
    this.checkContentOverflow();
  }
  /**
   * When the button has an icon, check to see if the content is overflowing
   */
  checkContentOverflow() {
    if (this.resizing || !this.icon) {
      return;
    }
    const spanElement = this.buttonElement.nativeElement.querySelector(':scope > span');
    if (!spanElement) {
      return;
    }
    this.htmlElement.title = '';
    spanElement.classList.remove('wg-button-hide-overflow');
    const buttonWidth = this.getButtonWidth(this.htmlElement, this.buttonElement.nativeElement);
    const childWidth = this.getTotalChildWidth(this.buttonElement.nativeElement);
    let isContentOverflowing = buttonWidth < childWidth;
    this.toggleSpanVisibility(spanElement, isContentOverflowing);
  }
  getButtonWidth(wrapperElement, buttonElement) {
    const style = window.getComputedStyle(buttonElement);
    const paddingLeft = parseFloat(style.paddingLeft);
    const paddingRight = parseFloat(style.paddingRight);
    return wrapperElement.clientWidth - paddingLeft - paddingRight + 14; // 14 = Want to allow for a little extra space
  }
  getTotalChildWidth(parentNode) {
    let totalWidth = 0;
    for (let i = 0; i < parentNode.childNodes.length; i++) {
      if (parentNode.childNodes[i].nodeType === Node.ELEMENT_NODE) {
        let child = parentNode.childNodes[i];
        let style = window.getComputedStyle(child);
        let marginLeft = parseFloat(style.marginLeft);
        let marginRight = parseFloat(style.marginRight);
        totalWidth += child.offsetWidth + marginLeft + marginRight;
      }
    }
    return totalWidth;
  }
  initializeResizeObserver() {
    this.resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        this.checkContentOverflow();
      }
    });
    this.resizeObserver.observe(this.htmlElement);
  }
  /**
   * Pause the logic for resizing the button to prevent flickering and hide the span if hide = true
   *
   * @param spanElement
   * @param hide
   */
  toggleSpanVisibility(spanElement, hide) {
    this.resizing = true;
    if (hide) {
      spanElement.classList.add('wg-button-hide-overflow');
      this.htmlElement.title = spanElement.textContent;
    }
    timer(100).subscribe(() => {
      this.resizing = false;
    });
  }
  updateCssClasses() {
    this.cssClasses.length = 0;
    this.cssClasses.push(`btn-${this.color}`);
    if (this.variant !== 'basic') {
      this.cssClasses.push(`btn-${this.variant}`);
    }
  }
  static {
    this.ɵfac = function WgButtonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgButtonComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgButtonComponent,
      selectors: [["wg-button"]],
      viewQuery: function WgButtonComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c1, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.buttonElement = _t.first);
        }
      },
      inputs: {
        color: "color",
        disabled: "disabled",
        icon: "icon",
        iconPosition: "iconPosition",
        label: "label",
        type: "type",
        variant: "variant"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c0,
      decls: 5,
      vars: 8,
      consts: [["button", ""], ["wgComponentStateLayer", "", 1, "btn", 3, "wgComponentStateLayerCssVersion", "ngClass", "disabled"], ["class", "start", 3, "name", 4, "ngIf"], [4, "ngIf"], ["class", "end", 3, "name", 4, "ngIf"], [1, "start", 3, "name"], [1, "end", 3, "name"]],
      template: function WgButtonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "button", 1, 0);
          i0.ɵɵtemplate(2, WgButtonComponent_wg_icon_2_Template, 1, 1, "wg-icon", 2)(3, WgButtonComponent_span_3_Template, 4, 3, "span", 3)(4, WgButtonComponent_wg_icon_4_Template, 1, 1, "wg-icon", 4);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("wgComponentStateLayerCssVersion", 2)("ngClass", ctx.cssClasses)("disabled", ctx.disabled);
          i0.ɵɵattribute("type", ctx.type)("aria-label", ctx.label);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.icon && ctx.iconPosition === "start");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.variant !== "icon");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.icon && ctx.iconPosition === "end");
        }
      },
      dependencies: [i1$2.NgClass, i1$2.NgIf, ComponentStateLayerDirective, WgIconComponent, i1$1.TranslatePipe],
      styles: ["wg-button{display:inline-block;overflow:hidden}wg-button+wg-button,wg-button+button,wg-button+a{margin-left:10px}wg-button button,wg-button .btn{align-content:center;align-items:center;display:inline-flex;justify-content:center}wg-button button>span,wg-button .btn>span{white-space:nowrap}wg-button button wg-icon.start,wg-button .btn wg-icon.start{margin-left:0}wg-button button wg-icon.end,wg-button .btn wg-icon.end{margin-right:0}wg-button button.btn-icon wg-icon,wg-button .btn.btn-icon wg-icon{margin:0}wg-button button wg-icon.start+span:not(.wg-button-hide-overflow),wg-button .btn wg-icon.start+span:not(.wg-button-hide-overflow){margin-left:5px}wg-button button span:not(.wg-button-hide-overflow)+wg-icon.end,wg-button .btn span:not(.wg-button-hide-overflow)+wg-icon.end{margin-left:5px}wg-button span.wg-button-hide-overflow{display:none}button+wg-button{margin-left:10px}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgButtonComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      selector: 'wg-button',
      standalone: false,
      template: "<button #button wgComponentStateLayer [wgComponentStateLayerCssVersion]=\"2\" [attr.type]=\"type\" class=\"btn\" [ngClass]=\"cssClasses\" [attr.aria-label]=\"label\" [disabled]=\"disabled\">\n  <wg-icon *ngIf=\"icon && iconPosition === 'start'\" [name]=\"icon\" class=\"start\"></wg-icon>\n  <span *ngIf=\"variant !== 'icon'\">\n    {{ label | translate }}\n    <ng-content></ng-content>\n  </span>\n  <wg-icon *ngIf=\"icon && iconPosition === 'end'\" [name]=\"icon\" class=\"end\"></wg-icon>\n</button>\n",
      styles: ["wg-button{display:inline-block;overflow:hidden}wg-button+wg-button,wg-button+button,wg-button+a{margin-left:10px}wg-button button,wg-button .btn{align-content:center;align-items:center;display:inline-flex;justify-content:center}wg-button button>span,wg-button .btn>span{white-space:nowrap}wg-button button wg-icon.start,wg-button .btn wg-icon.start{margin-left:0}wg-button button wg-icon.end,wg-button .btn wg-icon.end{margin-right:0}wg-button button.btn-icon wg-icon,wg-button .btn.btn-icon wg-icon{margin:0}wg-button button wg-icon.start+span:not(.wg-button-hide-overflow),wg-button .btn wg-icon.start+span:not(.wg-button-hide-overflow){margin-left:5px}wg-button button span:not(.wg-button-hide-overflow)+wg-icon.end,wg-button .btn span:not(.wg-button-hide-overflow)+wg-icon.end{margin-left:5px}wg-button span.wg-button-hide-overflow{display:none}button+wg-button{margin-left:10px}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    buttonElement: [{
      type: ViewChild,
      args: ['button', {
        static: true
      }]
    }],
    color: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    icon: [{
      type: Input
    }],
    iconPosition: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    type: [{
      type: Input
    }],
    variant: [{
      type: Input
    }]
  });
})();
class WgButtonModule {
  static {
    this.ɵfac = function WgButtonModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgButtonModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgButtonModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, TranslateModule, WgIconModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgButtonModule, [{
    type: NgModule,
    args: [{
      declarations: [WgButtonComponent],
      imports: [CommonModule, TranslateModule, ComponentStateLayerDirective, WgIconModule],
      exports: [WgButtonComponent]
    }]
  }], null, null);
})();
const DEFAULTS = {
  size: 140,
  darkColor: '#000000FF',
  lightColor: '#FFFFFFFF',
  errorCorrectionLevel: 'M',
  centerImageSize: 60,
  margin: 1
};
class WgQrcodeComponent {
  constructor() {
    this.size = DEFAULTS.size; // QR Code size
    this.darkColor = DEFAULTS.darkColor; // QR Code dark fill color
    this.lightColor = DEFAULTS.lightColor; // QR Code light fill color
    this.errorCorrectionLevel = DEFAULTS.errorCorrectionLevel;
    this.centerImageSize = DEFAULTS.centerImageSize; // Centre Logo size
    this.margin = DEFAULTS.margin; // QR Code margin
  }
  static {
    this.ɵfac = function WgQrcodeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgQrcodeComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgQrcodeComponent,
      selectors: [["wg-qrcode"]],
      inputs: {
        value: "value",
        size: "size",
        darkColor: "darkColor",
        lightColor: "lightColor",
        errorCorrectionLevel: "errorCorrectionLevel",
        centerImageSrc: "centerImageSrc",
        centerImageSize: "centerImageSize",
        margin: "margin"
      },
      standalone: false,
      decls: 2,
      vars: 8,
      consts: [[1, "qrcode-container"], [3, "value", "size", "darkColor", "lightColor", "errorCorrectionLevel", "centerImageSrc", "centerImageSize", "margin"]],
      template: function WgQrcodeComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵelement(1, "qr-code", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("value", ctx.value)("size", ctx.size)("darkColor", ctx.darkColor)("lightColor", ctx.lightColor)("errorCorrectionLevel", ctx.errorCorrectionLevel)("centerImageSrc", ctx.centerImageSrc)("centerImageSize", ctx.centerImageSize)("margin", ctx.margin);
        }
      },
      dependencies: [i1$4.QrCodeComponent],
      styles: ["qr-code[_ngcontent-%COMP%]{cursor:none}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgQrcodeComponent, [{
    type: Component,
    args: [{
      selector: 'wg-qrcode',
      template: `
    <div class="qrcode-container">
      <qr-code 
        [value]="value" 
        [size]="size"
        [darkColor]="darkColor"
        [lightColor]="lightColor"
        [errorCorrectionLevel]="errorCorrectionLevel"
        [centerImageSrc]="centerImageSrc"
        [centerImageSize]="centerImageSize"
        [margin]="margin">
      </qr-code>
    </div>
  `,
      standalone: false,
      styles: ["qr-code{cursor:none}\n"]
    }]
  }], () => [], {
    value: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    darkColor: [{
      type: Input
    }],
    lightColor: [{
      type: Input
    }],
    errorCorrectionLevel: [{
      type: Input
    }],
    centerImageSrc: [{
      type: Input
    }],
    centerImageSize: [{
      type: Input
    }],
    margin: [{
      type: Input
    }]
  });
})();
const QR_SIZE_MAP = {
  sm: 104,
  md: 140,
  lg: 160
};
const QR_DOWNLOAD_NAME = 'QRCode.png';
class WgQrcodeBannerComponent {
  set qrSize(size) {
    this.size = size in QR_SIZE_MAP ? QR_SIZE_MAP[size] : QR_SIZE_MAP['md'];
  }
  constructor(document, cdRef) {
    this.document = document;
    this.cdRef = cdRef;
    this.showBrandingLogo = false;
    this.showSsid = false;
    this.showPassphrase = false;
    this.showActions = true;
    this.broadcastSsid = false;
    this.printVoucher = new EventEmitter();
    this.errorLoadingLogo = false;
  }
  get qrCodeValue() {
    const t = this.authenticationType.trim() || '';
    const s = this.ssid.trim() || '';
    const p = this.passphrase.trim() || '';
    const h = this.broadcastSsid;
    return `WIFI:T:${t};S:${s};P:${p};H:${h};`;
  }
  get showSsidInfo() {
    return this.showSsid && !!this.ssid.trim();
  }
  get showParaphraseInfo() {
    return this.showPassphrase && !!this.passphrase.trim();
  }
  ngOnChanges(changes) {
    if (!changes.brandingLogoUrl?.firstChange && changes.brandingLogoUrl?.currentValue) {
      this.errorLoadingLogo = false;
    }
  }
  downloadQRCode() {
    const canvas = this.document.querySelector('.qrcode-banner canvas');
    canvas.toBlob(blob => {
      saveAs(blob, QR_DOWNLOAD_NAME);
    });
  }
  printQRCode() {
    this.printVoucher.emit();
  }
  handleImageLoadError() {
    this.errorLoadingLogo = true;
  }
  static {
    this.ɵfac = function WgQrcodeBannerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgQrcodeBannerComponent)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgQrcodeBannerComponent,
      selectors: [["wg-qrcode-banner"]],
      inputs: {
        qrSize: "qrSize",
        brandingLogoUrl: "brandingLogoUrl",
        titleText: "titleText",
        authenticationType: "authenticationType",
        ssid: "ssid",
        passphrase: "passphrase",
        footerText: "footerText",
        showBrandingLogo: "showBrandingLogo",
        showSsid: "showSsid",
        showPassphrase: "showPassphrase",
        showActions: "showActions",
        broadcastSsid: "broadcastSsid"
      },
      outputs: {
        printVoucher: "printVoucher"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 9,
      vars: 8,
      consts: [[1, "qrcode-banner", "wg-p-30"], [4, "ngIf"], [1, "banner-info"], ["class", "text", 4, "ngIf"], [3, "value", "size"], ["class", "actions wg-mt-15", 4, "ngIf"], ["alt", "logo", 1, "banner-image", "wg-mb-15", 3, "error", "src"], [1, "banner-title", "text", "wg-mb-15", 3, "title"], [1, "text"], [3, "title"], [1, "banner-footer", "text", "wg-mt-15", 3, "title"], [1, "actions", "wg-mt-15"], [3, "click"], ["name", "export-pdf", 1, "size-16"], [1, "wg-ml-5"], ["name", "download", 1, "size-16"]],
      template: function WgQrcodeBannerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, WgQrcodeBannerComponent_ng_container_1_Template, 2, 1, "ng-container", 1)(2, WgQrcodeBannerComponent_ng_container_2_Template, 3, 2, "ng-container", 1);
          i0.ɵɵelementStart(3, "p", 2);
          i0.ɵɵtemplate(4, WgQrcodeBannerComponent_span_4_Template, 5, 5, "span", 3)(5, WgQrcodeBannerComponent_span_5_Template, 5, 5, "span", 3);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(6, "wg-qrcode", 4);
          i0.ɵɵtemplate(7, WgQrcodeBannerComponent_ng_container_7_Template, 3, 2, "ng-container", 1);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(8, WgQrcodeBannerComponent_div_8_Template, 13, 6, "div", 5);
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.errorLoadingLogo && ctx.showBrandingLogo && ctx.brandingLogoUrl);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.titleText);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.showSsidInfo);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showParaphraseInfo);
          i0.ɵɵadvance();
          i0.ɵɵproperty("value", ctx.qrCodeValue)("size", ctx.size);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.footerText);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showActions);
        }
      },
      dependencies: [i1$2.NgIf, WgIconComponent, WgQrcodeComponent, i1$1.TranslatePipe],
      styles: ["[_nghost-%COMP%]   .qrcode-banner[_ngcontent-%COMP%]{text-align:center;border:1px solid #b5b5b5;display:flex;flex-direction:column;align-items:center;justify-content:center;word-break:break-all}[_nghost-%COMP%]   .qrcode-banner[_ngcontent-%COMP%]   .banner-image[_ngcontent-%COMP%]{width:118px;max-height:47px}[_nghost-%COMP%]   .qrcode-banner[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{display:block;overflow:hidden;text-overflow:ellipsis}[_nghost-%COMP%]   .qrcode-banner[_ngcontent-%COMP%]   .banner-title[_ngcontent-%COMP%]{font-size:13px;line-height:1.4}[_nghost-%COMP%]   .qrcode-banner[_ngcontent-%COMP%]   .banner-info[_ngcontent-%COMP%]{font-size:11px;line-height:1.4}[_nghost-%COMP%]   .qrcode-banner[_ngcontent-%COMP%]   .banner-footer[_ngcontent-%COMP%]{font-size:9px;line-height:1.4}.fix-width[_nghost-%COMP%]   .qrcode-banner[_ngcontent-%COMP%]{width:337px;height:437px}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgQrcodeBannerComponent, [{
    type: Component,
    args: [{
      selector: 'wg-qrcode-banner',
      standalone: false,
      template: "<div class=\"qrcode-banner wg-p-30\">\n  <ng-container *ngIf=\"!errorLoadingLogo && showBrandingLogo && brandingLogoUrl\">\n    <img class=\"banner-image wg-mb-15\" alt=\"logo\" [src]=\"brandingLogoUrl\" (error)=\"handleImageLoadError()\">\n  </ng-container>\n  <ng-container *ngIf=\"titleText\">\n    <h2 class=\"banner-title text wg-mb-15\" [title]=\"titleText\"> {{ titleText }} </h2>\n  </ng-container>\n  <p class=\"banner-info\">\n    <span *ngIf=\"showSsidInfo\" class=\"text\">\n      {{ 'qr_ssid_lbl' | translate }}: <span [title]=\"ssid\"> {{ ssid }} </span>\n    </span>\n    <span *ngIf=\"showParaphraseInfo\" class=\"text\">\n      {{ 'qr_passphrase_lbl' | translate }}: <span [title]=\"passphrase\"> {{ passphrase }} </span>\n    </span>\n  </p>\n  <wg-qrcode [value]=\"qrCodeValue\" [size]=\"size\"></wg-qrcode>\n  <ng-container *ngIf=\"footerText\">\n    <label class=\"banner-footer text wg-mt-15\" [title]=\"footerText\"> {{ footerText }} </label>\n  </ng-container>\n</div>\n<div *ngIf=\"showActions\" class=\"actions wg-mt-15\">\n  <p>\n    <a (click)=\"printQRCode()\">\n      <wg-icon name=\"export-pdf\" class=\"size-16\"></wg-icon>\n      <span class=\"wg-ml-5\"> {{ 'qr_create_pdf_lbl' | translate }} </span>\n    </a>\n  </p>\n  <p>\n    <a (click)=\"downloadQRCode()\">\n      <wg-icon name=\"download\" class=\"size-16\"></wg-icon>\n      <span class=\"wg-ml-5\"> {{ 'qr_download_ssid_lbl' | translate }} </span>\n    </a>\n  </p>\n</div>\n",
      styles: [":host .qrcode-banner{text-align:center;border:1px solid #b5b5b5;display:flex;flex-direction:column;align-items:center;justify-content:center;word-break:break-all}:host .qrcode-banner .banner-image{width:118px;max-height:47px}:host .qrcode-banner .text{display:block;overflow:hidden;text-overflow:ellipsis}:host .qrcode-banner .banner-title{font-size:13px;line-height:1.4}:host .qrcode-banner .banner-info{font-size:11px;line-height:1.4}:host .qrcode-banner .banner-footer{font-size:9px;line-height:1.4}:host.fix-width .qrcode-banner{width:337px;height:437px}\n"]
    }]
  }], () => [{
    type: Document,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: i0.ChangeDetectorRef
  }], {
    qrSize: [{
      type: Input
    }],
    brandingLogoUrl: [{
      type: Input
    }],
    titleText: [{
      type: Input
    }],
    authenticationType: [{
      type: Input
    }],
    ssid: [{
      type: Input
    }],
    passphrase: [{
      type: Input
    }],
    footerText: [{
      type: Input
    }],
    showBrandingLogo: [{
      type: Input
    }],
    showSsid: [{
      type: Input
    }],
    showPassphrase: [{
      type: Input
    }],
    showActions: [{
      type: Input
    }],
    broadcastSsid: [{
      type: Input
    }],
    printVoucher: [{
      type: Output
    }]
  });
})();
class WgQrcodeModule {
  static {
    this.ɵfac = function WgQrcodeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgQrcodeModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgQrcodeModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [QrCodeModule, TranslateModule, CommonModule, WgIconModule, WgButtonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgQrcodeModule, [{
    type: NgModule,
    args: [{
      declarations: [WgQrcodeComponent, WgQrcodeBannerComponent],
      imports: [QrCodeModule, TranslateModule, CommonModule, WgIconModule, WgButtonModule],
      exports: [WgQrcodeComponent, WgQrcodeBannerComponent]
    }]
  }], null, null);
})();
class LoaderService {
  constructor() {
    this.isLoading$ = new Subject();
    this.accumulatedLoadings = 0;
  }
  showLoading() {
    this._addLoading();
    if (!this.isLoading) {
      this.isLoading$.next(true);
      this.isLoading = true;
    }
  }
  hideLoading() {
    this._removeLoading();
    if (this.isLoading && this._isLastLoading()) {
      this.isLoading$.next(false);
      this.isLoading = false;
    }
  }
  _addLoading() {
    this.accumulatedLoadings++;
  }
  _removeLoading() {
    if (this.accumulatedLoadings > 0) {
      this.accumulatedLoadings--;
    }
  }
  _isLastLoading() {
    return this.accumulatedLoadings === 0;
  }
}
const HEIGHT = 8;
class LoaderComponent {
  constructor(document, el, loaderService) {
    this.document = document;
    this.el = el;
    this.loaderService = loaderService;
    this.modal = false;
    this.scale = 1;
    this.color = '#666';
    this.opacity = 0.2;
    this.useService = false;
    this.size = 0;
  }
  ngOnInit() {
    if (this.useService) {
      this.loaderService.isLoading$.subscribe(loading => {
        this.isLoading = loading;
        this.updateHostStyles();
        this.toggleOverlay(loading);
      });
    } else {
      this.isLoading = true;
      this.toggleOverlay(true);
    }
  }
  ngOnChanges(changes) {
    this.size = HEIGHT * this.scale * 3;
    this.updateHostStyles();
    this.updateCaptionStyles();
    this.updateIconStyles();
    if (this.ovelayElement) {
      this.ovelayElement.style.position = 'relative';
      this.ovelayElement.style.minHeight = '50px';
    }
    if (changes.modal && changes.modal.currentValue === true) {
      if (this.ovelayElement) {
        this.el.nativeElement.style.position = 'absolute';
      } else {
        this.el.nativeElement.style.position = 'fixed';
      }
      this.el.nativeElement.className = 'loader-modal';
    }
  }
  ngOnDestroy() {
    this.removeOverlayElement();
  }
  updateCaptionStyles() {
    const fontSizeString = window.getComputedStyle(this.el.nativeElement.querySelector('div.caption'), null).getPropertyValue('font-size');
    const fontSize = parseInt(fontSizeString, 10);
    this.captionStyles = {
      'line-height': this.size + 'px'
    };
  }
  updateIconStyles() {
    this.iconStyles = {
      height: this.size + 'px',
      width: this.size + 'px'
    };
  }
  updateHostStyles() {
    setTimeout(() => {
      if (this.modal && !this.ovelayElement) {
        const parent = this.getMainParentContainer();
        this.el.nativeElement.style.marginLeft = -(this.size / 2) + parent.getBoundingClientRect().left / 2 + 'px';
      } else {
        this.el.nativeElement.style.marginLeft = -(this.size / 2) + 'px';
      }
      this.el.nativeElement.style.marginTop = -(this.size / 2) + 'px';
    });
  }
  toggleOverlay(showOverlay) {
    if (showOverlay) {
      this.updateHostStyles();
      this.addOverlayElement();
    } else {
      this.removeOverlayElement();
    }
  }
  addOverlayElement() {
    setTimeout(() => {
      const overlayParent = this.ovelayElement || this.getMainParentContainer();
      this.blocked = this.document.createElement('div');
      this.blocked.classList.add('wg-loader-overlay');
      this.blocked.style.position = this.ovelayElement ? 'absolute' : 'fixed';
      if (!this.ovelayElement) {
        this.blocked.style.left = `${overlayParent.getBoundingClientRect().left}px`;
      }
      overlayParent.appendChild(this.blocked);
    });
  }
  getMainParentContainer() {
    return this.document.querySelector('wg-live-status-popout > main') || this.document.querySelector('wgc-layout-tsc > .content-container') || this.document.body;
  }
  removeOverlayElement() {
    setTimeout(() => {
      if (this.blocked && this.blocked.parentElement) {
        this.blocked.parentElement.removeChild(this.blocked);
      }
    });
  }
  static {
    this.ɵfac = function LoaderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LoaderComponent)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(LoaderService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: LoaderComponent,
      selectors: [["wg-loader"]],
      inputs: {
        modal: "modal",
        scale: "scale",
        color: "color",
        ovelayElement: "ovelayElement",
        opacity: "opacity",
        useService: "useService"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c0,
      decls: 3,
      vars: 3,
      consts: [["class", "icon", 3, "ngStyle", 4, "ngIf"], [1, "caption", 3, "ngStyle"], [4, "ngIf"], [1, "icon", 3, "ngStyle"], [1, "loader-icon"], ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 32 32", 2, "isolation", "isolate"], ["id", "a"], ["d", "M0 0h32v32H0z"], ["clip-path", "url(#a)"], ["id", "b"], ["fill", "#FFF", "d", "M0 0h32v32H0z"], ["clip-path", "url(#b)"], ["d", "M17.245 30.761A1.24 1.24 0 0 1 16.006 32h-.011a1.24 1.24 0 0 1-1.239-1.239l-.001-5.645c0-.685.555-1.239 1.239-1.239h.011c.684 0 1.239.554 1.239 1.239l.001 5.645z", "opacity", ".25"], ["d", "M17.245 6.884a1.24 1.24 0 0 1-1.239 1.239h-.011a1.24 1.24 0 0 1-1.239-1.239l-.001-5.645A1.24 1.24 0 0 1 15.994 0h.011a1.24 1.24 0 0 1 1.239 1.239l.001 5.645z"], ["d", "M1.239 17.245A1.24 1.24 0 0 1 0 16.006v-.011a1.24 1.24 0 0 1 1.239-1.239l5.645-.001a1.24 1.24 0 0 1 1.239 1.239v.011a1.24 1.24 0 0 1-1.239 1.239l-5.645.001z", "opacity", ".7"], ["d", "M25.116 17.245a1.24 1.24 0 0 1-1.239-1.239v-.011c0-.684.554-1.239 1.239-1.239h5.645A1.24 1.24 0 0 1 32 15.995v.011a1.24 1.24 0 0 1-1.239 1.239h-5.645zM24.459 28.161a1.24 1.24 0 0 1-.454 1.693l-.01.006a1.238 1.238 0 0 1-1.692-.454l-2.823-4.887a1.239 1.239 0 0 1 .454-1.693l.01-.006a1.24 1.24 0 0 1 1.693.454l2.822 4.887z", "opacity", ".1"], ["d", "M12.52 7.482a1.239 1.239 0 0 1-.454 1.693l-.01.006a1.238 1.238 0 0 1-1.692-.453L7.541 3.839a1.24 1.24 0 0 1 .454-1.693l.01-.006a1.238 1.238 0 0 1 1.692.454l2.823 4.888z", "opacity", ".9"], ["d", "M3.839 24.459a1.24 1.24 0 0 1-1.693-.454l-.005-.01a1.24 1.24 0 0 1 .454-1.692l4.889-2.823a1.238 1.238 0 0 1 1.692.454l.006.01c.343.592.139 1.35-.453 1.691l-4.89 2.824z", "opacity", ".55"], ["d", "M24.518 12.52a1.237 1.237 0 0 1-1.692-.454l-.006-.01a1.237 1.237 0 0 1 .454-1.692l4.887-2.823a1.24 1.24 0 0 1 1.693.454l.006.01a1.24 1.24 0 0 1-.454 1.692l-4.888 2.823zM29.407 22.303a1.24 1.24 0 0 1 .453 1.692l-.006.01a1.24 1.24 0 0 1-1.693.454l-4.887-2.823a1.24 1.24 0 0 1-.454-1.692l.007-.01a1.238 1.238 0 0 1 1.692-.453l4.888 2.822z", "opacity", ".1"], ["d", "M8.727 10.364c.593.342.796 1.1.454 1.692l-.006.01a1.24 1.24 0 0 1-1.693.454L2.594 9.698a1.24 1.24 0 0 1-.454-1.693l.006-.01a1.241 1.241 0 0 1 1.693-.454l4.888 2.823z", "opacity", ".8"], ["d", "M9.698 29.407a1.24 1.24 0 0 1-1.693.453l-.01-.006a1.239 1.239 0 0 1-.454-1.691l2.823-4.889a1.24 1.24 0 0 1 1.692-.454l.01.006a1.24 1.24 0 0 1 .454 1.692l-2.822 4.889z", "opacity", ".4"], ["d", "M21.636 8.727c-.342.593-1.1.796-1.692.454l-.01-.006a1.239 1.239 0 0 1-.454-1.693l2.821-4.888a1.24 1.24 0 0 1 1.693-.454l.01.006c.592.343.795 1.1.452 1.693l-2.82 4.888z", "opacity", ".1"]],
      template: function LoaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, LoaderComponent_div_0_Template, 20, 1, "div", 0);
          i0.ɵɵelementStart(1, "div", 1);
          i0.ɵɵtemplate(2, LoaderComponent_ng_content_2_Template, 1, 0, "ng-content", 2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.isLoading);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngStyle", ctx.captionStyles);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.isLoading);
        }
      },
      dependencies: [i1$2.NgIf, i1$2.NgStyle],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoaderComponent, [{
    type: Component,
    args: [{
      selector: 'wg-loader',
      standalone: false,
      template: "<div *ngIf=\"isLoading\" class=\"icon\" [ngStyle]=\"iconStyles\">\n  <span class=\"loader-icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" style=\"isolation:isolate\" viewBox=\"0 0 32 32\"><defs><clipPath id=\"a\"><path d=\"M0 0h32v32H0z\"/></clipPath></defs><g clip-path=\"url(#a)\"><clipPath id=\"b\"><path fill=\"#FFF\" d=\"M0 0h32v32H0z\"/></clipPath><g clip-path=\"url(#b)\"><path d=\"M17.245 30.761A1.24 1.24 0 0 1 16.006 32h-.011a1.24 1.24 0 0 1-1.239-1.239l-.001-5.645c0-.685.555-1.239 1.239-1.239h.011c.684 0 1.239.554 1.239 1.239l.001 5.645z\" opacity=\".25\"/><path d=\"M17.245 6.884a1.24 1.24 0 0 1-1.239 1.239h-.011a1.24 1.24 0 0 1-1.239-1.239l-.001-5.645A1.24 1.24 0 0 1 15.994 0h.011a1.24 1.24 0 0 1 1.239 1.239l.001 5.645z\"/><path d=\"M1.239 17.245A1.24 1.24 0 0 1 0 16.006v-.011a1.24 1.24 0 0 1 1.239-1.239l5.645-.001a1.24 1.24 0 0 1 1.239 1.239v.011a1.24 1.24 0 0 1-1.239 1.239l-5.645.001z\" opacity=\".7\"/><path d=\"M25.116 17.245a1.24 1.24 0 0 1-1.239-1.239v-.011c0-.684.554-1.239 1.239-1.239h5.645A1.24 1.24 0 0 1 32 15.995v.011a1.24 1.24 0 0 1-1.239 1.239h-5.645zM24.459 28.161a1.24 1.24 0 0 1-.454 1.693l-.01.006a1.238 1.238 0 0 1-1.692-.454l-2.823-4.887a1.239 1.239 0 0 1 .454-1.693l.01-.006a1.24 1.24 0 0 1 1.693.454l2.822 4.887z\" opacity=\".1\"/><path d=\"M12.52 7.482a1.239 1.239 0 0 1-.454 1.693l-.01.006a1.238 1.238 0 0 1-1.692-.453L7.541 3.839a1.24 1.24 0 0 1 .454-1.693l.01-.006a1.238 1.238 0 0 1 1.692.454l2.823 4.888z\" opacity=\".9\"/><path d=\"M3.839 24.459a1.24 1.24 0 0 1-1.693-.454l-.005-.01a1.24 1.24 0 0 1 .454-1.692l4.889-2.823a1.238 1.238 0 0 1 1.692.454l.006.01c.343.592.139 1.35-.453 1.691l-4.89 2.824z\" opacity=\".55\"/><path d=\"M24.518 12.52a1.237 1.237 0 0 1-1.692-.454l-.006-.01a1.237 1.237 0 0 1 .454-1.692l4.887-2.823a1.24 1.24 0 0 1 1.693.454l.006.01a1.24 1.24 0 0 1-.454 1.692l-4.888 2.823zM29.407 22.303a1.24 1.24 0 0 1 .453 1.692l-.006.01a1.24 1.24 0 0 1-1.693.454l-4.887-2.823a1.24 1.24 0 0 1-.454-1.692l.007-.01a1.238 1.238 0 0 1 1.692-.453l4.888 2.822z\" opacity=\".1\"/><path d=\"M8.727 10.364c.593.342.796 1.1.454 1.692l-.006.01a1.24 1.24 0 0 1-1.693.454L2.594 9.698a1.24 1.24 0 0 1-.454-1.693l.006-.01a1.241 1.241 0 0 1 1.693-.454l4.888 2.823z\" opacity=\".8\"/><path d=\"M9.698 29.407a1.24 1.24 0 0 1-1.693.453l-.01-.006a1.239 1.239 0 0 1-.454-1.691l2.823-4.889a1.24 1.24 0 0 1 1.692-.454l.01.006a1.24 1.24 0 0 1 .454 1.692l-2.822 4.889z\" opacity=\".4\"/><path d=\"M21.636 8.727c-.342.593-1.1.796-1.692.454l-.01-.006a1.239 1.239 0 0 1-.454-1.693l2.821-4.888a1.24 1.24 0 0 1 1.693-.454l.01.006c.592.343.795 1.1.452 1.693l-2.82 4.888z\" opacity=\".1\"/></g></g></svg></span>\n</div>\n<div class=\"caption\" [ngStyle]=\"captionStyles\">\n  <ng-content *ngIf=\"isLoading\"></ng-content>\n</div>\n"
    }]
  }], () => [{
    type: Document,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: i0.ElementRef
  }, {
    type: LoaderService
  }], {
    modal: [{
      type: Input
    }],
    scale: [{
      type: Input
    }],
    color: [{
      type: Input
    }],
    ovelayElement: [{
      type: Input
    }],
    opacity: [{
      type: Input
    }],
    useService: [{
      type: Input
    }]
  });
})();
class LoaderModule {
  static forRoot() {
    return {
      ngModule: LoaderModule,
      providers: [LoaderService]
    };
  }
  static {
    this.ɵfac = function LoaderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LoaderModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: LoaderModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoaderModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [LoaderComponent],
      exports: [LoaderComponent]
    }]
  }], null, null);
})();
class EqualValidatorDirective {
  constructor(validateEqual, reverse) {
    this.validateEqual = validateEqual;
    this.reverse = reverse;
  }
  get isReverse() {
    return this.reverse === 'true' ? true : false;
  }
  validate(c) {
    const currentField = c.value;
    const fieldCompared = c.root.get(this.validateEqual);
    if (fieldCompared && currentField !== fieldCompared.value && !this.isReverse) {
      return {
        validateEqual: false
      };
    }
    if (fieldCompared && currentField === fieldCompared.value && this.isReverse) {
      delete fieldCompared.errors.validateEqual;
      if (!Object.keys(fieldCompared.errors).length) {
        fieldCompared.setErrors(null);
      }
    }
    if (fieldCompared && currentField !== fieldCompared.value && this.isReverse) {
      fieldCompared.setErrors({
        validateEqual: false
      });
    }
    return null;
  }
  static {
    this.ɵfac = function EqualValidatorDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || EqualValidatorDirective)(i0.ɵɵinjectAttribute('validateEqual'), i0.ɵɵinjectAttribute('reverse'));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: EqualValidatorDirective,
      selectors: [["", "validateEqual", "", "formControlName", ""], ["", "validateEqual", "", "formControl", ""], ["", "validateEqual", "", "ngModel", ""]],
      standalone: false,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => EqualValidatorDirective),
        multi: true
      }])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EqualValidatorDirective, [{
    type: Directive,
    args: [{
      // eslint-disable-next-line @angular-eslint/directive-selector
      selector: '[validateEqual][formControlName],[validateEqual][formControl],[validateEqual][ngModel]',
      providers: [{
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => EqualValidatorDirective),
        multi: true
      }],
      standalone: false
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Attribute,
      args: ['validateEqual']
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Attribute,
      args: ['reverse']
    }]
  }], null);
})();
class BlankSpaceValidatorService {
  static test(control) {
    const valid = control.value ? new RegExp('^(?!\\s)(?!.*\\s$).+$').test(control.value) : true;
    return valid ? null : {
      BlankSpace: {
        value: control.value
      }
    };
  }
  static {
    this.ɵfac = function BlankSpaceValidatorService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BlankSpaceValidatorService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: BlankSpaceValidatorService,
      factory: BlankSpaceValidatorService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BlankSpaceValidatorService, [{
    type: Injectable
  }], null, null);
})();
class BlankSpaceValidatorDirective {
  validate(control) {
    return BlankSpaceValidatorService.test(control);
  }
  static {
    this.ɵfac = function BlankSpaceValidatorDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BlankSpaceValidatorDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: BlankSpaceValidatorDirective,
      selectors: [["", "BlankSpaceValidator", "", 3, "BlankSpaceValidator", "false"], ["input", "type", "text", 3, "BlankSpaceValidator", "false"], ["input", "type", "password", 3, "BlankSpaceValidator", "false"]],
      standalone: false,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => BlankSpaceValidatorDirective),
        multi: true
      }])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BlankSpaceValidatorDirective, [{
    type: Directive,
    args: [{
      // eslint-disable-next-line @angular-eslint/directive-selector
      selector: `[BlankSpaceValidator]:not([BlankSpaceValidator="false"]),
                input[type="text"]:not([BlankSpaceValidator="false"]),
                input[type="password"]:not([BlankSpaceValidator="false"])`,
      providers: [{
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => BlankSpaceValidatorDirective),
        multi: true
      }],
      standalone: false
    }]
  }], null, null);
})();
class UrlPatternValidatorService {
  static url(control) {
    // tslint:disable-next-line:max-line-length
    const valid = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(control.value);
    return valid ? null : {
      urlPattern: {
        value: control.value
      }
    };
  }
  static {
    this.ɵfac = function UrlPatternValidatorService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UrlPatternValidatorService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: UrlPatternValidatorService,
      factory: UrlPatternValidatorService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UrlPatternValidatorService, [{
    type: Injectable
  }], null, null);
})();
class UrlPatternValidatorDirective {
  constructor() {}
  validate(control) {
    return UrlPatternValidatorService.url(control);
  }
  static {
    this.ɵfac = function UrlPatternValidatorDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UrlPatternValidatorDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: UrlPatternValidatorDirective,
      selectors: [["", "UrlPatternValidator", ""]],
      standalone: false,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => UrlPatternValidatorDirective),
        multi: true
      }])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UrlPatternValidatorDirective, [{
    type: Directive,
    args: [{
      // eslint-disable-next-line @angular-eslint/directive-selector
      selector: '[UrlPatternValidator]',
      providers: [{
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => UrlPatternValidatorDirective),
        multi: true
      }],
      standalone: false
    }]
  }], () => [], null);
})();
class XSSPatternValidatorService {
  static test() {
    const val = control => {
      // tslint:disable-next-line:max-line-length
      const pattern = new RegExp('(<("[^"]*"|\'[^\']*\'|[^\'">])*>)|(&lt;("[^"]*"|\'[^\']*\'|[^\'">])*gt;)|(&#x3C;("[^"]*"|\'[^\']*\'|[^\'">])*&#x3E;)');
      const invalid = pattern.test(control.value);
      return invalid ? {
        XSSPattern: {
          value: control.value
        }
      } : null;
    };
    return val;
  }
  static {
    this.ɵfac = function XSSPatternValidatorService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || XSSPatternValidatorService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: XSSPatternValidatorService,
      factory: XSSPatternValidatorService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XSSPatternValidatorService, [{
    type: Injectable
  }], null, null);
})();
class RangeValidatorService {
  static max(max) {
    const maxVal = control => {
      const val = control.value;
      if (control.pristine || val <= max) {
        return null;
      }
      return {
        max: {
          maxValue: max,
          actualValue: control.value
        }
      };
    };
    return maxVal;
  }
  static min(min) {
    const minVal = control => {
      const val = control.value;
      if (control.pristine || !val || val >= min) {
        return null;
      }
      return {
        min: {
          minValue: min,
          actualValue: control.value
        }
      };
    };
    return minVal;
  }
  static {
    this.ɵfac = function RangeValidatorService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RangeValidatorService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RangeValidatorService,
      factory: RangeValidatorService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RangeValidatorService, [{
    type: Injectable
  }], null, null);
})();
class ShowErrorsComponent {
  translateMessage(key, params) {
    const message = this.keySuffix ? `${key}_${this.keySuffix}` : key;
    return this.translate.instant(message, Object.assign({
      fieldName: this.fieldName
    }, params));
  }
  constructor(translate) {
    this.translate = translate;
    this.fieldName = '<NO FIELDNAME SET>';
    this.errorMessages = {
      required: params => this.translateMessage('ui_common_form_error_required', params),
      unique: params => this.translateMessage('ui_common_form_error_unique', params),
      XSSPattern: params => this.translateMessage('ui_common_form_error_xss_pattern', params),
      BlankSpace: params => this.translateMessage('ui_common_form_error_blank_space', params),
      validateEqual: params => this.translateMessage('ui_common_form_error_equal_validator_password', params),
      pattern: params => this.translateMessage('ui_common_form_error_pattern', params),
      minlength: params => this.translateMessage('ui_common_form_error_minlength', params),
      maxlength: params => this.translateMessage('ui_common_form_error_maxlength', params),
      range: params => this.translateMessage('ui_common_form_error_range', params),
      min: params => this.translateMessage('ui_common_form_error_min_value', params),
      max: params => this.translateMessage('ui_common_form_error_max_value', params),
      urlPattern: params => this.translateMessage('ui_common_form_error_url', params),
      email: params => this.translateMessage('ui_common_form_error_email', params),
      time12HFormat: params => this.translateMessage('ui_common_form_error_time_12_hour_format', params),
      time24HFormat: params => this.translateMessage('ui_common_form_error_time_24_hour_format', params)
    };
  }
  ngOnInit() {
    if (this.customMessage) {
      Object.keys(this.customMessage).forEach(key => {
        if (this.customMessage[key] instanceof Function) {
          this.errorMessages[key] = this.customMessage[key];
        } else {
          this.errorMessages[key] = params => {
            return this.translate.instant(this.customMessage[key], {
              fieldName: this.fieldName,
              ...params
            });
          };
        }
      });
    }
  }
  shouldShowErrors() {
    return this.control && this.control.errors && (this.control.dirty || this.control.touched);
  }
  listOfErrors() {
    const errorListMapped = Object.keys(this.control.errors).map(field => this.getMessage(field, this.control.errors[field]));
    return this.acceptMultiplesErros ? errorListMapped : [errorListMapped[0]];
  }
  getMessage(type, params) {
    const getMessageByType = this.errorMessages[type];
    if (getMessageByType) {
      return getMessageByType(params);
    }
    return null;
  }
  static {
    this.ɵfac = function ShowErrorsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ShowErrorsComponent)(i0.ɵɵdirectiveInject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ShowErrorsComponent,
      selectors: [["show-errors"]],
      inputs: {
        acceptMultiplesErros: "acceptMultiplesErros",
        fieldName: "fieldName",
        keySuffix: "keySuffix",
        control: "control",
        customMessage: "customMessage"
      },
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [["class", "text-danger", 4, "ngIf"], [1, "text-danger"], ["class", "text-danger", 4, "ngFor", "ngForOf"]],
      template: function ShowErrorsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ShowErrorsComponent_div_0_Template, 2, 1, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.shouldShowErrors());
        }
      },
      dependencies: [i1$2.NgForOf, i1$2.NgIf],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ShowErrorsComponent, [{
    type: Component,
    args: [{
      // eslint-disable-next-line @angular-eslint/component-selector
      selector: 'show-errors',
      template: `
    <div *ngIf="shouldShowErrors()" class="text-danger">
      <span *ngFor="let error of listOfErrors()" class="text-danger">{{ error }}</span>
    </div>
   `,
      standalone: false
    }]
  }], () => [{
    type: i1$1.TranslateService
  }], {
    acceptMultiplesErros: [{
      type: Input
    }],
    fieldName: [{
      type: Input
    }],
    keySuffix: [{
      type: Input
    }],
    control: [{
      type: Input
    }],
    customMessage: [{
      type: Input
    }]
  });
})();
class RangeValidator {
  constructor() {
    this.normalizeValues();
  }
  normalizeValues() {
    this.rangeMin = this.rangeMin && Number(this.rangeMin);
    this.rangeMax = this.rangeMax && Number(this.rangeMax);
  }
  validate(control) {
    if (control.value || control.value === 0) {
      const value = Number(control.value);
      const isSmallerThanMininum = this.isSmallerThanMininum(this.rangeMin, value);
      const isGreaterThanMaximun = this.isGreaterThanMaximun(this.rangeMax, value);
      const range = {
        range: {
          minValue: this.rangeMin,
          maxValue: this.rangeMax,
          actualValue: value
        }
      };
      return isSmallerThanMininum || isGreaterThanMaximun ? range : null;
    } else {
      return null;
    }
  }
  isSmallerThanMininum(minValue, value) {
    return minValue && value < minValue;
  }
  isGreaterThanMaximun(maxValue, value) {
    return maxValue && value > maxValue;
  }
  static {
    this.ɵfac = function RangeValidator_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RangeValidator)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: RangeValidator,
      selectors: [["", "rangeValidator", "", "rangeMin", "", "rangeMax", ""], ["", "rangeValidator", "", "rangeMin", ""], ["", "rangeValidator", "", "rangeMax", ""]],
      inputs: {
        rangeMin: "rangeMin",
        rangeMax: "rangeMax"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => RangeValidator),
        multi: true
      }])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RangeValidator, [{
    type: Directive,
    args: [{
      // eslint-disable-next-line @angular-eslint/directive-selector
      selector: '[rangeValidator][rangeMin][rangeMax],[rangeValidator][rangeMin],[rangeValidator][rangeMax]',
      providers: [{
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => RangeValidator),
        multi: true
      }],
      standalone: false
    }]
  }], () => [], {
    rangeMin: [{
      type: Input
    }],
    rangeMax: [{
      type: Input
    }]
  });
})();
class XSSPatternValidatorDirective {
  constructor() {
    // tslint:disable-next-line:max-line-length
    this.pattern = new RegExp('(<("[^"]*"|\'[^\']*\'|[^\'">])*>)|(&lt;("[^"]*"|\'[^\']*\'|[^\'">])*gt;)|(&#x3C;("[^"]*"|\'[^\']*\'|[^\'">])*&#x3E;)');
  }
  validate(control) {
    const invalid = this.pattern.test(control.value);
    return invalid ? {
      XSSPattern: {
        value: control.value
      }
    } : null;
  }
  static {
    this.ɵfac = function XSSPatternValidatorDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || XSSPatternValidatorDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: XSSPatternValidatorDirective,
      selectors: [["", "XSSPatternValidator", "", 3, "XSSPatternValidator", "false"], ["input", "type", "text", 3, "XSSPatternValidator", "false"], ["input", "type", "password", 3, "XSSPatternValidator", "false"]],
      standalone: false,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => XSSPatternValidatorDirective),
        multi: true
      }])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XSSPatternValidatorDirective, [{
    type: Directive,
    args: [{
      // eslint-disable-next-line @angular-eslint/directive-selector
      selector: `[XSSPatternValidator]:not([XSSPatternValidator="false"]),
            input[type="text"]:not([XSSPatternValidator="false"]),
            input[type="password"]:not([XSSPatternValidator="false"])`,
      providers: [{
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => XSSPatternValidatorDirective),
        multi: true
      }],
      standalone: false
    }]
  }], () => [], null);
})();
class UniqueValidator {
  constructor() {}
  validate(abstractControl) {
    if (!this.inputObservable) {
      this.inputObservable = abstractControl.valueChanges.pipe(debounceTime(500), switchMap(val => this.uniqueValidatorFunction(val)), map(val => {
        if (val.length > 0) {
          return {
            unique: true
          };
        } else {
          return null;
        }
      }), first$1());
    }
    return this.inputObservable;
  }
  static {
    this.ɵfac = function UniqueValidator_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UniqueValidator)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: UniqueValidator,
      selectors: [["", "uniqueValidator", "", "formControlName", ""], ["", "uniqueValidator", "", "ngModel", ""]],
      inputs: {
        uniqueValidatorFunction: [0, "uniqueValidator", "uniqueValidatorFunction"]
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_ASYNC_VALIDATORS,
        useExisting: forwardRef(() => UniqueValidator),
        multi: true
      }])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UniqueValidator, [{
    type: Directive,
    args: [{
      // eslint-disable-next-line @angular-eslint/directive-selector
      selector: '[uniqueValidator][formControlName], [uniqueValidator][ngModel]',
      providers: [{
        provide: NG_ASYNC_VALIDATORS,
        useExisting: forwardRef(() => UniqueValidator),
        multi: true
      }],
      standalone: false
    }]
  }], () => [], {
    uniqueValidatorFunction: [{
      type: Input,
      args: ['uniqueValidator']
    }]
  });
})();
class WgTimeFormatValidatorService {
  static test12HFormat(control) {
    const valid = control.value ? new RegExp(/^(?:[0]\d|1[0-2]):(?:[0-5]\d)$/).test(control.value) : true;
    return valid ? null : {
      time12HFormat: {
        value: control.value
      }
    };
  }
  static test24HFormat(control) {
    const valid = control.value ? new RegExp(/^(?:[01]\d|2[0-3]):(?:[0-5]\d)$/).test(control.value) : true;
    return valid ? null : {
      time24HFormat: {
        value: control.value
      }
    };
  }
  static {
    this.ɵfac = function WgTimeFormatValidatorService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgTimeFormatValidatorService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: WgTimeFormatValidatorService,
      factory: WgTimeFormatValidatorService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgTimeFormatValidatorService, [{
    type: Injectable
  }], null, null);
})();
class WgTimeFormatValidatorDirective {
  validate(control) {
    const options = {
      ['24h']: () => WgTimeFormatValidatorService.test24HFormat(control),
      ['12h']: () => WgTimeFormatValidatorService.test12HFormat(control),
      ['default']: () => WgTimeFormatValidatorService.test24HFormat(control)
    };
    return options[this.wgTimeFormat || 'default']();
  }
  static {
    this.ɵfac = function WgTimeFormatValidatorDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgTimeFormatValidatorDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: WgTimeFormatValidatorDirective,
      selectors: [["", "wgTimeFormat", ""]],
      inputs: {
        wgTimeFormat: "wgTimeFormat"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => WgTimeFormatValidatorDirective),
        multi: true
      }])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgTimeFormatValidatorDirective, [{
    type: Directive,
    args: [{
      selector: '[wgTimeFormat]',
      providers: [{
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => WgTimeFormatValidatorDirective),
        multi: true
      }],
      standalone: false
    }]
  }], null, {
    wgTimeFormat: [{
      type: Input
    }]
  });
})();
class ValidatorModule {
  static {
    this.ɵfac = function ValidatorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ValidatorModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ValidatorModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [XSSPatternValidatorService, RangeValidatorService, BlankSpaceValidatorService, WgTimeFormatValidatorService, BlankSpaceValidatorDirective],
      imports: [CommonModule, TranslateModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ValidatorModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, TranslateModule],
      declarations: [RangeValidator, XSSPatternValidatorDirective, BlankSpaceValidatorDirective, UniqueValidator, EqualValidatorDirective, ShowErrorsComponent, UrlPatternValidatorDirective, WgTimeFormatValidatorDirective],
      exports: [RangeValidator, UniqueValidator, XSSPatternValidatorDirective, BlankSpaceValidatorDirective, EqualValidatorDirective, ShowErrorsComponent, UrlPatternValidatorDirective, WgTimeFormatValidatorDirective],
      providers: [XSSPatternValidatorService, RangeValidatorService, BlankSpaceValidatorService, WgTimeFormatValidatorService, BlankSpaceValidatorDirective]
    }]
  }], null, null);
})();
class WgChipsComponent {
  constructor(differs) {
    this.chipsListChange = new EventEmitter(); // emits the list of chips
    this.chipRemoved = new EventEmitter(); // emits the removed chip
    this.chipsListInvalid = new EventEmitter(); // emits the invalid list of chips if a valFunc is passed
    this.userInput = new EventEmitter(); // emits text being typed
    this.placeholder = 'Input'; // placeholder of the chips input field
    this.label = 'Name';
    this.className = 'form-control';
    this.disabled = false; // disable chips input box
    this.fieldError = false; // set fieldError to true to show ng-invalid similar to text input
    this.showSelectionUI = new EventEmitter();
    this.optionInput = '';
    this.validatorPassed = false;
    this.outputSent = false;
    this.differ = differs.find([]).create(null);
  }
  get valid() {
    if (this.fieldError) {
      return 'ng-invalid';
    }
    return '';
  }
  ngOnInit() {
    if (!this.chipsList) {
      this.chipsList = new Array();
    }
    if (this._isFunction(this.valFunc)) {
      this.validatorPassed = true;
    }
  }
  ngDoCheck() {
    const change = this.differ.diff(this.chipsList);
    if (change && !this.outputSent) {
      this.sendOutputs();
    } else {
      this.outputSent = false;
    }
  }
  setChips() {
    this.optionInput = this.optionInput.trim();
    const delimeters = this.delimiters ?? [',', ';', ' '];
    let delimeted = false;
    for (const delimeter of delimeters) {
      if (this.optionInput.includes(delimeter)) {
        const inputs = this.optionInput.split(delimeter);
        inputs.forEach(element => {
          if (element.trim()) {
            this.chipsList.push(element.trim());
          }
        });
        delimeted = true;
        break;
      }
    }
    if (!delimeted) {
      this.chipsList.push(this.optionInput);
    }
    this.optionInput = '';
  }
  sendOutputs() {
    this.chipsListChange.emit([].concat(this.chipsList));
    if (this.validatorPassed) {
      const invalidList = [];
      for (const item of this.chipsList) {
        if (!this.valFunc(item)) {
          invalidList.push(item);
        }
      }
      if (invalidList) {
        this.chipsListInvalid.emit([].concat(invalidList));
      }
    }
  }
  onInputChange(value) {
    if (this.disabled) {
      return;
    }
    this.optionInput = value;
    this.userInput.emit(this.optionInput);
    if (!value) {
      return;
    }
  }
  focusToInput(value = '') {
    if (this.inputSelector) {
      this.inputSelector.nativeElement.focus();
      this.inputSelector.nativeElement.value = value;
    }
  }
  inputEvent(e) {
    // enter or tab key pressed
    if ((e.which === 13 || e.which === 9) && this.optionInput) {
      this.focusToInput();
      this.setChips();
      this.optionInput = '';
    }
    // backspace pressed
    if (e.which === 8 && !e.target.value) {
      this.remove(this.chipsList[this.chipsList.length - 1]);
      this.sendOutputs();
      this.outputSent = true;
    }
  }
  remove(item) {
    if (this.disabled) {
      return;
    }
    const index = this.chipsList.indexOf(item);
    if (index !== -1) {
      this.chipRemoved.emit(this.chipsList[index]);
      this.chipsList.splice(index, 1);
    }
  }
  removeClick(item, event) {
    this.remove(item);
  }
  invalidItem(item) {
    if (this.validatorPassed) {
      if (!this.valFunc(item)) {
        return true;
      }
    }
    return false;
  }
  _isFunction(functionToCheck) {
    return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
  }
  showSelectionPopup() {
    if (this.disabled) return;
    this.showSelectionUI.emit();
  }
  static {
    this.ɵfac = function WgChipsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgChipsComponent)(i0.ɵɵdirectiveInject(i0.IterableDiffers));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgChipsComponent,
      selectors: [["wg-chips"]],
      viewQuery: function WgChipsComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c2, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputSelector = _t.first);
        }
      },
      inputs: {
        placeholder: "placeholder",
        label: "label",
        className: "className",
        disabled: "disabled",
        chipsList: "chipsList",
        valFunc: "valFunc",
        fieldError: "fieldError",
        delimiters: "delimiters",
        showChipSelectionDialog: "showChipSelectionDialog",
        selectionText: "selectionText"
      },
      outputs: {
        chipsListChange: "chipsListChange",
        chipRemoved: "chipRemoved",
        chipsListInvalid: "chipsListInvalid",
        userInput: "userInput",
        showSelectionUI: "showSelectionUI"
      },
      standalone: false,
      decls: 7,
      vars: 3,
      consts: [["regularChip", ""], ["chipWithDialog", ""], ["selector", ""], [1, "box-selector", 3, "ngClass"], [4, "ngIf"], [4, "ngTemplateOutlet"], ["tabindex", "0", "id", "multiple", 1, "mult-selector-input", 3, "focus", "ngClass"], [1, "selected-options"], ["class", "btn fs-block", "role", "button", 3, "btn-danger", 4, "ngFor", "ngForOf"], ["type", "text", "class", "selector-input ft-chips-field fs-block", 3, "hidden", "ngModel", "placeholder", "keydown", "ngModelChange", 4, "ngIf"], ["role", "button", 1, "btn", "fs-block"], ["class", "close", "style", "margin-left: 5px; padding: 0;", 3, "click", 4, "ngIf"], [1, "close", 2, "margin-left", "5px", "padding", "0", 3, "click"], ["name", "close"], ["type", "text", 1, "selector-input", "ft-chips-field", "fs-block", 3, "keydown", "ngModelChange", "hidden", "ngModel", "placeholder"], ["tabindex", "0", "id", "multiple", 1, "mult-selector-input", 3, "ngClass"], ["class", "btn d-inline-flex align-items-center", "role", "button", 4, "ngFor", "ngForOf"], ["class", "color-silver", 4, "ngIf"], [1, "ml-3", 3, "click"], ["role", "button", 1, "btn", "d-inline-flex", "align-items-center"], [4, "ngFor", "ngForOf"], [1, "close", "wg-ml-5", "wg-p-0", 3, "click"], ["name", "close", 3, "size"], ["class", "wg-mr-5", 3, "name", "size", 4, "ngIf"], [1, "wg-mr-5", 3, "name", "size"], [1, "color-silver"]],
      template: function WgChipsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 3);
          i0.ɵɵtemplate(1, WgChipsComponent_ng_container_1_Template, 2, 1, "ng-container", 4)(2, WgChipsComponent_ng_container_2_Template, 2, 1, "ng-container", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(3, WgChipsComponent_ng_template_3_Template, 4, 6, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(5, WgChipsComponent_ng_template_5_Template, 7, 10, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", ctx.valid);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.showChipSelectionDialog);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showChipSelectionDialog);
        }
      },
      dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgTemplateOutlet, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgModel, WgIconComponent, i1$2.SlicePipe, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgChipsComponent, [{
    type: Component,
    args: [{
      selector: 'wg-chips',
      standalone: false,
      template: "<div class=\"box-selector\" [ngClass]=\"valid\">\n  <ng-container *ngIf=\"!showChipSelectionDialog\">\n    <ng-container *ngTemplateOutlet=\"regularChip\"></ng-container>\n  </ng-container>\n  <ng-container *ngIf=\"showChipSelectionDialog\">\n    <ng-container *ngTemplateOutlet=\"chipWithDialog\"></ng-container>\n  </ng-container>\n</div>\n\n<!-- Code for exisiting chip -->\n<ng-template #regularChip>\n  <div tabindex=\"0\" id=\"multiple\" class=\"mult-selector-input\"\n        [ngClass]=\"[className]\"\n        (focus)=\"focusToInput()\">\n       <div class=\"selected-options\" [attr.disabled]=\"disabled ? 'disabled': null\">\n          <span class=\"btn fs-block\" [class.btn-danger]=\"invalidItem(item)\" *ngFor=\"let item of chipsList\" role=\"button\">\n              {{ item }}\n              <a *ngIf=\"!disabled\"\n                  class=\"close\"\n                  style=\"margin-left: 5px; padding: 0;\"\n                  (click)=\"removeClick(item, $event)\"><wg-icon name=\"close\"></wg-icon></a>\n          </span>\n       </div>\n\n    <input #selector\n        *ngIf=\"!disabled\"\n        type=\"text\" \n        class=\"selector-input ft-chips-field fs-block\"\n        [attr.disabled]=\"disabled ? 'disabled': null\"\n        [hidden]=\"disabled\"\n        [ngModel]=\"optionInput\"\n        [placeholder]=\"placeholder\"\n        (keydown)=\"inputEvent($event)\"\n        (ngModelChange)=\"onInputChange($event)\">\n  </div>\n</ng-template>\n\n<!-- Code for showing a dialog that then populates the chips\n     The chips can have icon too.\n-->\n<ng-template #chipWithDialog>\n  <div tabindex=\"0\"\n       id=\"multiple\"\n       class=\"mult-selector-input\"\n       [ngClass]=\"[className]\">\n    <div class=\"selected-options\">\n      <span class=\"btn d-inline-flex align-items-center\"\n            *ngFor=\"let item of chipsList\"\n            role=\"button\">\n          <ng-container *ngFor=\"let elem of item.split(':::') | slice:0:item.length - 1; let i=index\">\n            <wg-icon\n              *ngIf=\"i === 0 && elem\"\n               class=\"wg-mr-5\"\n               name=\"{{ elem }}\"\n               [size]=\"20\">\n            </wg-icon>\n            <span *ngIf=\"i === 1\">\n              {{ elem | translate }}\n            </span>\n          </ng-container>\n          <a class=\"close wg-ml-5 wg-p-0\"\n             (click)=\"removeClick(item, $event)\">\n             <wg-icon name=\"close\" [size]=\"20\"></wg-icon>\n          </a>\n      </span>\n      <span *ngIf=\"chipsList.length === 0\"\n             class=\"color-silver\">\n        {{ placeholder | translate }}\n      </span>\n      <a class=\"ml-3\" [class.disabled]=\"disabled\"\n         (click)=\"showSelectionPopup()\">\n        {{ selectionText | translate }}\n      </a>\n    </div>\n  </div>\n</ng-template>\n"
    }]
  }], () => [{
    type: i0.IterableDiffers
  }], {
    inputSelector: [{
      type: ViewChild,
      args: ['selector']
    }],
    chipsListChange: [{
      type: Output
    }],
    chipRemoved: [{
      type: Output
    }],
    chipsListInvalid: [{
      type: Output
    }],
    userInput: [{
      type: Output
    }],
    placeholder: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    className: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    chipsList: [{
      type: Input
    }],
    valFunc: [{
      type: Input
    }],
    fieldError: [{
      type: Input
    }],
    delimiters: [{
      type: Input
    }],
    showChipSelectionDialog: [{
      type: Input
    }],
    selectionText: [{
      type: Input
    }],
    showSelectionUI: [{
      type: Output
    }]
  });
})();
class WgChipsModule {
  static {
    this.ɵfac = function WgChipsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgChipsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgChipsModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FormsModule, WgIconModule, TranslateModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgChipsModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FormsModule, WgIconModule, TranslateModule],
      declarations: [WgChipsComponent],
      exports: [WgChipsComponent]
    }]
  }], null, null);
})();
class WgCardComponent {
  constructor() {
    this.cssClassWgCard = true;
    this.cssClassCard = true;
  }
  toggleBack(event) {
    event.preventDefault();
    if (this.backTemplate) {
      this.showBack = !this.showBack;
    }
  }
  static {
    this.ɵfac = function WgCardComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgCardComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgCardComponent,
      selectors: [["wg-card"]],
      contentQueries: function WgCardComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, _c4, 7);
          i0.ɵɵcontentQuery(dirIndex, _c5, 7);
          i0.ɵɵcontentQuery(dirIndex, _c6, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.bodyTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.backTemplate = _t.first);
        }
      },
      hostVars: 8,
      hostBindings: function WgCardComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("wg-card", ctx.cssClassWgCard)("card", ctx.cssClassCard)("show-back", ctx.showBack)("has-back", ctx.backTemplate);
        }
      },
      inputs: {
        showBack: "showBack"
      },
      standalone: false,
      decls: 6,
      vars: 4,
      consts: [[1, "card-header", 3, "click"], [4, "ngTemplateOutlet"], ["class", "expand-button", 4, "ngIf"], [1, "card-body"], ["class", "card-back", 4, "ngIf"], [1, "expand-button"], ["name", "expanded"], [1, "card-back"]],
      template: function WgCardComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵlistener("click", function WgCardComponent_Template_div_click_0_listener($event) {
            return ctx.toggleBack($event);
          });
          i0.ɵɵtemplate(1, WgCardComponent_ng_container_1_Template, 1, 0, "ng-container", 1)(2, WgCardComponent_a_2_Template, 2, 0, "a", 2);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "div", 3);
          i0.ɵɵtemplate(4, WgCardComponent_ng_container_4_Template, 1, 0, "ng-container", 1)(5, WgCardComponent_div_5_Template, 2, 1, "div", 4);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngTemplateOutlet", ctx.headerTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.backTemplate);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngTemplateOutlet", ctx.bodyTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.backTemplate);
        }
      },
      dependencies: [i1$2.NgIf, i1$2.NgTemplateOutlet, WgIconComponent],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgCardComponent, [{
    type: Component,
    args: [{
      selector: 'wg-card',
      standalone: false,
      template: "<div class=\"card-header\" (click)=\"toggleBack($event)\">\n  <ng-container *ngTemplateOutlet=\"headerTemplate\"></ng-container>\n  <a class=\"expand-button\" *ngIf=\"backTemplate\"><wg-icon name=\"expanded\"></wg-icon></a>\n</div>\n<div class=\"card-body\">\n  <ng-container *ngTemplateOutlet=\"bodyTemplate\"></ng-container>\n\n  <div class=\"card-back\" *ngIf=\"backTemplate\">\n    <ng-container *ngTemplateOutlet=\"backTemplate\"></ng-container>\n  </div>\n</div>\n"
    }]
  }], null, {
    cssClassWgCard: [{
      type: HostBinding,
      args: ['class.wg-card']
    }],
    cssClassCard: [{
      type: HostBinding,
      args: ['class.card']
    }],
    showBack: [{
      type: HostBinding,
      args: ['class.show-back']
    }, {
      type: Input
    }],
    headerTemplate: [{
      type: ContentChild,
      args: ['header', {
        static: true
      }]
    }],
    bodyTemplate: [{
      type: ContentChild,
      args: ['body', {
        static: true
      }]
    }],
    backTemplate: [{
      type: HostBinding,
      args: ['class.has-back']
    }, {
      type: ContentChild,
      args: ['back', {
        static: true
      }]
    }]
  });
})();
class WgCardModule {
  static {
    this.ɵfac = function WgCardModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgCardModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgCardModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, WgIconModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgCardModule, [{
    type: NgModule,
    args: [{
      declarations: [WgCardComponent],
      imports: [CommonModule, WgIconModule],
      exports: [WgCardComponent]
    }]
  }], null, null);
})();
class WgBreadcrumbsComponent {
  constructor() {
    this.clickEvent = new EventEmitter();
  }
  clickLink(event, arg) {
    event.preventDefault();
    this.clickEvent.emit(arg);
  }
  static {
    this.ɵfac = function WgBreadcrumbsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgBreadcrumbsComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgBreadcrumbsComponent,
      selectors: [["wg-breadcrumbs"]],
      inputs: {
        items: "items"
      },
      outputs: {
        clickEvent: "clickEvent"
      },
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [[4, "ngIf"], [4, "ngFor", "ngForOf"], [3, "routerLink"], [3, "click"]],
      template: function WgBreadcrumbsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, WgBreadcrumbsComponent_ul_0_Template, 2, 1, "ul", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.items && ctx.items.length > 0);
        }
      },
      dependencies: [i1$2.NgForOf, i1$2.NgIf, i2$1.RouterLink, i1$1.TranslatePipe],
      styles: ["wg-breadcrumbs>ul{align-items:center;display:flex;list-style:none;margin-bottom:30px;padding-left:0}wg-breadcrumbs>ul>li{font-size:11px;font-size:.8461538462rem}wg-text-tabs+wg-breadcrumbs>ul{margin-top:-17px}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgBreadcrumbsComponent, [{
    type: Component,
    args: [{
      encapsulation: ViewEncapsulation.None,
      selector: 'wg-breadcrumbs',
      standalone: false,
      template: "<ul *ngIf=\"items && items.length > 0\">\n  <ng-container *ngFor=\"let item of items; index as index;\">\n    <li *ngIf=\"index > 0\">&nbsp;/&nbsp;</li>\n    <li>\n      <ng-container *ngIf=\"index < items.length - 1 && item.route\">\n        <a [routerLink]=\"item.route\">{{ item.label | translate }}</a>\n      </ng-container>\n      <ng-container *ngIf=\"index < items.length - 1 && !item.route && item.arg\">\n        <a (click)=\"clickLink($event, item.arg)\">{{ item.label | translate }}</a>\n      </ng-container>\n      <ng-container *ngIf=\"index >= items.length - 1 || !(item.route || item.arg) \">\n        {{ item.label | translate }}\n      </ng-container>\n    </li>\n  </ng-container>\n</ul>\n",
      styles: ["wg-breadcrumbs>ul{align-items:center;display:flex;list-style:none;margin-bottom:30px;padding-left:0}wg-breadcrumbs>ul>li{font-size:11px;font-size:.8461538462rem}wg-text-tabs+wg-breadcrumbs>ul{margin-top:-17px}\n"]
    }]
  }], null, {
    items: [{
      type: Input
    }],
    clickEvent: [{
      type: Output
    }]
  });
})();
class WgBreadcrumbsService {
  constructor() {
    this.breadcrumbMap = new Map();
  }
  add(breadcrumbId, breadcrumbItem, index) {
    if (!breadcrumbId || breadcrumbId.length <= 0) {
      return;
    }
    const breadcrumbItems = this.breadcrumbMap.get(breadcrumbId);
    if (!breadcrumbItems) {
      return;
    }
    if (index != null && breadcrumbItems.length > index) {
      breadcrumbItems.length = index;
    }
    breadcrumbItems.push(breadcrumbItem);
  }
  clear(breadcrumbId) {
    if (!breadcrumbId || breadcrumbId.length <= 0) {
      return;
    }
    if (this.breadcrumbMap.has(breadcrumbId)) {
      this.breadcrumbMap.get(breadcrumbId).length = 0;
    }
  }
  destroy(breadcrumbId) {
    if (!breadcrumbId || breadcrumbId.length <= 0) {
      return;
    }
    if (this.breadcrumbMap.has(breadcrumbId)) {
      this.breadcrumbMap.delete(breadcrumbId);
    }
  }
  get(breadcrumbId) {
    if (!breadcrumbId || breadcrumbId.length <= 0) {
      return null;
    }
    if (this.breadcrumbMap.has(breadcrumbId)) {
      return this.breadcrumbMap.get(breadcrumbId);
    }
    return null;
  }
  initialize(breadcrumbId, breadcrumbItems) {
    if (!breadcrumbId || breadcrumbId.length <= 0) {
      return null;
    }
    this.destroy(breadcrumbId);
    this.breadcrumbMap.set(breadcrumbId, breadcrumbItems ? breadcrumbItems : []);
    return this.get(breadcrumbId);
  }
  remove(breadcrumbId, numberToRemove = 1) {
    if (!breadcrumbId || breadcrumbId.length <= 0) {
      return;
    }
    const breadcrumbItems = this.breadcrumbMap.get(breadcrumbId);
    if (!breadcrumbItems) {
      return;
    }
    breadcrumbItems.splice(-numberToRemove, numberToRemove);
  }
  static {
    this.ɵfac = function WgBreadcrumbsService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgBreadcrumbsService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: WgBreadcrumbsService,
      factory: WgBreadcrumbsService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgBreadcrumbsService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
class WgBreadcrumbsModule {
  static forRoot() {
    return {
      ngModule: WgBreadcrumbsModule,
      providers: [WgBreadcrumbsService]
    };
  }
  static {
    this.ɵfac = function WgBreadcrumbsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgBreadcrumbsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgBreadcrumbsModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, RouterModule, TranslateModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgBreadcrumbsModule, [{
    type: NgModule,
    args: [{
      declarations: [WgBreadcrumbsComponent],
      imports: [CommonModule, RouterModule, TranslateModule],
      exports: [WgBreadcrumbsComponent]
    }]
  }], null, null);
})();
class WgFileUploadComponent {
  constructor() {
    this.isDisabled = false;
    this.width = '152.35px';
    this.fileRemoved = new EventEmitter();
    this.fileUploaded = new EventEmitter();
  }
  dragHandlers(event) {
    event.preventDefault();
  }
  registerOnChange(onChangeFunction) {
    this.onChange = onChangeFunction;
  }
  registerOnTouched(onTouchedFunction) {}
  writeValue(file) {
    this.fileUpload.files = file ? [file] : [];
  }
  setFile(file) {
    if (this.isDisabled) {
      return;
    }
    this.fileUpload.files = [file];
  }
  clearErrorMessages() {
    if (this.isDisabled) {
      return;
    }
    this.fileUpload.msgs = [];
    this.fileUpload.cd.markForCheck();
  }
  removeFile() {
    if (this.isDisabled) {
      return;
    }
    this.fileUpload.remove(null, 0);
    this.triggerFileRemoved();
  }
  selectFileByInput(event) {
    if (this.isDisabled) {
      return;
    }
    this.fileUpload.onDrop(event);
    this.fileInput.nativeElement.value = '';
  }
  onFileSelected(event) {
    if (this.isDisabled) {
      return;
    }
    const validations = this.fileUpload.msgs.map(message => message.severity);
    if (validations.includes('error')) {
      this.triggerFileRemoved();
      return;
    }
    this.fileUploaded.emit(event.files[0]);
    this.triggerOnChange(event.files[0]);
  }
  triggerFileRemoved() {
    this.fileRemoved.emit();
    this.triggerOnChange();
  }
  triggerOnChange(param = null) {
    if (this.onChange) {
      this.onChange(param);
    }
  }
  static {
    this.ɵfac = function WgFileUploadComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgFileUploadComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgFileUploadComponent,
      selectors: [["wg-file-upload"]],
      viewQuery: function WgFileUploadComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c7, 5);
          i0.ɵɵviewQuery(_c8, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fileInput = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fileUpload = _t.first);
        }
      },
      hostBindings: function WgFileUploadComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("dragover", function WgFileUploadComponent_dragover_HostBindingHandler($event) {
            return ctx.dragHandlers($event);
          }, false, i0.ɵɵresolveDocument)("drop", function WgFileUploadComponent_drop_HostBindingHandler($event) {
            return ctx.dragHandlers($event);
          }, false, i0.ɵɵresolveDocument);
        }
      },
      inputs: {
        accept: "accept",
        isDisabled: "isDisabled",
        width: "width"
      },
      outputs: {
        fileRemoved: "fileRemoved",
        fileUploaded: "fileUploaded"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        multi: true,
        useExisting: forwardRef(() => WgFileUploadComponent)
      }])],
      decls: 5,
      vars: 8,
      consts: [["uploader", ""], ["fileInput", ""], ["name", "selectedFile", "url", "/", "styleClass", "wg-custom-file-upload", 3, "onSelect", "invalidFileTypeMessageSummary", "invalidFileTypeMessageDetail", "accept", "disabled"], ["pTemplate", "content"], ["tabindex", "0", 1, "file-upload-card", 3, "keydown.enter", "keydown.space", "ngStyle"], [1, "drag-drop-div", "file-upload-drop-area"], [1, "icon-container"], [1, "ft-upload-file-icon", 3, "click"], ["id", "uploadConfigFile", "name", "cloud-upload"], [1, "ft-upload-file-link", 3, "click"], ["type", "file", 3, "change", "accept", "disabled"], [1, "file-upload-details"], ["aria-hidden", "true", 1, "remove-file", 3, "click"], ["name", "close"], [1, "file-info"], ["name", "file"], [3, "title"]],
      template: function WgFileUploadComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "p-fileUpload", 2, 0);
          i0.ɵɵpipe(2, "translate");
          i0.ɵɵpipe(3, "translate");
          i0.ɵɵlistener("onSelect", function WgFileUploadComponent_Template_p_fileUpload_onSelect_0_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onFileSelected($event));
          });
          i0.ɵɵtemplate(4, WgFileUploadComponent_ng_template_4_Template, 24, 24, "ng-template", 3);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("invalidFileTypeMessageSummary", i0.ɵɵpipeBind1(2, 4, "file_upload_unsupported_file_error_summary"))("invalidFileTypeMessageDetail", i0.ɵɵpipeBind1(3, 6, "file_upload_unsupported_file_error_detail"))("accept", ctx.accept)("disabled", ctx.isDisabled);
        }
      },
      dependencies: [i1$2.NgStyle, i2$2.FileUpload, i3.PrimeTemplate, WgIconComponent, i1$1.TranslatePipe],
      styles: [".disabled[_nghost-%COMP%]{cursor:not-allowed}.drag-drop-div[_ngcontent-%COMP%]{padding:0 10px 20px;background:#fff;border:1px solid rgba(0,0,0,.125);text-align:center;transition:border-color .4s ease}.drag-drop-div[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-bottom:0}.file-info[_ngcontent-%COMP%]{word-break:break-word}.file-upload-card[_ngcontent-%COMP%]{position:relative;overflow:hidden;height:100%}.file-upload-drop-area[_ngcontent-%COMP%]{width:100%;height:100%}.file-upload-details[_ngcontent-%COMP%]{text-align:center;transition:all .3s ease-in-out;opacity:0;background-color:#fff;height:50%;width:95%;margin:auto;position:absolute;left:4px}.file-upload-show-details[_ngcontent-%COMP%]   .file-upload-details[_ngcontent-%COMP%]{transform:translateY(-105%);opacity:1}.icon-container[_ngcontent-%COMP%]{font-size:50px}.remove-file[_ngcontent-%COMP%]{position:absolute;top:0;right:4px}  .p-message-wrapper>span>timescircleicon{display:none}  .p-message-detail+button.p-message-close{color:#367b88}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgFileUploadComponent, [{
    type: Component,
    args: [{
      selector: 'wg-file-upload',
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        multi: true,
        useExisting: forwardRef(() => WgFileUploadComponent)
      }],
      standalone: false,
      template: "<p-fileUpload\n  #uploader\n  name=\"selectedFile\"\n  url=\"/\"\n  styleClass=\"wg-custom-file-upload\"\n  [invalidFileTypeMessageSummary]=\"'file_upload_unsupported_file_error_summary' | translate\"\n  [invalidFileTypeMessageDetail]=\"'file_upload_unsupported_file_error_detail' | translate\"\n  [accept]=\"accept\"\n  [disabled]=\"isDisabled\"\n  (onSelect)=\"onFileSelected($event)\">\n  <ng-template pTemplate=\"content\">\n    <div\n      class=\"file-upload-card\"\n      tabindex=\"0\"\n      [ngStyle]=\"{ width: width }\"\n      [class.file-upload-show-details]=\"fileUpload.files[0]\"\n      (keydown.enter)=\"fileInput.click()\"\n      (keydown.space)=\"fileInput.click()\">\n      <div class=\"drag-drop-div file-upload-drop-area\">\n        <div class=\"icon-container\">\n          <a class=\"ft-upload-file-icon\" [class.disabled]=\"isDisabled\" (click)=\"fileInput.click()\">\n            <wg-icon id=\"uploadConfigFile\" name=\"cloud-upload\"></wg-icon>\n          </a>\n        </div>\n\n        <p>\n          {{ 'file_upload_drag_and_drop_file' | translate }}\n          <br>\n          {{ 'file_upload_or' | translate }}\n        </p>\n\n        <div>\n          <a class=\"ft-upload-file-link\" [class.disabled]=\"isDisabled\" (click)=\"fileInput.click()\">\n            {{ 'file_upload_select_file' | translate }}\n          </a>\n          <input\n            #fileInput\n            type=\"file\"\n            [accept]=\"accept\"\n            [style.display]=\"'none'\"\n            [disabled]=\"isDisabled\"\n            (change)=\"selectFileByInput($event)\"/>\n        </div>\n      </div>\n\n      <div class=\"file-upload-details\">\n        <a (click)=\"removeFile()\" class=\"remove-file\" aria-hidden=\"true\">\n          <wg-icon name=\"close\"></wg-icon>\n        </a>\n\n        <div class=\"file-info\">\n          <wg-icon name=\"file\"></wg-icon>\n          <p [title]=\"fileUpload.files[0]?.name\">\n            {{ fileUpload.files[0]?.name }}\n          </p>\n        </div>\n      </div>\n    </div>\n  </ng-template>\n</p-fileUpload>\n",
      styles: [":host(.disabled){cursor:not-allowed}.drag-drop-div{padding:0 10px 20px;background:#fff;border:1px solid rgba(0,0,0,.125);text-align:center;transition:border-color .4s ease}.drag-drop-div p{margin-bottom:0}.file-info{word-break:break-word}.file-upload-card{position:relative;overflow:hidden;height:100%}.file-upload-drop-area{width:100%;height:100%}.file-upload-details{text-align:center;transition:all .3s ease-in-out;opacity:0;background-color:#fff;height:50%;width:95%;margin:auto;position:absolute;left:4px}.file-upload-show-details .file-upload-details{transform:translateY(-105%);opacity:1}.icon-container{font-size:50px}.remove-file{position:absolute;top:0;right:4px}::ng-deep .p-message-wrapper>span>timescircleicon{display:none}::ng-deep .p-message-detail+button.p-message-close{color:#367b88}\n"]
    }]
  }], null, {
    accept: [{
      type: Input
    }],
    isDisabled: [{
      type: Input
    }],
    width: [{
      type: Input
    }],
    fileRemoved: [{
      type: Output
    }],
    fileUploaded: [{
      type: Output
    }],
    fileInput: [{
      type: ViewChild,
      args: ['fileInput']
    }],
    fileUpload: [{
      type: ViewChild,
      args: ['uploader', {
        static: true
      }]
    }],
    dragHandlers: [{
      type: HostListener,
      args: ['document:dragover', ['$event']]
    }, {
      type: HostListener,
      args: ['document:drop', ['$event']]
    }]
  });
})();
class WgFileUploadModule {
  static {
    this.ɵfac = function WgFileUploadModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgFileUploadModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgFileUploadModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FormsModule, FileUploadModule, TranslateModule, WgIconModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgFileUploadModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FormsModule, FileUploadModule, TranslateModule, WgIconModule],
      declarations: [WgFileUploadComponent],
      exports: [WgFileUploadComponent]
    }]
  }], null, null);
})();
class WgProgressComponent {
  constructor() {
    this.cssClassProgress = true;
    this.height = 13;
  }
  static {
    this.ɵfac = function WgProgressComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgProgressComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgProgressComponent,
      selectors: [["wg-progress"]],
      hostVars: 4,
      hostBindings: function WgProgressComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵstyleProp("height", ctx.height, "px");
          i0.ɵɵclassProp("progress", ctx.cssClassProgress);
        }
      },
      inputs: {
        height: "height"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function WgProgressComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{background-color:#d4d4d4;border-radius:0}.narrow[_nghost-%COMP%]{height:8px!important}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgProgressComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      selector: 'wg-progress',
      template: `<ng-content></ng-content>`,
      standalone: false,
      styles: [":host{background-color:#d4d4d4;border-radius:0}:host.narrow{height:8px!important}\n"]
    }]
  }], () => [], {
    cssClassProgress: [{
      type: HostBinding,
      args: ['class.progress']
    }],
    height: [{
      type: HostBinding,
      args: ['style.height.px']
    }, {
      type: Input
    }]
  });
})();
class WgProgressBarComponent {
  constructor() {
    this.attrRole = 'progressbar';
    this.classes = 'progress-bar background-robin-egg color-snow';
    this.classZeroWidth = false;
    this.value = 0;
    this.minimumValue = 0;
    this.maximumValue = 100;
    this.width = 0;
    this.striped = false;
    this.animated = false;
    this.barClicked = new EventEmitter();
  }
  // eslint-disable-next-line @angular-eslint/no-input-rename
  set backgroundColorAttribute(color) {
    const classList = this.classes.split(' ', 3);
    this.classes = classList[0] + ' background-' + color + ' ' + classList[2];
  }
  // eslint-disable-next-line @angular-eslint/no-input-rename
  set textColorAttribute(color) {
    const classList = this.classes.split(' ', 3);
    this.classes = classList[0] + ' ' + classList[1] + ' color-' + color;
  }
  clickout(event) {
    const eventObj = {
      value: this.value
    };
    if (this.progressbarItem) {
      eventObj.item = this.progressbarItem;
    }
    this.barClicked.emit(eventObj);
    event.stopPropagation();
  }
  ngOnChanges(changes) {
    if (this.minimumValue > this.maximumValue) {
      const min = this.minimumValue;
      const max = this.maximumValue;
      this.minimumValue = max;
      this.maximumValue = min;
    }
    if (changes.value.currentValue !== changes.value.previousValue) {
      this.width = (this.value - this.minimumValue) * 100 / (this.maximumValue - this.minimumValue);
    }
    this.classZeroWidth = this.width <= 0;
  }
  static {
    this.ɵfac = function WgProgressBarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgProgressBarComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgProgressBarComponent,
      selectors: [["wg-progress-bar"]],
      hostVars: 14,
      hostBindings: function WgProgressBarComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function WgProgressBarComponent_click_HostBindingHandler($event) {
            return ctx.clickout($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.attrRole)("aria-valuenow", ctx.value)("aria-valuemin", ctx.minimumValue)("aria-valuemax", ctx.maximumValue);
          i0.ɵɵclassMap(ctx.classes);
          i0.ɵɵstyleProp("width", ctx.width, "%");
          i0.ɵɵclassProp("zero-width", ctx.classZeroWidth)("progress-bar-striped", ctx.striped)("progress-bar-animated", ctx.animated);
        }
      },
      inputs: {
        value: "value",
        minimumValue: [0, "min", "minimumValue"],
        maximumValue: [0, "max", "maximumValue"],
        striped: "striped",
        animated: "animated",
        backgroundColorAttribute: [0, "backgroundColor", "backgroundColorAttribute"],
        textColorAttribute: [0, "textColor", "textColorAttribute"],
        progressbarItem: "progressbarItem"
      },
      outputs: {
        barClicked: "barClicked"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function WgProgressBarComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{border-left:1px solid #ffffff}.hits[_nghost-%COMP%]{background-color:#57c5d9}.deny[_nghost-%COMP%]{background-color:#cf0000}.bytes[_nghost-%COMP%]{background-color:#359db0}[_nghost-%COMP%]:first-child, .zero-width[_nghost-%COMP%]{border-left:0}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgProgressBarComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      selector: 'wg-progress-bar',
      template: `<ng-content></ng-content>`,
      standalone: false,
      styles: [":host{border-left:1px solid #ffffff}:host.hits{background-color:#57c5d9}:host.deny{background-color:#cf0000}:host.bytes{background-color:#359db0}:host:first-child,:host.zero-width{border-left:0}\n"]
    }]
  }], () => [], {
    attrRole: [{
      type: HostBinding,
      args: ['attr.role']
    }],
    classes: [{
      type: HostBinding,
      args: ['class']
    }],
    classZeroWidth: [{
      type: HostBinding,
      args: ['class.zero-width']
    }],
    value: [{
      type: HostBinding,
      args: ['attr.aria-valuenow']
    }, {
      type: Input
    }],
    minimumValue: [{
      type: HostBinding,
      args: ['attr.aria-valuemin']
    }, {
      type: Input,
      args: ['min']
    }],
    maximumValue: [{
      type: HostBinding,
      args: ['attr.aria-valuemax']
    }, {
      type: Input,
      args: ['max']
    }],
    width: [{
      type: HostBinding,
      args: ['style.width.%']
    }],
    striped: [{
      type: HostBinding,
      args: ['class.progress-bar-striped']
    }, {
      type: Input
    }],
    animated: [{
      type: HostBinding,
      args: ['class.progress-bar-animated']
    }, {
      type: Input
    }],
    backgroundColorAttribute: [{
      type: Input,
      args: ['backgroundColor']
    }],
    textColorAttribute: [{
      type: Input,
      args: ['textColor']
    }],
    progressbarItem: [{
      type: Input,
      args: ['progressbarItem']
    }],
    barClicked: [{
      type: Output
    }],
    clickout: [{
      type: HostListener,
      args: ['click', ['$event']]
    }]
  });
})();
class WgProgressModule {
  static {
    this.ɵfac = function WgProgressModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgProgressModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgProgressModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgProgressModule, [{
    type: NgModule,
    args: [{
      declarations: [WgProgressComponent, WgProgressBarComponent],
      imports: [CommonModule],
      exports: [WgProgressComponent, WgProgressBarComponent]
    }]
  }], null, null);
})();

/**
 * @license
 * Copyright WatchGuard Technologies Inc. All Rights Reserved.
 *
 * This service provides a way for the wg-refresh to trigger a refresh to a component
 * not in the same component as the wg-refresh
 */
class WgRefreshService {
  constructor() {
    this.refreshTriggeredSubject = new Subject();
    this.refreshTriggeredObservable = this.refreshTriggeredSubject.asObservable();
  }
  refreshTriggered(refreshName) {
    this.refreshTriggeredSubject.next(refreshName);
  }
  static {
    this.ɵfac = function WgRefreshService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgRefreshService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: WgRefreshService,
      factory: WgRefreshService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgRefreshService, [{
    type: Injectable
  }], null, null);
})();

/**
 * @license
 * Copyright WatchGuard Technologies Inc. All Rights Reserved.
 *
 * This library provides a refresh button to give the users an impression
 * of data being loaded from backend.
 */
class WgRefreshComponent {
  constructor(wgRefreshService) {
    this.wgRefreshService = wgRefreshService;
    this.isDisabled = false;
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    this.onRefresh = new EventEmitter();
  }
  refresh(event) {
    if (this.isDisabled) {
      return;
    }
    event.preventDefault();
    this.onRefresh.emit();
    this.wgRefreshService.refreshTriggered(this.name);
  }
  static {
    this.ɵfac = function WgRefreshComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgRefreshComponent)(i0.ɵɵdirectiveInject(WgRefreshService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgRefreshComponent,
      selectors: [["wg-refresh"]],
      inputs: {
        refreshing: "refreshing",
        name: "name",
        isDisabled: "isDisabled"
      },
      outputs: {
        onRefresh: "onRefresh"
      },
      standalone: false,
      decls: 3,
      vars: 4,
      consts: [["title", "Refresh", 1, "refresh", 3, "click", "ngClass"], ["name", "refresh"], [3, "scale", "modal", 4, "ngIf"], [3, "scale", "modal"]],
      template: function WgRefreshComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "a", 0);
          i0.ɵɵlistener("click", function WgRefreshComponent_Template_a_click_0_listener($event) {
            return ctx.refresh($event);
          });
          i0.ɵɵelement(1, "wg-icon", 1);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(2, WgRefreshComponent_wg_loader_2_Template, 1, 2, "wg-loader", 2);
        }
        if (rf & 2) {
          i0.ɵɵclassProp("refreshing", ctx.refreshing);
          i0.ɵɵproperty("ngClass", ctx.isDisabled ? "color-watchguard-gray" : "");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.refreshing);
        }
      },
      dependencies: [i1$2.NgClass, i1$2.NgIf, LoaderComponent, WgIconComponent],
      styles: ["wg-refresh{vertical-align:middle}wg-refresh .refresh{cursor:pointer;margin-left:18px}wg-refresh .refresh wg-icon{height:18px;line-height:0;width:18px}wg-refresh .refresh wg-icon svg,wg-refresh .refresh wg-icon svg path,wg-refresh .refresh wg-icon svg circle{fill:#367b88;stroke:transparent}wg-refresh .refresh wg-icon svg{height:18px;min-height:18px;min-width:18px;width:18px}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgRefreshComponent, [{
    type: Component,
    args: [{
      encapsulation: ViewEncapsulation.None,
      selector: 'wg-refresh',
      standalone: false,
      template: "<a class=\"refresh\"\n     title=\"Refresh\"\n     [class.refreshing]=\"refreshing\"\n     [ngClass]=\"isDisabled ? 'color-watchguard-gray' : ''\"\n     (click)=\"refresh($event)\">\n  <wg-icon name=\"refresh\"></wg-icon>\n</a>\n\n<wg-loader *ngIf=\"refreshing\" [scale]=\"2\" [modal]=\"true\"></wg-loader>",
      styles: ["wg-refresh{vertical-align:middle}wg-refresh .refresh{cursor:pointer;margin-left:18px}wg-refresh .refresh wg-icon{height:18px;line-height:0;width:18px}wg-refresh .refresh wg-icon svg,wg-refresh .refresh wg-icon svg path,wg-refresh .refresh wg-icon svg circle{fill:#367b88;stroke:transparent}wg-refresh .refresh wg-icon svg{height:18px;min-height:18px;min-width:18px;width:18px}\n"]
    }]
  }], () => [{
    type: WgRefreshService
  }], {
    refreshing: [{
      type: Input
    }],
    name: [{
      type: Input
    }],
    isDisabled: [{
      type: Input
    }],
    onRefresh: [{
      type: Output
    }]
  });
})();
class WgRefreshModule {
  static {
    this.ɵfac = function WgRefreshModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgRefreshModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgRefreshModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [WgRefreshService],
      imports: [CommonModule, LoaderModule, WgIconModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgRefreshModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, LoaderModule, WgIconModule],
      declarations: [WgRefreshComponent],
      providers: [WgRefreshService],
      exports: [WgRefreshComponent]
    }]
  }], null, null);
})();
class WgSelectButtonComponent {
  constructor() {
    this.optionsChange = new EventEmitter();
    this.optionSelect = new EventEmitter();
    this.optionClick = new EventEmitter();
  }
  onButtonClick(optionSelected) {
    if (optionSelected.disabled) {
      return;
    }
    optionSelected.selected = !optionSelected.selected;
    const selectedValues = this.options.filter(option => option.selected);
    this.optionSelect.emit(selectedValues);
    this.optionsChange.emit(this.options);
    this.optionClick.emit(optionSelected);
  }
  static {
    this.ɵfac = function WgSelectButtonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgSelectButtonComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgSelectButtonComponent,
      selectors: [["wg-select-button"]],
      inputs: {
        options: "options"
      },
      outputs: {
        optionsChange: "optionsChange",
        optionSelect: "optionSelect",
        optionClick: "optionClick"
      },
      standalone: false,
      decls: 3,
      vars: 1,
      consts: [[1, "btn-select"], [1, "btn-group", "btn-group-toggle"], ["class", "btn btn-secondary btn-sm", 3, "title", "active", "disabled", "class", 4, "ngFor", "ngForOf"], [1, "btn", "btn-secondary", "btn-sm", 3, "title"], ["type", "checkbox", "checked", "true", 3, "click", "title", "disabled"], [3, "name", 4, "ngIf"], [4, "ngIf"], [3, "name"]],
      template: function WgSelectButtonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
          i0.ɵɵtemplate(2, WgSelectButtonComponent_label_2_Template, 6, 15, "label", 2);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.options);
        }
      },
      dependencies: [i1$2.NgForOf, i1$2.NgIf, WgIconComponent, i1$1.TranslatePipe],
      styles: ["wg-select-button .btn-select .btn.btn-secondary,wg-select-button .btn-select .btn.btn-secondary:not([disabled]):not(.disabled){align-items:center;display:flex;max-width:100px;overflow:hidden}wg-select-button .btn-select .btn.btn-secondary>wg-icon,wg-select-button .btn-select .btn.btn-secondary:not([disabled]):not(.disabled)>wg-icon{height:16px;line-height:0;width:16px}wg-select-button .btn-select .btn.btn-secondary>wg-icon svg,wg-select-button .btn-select .btn.btn-secondary:not([disabled]):not(.disabled)>wg-icon svg{height:16px;min-height:16px;min-width:16px;width:16px}wg-select-button .btn-select .btn.btn-secondary>span,wg-select-button .btn-select .btn.btn-secondary:not([disabled]):not(.disabled)>span{flex-grow:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}wg-select-button .btn-select .btn.btn-secondary>wg-icon+span,wg-select-button .btn-select .btn.btn-secondary:not([disabled]):not(.disabled)>wg-icon+span{margin-left:5px}wg-select-button .btn-select .btn.btn-secondary.active,wg-select-button .btn-select .btn.btn-secondary:not([disabled]):not(.disabled).active{background-color:#359db0;color:#fff}wg-select-button .btn-select .btn.btn-secondary.active wg-icon svg,wg-select-button .btn-select .btn.btn-secondary.active wg-icon svg path,wg-select-button .btn-select .btn.btn-secondary.active wg-icon svg circle,wg-select-button .btn-select .btn.btn-secondary:not([disabled]):not(.disabled).active wg-icon svg,wg-select-button .btn-select .btn.btn-secondary:not([disabled]):not(.disabled).active wg-icon svg path,wg-select-button .btn-select .btn.btn-secondary:not([disabled]):not(.disabled).active wg-icon svg circle{fill:#fff;stroke:transparent}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgSelectButtonComponent, [{
    type: Component,
    args: [{
      encapsulation: ViewEncapsulation.None,
      selector: 'wg-select-button',
      standalone: false,
      template: "<div class=\"btn-select\">\n  <div class=\"btn-group btn-group-toggle\">\n    <label [title]=\"(option.tooltip || option.text || '') | translate\" class=\"btn btn-secondary btn-sm\" *ngFor=\"let option of options\"\n        [class.active]=\"option.selected\" [class.disabled]=\"option.disabled\" [class]=\"option.cssClass\">\n      <input type=\"checkbox\" checked='true' [title]=\"(option.tooltip || option.text || '') | translate\" [disabled]=\"option.disabled\"\n          (click)=\"onButtonClick(option)\">\n      <wg-icon [name]=\"option.icon\" *ngIf=\"option.icon\"></wg-icon>\n      <span *ngIf=\"option.text\">{{option.text | translate}}</span>\n    </label>\n  </div>\n</div>\n",
      styles: ["wg-select-button .btn-select .btn.btn-secondary,wg-select-button .btn-select .btn.btn-secondary:not([disabled]):not(.disabled){align-items:center;display:flex;max-width:100px;overflow:hidden}wg-select-button .btn-select .btn.btn-secondary>wg-icon,wg-select-button .btn-select .btn.btn-secondary:not([disabled]):not(.disabled)>wg-icon{height:16px;line-height:0;width:16px}wg-select-button .btn-select .btn.btn-secondary>wg-icon svg,wg-select-button .btn-select .btn.btn-secondary:not([disabled]):not(.disabled)>wg-icon svg{height:16px;min-height:16px;min-width:16px;width:16px}wg-select-button .btn-select .btn.btn-secondary>span,wg-select-button .btn-select .btn.btn-secondary:not([disabled]):not(.disabled)>span{flex-grow:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}wg-select-button .btn-select .btn.btn-secondary>wg-icon+span,wg-select-button .btn-select .btn.btn-secondary:not([disabled]):not(.disabled)>wg-icon+span{margin-left:5px}wg-select-button .btn-select .btn.btn-secondary.active,wg-select-button .btn-select .btn.btn-secondary:not([disabled]):not(.disabled).active{background-color:#359db0;color:#fff}wg-select-button .btn-select .btn.btn-secondary.active wg-icon svg,wg-select-button .btn-select .btn.btn-secondary.active wg-icon svg path,wg-select-button .btn-select .btn.btn-secondary.active wg-icon svg circle,wg-select-button .btn-select .btn.btn-secondary:not([disabled]):not(.disabled).active wg-icon svg,wg-select-button .btn-select .btn.btn-secondary:not([disabled]):not(.disabled).active wg-icon svg path,wg-select-button .btn-select .btn.btn-secondary:not([disabled]):not(.disabled).active wg-icon svg circle{fill:#fff;stroke:transparent}\n"]
    }]
  }], null, {
    options: [{
      type: Input
    }],
    optionsChange: [{
      type: Output
    }],
    optionSelect: [{
      type: Output
    }],
    optionClick: [{
      type: Output
    }]
  });
})();
class WgSelectButtonModule {
  static {
    this.ɵfac = function WgSelectButtonModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgSelectButtonModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgSelectButtonModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FormsModule, TranslateModule, ButtonModule, SelectButtonModule, WgIconModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgSelectButtonModule, [{
    type: NgModule,
    args: [{
      declarations: [WgSelectButtonComponent],
      imports: [CommonModule, FormsModule, TranslateModule, ButtonModule, SelectButtonModule, WgIconModule],
      exports: [WgSelectButtonComponent]
    }]
  }], null, null);
})();

/**
 * @deprecated use wg-panel with collapsible=true instead
 */
class WgExpanderComponent {
  constructor() {
    this.expandable = true;
    this.expandedChange = new EventEmitter();
  }
  ngOnChanges(changes) {
    if (this.expandable === false && this.expanded === undefined) {
      this.expanded = false;
      this.expandedChange.emit(this.expanded);
    }
  }
  toggleContent(event, expanded) {
    if (this.expandable === false) {
      return;
    }
    if (expanded !== undefined) {
      this.expanded = expanded;
    } else {
      this.expanded = !this.expanded;
    }
    this.expandedChange.emit(this.expanded);
  }
  static {
    this.ɵfac = function WgExpanderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgExpanderComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgExpanderComponent,
      selectors: [["wg-expander"]],
      hostVars: 8,
      hostBindings: function WgExpanderComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("expandable", ctx.expandable)("expanded", ctx.expanded)("simple-header", ctx.useSimpleHeader)("left-toggle", ctx.useLeftToggle);
        }
      },
      inputs: {
        expandable: "expandable",
        expanded: "expanded",
        useSimpleHeader: "useSimpleHeader",
        useLeftToggle: "useLeftToggle"
      },
      outputs: {
        expandedChange: "expandedChange"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c11,
      decls: 6,
      vars: 0,
      consts: [[3, "click"], ["href", "", 3, "click"], ["name", "expanded"]],
      template: function WgExpanderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c10);
          i0.ɵɵelementStart(0, "header", 0);
          i0.ɵɵlistener("click", function WgExpanderComponent_Template_header_click_0_listener($event) {
            return ctx.toggleContent($event);
          });
          i0.ɵɵprojection(1);
          i0.ɵɵelementStart(2, "a", 1);
          i0.ɵɵlistener("click", function WgExpanderComponent_Template_a_click_2_listener($event) {
            return $event.preventDefault();
          });
          i0.ɵɵelement(3, "wg-icon", 2);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(4, "section");
          i0.ɵɵprojection(5, 1);
          i0.ɵɵelementEnd();
        }
      },
      dependencies: [WgIconComponent],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgExpanderComponent, [{
    type: Component,
    args: [{
      selector: 'wg-expander',
      standalone: false,
      template: "<header (click)=\"toggleContent($event)\">\n  <ng-content select=\".header\"></ng-content>\n  <a href=\"\" (click)=\"$event.preventDefault()\"><wg-icon name=\"expanded\"></wg-icon></a>\n</header>\n<section>\n  <ng-content select=\".content\"></ng-content>\n</section>"
    }]
  }], () => [], {
    expandable: [{
      type: HostBinding,
      args: ['class.expandable']
    }, {
      type: Input
    }],
    expanded: [{
      type: HostBinding,
      args: ['class.expanded']
    }, {
      type: Input
    }],
    useSimpleHeader: [{
      type: HostBinding,
      args: ['class.simple-header']
    }, {
      type: Input
    }],
    useLeftToggle: [{
      type: HostBinding,
      args: ['class.left-toggle']
    }, {
      type: Input
    }],
    expandedChange: [{
      type: Output
    }]
  });
})();

/**
 * @deprecated use wg-panel with collapsible=true instead
 */
class WgExpanderModule {
  static {
    this.ɵfac = function WgExpanderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgExpanderModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgExpanderModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, WgIconModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgExpanderModule, [{
    type: NgModule,
    args: [{
      declarations: [WgExpanderComponent],
      imports: [CommonModule, WgIconModule],
      exports: [WgExpanderComponent]
    }]
  }], null, null);
})();

/**
 * @license
 * Copyright WatchGuard Technologies Inc. All Rights Reserved.
 *
 * This library adds a popup dilaog component. It extends primeng's
 * p-dialog component.
 * The component takes in 'showDialog' as input, if true, dialog is shown else hidden.
 * It emits a 'dialogClosedEvent' so that caller can do the necessary
 * cleanup.
 *
 */
class WgDialogComponent {
  constructor(elementRef) {
    this.elementRef = elementRef;
    this.showDialogChange = new EventEmitter();
    this.hideClickOutside = false;
    // it looks like primeng is added focusOnShow in a new version but it doesn't seem to be available in npm yet
    // so for now we'll use the show callback to blur the focused button
    this.focusOnShow = false;
    this.closableFromHeader = true;
    /**
     * Dialog closed (finished disappearing)
     */
    this.dialogClosedEvent = new EventEmitter();
    this.styleClass = '';
    this.dialogWidth = 600;
  }
  ngOnInit() {
    if (this.elementRef && this.elementRef.nativeElement && this.elementRef.nativeElement.classList) {
      const element = this.elementRef.nativeElement;
      element.classList.forEach(classList => {
        this.styleClass += (this.styleClass === '' ? '' : ' ') + classList;
      });
      if (!this.closableFromHeader) {
        this.styleClass += ' disable-close-btn';
      }
    }
  }
  /**
   * Binds the p-dialog `visible` value to this component's
   * `showDialog` input/output.
   */
  updateShowDialog(value) {
    this.showDialog = value;
    this.showDialogChange.emit(this.showDialog);
  }
  dialogClosed() {
    this.dialogClosedEvent.emit();
  }
  focusElement() {
    const elementToBeFocused = this.elementRef.nativeElement.querySelector('[autofocus]');
    if (elementToBeFocused && elementToBeFocused.focus) {
      setTimeout(() => {
        elementToBeFocused.focus();
      });
    }
  }
  static {
    this.ɵfac = function WgDialogComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgDialogComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgDialogComponent,
      selectors: [["wg-dialog"]],
      inputs: {
        showDialog: "showDialog",
        hideClickOutside: "hideClickOutside",
        focusOnShow: "focusOnShow",
        closableFromHeader: "closableFromHeader"
      },
      outputs: {
        showDialogChange: "showDialogChange",
        dialogClosedEvent: "dialogClosedEvent"
      },
      standalone: false,
      ngContentSelectors: _c13,
      decls: 6,
      vars: 7,
      consts: [["header", ""], ["footer", ""], ["appendTo", "body", "showEffect", "fade", 3, "visibleChange", "onShow", "onHide", "visible", "styleClass", "resizable", "focusOnShow", "modal", "draggable", "dismissableMask"]],
      template: function WgDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵprojectionDef(_c12);
          i0.ɵɵelementStart(0, "p-dialog", 2);
          i0.ɵɵlistener("visibleChange", function WgDialogComponent_Template_p_dialog_visibleChange_0_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.updateShowDialog($event));
          })("onShow", function WgDialogComponent_Template_p_dialog_onShow_0_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.focusElement());
          })("onHide", function WgDialogComponent_Template_p_dialog_onHide_0_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.dialogClosed());
          });
          i0.ɵɵtemplate(1, WgDialogComponent_ng_template_1_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵprojection(3);
          i0.ɵɵtemplate(4, WgDialogComponent_ng_template_4_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("visible", ctx.showDialog)("styleClass", ctx.styleClass)("resizable", false)("focusOnShow", ctx.focusOnShow)("modal", true)("draggable", false)("dismissableMask", ctx.hideClickOutside);
        }
      },
      dependencies: [i1$5.Dialog],
      styles: [".p-dialog-mask{--p-dialog-background: var(--color-surface-surface-01);--p-dialog-border-color: var(--color-control-border);--p-dialog-border-radius: var(--radius-md);--p-dialog-color: var(--color-surface-on-surface);--p-dialog-shadow: 0 6px 10px rgba(0, 0, 0, .16), 0 3px 5px rgba(0, 0, 0, .2), 0 1px 12px rgba(0, 0, 0, .18);--p-mask-background: rgba(0, 0, 0, .3)}.p-dialog-header div{color:var(--color-surface-on-surface-soft);font:var(--font-standard-lg)}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgDialogComponent, [{
    type: Component,
    args: [{
      encapsulation: ViewEncapsulation.None,
      selector: 'wg-dialog',
      standalone: false,
      template: "<p-dialog\n  appendTo=\"body\"\n  [visible]=\"showDialog\"\n  (visibleChange)=\"updateShowDialog($event)\"\n  [styleClass]=\"styleClass\"\n  [resizable]=\"false\"\n  [focusOnShow]=\"focusOnShow\"\n  showEffect=\"fade\"\n  [modal]=\"true\"\n  [draggable]=\"false\"\n  (onShow)=\"focusElement()\"\n  [dismissableMask]=\"hideClickOutside\"\n  (onHide)=\"dialogClosed()\">\n  <ng-template #header>\n    <ng-content select=\"[dialog-title]\"></ng-content>\n  </ng-template>\n  <ng-content select=\"[dialog-content]\"></ng-content>\n  <ng-template #footer>\n    <ng-content select=\"[dialog-footer]\"></ng-content>\n  </ng-template>\n</p-dialog>",
      styles: [".p-dialog-mask{--p-dialog-background: var(--color-surface-surface-01);--p-dialog-border-color: var(--color-control-border);--p-dialog-border-radius: var(--radius-md);--p-dialog-color: var(--color-surface-on-surface);--p-dialog-shadow: 0 6px 10px rgba(0, 0, 0, .16), 0 3px 5px rgba(0, 0, 0, .2), 0 1px 12px rgba(0, 0, 0, .18);--p-mask-background: rgba(0, 0, 0, .3)}.p-dialog-header div{color:var(--color-surface-on-surface-soft);font:var(--font-standard-lg)}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    showDialog: [{
      type: Input
    }],
    showDialogChange: [{
      type: Output
    }],
    hideClickOutside: [{
      type: Input
    }],
    focusOnShow: [{
      type: Input
    }],
    closableFromHeader: [{
      type: Input
    }],
    dialogClosedEvent: [{
      type: Output
    }]
  });
})();
class WgDialogNavButtonsDirective {
  ngOnDestroy() {
    this.unListeners.forEach(x => x()); // click listeners
  }
  constructor(wgDlg, elementRef, renderer) {
    this.wgDlg = wgDlg;
    this.elementRef = elementRef;
    this.renderer = renderer;
    this.arrowClicked = new EventEmitter();
    this.margin = 10;
    this.buttonWidth = 50;
    this.dialogWidth = 500; //500px; default 'wg-dialog-md'
    this.unListeners = [];
  }
  ngOnChanges(changes) {
    if (this.leftArrow) {
      const leftDisplay = this.showDialog && !this.hideLeftArrow ? 'visible' : 'hidden';
      this.renderer.setStyle(this.leftArrow, 'visibility', leftDisplay);
    }
    if (this.rightArrow) {
      const rightDisplay = this.showDialog && !this.hideRightArrow ? 'visible' : 'hidden';
      this.renderer.setStyle(this.rightArrow, 'visibility', rightDisplay);
    }
  }
  ngAfterViewInit() {
    if (this.wgDlg?.styleClass?.includes('wg-dialog-xs')) {
      //320px;
      this.dialogWidth = 320;
    } else if (this.wgDlg?.styleClass?.includes('wg-dialog-sm')) {
      //420px;
      this.dialogWidth = 420;
    } else if (this.wgDlg?.styleClass?.includes('wg-dialog-lg')) {
      //680px;
      this.dialogWidth = 680;
    } else {
      //500px; default
      this.dialogWidth = 500;
    }
    this.leftArrow = this.createArrow('left');
    this.rightArrow = this.createArrow('right');
    const container = this.elementRef.nativeElement;
    this.renderer.appendChild(container, this.leftArrow);
    this.renderer.appendChild(container, this.rightArrow);
  }
  createArrow(direction) {
    const showArrow = this.showDialog ? direction === 'left' ? !this.hideLeftArrow : !this.hideRightArrow : false;
    const div = this.renderer.createElement('div');
    div.style.position = 'fixed';
    div.style.backgroundColor = 'black';
    div.style.zIndex = 11003;
    div.style.display = 'flex';
    div.style.visibility = showArrow ? 'visible' : 'hidden';
    div.style.outline = 'none';
    div.style.padding = '0px';
    div.style.top = '50%';
    div.style.left = '50%';
    div.style.width = '50px';
    div.style.height = '100px';
    div.style.textAlign = 'center';
    div.style.opacity = '0.25';
    div.style.fontSize = '2.5rem';
    div.style.cursor = 'pointer';
    div.style.alignItems = 'center';
    div.style.justifyContent = 'center';
    const trans = direction === 'left' ? (this.dialogWidth / 2 + this.buttonWidth + this.margin) * -1 : this.dialogWidth / 2 + this.margin;
    div.style.transform = `translate(${trans}px, -50px)`;
    const unListenerFn = this.renderer.listen(div, 'click', event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.arrowClicked.emit(direction);
    });
    this.unListeners.push(unListenerFn);
    const span = this.renderer.createElement('span');
    span.style.color = 'white';
    span.classList.add(`wg-icon-angle-${direction}-line`);
    this.renderer.appendChild(div, span);
    return div;
  }
  handleKeyboardEvent(event) {
    if (event.key === 'ArrowLeft') {
      this.arrowClicked.emit('left');
    } else if (event.key === 'ArrowRight') {
      this.arrowClicked.emit('right');
    }
  }
  static {
    this.ɵfac = function WgDialogNavButtonsDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgDialogNavButtonsDirective)(i0.ɵɵdirectiveInject(WgDialogComponent), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: WgDialogNavButtonsDirective,
      selectors: [["wg-dialog", "wgDlgNavButtons", ""]],
      hostBindings: function WgDialogNavButtonsDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown", function WgDialogNavButtonsDirective_keydown_HostBindingHandler($event) {
            return ctx.handleKeyboardEvent($event);
          }, false, i0.ɵɵresolveDocument);
        }
      },
      inputs: {
        hideLeftArrow: "hideLeftArrow",
        hideRightArrow: "hideRightArrow",
        showDialog: "showDialog"
      },
      outputs: {
        arrowClicked: "arrowClicked"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgDialogNavButtonsDirective, [{
    type: Directive,
    args: [{
      selector: "wg-dialog[wgDlgNavButtons]",
      standalone: false
    }]
  }], () => [{
    type: WgDialogComponent
  }, {
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }], {
    arrowClicked: [{
      type: Output
    }],
    hideLeftArrow: [{
      type: Input
    }],
    hideRightArrow: [{
      type: Input
    }],
    showDialog: [{
      type: Input
    }],
    handleKeyboardEvent: [{
      type: HostListener,
      args: ['document:keydown', ['$event']]
    }]
  });
})();
class WgDialogModule {
  static {
    this.ɵfac = function WgDialogModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgDialogModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgDialogModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, DialogModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgDialogModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, DialogModule],
      declarations: [WgDialogComponent, WgDialogNavButtonsDirective],
      exports: [WgDialogComponent, WgDialogNavButtonsDirective]
    }]
  }], null, null);
})();

/**
 * @license
 * Copyright WatchGuard Technologies Inc. All Rights Reserved.
 *
 * This component is a confirmation dialog that extends wg-dialog. By default,
 * the title and content are empty and uses 'Yes'/'No' buttons.
 *
 * The caller is responsible for hiding the dialog in response to cancel
 * and confirm actions.
 *
 * @Input showDialog:boolean Hide or show the dialog
 * @Input title:string The title of the dialog; default ''
 * @Input content:string|Array<string> The content of the dialog; default ''
 * @Input confirmBtnStr:string The label for the 'confirm' button; default 'Yes'
 * @Input cancelBtnStr:string The label for the 'cancel' button; default 'No'
 * @Output dialogCancelled:event Called when the dialog is 'cancelled' or closed
 * @Output dialogConfirmed:event Called when the dialog is confirmed
 *
 * Note: The title, content and button strings are translated by wg-confirm-dialog.
 *
 * Example using html:
 *  <wg-confirm-dialog
 *   [showDialog]="confirmDialogVisible"
 *   [title]="my_title_str"
 *   [content]="my_content_msg"
 *   (dialogCancelled)="confirmDialogVisible=false"
 *   (dialogConfirmed)="myDialogConfirmed()">
 *  </wg-confirm-dialog>
 *
 * All of the values can be set in typsecript code when showing the dialog,
 * so that a single html <wg-confirm-dialog> can be used for multiple purposes.
 * Example of multi-use confirm dialog configured via typescript:
 *  See wg-device-config's NetworkBlockingComponent.promptConfirmDialog()
 *
 */
class WgConfirmDialogComponent {
  constructor() {
    this.showDialogChange = new EventEmitter();
    this.confirmBtnClass = 'primary';
    /**
     * 'denied': "No" button was clicked (no auto-close)
     * 'closed': Dialog closed (finished disappearing)
     */
    this.dialogCancelled = new EventEmitter();
    /**
     * "Yes" button was clicked (no auto-close)
     */
    this.dialogConfirmed = new EventEmitter();
  }
  /**
   * Binds the wg-dialog `showDialog` value to this component's
   * `showDialog` input/output.
   */
  updateShowDialog(value) {
    this.showDialog = value;
    this.showDialogChange.emit(this.showDialog);
  }
  multipleContents() {
    return this.content instanceof Array;
  }
  dialogClosed() {
    this.dialogCancelled.emit('closed');
  }
  dialogDeny() {
    this.dialogCancelled.emit('denied');
  }
  dialogConfirm() {
    this.dialogConfirmed.emit();
  }
  static {
    this.ɵfac = function WgConfirmDialogComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgConfirmDialogComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgConfirmDialogComponent,
      selectors: [["wg-confirm-dialog"]],
      inputs: {
        showDialog: "showDialog",
        title: "title",
        content: "content",
        confirmBtnStr: "confirmBtnStr",
        confirmBtnClass: "confirmBtnClass",
        cancelBtnStr: "cancelBtnStr"
      },
      outputs: {
        showDialogChange: "showDialogChange",
        dialogCancelled: "dialogCancelled",
        dialogConfirmed: "dialogConfirmed"
      },
      standalone: false,
      decls: 18,
      vars: 17,
      consts: [["singleContent", ""], [3, "showDialogChange", "dialogClosedEvent", "showDialog"], ["dialog-title", ""], ["dialog-content", ""], [4, "ngIf", "ngIfElse"], ["dialog-footer", ""], [1, "ui-dialog-buttonpane", "ui-widget-content", "ui-helper-clearfix"], ["type", "button", 1, "btn", 3, "click"], ["type", "button", 1, "btn", 3, "click", "ngClass"], [3, "innerHTML", 4, "ngFor", "ngForOf"], [3, "innerHTML"]],
      template: function WgConfirmDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "wg-dialog", 1);
          i0.ɵɵlistener("showDialogChange", function WgConfirmDialogComponent_Template_wg_dialog_showDialogChange_0_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.updateShowDialog($event));
          })("dialogClosedEvent", function WgConfirmDialogComponent_Template_wg_dialog_dialogClosedEvent_0_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.dialogClosed());
          });
          i0.ɵɵelementStart(1, "div", 2);
          i0.ɵɵtext(2);
          i0.ɵɵpipe(3, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "div", 3);
          i0.ɵɵtemplate(5, WgConfirmDialogComponent_ng_container_5_Template, 2, 1, "ng-container", 4)(6, WgConfirmDialogComponent_ng_template_6_Template, 2, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(8, "div", 5)(9, "div", 6)(10, "button", 7);
          i0.ɵɵlistener("click", function WgConfirmDialogComponent_Template_button_click_10_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.dialogDeny());
          });
          i0.ɵɵtext(11);
          i0.ɵɵpipe(12, "translate");
          i0.ɵɵpipe(13, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(14, "button", 8);
          i0.ɵɵlistener("click", function WgConfirmDialogComponent_Template_button_click_14_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.dialogConfirm());
          });
          i0.ɵɵtext(15);
          i0.ɵɵpipe(16, "translate");
          i0.ɵɵpipe(17, "translate");
          i0.ɵɵelementEnd()()()();
        }
        if (rf & 2) {
          const singleContent_r4 = i0.ɵɵreference(7);
          i0.ɵɵproperty("showDialog", ctx.showDialog);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 7, ctx.title), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.multipleContents())("ngIfElse", singleContent_r4);
          i0.ɵɵadvance(6);
          i0.ɵɵtextInterpolate1(" ", !ctx.cancelBtnStr ? i0.ɵɵpipeBind1(12, 9, "ui_common_label_no") : i0.ɵɵpipeBind1(13, 11, ctx.cancelBtnStr), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngClass", "btn-" + ctx.confirmBtnClass);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", !ctx.confirmBtnStr ? i0.ɵɵpipeBind1(16, 13, "ui_common_label_yes") : i0.ɵɵpipeBind1(17, 15, ctx.confirmBtnStr), " ");
        }
      },
      dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, WgDialogComponent, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgConfirmDialogComponent, [{
    type: Component,
    args: [{
      selector: 'wg-confirm-dialog',
      standalone: false,
      template: "<wg-dialog\n  [showDialog]=\"showDialog\"\n  (showDialogChange)=\"updateShowDialog($event)\"\n  (dialogClosedEvent)=\"dialogClosed()\">\n  <div dialog-title>\n    {{ title | translate }}\n  </div>\n  <div dialog-content>\n    <ng-container *ngIf=\"multipleContents(); else singleContent\">\n      <p *ngFor=\"let c of content\" [innerHTML]=\"c | translate\"></p>\n    </ng-container>\n    <ng-template #singleContent>\n      <p [innerHTML]=\"content.toString() | translate\"></p>\n    </ng-template>\n  </div>\n  <div dialog-footer>\n    <div class=\"ui-dialog-buttonpane ui-widget-content ui-helper-clearfix\">\n      <button type=\"button\"\n              class=\"btn\"\n              (click)=\"dialogDeny()\">\n        {{ !cancelBtnStr ?\n          ('ui_common_label_no' | translate) : (cancelBtnStr | translate)\n        }}\n      </button>\n      <button type=\"button\"\n              class=\"btn\"\n              [ngClass]=\"'btn-'+confirmBtnClass\"\n              (click)=\"dialogConfirm()\">\n        {{ !confirmBtnStr ?\n          ('ui_common_label_yes' | translate) : (confirmBtnStr | translate)\n        }}\n      </button>\n    </div>\n  </div>\n</wg-dialog>\n"
    }]
  }], null, {
    showDialog: [{
      type: Input
    }],
    showDialogChange: [{
      type: Output
    }],
    title: [{
      type: Input
    }],
    content: [{
      type: Input
    }],
    confirmBtnStr: [{
      type: Input
    }],
    confirmBtnClass: [{
      type: Input
    }],
    cancelBtnStr: [{
      type: Input
    }],
    dialogCancelled: [{
      type: Output
    }],
    dialogConfirmed: [{
      type: Output
    }]
  });
})();
class WgConfirmDialogModule {
  static {
    this.ɵfac = function WgConfirmDialogModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgConfirmDialogModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgConfirmDialogModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, TranslateModule, WgDialogModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgConfirmDialogModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, TranslateModule, WgDialogModule],
      declarations: [WgConfirmDialogComponent],
      exports: [WgConfirmDialogComponent]
    }]
  }], null, null);
})();

/**
 * @license
 * Copyright WatchGuard Technologies Inc. All Rights Reserved.
 *
 * This component is a confirmation dialog with a progress bar that is based off
 * of wg-confirm-dialog. By default,
 * the title and content are empty and uses 'Yes'/'No' buttons.
 *
 * The caller is responsible for hiding the dialog in response to cancel
 * and confirm actions.
 *
 * @Input showDialog:boolean Hide or show the dialog
 * @Input title:string The title of the dialog; default ''
 * @Input content:string|Array<string> The content of the dialog; default ''
 * @Input confirmBtnStr:string The label for the 'confirm' button; default 'Yes'
 * @Input cancelBtnStr:string The label for the 'cancel' button; default 'No'
 * @Input progressDescription:string The label that shows up next to the progress bar
 * @Input progressValue:number The progress bar value. 0 - 100
 * @Output dialogCancelled:event Called when the dialog is 'cancelled' or closed
 * @Output dialogConfirmed:event Called when the dialog is confirmed
 *
 * Note: The title, content and button strings are translated by wg-confirm-progress-dialog.
 *
 * Example using html:
 *  <wg-confirm-progress-dialog
 *   [showDialog]="confirmDialogVisible"
 *   [title]="my_title_str"
 *   [content]="my_content_msg"
 *   [progressDescription]="description next to progress bar"
 *   [progressValue]="0-100"
 *   (dialogCancelled)="confirmDialogVisible=false"
 *   (dialogConfirmed)="myDialogConfirmed()">
 *  </wg-confirm-progress-dialog>
 *
 * All of the values can be set in typsecript code when showing the dialog,
 * so that a single html <wg-confirm-progress-dialog> can be used for multiple purposes.
 * Example of multi-use confirm dialog configured via typescript:
 *  See wg-device-config's NetworkBlockingComponent.promptConfirmDialog()
 *
 */
class WgConfirmProgressDialogComponent {
  constructor() {
    this.showDialogChange = new EventEmitter();
    this.confirmBtnClass = 'primary';
    /**
     * 'denied': "No" button was clicked (no auto-close)
     * 'closed': Dialog closed (finished disappearing)
     */
    this.dialogCancelled = new EventEmitter();
    /**
     * "Yes" button was clicked (no auto-close)
     */
    this.dialogConfirmed = new EventEmitter();
  }
  /**
   * Binds the wg-dialog `showDialog` value to this component's
   * `showDialog` input/output.
   */
  updateShowDialog(value) {
    this.showDialog = value;
    this.showDialogChange.emit(this.showDialog);
  }
  multipleContents() {
    return this.content instanceof Array;
  }
  dialogClosed() {
    this.dialogCancelled.emit('closed');
  }
  dialogDeny() {
    this.dialogCancelled.emit('denied');
  }
  dialogConfirm() {
    this.dialogConfirmed.emit();
  }
  static {
    this.ɵfac = function WgConfirmProgressDialogComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgConfirmProgressDialogComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgConfirmProgressDialogComponent,
      selectors: [["wg-confirm-progress-dialog"]],
      inputs: {
        showDialog: "showDialog",
        title: "title",
        content: "content",
        progressDescription: "progressDescription",
        progressValue: "progressValue",
        confirmBtnStr: "confirmBtnStr",
        confirmBtnClass: "confirmBtnClass",
        cancelBtnStr: "cancelBtnStr"
      },
      outputs: {
        showDialogChange: "showDialogChange",
        dialogCancelled: "dialogCancelled",
        dialogConfirmed: "dialogConfirmed"
      },
      standalone: false,
      decls: 11,
      vars: 8,
      consts: [["singleContent", ""], [3, "showDialogChange", "dialogClosedEvent", "showDialog"], ["dialog-title", ""], ["dialog-content", ""], [4, "ngIf"], ["dialog-footer", ""], [1, "ui-dialog-buttonpane", "ui-widget-content", "ui-helper-clearfix"], ["type", "button", "class", "btn", 3, "click", 4, "ngIf"], ["type", "button", "class", "btn", 3, "ngClass", "click", 4, "ngIf"], [3, "value", "striped", "animated"], [3, "innerHTML"], [4, "ngIf", "ngIfElse"], [3, "innerHTML", 4, "ngFor", "ngForOf"], ["type", "button", 1, "btn", 3, "click"], ["type", "button", 1, "btn", 3, "click", "ngClass"]],
      template: function WgConfirmProgressDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "wg-dialog", 1);
          i0.ɵɵlistener("showDialogChange", function WgConfirmProgressDialogComponent_Template_wg_dialog_showDialogChange_0_listener($event) {
            return ctx.updateShowDialog($event);
          })("dialogClosedEvent", function WgConfirmProgressDialogComponent_Template_wg_dialog_dialogClosedEvent_0_listener() {
            return ctx.dialogClosed();
          });
          i0.ɵɵelementStart(1, "div", 2);
          i0.ɵɵtext(2);
          i0.ɵɵpipe(3, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "div", 3);
          i0.ɵɵtemplate(5, WgConfirmProgressDialogComponent_ng_container_5_Template, 5, 6, "ng-container", 4)(6, WgConfirmProgressDialogComponent_ng_container_6_Template, 4, 2, "ng-container", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(7, "div", 5)(8, "div", 6);
          i0.ɵɵtemplate(9, WgConfirmProgressDialogComponent_button_9_Template, 4, 5, "button", 7)(10, WgConfirmProgressDialogComponent_button_10_Template, 4, 6, "button", 8);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("showDialog", ctx.showDialog);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 6, ctx.title), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.progressValue);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.progressValue);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", !ctx.progressValue);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.progressValue);
        }
      },
      dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, WgDialogComponent, WgProgressComponent, WgProgressBarComponent, i1$1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgConfirmProgressDialogComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      selector: 'wg-confirm-progress-dialog',
      standalone: false,
      template: "<wg-dialog\n  [showDialog]=\"showDialog\"\n  (showDialogChange)=\"updateShowDialog($event)\"\n  (dialogClosedEvent)=\"dialogClosed()\">\n  <div dialog-title>\n    {{ title | translate }}\n  </div>\n  <div dialog-content>\n    <ng-container *ngIf=\"progressValue\">\n      <wg-progress>\n        <wg-progress-bar [value]=\"progressValue\"\n                         [striped]=\"true\"\n                         [animated]=\"true\"></wg-progress-bar>\n      </wg-progress>\n      <p [innerHTML]=\"progressDescription.toString() | translate\"></p>\n    </ng-container>\n    <ng-container *ngIf=\"!progressValue\">\n      <ng-container *ngIf=\"multipleContents(); else singleContent\">\n        <p *ngFor=\"let c of content\" [innerHTML]=\"c | translate\"></p>\n      </ng-container>\n      <ng-template #singleContent>\n        <p [innerHTML]=\"content.toString() | translate\"></p>\n      </ng-template>\n    </ng-container>\n  </div>\n  <div dialog-footer>\n    <div class=\"ui-dialog-buttonpane ui-widget-content ui-helper-clearfix\">\n      <button *ngIf=\"!progressValue\"\n              type=\"button\"\n              class=\"btn\"\n              (click)=\"dialogDeny()\">\n        {{ !cancelBtnStr ?\n          ('ui_common_label_no' | translate) : (cancelBtnStr | translate)\n        }}\n      </button>\n      <button *ngIf=\"!progressValue\"\n              type=\"button\"\n              class=\"btn\"\n              [ngClass]=\"'btn-'+confirmBtnClass\"\n              (click)=\"dialogConfirm()\">\n        {{ !confirmBtnStr ?\n          ('ui_common_label_yes' | translate) : (confirmBtnStr | translate)\n        }}\n      </button>\n    </div>\n  </div>\n</wg-dialog>\n"
    }]
  }], null, {
    showDialog: [{
      type: Input
    }],
    showDialogChange: [{
      type: Output
    }],
    title: [{
      type: Input
    }],
    content: [{
      type: Input
    }],
    progressDescription: [{
      type: Input
    }],
    progressValue: [{
      type: Input
    }],
    confirmBtnStr: [{
      type: Input
    }],
    confirmBtnClass: [{
      type: Input
    }],
    cancelBtnStr: [{
      type: Input
    }],
    dialogCancelled: [{
      type: Output
    }],
    dialogConfirmed: [{
      type: Output
    }]
  });
})();
class WgConfirmProgressDialogModule {
  static {
    this.ɵfac = function WgConfirmProgressDialogModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgConfirmProgressDialogModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgConfirmProgressDialogModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, TranslateModule, WgDialogModule, WgProgressModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgConfirmProgressDialogModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, TranslateModule, WgDialogModule, WgProgressModule],
      declarations: [WgConfirmProgressDialogComponent],
      exports: [WgConfirmProgressDialogComponent]
    }]
  }], null, null);
})();
class WgDialogService {
  /**
   * Dynamicallly inject a dialog component into the view, and set it's inputs.
   * Optionally, you can also pass a callback to be executed once the dialog is closed.
   *
   * @param viewContainerRef
   * @param componentType A class type that extends `WgDynamicDialog<any>`
   * @param input Values for \@Input properties of the dialog component
   * @param onCloseCallback Optional callback that executes once the dialog is closed, exposing the dialog response
   * @returns
   */
  open(viewContainerRef, componentType, input, onCloseCallback) {
    const componentRef = viewContainerRef.createComponent(componentType, {});
    componentRef.instance.componentRef = componentRef;
    componentRef.instance.update(input);
    if (onCloseCallback) {
      componentRef.instance.onClosed.subscribe(onCloseCallback);
    }
    return componentRef.instance;
  }
  static {
    this.ɵfac = function WgDialogService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgDialogService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: WgDialogService,
      factory: WgDialogService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgDialogService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class WgDynamicDialog {
  constructor() {
    this.onModified = new Subject();
    this.onClosed = new Subject();
    /**
     *  Mutex lock: ensures a single close event is handled/fired
     */
    this.isBeingDestroyed = false;
    /**
     * You MUST use this on the `[showDialog]` property of `wg-dialog`
     * so the dynamic lifecycle works properly.
     */
    this.visible = true;
    /**
     * The response to be sent by `onClose`. You probably should not have to tweak this.
     */
    this.response = undefined;
  }
  /**
   * Call this on a custom dynamic dialog to notify it's parent
   * component of changes through onModified
   */
  notifyChange() {
    this.onModified.next();
  }
  /**
   * Close the dialog and passes a response to `onClose`.
   * @param response `Response` which should be sent to `onClose`
   * @param notifyChange Should trigger a `onModified` event (default: false)
   */
  close(response, notifyChange = false) {
    this.response = response;
    if (notifyChange) {
      this.notifyChange();
    }
    this.visible = false;
  }
  /**
   * Update the value of input properties of the dialog
   * @param input An object containing input properties of the dialog
   */
  update(input) {
    Object.assign(this, input);
  }
  /**
   * Bind input properties of a dynamic dialog to an Observable through a parsing method.
   * Use this when your dialog needs to remain open and be updated from the component which opened it.
   * @param dialog
   * @param observable The Observable to which the dialog will subscribe
   * @param parseFn A method that takes the observed data and returns an object of input data. This input data
   * is fed to the `update` method of the dialog.
   */
  bind(observable, parseFn) {
    const sub = observable.subscribe(data => {
      this.update(parseFn(data));
    });
    this.onClosed.subscribe(() => {
      sub.unsubscribe();
    });
  }
  /**
   * You can extend this method on custom dynamic dialogs in
   * case of a more complex cleanup
   */
  destroyComponent() {
    this.componentRef.destroy();
  }
  /**
   * You MUST use this method on the `(dialogClosedEvent)` property of `wg-dialog`
   * so the dynamic lifecycle works properly.
   */
  handleCloseEvent() {
    if (this.isBeingDestroyed) return;
    this.isBeingDestroyed = true;
    this.onClosed.next(this.response);
    this.onModified.complete();
    this.onClosed.complete();
    this.destroyComponent();
  }
}

/* eslint-disable @angular-eslint/component-class-suffix */
class WgDynamicConfirmDialog extends WgDynamicDialog {
  constructor() {
    super(...arguments);
    this.title = '';
    this.content = '';
    this.confirmBtnStr = undefined;
    this.confirmBtnClass = undefined;
    this.cancelBtnStr = undefined;
  }
  handleCancelEvent(event) {
    if (event === 'denied') {
      this.close(false);
    } else {
      this.handleCloseEvent();
    }
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵWgDynamicConfirmDialog_BaseFactory;
      return function WgDynamicConfirmDialog_Factory(__ngFactoryType__) {
        return (ɵWgDynamicConfirmDialog_BaseFactory || (ɵWgDynamicConfirmDialog_BaseFactory = i0.ɵɵgetInheritedFactory(WgDynamicConfirmDialog)))(__ngFactoryType__ || WgDynamicConfirmDialog);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgDynamicConfirmDialog,
      selectors: [["wg-dynamic-confirm-dialog"]],
      inputs: {
        title: "title",
        content: "content",
        confirmBtnStr: "confirmBtnStr",
        confirmBtnClass: "confirmBtnClass",
        cancelBtnStr: "cancelBtnStr"
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 6,
      consts: [[3, "dialogCancelled", "dialogConfirmed", "showDialog", "title", "content", "confirmBtnStr", "confirmBtnClass", "cancelBtnStr"]],
      template: function WgDynamicConfirmDialog_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "wg-confirm-dialog", 0);
          i0.ɵɵlistener("dialogCancelled", function WgDynamicConfirmDialog_Template_wg_confirm_dialog_dialogCancelled_0_listener($event) {
            return ctx.handleCancelEvent($event);
          })("dialogConfirmed", function WgDynamicConfirmDialog_Template_wg_confirm_dialog_dialogConfirmed_0_listener() {
            return ctx.close(true);
          });
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("showDialog", ctx.visible)("title", ctx.title)("content", ctx.content)("confirmBtnStr", ctx.confirmBtnStr)("confirmBtnClass", ctx.confirmBtnClass)("cancelBtnStr", ctx.cancelBtnStr);
        }
      },
      dependencies: [WgConfirmDialogModule, WgConfirmDialogComponent],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgDynamicConfirmDialog, [{
    type: Component,
    args: [{
      selector: 'wg-dynamic-confirm-dialog',
      imports: [WgConfirmDialogModule],
      template: "<wg-confirm-dialog\n  [showDialog]=\"visible\"\n  [title]=\"title\"\n  [content]=\"content\"\n  [confirmBtnStr]=\"confirmBtnStr\"\n  [confirmBtnClass]=\"confirmBtnClass\"\n  [cancelBtnStr]=\"cancelBtnStr\"\n  (dialogCancelled)=\"handleCancelEvent($event)\"\n  (dialogConfirmed)=\"close(true)\">\n</wg-confirm-dialog>\n"
    }]
  }], null, {
    title: [{
      type: Input
    }],
    content: [{
      type: Input
    }],
    confirmBtnStr: [{
      type: Input
    }],
    confirmBtnClass: [{
      type: Input
    }],
    cancelBtnStr: [{
      type: Input
    }]
  });
})();
class WgHideShowPasswordComponent {
  get invalid() {
    return this.inputControl && this.inputControl.invalid && this.inputControl.touched;
  }
  constructor(element) {
    this.element = element;
    this.inputGroup = true;
    this.focus = false;
    this.buttonTitle = 'show_password';
    this.visible = false;
  }
  ngOnInit() {
    this.inputElement = this.element.nativeElement.querySelector('wg-hide-show-password > input');
  }
  ngOnChanges(changes) {
    if (this.inputElement && changes.disabled.currentValue !== changes.disabled.previousValue) {
      if (changes.disabled.currentValue === true) {
        this.inputControl?.control?.disable();
        this.hidePassword();
      } else {
        this.inputControl?.control?.enable();
      }
    }
  }
  addFocus() {
    this.focus = true;
  }
  removeFocus() {
    this.focus = false;
  }
  toggleShow() {
    if (this.disabled) {
      return;
    }
    this.visible ? this.hidePassword() : this.showPassword();
  }
  showPassword() {
    this.visible = true;
    this.buttonTitle = 'hide_password';
    this.inputElement.setAttribute('type', 'text');
  }
  hidePassword() {
    this.visible = false;
    this.buttonTitle = 'show_password';
    this.inputElement.setAttribute('type', 'password');
  }
  static {
    this.ɵfac = function WgHideShowPasswordComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgHideShowPasswordComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgHideShowPasswordComponent,
      selectors: [["wg-hide-show-password"]],
      contentQueries: function WgHideShowPasswordComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, NgControl, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputControl = _t.first);
        }
      },
      hostVars: 6,
      hostBindings: function WgHideShowPasswordComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("focusin", function WgHideShowPasswordComponent_focusin_HostBindingHandler() {
            return ctx.addFocus();
          })("focusout", function WgHideShowPasswordComponent_focusout_HostBindingHandler() {
            return ctx.removeFocus();
          });
        }
        if (rf & 2) {
          i0.ɵɵclassProp("input-group", ctx.inputGroup)("focus", ctx.focus)("invalid", ctx.invalid);
        }
      },
      inputs: {
        disabled: "disabled"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c0,
      decls: 4,
      vars: 7,
      consts: [[3, "click", "ngClass"], ["name", "eye"]],
      template: function WgHideShowPasswordComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
          i0.ɵɵelementStart(1, "a", 0);
          i0.ɵɵpipe(2, "translate");
          i0.ɵɵlistener("click", function WgHideShowPasswordComponent_Template_a_click_1_listener() {
            return ctx.toggleShow();
          });
          i0.ɵɵelement(3, "wg-icon", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c14, ctx.disabled, ctx.visible));
          i0.ɵɵattribute("title", i0.ɵɵpipeBind1(2, 2, ctx.buttonTitle));
        }
      },
      dependencies: [i1$2.NgClass, WgIconComponent, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgHideShowPasswordComponent, [{
    type: Component,
    args: [{
      selector: 'wg-hide-show-password',
      template: `
    <ng-content></ng-content>
    <a (click)="toggleShow()" [attr.title]="buttonTitle | translate" [ngClass]="{ 'disabled': disabled, 'show-password': visible }">
      <wg-icon name="eye"></wg-icon>
    </a>`,
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    disabled: [{
      type: Input
    }],
    inputControl: [{
      type: ContentChild,
      args: [NgControl, {
        static: true
      }]
    }],
    inputGroup: [{
      type: HostBinding,
      args: ['class.input-group']
    }],
    focus: [{
      type: HostBinding,
      args: ['class.focus']
    }],
    invalid: [{
      type: HostBinding,
      args: ['class.invalid']
    }],
    addFocus: [{
      type: HostListener,
      args: ['focusin']
    }],
    removeFocus: [{
      type: HostListener,
      args: ['focusout']
    }]
  });
})();
class WgHideShowPasswordModule {
  static {
    this.ɵfac = function WgHideShowPasswordModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgHideShowPasswordModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgHideShowPasswordModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FormsModule, WgIconModule, TranslateModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgHideShowPasswordModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FormsModule, WgIconModule, TranslateModule],
      declarations: [WgHideShowPasswordComponent],
      exports: [WgHideShowPasswordComponent]
    }]
  }], null, null);
})();
const DEFAULT_LANG = 'en';
class WgLocalizedImageComponent {
  constructor(translateService) {
    this.translateService = translateService;
  }
  ngOnChanges(changes) {
    if (changes.hasOwnProperty('src') && !changes.src.firstChange || changes.hasOwnProperty('lang') && !changes.lang.firstChange) {
      this.loadImage();
    }
  }
  ngOnInit() {
    this.loadImage();
  }
  onError() {
    const fileInfo = this.getFileInfo(this.localizedSrc);
    if (fileInfo.lang !== DEFAULT_LANG) {
      this.updateSrc(DEFAULT_LANG);
    }
  }
  getFileInfo(url) {
    let basename = url.split('/').pop();
    let extension;
    let folder = url.split("/").slice(0, -1).join("/");
    if (basename.indexOf('.') !== -1) {
      const parts = basename.split('.');
      basename = parts[0];
      extension = parts[1];
    }
    const lang = basename.substring(basename.lastIndexOf('_') + 1);
    return {
      basename,
      extension,
      folder,
      lang
    };
  }
  loadImage() {
    if (!this.src) {
      this.localizedSrc = '';
      return;
    }
    this.updateSrc();
  }
  updateSrc(lang) {
    const fileInfo = this.getFileInfo(this.src);
    if (!lang) {
      lang = this.lang || this.translateService.currentLang || DEFAULT_LANG;
    }
    const url = `${fileInfo.folder}/${fileInfo.basename}_${lang}.${fileInfo.extension}`;
    this.localizedSrc = url;
  }
  static {
    this.ɵfac = function WgLocalizedImageComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgLocalizedImageComponent)(i0.ɵɵdirectiveInject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgLocalizedImageComponent,
      selectors: [["wg-localized-img"]],
      viewQuery: function WgLocalizedImageComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c15, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.image = _t.first);
        }
      },
      inputs: {
        alt: "alt",
        lang: "lang",
        src: "src"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 2,
      vars: 2,
      consts: [["image", ""], [3, "error"]],
      template: function WgLocalizedImageComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "img", 1, 0);
          i0.ɵɵlistener("error", function WgLocalizedImageComponent_Template_img_error_0_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onError());
          });
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵattribute("src", ctx.localizedSrc, i0.ɵɵsanitizeUrl)("alt", ctx.alt);
        }
      },
      styles: ["[_nghost-%COMP%]{display:inline-block}[_nghost-%COMP%]   img[_ngcontent-%COMP%]{max-height:100%;max-width:100%}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgLocalizedImageComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      selector: 'wg-localized-img',
      standalone: false,
      template: "<img #image [attr.src]=\"localizedSrc\" [attr.alt]=\"alt\" (error)=\"onError()\">",
      styles: [":host{display:inline-block}:host img{max-height:100%;max-width:100%}\n"]
    }]
  }], () => [{
    type: i1$1.TranslateService
  }], {
    image: [{
      type: ViewChild,
      args: ['image', {
        static: true
      }]
    }],
    alt: [{
      type: Input
    }],
    lang: [{
      type: Input
    }],
    src: [{
      type: Input
    }]
  });
})();
class WgImagesModule {
  static {
    this.ɵfac = function WgImagesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgImagesModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgImagesModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [TranslateModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgImagesModule, [{
    type: NgModule,
    args: [{
      declarations: [WgLocalizedImageComponent],
      imports: [TranslateModule],
      exports: [WgLocalizedImageComponent]
    }]
  }], null, null);
})();
class WgToggleComponent {
  constructor() {
    this.toggleChange = new EventEmitter();
    this.onChange = () => {};
    this.onTouched = () => {};
  }
  get toggle() {
    return this.toggleValue;
  }
  set toggle(value) {
    this.toggleValue = value;
    this.toggleChange.emit(this.toggleValue);
    this.onChange(value);
    this.onTouched();
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  writeValue(value) {
    this.toggleValue = value;
  }
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
  }
  static {
    this.ɵfac = function WgToggleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgToggleComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgToggleComponent,
      selectors: [["wg-toggle"]],
      inputs: {
        disabled: "disabled",
        toggle: "toggle"
      },
      outputs: {
        toggleChange: "toggleChange"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => WgToggleComponent),
        multi: true
      }])],
      decls: 3,
      vars: 5,
      consts: [[1, "switch", 3, "ngClass"], ["type", "checkbox", 3, "ngModelChange", "ngModel", "disabled"], [1, "slider", "round"]],
      template: function WgToggleComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "label", 0)(1, "input", 1);
          i0.ɵɵtwoWayListener("ngModelChange", function WgToggleComponent_Template_input_ngModelChange_1_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.toggle, $event) || (ctx.toggle = $event);
            return $event;
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelement(2, "span", 2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c16, ctx.disabled));
          i0.ɵɵadvance();
          i0.ɵɵtwoWayProperty("ngModel", ctx.toggle);
          i0.ɵɵproperty("disabled", ctx.disabled);
        }
      },
      dependencies: [i1$2.NgClass, i2.CheckboxControlValueAccessor, i2.NgControlStatus, i2.NgModel],
      styles: [".switch[_ngcontent-%COMP%]{position:relative;display:inline-block;width:45px;height:22px}.switch[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{display:none}.slider[_ngcontent-%COMP%]{position:absolute;cursor:pointer;inset:0;background-color:#b5b5b5;-webkit-transition:.4s;transition:.4s}.slider[_ngcontent-%COMP%]:before{position:absolute;content:\"\";height:18px;width:18px;left:2px;bottom:2px;background-color:#fff;-webkit-transition:.4s;transition:.4s;box-shadow:0 2px 4px #00000038}input[_ngcontent-%COMP%]:checked + .slider[_ngcontent-%COMP%]{background-color:#4aab53}input[_ngcontent-%COMP%]:checked + .slider[_ngcontent-%COMP%]:before{-webkit-transform:translateX(23px);-ms-transform:translateX(23px);transform:translate(23px)}.slider.round[_ngcontent-%COMP%]{border-radius:34px}.slider.round[_ngcontent-%COMP%]:before{border-radius:50%}.disabled[_ngcontent-%COMP%]   .slider[_ngcontent-%COMP%], .disabled[_ngcontent-%COMP%]   .switch[_ngcontent-%COMP%]{cursor:not-allowed;opacity:.6}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgToggleComponent, [{
    type: Component,
    args: [{
      selector: 'wg-toggle',
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => WgToggleComponent),
        multi: true
      }],
      standalone: false,
      template: "<label class=\"switch\" [ngClass]=\"{ 'disabled': disabled }\">\n    <input type=\"checkbox\" [(ngModel)]=\"toggle\" [disabled]=\"disabled\">\n    <span class=\"slider round\"></span>\n</label>\n",
      styles: [".switch{position:relative;display:inline-block;width:45px;height:22px}.switch input{display:none}.slider{position:absolute;cursor:pointer;inset:0;background-color:#b5b5b5;-webkit-transition:.4s;transition:.4s}.slider:before{position:absolute;content:\"\";height:18px;width:18px;left:2px;bottom:2px;background-color:#fff;-webkit-transition:.4s;transition:.4s;box-shadow:0 2px 4px #00000038}input:checked+.slider{background-color:#4aab53}input:checked+.slider:before{-webkit-transform:translateX(23px);-ms-transform:translateX(23px);transform:translate(23px)}.slider.round{border-radius:34px}.slider.round:before{border-radius:50%}.disabled .slider,.disabled .switch{cursor:not-allowed;opacity:.6}\n"]
    }]
  }], null, {
    toggleChange: [{
      type: Output
    }],
    disabled: [{
      type: Input
    }],
    toggle: [{
      type: Input
    }]
  });
})();
class WgToggleModule {
  static {
    this.ɵfac = function WgToggleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgToggleModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgToggleModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FormsModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgToggleModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FormsModule],
      declarations: [WgToggleComponent],
      exports: [WgToggleComponent]
    }]
  }], null, null);
})();

/**
 * Helper service to return the current account ID
 *
 * We can later add other helper functions that
 * can return useful information from other services
 * without having to directly add those services.
 *
 */
class WgBaseService {
  constructor() {
    // Dynamic chart data used by PRE module
    this.dynamicChartDataSubject = new Subject();
    this.dynamicChartDataChanged$ = this.dynamicChartDataSubject.asObservable();
    // https://watchguard.atlassian.net/issues/WCD-24072
    // Used for async reports;
    // we need to know when to start the async poller (during an active session or when user logs in)
    // a. During an active session, when TS or Inventory (or any other service in future)
    //    initiates an async download request, we should call asyncReportGenerationInitiated
    // and pass in service name and any other related attributes (like for inventory we will need request_id)
    // b. When user logs in, then too we should call asyncReportGenerationInitiated 
    // If we have atleast one async download in progress (This check should happen in unified app)
    // data could be {serviceName: <>} or {serviceName:<>, metadata: }
    // for inventory metadata would be the requestID associated with each download request
    // the poller will need this info to poll the inventory download backend
    this.asyncReportGenerationSubject = new Subject();
    this.asyncReportGenerationInitiated$ = this.asyncReportGenerationSubject.asObservable();
  }
  getAccountId() {
    return this.accountId;
  }
  setAccountId(accountId) {
    this.accountId = accountId;
  }
  updateDynamicChartData(data) {
    this.dynamicChartDataSubject.next(data);
  }
  asyncReportGenerationInitiated(data) {
    this.asyncReportGenerationSubject.next(data);
  }
  static {
    this.ɵfac = function WgBaseService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgBaseService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: WgBaseService,
      factory: WgBaseService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgBaseService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
const OPTIONAL = {
  optional: true
};
const TRANSITION$1 = '500ms';
function fade() {
  return [query(':enter', [style({
    opacity: 0
  })], OPTIONAL), query(':enter, :leave', [style({
    height: '100%',
    position: 'absolute',
    width: 'calc(100% - 60px)'
  })], OPTIONAL), query(':leave', [style({
    opacity: 1
  }), animate(`${TRANSITION$1}`, style({
    opacity: 0
  }))], OPTIONAL), query(':enter', [style({
    opacity: 0
  }), animate(`${TRANSITION$1}`, style({
    opacity: 1
  }))], OPTIONAL)];
}

/**
 * There are also CSS styles to draw and animate the background overlay.
 * At the time of this comment there are in:
 * DaaS-Common/Static/scss/wgc/components/_wg-panel.scss
 * DaaS-Common/Static/scss/wgc/themes/components/_wg-panel.scss
 *
 * If you change the animation time here, make sure it matches there, etc.
 */
const TRANSITION_ENTER = '500ms cubic-bezier(0.39, 0.575, 0.565, 1)';
const TRANSITION_LEAVE = '500ms cubic-bezier(0.47, 0, 0.745, 0.715)';
const slideOverLeftEnterParams = [style({
  bottom: '0',
  left: '0',
  position: 'absolute',
  right: '0',
  top: '0',
  transform: 'translateX(100%)',
  width: '100%'
}), animate(`${TRANSITION_ENTER}`, style({
  transform: 'translateX(0%)'
}))];
const slideOverLeftLeaveParams = [style({
  bottom: '0',
  left: '0',
  position: 'absolute',
  right: '0',
  top: '0',
  transform: 'translateX(0%)',
  width: '100%'
}), animate(`${TRANSITION_LEAVE}`, style({
  transform: 'translateX(100%)'
}))];
const slideOverLeftEnterAnimation = animation([group([query(':enter', slideOverLeftEnterParams, OPTIONAL), query(':leave', [style({
  bottom: '0',
  left: '0',
  padding: '30px',
  position: 'absolute',
  right: '0',
  top: '0',
  width: 'calc(100% - 60px)'
})], OPTIONAL)])]);
const slideOverLeftLeaveAnimation = animation([group([query(':leave', slideOverLeftLeaveParams, OPTIONAL), query(':enter', [style({
  bottom: '0',
  left: '0',
  padding: '30px',
  position: 'absolute',
  right: '0',
  top: '0',
  width: 'calc(100% - 60px)'
})], OPTIONAL)])]);
const TRANSITION = '300ms ease';
const slideInAnimation = animation([query(':enter, :leave', [style({
  left: '{{ leftEnterLeave }}',
  right: '{{ rightEnterLeave }}',
  position: 'absolute',
  width: 'calc(100% - 60px)'
})], OPTIONAL), query(':enter', [style({
  left: '{{ leftEnter }}',
  right: '{{ rightEnter }}'
})], OPTIONAL), group([query(':leave', [animate(`${TRANSITION}`, style({
  left: '{{ leftLeaveTransition }}',
  right: '{{ rightLeaveTransition }}'
}))], OPTIONAL), query(':enter', [animate(`${TRANSITION}`, style({
  left: '{{ leftEnterTransition }}',
  right: '{{ rightEnterTransition }}'
}))], OPTIONAL)])]);
const slideInParamsRight = {
  rightEnterLeave: 0,
  rightEnter: 'calc(-100% - 60px)',
  rightLeaveTransition: 'calc(100% + 30px)',
  rightEnterTransition: 'calc(0% + 30px)',
  leftEnterLeave: '',
  leftEnter: '',
  leftLeaveTransition: '',
  leftEnterTransition: ''
};
const slideInParamsLeft = {
  leftEnterLeave: 0,
  leftEnter: 'calc(-100% - 60px)',
  leftLeaveTransition: 'calc(100% + 30px)',
  leftEnterTransition: 'calc(0% + 30px)',
  rightEnterLeave: '',
  rightEnter: '',
  rightLeaveTransition: '',
  rightEnterTransition: ''
};
const WG_ROUTE_ANIMATIONS = {
  fade: 'fade',
  slideLeft: 'slideLeft',
  slideRight: 'slideRight',
  slideOverLeft: 'slideOverLeft'
};
const wgRouteAnimations = trigger('wgRouteAnimations', [transition(`* => ${WG_ROUTE_ANIMATIONS.fade}`, fade()), transition(`${WG_ROUTE_ANIMATIONS.fade} => *`, fade()), transition(`* => ${WG_ROUTE_ANIMATIONS.slideLeft}`, useAnimation(slideInAnimation, {
  params: {
    ...slideInParamsRight
  }
})), transition(`* => ${WG_ROUTE_ANIMATIONS.slideRight}`, useAnimation(slideInAnimation, {
  params: {
    ...slideInParamsLeft
  }
})), transition(`${WG_ROUTE_ANIMATIONS.slideRight} => *`, useAnimation(slideInAnimation, {
  params: {
    ...slideInParamsRight
  }
})), transition(`${WG_ROUTE_ANIMATIONS.slideLeft} => *`, useAnimation(slideInAnimation, {
  params: {
    ...slideInParamsLeft
  }
})), transition(`* => ${WG_ROUTE_ANIMATIONS.slideOverLeft}`, useAnimation(slideOverLeftEnterAnimation)), transition(`${WG_ROUTE_ANIMATIONS.slideOverLeft} => *`, useAnimation(slideOverLeftLeaveAnimation))]);

/**
 * @license
 * Copyright WatchGuard Technologies Inc. All Rights Reserved.
 *
 * This library provides common js utility methods that are used in DaaS
 *
 */
// This is the event used for resizing, etc.
// THIS SHOULD ONLY BE CREATED ONCE!!
const windowResizeEvent = undefined; // changed to const to make lint happy
let windowResizeTimeout;
const windowResizeSubject = new Subject();
/**
 * Check if the element is present in the array.
 * Return true if present else return false.
 * Wrapper to contains method from underscore
 */
function elemPresentInArray(element, arr) {
  return _.contains(arr, element);
}
/**
 * Set the passed in string or array of strings to empty strings.
 * TODO: Must be renamed to something more specific to strings like resetStrings().
 */
function resetElems(...fields) {
  // tslint:disable-next-line:only-arrow-functions
  return _.map(fields, function (s) {
    return '';
  });
}
/**
 * Extract a list of property values based on the property name from a list
 * of properties.
 * Wrapper to pluck method from underscore
 */
function extractValues(list, propertyName) {
  return _.pluck(list, propertyName);
}
/**
 * Extract a list of property values based on property names from a list
 * of properties.
 */
function extractMultipleValues(list, propertyNames) {
  return _.map(list, item => {
    return _.map(propertyNames, val => {
      return item[val];
    });
  });
}
/**
 * Have each item of a list paired with the elem.
 * Returns a list of lists containing each item of the input list and the elem.
 */
function merge(list, elem) {
  return _.map(list, item => {
    return [item, elem];
  });
}
/**
 * Produce a duplicate-free version of a list.
 * Returns:
 *  - Empty list if no elments in list or invalid input.
 *  - Array of elements that are not repeated in the input list.
 * Wrapper to uniq method from underscore
 */
function uniqueList(list) {
  return _.uniq(list);
}
/**
 * Looks through each value in the list, returning an array of
 * all the values that contain all of the key-value pairs
 * listed in properties.
 * Wrapper to where method from underscore
 * Returns:
 *  - Empty list if the properties does not match anything.
 *  - Input list if the properties is of invalid type.
 *  - Filtered list for valid properties.
 */
function filterList(list, properties) {
  return _.where(list, properties);
}
/**
 * Looks through the list and returns the first value that
 * matches all of the key-value pairs listed in properties.
 * Wrapper to findWhere method from underscore
 * Returns:
 *   - undefined if no match is found, or if list is empty.
 *   - First item of the list if properties is of invalid type.
 *   - Firt item that matched all of the key-value pairs listed in properties.
 */
function findInList(list, properties) {
  return _.findWhere(list, properties);
}
/**
 * Looks through the two input lists and returns an array
 * with values from the first list that are not present in the
 * second list.
 * Wrapper to difference method from underscore
 * Returns:
 *   - Empty array if all elements of first array are present in second one.
 *   - Array with elements that are unique in the first list.
 */
function diffList(list1, list2) {
  return _.difference(list1, list2);
}
/**
 * This method checks if the passed in field is empty string or not.
 * Return true if it's empty else return false
 */
function isEmpty(field) {
  return field === undefined || field === null || field.trim().length === 0;
}
/**
 * This method checks for string duplicacy.
 * Check if string field1 matches string field2
 * Return true if they match else return false
 */
function areSame(field1, field2) {
  return field1.toLowerCase() === field2.trim().toLowerCase();
}
/**
 * This method checks if the input string 'field' contains any of the
 * characters specified as invalid by the 'invalidChars'.
 * Return true if the string contains any of the invalid
 * characters else return false.
 * TODO: Must be renamed to something more generic like strContains().
 */
function hasInvalidChars(field, ...invalidChars) {
  if (isEmpty(field)) {
    return false;
  }
  // tslint:disable-next-line:only-arrow-functions
  if (_.find(invalidChars, function (char) {
    return field.indexOf(char) !== -1;
  })) {
    return true;
  }
  return false;
}
/**
 * This method checks if field length
 * is less than or equal to the passed in max
 * Return true if they match else return false
 */
function hasValidLength(field, max) {
  if (!isNum(max)) {
    return false;
  }
  return field.length <= max;
}
/**
 * Validate email address entries
 * regex that validate email addresses to
 * test@example.com or test@example.gov.com
 * Comply with Auth0 which does not allow the values
 * after . to be only numbers, it expectes start and end to be
 * alphabets.
 *
 * It also expects the user part to be 64 characters max, and the domain
 * part to be 256 characters max.
 */
function validEmailFieldSimple(field) {
  return /^[^\s@",<>;:]{1,64}@(?=.{1,256}$)([^\s@",%$#<>;:]+(\.(?:[a-z]+((\d*[a-z0-9\-]){0,}$))))/i.test(field);
}
/**
 * Validate username entries
 * regex that username email addresses to
 * Username can only contain alphanumeric characters and '_', '+', '-', or '.'.
 * Username should have between 1 and 15 characters.;
 */
function validUsernameSimple(field) {
  return /^[a-z0-9_+-.]{1,15}$/i.test(field);
}
/**
 * This method checks if the passed in field is number or not.
 * Return true if it has else return false
 * TODO: Must be renamed to some more appropriate like isPositiveInteger()
 */
function isNum(field) {
  if (field || field === 0) {
    return !isNaN(field) && parseInt(field, 10) >= 0 && isInt(field);
  } else {
    return false;
  }
}
/**
 * This method checks if the passed in field is number or not.
 * Return true if it has else return false
 * Wrapper to isNumber method in underscore.
 */
function isNumber(field) {
  return _.isNumber(field);
}
/**
 * This method checks if the passed in field is whole number.
 * Return true if it has else return false
 */
function isInt(field) {
  return field % 1 === 0;
}
/**
 * This method checks if the passed in field has
 * alpha number chars and some other special chars.
 * Return true if it has else return false.
 *
 * This is good for validating phone numbers.
 */
function hasAlphaNumSpecial(field) {
  if (field) {
    return /^[a-z0-9\-\ \,\_\+\.\*\:\@\/]+$/i.test(field);
  }
  return true;
}
/**
 * Check if passed in field matches
 * YYYY-MM-DD format
 */
function isValidDate(field) {
  return /^\d{4}-\d{2}-\d{2}$/.test(field);
}
/**
 *  Parse token
 *  http://stackoverflow.com/questions/38552003/how-to-decode-jwt-token-in-javascript
 */
function parseToken(token) {
  if (!token) {
    return '';
  }
  const base64Url = token.split('.')[1];
  if (!base64Url) {
    return '';
  }
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  if (!base64) {
    return '';
  }
  return JSON.parse(window.atob(base64));
}
/**
 * Validates a given password against our requirements for users.
 *
 * The requirements are: Password must contain at least three out of the four
 * 'lower case letter, upper case letter, number and special character' and a minimum of 8 characters.
 *
 * @export
 * @param string password
 */
function isValidUserPassword(password) {
  let isValid = true;
  if (!password || password.length < 8) {
    isValid = false;
  }
  if (isValid) {
    let numValid = 0;
    if (password.search(/[a-z]/) > -1) {
      numValid++;
    }
    if (password.search(/[A-Z]/) > -1) {
      numValid++;
    }
    if (password.search(/[\d]/) > -1) {
      numValid++;
    }
    if (password.search(/[\W_]/) > -1) {
      numValid++;
    }
    if (numValid < 3) {
      isValid = false;
    }
  }
  return isValid;
}
/**
 * Create and download a CSV file given the CSV values and filename.
 * @param csv String containing the comma seperated values.
 * @param filename The name of the CSV file to be downloaded.
 * https://github.com/primefaces/primeng/blob/master/components/datatable/datatable.ts
 */
function createCSVFile(csv, filename) {
  downloadFile(csv, filename);
}
/**
 *
 * @param data raw data from server (blob)
 * @param fileName name of the file
 * @param format (csv, zip etc)
 */
function downloadFile(data, fileName, format = 'csv') {
  let type = 'text';
  const chartSet = 'charset=utf-8';
  if (format === 'zip') {
    type = 'application';
  }
  const contentType = `${type}/${format};${chartSet};`;
  const blob = new Blob([data], {
    type: contentType
  });
  const nav = window.navigator;
  if (nav.msSaveOrOpenBlob) {
    nav.msSaveOrOpenBlob(blob, `${fileName}.${format}`);
  } else {
    const link = document.createElement('a');
    link.style.display = 'none';
    document.body.appendChild(link);
    if (link.download !== undefined) {
      link.setAttribute('href', URL.createObjectURL(blob));
      link.setAttribute('download', `${fileName}.${format}`);
      link.click();
    } else {
      const blobData = `data:${contentType},${data}`;
      window.open(encodeURI(blobData));
    }
    document.body.removeChild(link);
  }
}
/**
 * download csv file which supports special characters such as BOM (Byte Order Mark)
 * @param data raw data from server (blob)
 * @param fileName name of the file
 * @param format (csv, zip etc)
 */
function downloadCSVFile(data, fileName, format = 'csv') {
  let type = 'text';
  const chartSet = 'charset=utf-8';
  const BOM = '\uFEFF';
  if (format === 'zip') {
    type = 'application';
  }
  const contentType = `${type}/${format};${chartSet};`;
  const blobData = format === 'csv' ? [BOM, data] : [data];
  const blob = new Blob(blobData, {
    type: contentType
  });
  const nav = window.navigator;
  if (nav.msSaveOrOpenBlob) {
    nav.msSaveOrOpenBlob(blob, `${fileName}.${format}`);
  } else {
    const link = document.createElement('a');
    link.style.display = 'none';
    document.body.appendChild(link);
    if (link.download !== undefined) {
      link.setAttribute('href', URL.createObjectURL(blob));
      link.setAttribute('download', `${fileName}.${format}`);
      link.click();
    } else {
      const encodedData = encodeURIComponent(format === 'csv' ? BOM + data : data);
      const blobDataUri = `data:${contentType},${encodedData}`;
      window.open(blobDataUri);
    }
    document.body.removeChild(link);
  }
}
/**
 *  Return env based on the url.
 *
 *  Optionally provide the document object (for testing)
 *
 *  If env is undefined, it is production env.
 */
const getEnv = (theDocument, modifier = false) => {
  if (!theDocument) {
    theDocument = document;
  }
  const url = theDocument.location.host;
  let env = 'dev';
  if (url.indexOf('qa') > -1) {
    env = 'qa';
  } else if (url.indexOf('staging') > -1) {
    if (modifier) {
      env = 'stg';
    } else {
      env = 'staging';
    }
  } else if (url.indexOf('watchguard.com') > -1 && url.indexOf('dev') === -1) {
    env = undefined;
  }
  return env;
};
/**
 * Returns the region. This is used for the Guard URL.
 *
 * Optionally provide the document object (for testing)
 *
 * Example: 'usa'
 */
const getRegion = theDocument => {
  if (getEnv(theDocument) === 'dev') {
    return 'usa';
  } else {
    if (!theDocument) {
      theDocument = document;
    }
    return getEnv() ? theDocument.location.host.split('.')[1] : theDocument.location.host.split('.')[0];
  }
};
/**
 *  Return guardURL taking in region, service and product.
 *
 *  Region parameter is deprecated and no longer used.
 */
const guardURL = ({
  service = '',
  region = 'usa',
  product = 'daas'
} = {}) => {
  // Ignoring passed in region
  console.warn('Deprecation Warning: This Guard URL is deprecated. Please use the new Guard URL scheme.');
  return `https://guard.${getEnv()}.${region}.cloud.watchguard.com/${service}watchguard/${product}`;
};
/**
 * Returns the new Guard URL format.
 *
 * service is the name of your service (platform, etc.)
 *
 * DEPRECATED: (no longer used) region is the region in which the app is running. Defaults to usa
 *
 * withCloud is to specify if it should add /cloud or not
 *
 * If you provide an override, it will bypass the guard auth. Example:
 * newGuardUrl({service: 'platform', region: 'usa', override: 'accounts-mw', withCloud: true})
 *
 * Example of return value: https://guard.dev.usa.cloud.watchguard.com/cloud/platform/
 */
const newGuardUrl = ({
  service = '',
  region = 'usa',
  override = '',
  withCloud = true
} = {}) => {
  const cloud = withCloud ? '/cloud' : '';
  // Ignoring passed in region
  region = getRegion();
  if (!getEnv()) {
    // No overriding auth in prod.
    return `https://guard.${region}.cloud.watchguard.com${cloud}/${service}/`;
  } else {
    if (override) {
      return `https://guard.${getEnv()}.${region}.cloud.watchguard.com/${override + cloud}/${service}/`;
    } else {
      return `https://guard.${getEnv()}.${region}.cloud.watchguard.com${cloud}/${service}/`;
    }
  }
};
/**
 * Returns an observable that will return the width/height of
 * the window after a resize event.
 *
 * Takes the following arguments in an object:
 *
 * @param debounceTime
 * The debounce time in milliseconds. Optional.
 * Provide this to add debounce to resize.
 *
 * @returns Observable<WindowResizeObject>
 * The observable for resize events. Example:
 *
 * {
 *   width: 500,
 *   height: 500
 * }
 */
const getWindowResizeObservable = debounceTime => {
  if (!windowResizeEvent) {
    // Need to create new event handler for resize
    // THIS SHOULD ONLY BE CREATED ONCE!!!
    // Handling like debounce https://stackoverflow.com/a/5490021
    const emit = () => {
      windowResizeSubject.next({
        width: getWindowWidth(),
        height: getWindowHeight()
      });
    };
    window.addEventListener('resize', () => {
      if (debounceTime) {
        clearTimeout(windowResizeTimeout);
        windowResizeTimeout = setTimeout(emit, debounceTime);
      } else {
        emit();
      }
    });
  }
  return windowResizeSubject.asObservable();
};
/**
 * Returns the height of the window.
 *
 * https://stackoverflow.com/a/28241682
 */
const getWindowHeight = () => {
  return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
};
/**
 * Returns the width of the window.
 *
 * https://stackoverflow.com/a/28241682
 */
const getWindowWidth = () => {
  return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
};
/**
 * Returns the status for time countdowns related to licenses.
 *
 * Status':
 * - ok = >10 Days from Now
 * - attention = <= 10 Days from Now
 * - warning = <= 48 Hours from Now
 * - expired = <= 0 Milliseconds from Now
 *
 * @param Date date
 * The date to compare to now.
 *
 * @param boolean isUTC
 * true if date is in UTC, defaults to false. DO NOT set this if using toCompare. It will be ignored.
 *
 * @param Date toCompare
 * The date to compare against. Defaults to new Date().
 *
 * @returns string
 * Returns an object containing information about the status:
 * {
 *   status: 'warning',
 *   diff: 23,
 *   diffType: 'hours',
 *   colorClass: 'color-pumpkin'
 * }
 */
const getLicenseStatus = (date, {
  toCompare = null,
  isUTC = false
} = {}) => {
  const toReturn = {
    status: 'invalid',
    diff: null,
    diffType: null,
    colorClass: 'color-gravel'
  };
  if (!date || !(date instanceof Date) || !(typeof date.getTime === 'function') || !(Object.prototype.toString.call(date) === '[object Date]')) {
    return toReturn;
  } else if (isNaN(date.getTime())) {
    return toReturn;
  }
  if (toCompare) {
    if (!(toCompare instanceof Date) || !(typeof toCompare.getTime === 'function') || !(Object.prototype.toString.call(toCompare) === '[object Date]')) {
      return toReturn;
    } else if (isNaN(toCompare.getTime())) {
      return toReturn;
    }
  }
  let today = toCompare ? moment(toCompare) : moment();
  let compare = moment(date);
  if (isUTC && !toCompare) {
    today = moment.utc();
    compare = moment.utc(compare);
  }
  // compare
  const duration = moment.duration(compare.diff(today));
  const hours = Math.ceil(duration.as('hours'));
  const days = Math.ceil(duration.as('days'));
  const months = Math.ceil(duration.as('months'));
  return getLicenseStatusByDays(days, hours, months);
};
/**
 * Returns the status based on days_to_expire in API return.
 *
 * Status':
 * - ok = >10 Days
 * - attention = <= 10 Days
 * - warning = <= 2 Days
 * - expired = <= 0 Day
 *
 * @param days number
 * The days to expire in API return
 * If call this function directly and the passed days <= 0
 * should set the hours to 0 to return expired status.
 *
 * @param hours number
 * The hours from Now. Optional.
 *
 * @param momths number
 * The months from Now. Optional.
 *
 * @returns string
 * Returns an object containing information about the status:
 * {
 *   status: 'warning',
 *   diff: 23,
 *   diffType: 'hours',
 *   colorClass: 'color-pumpkin'
 * }
 */
const getLicenseStatusByDays = (days, hours, months) => {
  let toReturn = {
    status: 'invalid',
    diff: null,
    diffType: null,
    colorClass: 'color-gravel'
  };
  if (hours < 1) {
    toReturn = {
      status: 'expired',
      diff: 0,
      diffType: 'hours',
      colorClass: 'color-watchguard-red'
    };
  } else if (days <= 2) {
    toReturn = {
      status: 'warning',
      diff: hours ? hours : days,
      diffType: hours ? 'hours' : 'days',
      colorClass: 'color-pumpkin'
    };
  } else if (days <= 10) {
    toReturn = {
      status: 'attention',
      diff: days,
      diffType: 'days',
      colorClass: 'color-sol'
    };
  } else if (days <= 90) {
    toReturn = {
      status: 'ok',
      diff: days,
      diffType: 'days',
      colorClass: 'color-gravel'
    };
  } else {
    toReturn = {
      status: 'ok',
      diff: months ? months : Math.floor(days / 30),
      diffType: 'months',
      colorClass: 'color-gravel'
    };
  }
  return toReturn;
};
/*
  Check if the dom element appears in view or not.

  From:
  https://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport/7557433#7557433
*/
function isElementInViewport(el, overridingTopOffset) {
  const topOffset = overridingTopOffset || 120;
  const rect = el.getBoundingClientRect();
  return rect.top >= topOffset &&
  // note:  need top offset
  rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}
/*
  Scroll the dom element into viewport and place the focus on the element.
*/
function scrollIntoViewAndFocus(nativeElement, overrideScrollYOffset) {
  const scrollYOffset = overrideScrollYOffset || -120;
  if (!isElementInViewport(nativeElement)) {
    nativeElement.scrollIntoView();
    setTimeout(() => {
      window.scrollBy(0, scrollYOffset);
    }, 100);
  }
  nativeElement.focus();
}
// generic function used by
// - DeviceSummaryWidgetsService of wg-devices
// - AdministrationService of wgc-unified-app
// - ConfigureServicesService of wgc-unified-app
// - MainDashboardService of wgc-unified-app
// - MainReportsService of wgc-unified-app
// - SpAdministrationService of wgc-unified-app
// - SpDashboardService of wgc-unified-app
//
function getDynamicUiWidgets(widgets, widgetIDCompMap, widgetColsSpanMap, widgetGenerator) {
  // if no widgetGenerator is provided, only keep the entries with
  // correpsonding maps in widgetIDCompMap. Otherwise, widgets that are
  // not mapped are generated.
  const retWidgets = [];
  widgets.forEach(w => {
    let wData = widgetIDCompMap[w.id];
    if (!wData && widgetGenerator) {
      wData = widgetGenerator(w);
    }
    if (wData) {
      wData.data = JSON.parse(JSON.stringify(w));
      if (w.children) {
        wData.data.children = getDynamicUiWidgets(w.children, widgetIDCompMap, widgetColsSpanMap, widgetGenerator);
      }
      if (widgetColsSpanMap) {
        wData.data.colSpan = widgetColsSpanMap[w.id];
      }
      retWidgets.push(wData);
    }
  });
  return retWidgets;
}
/**
 * Return guard serverless API URL. Allow user to assign a service user value.
 * For example:
 * If no service user is assigned, the returned url will look like:
 *  https://guardapi.usa.cloud.watchguard.com
 *
 * If a service user is assigned (i.e. 'wifi'), the returned url will look like:
 * https://guardapi.wifi.usa.cloud.watchguard.com
 */
const newGuardApiUrl = ({
  region = 'usa',
  override = '',
  withCloud = false,
  service = '',
  modifier = false
} = {}) => {
  const cloud = withCloud ? '/cloud' : '';
  // Ignoring passed in region
  region = getRegion();
  let baseUrl = 'guardapi';
  if (service) {
    baseUrl = baseUrl + '.' + service;
  }
  if (!getEnv(false, modifier)) {
    // No overriding auth in prod.
    return `https://${baseUrl}.${region}.cloud.watchguard.com${cloud}/`;
  } else {
    if (override) {
      return `https://${baseUrl}.${getEnv()}.${region}.cloud.watchguard.com/${override + cloud}/`;
    } else {
      return `https://${baseUrl}.${getEnv()}.${region}.cloud.watchguard.com${cloud}/`;
    }
  }
};
const getFolkloreBaseApi = () => {
  const env = getEnv();
  const region = getRegion().toLowerCase();
  const regionMap = {
    usa: "usw2",
    deu: "euc1",
    jpn: "apne1"
  };
  const awsRegionCode = regionMap[region] || "usw2";
  const resolveEnv = env ? `ha.${env}` : "ha";
  return `https://core.authpoint.${awsRegionCode}.${resolveEnv}.cloud.watchguard.com/`;
};
function stripIdPrefix(id) {
  if (!id) {
    return '';
  }
  id = id.toString();
  if (id.indexOf('-') !== -1) {
    const index = id.indexOf('-');
    return id.substring(index + 1);
  } else {
    return id.toString();
  }
}
function idHasPrefix(id) {
  if (!id) {
    return false;
  }
  const fields = id.toString().split('-');
  return fields.length > 1;
}
function convertDevIdForObjs(devID) {
  if (!devID) {
    return '';
  }
  const idString = devID.toString();
  const x = idString.split('-');
  if (x.length > 1) {
    if (x[0] === 'FB') {
      return x[1];
    } else {
      return idString;
    }
  }
  return idString;
}
function resolveObjDevToDevId(devID) {
  if (!devID) {
    return '';
  }
  if (!isNaN(+devID)) {
    return `FB-${devID}`;
  }
  const idString = devID.toString();
  const x = idString.split('-');
  if (x.length === 1) {
    return `FB-${x[0]}`;
  }
  return idString;
}
function isAP(devID) {
  const realId = resolveObjDevToDevId(devID);
  return realId.indexOf('AP-') !== -1;
}
function isCluster(devID) {
  const realId = resolveObjDevToDevId(devID);
  return realId.indexOf('FBCL-') !== -1;
}
/**
 * Returns a copy of an array.
 *
 */
function deepCopyArray(array) {
  const copy = [];
  for (let i = 0, len = array.length; i < len; i++) {
    copy[i] = deepCopy(array[i]);
  }
  return copy;
}
/**
 * Returns a copy of an object.
 *
 * @param obj
 * Object to copy
 *
 * @returns any
 * A copy of the object
 */
function deepCopy(obj) {
  let copy;
  // only supports objects
  if (null == obj || typeof obj !== 'object') {
    return obj;
  }
  // handle array
  if (obj instanceof Array) {
    return deepCopyArray(obj);
  }
  // handle object
  if (obj instanceof Object) {
    copy = {};
    for (const attr in obj) {
      if (obj.hasOwnProperty(attr)) {
        copy[attr] = deepCopy(obj[attr]);
      }
    }
    return copy;
  }
  throw new Error('Unsupported type for deepCopy().');
}
/**
 * The following hash functions were found @
 * https://gist.github.com/jlevy/c246006675becc446360a798e2b2d781
 */
// cyrb53 (c) 2018 bryc (github.com/bryc). License: Public domain. Attribution appreciated.
// A fast and simple 64-bit (or 53-bit) string hash function with decent collision resistance.
// Largely inspired by MurmurHash2/3, but with a focus on speed/simplicity.
// See https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript/52171480#52171480
// https://github.com/bryc/code/blob/master/jshash/experimental/cyrb53.js
function cyrb64(str, seed = 0) {
  let h1 = 0xdeadbeef ^ seed,
    h2 = 0x41c6ce57 ^ seed;
  for (let i = 0, ch; i < str.length; i++) {
    ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507);
  h1 ^= Math.imul(h2 ^ h2 >>> 13, 3266489909);
  h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507);
  h2 ^= Math.imul(h1 ^ h1 >>> 13, 3266489909);
  // For a single 53-bit numeric return value we could return
  // 4294967296 * (2097151 & h2) + (h1 >>> 0);
  // but we instead return the full 64-bit value:
  return [h2 >>> 0, h1 >>> 0];
}
// An improved, *insecure* 64-bit hash that's short, fast, and has no dependencies.
// Output is always 14 characters.
function cyrb64Hash(str, seed = 0) {
  const [h2, h1] = cyrb64(str, seed);
  return h2.toString(36).padStart(7, '0') + h1.toString(36).padStart(7, '0');
}
const defaultHelpLink = 'https://www.watchguard.com/help/docs/help-center/';
const LANG_MAP$1 = {
  en: 'en-US',
  ja: 'ja-JP',
  fr: 'fr-FR',
  es: 'es-419'
};
const VERIFICATION_CODE_HELP_CONTEXT_ID = 16001;
const RAPID_DEPLOY_HELP_CONTEXT_ID = 16002;
const getHelpContextURLById = (contextId, currentLocale = 'en') => {
  const lang = LANG_MAP$1[currentLocale];
  let contextURL = defaultHelpLink + lang + '/index.html';
  if (contextId) {
    contextURL = defaultHelpLink + lang + '/index_CSH.html#' + contextId;
  }
  return contextURL;
};
var WgColors;
(function (WgColors) {
  // grays
  WgColors["black"] = "#000000";
  WgColors["abyss"] = "#262626";
  WgColors["space"] = "#434343";
  WgColors["gravel"] = "#606060";
  WgColors["tarmac"] = "#7c7c7c";
  WgColors["watchguardGray"] = "#999999";
  WgColors["slate"] = "#b5b5b5";
  WgColors["silver"] = "#d4d4d4";
  WgColors["platinum"] = "#ebebeb";
  WgColors["ash"] = "#f2f2f2";
  WgColors["ghost"] = "#fafafa";
  WgColors["snow"] = "#ffffff";
  // reds
  WgColors["ruby"] = "#cf0000";
  WgColors["watchguardRed"] = "#ff0000";
  WgColors["blush"] = "#fff0f0";
  // blues
  WgColors["pacific"] = "#367b88";
  WgColors["robinEgg"] = "#359db0";
  WgColors["lagoon"] = "#57c5d9";
  WgColors["sky"] = "#7ed2e2";
  WgColors["ice"] = "#edf9fc";
  // greens
  WgColors["success"] = "#4aab53";
  WgColors["seafoam"] = "#ebf7eb";
  // yellows
  WgColors["sol"] = "#ffce44";
  // oranges/browns
  WgColors["pumpkin"] = "#f8992b";
  WgColors["custard"] = "#fff6eb";
  // purples
  WgColors["eggplant"] = "#6c1d93";
})(WgColors || (WgColors = {}));
;

/**
 * @license
 * Copyright WatchGuard Technologies Inc. All Rights Reserved.
 *
 * Export all the constants that will be used app wide.
 *
 */
// Includes spanish dialects that understand our spanish translation
const LOCALE_BUNDLE_MAP = {
  'en-US': 'en',
  'fr-FR': 'fr',
  'fr-CA': 'fr',
  'fr-CH': 'fr',
  'fr-BE': 'fr',
  'fr-LU': 'fr',
  'fr-MC': 'fr',
  'fr': 'fr',
  'ja': 'ja',
  'es-AR': 'es-419',
  'es-BO': 'es-419',
  'es-CL': 'es-419',
  'es-CO': 'es-419',
  'es-CR': 'es-419',
  'es-DO': 'es-419',
  'es-EC': 'es-419',
  'es-SV': 'es-419',
  'es-GT': 'es-419',
  'es-HN': 'es-419',
  'es-MX': 'es-419',
  'es-NI': 'es-419',
  'es-PA': 'es-419',
  'es-PY': 'es-419',
  'es-PE': 'es-419',
  'es-PR': 'es-419',
  'es-UY': 'es-419',
  'es-VE': 'es-419',
  'es-US': 'es-419',
  'es-419': 'es-419',
  'es-ES': 'es-es',
  'es': 'es-es',
  'de-DE': 'de',
  'de-AT': 'de',
  // German (Austria)
  'de-LI': 'de',
  // German (Liechtenstein)
  'de-LU': 'de',
  // German (Luxembourg)
  'de-CH': 'de',
  // German (Switzerland)
  'de': 'de'
};
// Includes spanish dialects that understand our spanish translation
const SUPPORTED_LOCALES = Object.keys(LOCALE_BUNDLE_MAP);
const AUTHPOINT = 'AuthPoint';
const AUTH = 'AUTH'; // include both AuthPoint and Authpoint_TIS
const AUTHPOINT_TRIAL = 'AuthPoint_Trial';
const AUTHPOINT_NFR = 'AuthPoint_NFR';
const AUTHPOINT_OVERAGE = 'AuthPoint_Overage';
const AUTHPOINT_SUBSCRIPTION = 'AuthPoint Subscription';
const AUTHPOINT_TIS = 'AuthPoint_TIS';
const AUTHPOINT_TIS_TRIAL = 'AuthPoint_TIS_Trial';
const AUTHPOINT_TIS_NFR = 'AuthPoint_TIS_NFR';
const AUTHPOINT_TIS_OVERAGE = 'AuthPoint_TIS_Overage';
const FIREBOX = 'Dimension_Cloud';
const FIREBOX_DRL = 'Dimension_Cloud_Retention';
const HOST_SENSOR = 'TDR';
const ACCESS_POINT = 'AccessPoint';
const DNS_WATCH = 'DNSWatch';
const FIREWAN = 'FireWAN';
const FIREWAN_TRIAL = 'FireWAN_Trial';
const FIREWAN_NFR = 'FireWAN_NFR';
const FIREWAN_OVERAGE = 'FireWAN_Overage';
const NDR = 'NDR';
const NDR_NDR = 'NDR_NDR';
const NDR_NDR_TRIAL = 'NDR_NDR_Trial';
const NDR_NDR_NFR = 'NDR_NDR_NFR';
const NDR_NDR_OVERAGE = 'NDR_NDR_Overage';
const CMPL = 'CMPL';
const CMPL_REPORT = 'CMPL_Report';
const CMPL_REPORT_TRIAL = 'CMPL_Report_Trial';
const CMPL_REPORT_NFR = 'CMPL_Report_NFR';
const CMPL_REPORT_OVERAGE = 'CMPL_Report_Overage';
const TSP = 'TSP';
const TSP_SDR = 'TSP_SDR';
const TSP_SDR_TRIAL = 'TSP_SDR_Trial';
const TSP_SDR_NFR = 'TSP_SDR_NFR';
const TSP_SDR_OVERAGE = 'TSP_SDR_Overage';
const WGMDR = 'WGMDR';
const MDR_DEF = 'MDR_DEF';
const MDR_DEF_NFR = 'MDR_DEF_NFR';
const MDR_DEF_OVERAGE = 'MDR_DEF_Overage';
const MDR_TOTAL = 'MDR_TOTAL';
const MDR_TOTAL_NFR = 'MDR_TOTAL_NFR';
const MDR_TOTAL_OVERAGE = 'MDR_TOTAL_Overage';
const TXDR = 'TXDR';
const TSP_TXDR = 'TSP_TXDR';
const TSP_TXDR_NFR = 'TSP_TXDR_NFR';
const TSP_TXDR_OVERAGE = 'TSP_TXDR_Overage';
const TSPLUS = 'TSPlus';
const THREATSYNC = 'ThreatSyncV2';
const WESS = 'WESS';
const WESS_EPP = 'WESS_EPP';
const WESS_EPP_TRIAL = 'WESS_EPP_Trial';
const WESS_EPP_NFR = 'WESS_EPP_NFR';
const WESS_EPPPLUS = 'WESS_EPPPlus';
const WESS_EPPPLUS_TRIAL = 'WESS_EPPPlus_Trial';
const WESS_EPPPLUS_NFR = 'WESS_EPPPlus_NFR';
const WESS_AD = 'WESS_AD';
const WESS_AD_TRIAL = 'WESS_AD_Trial';
const WESS_AD_NFR = 'WESS_AD_NFR';
const WESS_AD360 = 'WESS_AD360';
const WESS_AD360_TRIAL = 'WESS_AD360_Trial';
const WESS_AD360_NFR = 'WESS_AD360_NFR';
const WESS_AEPDR = 'WESS_AEPDR';
const WESS_AEPDR_TRIAL = 'WESS_AEPDR_Trial';
const WESS_AEPDR_NFR = 'WESS_AEPDR_NFR';
const WESS_EDR_CORE = 'WESS_EDR_Core';
const WESS_EDR_CORE_NFR = 'WESS_EDR_Core_NFR';
// WCD-13890
const WESS_AD360_OVERAGE = 'WESS_AD360_Overage';
const WESS_AEDPR_OVERAGE = 'WESS_AEPDR_Overage';
const WESS_AD_OVERAGE = 'WESS_AD_Overage';
const WESS_EPP_OVERAGE = 'WESS_EPP_Overage';
const WESS_MODULE_ART = 'WESS_Module_ART';
const WESS_MODULE_ART_NFR = 'WESS_Module_ART_NFR';
const WESS_MODULE_FE = 'WESS_Module_FE';
const WESS_MODULE_FE_NFR = 'WESS_Module_FE_NFR';
const WESS_MODULE_PM = 'WESS_Module_PM';
const WESS_MODULE_PM_NFR = 'WESS_Module_PM_NFR';
const WESS_MODULE_DC = 'WESS_Module_DC';
const WESS_MODULE_DC_NFR = 'WESS_Module_DC_NFR';
const WESS_MODULE_SF = 'WESS_Module_SF';
const WESS_MODULE_SF_NFR = 'WESS_Module_SF_NFR';
const WESS_MODULE_MDR = 'WESS_Module_MDR';
const WESS_MODULE_MDR_NFR = 'WESS_Module_MDR_NFR';
const WESS_MODULE_Orion = 'WESS_Module_Orion';
const WESS_MODULE_Orion_NFR = 'WESS_Module_Orion_NFR';
const APP_SHELL_DATA_API = './assets/shell.json';
const APP_ASSETS_API = './assets/app-assets.json';
const APP_AUTH_DATA_API = './assets/auth.json';
const APP_AUTH_REP_DATA_API = './assets/auth-reports.json';
const APP_FB_DATA_API = './assets/fb.json';
const APP_ACCOUNT_MGMT_DATA_API = './assets/account-management.json';
const APP_NOTIFICATIONS_DATA_API = './assets/notifications.json';
const APP_INVENTORY_DATA_API = './assets/inventory.json';
const APP_ADMINISTRATION_DATA_API = './assets/administration.json';
const APP_FB_CONFIGURATION_DATA_API = './assets/fb-configuration.json';
const APP_WHITELIST_DATA_API = './assets/whitelist.json';
const APP_TDR_CONFIGURE_DATA_API = './assets/tdr-configure.json';
const APP_TDR_MONITOR_DATA_API = './assets/tdr-monitor.json';
const APP_FIREWAN_CONFIGURE_DATA_API = './assets/firewan-configure.json';
const APP_FIREWAN_MONITOR_DATA_API = './assets/firewan-monitor.json';
const APP_THREATSYNC_CONFIGURE_DATA_API = './assets/threatsync-configure.json';
const APP_THREATSYNC_MONITOR_DATA_API = './assets/threatsync-monitor.json';
const APP_NDR_CONFIGURE_DATA_API = './assets/ndr-configure.json';
const APP_NDR_MONITOR_DATA_API = './assets/ndr-monitor.json';
// Default Logo
const DEFAULT_APP_LOGO = 'wg_logo_white.png';
// Component location that decides where a component should
// be placed in the UI
const COMP_LOCATION_ROOT = 'root';
const COMP_LOCATION_TOP = 'top';
const COMP_LOCATION_BOTTOM = 'bottom';
const COMP_LOCATION_RIGHT = 'right';
const COMP_LOCATION_LEFT = 'left';
const COMP_LOCATION_CENTER = 'center';
const POSITION = 'position';
const RELEASE = 'release';
const CHILDREN = 'children';
const TOP_NAV_CHILDREN = 'top_nav_children';
const ROOT = 'root';
const ROOT_DASHBOARD = 'root_dashboard';
const ROOT_SP_DASHBOARD = 'root_sp_dashboard';
const ROOT_REPORTS = 'root_reports';
const ROOT_ADMINISTRATION = 'root_administration';
const ROOT_SP_ADMINISTRATION = 'root_sp_administration';
const ROOT_CONFIGURE_SERVICES = 'root_configure_services';
const OVERVIEW_DASHBOARD_MONITOR_AUTH = 'overview_dashboard_monitor_auth';
const OVERVIEW_DASHBOARD_CONFIGURE_AUTH = 'overview_dashboard_configure_auth';
const SP_TENANT_DASHBOARD_MONITOR_AUTH = 'sp_tenant_dashboard_monitor_auth';
const SP_TENANT_DASHBOARD_CONFIGURE_AUTH = 'sp_tenant_dashboard_configure_auth';
const OVERVIEW_DASHBOARD_MONITOR_FB = 'overview_dashboard_monitor_fb';
const OVERVIEW_DASHBOARD_CONFIGURE_FB = 'overview_dashboard_configure_fb';
const SP_TENANT_DASHBOARD_MONITOR_FB = 'sp_tenant_dashboard_monitor_fb';
const SP_TENANT_DASHBOARD_CONFIGURE_FB = 'sp_tenant_dashboard_configure_fb';
const OVERVIEW_DASHBOARD_MONITOR_TDR = 'overview_dashboard_monitor_tdr';
const OVERVIEW_DASHBOARD_CONFIGURE_TDR = 'overview_dashboard_configure_tdr';
const SP_TENANT_DASHBOARD_MONITOR_TDR = 'sp_tenant_dashboard_monitor_tdr';
const SP_TENANT_DASHBOARD_CONFIGURE_TDR = 'sp_tenant_dashboard_configure_tdr';
const OVERVIEW_DASHBOARD_MONITOR_FIREWAN = 'overview_dashboard_monitor_firewan';
const AUTH_ROOT = 'auth_root';
const AUTH_REP_ROOT = 'auth_reports_root';
const FB_ROOT = 'fb_root';
const FB_ROOT_DEVICE_SUMMARY = 'fb_root_devices_summary';
const ACCOUNT_MGMT_ROOT = 'account_management_root';
const NOTIFICATIONS_ROOT = 'notifications_root';
const INVENTORY_ROOT = 'inventory_root';
const INVENTORY_ROOT_NAV_OVERVIEW = 'inventory_root_nav_overview';
const INVENTORY_ROOT_TENANT_NAV_OVERVIEW = 'inventory_root_tenant_nav_overview';
const INVENTORY_ROOT_TENANT_NAV_FB = 'inventory_root_tenant_nav_overview_fb';
const INVENTORY_ROOT_TENANT_NAV_ACCESS_POINT = 'inventory_root_tenant_nav_overview_access';
const ADMINISTRATION_ROOT = 'administration_root';
const TDR_CONFIGURE_ROOT = 'tdr_configure_root';
const TDR_MONITOR_ROOT = 'tdr_monitor_root';
const FIREWAN_CONFIGURE_ROOT = 'firewan_configure_root';
const FIREWAN_MONITOR_ROOT = 'firewan_monitor_root';
const THREATSYNC_CONFIGURE_ROOT = 'threatsync_configure_root';
const THREATSYNC_MONITOR_ROOT = 'threatsync_monitor_root';
const NDR_CONFIGURE_ROOT = 'ndr_configure_root';
const NDR_MONITOR_ROOT = 'ndr_monitor_root';
// Indicates the target release for a component
const FOR_GA = 'ga';
const FOR_BETA = 'beta';
// Navigation sections
const SHELL_TOP = 'shell_top';
const SHELL_LEFT = 'shell_left';
const SHELL_PRIMARY = 'shell_primary';
const AUTH_MONITOR_NAV = 'auth_monitor';
const AUTH_CONFIGURE_NAV = 'auth_configure';
const TDR_MONITOR_NAV = 'tdr_monitor';
const TDR_CONFIGURE_NAV = 'tdr_configure';
const FB_MONITOR_NAV = 'fb_monitor';
const FB_CONFIGURE_NAV = 'fb_configure';
const FIREWAN_MONITOR_NAV = 'firewan_monitor';
const FIREWAN_CONFIGURE_NAV = 'firewan_configure';
const THREATSYNC_MONITOR_NAV = 'threatsync_monitor';
const THREATSYNC_CONFIGURE_NAV = 'threatsync_configure';
const NDR_MONITOR_NAV = 'ndr_monitor';
const NDR_CONFIGURE_NAV = 'ndr_configure';
const INVENTORY_NAV = 'inventory';
const ADMINISTRATION_NAV = 'administration';
// For Dynamic widgets
const FB_CONFIGURATION_WIDGETS = 'fb_configuration_widgets';
const AP_CONFIGURATION_WIDGETS = 'ap_configuration_widgets';
const FIREWAN_DASHBOARD = 'firewan_dashboard';
const WATCHGUARD_CLOUD_DIRECTORY = 'watchguard_cloud_directory';
const serviceHasLicense = (serviceName, licInfo, productType) => {
  let hasLic;
  switch (serviceName) {
    case AUTHPOINT:
      if (licInfo && licInfo.hasOwnProperty(AUTHPOINT)) {
        hasLic = licInfo[AUTHPOINT]?.hasLicense || licInfo[AUTHPOINT_TRIAL]?.hasLicense || licInfo[AUTHPOINT_NFR]?.hasLicense || licInfo[AUTHPOINT_OVERAGE]?.hasLicense;
      }
      break;
    case AUTH:
      if (licInfo && licInfo.hasOwnProperty(AUTHPOINT)) {
        hasLic = licInfo[AUTHPOINT]?.hasLicense || licInfo[AUTHPOINT_TRIAL]?.hasLicense || licInfo[AUTHPOINT_NFR]?.hasLicense || licInfo[AUTHPOINT_OVERAGE]?.hasLicense;
      }
      if (licInfo && licInfo.hasOwnProperty(AUTHPOINT_TIS)) {
        hasLic = hasLic || licInfo[AUTHPOINT_TIS]?.hasLicense || licInfo[AUTHPOINT_TIS_TRIAL]?.hasLicense || licInfo[AUTHPOINT_TIS_NFR]?.hasLicense || licInfo[AUTHPOINT_TIS_OVERAGE]?.hasLicense;
      }
      break;
    case FIREBOX:
      if (licInfo && licInfo.hasOwnProperty(FIREBOX)) {
        hasLic = licInfo[FIREBOX]?.hasLicense || licInfo[FIREBOX_DRL]?.hasLicense;
      }
      break;
    case HOST_SENSOR:
      if (licInfo && licInfo.hasOwnProperty(HOST_SENSOR)) {
        hasLic = licInfo[HOST_SENSOR]?.hasLicense;
      }
      break;
    case ACCESS_POINT:
      if (licInfo && licInfo.hasOwnProperty(ACCESS_POINT)) {
        hasLic = licInfo[ACCESS_POINT]?.hasLicense;
      }
      break;
    case DNS_WATCH:
      if (licInfo && licInfo.hasOwnProperty(DNS_WATCH)) {
        hasLic = licInfo[DNS_WATCH]?.hasLicense;
      }
      break;
    case FIREWAN:
      if (licInfo && licInfo.hasOwnProperty(FIREWAN)) {
        hasLic = licInfo[FIREWAN]?.hasLicense || licInfo[FIREWAN_TRIAL]?.hasLicense || licInfo[FIREWAN_NFR]?.hasLicense || licInfo[FIREWAN_OVERAGE]?.hasLicense;
      }
      break;
    case NDR:
      if (licInfo) {
        hasLic = licInfo[NDR_NDR]?.hasLicense || licInfo[NDR_NDR_TRIAL]?.hasLicense || licInfo[NDR_NDR_NFR]?.hasLicense || licInfo[NDR_NDR_OVERAGE]?.hasLicense;
      }
      break;
    case CMPL:
      if (licInfo) {
        hasLic = licInfo[CMPL_REPORT]?.hasLicense || licInfo[CMPL_REPORT_TRIAL]?.hasLicense || licInfo[CMPL_REPORT_NFR]?.hasLicense || licInfo[CMPL_REPORT_OVERAGE]?.hasLicense;
      }
      break;
    case TSP:
      if (licInfo) {
        hasLic = licInfo[TSP_SDR]?.hasLicense || licInfo[TSP_SDR_TRIAL]?.hasLicense || licInfo[TSP_SDR_NFR]?.hasLicense || licInfo[TSP_SDR_OVERAGE]?.hasLicense;
      }
      break;
    case WGMDR:
      if (licInfo && !productType) {
        hasLic = licInfo[MDR_DEF]?.hasLicense || licInfo[MDR_DEF_NFR]?.hasLicense || licInfo[MDR_DEF_OVERAGE]?.hasLicense || licInfo[MDR_TOTAL]?.hasLicense || licInfo[MDR_TOTAL_NFR]?.hasLicense || licInfo[MDR_TOTAL_OVERAGE]?.hasLicense;
      } else if (licInfo && licInfo.hasOwnProperty(productType)) {
        hasLic = licInfo[productType]?.hasLicense;
      }
      break;
    case TXDR:
      if (licInfo) {
        hasLic = licInfo[TSP_TXDR]?.hasLicense || licInfo[TSP_TXDR_NFR]?.hasLicense || licInfo[TSP_TXDR_OVERAGE]?.hasLicense;
      }
      break;
    case TSPLUS:
      if (licInfo) {
        hasLic = licInfo[NDR_NDR]?.hasLicense || licInfo[NDR_NDR_TRIAL]?.hasLicense || licInfo[NDR_NDR_NFR]?.hasLicense || licInfo[NDR_NDR_OVERAGE]?.hasLicense || licInfo[CMPL_REPORT]?.hasLicense || licInfo[CMPL_REPORT_TRIAL]?.hasLicense || licInfo[CMPL_REPORT_NFR]?.hasLicense || licInfo[CMPL_REPORT_OVERAGE]?.hasLicense || licInfo[TSP_SDR]?.hasLicense || licInfo[TSP_SDR_TRIAL]?.hasLicense || licInfo[TSP_SDR_NFR]?.hasLicense || licInfo[TSP_SDR_OVERAGE]?.hasLicense || licInfo[TSP_TXDR]?.hasLicense || licInfo[TSP_TXDR_NFR]?.hasLicense || licInfo[TSP_TXDR_OVERAGE]?.hasLicense;
      }
      break;
    case THREATSYNC:
      if (licInfo && licInfo.hasOwnProperty(THREATSYNC)) {
        hasLic = licInfo[THREATSYNC]?.hasLicense;
      }
      break;
    case WESS:
      if (!productType) {
        if (licInfo && (licInfo.hasOwnProperty(WESS_EPP) || licInfo.hasOwnProperty(WESS_AD) || licInfo.hasOwnProperty(WESS_AD360) || licInfo.hasOwnProperty(WESS_AEPDR) || licInfo.hasOwnProperty(WESS_EDR_CORE))) {
          hasLic = licInfo[WESS_EPP]?.hasLicense || licInfo[WESS_EPP_TRIAL]?.hasLicense || licInfo[WESS_EPP_NFR]?.hasLicense || licInfo[WESS_AD]?.hasLicense || licInfo[WESS_AD_TRIAL]?.hasLicense || licInfo[WESS_AD_NFR]?.hasLicense || licInfo[WESS_AD360]?.hasLicense || licInfo[WESS_AD360_TRIAL]?.hasLicense || licInfo[WESS_AD360_NFR]?.hasLicense || licInfo[WESS_AEPDR]?.hasLicense || licInfo[WESS_AEPDR_TRIAL]?.hasLicense || licInfo[WESS_AEPDR_NFR]?.hasLicense || licInfo[WESS_EDR_CORE]?.hasLicense || licInfo[WESS_EDR_CORE_NFR]?.hasLicense || licInfo[WESS_AD360_OVERAGE]?.hasLicense || licInfo[WESS_AEDPR_OVERAGE]?.hasLicense || licInfo[WESS_AD_OVERAGE]?.hasLicense || licInfo[WESS_EPP_OVERAGE]?.hasLicense || licInfo[WESS_MODULE_ART]?.hasLicense || licInfo[WESS_MODULE_ART_NFR]?.hasLicense || licInfo[WESS_MODULE_DC]?.hasLicense || licInfo[WESS_MODULE_DC_NFR]?.hasLicense || licInfo[WESS_MODULE_FE]?.hasLicense || licInfo[WESS_MODULE_FE_NFR]?.hasLicense || licInfo[WESS_MODULE_PM]?.hasLicense || licInfo[WESS_MODULE_PM_NFR]?.hasLicense || licInfo[WESS_MODULE_SF]?.hasLicense || licInfo[WESS_MODULE_SF_NFR]?.hasLicense || licInfo[WESS_MODULE_MDR]?.hasLicense || licInfo[WESS_MODULE_MDR_NFR]?.hasLicense || licInfo[WESS_MODULE_Orion]?.hasLicense || licInfo[WESS_MODULE_Orion_NFR]?.hasLicense;
        }
      } else {
        if (licInfo && licInfo.hasOwnProperty(productType)) {
          hasLic = licInfo[productType]?.hasLicense;
        }
      }
      break;
    default:
      hasLic = false;
  }
  return hasLic;
};
const TIMEZONES = [{
  id: 1,
  zone: 'Etc/GMT+12',
  offset: -720,
  val: '(UTC-12:00) International Date Line West'
}, {
  id: 2,
  zone: 'Etc/GMT+11',
  offset: -660,
  val: '(UTC-11:00) Coordinated Universal Time-11'
}, {
  id: 3,
  zone: 'America/Adak',
  offset: -600,
  val: '(UTC-10:00) Aleutian Islands'
}, {
  id: 4,
  zone: 'Pacific/Honolulu',
  offset: -600,
  val: '(UTC-10:00) Hawaii'
}, {
  id: 5,
  zone: 'Pacific/Marquesas',
  offset: -570,
  val: '(UTC-09:30) Marquesas Islands'
}, {
  id: 6,
  zone: 'America/Anchorage',
  offset: -540,
  val: '(UTC-09:00) Alaska'
}, {
  id: 7,
  zone: 'Etc/GMT+9',
  offset: -540,
  val: '(UTC-09:00) Coordinated Universal Time-09'
}, {
  id: 8,
  zone: 'America/Tijuana',
  offset: -480,
  val: '(UTC-08:00) Baja California'
}, {
  id: 9,
  zone: 'Etc/GMT+8',
  offset: -480,
  val: '(UTC-08:00) Coordinated Universal Time-08'
}, {
  id: 10,
  zone: 'America/Los_Angeles',
  offset: -480,
  val: '(UTC-08:00) Pacific Time (US & Canada)'
}, {
  id: 11,
  zone: 'America/Phoenix',
  offset: -420,
  val: '(UTC-07:00) Arizona'
}, {
  id: 12,
  zone: 'America/Chihuahua',
  offset: -420,
  val: '(UTC-07:00) Chihuahua, La Paz, Mazatlan'
}, {
  id: 13,
  zone: 'America/Denver',
  offset: -420,
  val: '(UTC-07:00) Mountain Time (US & Canada)'
}, {
  id: 14,
  zone: 'America/Guatemala',
  offset: -360,
  val: '(UTC-06:00) Central America'
}, {
  id: 15,
  zone: 'America/Chicago',
  offset: -360,
  val: '(UTC-06:00) Central Time (US & Canada)'
}, {
  id: 16,
  zone: 'Pacific/Easter',
  offset: -360,
  val: '(UTC-06:00) Easter Island'
}, {
  id: 17,
  zone: 'America/Mexico_City',
  offset: -360,
  val: '(UTC-06:00) Guadalajara, Mexico City, Monterrey'
}, {
  id: 18,
  zone: 'America/Regina',
  offset: -360,
  val: '(UTC-06:00) Saskatchewan'
}, {
  id: 19,
  zone: 'America/Bogota',
  offset: -300,
  val: '(UTC-05:00) Bogota, Lima, Quito, Rio Branco'
}, {
  id: 20,
  zone: 'America/Cancun',
  offset: -300,
  val: '(UTC-05:00) Chetumal'
}, {
  id: 21,
  zone: 'America/New_York',
  offset: -300,
  val: '(UTC-05:00) Eastern Time (US & Canada)'
}, {
  id: 22,
  zone: 'America/Port-au-Prince',
  offset: -300,
  val: '(UTC-05:00) Haiti'
}, {
  id: 23,
  zone: 'America/Havana',
  offset: -300,
  val: '(UTC-05:00) Havana'
}, {
  id: 24,
  zone: 'America/Indianapolis',
  offset: -300,
  val: '(UTC-05:00) Indiana (East)'
}, {
  id: 25,
  zone: 'America/Asuncion',
  offset: -240,
  val: '(UTC-04:00) Asuncion'
}, {
  id: 26,
  zone: 'America/Halifax',
  offset: -240,
  val: '(UTC-04:00) Atlantic Time (Canada)'
}, {
  id: 27,
  zone: 'America/Caracas',
  offset: -240,
  val: '(UTC-04:00) Caracas'
}, {
  id: 28,
  zone: 'America/Cuiaba',
  offset: -240,
  val: '(UTC-04:00) Cuiaba'
}, {
  id: 29,
  zone: 'America/La_Paz',
  offset: -240,
  val: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan'
}, {
  id: 30,
  zone: 'America/Santiago',
  offset: -240,
  val: '(UTC-04:00) Santiago'
}, {
  id: 31,
  zone: 'America/Grand_Turk',
  offset: -240,
  val: '(UTC-04:00) Turks and Caicos'
}, {
  id: 32,
  zone: 'America/St_Johns',
  offset: -210,
  val: '(UTC-03:30) Newfoundland'
}, {
  id: 33,
  zone: 'America/Araguaina',
  offset: -180,
  val: '(UTC-03:00) Araguaina'
}, {
  id: 34,
  zone: 'America/Sao_Paulo',
  offset: -180,
  val: '(UTC-03:00) Brasilia'
}, {
  id: 35,
  zone: 'America/Cayenne',
  offset: -180,
  val: '(UTC-03:00) Cayenne, Fortaleza'
}, {
  id: 36,
  zone: 'America/Buenos_Aires',
  offset: -180,
  val: '(UTC-03:00) City of Buenos Aires'
}, {
  id: 37,
  zone: 'America/Godthab',
  offset: -180,
  val: '(UTC-03:00) Greenland'
}, {
  id: 38,
  zone: 'America/Montevideo',
  offset: -180,
  val: '(UTC-03:00) Montevideo'
}, {
  id: 39,
  zone: 'America/Punta_Arenas',
  offset: -180,
  val: '(UTC-03:00) Punta Arenas'
}, {
  id: 40,
  zone: 'America/Miquelon',
  offset: -180,
  val: '(UTC-03:00) Saint Pierre and Miquelon'
}, {
  id: 41,
  zone: 'America/Bahia',
  offset: -180,
  val: '(UTC-03:00) Salvador'
}, {
  id: 42,
  zone: 'Etc/GMT+2',
  offset: -120,
  val: '(UTC-02:00) Coordinated Universal Time-02'
}, {
  id: 43,
  zone: 'Etc/GMT+2',
  offset: -120,
  val: '(UTC-02:00) Mid-Atlantic - Old'
}, {
  id: 44,
  zone: 'Atlantic/Azores',
  offset: -60,
  val: '(UTC-01:00) Azores'
}, {
  id: 45,
  zone: 'Atlantic/Cape_Verde',
  offset: -60,
  val: '(UTC-01:00) Cabo Verde Is.'
}, {
  id: 46,
  zone: 'Etc/GMT',
  offset: 0,
  val: '(UTC) Coordinated Universal Time'
}, {
  id: 47,
  zone: 'Africa/Casablanca',
  offset: 0,
  val: '(UTC+00:00) Casablanca'
}, {
  id: 48,
  zone: 'Europe/London',
  offset: 0,
  val: '(UTC+00:00) Dublin, Edinburgh, Lisbon, London'
}, {
  id: 49,
  zone: 'Atlantic/Reykjavik',
  offset: 0,
  val: '(UTC+00:00) Monrovia, Reykjavik'
}, {
  id: 50,
  zone: 'Europe/Berlin',
  offset: 60,
  val: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna'
}, {
  id: 51,
  zone: 'Europe/Budapest',
  offset: 60,
  val: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague'
}, {
  id: 52,
  zone: 'Europe/Paris',
  offset: 60,
  val: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris'
}, {
  id: 53,
  zone: 'Europe/Warsaw',
  offset: 60,
  val: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb'
}, {
  id: 54,
  zone: 'Africa/Lagos',
  offset: 60,
  val: '(UTC+01:00) West Central Africa'
}, {
  id: 55,
  zone: 'Africa/Windhoek',
  offset: 60,
  val: '(UTC+01:00) Windhoek'
}, {
  id: 56,
  zone: 'Asia/Amman',
  offset: 120,
  val: '(UTC+02:00) Amman'
}, {
  id: 57,
  zone: 'Europe/Bucharest',
  offset: 120,
  val: '(UTC+02:00) Athens, Bucharest'
}, {
  id: 58,
  zone: 'Asia/Beirut',
  offset: 120,
  val: '(UTC+02:00) Beirut'
}, {
  id: 59,
  zone: 'Africa/Cairo',
  offset: 120,
  val: '(UTC+02:00) Cairo'
}, {
  id: 60,
  zone: 'Europe/Chisinau',
  offset: 120,
  val: '(UTC+02:00) Chisinau'
}, {
  id: 61,
  zone: 'Asia/Damascus',
  offset: 120,
  val: '(UTC+02:00) Damascus'
}, {
  id: 62,
  zone: 'Asia/Hebron',
  offset: 120,
  val: '(UTC+02:00) Gaza, Hebron'
}, {
  id: 63,
  zone: 'Africa/Johannesburg',
  offset: 120,
  val: '(UTC+02:00) Harare, Pretoria'
}, {
  id: 64,
  zone: 'Europe/Kiev',
  offset: 120,
  val: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius'
}, {
  id: 65,
  zone: 'Asia/Jerusalem',
  offset: 120,
  val: '(UTC+02:00) Jerusalem'
}, {
  id: 66,
  zone: 'Europe/Kaliningrad',
  offset: 120,
  val: '(UTC+02:00) Kaliningrad'
}, {
  id: 67,
  zone: 'Africa/Tripoli',
  offset: 120,
  val: '(UTC+02:00) Tripoli'
}, {
  id: 68,
  zone: 'Asia/Baghdad',
  offset: 180,
  val: '(UTC+03:00) Baghdad'
}, {
  id: 69,
  zone: 'Europe/Istanbul',
  offset: 180,
  val: '(UTC+03:00) Istanbul'
}, {
  id: 70,
  zone: 'Asia/Riyadh',
  offset: 180,
  val: '(UTC+03:00) Kuwait, Riyadh'
}, {
  id: 71,
  zone: 'Europe/Minsk',
  offset: 180,
  val: '(UTC+03:00) Minsk'
}, {
  id: 72,
  zone: 'Europe/Moscow',
  offset: 180,
  val: '(UTC+03:00) Moscow, St. Petersburg, Volgograd'
}, {
  id: 73,
  zone: 'Africa/Nairobi',
  offset: 180,
  val: '(UTC+03:00) Nairobi'
}, {
  id: 74,
  zone: 'Asia/Tehran',
  offset: 210,
  val: '(UTC+03:30) Tehran'
}, {
  id: 75,
  zone: 'Asia/Dubai',
  offset: 240,
  val: '(UTC+04:00) Abu Dhabi, Muscat'
}, {
  id: 76,
  zone: 'Europe/Astrakhan',
  offset: 240,
  val: '(UTC+04:00) Astrakhan, Ulyanovsk'
}, {
  id: 77,
  zone: 'Asia/Baku',
  offset: 240,
  val: '(UTC+04:00) Baku'
}, {
  id: 78,
  zone: 'Europe/Samara',
  offset: 240,
  val: '(UTC+04:00) Izhevsk, Samara'
}, {
  id: 79,
  zone: 'Indian/Mauritius',
  offset: 240,
  val: '(UTC+04:00) Port Louis'
}, {
  id: 80,
  zone: 'Europe/Saratov',
  offset: 240,
  val: '(UTC+04:00) Saratov'
}, {
  id: 81,
  zone: 'Asia/Tbilisi',
  offset: 240,
  val: '(UTC+04:00) Tbilisi'
}, {
  id: 82,
  zone: 'Asia/Yerevan',
  offset: 240,
  val: '(UTC+04:00) Yerevan'
}, {
  id: 83,
  zone: 'Asia/Kabul',
  offset: 270,
  val: '(UTC+04:30) Kabul'
}, {
  id: 84,
  zone: 'Asia/Tashkent',
  offset: 300,
  val: '(UTC+05:00) Ashgabat, Tashkent'
}, {
  id: 85,
  zone: 'Asia/Yekaterinburg',
  offset: 300,
  val: '(UTC+05:00) Ekaterinburg'
}, {
  id: 86,
  zone: 'Asia/Karachi',
  offset: 300,
  val: '(UTC+05:00) Islamabad, Karachi'
}, {
  id: 87,
  zone: 'Asia/Calcutta',
  offset: 330,
  val: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi'
}, {
  id: 88,
  zone: 'Asia/Colombo',
  offset: 330,
  val: '(UTC+05:30) Sri Jayawardenepura'
}, {
  id: 89,
  zone: 'Asia/Katmandu',
  offset: 345,
  val: '(UTC+05:45) Kathmandu'
}, {
  id: 90,
  zone: 'Asia/Almaty',
  offset: 360,
  val: '(UTC+06:00) Astana'
}, {
  id: 91,
  zone: 'Asia/Dhaka',
  offset: 360,
  val: '(UTC+06:00) Dhaka'
}, {
  id: 92,
  zone: 'Asia/Omsk',
  offset: 360,
  val: '(UTC+06:00) Omsk'
}, {
  id: 93,
  zone: 'Asia/Rangoon',
  offset: 390,
  val: '(UTC+06:30) Yangon (Rangoon)'
}, {
  id: 94,
  zone: 'Asia/Bangkok',
  offset: 420,
  val: '(UTC+07:00) Bangkok, Hanoi, Jakarta'
}, {
  id: 95,
  zone: 'Asia/Barnaul',
  offset: 420,
  val: '(UTC+07:00) Barnaul, Gorno-Altaysk'
}, {
  id: 96,
  zone: 'Asia/Hovd',
  offset: 420,
  val: '(UTC+07:00) Hovd'
}, {
  id: 97,
  zone: 'Asia/Krasnoyarsk',
  offset: 420,
  val: '(UTC+07:00) Krasnoyarsk'
}, {
  id: 98,
  zone: 'Asia/Novosibirsk',
  offset: 420,
  val: '(UTC+07:00) Novosibirsk'
}, {
  id: 99,
  zone: 'Asia/Tomsk',
  offset: 420,
  val: '(UTC+07:00) Tomsk'
}, {
  id: 100,
  zone: 'Asia/Shanghai',
  offset: 480,
  val: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi'
}, {
  id: 101,
  zone: 'Asia/Irkutsk',
  offset: 480,
  val: '(UTC+08:00) Irkutsk'
}, {
  id: 102,
  zone: 'Asia/Singapore',
  offset: 480,
  val: '(UTC+08:00) Kuala Lumpur, Singapore'
}, {
  id: 103,
  zone: 'Australia/Perth',
  offset: 480,
  val: '(UTC+08:00) Perth'
}, {
  id: 104,
  zone: 'Asia/Taipei',
  offset: 480,
  val: '(UTC+08:00) Taipei'
}, {
  id: 105,
  zone: 'Asia/Ulaanbaatar',
  offset: 480,
  val: '(UTC+08:00) Ulaanbaatar'
}, {
  id: 106,
  zone: 'Asia/Pyongyang',
  offset: 510,
  val: '(UTC+08:30) Pyongyang'
}, {
  id: 107,
  zone: 'Australia/Eucla',
  offset: 525,
  val: '(UTC+08:45) Eucla'
}, {
  id: 108,
  zone: 'Asia/Chita',
  offset: 540,
  val: '(UTC+09:00) Chita'
}, {
  id: 109,
  zone: 'Asia/Tokyo',
  offset: 540,
  val: '(UTC+09:00) Osaka, Sapporo, Tokyo'
}, {
  id: 110,
  zone: 'Asia/Seoul',
  offset: 540,
  val: '(UTC+09:00) Seoul'
}, {
  id: 111,
  zone: 'Asia/Yakutsk',
  offset: 540,
  val: '(UTC+09:00) Yakutsk'
}, {
  id: 112,
  zone: 'Australia/Adelaide',
  offset: 570,
  val: '(UTC+09:30) Adelaide'
}, {
  id: 113,
  zone: 'Australia/Darwin',
  offset: 570,
  val: '(UTC+09:30) Darwin'
}, {
  id: 114,
  zone: 'Australia/Brisbane',
  offset: 600,
  val: '(UTC+10:00) Brisbane'
}, {
  id: 115,
  zone: 'Australia/Sydney',
  offset: 600,
  val: '(UTC+10:00) Canberra, Melbourne, Sydney'
}, {
  id: 116,
  zone: 'Pacific/Port_Moresby',
  offset: 600,
  val: '(UTC+10:00) Guam, Port Moresby'
}, {
  id: 117,
  zone: 'Australia/Hobart',
  offset: 600,
  val: '(UTC+10:00) Hobart'
}, {
  id: 118,
  zone: 'Asia/Vladivostok',
  offset: 600,
  val: '(UTC+10:00) Vladivostok'
}, {
  id: 119,
  zone: 'Australia/Lord_Howe',
  offset: 630,
  val: '(UTC+10:30) Lord Howe Island'
}, {
  id: 120,
  zone: 'Pacific/Bougainville',
  offset: 660,
  val: '(UTC+11:00) Bougainville Island'
}, {
  id: 121,
  zone: 'Asia/Srednekolymsk',
  offset: 660,
  val: '(UTC+11:00) Chokurdakh'
}, {
  id: 122,
  zone: 'Asia/Magadan',
  offset: 660,
  val: '(UTC+11:00) Magadan'
}, {
  id: 123,
  zone: 'Pacific/Norfolk',
  offset: 660,
  val: '(UTC+11:00) Norfolk Island'
}, {
  id: 124,
  zone: 'Asia/Sakhalin',
  offset: 660,
  val: '(UTC+11:00) Sakhalin'
}, {
  id: 125,
  zone: 'Pacific/Guadalcanal',
  offset: 660,
  val: '(UTC+11:00) Solomon Is., New Caledonia'
}, {
  id: 126,
  zone: 'Asia/Kamchatka',
  offset: 720,
  val: '(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky'
}, {
  id: 127,
  zone: 'Pacific/Auckland',
  offset: 720,
  val: '(UTC+12:00) Auckland, Wellington'
}, {
  id: 128,
  zone: 'Etc/GMT-12',
  offset: 720,
  val: '(UTC+12:00) Coordinated Universal Time+12'
}, {
  id: 129,
  zone: 'Pacific/Fiji',
  offset: 720,
  val: '(UTC+12:00) Fiji'
}, {
  id: 130,
  zone: 'Asia/Kamchatka',
  offset: 720,
  val: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old'
}, {
  id: 131,
  zone: 'Pacific/Chatham',
  offset: 765,
  val: '(UTC+12:45) Chatham Islands'
}, {
  id: 132,
  zone: 'Etc/GMT-13',
  offset: 780,
  val: '(UTC+13:00) Coordinated Universal Time+13'
}, {
  id: 133,
  zone: 'Pacific/Tongatapu',
  offset: 780,
  val: '(UTC+13:00) Nuku alofa'
}, {
  id: 134,
  zone: 'Pacific/Apia',
  offset: 780,
  val: '(UTC+13:00) Samoa'
}, {
  id: 135,
  zone: 'Pacific/Kiritimati',
  offset: 840,
  val: '(UTC+14:00) Kiritimati Island'
}];
var SortOrder;
(function (SortOrder) {
  SortOrder["ASCENDING"] = "asc";
  SortOrder["DESCENDING"] = "desc";
})(SortOrder || (SortOrder = {}));
const CONTENT_BREAKPOINT_CLASS = 'content-bp-container';
/**
 * these values are also in Static/scss/wgc/common/_content-breakpoints.scss
 * and will also need to be updated there when these change
 */
const contentBreakpoints = [{
  size: 'XS',
  min: 0,
  max: 563.99
}, {
  size: 'SM',
  min: 564,
  max: 744.99
}, {
  size: 'MD',
  min: 745,
  max: 990.99
}, {
  size: 'LG',
  min: 991,
  max: 1170.99
}, {
  size: 'XL',
  min: 1171,
  max: Number.MAX_VALUE
}];
/**
 * This is deprecated and will be deleted soon, please use wg-directives/wgContainerQuery should be used instead
 */
class ContentBreakpointService {
  constructor() {
    this.elements = [];
    window.addEventListener('resize', event => {
      this.updateElementClasses();
    });
  }
  addElement(element, includePadding = false) {
    if (!element) {
      return;
    }
    const contentBreakpointElement = {
      element,
      includePadding
    };
    const currentIndex = this.elements.findIndex(value => {
      return value.element === element;
    });
    if (currentIndex === -1) {
      this.computeElementClass(contentBreakpointElement);
      this.elements.push(contentBreakpointElement);
    }
  }
  removeElement(element) {
    const elementIndex = this.elements.findIndex(contentBreakpointElement => {
      if (contentBreakpointElement.element === element) {
        return true;
      }
      return false;
    });
    if (elementIndex !== -1) {
      for (const contentBreakpoint of contentBreakpoints) {
        element.classList.remove(this.getClassName(contentBreakpoint.size));
      }
      this.elements.splice(elementIndex, 1);
    }
  }
  updateElementClasses() {
    if (this.throttleHandle !== undefined) {
      clearTimeout(this.throttleHandle);
      this.throttleHandle = undefined;
    }
    this.throttleHandle = setTimeout(() => {
      this.computeElementsClass();
    }, 250);
  }
  computeElementsClass() {
    this.elements.forEach(contentBreakpointElement => {
      this.computeElementClass(contentBreakpointElement);
    });
  }
  computeElementClass(contentBreakpointElement) {
    let size;
    const element = contentBreakpointElement.element;
    const computedStyle = window.getComputedStyle(element);
    let contentWidth = element.clientWidth;
    if (!contentBreakpointElement.includePadding) {
      contentWidth = contentWidth - (parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight));
    }
    for (const contentBreakpoint of contentBreakpoints) {
      element.classList.remove(this.getClassName(contentBreakpoint.size));
      if (contentWidth >= contentBreakpoint.min && contentWidth <= contentBreakpoint.max) {
        size = contentBreakpoint.size;
      }
    }
    if (size) {
      element.classList.add(this.getClassName(size));
    }
  }
  getClassName(size) {
    if (size) {
      return CONTENT_BREAKPOINT_CLASS + '-' + size.toLowerCase();
    }
    return '';
  }
  static {
    this.ɵfac = function ContentBreakpointService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ContentBreakpointService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ContentBreakpointService,
      factory: ContentBreakpointService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContentBreakpointService, [{
    type: Injectable
  }], () => [], null);
})();
const LANG_MAP = {
  en: 'en-US',
  ja: 'ja-JP',
  fr: 'fr-FR',
  es: 'es-419'
};
class HelpService {
  constructor(http, translate, router) {
    this.http = http;
    this.translate = translate;
    this.router = router;
    this.helpURL = 'help/help-links.json';
    this.defaultHelpLink = 'https://www.watchguard.com/help/docs/help-center/';
    this.getHelpInfo().subscribe(info => {
      if (info) {
        this.helpInfo = info;
      }
    });
  }
  getHelpContextURL() {
    const lang = LANG_MAP.en; // TODO: Add the correct locale when help supports it
    let contextURL = this.defaultHelpLink + lang + '/index.html';
    if (this.helpInfo) {
      // Get the route, replace any ID numbers w/ 0's
      const route = this.router.url;
      // Now, test the URLs
      let contextId = 0;
      for (const link in this.helpInfo) {
        if (this.helpInfo.hasOwnProperty(link)) {
          try {
            const linkRegExp = new RegExp(link);
            if (linkRegExp.test(route)) {
              contextId = this.helpInfo[link];
              break;
            }
          } catch (error) {
            console.error(error);
          }
        }
      }
      if (contextId === 0) {
        contextURL = this.helpInfo.url + lang + '/index.html';
      } else {
        contextURL = this.helpInfo.url + lang + '/index_CSH.html#' + contextId;
      }
    }
    return contextURL;
  }
  getHelpInfo() {
    return this.http.get(this.helpURL);
  }
  static {
    this.ɵfac = function HelpService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HelpService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i1$1.TranslateService), i0.ɵɵinject(i2$1.Router));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: HelpService,
      factory: HelpService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HelpService, [{
    type: Injectable
  }], () => [{
    type: i1.HttpClient
  }, {
    type: i1$1.TranslateService
  }, {
    type: i2$1.Router
  }], null);
})();
class LeftNavService {
  constructor() {
    this.primaryCollapsed = false;
    this.primaryCollapsedSubject = new Subject();
    this.leftNavDataSubject = new BehaviorSubject(new Array());
  }
  togglePrimaryCollapsed(collapsed, fromResizeEvent) {
    if (collapsed === undefined) {
      this.primaryCollapsed = !this.primaryCollapsed;
    } else {
      this.primaryCollapsed = collapsed;
    }
    const data = {
      collapsed: this.primaryCollapsed,
      fromResizeEvent
    };
    this.primaryCollapsedSubject.next(data);
  }
  setLeftNavData(data) {
    this.leftNavDataSubject.next(data);
  }
  static {
    this.ɵfac = function LeftNavService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LeftNavService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LeftNavService,
      factory: LeftNavService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LeftNavService, [{
    type: Injectable
  }], () => [], null);
})();
class LocaleResolverService {
  constructor(translateService) {
    this.translateService = translateService;
    this.bundlesBehindFeatureToggle = ['de-DE', 'de-AT', 'de-LI', 'de-LU', 'de-CH', 'de', 'es', 'es-ES'];
  }
  get userPrefLang() {
    const userPrefLanguage = this.translateService.getBrowserCultureLang();
    if (SUPPORTED_LOCALES.indexOf(userPrefLanguage) !== -1) {
      return this.checkForLocalesBehindFeatureToggle(userPrefLanguage);
    }
    return 'en';
  }
  // This is set in unified app, app.component.ts
  set loadFeatureToggledLocaleBundles(loadBundles) {
    this._loadFeatureToggledLocaleBundles = loadBundles;
  }
  /**
   * If client's default language is set to bundlesBehindFeatureToggle
   * and beta toggle to load the bundle is turned off,
   *  then load english bundle.
   * If beta toggle to load the bundle is turned on,
   *  then load the locale specific bundle
   *
   * This is applies to logged in account only
   * WCD-10188
   */
  checkForLocalesBehindFeatureToggle(userPrefLanguage) {
    if (this.bundlesBehindFeatureToggle.indexOf(userPrefLanguage) !== -1 && !this._loadFeatureToggledLocaleBundles) {
      return 'en';
    }
    return LOCALE_BUNDLE_MAP[userPrefLanguage];
  }
  static {
    this.ɵfac = function LocaleResolverService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LocaleResolverService)(i0.ɵɵinject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LocaleResolverService,
      factory: LocaleResolverService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocaleResolverService, [{
    type: Injectable
  }], () => [{
    type: i1$1.TranslateService
  }], null);
})();
const gridBreakpoints = [{
  size: 'XS',
  min: 0,
  max: 575.99
}, {
  size: 'SM',
  min: 576,
  max: 767.99
}, {
  size: 'MD',
  min: 768,
  max: 1279.99
}, {
  size: 'LG',
  min: 1280,
  max: 1599.99
}, {
  size: 'XL',
  min: 1600,
  max: Number.MAX_VALUE
}];
class ScreenService {
  constructor() {
    this.screenDimensions = {
      height: undefined,
      screenSize: undefined,
      width: undefined
    };
    this.screenDimensionsSubject = new BehaviorSubject(this.screenDimensions);
    this.computeScreenDimensions();
    window.addEventListener('resize', event => {
      this.updateScreenDimensions();
    });
  }
  updateScreenDimensions() {
    if (this.throttleHandle !== undefined) {
      clearTimeout(this.throttleHandle);
      this.throttleHandle = undefined;
    }
    this.throttleHandle = setTimeout(() => {
      this.computeScreenDimensions();
    }, 250);
  }
  computeScreenDimensions() {
    this.screenDimensions.height = window.innerHeight;
    this.screenDimensions.width = window.innerWidth;
    this.screenDimensions.screenSize = undefined;
    for (const gridBreakpoint of gridBreakpoints) {
      if (this.screenDimensions.width >= gridBreakpoint.min && this.screenDimensions.width <= gridBreakpoint.max) {
        this.screenDimensions.screenSize = gridBreakpoint.size;
        break;
      }
    }
    this.screenDimensionsSubject.next(this.screenDimensions);
  }
  static {
    this.ɵfac = function ScreenService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ScreenService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ScreenService,
      factory: ScreenService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ScreenService, [{
    type: Injectable
  }], () => [], null);
})();
class SecLeftNavService {
  constructor() {
    this.collapsed = false;
    this.exists = false;
    this.changes = new Subject();
  }
  sendChanges() {
    this.changes.next(new SecLeftNavChanges(this.exists, this.collapsed));
  }
  setExists(exists) {
    if (this.exists !== exists) {
      this.exists = exists;
      if (!this.exists) {
        this.collapsed = false;
      }
      this.sendChanges();
    }
  }
  toggleSecondaryCollapsed(collapsed) {
    if (collapsed === undefined) {
      this.collapsed = !this.collapsed;
      this.sendChanges();
    } else if (this.collapsed !== collapsed) {
      this.collapsed = collapsed;
      this.sendChanges();
    }
  }
  static {
    this.ɵfac = function SecLeftNavService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SecLeftNavService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SecLeftNavService,
      factory: SecLeftNavService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SecLeftNavService, [{
    type: Injectable
  }], () => [], null);
})();
class SecLeftNavChanges {
  constructor(exists, collapsed) {
    this.exists = exists;
    this.collapsed = collapsed;
  }
}
class WgServicesModule {
  static forRoot() {
    return {
      ngModule: WgServicesModule,
      providers: [ContentBreakpointService, HelpService, LeftNavService, LocaleResolverService, ScreenService, SecLeftNavService]
    };
  }
  static {
    this.ɵfac = function WgServicesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgServicesModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgServicesModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgServicesModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule]
    }]
  }], null, null);
})();
class WidgetDirective {
  constructor(viewContainerRef) {
    this.viewContainerRef = viewContainerRef;
  }
  static {
    this.ɵfac = function WidgetDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WidgetDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: WidgetDirective,
      selectors: [["", "wgc-widget", ""]],
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WidgetDirective, [{
    type: Directive,
    args: [{
      // eslint-disable-next-line @angular-eslint/directive-selector
      selector: '[wgc-widget]',
      standalone: false
    }]
  }], () => [{
    type: i0.ViewContainerRef
  }], null);
})();
class WgDirectiveModule {
  static {
    this.ɵfac = function WgDirectiveModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgDirectiveModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgDirectiveModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgDirectiveModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [WidgetDirective],
      exports: [WidgetDirective]
    }]
  }], null, null);
})();

/**
 * @license
 * Copyright WatchGuard Technologies Inc. All Rights Reserved.
 *
 * This module exports AppAssetManager class.
 *
 * This class holds all the asset related data loaded from
 * an external json file. (app-asset.json)
 *
 * This module is responsible for the following:
 *   a. Parse the data from the json file and make it available
 *      to callers
 *   b. Load app logo
 *   c. Load other details like color etc
 *
 */
class AppAssetManager {
  constructor() {}
  get appLogo() {
    if (this.assetData) {
      return this.assetData.logo;
    }
    return DEFAULT_APP_LOGO;
  }
  get appHeaderTitle() {
    if (this.assetData) {
      return this.assetData.header_title;
    }
    return '';
  }
  get appFooterTile() {
    if (this.assetData) {
      return this.assetData.footer_title;
    }
    return '';
  }
}

/**
 * @license
 * Copyright WatchGuard Technologies Inc. All Rights Reserved.
 *
 * This module exports ComponentManager class.
 *
 * This class holds all the component related data loaded from
 * an external json file. (app-data.json)
 *
 * This module is responsible for the following:
 *   a. Parse the data from the json file and make it available
 *      to callers
 *   b. Provide methods that allow caller to decide which
 *      components should be loaded
 *   c. Load components based on their location ie top, left etc
 *
 */
class ComponentManager {
  constructor() {
    this.widgetData = {};
    this.components = {};
    this.sectionMap = {
      [SHELL_TOP]: SHELL_TOP,
      [AUTH_CONFIGURE_NAV]: AUTH_ROOT,
      [AUTH_MONITOR_NAV]: AUTH_REP_ROOT,
      [FB_CONFIGURE_NAV]: FB_ROOT,
      [FB_MONITOR_NAV]: FB_ROOT,
      [INVENTORY_NAV]: INVENTORY_ROOT,
      [ACCOUNT_MGMT_ROOT]: ACCOUNT_MGMT_ROOT,
      [NOTIFICATIONS_ROOT]: NOTIFICATIONS_ROOT,
      [ADMINISTRATION_NAV]: ADMINISTRATION_ROOT,
      [FB_CONFIGURATION_WIDGETS]: null,
      [FIREWAN_DASHBOARD]: null,
      [TDR_CONFIGURE_NAV]: TDR_CONFIGURE_ROOT,
      [TDR_MONITOR_NAV]: TDR_MONITOR_ROOT,
      [FIREWAN_CONFIGURE_NAV]: FIREWAN_CONFIGURE_ROOT,
      [FIREWAN_MONITOR_NAV]: FIREWAN_MONITOR_ROOT,
      [THREATSYNC_CONFIGURE_NAV]: THREATSYNC_CONFIGURE_ROOT,
      [THREATSYNC_MONITOR_NAV]: THREATSYNC_MONITOR_ROOT,
      [NDR_CONFIGURE_NAV]: NDR_CONFIGURE_ROOT,
      [NDR_MONITOR_NAV]: NDR_MONITOR_ROOT
    };
  }
  initSecondayNav(section) {
    switch (section) {
      case SHELL_TOP:
        this.initShellNavigation();
        break;
      case AUTH_MONITOR_NAV:
      case AUTH_CONFIGURE_NAV:
      case FB_MONITOR_NAV:
      case INVENTORY_NAV:
      case ADMINISTRATION_NAV:
        this.initComponents(this.sectionMap[section]);
        break;
      default:
        break;
    }
  }
  getNavContent(section) {
    // return the cached content for the given section string
    // section = INVENTORY_NAV, AUTH_CONFIGURE_NAV, etc.
    return this.components[section];
  }
  updateWidgetData(data) {
    this.widgetData = {
      ...this.widgetData,
      ...data
    };
  }
  initShellNavigation() {
    const criteria = {};
    const criteriaTop = {};
    criteria[POSITION] = COMP_LOCATION_LEFT;
    criteria[RELEASE] = FOR_GA;
    criteriaTop[POSITION] = COMP_LOCATION_TOP;
    criteriaTop[RELEASE] = FOR_GA;
    const leftWidgets = this.getWidgetInfo(ROOT, criteria);
    // Primary navigation for Service Provider - Left side
    const leftSideNavComps = leftWidgets.filter(l => l.for_sp === true).map(l => ({
      data: {
        id: l.id,
        for_sp: l.for_sp,
        route: l.route,
        roles: l.roles,
        name: l.name,
        icon: l.icon,
        order: l.order,
        release: l.release
      }
    }));
    this.components[SHELL_LEFT] = leftSideNavComps;
    // Primary navigation for Subscriber - Horizontal
    const topSideNavComps = leftWidgets.filter(l => l.for_sp === false).map(l => ({
      id: l.id,
      for_sp: l.for_sp,
      route: l.route,
      roles: l.roles,
      name: l.name,
      top_nav_children: l.top_nav_children,
      icon: l.icon,
      order: l.order,
      release: l.release
    }));
    topSideNavComps.forEach(element => {
      const navList = this.getNavInfo(element.id, criteriaTop);
      element.top_nav_children = navList;
    });
    this.components[SHELL_TOP] = topSideNavComps;
    // Primary navigation for Service Provider / Subscriber - Top side
    const primaryNavComps = leftWidgets.filter(l => l.primary_nav === true).map(l => ({
      id: l.id,
      primary_nav: l.primary_nav,
      for_sp: l.for_sp,
      route: l.route,
      roles: l.roles,
      name: l.name,
      top_nav_children: l.top_nav_children,
      icon: l.icon,
      order: l.order,
      release: l.release
    }));
    primaryNavComps.forEach(element => {
      const navList = this.getNavInfo(element.id, criteriaTop);
      element.top_nav_children = navList;
    });
    this.components[SHELL_PRIMARY] = primaryNavComps;
  }
  initData(data, section) {
    this.updateWidgetData(data);
    this.initComponents(section);
  }
  initComponents(section) {
    const criteria = {};
    criteria[POSITION] = COMP_LOCATION_LEFT;
    criteria[RELEASE] = FOR_GA;
    const base = this.sectionMap[section];
    if (base) {
      const leftWidgets = this.getWidgetInfo(base, criteria);
      const m = leftWidgets.map(l => ({
        data: {
          id: l.id,
          route: l.route,
          roles: l.roles,
          name: l.name,
          children: l.children,
          order: l.order,
          release: l.release
        }
      }));
      this.components[section] = m;
    }
  }
  getNavInfo(compID, criteria = {}) {
    const data = this.widgetData;
    const navList = this.getTopNavChildren(data, compID);
    const navInfo = this.getFilteredComponentList(data, navList, true, criteria);
    return navInfo;
  }
  getWidgetInfo(compID, criteria = {}) {
    const data = this.widgetData;
    let widgets;
    let prepNestedNav = true;
    if (compID === ROOT) {
      prepNestedNav = false;
    }
    widgets = this.getChildren(data, compID);
    const fW = this.getFilteredComponentList(data, widgets, prepNestedNav, criteria);
    return fW;
  }
  /*
    Based on the criterias return a filtered list of components
  */
  getFilteredComponentList(data, compList, prepNestedNav, criteria) {
    // filter by criterias and then sort by order
    const v = compList.reduce((initVal, val) => {
      const vv = JSON.parse(JSON.stringify(data[val]));
      if (vv.position.indexOf(criteria.position) !== -1 && vv.release === criteria.release) {
        if (prepNestedNav) {
          const nestedChildren = vv.children;
          if (nestedChildren.length > 0) {
            const sC = {};
            sC[POSITION] = vv.position[0] === 'center' ? COMP_LOCATION_LEFT : vv.position[0];
            sC[RELEASE] = criteria[RELEASE];
            const fW = this.getFilteredComponentList(data, nestedChildren, prepNestedNav, sC);
            vv.children = fW;
          }
        }
        return initVal.concat(vv);
      } else {
        return initVal;
      }
    }, []);
    return v.sort((a, b) => a.order - b.order);
  }
  getChildren(data, parentID) {
    const children = data[parentID][CHILDREN];
    return children;
  }
  getTopNavChildren(data, parentID) {
    const children = data[parentID][TOP_NAV_CHILDREN];
    return children;
  }
}

/**
 * @license
 * Copyright WatchGuard Technologies Inc. All Rights Reserved.
 *
 * AppContentLoaderService loads the static files need by the app.
 * Also provides stub methods that other components can call
 * by injecting this services.
 *
 */
class AppContentLoaderService {
  constructor(http, leftNavService) {
    this.http = http;
    this.leftNavService = leftNavService;
    // An object to store all parent component ids with their
    // associated child components
    this.compObjs = {
      [AP_CONFIGURATION_WIDGETS]: {},
      [FB_CONFIGURATION_WIDGETS]: {},
      [FB_ROOT_DEVICE_SUMMARY]: {},
      [FIREWAN_DASHBOARD]: {},
      [INVENTORY_ROOT_NAV_OVERVIEW]: {},
      [INVENTORY_ROOT_TENANT_NAV_ACCESS_POINT]: {},
      [INVENTORY_ROOT_TENANT_NAV_FB]: {},
      [INVENTORY_ROOT_TENANT_NAV_OVERVIEW]: {},
      [OVERVIEW_DASHBOARD_CONFIGURE_AUTH]: {},
      [OVERVIEW_DASHBOARD_CONFIGURE_FB]: {},
      [OVERVIEW_DASHBOARD_CONFIGURE_TDR]: {},
      [OVERVIEW_DASHBOARD_MONITOR_AUTH]: {},
      [OVERVIEW_DASHBOARD_MONITOR_FB]: {},
      [OVERVIEW_DASHBOARD_MONITOR_TDR]: {},
      [OVERVIEW_DASHBOARD_MONITOR_FIREWAN]: {},
      [ROOT_ADMINISTRATION]: {},
      [ROOT_CONFIGURE_SERVICES]: {},
      [ROOT_DASHBOARD]: {},
      [ROOT_REPORTS]: {},
      [ROOT_SP_ADMINISTRATION]: {},
      [ROOT_SP_DASHBOARD]: {},
      [SP_TENANT_DASHBOARD_CONFIGURE_AUTH]: {},
      [SP_TENANT_DASHBOARD_CONFIGURE_FB]: {},
      [SP_TENANT_DASHBOARD_CONFIGURE_TDR]: {},
      [SP_TENANT_DASHBOARD_MONITOR_AUTH]: {},
      [SP_TENANT_DASHBOARD_MONITOR_FB]: {},
      [SP_TENANT_DASHBOARD_MONITOR_TDR]: {}
    };
    this.apConfigurationWidgetsComponent = this.compObjs[AP_CONFIGURATION_WIDGETS];
    this.fbConfigurationWidgetsComponent = this.compObjs[FB_CONFIGURATION_WIDGETS];
    this.fbDeviceSummaryComponents = this.compObjs[FB_ROOT_DEVICE_SUMMARY];
    this.firewanConfigurationWidgetsComponent = this.compObjs[FIREWAN_DASHBOARD];
    this.inventoryRootOverviewComponents = this.compObjs[INVENTORY_ROOT_NAV_OVERVIEW];
    this.inventoryRootTenantAccessPointComponents = this.compObjs[INVENTORY_ROOT_TENANT_NAV_ACCESS_POINT];
    this.inventoryRootTenantFbComponents = this.compObjs[INVENTORY_ROOT_TENANT_NAV_FB];
    this.inventoryRootTenantOverviewComponents = this.compObjs[INVENTORY_ROOT_TENANT_NAV_OVERVIEW];
    this.overviewDashboardConfigureAuthComponents = this.compObjs[OVERVIEW_DASHBOARD_CONFIGURE_AUTH];
    this.overviewDashboardConfigureFbComponents = this.compObjs[OVERVIEW_DASHBOARD_CONFIGURE_FB];
    this.overviewDashboardConfigureTdrComponents = this.compObjs[OVERVIEW_DASHBOARD_CONFIGURE_TDR];
    this.overviewDashboardMonitorAuthComponents = this.compObjs[OVERVIEW_DASHBOARD_MONITOR_AUTH];
    this.overviewDashboardMonitorFbComponents = this.compObjs[OVERVIEW_DASHBOARD_MONITOR_FB];
    this.overviewDashboardMonitorTdrComponents = this.compObjs[OVERVIEW_DASHBOARD_MONITOR_TDR];
    this.overviewDashboardMonitorFirewanComponents = this.compObjs[OVERVIEW_DASHBOARD_MONITOR_FIREWAN];
    this.rootAdministrationComponents = this.compObjs[ROOT_ADMINISTRATION];
    this.rootConfigureComponents = this.compObjs[ROOT_CONFIGURE_SERVICES];
    this.rootDashboardComponents = this.compObjs[ROOT_DASHBOARD];
    this.rootReportsComponents = this.compObjs[ROOT_REPORTS];
    this.rootSpAdministrationComponents = this.compObjs[ROOT_SP_ADMINISTRATION];
    this.rootSpDashboardComponents = this.compObjs[ROOT_SP_DASHBOARD];
    this.spTenantDashboardConfigureAuthComponents = this.compObjs[SP_TENANT_DASHBOARD_CONFIGURE_AUTH];
    this.spTenantDashboardConfigureFbComponents = this.compObjs[SP_TENANT_DASHBOARD_CONFIGURE_FB];
    this.spTenantDashboardConfigureTdrComponents = this.compObjs[SP_TENANT_DASHBOARD_CONFIGURE_TDR];
    this.spTenantDashboardMonitorAuthComponents = this.compObjs[SP_TENANT_DASHBOARD_MONITOR_AUTH];
    this.spTenantDashboardMonitorFbComponents = this.compObjs[SP_TENANT_DASHBOARD_MONITOR_FB];
    this.spTenantDashboardMonitorTdrComponents = this.compObjs[SP_TENANT_DASHBOARD_MONITOR_TDR];
    this.shellInitializedSubject = new BehaviorSubject(false);
    // object containing map of section names to BehaviorSubjects indicating
    // if the section has been loaded
    this.sectionInitialized = {
      [AUTH_MONITOR_NAV]: new BehaviorSubject(false),
      [AUTH_CONFIGURE_NAV]: new BehaviorSubject(false),
      [FB_MONITOR_NAV]: new BehaviorSubject(false),
      [INVENTORY_NAV]: new BehaviorSubject(false),
      [ADMINISTRATION_NAV]: new BehaviorSubject(false),
      [FB_CONFIGURATION_WIDGETS]: new BehaviorSubject(false),
      [TDR_CONFIGURE_NAV]: new BehaviorSubject(false),
      [TDR_MONITOR_NAV]: new BehaviorSubject(false),
      [FIREWAN_CONFIGURE_NAV]: new BehaviorSubject(false),
      [FIREWAN_MONITOR_NAV]: new BehaviorSubject(false),
      [FIREWAN_DASHBOARD]: new BehaviorSubject(false),
      [THREATSYNC_CONFIGURE_NAV]: new BehaviorSubject(false),
      [THREATSYNC_MONITOR_NAV]: new BehaviorSubject(false),
      [NDR_CONFIGURE_NAV]: new BehaviorSubject(false),
      [NDR_MONITOR_NAV]: new BehaviorSubject(false)
    };
    // tslint:disable-next-line:variable-name
    this._whiteList = {
      services: [],
      endpoints: [],
      skipUrls: []
    };
  }
  setWhiteList(value) {
    this._whiteList = value;
  }
  getWhiteList() {
    return this._whiteList;
  }
  updateSection(section) {
    // Firebox configure and monitor share the same JSON
    if (section === FB_CONFIGURE_NAV) {
      section = FB_MONITOR_NAV;
    }
    return section;
  }
  getSecondaryNavContent(section) {
    let content;
    section = this.updateSection(section);
    switch (section) {
      case SHELL_TOP:
      case SHELL_LEFT:
      case SHELL_PRIMARY:
      case AUTH_MONITOR_NAV:
      case AUTH_CONFIGURE_NAV:
      case FB_MONITOR_NAV:
      case INVENTORY_NAV:
      case ADMINISTRATION_NAV:
      case TDR_CONFIGURE_NAV:
      case TDR_MONITOR_NAV:
      case FIREWAN_CONFIGURE_NAV:
      case FIREWAN_MONITOR_NAV:
      case THREATSYNC_CONFIGURE_NAV:
      case THREATSYNC_MONITOR_NAV:
      case NDR_CONFIGURE_NAV:
      case NDR_MONITOR_NAV:
      case ACCOUNT_MGMT_ROOT:
      case NOTIFICATIONS_ROOT:
        if (this.appComponentManager) {
          content = this.appComponentManager.getNavContent(section);
        }
        break;
      default:
        break;
    }
    return content;
  }
  get shellLeftSection() {
    return this.getSecondaryNavContent(SHELL_LEFT);
  }
  get shellPrimaryNavigation() {
    return this.getSecondaryNavContent(SHELL_PRIMARY);
  }
  get shellTopNavSection() {
    return this.getSecondaryNavContent(SHELL_TOP);
  }
  get authLeftContent() {
    return this.getSecondaryNavContent(AUTH_CONFIGURE_NAV);
  }
  get authRepLeftContent() {
    return this.getSecondaryNavContent(AUTH_MONITOR_NAV);
  }
  get fbLeftContent() {
    return this.getSecondaryNavContent(FB_MONITOR_NAV);
  }
  get inventoryLeftContent() {
    return this.getSecondaryNavContent(INVENTORY_NAV);
  }
  get administrationLeftContent() {
    return this.getSecondaryNavContent(ADMINISTRATION_NAV);
  }
  get tdrConfigureLeftContent() {
    return this.getSecondaryNavContent(TDR_CONFIGURE_NAV);
  }
  get tdrMonitorLeftContent() {
    return this.getSecondaryNavContent(TDR_MONITOR_NAV);
  }
  get firewanConfigureLeftContent() {
    return this.getSecondaryNavContent(FIREWAN_CONFIGURE_NAV);
  }
  get firewanMonitorLeftContent() {
    return this.getSecondaryNavContent(FIREWAN_MONITOR_NAV);
  }
  get threatsyncConfigureLeftContent() {
    return this.getSecondaryNavContent(THREATSYNC_CONFIGURE_NAV);
  }
  get threatsyncMonitorLeftContent() {
    return this.getSecondaryNavContent(THREATSYNC_MONITOR_NAV);
  }
  get ndrConfigureLeftContent() {
    return this.getSecondaryNavContent(NDR_CONFIGURE_NAV);
  }
  get ndrMonitorLeftContent() {
    return this.getSecondaryNavContent(NDR_MONITOR_NAV);
  }
  get accountMgmtLeftContent() {
    return this.getSecondaryNavContent(ACCOUNT_MGMT_ROOT);
  }
  get notificationsLeftContent() {
    return this.getSecondaryNavContent(NOTIFICATIONS_ROOT);
  }
  getMainDashContent(criteria) {
    if (this.appComponentManager) {
      return this.appComponentManager.getWidgetInfo(ROOT_DASHBOARD, criteria);
    }
  }
  /**
   * Load the lists of child components for a specified parent
   * @param name - string id of the parent component
   * @param compService - service class with a getComps method to return the component data
   * @param release - release to match in returned component list (default: 'ga')
   * @param postitions - the array of positions to retrieve lists for (default: ['top'])
   */
  loadChildComponents(name, compService, release = FOR_GA, postitions = [COMP_LOCATION_TOP]) {
    if (this.appComponentManager) {
      const criteria = {};
      if (!this.compObjs.hasOwnProperty(name)) {
        // Create a new parent
        this.compObjs[name] = {};
      }
      criteria[RELEASE] = release;
      for (const position of postitions) {
        criteria[POSITION] = position;
        const widgetInfo = this.appComponentManager.getWidgetInfo(name, criteria);
        this.compObjs[name][position] = compService.getComps(widgetInfo);
      }
    }
  }
  loadFbDeviceSummaryComponents(compService) {
    this.loadChildComponents(FB_ROOT_DEVICE_SUMMARY, compService, FOR_GA, [COMP_LOCATION_CENTER]);
  }
  loadInventoryRootOverviewComponents(compService) {
    this.loadChildComponents(INVENTORY_ROOT_NAV_OVERVIEW, compService);
  }
  loadInventoryRootTenantOverviewComponents(compService) {
    this.loadChildComponents(INVENTORY_ROOT_TENANT_NAV_OVERVIEW, compService);
  }
  loadInventoryRootTenantFbComponents(compService) {
    this.loadChildComponents(INVENTORY_ROOT_TENANT_NAV_FB, compService);
  }
  loadInventoryRootTenantAccessPointComponents(compService) {
    this.loadChildComponents(INVENTORY_ROOT_TENANT_NAV_ACCESS_POINT, compService);
  }
  // ---- Init helper methods ----------------------------
  initShellData(data) {
    this.appComponentManager = new ComponentManager();
    this.appComponentManager.updateWidgetData(data);
    this.shellInitializedSubject.next(true);
  }
  initSideNav(forServiceProvider = false) {
    if (this.appComponentManager) {
      this.appComponentManager.initShellNavigation();
      if (forServiceProvider) {
        this.leftNavService.setLeftNavData(this.appComponentManager.components[SHELL_LEFT]);
      }
    }
  }
  initData(data, section) {
    section = this.updateSection(section);
    switch (section) {
      case SHELL_TOP:
        this.initSideNav(data);
        break;
      case AUTH_MONITOR_NAV:
      case AUTH_CONFIGURE_NAV:
      case FB_MONITOR_NAV:
      case FB_CONFIGURE_NAV:
      case INVENTORY_NAV:
      case ADMINISTRATION_NAV:
      case FB_CONFIGURATION_WIDGETS:
      case TDR_CONFIGURE_NAV:
      case TDR_MONITOR_NAV:
      case FIREWAN_MONITOR_NAV:
      case FIREWAN_CONFIGURE_NAV:
      case FIREWAN_DASHBOARD:
      case THREATSYNC_MONITOR_NAV:
      case THREATSYNC_CONFIGURE_NAV:
      case NDR_MONITOR_NAV:
      case NDR_CONFIGURE_NAV:
        if (this.appComponentManager) {
          this.appComponentManager.initData(data, section);
          this.setInitialized(section);
        }
        break;
      default:
        break;
    }
  }
  initAuthData(data) {
    this.initData(data, AUTH_CONFIGURE_NAV);
  }
  initAuthRepData(data) {
    this.initData(data, AUTH_MONITOR_NAV);
  }
  initFbData(data) {
    this.initData(data, FB_MONITOR_NAV);
  }
  initAccountMgmtData(data) {
    this.initData(data, ACCOUNT_MGMT_ROOT);
  }
  initNotificationsData(data) {
    this.initData(data, NOTIFICATIONS_ROOT);
  }
  initInventoryData(data) {
    this.initData(data, INVENTORY_NAV);
  }
  initTdrConfigureData(data) {
    this.initData(data, TDR_CONFIGURE_NAV);
  }
  initTdrMonitorData(data) {
    this.initData(data, TDR_MONITOR_NAV);
  }
  initFireWANConfigureData(data) {
    this.initData(data, FIREWAN_CONFIGURE_NAV);
  }
  initFireWANMonitorData(data) {
    this.initData(data, FIREWAN_MONITOR_NAV);
  }
  initThreatSyncConfigureData(data) {
    this.initData(data, THREATSYNC_CONFIGURE_NAV);
  }
  initThreatSyncMonitorData(data) {
    this.initData(data, THREATSYNC_MONITOR_NAV);
  }
  initNdrConfigureData(data) {
    this.initData(data, NDR_CONFIGURE_NAV);
  }
  initNdrMonitorData(data) {
    this.initData(data, NDR_MONITOR_NAV);
  }
  initAdministrationNavData(data) {
    this.initData(data, ADMINISTRATION_NAV);
  }
  initFbConfigData(data) {
    this.initData(data, FB_CONFIGURATION_WIDGETS);
  }
  initFireWANDashboardData(data) {
    this.initData(data, FIREWAN_DASHBOARD);
  }
  initDashboardData(compService) {
    this.loadChildComponents(ROOT_DASHBOARD, compService, FOR_GA, [COMP_LOCATION_TOP, COMP_LOCATION_BOTTOM]);
  }
  initSpDashboardData(compService) {
    this.loadChildComponents(ROOT_SP_DASHBOARD, compService);
  }
  initOverviewDashboardMonitorAuthData(compService) {
    this.loadChildComponents(OVERVIEW_DASHBOARD_MONITOR_AUTH, compService);
  }
  initOverviewDashboardConfigureAuthData(compService) {
    this.loadChildComponents(OVERVIEW_DASHBOARD_CONFIGURE_AUTH, compService);
  }
  initSpTenantDashboardMonitorAuthData(compService) {
    this.loadChildComponents(SP_TENANT_DASHBOARD_MONITOR_AUTH, compService);
  }
  initSpTenantDashboardConfigureAuthData(compService) {
    this.loadChildComponents(SP_TENANT_DASHBOARD_CONFIGURE_AUTH, compService);
  }
  initOverviewDashboardMonitorTdrData(compService) {
    this.loadChildComponents(OVERVIEW_DASHBOARD_MONITOR_TDR, compService);
  }
  initOverviewDashboardConfigureTdrData(compService) {
    this.loadChildComponents(OVERVIEW_DASHBOARD_CONFIGURE_TDR, compService);
  }
  initSpTenantDashboardMonitorTdrData(compService) {
    this.loadChildComponents(SP_TENANT_DASHBOARD_MONITOR_TDR, compService);
  }
  initSpTenantDashboardConfigureTdrData(compService) {
    this.loadChildComponents(SP_TENANT_DASHBOARD_CONFIGURE_TDR, compService);
  }
  initOverviewDashboardMonitorFbData(compService) {
    this.loadChildComponents(OVERVIEW_DASHBOARD_MONITOR_FB, compService);
  }
  initOverviewDashboardConfigureFbData(compService) {
    this.loadChildComponents(OVERVIEW_DASHBOARD_CONFIGURE_FB, compService);
  }
  initOverviewDashboardMonitorFirewanData(compService) {
    this.loadChildComponents(OVERVIEW_DASHBOARD_MONITOR_FIREWAN, compService);
  }
  initSpTenantDashboardMonitorFbData(compService) {
    this.loadChildComponents(SP_TENANT_DASHBOARD_MONITOR_FB, compService);
  }
  initSpTenantDashboardConfigureFbData(compService) {
    this.loadChildComponents(SP_TENANT_DASHBOARD_CONFIGURE_FB, compService);
  }
  initReportsData(compService) {
    this.loadChildComponents(ROOT_REPORTS, compService);
  }
  initServicesData(compService) {
    this.loadChildComponents(ROOT_CONFIGURE_SERVICES, compService);
  }
  initAdministrationData(compService) {
    this.loadChildComponents(ROOT_ADMINISTRATION, compService, FOR_GA, [COMP_LOCATION_CENTER, COMP_LOCATION_LEFT]);
  }
  initSpAdministrationData(compService) {
    this.loadChildComponents(ROOT_SP_ADMINISTRATION, compService, FOR_GA, [COMP_LOCATION_CENTER, COMP_LOCATION_LEFT]);
  }
  initFbWidgetsData(compService) {
    this.loadChildComponents(FB_ROOT_DEVICE_SUMMARY, compService, FOR_GA, [COMP_LOCATION_CENTER]);
  }
  initInventoryOverviewWidgetsData(compService) {
    this.loadChildComponents(INVENTORY_ROOT_NAV_OVERVIEW, compService);
  }
  initInventoryTenantOverviewWidgetsData(compService) {
    this.loadChildComponents(INVENTORY_ROOT_TENANT_NAV_OVERVIEW, compService);
  }
  initInventoryTenantFbWidgetsData(compService) {
    this.loadChildComponents(INVENTORY_ROOT_TENANT_NAV_FB, compService);
  }
  initInventoryTenantAccessPointWidgetsData(compService) {
    this.loadChildComponents(INVENTORY_ROOT_TENANT_NAV_ACCESS_POINT, compService);
  }
  initFbConfigWidgetsData(compService) {
    this.loadChildComponents(FB_CONFIGURATION_WIDGETS, compService);
  }
  initApConfigWidgetsData(compService) {
    this.loadChildComponents(AP_CONFIGURATION_WIDGETS, compService);
  }
  initFireWANDashboardsData(compService) {
    this.loadChildComponents(FIREWAN_DASHBOARD, compService);
  }
  isShellInitialized() {
    return this.shellInitializedSubject.asObservable();
  }
  setInitialized(section) {
    this.sectionInitialized[section].next(true);
  }
  isSectionInitialized(section) {
    return this.sectionInitialized[section].getValue();
  }
  isAuthInitialized() {
    return this.isSectionInitialized(AUTH_CONFIGURE_NAV);
  }
  isAuthRepInitialized() {
    return this.isSectionInitialized(AUTH_MONITOR_NAV);
  }
  isFbInitialized() {
    return this.isSectionInitialized(FB_MONITOR_NAV);
  }
  isAcntMgmtInitialized() {
    return this.isSectionInitialized(ACCOUNT_MGMT_ROOT);
  }
  isNotificationsInitialized() {
    return this.isSectionInitialized(NOTIFICATIONS_ROOT);
  }
  isInventoryInitialized() {
    return this.isSectionInitialized(INVENTORY_NAV);
  }
  isAdministrationInitialized() {
    return this.isSectionInitialized(ADMINISTRATION_NAV);
  }
  isFbConfigurationInitialized() {
    return this.isSectionInitialized(FB_CONFIGURATION_WIDGETS);
  }
  isFireWANDashboardInitialized() {
    return this.isSectionInitialized(FIREWAN_DASHBOARD);
  }
  isTdrConfigureInitialized() {
    return this.isSectionInitialized(TDR_CONFIGURE_NAV);
  }
  isTdrMonitorInitialized() {
    return this.isSectionInitialized(TDR_MONITOR_NAV);
  }
  isFireWANConfigureInitialized() {
    return this.isSectionInitialized(FIREWAN_CONFIGURE_NAV);
  }
  isFireWANMonitorInitialized() {
    return this.isSectionInitialized(FIREWAN_MONITOR_NAV);
  }
  isThreatSyncConfigureInitialized() {
    return this.isSectionInitialized(THREATSYNC_CONFIGURE_NAV);
  }
  isThreatSyncNMonitorInitialized() {
    return this.isSectionInitialized(THREATSYNC_MONITOR_NAV);
  }
  isNdrConfigureInitialized() {
    return this.isSectionInitialized(NDR_CONFIGURE_NAV);
  }
  isNdrMonitorInitialized() {
    return this.isSectionInitialized(NDR_MONITOR_NAV);
  }
  // -------------- Asset related ---------------
  initAppAssets(data) {
    this.appAssetManager = new AppAssetManager();
    this.appAssetManager.assetData = data;
  }
  get appLogo() {
    if (this.appAssetManager) {
      return this.appAssetManager.appLogo;
    }
  }
  get appHeaderTitle() {
    if (this.appAssetManager) {
      return this.appAssetManager.appHeaderTitle;
    }
  }
  get appFooterTitle() {
    if (this.appAssetManager) {
      return this.appAssetManager.appFooterTile;
    }
  }
  loadData(section) {
    let sectionUrl;
    switch (section) {
      case SHELL_TOP:
        sectionUrl = APP_SHELL_DATA_API;
        break;
      case AUTH_MONITOR_NAV:
        sectionUrl = APP_AUTH_REP_DATA_API;
        break;
      case AUTH_CONFIGURE_NAV:
        sectionUrl = APP_AUTH_DATA_API;
        break;
      case FB_MONITOR_NAV:
        sectionUrl = APP_FB_DATA_API;
        break;
      case FB_CONFIGURE_NAV:
        sectionUrl = APP_FB_DATA_API;
        break;
      case INVENTORY_NAV:
        sectionUrl = APP_INVENTORY_DATA_API;
        break;
      case ADMINISTRATION_NAV:
        sectionUrl = APP_ADMINISTRATION_DATA_API;
        break;
      case FB_CONFIGURATION_WIDGETS:
        sectionUrl = APP_FB_CONFIGURATION_DATA_API;
        break;
      case TDR_CONFIGURE_NAV:
        sectionUrl = APP_TDR_CONFIGURE_DATA_API;
        break;
      case TDR_MONITOR_NAV:
        sectionUrl = APP_TDR_MONITOR_DATA_API;
        break;
      case FIREWAN_CONFIGURE_NAV:
        sectionUrl = APP_FIREWAN_CONFIGURE_DATA_API;
        break;
      case FIREWAN_MONITOR_NAV:
        sectionUrl = APP_FIREWAN_MONITOR_DATA_API;
        break;
      case FIREWAN_DASHBOARD:
        sectionUrl = APP_FIREWAN_CONFIGURE_DATA_API;
        break;
      case THREATSYNC_CONFIGURE_NAV:
        sectionUrl = APP_THREATSYNC_CONFIGURE_DATA_API;
        break;
      case THREATSYNC_MONITOR_NAV:
        sectionUrl = APP_THREATSYNC_MONITOR_DATA_API;
        break;
      case NDR_CONFIGURE_NAV:
        sectionUrl = APP_NDR_CONFIGURE_DATA_API;
        break;
      case NDR_MONITOR_NAV:
        sectionUrl = APP_NDR_MONITOR_DATA_API;
        break;
      default:
        break;
    }
    return this.loadJsonData(sectionUrl);
  }
  loadJsonData(filename) {
    return this.http.get(filename).pipe(catchError(error => {
      const msg = `Error loading JSON data from ${filename}: ${error.message}`;
      console.error(error.error);
      return throwError(() => new Error(msg));
    }));
  }
  loadWhitelistData() {
    return this.loadJsonData(APP_WHITELIST_DATA_API);
  }
  loadShellData() {
    return this.loadJsonData(APP_SHELL_DATA_API);
  }
  loadAppAssets() {
    return this.loadJsonData(APP_ASSETS_API);
  }
  loadAuthData() {
    return this.loadJsonData(APP_AUTH_DATA_API);
  }
  loadAuthRepData() {
    return this.loadJsonData(APP_AUTH_REP_DATA_API);
  }
  loadFbData() {
    return this.loadJsonData(APP_FB_DATA_API);
  }
  loadAccountMgmtData() {
    return this.loadJsonData(APP_ACCOUNT_MGMT_DATA_API);
  }
  loadNotificationsData() {
    return this.loadJsonData(APP_NOTIFICATIONS_DATA_API);
  }
  loadInventoryData() {
    return this.loadJsonData(APP_INVENTORY_DATA_API);
  }
  loadTdrConfigureData() {
    return this.loadJsonData(APP_TDR_CONFIGURE_DATA_API);
  }
  loadTdrMonitorData() {
    return this.loadJsonData(APP_TDR_MONITOR_DATA_API);
  }
  loadFireWANConfigureData() {
    return this.loadJsonData(APP_FIREWAN_CONFIGURE_DATA_API);
  }
  loadFireWANMonitorData() {
    return this.loadJsonData(APP_FIREWAN_MONITOR_DATA_API);
  }
  loadThreatSyncConfigureData() {
    return this.loadJsonData(APP_THREATSYNC_CONFIGURE_DATA_API);
  }
  loadThreatSyncMonitorData() {
    return this.loadJsonData(APP_THREATSYNC_MONITOR_DATA_API);
  }
  static {
    this.ɵfac = function AppContentLoaderService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AppContentLoaderService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(LeftNavService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AppContentLoaderService,
      factory: AppContentLoaderService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AppContentLoaderService, [{
    type: Injectable
  }], () => [{
    type: i1.HttpClient
  }, {
    type: LeftNavService
  }], null);
})();
class WidgetItem {
  constructor(component, data = {}) {
    this.component = component;
    this.data = data;
  }
}
class MainContentComponent {
  constructor(componentFactoryResolver) {
    this.componentFactoryResolver = componentFactoryResolver;
  }
  ngOnInit() {
    this.loadComponent();
  }
  loadComponent() {
    if (this.widget) {
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.widget.component);
      const viewContainerRef = this.wgcWidget.viewContainerRef;
      viewContainerRef.clear();
      const componentRef = viewContainerRef.createComponent(componentFactory);
      componentRef.instance.data = this.widget.data;
    }
  }
  static {
    this.ɵfac = function MainContentComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MainContentComponent)(i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MainContentComponent,
      selectors: [["wgc-main-content"]],
      viewQuery: function MainContentComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(WidgetDirective, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.wgcWidget = _t.first);
        }
      },
      inputs: {
        widget: "widget"
      },
      standalone: false,
      decls: 2,
      vars: 1,
      consts: [[3, "id"], ["wgc-widget", ""]],
      template: function MainContentComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, MainContentComponent_ng_template_1_Template, 0, 0, "ng-template", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵpropertyInterpolate("id", ctx.widget.data.id);
        }
      },
      dependencies: [WidgetDirective],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MainContentComponent, [{
    type: Component,
    args: [{
      // eslint-disable-next-line @angular-eslint/component-selector
      selector: 'wgc-main-content',
      template: `
  <div id="{{ widget.data.id }}">
    <ng-template wgc-widget></ng-template>
  </div>
  `,
      standalone: false
    }]
  }], () => [{
    type: i0.ComponentFactoryResolver
  }], {
    widget: [{
      type: Input
    }],
    wgcWidget: [{
      type: ViewChild,
      args: [WidgetDirective, {
        static: true
      }]
    }]
  });
})();
class MainContentModule {
  static {
    this.ɵfac = function MainContentModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MainContentModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MainContentModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, WgDirectiveModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MainContentModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, WgDirectiveModule],
      declarations: [MainContentComponent],
      exports: [MainContentComponent]
    }]
  }], null, null);
})();
class DeviceService {
  constructor() {
    this.selectedDeviceSubject = new BehaviorSubject(undefined);
    this.deviceSummarySubject = new BehaviorSubject(false);
    // Use this to track which section user is in (reports or services)
    // Make it private so that someone cannot directly change it
    // https://blog.angulartraining.com/rxjs-subjects-a-tutorial-4dcce0e9637f
    this.selectedSectionSubject$ = new Subject();
    this.defaultRootRoutes = [
    // Service Provider
    {
      monitor: `sp/subscriber/reports/$acntID/fb/devices/summary`,
      configure: `sp/subscriber/services/$acntID/fb/devices/configure`
    },
    // Subscriber
    {
      monitor: `reports/fb/devices/summary`,
      configure: `services/fb/devices/configure`
    },
    // local
    {
      monitor: `devices/summary`,
      configure: `devices/configure`
    },
    // SP nav mode
    {
      monitor: `ss-tenant/reports/$acntID/fb/devices/summary`,
      configure: `ss-tenant/services/$acntID/fb/devices/configure`
    }];
    this.tenantRoute = '/sp/subscriber/';
    this.spTenantRoute = '/ss-tenant/';
    this.devicesOnlyRoute = '/devices/';
    this.deviceOnlyRoute = '/device/';
    this.devicesFbRoute = `/fb${this.devicesOnlyRoute}`;
    this.deviceFbRoute = `/fb${this.deviceOnlyRoute}`;
    this.selectedSectionObservable$ = this.selectedSectionSubject$.asObservable();
    this.reloadDevicesSubject = new BehaviorSubject({});
  }
  set currentDefaultRoute(route) {
    this.curDefaultRoute = route;
  }
  get currentDefaultRoute() {
    return this.curDefaultRoute;
  }
  setSelectedDevice(selectedDevice) {
    this.selectedDevice = selectedDevice;
    this.selectedDeviceSubject.next(this.selectedDevice);
  }
  deviceSummaryContentsLoaded(loaded) {
    this.deviceSummarySubject.next(loaded);
  }
  setSelectedSection(section) {
    this.curSection = section;
    this.selectedSectionSubject$.next(section);
  }
  /**
   * Check if passed in folder id is root or not
   * Root will always have id same as account id which is
   * a string.
   *
   * Note: Deprecated. Will be removed later.
   *
   * @param id account_id or device_id
   */
  isRoot(id) {
    return isNaN(id);
  }
  getDefaultRootRoute(accountID) {
    let defaultRootRoute;
    if (this.userInSubscriberTenantPg()) {
      this.defaultRoute(0); // SP mode
      defaultRootRoute = this.defaultRoute(0);
      defaultRootRoute = defaultRootRoute.replace('$acntID', accountID);
    } else if (this.devMode()) {
      defaultRootRoute = this.defaultRoute(2);
    } else {
      defaultRootRoute = this.defaultRoute(1);
    }
    return defaultRootRoute;
  }
  /**
   *
   * section:
   *     can be either reports(Monitor button) or services (Configure button) in UI
   * subPage:
   *     can be summary, configure, configuration/aliases etc end out the URL
   *     that identifies the actual page user is routing to.
   *
   * Subscriber examples:
   * /reports/fb/device/11118/summary
   *     (section: reports, subPage: summary)
   * /reports/fb/devices/pf
   *     (section: reports, subPage: pf)
   * /services/fb/devices/configure
   *     (section: services, subPage: configure)
   *
   * Service Provider examples:
   * /sp/subscriber/reports/ACC-1132322/fb/devices/summary
   *     (section: reports, subPage: summary)
   * /sp/subscriber/services/ACC-1132322/fb/device/10845/deploy_history
   *     (section: services, subPage: deploy_history)
   *
   */
  getAbsoluteURL(section, subPage, currentUrl) {
    let tmpSection = section;
    let tmpTenantRoute = '';
    let tmpDevicesFbRoute = '';
    let devicesFbRoute = this.devicesFbRoute;
    let deviceFbRoute = this.deviceFbRoute;
    let acntID = '';
    if (this.devMode()) {
      tmpSection = '';
      devicesFbRoute = this.devicesOnlyRoute;
      deviceFbRoute = this.deviceOnlyRoute;
    }
    const userInTenantRoute = currentUrl.indexOf(this.tenantRoute) !== -1;
    const userInSpTenantRoute = currentUrl.indexOf(this.spTenantRoute) !== -1;
    if (userInTenantRoute || userInSpTenantRoute) {
      // /sp/subscriber/services/ OR /sp/subscriber/reports/ OR
      // /ss-tenant/services/ OR /tenant/reports/
      tmpSection = '';
      acntID = this.extractAcntID(currentUrl);
    }
    if (userInTenantRoute) {
      tmpTenantRoute = this.tenantRoute + section + '/';
    } else if (userInSpTenantRoute) {
      tmpTenantRoute = this.spTenantRoute + section;
    }
    if (currentUrl.indexOf(devicesFbRoute) === -1 && currentUrl.indexOf(deviceFbRoute) !== -1) {
      tmpDevicesFbRoute = `${deviceFbRoute}${this.extractDeviceID(currentUrl, deviceFbRoute, deviceFbRoute.length)}/`;
    } else {
      tmpDevicesFbRoute = devicesFbRoute;
    }
    return tmpSection + tmpTenantRoute + acntID + tmpDevicesFbRoute + subPage;
  }
  // --------------- Private methods -------------------------------
  defaultRoute(mode) {
    const curSectionIsReports = this.curSection === 'reports';
    const defaultRoute = curSectionIsReports ? this.defaultRootRoutes[mode].monitor : this.defaultRootRoutes[mode].configure;
    return defaultRoute;
  }
  devMode() {
    return !(this.userInMonitorPg() || this.userInReportsPg());
  }
  userInMonitorPg() {
    if (!this.currentDefaultRoute) {
      return false;
    }
    return this.currentDefaultRoute.indexOf('/services/') !== -1;
  }
  userInReportsPg() {
    if (!this.currentDefaultRoute) {
      return false;
    }
    return this.currentDefaultRoute.indexOf('/reports/') !== -1;
  }
  userInSubscriberTenantPg() {
    if (!this.currentDefaultRoute) {
      return false;
    }
    return this.currentDefaultRoute.indexOf('/sp/subscriber/') !== -1 || this.currentDefaultRoute.indexOf('/ss-tenant/') !== -1;
  }
  extractAcntID(currentUrl) {
    let acntID;
    // EG: currentUrl 'sp/subscriber/reports/ACC-1132322/fb/devices/summary'
    // We know for tenant drill down mode '/fb/' always exists
    // Extract the index from currentUrl upto '/fb'; 33
    const indexUptoFbStr = currentUrl.indexOf('/fb/');
    // Extract the route from beginning till indexUpToFbStr
    // 'sp/subscriber/reports/ACC-1132322'
    const urlTillAcntID = currentUrl.substring(0, indexUptoFbStr);
    // Now extract the accountID from urlTillAcntID str
    acntID = urlTillAcntID.substring(urlTillAcntID.lastIndexOf('/') + 1);
    return acntID;
  }
  extractDeviceID(currentUrl, deviceRoute, deviceFbRouteLen) {
    let devID;
    // Eg: reports/fb/device/11118/summary OR
    // services/fb/device/11118/configuration/aliases
    // sp/subscriber/reports/ACC-1132322/fb/device/10274/summary OR
    // sp/subscriber/services/ACC-1132322/fb/device/10274/configure OR
    // ss-tenant/reports/WGC-1-042603e54b0a462da23d/fb/device/FB-12809/summary OR
    // ss-tenant/services/WGC-1-042603e54b0a462da23d/fb/device/FB-12809/configure
    // We know if user selects a sub-folder or a device
    // route WILL HAVE  '/device/fb/' always.
    // Extract the index from currentUrl upto '/fb'
    const indexUptoFbStr = currentUrl.indexOf(deviceRoute);
    // Extract string starting from deviceID;
    // since we know device ID always comes after /fb/device/
    // "11118/summary"
    const strStartingWithDevID = currentUrl.substring(indexUptoFbStr + deviceFbRouteLen);
    // Extract device ID from "11118/summary"
    devID = strStartingWithDevID.split('/')[0];
    return devID;
  }
  // used in the new SP nav
  reloadDevices(reload, deviceID) {
    this.reloadDevicesSubject.next({
      reload,
      deviceID
    });
  }
  static {
    this.ɵfac = function DeviceService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DeviceService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: DeviceService,
      factory: DeviceService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DeviceService, [{
    type: Injectable
  }], () => [], null);
})();
class GlobalEventService {
  constructor() {
    this.documentClicked = new Subject();
    this.windowResized = new Subject();
    this.documentClick$ = fromEvent(document, 'click').subscribe(event => {
      this.onClick(event);
    });
    this.windowResize$ = fromEvent(window, 'resize').pipe(throttleTime(250, undefined, {
      leading: true,
      trailing: true
    })).subscribe(event => {
      this.onResize(event);
    });
  }
  ngOnDestroy() {
    if (this.documentClick$) {
      this.documentClick$.unsubscribe();
    }
    if (this.windowResize$) {
      this.windowResize$.unsubscribe();
    }
  }
  onClick(event) {
    this.documentClicked.next(event);
  }
  onResize(event) {
    this.windowResized.next(event);
  }
  static {
    this.ɵfac = function GlobalEventService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GlobalEventService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GlobalEventService,
      factory: GlobalEventService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GlobalEventService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
class DeviceBannerComponent {
  constructor(deviceService, router, translateService) {
    this.deviceService = deviceService;
    this.router = router;
    this.translateService = translateService;
    this.firstLabel = 'ui_title_monitor';
    this.secondLabel = 'configure_lbl';
    this.firstRoute = 'summary';
    this.secondRoute = 'configure';
    this.firstActive = true;
    this.secondActive = false;
    this.subscriptions$ = new Subscription();
  }
  ngOnChanges(changes) {
    if (changes.firstActive || changes.secondActive) {
      let curSection = 'reports';
      if (changes.secondActive.currentValue) {
        curSection = 'configure';
      }
      this.deviceService.setSelectedSection(curSection);
    }
  }
  ngOnDestroy() {
    if (this.subscriptions$ != null) {
      this.subscriptions$.unsubscribe();
    }
  }
  ngOnInit() {
    const liveStatusTypes = ['firebox', 'cluster'];
    this.subscriptions$.add(this.deviceService.selectedDeviceSubject.subscribe(selectedDevice => {
      this.selectedDevice = selectedDevice;
      if (selectedDevice != null && selectedDevice.data != null && liveStatusTypes.includes(selectedDevice.data.node_type)) {
        this.showLiveStatus = selectedDevice.status === 'device-online';
        this.showConfigureMonitor = false;
      } else {
        this.showLiveStatus = false;
        this.showConfigureMonitor = true;
      }
    }));
  }
  getRouterLink(section, subPage) {
    const currentUrl = this.router.url;
    const tenantRoute = '/sp/subscriber/';
    const spTenantRoute = '/ss-tenant/';
    const userInTenantRoute = currentUrl.indexOf(tenantRoute) !== -1;
    const userInSpTenantRoute = currentUrl.indexOf(spTenantRoute) !== -1;
    if (userInTenantRoute || userInSpTenantRoute) {
      if (section != null && !section.endsWith('/')) {
        section += '/';
      }
    } else {
      if (section != null && section.endsWith('/')) {
        section = section.trim().substring(0, section.trim().length - 1);
      }
    }
    return this.deviceService.getAbsoluteURL(section, subPage, currentUrl);
  }
  openLiveStatus() {
    const liveStatusLink = this.getRouterLink('live_status_popout', '');
    const liveStatusTarget = `wgc-livestatus-popup-${this.selectedDevice.id}`;
    const popoutWindow = window.open(liveStatusLink, liveStatusTarget, 'location=no,menubar=no,status=no,toolbar=no');
    if (popoutWindow == null) {
      alert(this.translateService.instant('device_banner_live_status_popout_blocked'));
    }
  }
  static {
    this.ɵfac = function DeviceBannerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DeviceBannerComponent)(i0.ɵɵdirectiveInject(DeviceService), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DeviceBannerComponent,
      selectors: [["wg-device-banner"]],
      inputs: {
        title: "title",
        deviceId: "deviceId",
        firstLabel: "firstLabel",
        secondLabel: "secondLabel",
        firstRoute: "firstRoute",
        secondRoute: "secondRoute",
        firstActive: "firstActive",
        secondActive: "secondActive"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 5,
      vars: 6,
      consts: [[1, "section-title", 3, "ngClass"], [1, "fs-block"], [4, "ngIf"], [1, "right"], [3, "click"], ["name", "open-tab", 1, "size-20", "color-snow", "wg-ml-10"], [1, "navigation-buttons"], ["type", "button", 1, "btn", 3, "ngClass", "routerLink"]],
      template: function DeviceBannerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "h2", 0)(1, "span", 1);
          i0.ɵɵtext(2);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(3, DeviceBannerComponent_ng_container_3_Template, 5, 0, "ng-container", 2)(4, DeviceBannerComponent_ng_container_4_Template, 8, 14, "ng-container", 2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c17, !ctx.showLiveStatus));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.title);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showLiveStatus);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showConfigureMonitor);
        }
      },
      dependencies: [i1$2.NgClass, i1$2.NgIf, i2$1.RouterLink, WgIconComponent, i1$1.TranslatePipe],
      styles: ["h2.section-title[_ngcontent-%COMP%] > .right[_ngcontent-%COMP%]{align-items:center;display:flex}h2.section-title[_ngcontent-%COMP%] > .right[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{font-size:13px;font-size:1rem;color:#fff!important}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DeviceBannerComponent, [{
    type: Component,
    args: [{
      selector: 'wg-device-banner',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<h2 class=\"section-title\" [ngClass]=\"{ 'has-nav-buttons': !showLiveStatus }\">\n  <span class=\"fs-block\">{{ title }}</span>\n  <ng-container *ngIf=\"showLiveStatus\">\n    <div class=\"right\">\n      <a (click)=\"openLiveStatus()\">Live Status <wg-icon name=\"open-tab\" class=\"size-20 color-snow wg-ml-10\"></wg-icon></a>\n    </div>\n  </ng-container>\n  <ng-container *ngIf=\"showConfigureMonitor\">\n    <span class=\"navigation-buttons\">\n      <button type=\"button\"\n        class=\"btn\"\n        [ngClass]=\"{ 'active': firstActive }\"\n        routerLink=\"{{ '/' + getRouterLink('reports/', firstRoute) }}\">\n        {{ firstLabel | translate }}\n      </button>\n      <button type=\"button\"\n        class=\"btn\"\n        [ngClass]=\"{ 'active': secondActive }\"\n        routerLink=\"{{ '/' + getRouterLink('services/', secondRoute) }}\">\n        {{ secondLabel | translate }}\n      </button>\n    </span>\n  </ng-container>\n</h2>\n",
      styles: ["h2.section-title>.right{align-items:center;display:flex}h2.section-title>.right>a{font-size:13px;font-size:1rem;color:#fff!important}\n"]
    }]
  }], () => [{
    type: DeviceService
  }, {
    type: i2$1.Router
  }, {
    type: i1$1.TranslateService
  }], {
    title: [{
      type: Input
    }],
    deviceId: [{
      type: Input
    }],
    firstLabel: [{
      type: Input
    }],
    secondLabel: [{
      type: Input
    }],
    firstRoute: [{
      type: Input
    }],
    secondRoute: [{
      type: Input
    }],
    firstActive: [{
      type: Input
    }],
    secondActive: [{
      type: Input
    }]
  });
})();
class DeviceBannerModule {
  static {
    this.ɵfac = function DeviceBannerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DeviceBannerModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DeviceBannerModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, RouterModule, TranslateModule, WgIconModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DeviceBannerModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, TranslateModule, WgIconModule],
      declarations: [DeviceBannerComponent],
      exports: [DeviceBannerComponent]
    }]
  }], null, null);
})();
class NoLicenseComponent {
  static {
    this.ɵfac = function NoLicenseComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NoLicenseComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NoLicenseComponent,
      selectors: [["wgc-no-license"]],
      inputs: {
        title: "title",
        msg: "msg"
      },
      standalone: false,
      decls: 6,
      vars: 2,
      consts: [[1, "no-data"], ["name", "circle-exclamation"]],
      template: function NoLicenseComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "header");
          i0.ɵɵtext(1);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(2, "div", 0)(3, "h5");
          i0.ɵɵelement(4, "wg-icon", 1);
          i0.ɵɵtext(5);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", ctx.title, "\n");
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1(" ", ctx.msg, " ");
        }
      },
      dependencies: [WgIconComponent],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NoLicenseComponent, [{
    type: Component,
    args: [{
      selector: 'wgc-no-license',
      standalone: false,
      template: "<header>\n  {{ title }}\n</header>\n<div class=\"no-data\">\n  <h5>\n    <wg-icon name=\"circle-exclamation\"></wg-icon>\n    {{ msg }}\n  </h5>\n</div>\n"
    }]
  }], null, {
    title: [{
      type: Input
    }],
    msg: [{
      type: Input
    }]
  });
})();
class NoLicenseModule {
  static {
    this.ɵfac = function NoLicenseModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NoLicenseModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NoLicenseModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, WgIconModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NoLicenseModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, WgIconModule],
      declarations: [NoLicenseComponent],
      exports: [NoLicenseComponent]
    }]
  }], null, null);
})();
const COLLAPSED_WIDTH = 30;
const MIN_WIDTH = 240;
class LayoutTscComponent {
  constructor(elementRef, window) {
    this.elementRef = elementRef;
    this.window = window;
    this.layoutTscClass = true;
    this.collapsed = false;
    this.collapseIcon = 'arrow-double-left-thick';
    this.minWidth = MIN_WIDTH;
  }
  ngAfterViewInit() {
    if (this.elementRef && this.elementRef.nativeElement) {
      this.htmlElement = this.elementRef.nativeElement;
    }
  }
  ngOnChanges(changes) {
    if (changes.hasOwnProperty('hideSecondary') && !changes.hideSecondary.firstChange) {
      // need this setTimeout in order to wait for angular to show/hide the secondary
      // in order to get width of secondary for resize
      setTimeout(() => {
        this.resizeSections();
      });
    }
  }
  ngOnDestroy() {
    this.cleanupResizerEvents();
  }
  resizerMouseDown(event) {
    // get the current styles of the resizer so we can restore them when done
    this.resizerStyles = {
      position: this.resizer.nativeElement.style.position,
      left: this.resizer.nativeElement.style.left,
      right: this.resizer.nativeElement.style.right,
      width: this.resizer.nativeElement.style.width
    };
    // set the resizer to fixed so it can take up the entire screen
    this.resizer.nativeElement.style.position = 'fixed';
    this.resizer.nativeElement.style.left = '0px';
    this.resizer.nativeElement.style.right = '0px';
    this.resizer.nativeElement.style.width = 'auto';
    this.resizerMouseMoveBound = this.resizerMouseMove.bind(this);
    this.window.addEventListener('mousemove', this.resizerMouseMoveBound);
    this.resizerMouseUpBound = this.resizerMouseUp.bind(this);
    this.window.addEventListener('mouseup', this.resizerMouseUpBound);
  }
  resizerMouseMove(event) {
    const bodyRect = document.body.getBoundingClientRect();
    const treeRect = this.treeContainer.nativeElement.getBoundingClientRect();
    const offsetLeft = treeRect.left - bodyRect.left;
    let treeWidth = event.pageX - offsetLeft;
    treeWidth = Math.max(treeWidth, 50);
    treeWidth = Math.min(treeWidth, this.window.innerWidth - 50);
    this.resizeSections(treeWidth);
  }
  resizerMouseUp(event) {
    // reset the resizer to its original styles
    this.resizer.nativeElement.style.position = this.resizerStyles.position;
    this.resizer.nativeElement.style.left = this.resizerStyles.left;
    this.resizer.nativeElement.style.right = this.resizerStyles.right;
    this.resizer.nativeElement.style.width = this.resizerStyles.width;
    this.cleanupResizerEvents();
  }
  resizeSections(treeWidth) {
    if (treeWidth === undefined) {
      treeWidth = this.getComputedWidth(this.treeContainer.nativeElement);
    } else {
      if (treeWidth < this.minWidth) {
        treeWidth = this.minWidth;
      }
      this.treeContainer.nativeElement.style.width = treeWidth + 'px';
    }
    this.secondaryLeft = treeWidth + 'px';
    if (!this.hideSecondary) {
      treeWidth += this.getComputedWidth(this.secondaryContainer.nativeElement);
    }
    this.contentContainer.nativeElement.style.left = treeWidth + 'px';
    window.dispatchEvent(new Event('resize'));
  }
  toggleCollapse(event) {
    if (!this.collapsed) {
      this.treePreviousWidth = this.getComputedWidth(this.treeContainer.nativeElement);
    }
    this.collapsed = !this.collapsed;
    if (this.collapsed) {
      this.minWidth = COLLAPSED_WIDTH;
      this.collapseIcon = 'arrow-double-right-thick';
      this.resizeSections(COLLAPSED_WIDTH);
    } else {
      this.minWidth = MIN_WIDTH;
      this.collapseIcon = 'arrow-double-left-thick';
      this.resizeSections(this.treePreviousWidth);
    }
  }
  collapseView() {
    if (!this.collapsed) {
      this.toggleCollapse(null);
    }
  }
  expandView() {
    if (this.collapsed) {
      this.toggleCollapse(null);
    }
  }
  cleanupResizerEvents() {
    if (this.resizerMouseMoveBound) {
      this.window.removeEventListener('mousemove', this.resizerMouseMoveBound);
    }
    if (this.resizerMouseUpBound) {
      this.window.removeEventListener('mouseup', this.resizerMouseUpBound);
    }
  }
  getComputedWidth(element) {
    if (!element) {
      return 0;
    }
    return parseInt(getComputedStyle(element).width, 10);
  }
  static {
    this.ɵfac = function LayoutTscComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LayoutTscComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(Window));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: LayoutTscComponent,
      selectors: [["wgc-layout-tsc"]],
      viewQuery: function LayoutTscComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c19, 7);
          i0.ɵɵviewQuery(_c20, 7);
          i0.ɵɵviewQuery(_c21, 5);
          i0.ɵɵviewQuery(_c22, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentContainer = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.resizer = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.secondaryContainer = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.treeContainer = _t.first);
        }
      },
      hostVars: 2,
      hostBindings: function LayoutTscComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("layout-tsc", ctx.layoutTscClass);
        }
      },
      inputs: {
        hideSecondary: "hideSecondary",
        saveStateName: "saveStateName",
        secondaryLeft: "secondaryLeft"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c24,
      decls: 12,
      vars: 6,
      consts: [["treeContainer", ""], ["resizer", ""], ["contentContainer", ""], ["secondaryContainer", ""], [1, "tree-container", 3, "ngClass"], [4, "ngIf"], [1, "layout-collapser"], [3, "click"], [3, "name"], [1, "layout-resizer", 3, "mousedown"], ["class", "secondary-container", 3, "left", 4, "ngIf"], ["wgContainerQuery", "", 1, "content-container"], [1, "secondary-container"]],
      template: function LayoutTscComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵprojectionDef(_c23);
          i0.ɵɵelementStart(0, "div", 4, 0);
          i0.ɵɵtemplate(2, LayoutTscComponent_ng_content_2_Template, 1, 0, "ng-content", 5);
          i0.ɵɵelementStart(3, "div", 6)(4, "a", 7);
          i0.ɵɵlistener("click", function LayoutTscComponent_Template_a_click_4_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.toggleCollapse($event));
          });
          i0.ɵɵelement(5, "wg-icon", 8);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(6, "div", 9, 1);
          i0.ɵɵlistener("mousedown", function LayoutTscComponent_Template_div_mousedown_6_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.resizerMouseDown($event));
          });
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(8, LayoutTscComponent_div_8_Template, 3, 2, "div", 10);
          i0.ɵɵelementStart(9, "div", 11, 2);
          i0.ɵɵprojection(11);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c25, ctx.collapsed));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.collapsed);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("name", ctx.collapseIcon);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", !ctx.hideSecondary);
        }
      },
      dependencies: [i1$2.NgClass, i1$2.NgIf, WgContainerQueryDirective, WgIconComponent],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LayoutTscComponent, [{
    type: Component,
    args: [{
      selector: 'wgc-layout-tsc',
      standalone: false,
      template: "<div #treeContainer class=\"tree-container\" [ngClass]=\"{ collapsed: collapsed }\">\n  <ng-content *ngIf=\"!this.collapsed\" select=\"section.tree\"></ng-content>\n  <div class=\"layout-collapser\">\n    <a (click)=\"toggleCollapse($event)\"><wg-icon [name]=\"collapseIcon\"></wg-icon></a>\n  </div>\n  <div #resizer class=\"layout-resizer\" (mousedown)=\"resizerMouseDown($event)\"></div>\n</div>\n<div #secondaryContainer class=\"secondary-container\" [style.left]=\"secondaryLeft\" *ngIf=\"!hideSecondary\">\n  <ng-content select=\"section.secondary\"></ng-content>\n</div>\n<div #contentContainer class=\"content-container\" wgContainerQuery>\n  <ng-content select=\"section.content\"></ng-content>\n</div>\n"
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: Window
  }], {
    layoutTscClass: [{
      type: HostBinding,
      args: ['class.layout-tsc']
    }],
    contentContainer: [{
      type: ViewChild,
      args: ['contentContainer', {
        static: true
      }]
    }],
    resizer: [{
      type: ViewChild,
      args: ['resizer', {
        static: true
      }]
    }],
    secondaryContainer: [{
      type: ViewChild,
      args: ['secondaryContainer']
    }],
    treeContainer: [{
      type: ViewChild,
      args: ['treeContainer', {
        static: true
      }]
    }],
    hideSecondary: [{
      type: Input
    }],
    saveStateName: [{
      type: Input
    }],
    secondaryLeft: [{
      type: Input
    }]
  });
})();
class LayoutTscModule {
  static {
    this.ɵfac = function LayoutTscModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LayoutTscModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: LayoutTscModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: Window,
        useValue: window
      }],
      imports: [CommonModule, WgContainerQueryModule, WgIconModule, WgServicesModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LayoutTscModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, WgContainerQueryModule, WgIconModule, WgServicesModule],
      declarations: [LayoutTscComponent],
      exports: [LayoutTscComponent],
      providers: [{
        provide: Window,
        useValue: window
      }]
    }]
  }], null, null);
})();
class AppObservableService {
  constructor() {
    // We want the subject to be private and expose it's observable part only
    this.accountSelectedSubject$ = new BehaviorSubject({});
    this.accountSelectedObservable$ = this.accountSelectedSubject$.asObservable();
    // Maintain a list of service providers and their direct children
    // This is used by inventory UI currently
    this.serviceProviderAndChildrenCache = {};
  }
  accountSelected(selectedAccount) {
    this.accountSelectedSubject$.next(selectedAccount);
  }
  // For the passed in parent if it's present in the cache
  // return it's children
  getTenants(parentID) {
    if (this.serviceProviderAndChildrenCache.hasOwnProperty(parentID)) {
      const tenants = this.serviceProviderAndChildrenCache[parentID];
      return tenants;
    }
  }
  // Update the cache by adding the tenant to it's parent
  // If Parent is not yet in the cachem then initialize it first
  addTenant(parentID, tenant) {
    if (!this.serviceProviderAndChildrenCache.hasOwnProperty(parentID)) {
      this.serviceProviderAndChildrenCache[parentID] = [];
    }
    this.serviceProviderAndChildrenCache[parentID].push(tenant);
  }
  // Remove the tenant from it's parent and update the cache
  removeTenant(parentID, tenantID) {
    if (this.serviceProviderAndChildrenCache.hasOwnProperty(parentID)) {
      const tenants = this.serviceProviderAndChildrenCache[parentID];
      // All tenants except the one we want to remove
      const filteredTenants = tenants.filter(tenant => tenant.accountID !== tenantID);
      // Update the cache
      this.serviceProviderAndChildrenCache[parentID] = filteredTenants;
    }
  }
  // Reset sp cache
  clearSpChildrenCache() {
    this.serviceProviderAndChildrenCache = {};
  }
  static {
    this.ɵfac = function AppObservableService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AppObservableService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AppObservableService,
      factory: AppObservableService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AppObservableService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
const API_CONSTANTS$1 = {
  groupMgrSvrBaseUrl: 'platform-groupmgr-svc/v1',
  unifiedIdConfigBaseUrl: "unifiedid-config/v1"
};
// map column name of grid to name used by the new api, groupmgr-svc
const colNameMaps = {
  friendly_name: 'name',
  managed: 'managed',
  logging: 'logging',
  serial_number: 'serial_number',
  current_version: 'version'
};
class GroupMgrSrvService {
  constructor(http) {
    this.http = http;
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    this.paginationDevRows = 25;
    this.currentDevPage = 1;
    this.columnDevSortFilter = {
      field: 'friendly_name',
      order: 1
    };
  }
  devicesInCloud(customerID, excludeAPs) {
    let url;
    if (excludeAPs) {
      url = this.getGuardApiUrl() + API_CONSTANTS$1.groupMgrSvrBaseUrl + `/${customerID}/group/GRP-0/items?type=GRP,FB`;
    } else {
      url = this.getGuardApiUrl() + API_CONSTANTS$1.groupMgrSvrBaseUrl + `/${customerID}/group/GRP-0/items`;
    }
    return this.http.get(url, {
      headers: this.headers
    }).pipe(map(data => data.data), catchError(this.handleError));
  }
  activatedCloudDevList(customerID, groupID) {
    const params = new HttpParams().set('sort_by', colNameMaps[this.columnDevSortFilter.field]).set('sort_order', this.columnDevSortFilter.order.toString()).set('page', this.currentDevPage.toString()).set('rows', this.paginationDevRows.toString());
    const url = this.getGuardApiUrl() + API_CONSTANTS$1.groupMgrSvrBaseUrl + `/${customerID}/group/${groupID}/items?view=flat&` + params;
    return this.http.get(url, {
      headers: this.headers
    }).pipe(tap(data => {
      if (data.data) {
        this.totalDevPages = data.totalpages;
        this.totalDevCount = data.totalrecords;
      }
    }), map(data => data.data), catchError(this.handleError));
  }
  getDeviceInfo(customerID, itemID, registerInfo, extraInfo) {
    const url = this.getGuardApiUrl() + API_CONSTANTS$1.groupMgrSvrBaseUrl + `/${customerID}/item/${itemID}`;
    let params = new HttpParams();
    if (registerInfo) {
      // Only for Configure page
      params = params.append('register_info', '1');
    }
    if (extraInfo) {
      params = params.append('extra_info', '1');
    }
    return this.http.get(url, {
      headers: this.headers,
      params
    }).pipe(catchError(this.handleError));
  }
  addFolder(customerID, parentFolderID, folderName) {
    const body = JSON.stringify({
      name: folderName
    });
    const url = this.getGuardApiUrl() + API_CONSTANTS$1.groupMgrSvrBaseUrl + `/${customerID}/group/${parentFolderID}`;
    return this.http.post(url, body, {
      headers: this.headers
    }).pipe(catchError(this.handleError));
  }
  renameFolder(customerID, folderID, newFolderName) {
    const body = JSON.stringify({
      name: newFolderName
    });
    const url = this.getGuardApiUrl() + API_CONSTANTS$1.groupMgrSvrBaseUrl + `/${customerID}/group/${folderID}`;
    return this.http.patch(url, body, {
      headers: this.headers
    }).pipe(catchError(this.handleError));
  }
  deleteFolder(customerID, folderID) {
    const url = this.getGuardApiUrl() + API_CONSTANTS$1.groupMgrSvrBaseUrl + `/${customerID}/group/${folderID}`;
    return this.http.delete(url, {
      headers: this.headers
    }).pipe(catchError(this.handleError));
  }
  move(customerID, targetFolderID, items) {
    const body = JSON.stringify({
      candidate_ids: items
    });
    const url = this.getGuardApiUrl() + API_CONSTANTS$1.groupMgrSvrBaseUrl + `/${customerID}/group/${targetFolderID}`;
    return this.http.put(url, body, {
      headers: this.headers
    }).pipe(catchError(this.handleError));
  }
  // for serverless API's
  getGuardApiUrl(override = '') {
    const options = {
      region: 'usa',
      override
    };
    if (window.location.host.indexOf('watchguard.com') !== -1) {
      options.override = '';
    }
    return newGuardApiUrl(options);
  }
  handleError(error) {
    const errMsg = error.message ? error.message : error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    return throwError(() => new Error(errMsg));
  }
  static {
    this.ɵfac = function GroupMgrSrvService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GroupMgrSrvService)(i0.ɵɵinject(i1.HttpClient));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GroupMgrSrvService,
      factory: GroupMgrSrvService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GroupMgrSrvService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }], null);
})();
const API_CONSTANTS = {
  baseUrl: 'platform-groupmgr-svc/v1/',
  getRootGroup: '/group/GRP_ACC-0/items',
  group: '/group/'
};
class AccountGroupMgrService {
  constructor(http) {
    this.http = http;
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
  }
  getAccountGroupData(accountID, queryParam) {
    let url = this.getGuardApiUrl() + API_CONSTANTS.baseUrl + accountID + API_CONSTANTS.getRootGroup;
    if (queryParam) {
      url = url.concat('?', queryParam);
    }
    return this.http.get(url, {
      headers: this.headers
    }).pipe(map(data => data.data), catchError(this.handleError));
  }
  createAccountGroup(accountID, parentGroupId, groupName) {
    const url = this.getGuardApiUrl() + API_CONSTANTS.baseUrl + accountID + API_CONSTANTS.group + parentGroupId;
    return this.http.post(url, {
      name: groupName
    }, {
      headers: this.headers
    }).pipe(map(data => data.data), catchError(this.handleError));
  }
  renameAccountGroup(accountID, groupId, newGroupName) {
    const url = this.getGuardApiUrl() + API_CONSTANTS.baseUrl + accountID + API_CONSTANTS.group + groupId;
    return this.http.patch(url, {
      name: newGroupName
    }, {
      headers: this.headers
    }).pipe(map(data => data.data), catchError(this.handleError));
  }
  moveToAccountGroup(accountID, groupId, accountToMove) {
    const url = this.getGuardApiUrl() + API_CONSTANTS.baseUrl + accountID + API_CONSTANTS.group + groupId;
    return this.http.put(url, {
      candidate_ids: [accountToMove]
    }, {
      headers: this.headers
    }).pipe(catchError(this.handleError));
  }
  deleteAccountGroup(accountID, groupId) {
    const url = this.getGuardApiUrl() + API_CONSTANTS.baseUrl + accountID + API_CONSTANTS.group + groupId;
    return this.http.delete(url, {
      headers: this.headers
    }).pipe(map(data => data.data), catchError(this.handleError));
  }
  getGuardApiUrl(override = '') {
    const options = {
      region: 'usa',
      override
    };
    if (window.location.host.indexOf('watchguard.com') !== -1) {
      options.override = '';
    }
    return newGuardApiUrl(options);
  }
  handleError(error) {
    const errMsg = error.message ? error.message : error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    return throwError(() => new Error(errMsg));
  }
  static {
    this.ɵfac = function AccountGroupMgrService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AccountGroupMgrService)(i0.ɵɵinject(i1.HttpClient));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AccountGroupMgrService,
      factory: AccountGroupMgrService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccountGroupMgrService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }], null);
})();
;
;
/**
 * @deprecated Should use GeographyService.getContinents() instead
 */
const Continents = [{
  name: 'Africa',
  countries: [{
    name: 'Angola',
    code2: 'AO',
    code3: 'AGO'
  }, {
    name: 'Burkina Faso',
    code2: 'BF',
    code3: 'BFA'
  }, {
    name: 'Burundi',
    code2: 'BI',
    code3: 'BDI'
  }, {
    name: 'Benin',
    code2: 'BJ',
    code3: 'BEN'
  }, {
    name: 'Botswana',
    code2: 'BW',
    code3: 'BWA'
  }, {
    name: 'Congo',
    code2: 'CD',
    code3: 'COD'
  }, {
    name: 'Central African Republic',
    code2: 'CF',
    code3: 'CAF'
  }, {
    name: 'Republic of the Congo',
    code2: 'CG',
    code3: 'COG'
  }, {
    name: 'Ivory Coast',
    code2: 'CI',
    code3: 'CIV'
  }, {
    name: 'Cameroon',
    code2: 'CM',
    code3: 'CMR'
  }, {
    name: 'Cape Verde',
    code2: 'CV',
    code3: 'CPV'
  }, {
    name: 'Djibouti',
    code2: 'DJ',
    code3: 'DJI'
  }, {
    name: 'Algeria',
    code2: 'DZ',
    code3: 'DZA'
  }, {
    name: 'Egypt',
    code2: 'EG',
    code3: 'EGY'
  }, {
    name: 'Eritrea',
    code2: 'ER',
    code3: 'ERI'
  }, {
    name: 'Ethiopia',
    code2: 'ET',
    code3: 'ETH'
  }, {
    name: 'Gabon',
    code2: 'GA',
    code3: 'GAB'
  }, {
    name: 'Ghana',
    code2: 'GH',
    code3: 'GHA'
  }, {
    name: 'Gambia',
    code2: 'GM',
    code3: 'GMB'
  }, {
    name: 'Guinea',
    code2: 'GN',
    code3: 'GIN'
  }, {
    name: 'Equatorial Guinea',
    code2: 'GQ',
    code3: 'GNQ'
  }, {
    name: 'Guinea-Bissau',
    code2: 'GW',
    code3: 'GNB'
  }, {
    name: 'Kenya',
    code2: 'KE',
    code3: 'KEN'
  }, {
    name: 'Comoros',
    code2: 'KM',
    code3: 'COM'
  }, {
    name: 'Liberia',
    code2: 'LR',
    code3: 'LBR'
  }, {
    name: 'Lesotho',
    code2: 'LS',
    code3: 'LSO'
  }, {
    name: 'Libya',
    code2: 'LY',
    code3: 'LBY'
  }, {
    name: 'Morocco',
    code2: 'MA',
    code3: 'MAR'
  }, {
    name: 'Madagascar',
    code2: 'MG',
    code3: 'MDG'
  }, {
    name: 'Mali',
    code2: 'ML',
    code3: 'MLI'
  }, {
    name: 'Mauritania',
    code2: 'MR',
    code3: 'MRT'
  }, {
    name: 'Mauritius',
    code2: 'MU',
    code3: 'MUS'
  }, {
    name: 'Malawi',
    code2: 'MW',
    code3: 'MWI'
  }, {
    name: 'Mozambique',
    code2: 'MZ',
    code3: 'MOZ'
  }, {
    name: 'Namibia',
    code2: 'NA',
    code3: 'NAM'
  }, {
    name: 'Niger',
    code2: 'NE',
    code3: 'NER'
  }, {
    name: 'Nigeria',
    code2: 'NG',
    code3: 'NGA'
  }, {
    name: 'Réunion',
    code2: 'RE',
    code3: 'REU'
  }, {
    name: 'Rwanda',
    code2: 'RW',
    code3: 'RWA'
  }, {
    name: 'Seychelles',
    code2: 'SC',
    code3: 'SYC'
  }, {
    name: 'Sudan',
    code2: 'SD',
    code3: 'SDN'
  }, {
    name: 'Saint Helena',
    code2: 'SH',
    code3: 'SHN'
  }, {
    name: 'Sierra Leone',
    code2: 'SL',
    code3: 'SLE'
  }, {
    name: 'Senegal',
    code2: 'SN',
    code3: 'SEN'
  }, {
    name: 'Somalia',
    code2: 'SO',
    code3: 'SOM'
  }, {
    name: 'South Sudan',
    code2: 'SS',
    code3: 'SSD'
  }, {
    name: 'São Tomé and Príncipe',
    code2: 'ST',
    code3: 'STP'
  }, {
    name: 'Swaziland',
    code2: 'SZ',
    code3: 'SWZ'
  }, {
    name: 'Chad',
    code2: 'TD',
    code3: 'TCD'
  }, {
    name: 'Togo',
    code2: 'TG',
    code3: 'TGO'
  }, {
    name: 'Tunisia',
    code2: 'TN',
    code3: 'TUN'
  }, {
    name: 'Tanzania',
    code2: 'TZ',
    code3: 'TZA'
  }, {
    name: 'Uganda',
    code2: 'UG',
    code3: 'UGA'
  }, {
    name: 'Mayotte',
    code2: 'YT',
    code3: 'MYT'
  }, {
    name: 'South Africa',
    code2: 'ZA',
    code3: 'ZAF'
  }, {
    name: 'Zambia',
    code2: 'ZM',
    code3: 'ZMB'
  }, {
    name: 'Zimbabwe',
    code2: 'ZW',
    code3: 'ZWE'
  }]
}, {
  name: 'North America',
  countries: [{
    name: 'Antigua and Barbuda',
    code2: 'AG',
    code3: 'ATG'
  }, {
    name: 'Anguilla',
    code2: 'AI',
    code3: 'AIA'
  }, {
    name: 'Aruba',
    code2: 'AW',
    code3: 'ABW'
  }, {
    name: 'Barbados',
    code2: 'BB',
    code3: 'BRB'
  }, {
    name: 'Saint-Barthélemy',
    code2: 'BL',
    code3: 'BLM'
  }, {
    name: 'Bermuda',
    code2: 'BM',
    code3: 'BMU'
  }, {
    name: 'Bonaire, Sint Eustatius, and Saba',
    code2: 'BQ',
    code3: 'BES'
  }, {
    name: 'Bahamas',
    code2: 'BS',
    code3: 'BHS'
  }, {
    name: 'Belize',
    code2: 'BZ',
    code3: 'BLZ'
  }, {
    name: 'Canada',
    code2: 'CA',
    code3: 'CAN'
  }, {
    name: 'Costa Rica',
    code2: 'CR',
    code3: 'CRI'
  }, {
    name: 'Cuba',
    code2: 'CU',
    code3: 'CUB'
  }, {
    name: 'Curaçao',
    code2: 'CW',
    code3: 'CUW'
  }, {
    name: 'Dominica',
    code2: 'DM',
    code3: 'DMA'
  }, {
    name: 'Dominican Republic',
    code2: 'DO',
    code3: 'DOM'
  }, {
    name: 'Grenada',
    code2: 'GD',
    code3: 'GRD'
  }, {
    name: 'Greenland',
    code2: 'GL',
    code3: 'GRL'
  }, {
    name: 'Guadeloupe',
    code2: 'GP',
    code3: 'GLP'
  }, {
    name: 'Guatemala',
    code2: 'GT',
    code3: 'GTM'
  }, {
    name: 'Honduras',
    code2: 'HN',
    code3: 'HND'
  }, {
    name: 'Haiti',
    code2: 'HT',
    code3: 'HTI'
  }, {
    name: 'Jamaica',
    code2: 'JM',
    code3: 'JAM'
  }, {
    name: 'Saint Kitts and Nevis',
    code2: 'KN',
    code3: 'KNA'
  }, {
    name: 'Cayman Islands',
    code2: 'KY',
    code3: 'CYM'
  }, {
    name: 'Saint Lucia',
    code2: 'LC',
    code3: 'LCA'
  }, {
    name: 'Saint Martin',
    code2: 'MF',
    code3: 'MAF'
  }, {
    name: 'Martinique',
    code2: 'MQ',
    code3: 'MTQ'
  }, {
    name: 'Montserrat',
    code2: 'MS',
    code3: 'MSR'
  }, {
    name: 'Mexico',
    code2: 'MX',
    code3: 'MEX'
  }, {
    name: 'Nicaragua',
    code2: 'NI',
    code3: 'NIC'
  }, {
    name: 'Panama',
    code2: 'PA',
    code3: 'PAN'
  }, {
    name: 'Saint Pierre and Miquelon',
    code2: 'PM',
    code3: 'SPM'
  }, {
    name: 'Puerto Rico',
    code2: 'PR',
    code3: 'PRI'
  }, {
    name: 'El Salvador',
    code2: 'SV',
    code3: 'SLV'
  }, {
    name: 'Sint Maarten',
    code2: 'SX',
    code3: 'SXM'
  }, {
    name: 'Turks and Caicos Islands',
    code2: 'TC',
    code3: 'TCA'
  }, {
    name: 'Trinidad and Tobago',
    code2: 'TT',
    code3: 'TTO'
  }, {
    name: 'United States',
    code2: 'US',
    code3: 'USA'
  }, {
    name: 'Saint Vincent and the Grenadines',
    code2: 'VC',
    code3: 'VCT'
  }, {
    name: 'British Virgin Islands',
    code2: 'VG',
    code3: 'VGB'
  }, {
    name: 'U.S. Virgin Islands',
    code2: 'VI',
    code3: 'VIR'
  }]
}, {
  name: 'Oceania',
  countries: [{
    name: 'American Samoa',
    code2: 'AS',
    code3: 'ASM'
  }, {
    name: 'Australia',
    code2: 'AU',
    code3: 'AUS'
  }, {
    name: 'Christmas Island',
    code2: 'CX',
    code3: 'CXR'
  }, {
    name: 'Cook Islands',
    code2: 'CK',
    code3: 'COK'
  }, {
    name: 'Fiji',
    code2: 'FJ',
    code3: 'FJI'
  }, {
    name: 'Federated States of Micronesia',
    code2: 'FM',
    code3: 'FSM'
  }, {
    name: 'Guam',
    code2: 'GU',
    code3: 'GUM'
  }, {
    name: 'Kiribati',
    code2: 'KI',
    code3: 'KIR'
  }, {
    name: 'Marshall Islands',
    code2: 'MH',
    code3: 'MHL'
  }, {
    name: 'Northern Mariana Islands',
    code2: 'MP',
    code3: 'MNP'
  }, {
    name: 'New Caledonia',
    code2: 'NC',
    code3: 'NCL'
  }, {
    name: 'Norfolk Island',
    code2: 'NF',
    code3: 'NFK'
  }, {
    name: 'Nauru',
    code2: 'NR',
    code3: 'NRU'
  }, {
    name: 'Niue',
    code2: 'NU',
    code3: 'NIU'
  }, {
    name: 'New Zealand',
    code2: 'NZ',
    code3: 'NZL'
  }, {
    name: 'French Polynesia',
    code2: 'PF',
    code3: 'PYF'
  }, {
    name: 'Papua New Guinea',
    code2: 'PG',
    code3: 'PNG'
  }, {
    name: 'Pitcairn Islands',
    code2: 'PN',
    code3: 'PCN'
  }, {
    name: 'Palau',
    code2: 'PW',
    code3: 'PLW'
  }, {
    name: 'Solomon Islands',
    code2: 'SB',
    code3: 'SLB'
  }, {
    name: 'Tokelau',
    code2: 'TK',
    code3: 'TKL'
  }, {
    name: 'East Timor',
    code2: 'TL',
    code3: 'TLS'
  }, {
    name: 'Tonga',
    code2: 'TO',
    code3: 'TON'
  }, {
    name: 'Tuvalu',
    code2: 'TV',
    code3: 'TUV'
  }, {
    name: 'U.S. Minor Outlying Islands',
    code2: 'UM',
    code3: 'UMI'
  }, {
    name: 'Vanuatu',
    code2: 'VU',
    code3: 'VUT'
  }, {
    name: 'Wallis and Futuna',
    code2: 'WF',
    code3: 'WLF'
  }, {
    name: 'Samoa',
    code2: 'WS',
    code3: 'WSM'
  }]
}, {
  name: 'Antarctica',
  countries: [{
    name: 'Antarctica',
    code2: 'AQ',
    code3: 'ATA'
  }, {
    name: 'South Georgia and the South Sandwich Islands',
    code2: 'GS',
    code3: 'SGS'
  }, {
    name: 'French Southern Territories',
    code2: 'TF',
    code3: 'ATF'
  }]
}, {
  name: 'Asia',
  countries: [{
    name: 'United Arab Emirates',
    code2: 'AE',
    code3: 'ARE'
  }, {
    name: 'Afghanistan',
    code2: 'AF',
    code3: 'AFG'
  }, {
    name: 'Armenia',
    code2: 'AM',
    code3: 'ARM'
  }, {
    name: 'Azerbaijan',
    code2: 'AZ',
    code3: 'AZE'
  }, {
    name: 'Bangladesh',
    code2: 'BD',
    code3: 'BGD'
  }, {
    name: 'Bahrain',
    code2: 'BH',
    code3: 'BHR'
  }, {
    name: 'Brunei',
    code2: 'BN',
    code3: 'BRN'
  }, {
    name: 'Bhutan',
    code2: 'BT',
    code3: 'BTN'
  }, {
    name: 'Cocos [Keeling] Islands',
    code2: 'CC',
    code3: 'CCK'
  }, {
    name: 'China',
    code2: 'CN',
    code3: 'CHN'
  }, {
    name: 'Georgia',
    code2: 'GE',
    code3: 'GEO'
  }, {
    name: 'Hong Kong',
    code2: 'HK',
    code3: 'HKG'
  }, {
    name: 'Indonesia',
    code2: 'ID',
    code3: 'IDN'
  }, {
    name: 'Israel',
    code2: 'IL',
    code3: 'ISR'
  }, {
    name: 'India',
    code2: 'IN',
    code3: 'IND'
  }, {
    name: 'British Indian Ocean Territory',
    code2: 'IO',
    code3: 'IOT'
  }, {
    name: 'Iraq',
    code2: 'IQ',
    code3: 'IRQ'
  }, {
    name: 'Iran',
    code2: 'IR',
    code3: 'IRN'
  }, {
    name: 'Hashemite Kingdom of Jordan',
    code2: 'JO',
    code3: 'JOR'
  }, {
    name: 'Japan',
    code2: 'JP',
    code3: 'JPN'
  }, {
    name: 'Kyrgyzstan',
    code2: 'KG',
    code3: 'KGZ'
  }, {
    name: 'Cambodia',
    code2: 'KH',
    code3: 'KHM'
  }, {
    name: 'North Korea',
    code2: 'KP',
    code3: 'PRK'
  }, {
    name: 'Republic of Korea',
    code2: 'KR',
    code3: 'KOR'
  }, {
    name: 'Kuwait',
    code2: 'KW',
    code3: 'KWT'
  }, {
    name: 'Kazakhstan',
    code2: 'KZ',
    code3: 'KAZ'
  }, {
    name: 'Laos',
    code2: 'LA',
    code3: 'LAO'
  }, {
    name: 'Lebanon',
    code2: 'LB',
    code3: 'LBN'
  }, {
    name: 'Sri Lanka',
    code2: 'LK',
    code3: 'LKA'
  }, {
    name: 'Myanmar [Burma]',
    code2: 'MM',
    code3: 'MMR'
  }, {
    name: 'Mongolia',
    code2: 'MN',
    code3: 'MNG'
  }, {
    name: 'Macao',
    code2: 'MO',
    code3: 'MAC'
  }, {
    name: 'Maldives',
    code2: 'MV',
    code3: 'MDV'
  }, {
    name: 'Malaysia',
    code2: 'MY',
    code3: 'MYS'
  }, {
    name: 'Nepal',
    code2: 'NP',
    code3: 'NPL'
  }, {
    name: 'Oman',
    code2: 'OM',
    code3: 'OMN'
  }, {
    name: 'Philippines',
    code2: 'PH',
    code3: 'PHL'
  }, {
    name: 'Pakistan',
    code2: 'PK',
    code3: 'PAK'
  }, {
    name: 'Palestine',
    code2: 'PS',
    code3: 'PSE'
  }, {
    name: 'Qatar',
    code2: 'QA',
    code3: 'QAT'
  }, {
    name: 'Saudi Arabia',
    code2: 'SA',
    code3: 'SAU'
  }, {
    name: 'Singapore',
    code2: 'SG',
    code3: 'SGP'
  }, {
    name: 'Syria',
    code2: 'SY',
    code3: 'SYR'
  }, {
    name: 'Thailand',
    code2: 'TH',
    code3: 'THA'
  }, {
    name: 'Tajikistan',
    code2: 'TJ',
    code3: 'TJK'
  }, {
    name: 'Turkmenistan',
    code2: 'TM',
    code3: 'TKM'
  }, {
    name: 'Turkey',
    code2: 'TR',
    code3: 'TUR'
  }, {
    name: 'Taiwan',
    code2: 'TW',
    code3: 'TWN'
  }, {
    name: 'Uzbekistan',
    code2: 'UZ',
    code3: 'UZB'
  }, {
    name: 'Vietnam',
    code2: 'VN',
    code3: 'VNM'
  }, {
    name: 'Yemen',
    code2: 'YE',
    code3: 'YEM'
  }]
}, {
  name: 'Europe',
  countries: [{
    name: 'Andorra',
    code2: 'AD',
    code3: 'AND'
  }, {
    name: 'Albania',
    code2: 'AL',
    code3: 'ALB'
  }, {
    name: 'Austria',
    code2: 'AT',
    code3: 'AUT'
  }, {
    name: 'Åland',
    code2: 'AX',
    code3: 'ALA'
  }, {
    name: 'Bosnia and Herzegovina',
    code2: 'BA',
    code3: 'BIH'
  }, {
    name: 'Belgium',
    code2: 'BE',
    code3: 'BEL'
  }, {
    name: 'Bulgaria',
    code2: 'BG',
    code3: 'BGR'
  }, {
    name: 'Belarus',
    code2: 'BY',
    code3: 'BLR'
  }, {
    name: 'Switzerland',
    code2: 'CH',
    code3: 'CHE'
  }, {
    name: 'Cyprus',
    code2: 'CY',
    code3: 'CYP'
  }, {
    name: 'Czechia',
    code2: 'CZ',
    code3: 'CZE'
  }, {
    name: 'Germany',
    code2: 'DE',
    code3: 'DEU'
  }, {
    name: 'Denmark',
    code2: 'DK',
    code3: 'DNK'
  }, {
    name: 'Estonia',
    code2: 'EE',
    code3: 'EST'
  }, {
    name: 'Spain',
    code2: 'ES',
    code3: 'ESP'
  }, {
    name: 'Finland',
    code2: 'FI',
    code3: 'FIN'
  }, {
    name: 'Faroe Islands',
    code2: 'FO',
    code3: 'FRO'
  }, {
    name: 'France',
    code2: 'FR',
    code3: 'FRA'
  }, {
    name: 'United Kingdom',
    code2: 'GB',
    code3: 'GBR'
  }, {
    name: 'Guernsey',
    code2: 'GG',
    code3: 'GGY'
  }, {
    name: 'Gibraltar',
    code2: 'GI',
    code3: 'GIB'
  }, {
    name: 'Greece',
    code2: 'GR',
    code3: 'GRC'
  }, {
    name: 'Croatia',
    code2: 'HR',
    code3: 'HRV'
  }, {
    name: 'Hungary',
    code2: 'HU',
    code3: 'HUN'
  }, {
    name: 'Ireland',
    code2: 'IE',
    code3: 'IRL'
  }, {
    name: 'Isle of Man',
    code2: 'IM',
    code3: 'IMN'
  }, {
    name: 'Iceland',
    code2: 'IS',
    code3: 'ISL'
  }, {
    name: 'Italy',
    code2: 'IT',
    code3: 'ITA'
  }, {
    name: 'Jersey',
    code2: 'JE',
    code3: 'JEY'
  }, {
    name: 'Liechtenstein',
    code2: 'LI',
    code3: 'LIE'
  }, {
    name: 'Republic of Lithuania',
    code2: 'LT',
    code3: 'LTU'
  }, {
    name: 'Luxembourg',
    code2: 'LU',
    code3: 'LUX'
  }, {
    name: 'Latvia',
    code2: 'LV',
    code3: 'LVA'
  }, {
    name: 'Monaco',
    code2: 'MC',
    code3: 'MCO'
  }, {
    name: 'Republic of Moldova',
    code2: 'MD',
    code3: 'MDA'
  }, {
    name: 'Montenegro',
    code2: 'ME',
    code3: 'MNE'
  }, {
    name: 'Macedonia',
    code2: 'MK',
    code3: 'MKD'
  }, {
    name: 'Malta',
    code2: 'MT',
    code3: 'MLT'
  }, {
    name: 'Netherlands',
    code2: 'NL',
    code3: 'NLD'
  }, {
    name: 'Norway',
    code2: 'NO',
    code3: 'NOR'
  }, {
    name: 'Poland',
    code2: 'PL',
    code3: 'POL'
  }, {
    name: 'Portugal',
    code2: 'PT',
    code3: 'PRT'
  }, {
    name: 'Romania',
    code2: 'RO',
    code3: 'ROU'
  }, {
    name: 'Serbia',
    code2: 'RS',
    code3: 'SRB'
  }, {
    name: 'Russia',
    code2: 'RU',
    code3: 'RUS'
  }, {
    name: 'Sweden',
    code2: 'SE',
    code3: 'SWE'
  }, {
    name: 'Slovenia',
    code2: 'SI',
    code3: 'SVN'
  }, {
    name: 'Svalbard and Jan Mayen',
    code2: 'SJ',
    code3: 'SJM'
  }, {
    name: 'Slovak Republic',
    code2: 'SK',
    code3: 'SVK'
  }, {
    name: 'San Marino',
    code2: 'SM',
    code3: 'SMR'
  }, {
    name: 'Ukraine',
    code2: 'UA',
    code3: 'UKR'
  }, {
    name: 'Vatican City',
    code2: 'VA',
    code3: 'VAT'
  }, {
    name: 'Kosovo',
    code2: 'XK',
    code3: 'UNK'
  }]
}, {
  name: 'South America',
  countries: [{
    name: 'Argentina',
    code2: 'AR',
    code3: 'ARG'
  }, {
    name: 'Bolivia',
    code2: 'BO',
    code3: 'BOL'
  }, {
    name: 'Brazil',
    code2: 'BR',
    code3: 'BRA'
  }, {
    name: 'Chile',
    code2: 'CL',
    code3: 'CHL'
  }, {
    name: 'Colombia',
    code2: 'CO',
    code3: 'COL'
  }, {
    name: 'Ecuador',
    code2: 'EC',
    code3: 'ECU'
  }, {
    name: 'Falkland Islands',
    code2: 'FK',
    code3: 'FLK'
  }, {
    name: 'French Guiana',
    code2: 'GF',
    code3: 'GUF'
  }, {
    name: 'Guyana',
    code2: 'GY',
    code3: 'GUY'
  }, {
    name: 'Peru',
    code2: 'PE',
    code3: 'PER'
  }, {
    name: 'Paraguay',
    code2: 'PY',
    code3: 'PRY'
  }, {
    name: 'Suriname',
    code2: 'SR',
    code3: 'SUR'
  }, {
    name: 'Uruguay',
    code2: 'UY',
    code3: 'URY'
  }, {
    name: 'Venezuela',
    code2: 'VE',
    code3: 'VEN'
  }]
}];
class GeographyService {
  constructor(http, translateService) {
    this.http = http;
    this.translateService = translateService;
    this.geolocationUrl = '/topojson/v2/geolocation.json';
    this.geoJsonUrl = '/topojson/v2/world-countries.json';
    this.currentLanguage = 'en';
    this.subscriptions = new Subscription();
    this.updateCurrentLanguage(translateService.currentLang);
    this.subscriptions.add(this.translateService.onLangChange.subscribe(langChangeEvent => {
      const currentLang = langChangeEvent.lang?.substring(0, 2);
      this.updateCurrentLanguage(currentLang);
    }));
  }
  ngOnDestroy() {
    this.subscriptions?.unsubscribe();
  }
  /**
   * This organizes the countries by continent.
   * @returns Observable<Continent[]>
   */
  getContinents() {
    if (this.continents) {
      return of(this.continents);
    }
    return new Observable(observer => {
      this.getGeolocationJson().pipe(first()).subscribe(data => {
        const continents = this.getContinentsFromJson(data);
        if (!continents?.length) {
          observer.next(null);
          observer.complete();
          return;
        }
        continents.sort((a, b) => a.name.localeCompare(b.name));
        this.getCountries().pipe(first()).subscribe(countries => {
          // add countries to continents
          continents.forEach(continent => {
            continent.countries = countries.filter(findCountry => findCountry.continentCode === continent.code);
          });
          this.continents = continents;
          observer.next(continents);
          observer.complete();
        });
      });
    });
  }
  /**
   * This returns a sorted list of countries
   * @returns Observable<Country[]>
   */
  getCountries() {
    if (this.countries) {
      return of(this.countries);
    }
    return new Observable(observer => {
      this.getGeolocationJson().pipe(first()).subscribe(data => {
        const continents = this.getContinentsFromJson(data);
        const webUiCountries = data?.geolocation['country-list']?.country;
        if (!webUiCountries?.length) {
          observer.next(null);
          observer.complete();
          return;
        }
        const countries = [];
        webUiCountries.forEach(webUiCountry => {
          const continent = continents.find(findContinent => findContinent.code === webUiCountry['continent-code']);
          countries.push({
            name: webUiCountry.name.find(findName => findName['@lang'] === this.currentLanguage)['#text'],
            code2: webUiCountry.alpha2,
            code3: webUiCountry.alpha3,
            continent: continent?.name,
            continentCode: continent?.code
          });
        });
        countries.sort((a, b) => a.name.localeCompare(b.name));
        this.countries = countries;
        observer.next(countries);
        observer.complete();
      });
    });
  }
  getCountryNameFromFeature(feature) {
    return feature?.properties?.name;
  }
  getCountryCode2FromFeature(feature) {
    return feature?.properties?.iso_a2;
  }
  getCountryCode3FromFeature(feature) {
    return feature?.properties?.iso_a3;
  }
  getCountryCode3toNameMap() {
    if (this.countryCode3Map) {
      return of(this.countryCode3Map);
    }
    return this.getCountries().pipe(map$1(countries => {
      this.countryCode3Map = (countries ?? []).reduce((acc, country) => {
        acc.set(country.code3, country.name);
        return acc;
      }, new Map());
      return this.countryCode3Map;
    }));
  }
  getGeoJson() {
    if (this.translatedGeoJson) {
      return of(this.translatedGeoJson);
    }
    return new Observable(observer => {
      if (this.geoJson) {
        this.translateGeoJson().pipe(first()).subscribe(translatedGeoJson => {
          this.translatedGeoJson = translatedGeoJson;
          observer.next(translatedGeoJson);
          observer.complete();
        });
        return;
      }
      this.http.get(this.geoJsonUrl).pipe(first()).subscribe(json => {
        this.geoJson = json;
        this.translateGeoJson().pipe(first()).subscribe(translatedGeoJson => {
          this.translatedGeoJson = translatedGeoJson;
          observer.next(translatedGeoJson);
          observer.complete();
        });
      });
    });
  }
  getContinentsFromJson(data) {
    if (!data) {
      return null;
    }
    const webUiContinents = data?.geolocation['continent-list']?.continent;
    if (!webUiContinents?.length) {
      return null;
    }
    const continents = [];
    webUiContinents.forEach(webUiContinent => {
      continents.push({
        name: webUiContinent.name.find(findName => findName['@lang'] === this.currentLanguage)['#text'],
        code: webUiContinent.code,
        countries: []
      });
    });
    return continents;
  }
  getGeolocationJson() {
    if (this.geolocationJson) {
      return of(this.geolocationJson);
    }
    return this.http.get(this.geolocationUrl).pipe(tap$1(json => this.geolocationJson = json));
  }
  translateGeoJson() {
    if (this.translatedGeoJson || !this.geoJson) {
      return null;
    }
    return this.getCountries().pipe(first(), map$1(countries => {
      const translatedGeoJson = JSON.parse(JSON.stringify(this.geoJson));
      translatedGeoJson.features?.forEach(feature => {
        const featureCode3 = this.getCountryCode3FromFeature(feature);
        feature.properties.name = countries.find(findCountry => findCountry.code3 === featureCode3).name;
      });
      return translatedGeoJson;
    }));
  }
  updateCurrentLanguage(translateServiceLang) {
    const prevLanguage = this.currentLanguage;
    if (translateServiceLang === 'es' || translateServiceLang === 'fr' || translateServiceLang === 'ja') {
      this.currentLanguage = translateServiceLang;
    } else {
      this.currentLanguage = 'en';
    }
    // force update of names if language has changed
    this.continents = null;
    this.countries = null;
    this.countryCode3Map = null;
    this.translatedGeoJson = null;
  }
  static {
    this.ɵfac = function GeographyService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GeographyService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GeographyService,
      factory: GeographyService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GeographyService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: i1$1.TranslateService
  }], null);
})();
;

/**
 * This class is the default operator settings service. It doesn't do anything. This is here so
 * we don't have to set up a session, or update local storage for no reason for sample projects
 * like wg-table-sample that use tables
 *
 * We want to use LocalStorageOperatorSettingsService for sample apps that need to save settings without a session
 * and BackendOperatorSettingsService for wgc-unified-app, etc
 */
class OperatorSettingsService {
  delete(name) {
    return of({
      success: true,
      message: `No-op`
    });
  }
  get(name) {
    return of(null);
  }
  save(name, value) {
    return of({
      success: true,
      message: `No-op`
    });
  }
  static {
    this.ɵfac = function OperatorSettingsService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OperatorSettingsService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OperatorSettingsService,
      factory: OperatorSettingsService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OperatorSettingsService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
const BASE_URL = 'operator-settings-svc/v1/preferences/';
const HEADERS = new HttpHeaders({
  'Content-Type': 'application/json'
});
/**
 * This class is the OperatorSettingsService that saves the operator settings to the cloud backend.
 * This should be used for any production projects. To use simply override the provider
 */
class BackendOperatorSettingsService {
  constructor() {
    this.http = inject(HttpClient);
  }
  delete(name) {
    let url = `${this.getGuardApiUrl()}${BASE_URL}${name}`;
    return this.http.delete(url, {
      headers: HEADERS
    }).pipe(map$1(response => {
      return {
        success: response.status === 'Success',
        message: response.message
      };
    }), catchError$1(this.handleError));
  }
  get(name) {
    let url = `${this.getGuardApiUrl()}${BASE_URL}${name}`;
    return this.http.get(url, {
      headers: HEADERS
    }).pipe(map$1(response => response.data), catchError$1(this.handleError));
  }
  save(name, value) {
    let url = `${this.getGuardApiUrl()}${BASE_URL}${name}`;
    return this.http.put(url, {
      data: value
    }, {
      headers: HEADERS
    }).pipe(map$1(response => {
      {
        return {
          success: response.status === 'Success',
          message: response.message
        };
      }
    }), catchError$1(this.handleError));
  }
  getGuardApiUrl(override = '') {
    const options = {
      region: 'usa',
      override
    };
    if (window.location.host.indexOf('watchguard.com') !== -1) {
      options.override = '';
    }
    return newGuardApiUrl(options);
  }
  handleError(error) {
    const errMsg = error.message ? error.message : error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error(`Error while handling operator settings: ${errMsg}`);
    return of(null);
  }
  static {
    this.ɵfac = function BackendOperatorSettingsService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BackendOperatorSettingsService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: BackendOperatorSettingsService,
      factory: BackendOperatorSettingsService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BackendOperatorSettingsService, [{
    type: Injectable
  }], null, null);
})();

/**
 * This class uses localStorage to save settings to the browser. This will be used in sample apps and the Design System, etc
 * where we don't have user sessions available.
 */
class LocalStorageOperatorSettingsService {
  delete(name) {
    localStorage.removeItem(name);
    return of({
      success: true,
      message: `Deleted ${name}`
    });
  }
  get(name) {
    return of(JSON.parse(localStorage.getItem(name)));
  }
  save(name, value) {
    localStorage.setItem(name, JSON.stringify(value));
    return of({
      success: true,
      message: `Saved ${name}`
    });
  }
  static {
    this.ɵfac = function LocalStorageOperatorSettingsService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LocalStorageOperatorSettingsService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LocalStorageOperatorSettingsService,
      factory: LocalStorageOperatorSettingsService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocalStorageOperatorSettingsService, [{
    type: Injectable
  }], null, null);
})();
const DB = new Map();
class DatabaseMockHandlerClass {
  process(url, request, next) {
    console.log(`Handled <db>: ${request.url} <${request.method.toLowerCase()}>`);
    const regExp = new RegExp(url.regExp, 'g');
    const matches = regExp.exec(request.url);
    const tableName = this.getTableName(url, matches);
    const id = this.getIdFromRequest(url, matches);
    let objects = DB.get(tableName);
    if (!objects && url.initialJson) {
      if (url.initialJson.default) {
        objects = url.initialJson.default;
      } else {
        objects = url.initialJson;
      }
      DB.set(tableName, objects);
    } else if (!objects || objects.length === 0) {
      objects = [];
      DB.set(tableName, objects);
    }
    let obj = null;
    if (id !== undefined) {
      obj = objects.find(findObject => {
        return findObject.id === id;
      });
    }
    let response;
    switch (request.method.toLowerCase()) {
      case 'get':
        if (id) {
          response = new HttpResponse({
            status: 200,
            body: obj
          });
        } else {
          response = new HttpResponse({
            status: 200,
            body: objects
          });
        }
        break;
      case 'post':
        obj = request.body;
        obj.id = this.getNextDatabaseId(tableName);
        if (url.getNextId) {
          obj.id = url.getNextId(obj, url, matches);
        }
        if (url.transformObjectForAdd) {
          url.transformObjectForAdd(obj, url, matches, objects);
        }
        objects.push(obj);
        DB.set(tableName, objects);
        response = new HttpResponse({
          status: 200,
          body: obj
        });
        break;
      case 'put':
        if (!obj) {
          response = new HttpResponse({
            status: 500
          });
          break;
        }
        obj = Object.assign({}, obj, request.body);
        objects.splice(objects.findIndex(findObject => findObject.id === obj.id), 1);
        objects.push(obj);
        DB.set(tableName, objects);
        response = new HttpResponse({
          status: 200,
          body: obj
        });
        break;
      case 'delete':
        if (!obj) {
          response = new HttpResponse({
            status: 500
          });
          break;
        }
        objects.splice(objects.findIndex(findObject => findObject.id === obj.id), 1);
        if (url.cleanupAfterDelete) {
          url.cleanupAfterDelete(obj, objects, url, matches);
        }
        DB.set(tableName, objects);
        response = new HttpResponse({
          status: 200,
          body: obj
        });
        break;
    }
    return of(response).pipe(delay(250));
  }
  getIdFromRequest(url, urlRegexMatches) {
    const idMatchIndex = url.idMatchIndex && url.idMatchIndex > 0 ? url.idMatchIndex : 1;
    return urlRegexMatches && urlRegexMatches.length > idMatchIndex ? urlRegexMatches[idMatchIndex] : undefined;
  }
  getNextDatabaseId(objType) {
    let id = 1;
    const objects = DB.get(objType);
    if (objects && objects.length > 0) {
      objects.forEach(findObject => {
        if (findObject.id >= id) {
          id = findObject.id + 1;
        }
      });
    }
    return id;
  }
  getTableName(url, urlRegexMatches) {
    let tableName = url.tableName;
    if (tableName.indexOf('$') >= 0 && urlRegexMatches) {
      for (let index = 0; index < urlRegexMatches.length; index++) {
        tableName = tableName.replace(`$${index}`, urlRegexMatches[index]);
      }
    }
    return tableName;
  }
}
const DatabaseMockHandler = new DatabaseMockHandlerClass();
class JsonMockHandlerClass {
  process(url, request, next) {
    console.log(`Handled <json>: ${request.url} <${request.method.toLowerCase()}>`);
    return of(new HttpResponse({
      status: 200,
      body: url.jsonToReturn
    })).pipe(delay(250));
  }
}
const JsonMockHandler = new JsonMockHandlerClass();
const DEV_STATIC_URL = '//dev.usa.cloud.watchguard.com.s3-website-us-west-2.amazonaws.com';
class StaticMockHandlerClass {
  process(url, request, next) {
    console.log(`Handled <static>: ${request.url} <${request.method.toLowerCase()}>`);
    let requestUrl = request.url;
    if (requestUrl.startsWith('.')) {
      requestUrl = requestUrl.substring(1);
    }
    if (!requestUrl.startsWith('/')) {
      requestUrl = `/${requestUrl}`;
    }
    requestUrl = `${DEV_STATIC_URL}${requestUrl}`;
    console.log(`Forwarded to: ${requestUrl}`);
    const newRequest = request.clone({
      url: requestUrl
    });
    return next.handle(newRequest);
  }
}
const StaticMockHandler = new StaticMockHandlerClass();
function fixMainCssUrls() {
  const mainCssElements = document.head.querySelectorAll('link[rel="stylesheet"][href*="css/wgc"');
  mainCssElements.forEach(mainCssElement => {
    let href = mainCssElement.getAttribute('href');
    if (!href.startsWith('/')) {
      href = `/${href}`;
    }
    console.log(`Fixing CSS url: ${href} => ${DEV_STATIC_URL}${href}`);
    mainCssElement.setAttribute('href', `${DEV_STATIC_URL}${href}`);
  });
}
class MockUrlList extends Array {}
const STATIC_URL_REGEXP = new RegExp(`^\.?/?(assets|css|fonts|images|locale\\-bundle|topojson)/.*$`);
class HttpMockRequestInterceptor {
  constructor(urlsToMock) {
    this.urlsToMock = urlsToMock;
  }
  intercept(request, next) {
    if (request.url.endsWith('transact')) {
      return this.processTransactRequest(request, next);
    }
    if (this.urlsToMock && this.urlsToMock.length > 0) {
      for (const url of this.urlsToMock) {
        const regExp = new RegExp(url.regExp, 'g');
        if (url.methods.indexOf(request.method.toLowerCase()) !== -1 && regExp.test(request.url)) {
          switch (url.type) {
            case 'json':
              return JsonMockHandler.process(url, request);
            case 'database':
              return DatabaseMockHandler.process(url, request);
          }
        }
      }
    }
    if (STATIC_URL_REGEXP.test(request.url)) {
      return StaticMockHandler.process(undefined, request, next);
    }
    console.log(`Handled <default http>: ${request.url} <${request.method.toLowerCase()}>`);
    return next.handle(request);
  }
  processTransactRequest(request, next) {
    // for processing sub request's url
    const servicePath = 'firebox/gateway';
    // process sub requests:
    //    form sub http request:
    //    method: request.body[i].method
    //    url: request.body[i].url ==> full scale http url
    //      e.g.
    //      "v1/WGC-1-93c42986d7b849bf9840/configuration/ipsec/gatewaypairs/ipsgp_ucQPkGKB3gxvsc25ZLNf1"
    //      ==>
    //      "https://guard.dev.usa.cloud.watchguard.com/cloud/firebox/gateway/v1/
    //         WGC-1-93c42986d7b849bf9840/configuration/ipsec/gatewaypairs/ipsgp_ucQPkGKB3gxvsc25ZLNf1"
    //    body: request.body[i].data
    const ind = request.url.indexOf(servicePath) + servicePath.length;
    const subS = request.url.substring(0, ind);
    let response;
    for (const subReq of request.body) {
      // clone request and replace url with urlUpdated at the same time
      const subReqUrl = subS + '/' + subReq.url;
      const newHttpsReq = request.clone({
        method: subReq.method,
        url: subReqUrl,
        body: subReq.data
      });
      // invoke original intercept() for the sub request
      this.intercept(newHttpsReq, next).subscribe(val => {
        if (val.type === HttpEventType.Response) {
          response = val;
          if (response.status !== 200) {
            return of(response);
          }
        }
      });
    }
    // all the sub requests finish successfully
    response = new HttpResponse({
      status: 200
    });
    return of(response);
  }
  static {
    this.ɵfac = function HttpMockRequestInterceptor_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HttpMockRequestInterceptor)(i0.ɵɵinject(MockUrlList));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: HttpMockRequestInterceptor,
      factory: HttpMockRequestInterceptor.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HttpMockRequestInterceptor, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: MockUrlList
  }], null);
})();
class MockHandler {}
class WgInfoPopoverComponent {
  constructor() {
    this.text = '';
  }
  static {
    this.ɵfac = function WgInfoPopoverComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgInfoPopoverComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgInfoPopoverComponent,
      selectors: [["wg-info-popover"]],
      inputs: {
        text: "text",
        bypassSecurity: "bypassSecurity"
      },
      standalone: false,
      decls: 1,
      vars: 3,
      consts: [["name", "circle-info", 3, "wgTooltip", "wgTooltipBypassSecurity", "wgTooltipPos"]],
      template: function WgInfoPopoverComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "wg-icon", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("wgTooltip", ctx.text)("wgTooltipBypassSecurity", ctx.bypassSecurity)("wgTooltipPos", "bottom");
        }
      },
      dependencies: [WgIconComponent, WgTooltipDirective],
      styles: ["wg-info-popover{cursor:pointer;display:inline-block;line-height:1;margin-left:10px;vertical-align:middle}wg-info-popover wg-icon{--icon-fill: #367b88}.form-row wg-info-popover{margin-bottom:9px;margin-left:0}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgInfoPopoverComponent, [{
    type: Component,
    args: [{
      encapsulation: ViewEncapsulation.None,
      selector: 'wg-info-popover',
      standalone: false,
      template: "<wg-icon name=\"circle-info\" [wgTooltip]=\"text\" [wgTooltipBypassSecurity]=\"bypassSecurity\" [wgTooltipPos]=\"'bottom'\"></wg-icon>\n",
      styles: ["wg-info-popover{cursor:pointer;display:inline-block;line-height:1;margin-left:10px;vertical-align:middle}wg-info-popover wg-icon{--icon-fill: #367b88}.form-row wg-info-popover{margin-bottom:9px;margin-left:0}\n"]
    }]
  }], null, {
    text: [{
      type: Input
    }],
    bypassSecurity: [{
      type: Input
    }]
  });
})();
class WgInfoPopoverModule {
  static {
    this.ɵfac = function WgInfoPopoverModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgInfoPopoverModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgInfoPopoverModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, WgIconModule, WgTooltipModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgInfoPopoverModule, [{
    type: NgModule,
    args: [{
      declarations: [WgInfoPopoverComponent],
      imports: [CommonModule, WgIconModule, WgTooltipModule],
      exports: [WgInfoPopoverComponent]
    }]
  }], null, null);
})();
function commaify(val, args) {
  let ret = '';
  if (val === undefined || val === null || isNaN(val)) {
    return val;
  }
  return val.toLocaleString('en-US');
}
/*
 * add comma to numbers
 */
class CommaifyPipe {
  transform(val, args) {
    return commaify(val, args);
  }
  static {
    this.ɵfac = function CommaifyPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CommaifyPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "commaify",
      type: CommaifyPipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CommaifyPipe, [{
    type: Pipe,
    args: [{
      name: 'commaify',
      standalone: false
    }]
  }], null, null);
})();

/**
 * converts HTML special charecters to their entity equivalents
 */
class EscapeHtmlPipe {
  constructor() {
    this.entityMap = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      '\'': '&#39;'
    };
  }
  transform(source) {
    let escapedSource = '';
    if (source) {
      escapedSource = source.replace(/[&<>"']/g, s => {
        return this.entityMap[s];
      });
    }
    return escapedSource;
  }
  static {
    this.ɵfac = function EscapeHtmlPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || EscapeHtmlPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "escapeHtml",
      type: EscapeHtmlPipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EscapeHtmlPipe, [{
    type: Pipe,
    args: [{
      name: 'escapeHtml',
      standalone: false
    }]
  }], null, null);
})();

/*
 * transform numbers to appropriate units
 */
class FormatHitsPipe {
  constructor() {
    this.units = ['', 'K', 'M', 'B', 'T'];
  }
  transform(value, i = 0) {
    if (value === undefined || value === null || isNaN(value)) {
      return '';
    }
    if (value < 999) {
      if (Number.isInteger(value)) {
        return value.toString() + this.units[i];
      } else {
        return value.toFixed(1) + this.units[i];
      }
    } else {
      return this.transform(value / 1000, ++i);
    }
  }
  static {
    this.ɵfac = function FormatHitsPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormatHitsPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "formatHits",
      type: FormatHitsPipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormatHitsPipe, [{
    type: Pipe,
    args: [{
      name: 'formatHits',
      standalone: false
    }]
  }], null, null);
})();

/*
 * bytes display formatting
 * added translation service here
 * make sure that language is already downloaded when using this pipe
 */
class FormatBytesPipe {
  constructor(translateService) {
    this.translateService = translateService;
    this.formatStrings = {
      BYTES: 'visibility_bytes',
      TB: 'visibility_TB',
      GB: 'visibility_GB',
      MB: 'visibility_MB',
      KB: 'visibility_KB'
    };
  }
  transform(val, args = {}) {
    const value = +val;
    const start = value / 1024;
    let ret = '';
    const fractionDigits = args.fractionDigits || 0;
    if (start > 1) {
      const start1 = start / 1024;
      if (start1 > 1) {
        const start2 = start1 / 1024;
        if (start2 > 1) {
          const start3 = start2 / 1024;
          if (start3 > 10) {
            ret = start3.toFixed(fractionDigits) + ' ' + this.translateService.instant(this.formatStrings.TB);
          } else {
            ret = start2.toFixed(fractionDigits) + ' ' + this.translateService.instant(this.formatStrings.GB);
          }
        } else {
          ret = start1.toFixed(fractionDigits) + ' ' + this.translateService.instant(this.formatStrings.MB);
        }
      } else {
        ret = start.toFixed(fractionDigits) + ' ' + this.translateService.instant(this.formatStrings.KB);
      }
    } else {
      const units = args.showBytes ? ' ' + this.translateService.instant(this.formatStrings.BYTES) : '';
      ret = value.toFixed(0) + units;
    }
    return ret;
  }
  static {
    this.ɵfac = function FormatBytesPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormatBytesPipe)(i0.ɵɵdirectiveInject(i1$1.TranslateService, 16));
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "formatBytes",
      type: FormatBytesPipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormatBytesPipe, [{
    type: Pipe,
    args: [{
      name: 'formatBytes',
      standalone: false
    }]
  }], () => [{
    type: i1$1.TranslateService
  }], null);
})();

/*
 * Format the bandwidth to bps, Gbps, Mbps, and Kbps
 * Usage:
 *   value | number (bytes per second)
 * Example:
 *   {{ 8000 | formatBandwidth }}
 *   formats to: 8 Kbps
*/
class FormatBandwidthPipe {
  constructor(translateService) {
    this.translateService = translateService;
    this.units = [{
      divisor: 1000 ** 3,
      label: 'gbps',
      toFix: 2
    }, {
      divisor: 1000 ** 2,
      label: 'mbps',
      toFix: 2
    }, {
      divisor: 1000,
      label: 'kbps',
      toFix: 2
    }, {
      divisor: 1,
      label: 'bps',
      toFix: 0
    }];
  }
  transform(bandwidth, args = {}) {
    const bandwidthBits = args.bps ? bandwidth : bandwidth * 8;
    const unit = this.units.find(x => bandwidthBits > x.divisor) || this.units[this.units.length - 1];
    const toFix = unit.divisor > 1 && args.hasOwnProperty('fractionDigits') ? args.fractionDigits : unit.toFix;
    return commaify((bandwidthBits / unit.divisor).toFixed(toFix)) + ' ' + this.translateService.instant(unit.label);
  }
  static {
    this.ɵfac = function FormatBandwidthPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormatBandwidthPipe)(i0.ɵɵdirectiveInject(i1$1.TranslateService, 16));
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "formatBandwidth",
      type: FormatBandwidthPipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormatBandwidthPipe, [{
    type: Pipe,
    args: [{
      name: 'formatBandwidth',
      standalone: false
    }]
  }], () => [{
    type: i1$1.TranslateService
  }], null);
})();

/*
 * Filter out bytes column if totalBytes is zero
 */
class RemoveColumnPipe {
  constructor() {
    this.removeCols = ['bytes', 'quota']; // remove column if all fields for column in removeColArray are empty
  }
  transform(value, totalBytes) {
    return value.filter(val => this.keepColumn(val, totalBytes));
  }
  keepColumn(val, totalBytes) {
    if (this.removeCols.includes(val.field) && totalBytes === 0) {
      return false;
    }
    return true;
  }
  static {
    this.ɵfac = function RemoveColumnPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RemoveColumnPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "removeColumn",
      type: RemoveColumnPipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RemoveColumnPipe, [{
    type: Pipe,
    args: [{
      name: 'removeColumn',
      standalone: false
    }]
  }], null, null);
})();

/**
 * Title Case
 *
 * See: https://medium.com/@mwhitt.w/converting-text-to-titlecase-using-angular2-pipes-552b3bfa8e22#.t64iifvnc
 */
class TitleCasePipe {
  transform(val, args) {
    if (!val) {
      return '';
    } else {
      return val.replace(/\w\S*/g, txt => txt[0].toUpperCase() + txt.substr(1).toLowerCase());
    }
  }
  static {
    this.ɵfac = function TitleCasePipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TitleCasePipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "titleCase",
      type: TitleCasePipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TitleCasePipe, [{
    type: Pipe,
    args: [{
      name: 'titleCase',
      standalone: false
    }]
  }], null, null);
})();

/*
 * convert utc to local formatted date/time
 *
 * val = date
 * inputFormat = format to convert from
 */
class UtcToLocalPipe {
  transform(val, inputFormat, outputFormat) {
    if (!moment(val, inputFormat, true).isValid()) {
      return '';
    }
    if (outputFormat) {
      return moment.utc(val, inputFormat).local().format(outputFormat);
    }
    return moment.utc(val, inputFormat).local().format('YYYY-MM-DD HH:mm:ss');
  }
  static {
    this.ɵfac = function UtcToLocalPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UtcToLocalPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "utcToLocal",
      type: UtcToLocalPipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UtcToLocalPipe, [{
    type: Pipe,
    args: [{
      name: 'utcToLocal',
      standalone: false
    }]
  }], null, null);
})();
let HighlightPipe$2 = class HighlightPipe {
  transform(originalValue, textToHighlight) {
    if (originalValue == null) {
      return originalValue;
    }
    if (textToHighlight == null || textToHighlight.trim() === '') {
      return originalValue;
    }
    // normalize text
    textToHighlight = this.normalizeString(textToHighlight);
    const normalizedValue = this.normalizeString(originalValue);
    const regex = new RegExp(textToHighlight, 'gi');
    let highlightedValue = originalValue.replace(regex, matchedString => {
      return `<b>${matchedString}</b>`;
    });
    return highlightedValue;
  }
  normalizeString(string) {
    return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  }
  static {
    this.ɵfac = function HighlightPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HighlightPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "highlight",
      type: HighlightPipe,
      pure: true,
      standalone: false
    });
  }
};
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HighlightPipe$2, [{
    type: Pipe,
    args: [{
      name: 'highlight',
      standalone: false
    }]
  }], null, null);
})();

/**
 * 'dateTimeDesc' display formatt
 *  dateStr: date string with format like "2023-07-29T16:34:36"
 */
class DateTimeDescPipe {
  transform(dateStr) {
    const lastConnectedDateTime = DateTime.fromJSDate(new Date(dateStr));
    let start;
    let end;
    let interval;
    //Today
    start = DateTime.now().startOf('day');
    end = DateTime.now().endOf('day');
    interval = Interval.fromDateTimes(start, end);
    if (interval.contains(lastConnectedDateTime)) {
      return 'filterdate_today_lbl';
    }
    //This Week
    start = DateTime.now().minus({
      week: 1
    }).endOf('day');
    end = DateTime.now().minus({
      day: 1
    }).endOf('day');
    interval = Interval.fromDateTimes(start, end);
    if (interval.contains(lastConnectedDateTime)) {
      return 'filterdate_thisweek_lbl';
    }
    //1-2 weeks ago
    start = DateTime.now().minus({
      week: 2
    }).endOf('day');
    end = DateTime.now().minus({
      week: 1
    }).endOf('day');
    interval = Interval.fromDateTimes(start, end);
    if (interval.contains(lastConnectedDateTime)) {
      return 'filterdate_1weekago_lbl';
    }
    //2-4 weeks ago
    start = DateTime.now().minus({
      week: 4
    }).endOf('day');
    end = DateTime.now().minus({
      week: 2
    }).endOf('day');
    interval = Interval.fromDateTimes(start, end);
    if (interval.contains(lastConnectedDateTime)) {
      return 'filterdate_2weeksago_lbl';
    }
    //1-6 months ago
    start = DateTime.now().minus({
      months: 6
    }).endOf('day');
    end = DateTime.now().minus({
      months: 1
    }).endOf('day');
    interval = Interval.fromDateTimes(start, end);
    if (interval.contains(lastConnectedDateTime)) {
      return 'filterdate_1monthago_lbl';
    }
    //6-12 months ago
    start = DateTime.now().minus({
      months: 12
    }).endOf('day');
    end = DateTime.now().minus({
      months: 6
    }).endOf('day');
    interval = Interval.fromDateTimes(start, end);
    if (interval.contains(lastConnectedDateTime)) {
      return 'filterdate_6monthsago_lbl';
    }
    //Over one year ago:
    start = DateTime.now().minus({
      year: 200
    }).endOf('day');
    end = DateTime.now().minus({
      year: 1
    }).endOf('day');
    interval = Interval.fromDateTimes(start, end);
    if (interval.contains(lastConnectedDateTime)) {
      return 'filterdate_1yearago_lbl';
    }
    return 'filterdate_not_available_lbl';
  }
  static {
    this.ɵfac = function DateTimeDescPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DateTimeDescPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "dateTimeDesc",
      type: DateTimeDescPipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateTimeDescPipe, [{
    type: Pipe,
    args: [{
      name: 'dateTimeDesc',
      standalone: false
    }]
  }], null, null);
})();
class CountryCode3ToNamePipe {
  constructor() {
    this.geoService = inject(GeographyService);
  }
  transform(code3Countries) {
    if (!code3Countries?.length) {
      return of('');
    }
    return this.geoService.getCountryCode3toNameMap().pipe(map$1(geoMap => {
      return code3Countries.map(x => geoMap.get(x)).join(', ');
    }));
  }
  static {
    this.ɵfac = function CountryCode3ToNamePipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CountryCode3ToNamePipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "countryCode3ToName",
      type: CountryCode3ToNamePipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CountryCode3ToNamePipe, [{
    type: Pipe,
    args: [{
      name: 'countryCode3ToName',
      standalone: false
    }]
  }], null, null);
})();
class WgPipesModule {
  static {
    this.ɵfac = function WgPipesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgPipesModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgPipesModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [CommaifyPipe, EscapeHtmlPipe, FormatHitsPipe, FormatBytesPipe, FormatBandwidthPipe, HighlightPipe$2, RemoveColumnPipe, TitleCasePipe, UtcToLocalPipe, DateTimeDescPipe, CountryCode3ToNamePipe]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgPipesModule, [{
    type: NgModule,
    args: [{
      declarations: [CommaifyPipe, EscapeHtmlPipe, FormatHitsPipe, FormatBytesPipe, FormatBandwidthPipe, HighlightPipe$2, RemoveColumnPipe, TitleCasePipe, UtcToLocalPipe, DateTimeDescPipe, CountryCode3ToNamePipe],
      exports: [CommaifyPipe, EscapeHtmlPipe, FormatHitsPipe, FormatBytesPipe, FormatBandwidthPipe, HighlightPipe$2, RemoveColumnPipe, TitleCasePipe, UtcToLocalPipe, DateTimeDescPipe, CountryCode3ToNamePipe],
      providers: [CommaifyPipe, EscapeHtmlPipe, FormatHitsPipe, FormatBytesPipe, FormatBandwidthPipe, HighlightPipe$2, RemoveColumnPipe, TitleCasePipe, UtcToLocalPipe, DateTimeDescPipe, CountryCode3ToNamePipe]
    }]
  }], null, null);
})();

/**
 * It transforms a known safe value or a value with unknown safety to a safe HTML or raw text
 * depending on the choice of caller.
 *
 * Usage: Use this pipe either as a part of [innerHTML] property or directly in string interpolation.
 */
class SafeHtmlPipe {
  constructor(sanitizer) {
    this.sanitizer = sanitizer;
  }
  transform(htmlStr) {
    return this.sanitizer.sanitize(SecurityContext.NONE, htmlStr);
  }
  static {
    this.ɵfac = function SafeHtmlPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SafeHtmlPipe)(i0.ɵɵdirectiveInject(i1$3.DomSanitizer, 16));
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "safeHtml",
      type: SafeHtmlPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SafeHtmlPipe, [{
    type: Pipe,
    args: [{
      name: "safeHtml",
      standalone: true
    }]
  }], () => [{
    type: i1$3.DomSanitizer
  }], null);
})();
let HighlightPipe$1 = class HighlightPipe {
  transform(value, textToHighlight) {
    if (!textToHighlight) {
      return value;
    }
    textToHighlight = textToHighlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const textFragment = new RegExp(textToHighlight, 'gi');
    return value.replace(textFragment, '<b>$&</b>');
  }
  static {
    this.ɵfac = function HighlightPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HighlightPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "highlight",
      type: HighlightPipe,
      pure: true,
      standalone: false
    });
  }
};
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HighlightPipe$1, [{
    type: Pipe,
    args: [{
      name: 'highlight',
      standalone: false
    }]
  }], null, null);
})();
class WgSelectorComponent {
  set selected(selectedList) {
    if (selectedList) {
      this.selectedListSubject.next([...selectedList]);
    }
  }
  set options(optionList) {
    if (optionList) {
      this.availableListSubject.next([...optionList]);
    }
  }
  searchChanged(searchText) {
    this.inputValue = searchText;
    this.searchSubject.next(searchText);
  }
  constructor(translateService) {
    this.translateService = translateService;
    this.selectedChange = new EventEmitter();
    this.selectedOptionClick = new EventEmitter();
    this.allowCustom = false;
    this.maxHeight = 0;
    this.placeholder = '';
    this.noneFound = '';
    this.label = 'name';
    this.keyField = '';
    this.className = 'form-control';
    this.disabled = false;
    this.toggleHeight = false;
    this.inputValue = '';
    this.isDropdownOpened = false;
    this.availableListSubject = new BehaviorSubject([]);
    this.selectedListSubject = new BehaviorSubject([]);
    this.searchSubject = new BehaviorSubject('');
    this.itemsMaxHeightPx = 200;
    this.itemHeightPx = 40;
  }
  ngOnInit() {
    this.lists$ = combineLatest([this.availableListSubject.asObservable(), this.selectedListSubject.asObservable(), this.searchSubject.asObservable().pipe(tap(value => {
      if (!!value) {
        this.showOptionsDropdown();
      }
    }))]).pipe(map(this.translateTag.bind(this)), map(this.filterAvailableItems.bind(this)), map(this.createWrapper.bind(this)), shareReplay(1));
  }
  emitClickedOptionEvent(selectedItem) {
    this.selectedOptionClick.emit(selectedItem);
  }
  getHeight(totalAvailableItems) {
    const totalHeight = totalAvailableItems * this.itemHeightPx;
    return (totalHeight > this.itemsMaxHeightPx ? this.itemsMaxHeightPx : totalHeight) + 'px';
  }
  moveFocus(index, event) {
    event.preventDefault();
    if (!this.isDropdownOpened) {
      this.showOptionsDropdown();
      return;
    }
    combineLatest([this.lists$, this.getFocusedOption()]).pipe(first$1()).subscribe(([{
      availableItems
    }, focusedOption]) => {
      if (!availableItems || !availableItems.length) {
        return;
      }
      let newIndex = 0;
      if (focusedOption) {
        newIndex = availableItems.indexOf(focusedOption) + index;
      }
      const nextFocusableItem = availableItems[newIndex];
      if (nextFocusableItem) {
        nextFocusableItem.focused = true;
        if (focusedOption) {
          focusedOption.focused = false;
        }
      }
      if (this.viewport) {
        this.viewport.scrollToIndex(newIndex - 2);
      }
    });
  }
  showOptionsDropdown() {
    this.isDropdownOpened = true;
  }
  focusInputSelector(event) {
    if (event.target === event.currentTarget) {
      this.inputSelector.nativeElement.focus();
    }
  }
  closeOptionsDropdown() {
    this.isDropdownOpened = false;
    this.inputValue = '';
    this.searchSubject.next('');
  }
  setOption(event) {
    this.getFocusedOption().subscribe(focusedOption => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (!focusedOption || !this.isDropdownOpened) {
        return;
      }
      if (this.allowCustom && this.selectedListSubject.value.find(this.getItemsCompare(focusedOption.item))) {
        this.closeOptionsDropdown();
        return;
      }
      const newSelectedItems = [...this.selectedListSubject.value, focusedOption?.item];
      this.selectedListSubject.next(newSelectedItems);
      this.emitSelectedOptionEvent();
      this.closeOptionsDropdown();
      this.scrollToLast();
    });
  }
  removeLastItem() {
    const selectedList = this.selectedListSubject.value;
    if (!this.inputValue && selectedList && selectedList.length) {
      const lastItem = selectedList[selectedList.length - 1];
      this.remove(lastItem);
      this.scrollToLast();
    }
  }
  remove(selectedItem) {
    if (this.disabled) {
      return;
    }
    const selectedList = [...this.selectedListSubject.value];
    selectedList.splice(selectedList.indexOf(selectedItem), 1);
    this.selectedListSubject.next(selectedList);
    this.emitSelectedOptionEvent();
  }
  preventDefault(event) {
    event.preventDefault();
  }
  clearFocus() {
    this.lists$.pipe(first$1()).subscribe(({
      availableItems
    }) => {
      availableItems.filter(item => item.focused).forEach(item => item.focused = false);
    });
  }
  mouseOver(item) {
    this.clearFocus();
    item.focused = true;
  }
  addCustomOptionToDropdown(availableItems, filter) {
    if (!filter) {
      return;
    }
    const foundMatch = !!availableItems.find(this.getItemsCompare(filter));
    if (foundMatch) {
      return;
    }
    if (this.keyField) {
      const customItem = {};
      customItem[this.keyField] = filter;
      availableItems.unshift(customItem);
    } else {
      availableItems.unshift(filter);
    }
  }
  emitSelectedOptionEvent() {
    this.selectedChange.emit(this.selectedListSubject.value);
  }
  scrollToLast() {
    setTimeout(() => {
      if (this.selectedOptionsContainer) {
        const element = this.selectedOptionsContainer.nativeElement;
        element.scrollTop = element.scrollHeight;
      }
    });
  }
  getFocusedOption() {
    return this.lists$.pipe(first$1(), map(({
      availableItems
    }) => availableItems.find(availableItem => availableItem.focused)));
  }
  getItemsCompare(filter) {
    let findMatch = findItem => JSON.stringify(filter) === JSON.stringify(findItem);
    if (this.keyField) {
      findMatch = findItem => (typeof filter === 'string' ? filter : filter[this.keyField]) === findItem[this.keyField];
    }
    return findMatch;
  }
  filterAvailableItems([availableItems, selectedItems, filter]) {
    const filterSelectedItems = option => {
      return !selectedItems || !selectedItems.some(this.getItemsCompare(option));
    };
    const filterUserSearch = option => {
      return !filter ? option : option[this.label].toLowerCase().includes(filter.toLowerCase()) || option[this.tag]?.toLowerCase().includes(filter.toLowerCase());
    };
    availableItems = availableItems.filter(filterSelectedItems).filter(filterUserSearch);
    if (this.allowCustom) {
      this.addCustomOptionToDropdown(availableItems, filter);
    }
    return {
      availableItems,
      selectedItems
    };
  }
  translateTag([availableItems, selectedItems, filter]) {
    return [availableItems.map(item => {
      if (this.tag && item[this.tag]) {
        item[this.tag] = this.translateService.instant(item[this.tag]);
      }
      return item;
    }), selectedItems.map(item => {
      if (this.tag && item[this.tag]) {
        item[this.tag] = this.translateService.instant(item[this.tag]);
      }
      return item;
    }), filter];
  }
  createWrapper({
    availableItems,
    selectedItems
  }) {
    availableItems = availableItems.map((itemAvailable, index) => ({
      item: itemAvailable,
      focused: index === 0
    }));
    return {
      availableItems,
      selectedItems
    };
  }
  static {
    this.ɵfac = function WgSelectorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgSelectorComponent)(i0.ɵɵdirectiveInject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgSelectorComponent,
      selectors: [["wg-selector"]],
      viewQuery: function WgSelectorComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c2, 7);
          i0.ɵɵviewQuery(CdkVirtualScrollViewport, 5);
          i0.ɵɵviewQuery(_c26, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputSelector = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.viewport = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.selectedOptionsContainer = _t.first);
        }
      },
      inputs: {
        allowCustom: "allowCustom",
        maxHeight: "maxHeight",
        placeholder: "placeholder",
        noneFound: "noneFound",
        label: "label",
        tag: "tag",
        keyField: "keyField",
        className: "className",
        disabled: "disabled",
        toggleHeight: "toggleHeight",
        selected: "selected",
        options: "options"
      },
      outputs: {
        selectedChange: "selectedChange",
        selectedOptionClick: "selectedOptionClick"
      },
      standalone: false,
      decls: 10,
      vars: 20,
      consts: [["selectedOptionsContainer", ""], ["selector", ""], ["noneFoundTemplate", ""], [1, "mult-selector-input", 3, "click", "mousedown", "ngClass"], [1, "selected-options", 3, "click"], ["class", "btn", "role", "button", 4, "ngFor", "ngForOf"], [1, "input-with-icon", 3, "ngClass"], ["type", "text", 1, "selector-input", 3, "ngModelChange", "focus", "click", "mousedown", "blur", "keydown.backspace", "keydown.enter", "keydown.esc", "keydown.arrowup", "keydown.arrowdown", "ngClass", "ngModel", "placeholder", "disabled"], ["name", "expanded", 3, "click"], ["class", "box-options", "role", "listbox", 4, "ngIf"], ["role", "button", 1, "btn"], [3, "click"], ["class", "table-status-label", 4, "ngIf"], [1, "close", 3, "click"], ["name", "close"], [1, "table-status-label"], ["role", "listbox", 1, "box-options"], [4, "ngIf", "ngIfElse"], [1, "viewport", 3, "itemSize"], ["class", "box-option", "role", "option", 3, "class", "focused", "click", "mousedown", "mouseenter", "mouseleave", 4, "cdkVirtualFor", "cdkVirtualForOf"], ["role", "option", 1, "box-option", 3, "click", "mousedown", "mouseenter", "mouseleave"], [3, "innerHTML"], ["class", "disabled", 4, "ngIf"], [1, "disabled"]],
      template: function WgSelectorComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 3);
          i0.ɵɵlistener("click", function WgSelectorComponent_Template_div_click_0_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.focusInputSelector($event));
          })("mousedown", function WgSelectorComponent_Template_div_mousedown_0_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.preventDefault($event));
          });
          i0.ɵɵelementStart(1, "div", 4, 0);
          i0.ɵɵlistener("click", function WgSelectorComponent_Template_div_click_1_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.focusInputSelector($event));
          });
          i0.ɵɵtemplate(3, WgSelectorComponent_span_3_Template, 7, 6, "span", 5);
          i0.ɵɵpipe(4, "async");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "div", 6)(6, "input", 7, 1);
          i0.ɵɵlistener("ngModelChange", function WgSelectorComponent_Template_input_ngModelChange_6_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.searchChanged($event));
          })("focus", function WgSelectorComponent_Template_input_focus_6_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.showOptionsDropdown());
          })("click", function WgSelectorComponent_Template_input_click_6_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.showOptionsDropdown());
          })("mousedown", function WgSelectorComponent_Template_input_mousedown_6_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView($event.stopPropagation());
          })("blur", function WgSelectorComponent_Template_input_blur_6_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.closeOptionsDropdown());
          })("keydown.backspace", function WgSelectorComponent_Template_input_keydown_backspace_6_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.removeLastItem());
          })("keydown.enter", function WgSelectorComponent_Template_input_keydown_enter_6_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.setOption($event));
          })("keydown.esc", function WgSelectorComponent_Template_input_keydown_esc_6_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.closeOptionsDropdown());
          })("keydown.arrowup", function WgSelectorComponent_Template_input_keydown_arrowup_6_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.moveFocus(-1, $event));
          })("keydown.arrowdown", function WgSelectorComponent_Template_input_keydown_arrowdown_6_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.moveFocus(1, $event));
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(8, "wg-icon", 8);
          i0.ɵɵlistener("click", function WgSelectorComponent_Template_wg_icon_click_8_listener() {
            i0.ɵɵrestoreView(_r1);
            const selector_r5 = i0.ɵɵreference(7);
            return i0.ɵɵresetView(selector_r5.focus());
          });
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(9, WgSelectorComponent_ul_9_Template, 5, 4, "ul", 9);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("disabled", ctx.disabled);
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c3, ctx.className));
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("max-height", ctx.maxHeight ? ctx.maxHeight + "px" : "");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(4, 12, ctx.lists$).selectedItems);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c27, ctx.toggleHeight));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c27, ctx.toggleHeight))("ngModel", ctx.inputValue)("placeholder", !(ctx.selectedListSubject == null ? null : ctx.selectedListSubject.value.length) ? ctx.placeholder : "")("disabled", ctx.disabled);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.isDropdownOpened && !ctx.disabled);
        }
      },
      dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgModel, WgIconComponent, i5.CdkFixedSizeVirtualScroll, i5.CdkVirtualForOf, i5.CdkVirtualScrollViewport, i1$2.AsyncPipe, i1$1.TranslatePipe, HighlightPipe$1],
      styles: ["wg-selector input{box-shadow:none}wg-selector input:focus{box-shadow:none}wg-selector ul{margin:0;list-style:none;padding:0}wg-selector .box-selector{position:relative}wg-selector .box-selector>.form-control{padding:4px 7px}wg-selector .box-options{box-shadow:0 3px 3px #00000029,0 3px 4px #0000002e,0 1px 8px #0003;background-color:#fff;border:0 none;display:none;max-height:200px;overflow-x:hidden;position:absolute;width:100%;z-index:100}wg-selector .btn,wg-selector .btn:hover,wg-selector .btn:hover:not(:active){font-size:13px;font-size:1rem;cursor:default;font-weight:400;height:26px;line-height:26px;margin-bottom:8px;margin-right:7px;max-width:100%;overflow:hidden;padding:0 40px 0 12px;position:relative;text-overflow:ellipsis;white-space:nowrap}wg-selector .btn a.close,wg-selector .btn a.close:hover,wg-selector .btn:hover a.close,wg-selector .btn:hover a.close:hover,wg-selector .btn:hover:not(:active) a.close,wg-selector .btn:hover:not(:active) a.close:hover{cursor:pointer;position:absolute;right:10px;top:calc(50% - 11px)}wg-selector .btn a.close wg-icon,wg-selector .btn a.close:hover wg-icon,wg-selector .btn:hover a.close wg-icon,wg-selector .btn:hover a.close:hover wg-icon,wg-selector .btn:hover:not(:active) a.close wg-icon,wg-selector .btn:hover:not(:active) a.close:hover wg-icon{height:13px;line-height:0;width:13px}wg-selector .btn a.close wg-icon svg,wg-selector .btn a.close:hover wg-icon svg,wg-selector .btn:hover a.close wg-icon svg,wg-selector .btn:hover a.close:hover wg-icon svg,wg-selector .btn:hover:not(:active) a.close wg-icon svg,wg-selector .btn:hover:not(:active) a.close:hover wg-icon svg{height:13px;min-height:13px;min-width:13px;width:13px}wg-selector .btn:nth-last-of-type(1),wg-selector .btn:hover:nth-last-of-type(1),wg-selector .btn:hover:not(:active):nth-last-of-type(1){margin-right:0}wg-selector .btn+.btn,wg-selector .btn:hover+.btn,wg-selector .btn:hover:not(:active)+.btn{margin-left:0}wg-selector .btn:not([disabled]):not(.disabled),wg-selector .btn:hover:not([disabled]):not(.disabled),wg-selector .btn:hover:not(:active):not([disabled]):not(.disabled),wg-selector .btn:focus:not([disabled]):not(.disabled),wg-selector .btn:focus:not(:active):not([disabled]):not(.disabled){box-shadow:none;background-color:#fafafa;border-color:#b5b5b5;color:#606060}wg-selector .btn:not([disabled]):not(.disabled) a.close,wg-selector .btn:not([disabled]):not(.disabled) a.close:hover,wg-selector .btn:hover:not([disabled]):not(.disabled) a.close,wg-selector .btn:hover:not([disabled]):not(.disabled) a.close:hover,wg-selector .btn:hover:not(:active):not([disabled]):not(.disabled) a.close,wg-selector .btn:hover:not(:active):not([disabled]):not(.disabled) a.close:hover,wg-selector .btn:focus:not([disabled]):not(.disabled) a.close,wg-selector .btn:focus:not([disabled]):not(.disabled) a.close:hover,wg-selector .btn:focus:not(:active):not([disabled]):not(.disabled) a.close,wg-selector .btn:focus:not(:active):not([disabled]):not(.disabled) a.close:hover{color:#b5b5b5;opacity:1}wg-selector .btn:not([disabled]):not(.disabled) a.close wg-icon svg,wg-selector .btn:not([disabled]):not(.disabled) a.close wg-icon svg path,wg-selector .btn:not([disabled]):not(.disabled) a.close wg-icon svg circle,wg-selector .btn:not([disabled]):not(.disabled) a.close:hover wg-icon svg,wg-selector .btn:not([disabled]):not(.disabled) a.close:hover wg-icon svg path,wg-selector .btn:not([disabled]):not(.disabled) a.close:hover wg-icon svg circle,wg-selector .btn:hover:not([disabled]):not(.disabled) a.close wg-icon svg,wg-selector .btn:hover:not([disabled]):not(.disabled) a.close wg-icon svg path,wg-selector .btn:hover:not([disabled]):not(.disabled) a.close wg-icon svg circle,wg-selector .btn:hover:not([disabled]):not(.disabled) a.close:hover wg-icon svg,wg-selector .btn:hover:not([disabled]):not(.disabled) a.close:hover wg-icon svg path,wg-selector .btn:hover:not([disabled]):not(.disabled) a.close:hover wg-icon svg circle,wg-selector .btn:hover:not(:active):not([disabled]):not(.disabled) a.close wg-icon svg,wg-selector .btn:hover:not(:active):not([disabled]):not(.disabled) a.close wg-icon svg path,wg-selector .btn:hover:not(:active):not([disabled]):not(.disabled) a.close wg-icon svg circle,wg-selector .btn:hover:not(:active):not([disabled]):not(.disabled) a.close:hover wg-icon svg,wg-selector .btn:hover:not(:active):not([disabled]):not(.disabled) a.close:hover wg-icon svg path,wg-selector .btn:hover:not(:active):not([disabled]):not(.disabled) a.close:hover wg-icon svg circle,wg-selector .btn:focus:not([disabled]):not(.disabled) a.close wg-icon svg,wg-selector .btn:focus:not([disabled]):not(.disabled) a.close wg-icon svg path,wg-selector .btn:focus:not([disabled]):not(.disabled) a.close wg-icon svg circle,wg-selector .btn:focus:not([disabled]):not(.disabled) a.close:hover wg-icon svg,wg-selector .btn:focus:not([disabled]):not(.disabled) a.close:hover wg-icon svg path,wg-selector .btn:focus:not([disabled]):not(.disabled) a.close:hover wg-icon svg circle,wg-selector .btn:focus:not(:active):not([disabled]):not(.disabled) a.close wg-icon svg,wg-selector .btn:focus:not(:active):not([disabled]):not(.disabled) a.close wg-icon svg path,wg-selector .btn:focus:not(:active):not([disabled]):not(.disabled) a.close wg-icon svg circle,wg-selector .btn:focus:not(:active):not([disabled]):not(.disabled) a.close:hover wg-icon svg,wg-selector .btn:focus:not(:active):not([disabled]):not(.disabled) a.close:hover wg-icon svg path,wg-selector .btn:focus:not(:active):not([disabled]):not(.disabled) a.close:hover wg-icon svg circle{fill:#b5b5b5;stroke:transparent}wg-selector .mult-selector-input{cursor:default;outline:0}wg-selector .selector-input:focus{cursor:text}wg-selector .box-options:hover{display:block}wg-selector div.selector-input{padding:5px}wg-selector .selector-input:focus+.box-options{display:block}wg-selector ul li{color:#262626;padding:5px 10px}wg-selector ul li:hover{color:#262626;cursor:default;background-color:#ebebeb}wg-selector .li-option:active+.box-options{padding:50px}wg-selector .mult-selector-input,wg-selector .mult-selector-input.form-control{height:auto}wg-selector input.selector-input{border:0 none;cursor:pointer;height:24px;padding:0;width:100%}wg-selector .mult-selector-input .box-options{left:0;margin-top:6px}wg-selector .selector-input::-ms-clear{display:none}wg-selector .mult-selector-input{min-width:202px;position:relative}wg-selector .not-clickable{color:#606060!important;cursor:default!important}wg-selector .not-clickable:hov .close{margin-left:5px;padding:0}wg-selector li[role=option]{min-height:40px;padding:10px}wg-selector .box-option{color:#262626}wg-selector .box-option:hover{background-color:transparent}wg-selector .box-option.focused{background-color:#edf9fc}wg-selector .viewport{width:100%}wg-selector .box-options{display:block}wg-selector .selected-options{position:relative;overflow-y:auto;overflow-x:hidden}wg-selector .selected-options .btn{text-transform:none}wg-selector .table-status-label{line-height:1.5}wg-selector .input-with-icon{padding-right:25px;cursor:pointer}wg-selector .input-with-icon wg-icon{bottom:10px;position:absolute;right:5px}wg-selector .input-with-icon wg-icon svg,wg-selector .input-with-icon wg-icon svg path,wg-selector .input-with-icon wg-icon svg circle{fill:#367b88;stroke:transparent}wg-selector .disabled{pointer-events:none}wg-selector .disabled .selector-input{background-color:#fff;cursor:not-allowed!important}wg-selector .disabled .close{cursor:not-allowed!important}wg-selector .disabled .input-with-icon{cursor:not-allowed}wg-selector .toggled-height{height:24px;padding-right:25px;cursor:pointer}wg-selector .toggled-height .selector-input{padding:5px;height:24px}wg-selector .toggled-height .selector-input-icon{border:0 none;cursor:pointer;height:24px!important;padding:0;width:100%}wg-selector .toggled-height wg-icon{bottom:5px;position:absolute;right:5px}wg-selector .toggled-height wg-icon svg,wg-selector .toggled-height wg-icon svg path,wg-selector .toggled-height wg-icon svg circle{fill:#367b88;stroke:transparent}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgSelectorComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      selector: 'wg-selector',
      standalone: false,
      template: "<div class=\"mult-selector-input\"\n  (click)=\"focusInputSelector($event)\"\n  (mousedown)=\"preventDefault($event)\"\n  [class.disabled]=\"disabled\"\n  [ngClass]=\"[className]\">\n\n  <div class=\"selected-options\" #selectedOptionsContainer [style.maxHeight]=\"maxHeight ? maxHeight + 'px' : ''\" (click)=\"focusInputSelector($event)\">\n    <span class=\"btn\" *ngFor=\"let selectedOption of (lists$ | async).selectedItems\" role=\"button\">\n      <a [class.not-clickable]=\"selectedOptionClick.observers.length === 0\"\n        (click)=\"emitClickedOptionEvent(selectedOption)\" >\n        {{ selectedOption[label] | translate}}\n        <span class=\"table-status-label\" *ngIf=\"tag && selectedOption[tag]\">\n          {{ selectedOption[tag] }}\n        </span>\n      </a>\n      <a class=\"close\" (click)=\"remove(selectedOption)\">\n        <wg-icon name=\"close\"></wg-icon>\n      </a>\n    </span>\n  </div>\n  <div class=\"input-with-icon\"\n       [ngClass]=\"{'toggled-height': toggleHeight}\">\n    <input #selector type=\"text\" class=\"selector-input\"\n      [ngClass]=\"{'toggled-height': toggleHeight}\"\n      [ngModel]=\"inputValue\"\n      [placeholder]=\"!selectedListSubject?.value.length ? placeholder : ''\"\n      [disabled]=\"disabled\"\n      (ngModelChange)=\"searchChanged($event)\"\n      (focus)=\"showOptionsDropdown()\"\n      (click)=\"showOptionsDropdown()\"\n      (mousedown)=\"$event.stopPropagation()\"\n      (blur)=\"closeOptionsDropdown()\"\n      (keydown.backspace)=\"removeLastItem()\"\n      (keydown.enter)=\"setOption($event)\"\n      (keydown.esc)=\"closeOptionsDropdown()\"\n      (keydown.arrowup)=\"moveFocus(-1, $event)\"\n      (keydown.arrowdown)=\"moveFocus(1, $event)\">\n    <wg-icon name=\"expanded\" (click)=\"selector.focus()\"></wg-icon>\n  </div>\n\n  <ul class=\"box-options\" role=\"listbox\" *ngIf=\"isDropdownOpened && !disabled\">\n    <ng-container *ngIf=\"(lists$ | async).availableItems?.length as availableLength; else noneFoundTemplate\">\n      <cdk-virtual-scroll-viewport [itemSize]=\"itemHeightPx\" class=\"viewport\" [style.height]=\"getHeight(availableLength)\">\n        <li class=\"box-option\" role=\"option\"\n          *cdkVirtualFor=\"let selectorOption of (lists$ | async).availableItems\"\n          [class]=\"selectorOption.item.cssClass\"\n          [class.focused]=\"selectorOption.focused\"\n          (click)=\"setOption()\"\n          (mousedown)=\"preventDefault($event)\"\n          (mouseenter)=\"mouseOver(selectorOption)\"\n          (mouseleave)=\"clearFocus()\">\n          <span [innerHTML]=\"selectorOption.item[label] | translate | highlight:inputValue\"></span>\n          <span class=\"table-status-label\" *ngIf=\"tag && selectorOption.item[tag]\">\n            {{ selectorOption.item[tag] | translate}}\n          </span>\n        </li>\n      </cdk-virtual-scroll-viewport>\n    </ng-container>\n\n    <ng-template #noneFoundTemplate>\n      <li class=\"disabled\" *ngIf=\"noneFound\">\n        {{ noneFound }}\n      </li>\n    </ng-template>\n  </ul>\n</div>\n",
      styles: ["wg-selector input{box-shadow:none}wg-selector input:focus{box-shadow:none}wg-selector ul{margin:0;list-style:none;padding:0}wg-selector .box-selector{position:relative}wg-selector .box-selector>.form-control{padding:4px 7px}wg-selector .box-options{box-shadow:0 3px 3px #00000029,0 3px 4px #0000002e,0 1px 8px #0003;background-color:#fff;border:0 none;display:none;max-height:200px;overflow-x:hidden;position:absolute;width:100%;z-index:100}wg-selector .btn,wg-selector .btn:hover,wg-selector .btn:hover:not(:active){font-size:13px;font-size:1rem;cursor:default;font-weight:400;height:26px;line-height:26px;margin-bottom:8px;margin-right:7px;max-width:100%;overflow:hidden;padding:0 40px 0 12px;position:relative;text-overflow:ellipsis;white-space:nowrap}wg-selector .btn a.close,wg-selector .btn a.close:hover,wg-selector .btn:hover a.close,wg-selector .btn:hover a.close:hover,wg-selector .btn:hover:not(:active) a.close,wg-selector .btn:hover:not(:active) a.close:hover{cursor:pointer;position:absolute;right:10px;top:calc(50% - 11px)}wg-selector .btn a.close wg-icon,wg-selector .btn a.close:hover wg-icon,wg-selector .btn:hover a.close wg-icon,wg-selector .btn:hover a.close:hover wg-icon,wg-selector .btn:hover:not(:active) a.close wg-icon,wg-selector .btn:hover:not(:active) a.close:hover wg-icon{height:13px;line-height:0;width:13px}wg-selector .btn a.close wg-icon svg,wg-selector .btn a.close:hover wg-icon svg,wg-selector .btn:hover a.close wg-icon svg,wg-selector .btn:hover a.close:hover wg-icon svg,wg-selector .btn:hover:not(:active) a.close wg-icon svg,wg-selector .btn:hover:not(:active) a.close:hover wg-icon svg{height:13px;min-height:13px;min-width:13px;width:13px}wg-selector .btn:nth-last-of-type(1),wg-selector .btn:hover:nth-last-of-type(1),wg-selector .btn:hover:not(:active):nth-last-of-type(1){margin-right:0}wg-selector .btn+.btn,wg-selector .btn:hover+.btn,wg-selector .btn:hover:not(:active)+.btn{margin-left:0}wg-selector .btn:not([disabled]):not(.disabled),wg-selector .btn:hover:not([disabled]):not(.disabled),wg-selector .btn:hover:not(:active):not([disabled]):not(.disabled),wg-selector .btn:focus:not([disabled]):not(.disabled),wg-selector .btn:focus:not(:active):not([disabled]):not(.disabled){box-shadow:none;background-color:#fafafa;border-color:#b5b5b5;color:#606060}wg-selector .btn:not([disabled]):not(.disabled) a.close,wg-selector .btn:not([disabled]):not(.disabled) a.close:hover,wg-selector .btn:hover:not([disabled]):not(.disabled) a.close,wg-selector .btn:hover:not([disabled]):not(.disabled) a.close:hover,wg-selector .btn:hover:not(:active):not([disabled]):not(.disabled) a.close,wg-selector .btn:hover:not(:active):not([disabled]):not(.disabled) a.close:hover,wg-selector .btn:focus:not([disabled]):not(.disabled) a.close,wg-selector .btn:focus:not([disabled]):not(.disabled) a.close:hover,wg-selector .btn:focus:not(:active):not([disabled]):not(.disabled) a.close,wg-selector .btn:focus:not(:active):not([disabled]):not(.disabled) a.close:hover{color:#b5b5b5;opacity:1}wg-selector .btn:not([disabled]):not(.disabled) a.close wg-icon svg,wg-selector .btn:not([disabled]):not(.disabled) a.close wg-icon svg path,wg-selector .btn:not([disabled]):not(.disabled) a.close wg-icon svg circle,wg-selector .btn:not([disabled]):not(.disabled) a.close:hover wg-icon svg,wg-selector .btn:not([disabled]):not(.disabled) a.close:hover wg-icon svg path,wg-selector .btn:not([disabled]):not(.disabled) a.close:hover wg-icon svg circle,wg-selector .btn:hover:not([disabled]):not(.disabled) a.close wg-icon svg,wg-selector .btn:hover:not([disabled]):not(.disabled) a.close wg-icon svg path,wg-selector .btn:hover:not([disabled]):not(.disabled) a.close wg-icon svg circle,wg-selector .btn:hover:not([disabled]):not(.disabled) a.close:hover wg-icon svg,wg-selector .btn:hover:not([disabled]):not(.disabled) a.close:hover wg-icon svg path,wg-selector .btn:hover:not([disabled]):not(.disabled) a.close:hover wg-icon svg circle,wg-selector .btn:hover:not(:active):not([disabled]):not(.disabled) a.close wg-icon svg,wg-selector .btn:hover:not(:active):not([disabled]):not(.disabled) a.close wg-icon svg path,wg-selector .btn:hover:not(:active):not([disabled]):not(.disabled) a.close wg-icon svg circle,wg-selector .btn:hover:not(:active):not([disabled]):not(.disabled) a.close:hover wg-icon svg,wg-selector .btn:hover:not(:active):not([disabled]):not(.disabled) a.close:hover wg-icon svg path,wg-selector .btn:hover:not(:active):not([disabled]):not(.disabled) a.close:hover wg-icon svg circle,wg-selector .btn:focus:not([disabled]):not(.disabled) a.close wg-icon svg,wg-selector .btn:focus:not([disabled]):not(.disabled) a.close wg-icon svg path,wg-selector .btn:focus:not([disabled]):not(.disabled) a.close wg-icon svg circle,wg-selector .btn:focus:not([disabled]):not(.disabled) a.close:hover wg-icon svg,wg-selector .btn:focus:not([disabled]):not(.disabled) a.close:hover wg-icon svg path,wg-selector .btn:focus:not([disabled]):not(.disabled) a.close:hover wg-icon svg circle,wg-selector .btn:focus:not(:active):not([disabled]):not(.disabled) a.close wg-icon svg,wg-selector .btn:focus:not(:active):not([disabled]):not(.disabled) a.close wg-icon svg path,wg-selector .btn:focus:not(:active):not([disabled]):not(.disabled) a.close wg-icon svg circle,wg-selector .btn:focus:not(:active):not([disabled]):not(.disabled) a.close:hover wg-icon svg,wg-selector .btn:focus:not(:active):not([disabled]):not(.disabled) a.close:hover wg-icon svg path,wg-selector .btn:focus:not(:active):not([disabled]):not(.disabled) a.close:hover wg-icon svg circle{fill:#b5b5b5;stroke:transparent}wg-selector .mult-selector-input{cursor:default;outline:0}wg-selector .selector-input:focus{cursor:text}wg-selector .box-options:hover{display:block}wg-selector div.selector-input{padding:5px}wg-selector .selector-input:focus+.box-options{display:block}wg-selector ul li{color:#262626;padding:5px 10px}wg-selector ul li:hover{color:#262626;cursor:default;background-color:#ebebeb}wg-selector .li-option:active+.box-options{padding:50px}wg-selector .mult-selector-input,wg-selector .mult-selector-input.form-control{height:auto}wg-selector input.selector-input{border:0 none;cursor:pointer;height:24px;padding:0;width:100%}wg-selector .mult-selector-input .box-options{left:0;margin-top:6px}wg-selector .selector-input::-ms-clear{display:none}wg-selector .mult-selector-input{min-width:202px;position:relative}wg-selector .not-clickable{color:#606060!important;cursor:default!important}wg-selector .not-clickable:hov .close{margin-left:5px;padding:0}wg-selector li[role=option]{min-height:40px;padding:10px}wg-selector .box-option{color:#262626}wg-selector .box-option:hover{background-color:transparent}wg-selector .box-option.focused{background-color:#edf9fc}wg-selector .viewport{width:100%}wg-selector .box-options{display:block}wg-selector .selected-options{position:relative;overflow-y:auto;overflow-x:hidden}wg-selector .selected-options .btn{text-transform:none}wg-selector .table-status-label{line-height:1.5}wg-selector .input-with-icon{padding-right:25px;cursor:pointer}wg-selector .input-with-icon wg-icon{bottom:10px;position:absolute;right:5px}wg-selector .input-with-icon wg-icon svg,wg-selector .input-with-icon wg-icon svg path,wg-selector .input-with-icon wg-icon svg circle{fill:#367b88;stroke:transparent}wg-selector .disabled{pointer-events:none}wg-selector .disabled .selector-input{background-color:#fff;cursor:not-allowed!important}wg-selector .disabled .close{cursor:not-allowed!important}wg-selector .disabled .input-with-icon{cursor:not-allowed}wg-selector .toggled-height{height:24px;padding-right:25px;cursor:pointer}wg-selector .toggled-height .selector-input{padding:5px;height:24px}wg-selector .toggled-height .selector-input-icon{border:0 none;cursor:pointer;height:24px!important;padding:0;width:100%}wg-selector .toggled-height wg-icon{bottom:5px;position:absolute;right:5px}wg-selector .toggled-height wg-icon svg,wg-selector .toggled-height wg-icon svg path,wg-selector .toggled-height wg-icon svg circle{fill:#367b88;stroke:transparent}\n"]
    }]
  }], () => [{
    type: i1$1.TranslateService
  }], {
    selectedChange: [{
      type: Output
    }],
    selectedOptionClick: [{
      type: Output
    }],
    allowCustom: [{
      type: Input
    }],
    maxHeight: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    noneFound: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    tag: [{
      type: Input
    }],
    keyField: [{
      type: Input
    }],
    className: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    toggleHeight: [{
      type: Input
    }],
    selected: [{
      type: Input
    }],
    options: [{
      type: Input
    }],
    inputSelector: [{
      type: ViewChild,
      args: ['selector', {
        static: true
      }]
    }],
    viewport: [{
      type: ViewChild,
      args: [CdkVirtualScrollViewport]
    }],
    selectedOptionsContainer: [{
      type: ViewChild,
      args: ['selectedOptionsContainer']
    }]
  });
})();
class WGSelectorModule {
  static {
    this.ɵfac = function WGSelectorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WGSelectorModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WGSelectorModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FormsModule, WgIconModule, ScrollingModule, TranslateModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WGSelectorModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FormsModule, WgIconModule, ScrollingModule, TranslateModule],
      declarations: [WgSelectorComponent, HighlightPipe$1],
      exports: [WgSelectorComponent]
    }]
  }], null, null);
})();
class WgPanelHeaderLeftComponent {
  static {
    this.ɵfac = function WgPanelHeaderLeftComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgPanelHeaderLeftComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgPanelHeaderLeftComponent,
      selectors: [["wg-panel-header-left"]],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function WgPanelHeaderLeftComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgPanelHeaderLeftComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      selector: 'wg-panel-header-left',
      standalone: true,
      imports: [],
      template: "<ng-content></ng-content>",
      styles: [":host{display:block}\n"]
    }]
  }], null, null);
})();
class WgPanelHeaderRightComponent {
  static {
    this.ɵfac = function WgPanelHeaderRightComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgPanelHeaderRightComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgPanelHeaderRightComponent,
      selectors: [["wg-panel-header-right"]],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function WgPanelHeaderRightComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]     wg-h-list{justify-content:right}[_nghost-%COMP%]     wg-h-list span.label{text-align:right}@container wg-panel (width < 600px){[_nghost-%COMP%]     wg-h-list{justify-content:left}[_nghost-%COMP%]     wg-h-list span.label{text-align:left}}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgPanelHeaderRightComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      selector: 'wg-panel-header-right',
      standalone: true,
      imports: [],
      template: "<ng-content></ng-content>\n",
      styles: [":host ::ng-deep wg-h-list{justify-content:right}:host ::ng-deep wg-h-list span.label{text-align:right}@container wg-panel (width < 600px){:host ::ng-deep wg-h-list{justify-content:left}:host ::ng-deep wg-h-list span.label{text-align:left}}\n"]
    }]
  }], null, null);
})();
class WgPanelItemComponent {
  static {
    this.ɵfac = function WgPanelItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgPanelItemComponent)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: WgPanelItemComponent
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgPanelItemComponent, [{
    type: Directive
  }], null, null);
})();
class WgPanelHeaderComponent extends WgPanelItemComponent {
  constructor() {
    super(...arguments);
    this.leadingIconColor = input();
    this.leadingIcon = input();
    this.leadingIconSize = input(WgIconSizes.MD);
    this.noPadding = input(false);
    this.titleLabel = input();
    this.toggle = input(false);
    this.toggleValue = model(false);
    this.headerLeft = contentChild(WgPanelHeaderLeftComponent);
    this.headerRight = contentChild(WgPanelHeaderRightComponent);
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵWgPanelHeaderComponent_BaseFactory;
      return function WgPanelHeaderComponent_Factory(__ngFactoryType__) {
        return (ɵWgPanelHeaderComponent_BaseFactory || (ɵWgPanelHeaderComponent_BaseFactory = i0.ɵɵgetInheritedFactory(WgPanelHeaderComponent)))(__ngFactoryType__ || WgPanelHeaderComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgPanelHeaderComponent,
      selectors: [["wg-panel-header"]],
      contentQueries: function WgPanelHeaderComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.headerLeft, WgPanelHeaderLeftComponent, 5);
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.headerRight, WgPanelHeaderRightComponent, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance(2);
        }
      },
      hostVars: 2,
      hostBindings: function WgPanelHeaderComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("no-padding", ctx.noPadding());
        }
      },
      inputs: {
        leadingIconColor: [1, "leadingIconColor"],
        leadingIcon: [1, "leadingIcon"],
        leadingIconSize: [1, "leadingIconSize"],
        noPadding: [1, "noPadding"],
        titleLabel: [1, "titleLabel"],
        toggle: [1, "toggle"],
        toggleValue: [1, "toggleValue"]
      },
      outputs: {
        toggleValue: "toggleValueChange"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: WgPanelItemComponent,
        useExisting: forwardRef(() => WgPanelHeaderComponent)
      }]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c29,
      decls: 3,
      vars: 2,
      consts: [[1, "left"], [1, "right"], [3, "toggle"], [3, "name", "size", "--icon-fill"], [3, "toggleChange", "toggle"], [3, "name", "size"]],
      template: function WgPanelHeaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c28);
          i0.ɵɵelementStart(0, "div");
          i0.ɵɵtemplate(1, WgPanelHeaderComponent_Conditional_1_Template, 3, 1, "div", 0)(2, WgPanelHeaderComponent_Conditional_2_Template, 2, 0, "div", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.titleLabel() || ctx.headerLeft() ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.headerRight() ? 2 : -1);
        }
      },
      dependencies: [TranslateModule, i1$1.TranslatePipe, WgIconModule, WgIconComponent, WgToggleModule, WgToggleComponent],
      styles: ["[_nghost-%COMP%]{display:block}[_nghost-%COMP%] > div[_ngcontent-%COMP%]{align-items:flex-start;display:flex}[_nghost-%COMP%] > div[_ngcontent-%COMP%] > .left[_ngcontent-%COMP%]{align-items:center;display:flex;flex:1 1 auto;overflow:hidden}[_nghost-%COMP%] > div[_ngcontent-%COMP%] > .left[_ngcontent-%COMP%]     wg-toggle{display:block;height:22px}[_nghost-%COMP%] > div[_ngcontent-%COMP%] > .left[_ngcontent-%COMP%]     wg-toggle label{margin-bottom:0}[_nghost-%COMP%] > div[_ngcontent-%COMP%] > .left[_ngcontent-%COMP%]   wg-toggle[_ngcontent-%COMP%] + wg-icon[_ngcontent-%COMP%], [_nghost-%COMP%] > div[_ngcontent-%COMP%] > .left[_ngcontent-%COMP%]   wg-toggle[_ngcontent-%COMP%] + span[_ngcontent-%COMP%], [_nghost-%COMP%] > div[_ngcontent-%COMP%] > .left[_ngcontent-%COMP%]   wg-icon[_ngcontent-%COMP%] + span[_ngcontent-%COMP%]{margin-left:var(--spacing-sm)}[_nghost-%COMP%] > div[_ngcontent-%COMP%] > .right[_ngcontent-%COMP%]{align-items:center;display:flex;flex:0 1 auto;overflow:hidden}[_nghost-%COMP%] > div[_ngcontent-%COMP%] > .left[_ngcontent-%COMP%]:has(+.right){margin-right:var(--spacing-md)}@container wg-panel (width < 600px){[_nghost-%COMP%] > div[_ngcontent-%COMP%]{flex-wrap:wrap}[_nghost-%COMP%]     wg-panel-header-right{align-items:flex-start;margin-top:var(--spacing-md)}}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgPanelHeaderComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      selector: 'wg-panel-header',
      standalone: true,
      imports: [TranslateModule, WgIconModule, WgToggleModule],
      providers: [{
        provide: WgPanelItemComponent,
        useExisting: forwardRef(() => WgPanelHeaderComponent)
      }],
      host: {
        '[class.no-padding]': 'noPadding()'
      },
      template: "<div>\n  @if (titleLabel() || headerLeft()) {\n    <div class=\"left\">\n      @if (titleLabel()) {\n        <!-- simple icon and title header -->\n        @if (toggle()) {\n          <wg-toggle [(toggle)]=\"toggleValue\"></wg-toggle>\n        }\n\n        @if (leadingIcon()) {\n          <wg-icon [name]=\"leadingIcon()\" [size]=\"leadingIconSize()\" [style.--icon-fill]=\"leadingIconColor()\"></wg-icon>\n        }\n\n        <span>{{ titleLabel() | translate }}</span>\n      } @else {\n        <ng-content select=\"wg-panel-header-left\"></ng-content>\n      }\n    </div>\n  }\n\n  @if (headerRight()) {\n    <div class=\"right\">\n      <ng-content select=\"wg-panel-header-right\"></ng-content>\n    </div>\n  }\n</div>\n",
      styles: [":host{display:block}:host>div{align-items:flex-start;display:flex}:host>div>.left{align-items:center;display:flex;flex:1 1 auto;overflow:hidden}:host>div>.left ::ng-deep wg-toggle{display:block;height:22px}:host>div>.left ::ng-deep wg-toggle label{margin-bottom:0}:host>div>.left wg-toggle+wg-icon,:host>div>.left wg-toggle+span,:host>div>.left wg-icon+span{margin-left:var(--spacing-sm)}:host>div>.right{align-items:center;display:flex;flex:0 1 auto;overflow:hidden}:host>div>.left:has(+.right){margin-right:var(--spacing-md)}@container wg-panel (width < 600px){:host>div{flex-wrap:wrap}:host ::ng-deep wg-panel-header-right{align-items:flex-start;margin-top:var(--spacing-md)}}\n"]
    }]
  }], null, null);
})();
class WgPanelContentComponent extends WgPanelItemComponent {
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵWgPanelContentComponent_BaseFactory;
      return function WgPanelContentComponent_Factory(__ngFactoryType__) {
        return (ɵWgPanelContentComponent_BaseFactory || (ɵWgPanelContentComponent_BaseFactory = i0.ɵɵgetInheritedFactory(WgPanelContentComponent)))(__ngFactoryType__ || WgPanelContentComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgPanelContentComponent,
      selectors: [["wg-panel-content"]],
      features: [i0.ɵɵProvidersFeature([{
        provide: WgPanelItemComponent,
        useExisting: forwardRef(() => WgPanelContentComponent)
      }]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function WgPanelContentComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgPanelContentComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      selector: 'wg-panel-content',
      standalone: true,
      imports: [],
      providers: [{
        provide: WgPanelItemComponent,
        useExisting: forwardRef(() => WgPanelContentComponent)
      }],
      template: "<ng-content></ng-content>\n",
      styles: [":host{display:block}\n"]
    }]
  }], null, null);
})();
const ICON_COLLAPSED = 'chevron-down-line';
const ICON_NOT_COLLAPSED = 'chevron-up-line';
class WgPanelComponent {
  constructor() {
    this.collapsible = model(false);
    this.collapsed = model(false);
    this.content = contentChild(WgPanelContentComponent);
    this.header = contentChild(WgPanelHeaderComponent);
    this.collapsibleIcon = 'chevron-up-line';
    this.deprecated = true;
    /**
     * deprecated
     */
    /* @deprecated */
    this.headerIcon = input();
    /* @deprecated */
    this.headerTitle = input();
    /* @deprecated */
    this.headerTemplate = input();
    /* @deprecated */
    this.bodyTemplate = input();
    /* @deprecated */
    this.contentChildHeaderTemplate = contentChild('header');
    /* @deprecated */
    this.contentChildBodyTemplate = contentChild('body');
    effect(() => {
      this.collapsibleIcon = this.collapsed() ? ICON_COLLAPSED : ICON_NOT_COLLAPSED;
    });
  }
  ngOnInit() {
    if (this.content() || this.header()) {
      this.deprecated = false;
    }
  }
  toggleCollapsed() {
    if (!this.collapsible()) {
      return;
    }
    this.collapsed.set(!this.collapsed());
  }
  static {
    this.ɵfac = function WgPanelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgPanelComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgPanelComponent,
      selectors: [["wg-panel"]],
      contentQueries: function WgPanelComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.content, WgPanelContentComponent, 5);
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.header, WgPanelHeaderComponent, 5);
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.contentChildHeaderTemplate, _c4, 5);
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.contentChildBodyTemplate, _c5, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance(4);
        }
      },
      hostVars: 6,
      hostBindings: function WgPanelComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("v2", !ctx.deprecated)("collapsible", ctx.collapsible())("collapsed", ctx.collapsed());
        }
      },
      inputs: {
        collapsible: [1, "collapsible"],
        collapsed: [1, "collapsed"],
        headerIcon: [1, "headerIcon"],
        headerTitle: [1, "headerTitle"],
        headerTemplate: [1, "headerTemplate"],
        bodyTemplate: [1, "bodyTemplate"]
      },
      outputs: {
        collapsible: "collapsibleChange",
        collapsed: "collapsedChange"
      },
      standalone: false,
      ngContentSelectors: _c31,
      decls: 2,
      vars: 1,
      consts: [["wgContainerQuery", "", 1, "wg-panel"], [3, "wgComponentStateLayer"], [3, "click", "wgComponentStateLayer"], [3, "name"], [4, "ngTemplateOutlet"]],
      template: function WgPanelComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c30);
          i0.ɵɵtemplate(0, WgPanelComponent_Conditional_0_Template, 5, 1, "div")(1, WgPanelComponent_Conditional_1_Template, 6, 2, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵconditional(!ctx.deprecated ? 0 : 1);
        }
      },
      dependencies: [i1$2.NgTemplateOutlet, ComponentStateLayerDirective, WgContainerQueryDirective, WgIconComponent, i1$1.TranslatePipe],
      styles: ["wg-panel.v2{--panel-animation-speed: var(--common-menu-animation-duration);--panel-border: 1px solid var(--color-control-border);background-color:var(--color-surface-surface-01);border:var(--panel-border);container-name:wg-panel;container-type:inline-size;display:flex;flex-direction:column}wg-panel.v2>div>header{align-items:flex-start;display:flex;padding:var(--spacing-md) var(--spacing-xl)}wg-panel.v2>div>header>div:nth-child(1){flex:1 1 auto;overflow:hidden}wg-panel.v2>div>header>div:nth-child(2){flex:0 0 auto}wg-panel.v2>div>header>div+div{margin-left:var(--spacing-sm)}wg-panel.v2>div>section{display:grid;grid-template-rows:1fr;padding:var(--spacing-xl);transition:grid-template-rows var(--panel-animation-speed) ease-out,padding var(--panel-animation-speed) ease-out}wg-panel.v2>div>section>div{overflow:hidden}wg-panel.v2>div>header+section{border-top:var(--panel-border)}wg-panel.v2.collapsible>div>header{cursor:pointer;-webkit-user-select:none;user-select:none}wg-panel.v2.collapsible.collapsed>div>section{animation-duration:var(--panel-animation-speed);animation-name:section-border-hide;border-top:0;grid-template-rows:0fr;padding-bottom:var(--spacing-none);padding-top:var(--spacing-none)}wg-panel.v2+wg-panel{margin-top:var(--spacing-xl)}@keyframes section-border-hide{0%{border-top:var(--panel-border)}99%{border-top:var(--panel-border)}to{border-top:0px none}}wg-panel:not(.v2){display:block}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgPanelComponent, [{
    type: Component,
    args: [{
      encapsulation: ViewEncapsulation.None,
      selector: 'wg-panel',
      standalone: false,
      host: {
        '[class.v2]': '!deprecated',
        '[class.collapsible]': 'collapsible()',
        '[class.collapsed]': 'collapsed()'
      },
      template: "@if (!deprecated) {\n  <div>\n    @if (header()) {\n      <header (click)=\"toggleCollapsed()\" [wgComponentStateLayer]=\"collapsible()\">\n        <div>\n          <ng-content select=\"wg-panel-header\"></ng-content>\n        </div>\n\n        @if (collapsible()) {\n          <div>\n            <wg-icon [name]=\"collapsibleIcon\"></wg-icon>\n          </div>\n        }\n      </header>\n    }\n\n    <section>\n      <div>\n        <ng-content select=\"wg-panel-content\"></ng-content>\n      </div>\n    </section>\n  </div>\n} @else {\n  <!-- deprecated -->\n  <div class=\"wg-panel\" wgContainerQuery>\n    @if (contentChildHeaderTemplate() || headerTemplate() || headerTitle() || headerIcon()) {\n      <header>\n        @if (contentChildHeaderTemplate()) {\n          <ng-container *ngTemplateOutlet=\"contentChildHeaderTemplate()\"></ng-container>\n        } @else if (headerTemplate()) {\n          <ng-container *ngTemplateOutlet=\"headerTemplate()\"></ng-container>\n        } @else {\n          @if (headerIcon()) {\n            <wg-icon [name]=\"headerIcon()\"></wg-icon>\n          }\n          <h5>{{ headerTitle() | translate }}</h5>\n        }\n      </header>\n    }\n\n    <section>\n      @if (contentChildBodyTemplate()) {\n        <ng-container *ngTemplateOutlet=\"contentChildBodyTemplate()\"></ng-container>\n      } @else if (bodyTemplate()) {\n        <ng-container *ngTemplateOutlet=\"bodyTemplate()\"></ng-container>\n      } @else {\n        <ng-content></ng-content>\n      }\n    </section>\n  </div>\n}\n",
      styles: ["wg-panel.v2{--panel-animation-speed: var(--common-menu-animation-duration);--panel-border: 1px solid var(--color-control-border);background-color:var(--color-surface-surface-01);border:var(--panel-border);container-name:wg-panel;container-type:inline-size;display:flex;flex-direction:column}wg-panel.v2>div>header{align-items:flex-start;display:flex;padding:var(--spacing-md) var(--spacing-xl)}wg-panel.v2>div>header>div:nth-child(1){flex:1 1 auto;overflow:hidden}wg-panel.v2>div>header>div:nth-child(2){flex:0 0 auto}wg-panel.v2>div>header>div+div{margin-left:var(--spacing-sm)}wg-panel.v2>div>section{display:grid;grid-template-rows:1fr;padding:var(--spacing-xl);transition:grid-template-rows var(--panel-animation-speed) ease-out,padding var(--panel-animation-speed) ease-out}wg-panel.v2>div>section>div{overflow:hidden}wg-panel.v2>div>header+section{border-top:var(--panel-border)}wg-panel.v2.collapsible>div>header{cursor:pointer;-webkit-user-select:none;user-select:none}wg-panel.v2.collapsible.collapsed>div>section{animation-duration:var(--panel-animation-speed);animation-name:section-border-hide;border-top:0;grid-template-rows:0fr;padding-bottom:var(--spacing-none);padding-top:var(--spacing-none)}wg-panel.v2+wg-panel{margin-top:var(--spacing-xl)}@keyframes section-border-hide{0%{border-top:var(--panel-border)}99%{border-top:var(--panel-border)}to{border-top:0px none}}wg-panel:not(.v2){display:block}\n"]
    }]
  }], () => [], null);
})();
class WgPanelModule {
  static {
    this.ɵfac = function WgPanelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgPanelModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgPanelModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, TranslateModule, WgContainerQueryModule, WgIconModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgPanelModule, [{
    type: NgModule,
    args: [{
      declarations: [WgPanelComponent],
      imports: [CommonModule, TranslateModule, ComponentStateLayerDirective, WgContainerQueryModule, WgIconModule],
      exports: [WgPanelComponent]
    }]
  }], null, null);
})();
class WgSlideInPanelItemComponent {
  static {
    this.ɵfac = function WgSlideInPanelItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgSlideInPanelItemComponent)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: WgSlideInPanelItemComponent
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgSlideInPanelItemComponent, [{
    type: Directive
  }], null, null);
})();
class WgSlideInPanelComponent {
  constructor() {
    this.items = contentChildren(WgSlideInPanelItemComponent, {
      descendants: true
    });
    this.show = false;
    this.showChange = new EventEmitter();
    this.scrolled = false;
    this.elementRef = inject(ElementRef);
    this.globalEventService = inject(GlobalEventService);
    this.showing = false;
    this.subscriptions$ = new Subscription();
  }
  ngOnChanges(changes) {
    if (changes != null && changes.show != null) {
      this.showing = true;
      this.showChange.emit(this.show);
      setTimeout(() => {
        this.showing = false;
      }, 250); // should match slide-in animation time
    }
  }
  ngOnDestroy() {
    if (this.subscriptions$ != null) {
      this.subscriptions$.unsubscribe();
    }
  }
  ngOnInit() {
    this.subscriptions$.add(this.globalEventService.documentClicked.subscribe(event => {
      if (this.hideOnClickOutside === false) {
        return;
      }
      if (!this.showing && this.show && event.target.closest('wg-slide-in-panel') == null) {
        this.show = false;
        this.showChange.emit(this.show);
      }
    }));
  }
  hide() {
    this.show = false;
    this.showChange.emit(this.show);
  }
  onScroll() {
    this.scrolled = this.elementRef.nativeElement.scrollTop > 0;
  }
  static {
    this.ɵfac = function WgSlideInPanelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgSlideInPanelComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgSlideInPanelComponent,
      selectors: [["wg-slide-in-panel"]],
      contentQueries: function WgSlideInPanelComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.items, WgSlideInPanelItemComponent, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      hostVars: 8,
      hostBindings: function WgSlideInPanelComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("scroll", function WgSlideInPanelComponent_scroll_HostBindingHandler() {
            return ctx.onScroll();
          });
        }
        if (rf & 2) {
          let tmp_0_0;
          i0.ɵɵclassProp("deprecated", !((tmp_0_0 = ctx.items()) == null ? null : tmp_0_0.length))("titled", ctx.title)("show", ctx.show)("scrolled", ctx.scrolled);
        }
      },
      inputs: {
        hideOnClickOutside: "hideOnClickOutside",
        title: "title",
        show: "show",
        template: "template"
      },
      outputs: {
        showChange: "showChange"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c0,
      decls: 4,
      vars: 2,
      consts: [[1, "hide-button", 3, "click"], ["name", "close", 1, "size-18", "color-watchguard-gray"], [4, "ngTemplateOutlet"]],
      template: function WgSlideInPanelComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, WgSlideInPanelComponent_Conditional_0_Template, 6, 3, "header");
          i0.ɵɵelementStart(1, "div");
          i0.ɵɵprojection(2);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(3, WgSlideInPanelComponent_Conditional_3_Template, 2, 1, "ng-container");
        }
        if (rf & 2) {
          let tmp_0_0;
          let tmp_1_0;
          i0.ɵɵconditional(!((tmp_0_0 = ctx.items()) == null ? null : tmp_0_0.length) ? 0 : -1);
          i0.ɵɵadvance(3);
          i0.ɵɵconditional(!((tmp_1_0 = ctx.items()) == null ? null : tmp_1_0.length) && ctx.template ? 3 : -1);
        }
      },
      dependencies: [i1$2.NgTemplateOutlet, WgIconComponent, i1$1.TranslatePipe],
      styles: ["[_nghost-%COMP%]:not(.deprecated){--slide-in-panel-animation-speed: var(--common-menu-animation-duration, .25s);--slide-in-panel-x-padding: var(--spacing-xl);--slide-in-panel-width: 400px;box-shadow:0 0 2px #00000029,-2px 0 2px #00000029,-1px 0 3px #00000029;background-color:var(--color-surface-surface-01);bottom:0;display:block;overflow-x:hidden;overflow-y:auto;padding:var(--spacing-none);position:fixed;right:0;transform:translate(calc(var(--slide-in-panel-width) + 10px));transition:transform var(--slide-in-panel-animation-speed) ease-out;top:var(--header-height, 50px);width:var(--slide-in-panel-width);z-index:var(--zindex-dialog, 11002)}[_nghost-%COMP%]:not(.deprecated).show{transform:translate(0)}[_nghost-%COMP%]:not(.deprecated) > div[_ngcontent-%COMP%]{width:var(--slide-in-panel-width)}[_nghost-%COMP%]:not(.deprecated)     wg-slide-in-panel-content:after, [_nghost-%COMP%]:not(.deprecated)     wg-slide-in-panel-expander:after, [_nghost-%COMP%]:not(.deprecated)     wg-slide-in-panel-title:after{background-color:var(--color-control-divider);content:\"\";display:block;height:1px;width:100%}.deprecated[_nghost-%COMP%]{box-shadow:0 0 2px #00000029,-2px 0 2px #00000029,-1px 0 3px #00000029;background-color:#fff;bottom:0;display:block;overflow:auto;padding:0 30px 30px;position:fixed;right:0;transform:translate(335px);transition:transform .25s ease-in-out;top:50px;width:325px;z-index:11002}.deprecated[_nghost-%COMP%] > header[_ngcontent-%COMP%]{display:flex;margin:0 -30px;padding:15px 15px 15px 30px;position:sticky;top:0;z-index:2}.deprecated[_nghost-%COMP%] > header[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{font-size:15px;font-size:1.1538461538rem;flex-grow:1;flex-shrink:1;font-weight:700;margin-bottom:0;margin-top:0}.deprecated.show[_nghost-%COMP%]{transform:translate(0)}.deprecated.titled[_nghost-%COMP%] > header[_ngcontent-%COMP%]{background-color:#fff}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgSlideInPanelComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      selector: 'wg-slide-in-panel',
      host: {
        '[class.deprecated]': '!items()?.length'
      },
      standalone: false,
      template: "@if (!items()?.length) {\n  <!-- deprecated way -->\n  <header>\n    <h4>{{ title | translate }}</h4>\n\n    <a class=\"hide-button\" (click)=\"hide()\">\n      <wg-icon name=\"close\" class=\"size-18 color-watchguard-gray\"></wg-icon>\n    </a>\n  </header>\n}\n\n<div>\n  <ng-content></ng-content>\n</div>\n\n@if (!items()?.length && template) {\n  <!-- deprecated way -->\n  <ng-container>\n    <ng-container *ngTemplateOutlet=\"template\"></ng-container>\n  </ng-container>\n}\n",
      styles: [":host:not(.deprecated){--slide-in-panel-animation-speed: var(--common-menu-animation-duration, .25s);--slide-in-panel-x-padding: var(--spacing-xl);--slide-in-panel-width: 400px;box-shadow:0 0 2px #00000029,-2px 0 2px #00000029,-1px 0 3px #00000029;background-color:var(--color-surface-surface-01);bottom:0;display:block;overflow-x:hidden;overflow-y:auto;padding:var(--spacing-none);position:fixed;right:0;transform:translate(calc(var(--slide-in-panel-width) + 10px));transition:transform var(--slide-in-panel-animation-speed) ease-out;top:var(--header-height, 50px);width:var(--slide-in-panel-width);z-index:var(--zindex-dialog, 11002)}:host:not(.deprecated).show{transform:translate(0)}:host:not(.deprecated)>div{width:var(--slide-in-panel-width)}:host:not(.deprecated) ::ng-deep wg-slide-in-panel-content:after,:host:not(.deprecated) ::ng-deep wg-slide-in-panel-expander:after,:host:not(.deprecated) ::ng-deep wg-slide-in-panel-title:after{background-color:var(--color-control-divider);content:\"\";display:block;height:1px;width:100%}:host.deprecated{box-shadow:0 0 2px #00000029,-2px 0 2px #00000029,-1px 0 3px #00000029;background-color:#fff;bottom:0;display:block;overflow:auto;padding:0 30px 30px;position:fixed;right:0;transform:translate(335px);transition:transform .25s ease-in-out;top:50px;width:325px;z-index:11002}:host.deprecated>header{display:flex;margin:0 -30px;padding:15px 15px 15px 30px;position:sticky;top:0;z-index:2}:host.deprecated>header h4{font-size:15px;font-size:1.1538461538rem;flex-grow:1;flex-shrink:1;font-weight:700;margin-bottom:0;margin-top:0}:host.deprecated.show{transform:translate(0)}:host.deprecated.titled>header{background-color:#fff}\n"]
    }]
  }], null, {
    hideOnClickOutside: [{
      type: Input
    }],
    title: [{
      type: HostBinding,
      args: ['class.titled']
    }, {
      type: Input
    }],
    show: [{
      type: HostBinding,
      args: ['class.show']
    }, {
      type: Input
    }],
    showChange: [{
      type: Output
    }],
    template: [{
      type: Input
    }],
    scrolled: [{
      type: HostBinding,
      args: ['class.scrolled']
    }],
    onScroll: [{
      type: HostListener,
      args: ['scroll']
    }]
  });
})();
class WgSlideInPanelContentComponent extends WgSlideInPanelItemComponent {
  constructor() {
    super();
    this.labelValues = contentChildren(WgLabelValueComponent, {
      descendants: true
    });
    effect(() => {
      this.labelValues()?.forEach(labelValue => {
        if (!labelValue.wrapBreakpoint()) {
          labelValue.wrapBreakpoint.set('0px');
          labelValue.paddingY.set('var(--spacing-sm)');
        }
      });
    }, {
      allowSignalWrites: true
    });
  }
  static {
    this.ɵfac = function WgSlideInPanelContentComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgSlideInPanelContentComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgSlideInPanelContentComponent,
      selectors: [["wg-slide-in-panel-content"]],
      contentQueries: function WgSlideInPanelContentComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.labelValues, WgLabelValueComponent, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: WgSlideInPanelItemComponent,
        useExisting: forwardRef(() => WgSlideInPanelContentComponent)
      }]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 2,
      vars: 0,
      template: function WgSlideInPanelContentComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div");
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}[_nghost-%COMP%] > div[_ngcontent-%COMP%]{padding:var(--spacing-md) var(--slide-in-panel-x-padding, var(--spacing-xl))}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgSlideInPanelContentComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      selector: 'wg-slide-in-panel-content',
      imports: [],
      providers: [{
        provide: WgSlideInPanelItemComponent,
        useExisting: forwardRef(() => WgSlideInPanelContentComponent)
      }],
      template: "<div>\n  <ng-content></ng-content>\n</div>\n",
      styles: [":host{display:block}:host>div{padding:var(--spacing-md) var(--slide-in-panel-x-padding, var(--spacing-xl))}\n"]
    }]
  }], () => [], null);
})();
class WgSlideInPanelExpanderComponent extends WgSlideInPanelItemComponent {
  constructor() {
    super(...arguments);
    this.titleLabel = input.required();
    this.open = model(false);
  }
  toggleOpen(event) {
    event?.stopImmediatePropagation();
    this.open.set(!this.open());
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵWgSlideInPanelExpanderComponent_BaseFactory;
      return function WgSlideInPanelExpanderComponent_Factory(__ngFactoryType__) {
        return (ɵWgSlideInPanelExpanderComponent_BaseFactory || (ɵWgSlideInPanelExpanderComponent_BaseFactory = i0.ɵɵgetInheritedFactory(WgSlideInPanelExpanderComponent)))(__ngFactoryType__ || WgSlideInPanelExpanderComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgSlideInPanelExpanderComponent,
      selectors: [["wg-slide-in-panel-expander"]],
      hostVars: 2,
      hostBindings: function WgSlideInPanelExpanderComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("open", ctx.open());
        }
      },
      inputs: {
        titleLabel: [1, "titleLabel"],
        open: [1, "open"]
      },
      outputs: {
        open: "openChange"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: WgSlideInPanelItemComponent,
        useExisting: forwardRef(() => WgSlideInPanelExpanderComponent)
      }]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 9,
      vars: 4,
      consts: [["wgComponentStateLayer", "", 3, "click"], [3, "name"]],
      template: function WgSlideInPanelExpanderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div")(1, "header", 0);
          i0.ɵɵlistener("click", function WgSlideInPanelExpanderComponent_Template_header_click_1_listener($event) {
            return ctx.toggleOpen($event);
          });
          i0.ɵɵelementStart(2, "span");
          i0.ɵɵtext(3);
          i0.ɵɵpipe(4, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelement(5, "wg-icon", 1);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "section")(7, "div");
          i0.ɵɵprojection(8);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 2, ctx.titleLabel()));
          i0.ɵɵadvance(2);
          i0.ɵɵpropertyInterpolate("name", ctx.open() ? "chevron-up-line" : "chevron-down-line");
        }
      },
      dependencies: [TranslateModule, i1$1.TranslatePipe, ComponentStateLayerDirective, WgIconModule, WgIconComponent],
      styles: ["[_nghost-%COMP%]{--spacing-y: 10px;display:block}[_nghost-%COMP%] > div[_ngcontent-%COMP%] > header[_ngcontent-%COMP%]{align-items:center;cursor:pointer;display:flex;padding:var(--spacing-y) var(--slide-in-panel-x-padding, var(--spacing-xl));-webkit-user-select:none;user-select:none}[_nghost-%COMP%] > div[_ngcontent-%COMP%] > header[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{flex:1 1 auto;font:var(--font-standard-md);font-weight:var(--font-weight-strong)}[_nghost-%COMP%] > div[_ngcontent-%COMP%] > header[_ngcontent-%COMP%] > wg-icon[_ngcontent-%COMP%]{flex:0 0 auto}[_nghost-%COMP%] > div[_ngcontent-%COMP%] > section[_ngcontent-%COMP%]{display:grid;grid-template-rows:0fr;transition:grid-template-rows var(--slide-in-panel-animation-speed) ease-out,padding var(--slide-in-panel-animation-speed) ease-out}[_nghost-%COMP%] > div[_ngcontent-%COMP%] > section[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{overflow:hidden}.open[_nghost-%COMP%] > div[_ngcontent-%COMP%] > section[_ngcontent-%COMP%]{grid-template-rows:1fr}[_nghost-%COMP%]     :last-child:after{display:none}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgSlideInPanelExpanderComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      selector: 'wg-slide-in-panel-expander',
      imports: [TranslateModule, ComponentStateLayerDirective, WgIconModule],
      providers: [{
        provide: WgSlideInPanelItemComponent,
        useExisting: forwardRef(() => WgSlideInPanelExpanderComponent)
      }],
      host: {
        '[class.open]': 'open()'
      },
      template: "<div>\n  <header (click)=\"toggleOpen($event)\" wgComponentStateLayer>\n    <span>{{ titleLabel() | translate }}</span>\n\n    <wg-icon name=\"{{ open() ? 'chevron-up-line' : 'chevron-down-line' }}\"></wg-icon>\n  </header>\n\n  <section>\n    <div>\n      <ng-content></ng-content>\n    </div>\n  </section>\n</div>\n",
      styles: [":host{--spacing-y: 10px;display:block}:host>div>header{align-items:center;cursor:pointer;display:flex;padding:var(--spacing-y) var(--slide-in-panel-x-padding, var(--spacing-xl));-webkit-user-select:none;user-select:none}:host>div>header>span{flex:1 1 auto;font:var(--font-standard-md);font-weight:var(--font-weight-strong)}:host>div>header>wg-icon{flex:0 0 auto}:host>div>section{display:grid;grid-template-rows:0fr;transition:grid-template-rows var(--slide-in-panel-animation-speed) ease-out,padding var(--slide-in-panel-animation-speed) ease-out}:host>div>section>div{overflow:hidden}:host.open>div>section{grid-template-rows:1fr}:host ::ng-deep :last-child:after{display:none}\n"]
    }]
  }], null, null);
})();
class WgSlideInPanelTitleComponent extends WgSlideInPanelItemComponent {
  constructor() {
    super(...arguments);
    this.titleLabel = input.required();
    this.slideInPanel = inject(WgSlideInPanelComponent);
  }
  exit() {
    this.slideInPanel?.hide();
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵWgSlideInPanelTitleComponent_BaseFactory;
      return function WgSlideInPanelTitleComponent_Factory(__ngFactoryType__) {
        return (ɵWgSlideInPanelTitleComponent_BaseFactory || (ɵWgSlideInPanelTitleComponent_BaseFactory = i0.ɵɵgetInheritedFactory(WgSlideInPanelTitleComponent)))(__ngFactoryType__ || WgSlideInPanelTitleComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgSlideInPanelTitleComponent,
      selectors: [["wg-slide-in-panel-title"]],
      inputs: {
        titleLabel: [1, "titleLabel"]
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: WgSlideInPanelItemComponent,
        useExisting: forwardRef(() => WgSlideInPanelTitleComponent)
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 5,
      vars: 3,
      consts: [["name", "exit-line", 3, "click"]],
      template: function WgSlideInPanelTitleComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div")(1, "span");
          i0.ɵɵtext(2);
          i0.ɵɵpipe(3, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "wg-icon", 0);
          i0.ɵɵlistener("click", function WgSlideInPanelTitleComponent_Template_wg_icon_click_4_listener() {
            return ctx.exit();
          });
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, ctx.titleLabel()));
        }
      },
      dependencies: [TranslateModule, i1$1.TranslatePipe, WgIconModule, WgIconComponent],
      styles: ["[_nghost-%COMP%]{--spacing-y: 12px;background-color:var(--color-surface-surface-01);display:block;position:sticky;top:0}[_nghost-%COMP%] > div[_ngcontent-%COMP%]{align-items:flex-start;display:flex;padding:var(--spacing-y) var(--slide-in-panel-x-padding, var(--spacing-xl))}[_nghost-%COMP%] > div[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{flex:1 1 auto;font:var(--font-standard-lg);font-weight:var(--font-weight-strong);overflow:hidden;overflow-wrap:break-word}[_nghost-%COMP%] > div[_ngcontent-%COMP%] > wg-icon[_ngcontent-%COMP%]{cursor:pointer;flex:0 0 auto;margin-top:1px}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgSlideInPanelTitleComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      selector: 'wg-slide-in-panel-title',
      imports: [TranslateModule, WgIconModule],
      providers: [{
        provide: WgSlideInPanelItemComponent,
        useExisting: forwardRef(() => WgSlideInPanelTitleComponent)
      }],
      template: "<div>\n  <span>{{ titleLabel() | translate }}</span>\n\n  <wg-icon name=\"exit-line\" (click)=\"exit()\"></wg-icon>\n</div>\n",
      styles: [":host{--spacing-y: 12px;background-color:var(--color-surface-surface-01);display:block;position:sticky;top:0}:host>div{align-items:flex-start;display:flex;padding:var(--spacing-y) var(--slide-in-panel-x-padding, var(--spacing-xl))}:host>div>span{flex:1 1 auto;font:var(--font-standard-lg);font-weight:var(--font-weight-strong);overflow:hidden;overflow-wrap:break-word}:host>div>wg-icon{cursor:pointer;flex:0 0 auto;margin-top:1px}\n"]
    }]
  }], null, null);
})();
class WgSlideInPanelModule {
  static {
    this.ɵfac = function WgSlideInPanelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgSlideInPanelModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgSlideInPanelModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, TranslateModule, WgIconModule, WgServicesModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgSlideInPanelModule, [{
    type: NgModule,
    args: [{
      declarations: [WgSlideInPanelComponent],
      imports: [CommonModule, TranslateModule, WgIconModule, WgServicesModule],
      exports: [WgSlideInPanelComponent]
    }]
  }], null, null);
})();
class WgSlideInPanelContainerComponent {
  constructor(elementRef) {
    this.elementRef = elementRef;
    this.subscriptions$ = new Subscription();
  }
  ngAfterViewInit() {
    this.contentHtmlElement = this.elementRef.nativeElement.firstChild;
    this.slideInHtmlElement = this.elementRef.nativeElement.querySelector('wg-slide-in-panel');
    if (this.slideInPanel != null) {
      if (this.slideInPanel.hideOnClickOutside == null) {
        this.slideInPanel.hideOnClickOutside = false;
      }
      this.subscriptions$.add(this.slideInPanel.showChange.subscribe(show => {
        this.showChanged(show);
      }));
    }
  }
  ngOnDestroy() {
    if (this.subscriptions$ != null) {
      this.subscriptions$.unsubscribe();
    }
  }
  showChanged(show) {
    if (this.contentHtmlElement == null || this.slideInHtmlElement == null) {
      return;
    }
    if (show) {
      const slideInWidth = this.slideInHtmlElement.getBoundingClientRect().width;
      this.contentHtmlElement.style.marginRight = `${slideInWidth}px`;
    } else if (this.contentHtmlElement != null) {
      this.contentHtmlElement.style.marginRight = '0px';
    }
  }
  static {
    this.ɵfac = function WgSlideInPanelContainerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgSlideInPanelContainerComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgSlideInPanelContainerComponent,
      selectors: [["wg-slide-in-panel-container"]],
      contentQueries: function WgSlideInPanelContainerComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, WgSlideInPanelComponent, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.slideInPanel = _t.first);
        }
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 2,
      vars: 0,
      consts: [["wgContainerQuery", ""]],
      template: function WgSlideInPanelContainerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "section", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
      },
      dependencies: [WgContainerQueryDirective],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgSlideInPanelContainerComponent, [{
    type: Component,
    args: [{
      selector: 'wg-slide-in-panel-container',
      standalone: false,
      template: "<section wgContainerQuery>\n  <ng-content></ng-content>\n</section>\n"
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    slideInPanel: [{
      type: ContentChild,
      args: [WgSlideInPanelComponent, {
        static: false
      }]
    }]
  });
})();
class WgSlideInPanelContainerModule {
  static {
    this.ɵfac = function WgSlideInPanelContainerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgSlideInPanelContainerModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgSlideInPanelContainerModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, WgContainerQueryModule, WgSlideInPanelModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgSlideInPanelContainerModule, [{
    type: NgModule,
    args: [{
      declarations: [WgSlideInPanelContainerComponent],
      imports: [CommonModule, WgContainerQueryModule, WgSlideInPanelModule],
      exports: [WgSlideInPanelContainerComponent]
    }]
  }], null, null);
})();
class WgWidgetPanelComponent {
  constructor(elementRef) {
    this.elementRef = elementRef;
  }
  ngAfterViewInit() {
    this.htmlElement = this.elementRef.nativeElement;
    this.widgetContainerHTMLElement = this.widgetContainerElement.nativeElement;
    this.contentChanged();
    this.initializeMutationObserver();
  }
  ngOnDestroy() {
    if (this.mutationObserver != null) {
      this.mutationObserver.disconnect();
    }
  }
  contentChanged() {
    this.htmlElement.classList.add('loading');
    setTimeout(() => {
      this.layoutWidgets();
      this.htmlElement.classList.remove('loading');
    });
  }
  clearCssClasses(htmlElement) {
    if (htmlElement == null) {
      return;
    }
    const classesToRemove = [];
    htmlElement.classList.forEach(cssClass => {
      if (cssClass.startsWith('col-')) {
        classesToRemove.push(cssClass);
      }
    });
    classesToRemove.forEach(cssClass => {
      htmlElement.classList.remove(cssClass);
    });
  }
  initializeMutationObserver() {
    this.mutationObserver = new window.MutationObserver(() => {
      this.mutationObserver.disconnect();
      this.contentChanged();
      setTimeout(() => {
        this.mutationObserver.observe(this.widgetContainerHTMLElement, {
          subtree: true,
          childList: true,
          attributes: false
        });
      });
    });
    this.mutationObserver.observe(this.widgetContainerHTMLElement, {
      subtree: true,
      childList: true,
      attributes: false
    });
  }
  layoutWidgets() {
    const widgetsNodeList = this.htmlElement.querySelectorAll('.wg-panel > section > .container-fluid > .row > *');
    if (!widgetsNodeList || widgetsNodeList.length === 0) {
      return;
    }
    const widgets = [];
    for (let index = 0; index < widgetsNodeList.length; index++) {
      widgets.push(widgetsNodeList[index]);
      this.clearCssClasses(widgets[widgets.length - 1]);
    }
    const widgetCount = widgets.length.valueOf();
    const remainder = widgetCount % 4;
    switch (widgetCount) {
      case 1:
        widgets[0].classList.add('col-12');
        break;
      case 2:
        widgets.forEach(widget => widget.classList.add('col-sm-6'));
        break;
      case 3:
        widgets.slice(0, 2).forEach(widget => widget.classList.add('col-sm-6', 'col-md-4'));
        widgets[2].classList.add('col-md-4');
        break;
      case 4:
        widgets.forEach(widget => widget.classList.add('col-sm-6', 'col-lg-3'));
        break;
      default:
        switch (remainder) {
          case 1:
            widgets.slice(0, widgetCount - 5).forEach(widget => widget.classList.add('col-sm-6', 'col-lg-3'));
            widgets.slice(widgetCount - 5, widgetCount - 2).forEach(widget => widget.classList.add('col-sm-6', 'col-md-4'));
            widgets[widgetCount - 2].classList.add('col-sm-6', 'col-md-6');
            widgets[widgetCount - 1].classList.add('col-sm-12', 'col-md-6');
            break;
          case 2:
            widgets.slice(0, widgetCount - 6).forEach(widget => widget.classList.add('col-sm-6', 'col-lg-3'));
            widgets.slice(widgetCount - 6, widgetCount).forEach(widget => widget.classList.add('col-sm-6', 'col-md-4'));
            break;
          case 3:
            widgets.slice(0, widgetCount - 7).forEach(widget => widget.classList.add('col-sm-6', 'col-lg-3'));
            widgets.slice(widgetCount - 7, widgetCount - 3).forEach(widget => widget.classList.add('col-sm-6', 'col-lg-3'));
            widgets[widgetCount - 3].classList.add('col-sm-6', 'col-lg-4');
            widgets[widgetCount - 2].classList.add('col-sm-6', 'col-lg-4');
            widgets[widgetCount - 1].classList.add('col-sm-12', 'col-lg-4');
            break;
          default:
            widgets.slice(0, widgetCount - 8).forEach(widget => widget.classList.add('col-sm-6', 'col-lg-3'));
            widgets.slice(widgetCount - 8, widgetCount).forEach(widget => widget.classList.add('col-sm-6', 'col-lg-3'));
            break;
        }
    }
  }
  static {
    this.ɵfac = function WgWidgetPanelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgWidgetPanelComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgWidgetPanelComponent,
      selectors: [["wg-widget-panel"]],
      contentQueries: function WgWidgetPanelComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, _c4, 5);
          i0.ɵɵcontentQuery(dirIndex, _c5, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerContentTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.body = _t.first);
        }
      },
      viewQuery: function WgWidgetPanelComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c32, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.widgetContainerElement = _t.first);
        }
      },
      inputs: {
        headerIcon: "headerIcon",
        headerTitle: "headerTitle",
        headerTemplate: "headerTemplate",
        bodyTemplate: "bodyTemplate"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 8,
      vars: 8,
      consts: [["widgetContainer", ""], ["header", ""], [3, "headerIcon", "headerTitle", "headerTemplate", "bodyTemplate"], [4, "ngIf"], [1, "container-fluid", "p-0"], [1, "row", "no-gutters"], [4, "ngTemplateOutlet"]],
      template: function WgWidgetPanelComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "wg-panel", 2);
          i0.ɵɵtemplate(1, WgWidgetPanelComponent_ng_container_1_Template, 3, 0, "ng-container", 3);
          i0.ɵɵelementStart(2, "div", 4)(3, "div", 5, 0);
          i0.ɵɵtemplate(5, WgWidgetPanelComponent_ng_container_5_Template, 2, 1, "ng-container", 3)(6, WgWidgetPanelComponent_ng_container_6_Template, 2, 1, "ng-container", 3)(7, WgWidgetPanelComponent_ng_container_7_Template, 2, 0, "ng-container", 3);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("headerIcon", ctx.headerIcon)("headerTitle", ctx.headerTitle)("headerTemplate", ctx.headerTemplate)("bodyTemplate", ctx.bodyTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.headerContentTemplate);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("ngIf", ctx.body);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.bodyTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.body && !ctx.bodyTemplate);
        }
      },
      dependencies: [i1$2.NgIf, i1$2.NgTemplateOutlet, WgPanelComponent],
      styles: ["wg-widget-panel .loading-message{display:none}wg-widget-panel>wg-panel,wg-widget-panel .wg-panel{border:0 none}wg-widget-panel>wg-panel>header,wg-widget-panel .wg-panel>header{border:1px solid #b5b5b5;border-bottom:0 none}wg-widget-panel>wg-panel>section,wg-widget-panel .wg-panel>section{border-bottom:0 none;border-left:1px solid #b5b5b5;border-right:0 none;border-top:1px solid #b5b5b5;padding:0}wg-widget-panel>wg-panel>section>.container-fluid>.row>*,wg-widget-panel .wg-panel>section>.container-fluid>.row>*{border:0 none;border-bottom:1px solid #b5b5b5;border-right:1px solid #b5b5b5;min-height:0}wg-widget-panel>wg-panel>section>.container-fluid>.row [class^=widget-],wg-widget-panel>wg-panel>section>.container-fluid>.row [class*=\" widget-\"],wg-widget-panel .wg-panel>section>.container-fluid>.row [class^=widget-],wg-widget-panel .wg-panel>section>.container-fluid>.row [class*=\" widget-\"]{padding:30px!important}wg-widget-panel.loading .loading-message{display:block}wg-widget-panel.loading>wg-panel>section,wg-widget-panel.loading .wg-panel>section{border-bottom:1px solid #b5b5b5;border-right:1px solid #b5b5b5}wg-widget-panel.loading>wg-panel>section>.container-fluid,wg-widget-panel.loading .wg-panel>section>.container-fluid{left:-99999px;position:fixed;top:-99999px}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgWidgetPanelComponent, [{
    type: Component,
    args: [{
      encapsulation: ViewEncapsulation.None,
      selector: 'wg-widget-panel',
      standalone: false,
      template: "<wg-panel [headerIcon]=\"headerIcon\" [headerTitle]=\"headerTitle\" [headerTemplate]=\"headerTemplate\" [bodyTemplate]=\"bodyTemplate\">\n  <ng-container *ngIf=\"headerContentTemplate\">\n    <ng-template #header>\n      <ng-container *ngTemplateOutlet=\"headerContentTemplate\"></ng-container>\n    </ng-template>\n  </ng-container>\n\n  <div class=\"container-fluid p-0\">\n    <div #widgetContainer class=\"row no-gutters\">\n      <ng-container *ngIf=\"body\">\n        <ng-container *ngTemplateOutlet=\"body\"></ng-container>\n      </ng-container>\n\n      <ng-container *ngIf=\"bodyTemplate\">\n        <ng-container *ngTemplateOutlet=\"bodyTemplate\"></ng-container>\n      </ng-container>\n\n      <ng-container *ngIf=\"!body && !bodyTemplate\">\n        <ng-content></ng-content>\n      </ng-container>\n    </div>\n  </div>\n</wg-panel>\n",
      styles: ["wg-widget-panel .loading-message{display:none}wg-widget-panel>wg-panel,wg-widget-panel .wg-panel{border:0 none}wg-widget-panel>wg-panel>header,wg-widget-panel .wg-panel>header{border:1px solid #b5b5b5;border-bottom:0 none}wg-widget-panel>wg-panel>section,wg-widget-panel .wg-panel>section{border-bottom:0 none;border-left:1px solid #b5b5b5;border-right:0 none;border-top:1px solid #b5b5b5;padding:0}wg-widget-panel>wg-panel>section>.container-fluid>.row>*,wg-widget-panel .wg-panel>section>.container-fluid>.row>*{border:0 none;border-bottom:1px solid #b5b5b5;border-right:1px solid #b5b5b5;min-height:0}wg-widget-panel>wg-panel>section>.container-fluid>.row [class^=widget-],wg-widget-panel>wg-panel>section>.container-fluid>.row [class*=\" widget-\"],wg-widget-panel .wg-panel>section>.container-fluid>.row [class^=widget-],wg-widget-panel .wg-panel>section>.container-fluid>.row [class*=\" widget-\"]{padding:30px!important}wg-widget-panel.loading .loading-message{display:block}wg-widget-panel.loading>wg-panel>section,wg-widget-panel.loading .wg-panel>section{border-bottom:1px solid #b5b5b5;border-right:1px solid #b5b5b5}wg-widget-panel.loading>wg-panel>section>.container-fluid,wg-widget-panel.loading .wg-panel>section>.container-fluid{left:-99999px;position:fixed;top:-99999px}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    headerIcon: [{
      type: Input
    }],
    headerTitle: [{
      type: Input
    }],
    headerTemplate: [{
      type: Input
    }],
    bodyTemplate: [{
      type: Input
    }],
    widgetContainerElement: [{
      type: ViewChild,
      args: ['widgetContainer']
    }],
    headerContentTemplate: [{
      type: ContentChild,
      args: ['header']
    }],
    body: [{
      type: ContentChild,
      args: ['body']
    }]
  });
})();
class WgWidgetPanelModule {
  static {
    this.ɵfac = function WgWidgetPanelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgWidgetPanelModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgWidgetPanelModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, WgPanelModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgWidgetPanelModule, [{
    type: NgModule,
    args: [{
      declarations: [WgWidgetPanelComponent],
      imports: [CommonModule, WgPanelModule],
      exports: [WgWidgetPanelComponent]
    }]
  }], null, null);
})();
const LIST_ACTION = 'LIST';
const GET_ACTION = 'GET';
const ADD_ACTION = 'ADD';
const ADD_TENANT_ACTION = 'ADD_TENANT';
const UPDATE_ACTION = 'UPDATE';
const REMOVE_ACTION = 'REMOVE';
const UPGRADE_ACTION = 'UPGRADE';
;
;
;
;
;
;
;
;

/**
 *
 * Contains CRUD operations on cached account Info and Tenant List
 *
 * Account Info: Details see accountCache below
 *
 * Tenant List: Details see parentInfoCache below
 */
/**
 *
 * @param state AcntIdInfo
 * @param action can be LIST, ADD, UPDATE (name or accountType), GET, REMOVE
 *
 */
const accountCache = (state, action) => {
  let acntID;
  switch (action.type) {
    case LIST_ACTION:
      return state;
    case ADD_ACTION:
      acntID = action.payload.accountID;
      const acntInfo = action.payload;
      return Object.assign({}, state, {
        [acntID]: acntInfo
      });
    case UPDATE_ACTION:
      acntID = action.payload.accountID;
      const key = action.payload.key;
      const val = action.payload.val;
      if (state.hasOwnProperty(acntID)) {
        return Object.assign({}, state, {
          [acntID]: {
            ...state[acntID],
            [key]: val
          }
        });
      }
      break;
    case GET_ACTION:
      acntID = action.payload.accountID;
      if (state.hasOwnProperty(acntID)) {
        return state[acntID];
      }
      break;
    case REMOVE_ACTION:
      acntID = action.payload.accountID;
      if (state.hasOwnProperty(acntID)) {
        const newState = Object.assign({}, state);
        delete newState[acntID];
        return newState;
      }
      break;
    default:
      return state;
  }
  return state;
};
/**
 *
 * @param state ParentIdInfo
 * @param action can be LIST, ADD, GET, UPDATE, REMOVE, UPGRADE
 *
 */
const parentInfoCache = (state, action) => {
  let parentID;
  let acntID;
  let acntType;
  let tenantList;
  switch (action.type) {
    /**
     * Return the current state which has collection of
     * parent IDs and corresponding account type and their
     * tenant list
     *
     * state could be {} OR
     *   state = {
     *     'ACC-111': {1: [{accountID: '111', accountName: 'test'}]}
     *   }
     */
    case LIST_ACTION:
      return state;
    /**
     * Add the passed in acntID to the state
     * The acntID itself should have the passed in
     * acntType which stores the list of tenants
     *
     * So assume state is {}
     * acntID = 'ACC-111'
     * acntType = 1
     * tenantList = [{accountID: '111', accountName: 'test'}]
     *
     * After the ADD it will be state will be
     *
     * state = {
     *   'ACC-111': {1: [{accountID: '111', accountName: 'test'}]}
     * }
     *
     */
    case ADD_ACTION:
      acntID = action.payload.accountID;
      acntType = action.payload.accountType;
      tenantList = action.payload.tenantList;
      return {
        ...state,
        [acntID]: {
          ...state[acntID],
          [acntType]: tenantList
        }
      };
    case ADD_TENANT_ACTION:
      parentID = action.payload.parentID;
      acntID = action.payload.accountID;
      acntType = action.payload.accountType;
      const acntName = action.payload.accountName;
      if (state.hasOwnProperty(parentID) && state[parentID].hasOwnProperty(acntType)) {
        tenantList = state[parentID][acntType];
        if (tenantList && tenantList.length > 0) {
          const acntExists = tenantList.filter(tenant => tenant.accountID === acntID);
          if (acntExists && acntExists.length > 0) {
            return state;
          }
          const newAcntInfo = [{
            accountID: acntID,
            accountName: acntName
          }];
          const newState = {
            ...state,
            [parentID]: {
              ...state[parentID],
              [acntType]: sortListByAccountName(tenantList, newAcntInfo)
            }
          };
          return newState;
        }
      }
      break;
    /**
     * Update the tenantName for the passed in acntID
     *   if the passed in parent ID and acntType is present in the state
     *
     * So assume state is
     *
     * state = {
     *   'ACC-111': {1: [{accountID: '111', accountName: 'test'}]}
     * }
     *
     * if user passed in
     *    parent ID as ACC-111
     *    acntType as 1
     *    and key as accountName and val as 'jon'
     *
     *   then, After the Update it will be state will be
     *
     * state = {
     *   'ACC-111': {1: [{accountID: '111', accountName: 'joh'}]}
     * }
     *
     */
    case UPDATE_ACTION:
      const key = action.payload.key;
      const val = action.payload.val;
      parentID = action.payload.parentID;
      acntID = action.payload.accountID;
      acntType = action.payload.accountType;
      if (state.hasOwnProperty(parentID) && state[parentID].hasOwnProperty(acntType)) {
        tenantList = state[parentID][acntType];
        const acntIdPresent = tenantList.filter(t => t.accountID === acntID);
        if (acntIdPresent.length === 0) {
          return state;
        }
        const listWithoutAcntID = tenantList.filter(t => t.accountID !== acntID);
        const listWithAcntIdOnly = [{
          accountName: val,
          accountID: acntID
        }];
        const u = {
          ...state,
          [parentID]: {
            ...state[parentID],
            [acntType]: sortListByAccountName(listWithoutAcntID, listWithAcntIdOnly)
          }
        };
        return u;
      }
      break;
    /**
     * Get the tenant list for the paased in account ID
     * and acntType
     *   if the passed in acntID and acntType is present in the state
     *
     * So assume state is
     *
     * state = {
     *   'ACC-111': {1: [{accountID: '111', accountName: 'test'}]}
     * }
     *
     * if user passed in
     *    acntID ID as ACC-111
     *    acntType as 1
     *
     *   then, user get back:
     *     [{accountID: '111', accountName: 'joh'}]}
     *
     */
    case GET_ACTION:
      acntID = action.payload.accountID;
      acntType = action.payload.accountType;
      if (state.hasOwnProperty(acntID) && state[acntID].hasOwnProperty(acntType)) {
        return state[acntID][acntType];
      }
      break;
    /**
     * Remove passed in account ID from tenant list
     *   if the passed in parentID and acntType is present in the state
     *   and if the accountID is present
     * So assume state is
     *
     * state = {
     *   'ACC-111': {1: [
     *                    {accountID: '111', accountName: 'test'}
     *                    {accountID: '222', accountName: 'jon'}
     *                  ]
     *               }
     * }
     *
     * if user wants to remove accountID 222 and if
     *    parent ID is 'ACC-111' and acntType is 1
     *
     *   then the account ID is removed and user gets back:
     *     [{accountID: '111', accountName: 'test'}]}
     *
     */
    case REMOVE_ACTION:
      parentID = action.payload.parentID;
      acntID = action.payload.accountID;
      acntType = action.payload.accountType;
      if (state.hasOwnProperty(parentID) && state[parentID].hasOwnProperty(acntType)) {
        tenantList = state[parentID][acntType];
        const listWithoutAcntID = tenantList.filter(t => t.accountID !== acntID);
        return {
          ...state,
          [parentID]: {
            ...state[parentID],
            [acntType]: listWithoutAcntID
          }
        };
      }
      break;
    /**
     * Upgrade passed in account ID from tenant list to SP
     *   if the passed in parentID is present in the state
     *   and if acntType 2 has the passed in accountID
     *   then delete that account ID from acntType 2 and
     *   add it to acntType 1.
     *
     * So assume state is
     *
     * state = {
     *   'ACC-111': {2: [
     *                    {accountID: '111', accountName: 'test'}
     *                    {accountID: '222', accountName: 'jon'}
     *                  ]
     *               }
     * }
     *
     * if user wants to upgrade accountID 222 and if
     *    parent ID is 'ACC-111' and acntType is 2
     *
     *   then the account ID is upgrades and user gets back:
     *   'ACC-111': {2: [
     *                    {accountID: '111', accountName: 'test'}
     *                  ]
     *               }
     *            :{1: [
     *                    {accountID: '222', accountName: 'jon'}
     *                  ]
     *               }
     *    }
     *
     */
    case UPGRADE_ACTION:
      parentID = action.payload.parentID;
      acntID = action.payload.accountID;
      const ssAcntType = 2;
      const spAcntType = 1;
      if (state.hasOwnProperty(parentID) && state[parentID].hasOwnProperty(ssAcntType) && state[parentID].hasOwnProperty(spAcntType)) {
        tenantList = state[parentID][ssAcntType];
        const listWithAcntID = tenantList.filter(t => t.accountID === acntID);
        if (listWithAcntID && listWithAcntID.length > 0) {
          const listWithOutAcntID = tenantList.filter(t => t.accountID !== acntID);
          const nState = {
            ...state,
            [parentID]: {
              ...state[parentID],
              [ssAcntType]: listWithOutAcntID
            }
          };
          tenantList = [];
          if (nState[parentID].hasOwnProperty(spAcntType)) {
            tenantList = nState[parentID][spAcntType];
          }
          return {
            ...nState,
            [parentID]: {
              ...nState[parentID],
              [spAcntType]: sortListByAccountName(tenantList, listWithAcntID)
            }
          };
        }
      }
      break;
    default:
      return state;
  }
  return state;
};
const sortListByAccountName = (list1, list2) => {
  const combinedList = [...list1, ...list2];
  combinedList.sort((a, b) => {
    if (a.accountName < b.accountName) {
      return -1;
    }
    if (a.accountName > b.accountName) {
      return 1;
    }
    return 0;
  });
  return combinedList;
};
class WgAccountInfoService {
  constructor(http) {
    this.http = http;
    this.getAccountInfoAction = 'accounts/GetAccountInfo';
    this.listAccountsAction = 'accounts/ListChildAccounts';
    this._accountIDCache = {};
    this._parentIDCache = {};
    this.headers = new HttpHeaders().set('Content-Type', 'application/json');
  }
  getAccountInfo(accountID) {
    if (this._prevAccountID && this._prevAccountID !== accountID) {
      this.acntInfoObservable = null;
    }
    if (this._accountIDCache && this._accountIDCache.hasOwnProperty(accountID)) {
      // if accountID is in cache return it as Observable
      return this._getAcntInfoFromCache(accountID);
    } else if (this.acntInfoObservable) {
      // if this.acntInfoObservable is set then
      // the request is in progress return the `Observable`
      // for the ongoing request
      return this.acntInfoObservable;
    } else {
      this.acntInfoObservable = null;
      this._prevAccountID = accountID;
      const httpParams = new HttpParams().set('account_id', accountID).set('include_parent', 'true').set('include_delegated_parent', 'true').set('include_sf_properties', 'true');
      this.acntInfoObservable = this.http.get(this._getURL('platform', 'accounts-mw') + this.getAccountInfoAction, {
        headers: this.headers,
        params: httpParams
      }).pipe(map(acntInfo => {
        const acnt = this.parseAcntInfo(acntInfo);
        if (acnt && acnt.hasOwnProperty('accountID')) {
          this.accountInfoCache(ADD_ACTION, acnt);
        }
        return acnt;
      }), share());
      return this.acntInfoObservable;
    }
  }
  getTenantAccounts(accountID, accountType) {
    if (this._prevParentID) {
      this.tenantInfoObservable = null;
    }
    if (this._parentIDCache && this._parentIDCache.hasOwnProperty(accountID) && this._parentIDCache[accountID].hasOwnProperty(accountType)) {
      // if accountID is in cache return it as Observable
      return this._getParentAcntInfoFromCache(accountID, accountType);
    } else if (this.tenantInfoObservable) {
      // if this.tenantInfoObservable is set then
      // the request is in progress return the `Observable`
      // for the ongoing request
      return this.tenantInfoObservable;
    } else {
      this.tenantInfoObservable = null;
      this._prevParentID = accountID;
      this.tenantInfoObservable = this.http.get(this._getURL('platform', 'accounts-mw') + this.listAccountsAction, {
        headers: this.headers,
        params: this._getAccountListParams(accountID, accountType)
      }).pipe(map(acntInfo => {
        const acnt = this.parseParentAcntInfo(acntInfo, accountID, accountType);
        if (acnt && acnt.length > 0) {
          const payLoad = {
            accountID: accountID,
            accountType: accountType,
            tenantList: acnt
          };
          this.parentCache(ADD_ACTION, payLoad);
        }
        return acnt;
      }), share());
      return this.tenantInfoObservable;
    }
  }
  accountInfoCache(action, payload) {
    const info = accountCache(this._accountIDCache, {
      type: action,
      payload
    });
    if ([ADD_ACTION, UPDATE_ACTION, REMOVE_ACTION].indexOf(action) !== -1) {
      this._accountIDCache = info;
    }
    if (action !== GET_ACTION && action !== LIST_ACTION) {
      this._updateParentCache(this._getParentAction(action, payload.key), payload);
    }
    return info;
  }
  parentCache(action, payload) {
    const info = parentInfoCache(this._parentIDCache, {
      type: action,
      payload
    });
    if ([ADD_TENANT_ACTION, ADD_ACTION, UPDATE_ACTION, REMOVE_ACTION, UPGRADE_ACTION].indexOf(action) !== -1) {
      this._parentIDCache = info;
    }
    return info;
  }
  _getParentAction(action, key) {
    let parentAction = action;
    switch (action) {
      case ADD_ACTION:
        parentAction = ADD_TENANT_ACTION;
        break;
      case UPDATE_ACTION:
        parentAction = action === UPDATE_ACTION && key === 'type' ? UPGRADE_ACTION : UPDATE_ACTION;
    }
    return parentAction;
  }
  _updateParentCache(actionType, payload) {
    const parentPayload = {
      ...payload
    };
    if (actionType === ADD_TENANT_ACTION) {
      parentPayload.parentID = payload.parent.id;
      parentPayload.accountType = payload.type;
    }
    this.parentCache(actionType, parentPayload);
  }
  _getAccountListParams(accountID, accountType) {
    let params = new HttpParams();
    params = params.set('account_id', accountID).set('include_delegated_accounts', 'true').set('starting_index', '-1');
    return params;
  }
  _getAcntInfoFromCache(accountID) {
    return of(this.accountInfoCache(GET_ACTION, {
      accountID
    }));
  }
  _getParentAcntInfoFromCache(accountID, accountType) {
    return of(this.parentCache(GET_ACTION, {
      accountID,
      accountType
    }));
  }
  /**
   *
   * @param acntInfo
   *
   * For the passed in account id add the accountInfo
   * into the _accountIDsCache
   */
  parseParentAcntInfo(acntInfo, parentID, accountType) {
    if (acntInfo.hasOwnProperty('errors') && acntInfo.errors.length > 0) {
      return {};
    }
    if (acntInfo.hasOwnProperty('response') && acntInfo.response.length > 0) {
      const acntInfoList = acntInfo.response.map(dat => {
        return {
          accountName: dat.name,
          accountID: dat.account_id,
          relationType: dat.relation_type
        };
      });
      return acntInfoList;
    }
  }
  /**
   *
   * @param acntInfo
   *
   * For the passed in account id add the accountInfo
   * into the _accountIDsCache
   */
  parseAcntInfo(acntInfo) {
    if (acntInfo && acntInfo.hasOwnProperty('response') && acntInfo.response) {
      const data = acntInfo.response[0];
      const info = {
        accountID: data.account_id,
        accountName: data.name,
        parent: data.parent,
        delegated_parent: data.delegated_parent,
        support_delegated_parent: data.support_delegated_parent,
        type: data.type,
        tier: data?.tier,
        status: data.status,
        isOrionEnabled: data?.isOrionEnabled ? true : false,
        contacts: data?.contacts
      };
      return info;
    }
    return {};
  }
  _getURL(service, override = '') {
    const env = getEnv();
    const options = {
      service: service,
      region: 'usa',
      override: override
    };
    if (window.location.host.indexOf('watchguard.com') !== -1) {
      options.override = '';
    }
    return newGuardUrl(options);
  }
  static {
    this.ɵfac = function WgAccountInfoService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgAccountInfoService)(i0.ɵɵinject(i1.HttpClient));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: WgAccountInfoService,
      factory: WgAccountInfoService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgAccountInfoService, [{
    type: Injectable
  }], () => [{
    type: i1.HttpClient
  }], null);
})();
class WgAccountInfoModule {
  static {
    this.ɵfac = function WgAccountInfoModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgAccountInfoModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgAccountInfoModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [WgAccountInfoService]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgAccountInfoModule, [{
    type: NgModule,
    args: [{
      providers: [WgAccountInfoService]
    }]
  }], null, null);
})();
class WgSessionModule {
  static {
    this.ɵfac = function WgSessionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgSessionModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgSessionModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgSessionModule, [{
    type: NgModule,
    args: [{}]
  }], null, null);
})();

/**
 * The service is used to store the cache for the feature toggle enforcement.
 * Components can use the methods defined here to help in deciding if UI widgets
 * and menu items should be shown or hidden.
 */
class WgFeatureToggleService {
  constructor() {
    this.resetFeatureCache();
    this.featureToggleChangeSubject = new BehaviorSubject({});
    this.featureToggleCacheSubject = new BehaviorSubject(false);
  }
  /**
   * This method should be called after successfully logging in.
   * Then populateFeatureCache() should be called right after GetSessionInfo()
   * returns with the feature toggle enforment information.
   */
  resetFeatureCache() {
    this.featureEnforcementCache = {};
  }
  /**
   * Call this after GetSessionInfo() and SetAccountContext().
   * featureEnforcementList is an array of entries that are retreived from
   * the middleware.
   *
   * Each entry contains the following fields,
   *  application_identifier,
   *  feature_identifier,
   *  feature_version,
   *  preference
   */
  populateFeatureCache(accountID, featureEnforcementList) {
    if (!accountID) {
      console.debug('No accountID in populateFeatureCache().');
      return;
    }
    if (!featureEnforcementList) {
      console.debug('No featureEnforcementList in populateFeatureCache().');
      return;
    }
    // in case the info for the account exists, just replace it with new info.
    const appIdInfo = {};
    this.featureEnforcementCache[accountID] = appIdInfo;
    for (const entry of featureEnforcementList) {
      if (!entry.hasOwnProperty('application_identifier')) {
        console.debug('No application_identifier.');
        continue;
      }
      if (!entry.hasOwnProperty('preference')) {
        console.debug('No preference.');
        continue;
      }
      let enforcementEntries;
      const appID = entry.application_identifier;
      if (!appIdInfo.hasOwnProperty(appID)) {
        appIdInfo[appID] = [];
      }
      enforcementEntries = appIdInfo[appID];
      const data = {
        featureIdentifier: entry.hasOwnProperty('feature_identifier') && entry.feature_identifier ? entry.feature_identifier : null,
        featureVersion: entry.hasOwnProperty('feature_version') && entry.feature_version ? entry.feature_version : null,
        preference: entry.preference
      };
      enforcementEntries.push(data);
    }
    // Successfully updated the cache, now notify the
    // subject so that listeners can subscribe and do the needful
    this.featureToggleCacheChanged(true);
  }
  /**
   * Search the cache based on the parameters and return true or false.
   * This method can be called from directives or ts files to get information.
   * Note: if there is no match, return true.
   */
  allowFeature(accountID, applicationIdentifier, featureIdentifier, featureVersion) {
    if (!this.featureEnforcementCache.hasOwnProperty(accountID)) {
      console.debug('Feature cache does not contain ' + 'information of account: ' + accountID);
      return true;
    }
    // true if the application level feature entry does not exists or
    // exists with the preference of true;
    let appLevelPreference = true;
    if (this.featureEnforcementCache[accountID].hasOwnProperty(applicationIdentifier)) {
      // locate application level feature entry.
      const enforcementList = this.featureEnforcementCache[accountID][applicationIdentifier];
      for (const entry of enforcementList) {
        if (entry.featureIdentifier == null && entry.featureVersion == null) {
          // note: use == to check null or undefined
          appLevelPreference = entry.preference;
          break;
        }
      }
    }
    // if application level preference is false, return false.
    if (!appLevelPreference) {
      return false;
    } else {
      if (!this.featureEnforcementCache[accountID].hasOwnProperty(applicationIdentifier)) {
        // just return true, so the corresponding UI is visible.
        return true;
      }
      if (featureIdentifier === '') {
        featureIdentifier = null;
      }
      if (featureVersion === '') {
        featureVersion = null;
      }
      const enforcementList = this.featureEnforcementCache[accountID][applicationIdentifier];
      for (const entry of enforcementList) {
        if (entry.featureIdentifier === featureIdentifier && entry.featureVersion === featureVersion) {
          return entry.preference;
        }
      }
    }
    return true;
  }
  /**
   * Search the cache based on the parameters and update the preference.
   */
  updateFeaturePreference(accountID, applicationIdentifier, featureIdentifier, featureVersion, preference) {
    if (!this.featureEnforcementCache.hasOwnProperty(accountID)) {
      console.debug('Feature cache does not contain ' + 'information of account: ' + accountID);
      return;
    }
    if (!this.featureEnforcementCache[accountID].hasOwnProperty(applicationIdentifier)) {
      console.debug('Feature cache does not contain applicationIdentifier: ' + applicationIdentifier + ' in account: ' + accountID);
      return;
    }
    const enforcementList = this.featureEnforcementCache[accountID][applicationIdentifier];
    for (const entry of enforcementList) {
      if (entry.featureIdentifier === featureIdentifier && entry.featureVersion === featureVersion) {
        entry.preference = preference;
        return;
      }
    }
  }
  /**
   * Inspect the dynamic widget or menu item object defined in json files (in Static) and
   * return true to keep and false to remove.
   *
   * Criteria:
   * - Search item for applicationID and featureID fields. If either does not exist,
   *   return true to keep.
   * - Then serach for an optional field featureVersion. Then call allowFeature()
   *   of the WgFeatureToggleService and return with the result.
   */
  filterJsonEntry(acntID, item) {
    if (!acntID) {
      console.debug('The acntID does not contain value in filterJsonEntry().');
      return true;
    }
    // process "obsoleteFeatures" which is an array containing a list of toggle items.
    // The obsoleteFeatures has a higher procedent than "features".
    // if any of the toggle item is true, do not include the entry.
    if (item.hasOwnProperty('obsoleteFeatures') && item.obsoleteFeatures.length > 0) {
      for (const betaInfoEntry of item.obsoleteFeatures) {
        if (betaInfoEntry.hasOwnProperty('applicationID') && betaInfoEntry.hasOwnProperty('featureID') && betaInfoEntry.hasOwnProperty('featureVersion')) {
          if (this.allowFeature(acntID, betaInfoEntry.applicationID, betaInfoEntry.featureID, betaInfoEntry.featureVersion)) {
            return false; // exclude the entry
          }
        }
      }
    }
    // process features which is an array containing a list of toggle items.
    // if any of the toggle item is true, include the entry.
    let itemHasFeature;
    let itemDataHasFeature;
    if (item.hasOwnProperty('features') && item.features.length > 0) {
      itemHasFeature = true;
    }
    if (item.hasOwnProperty('data') && item.data.hasOwnProperty('features') && item.data.features.length > 0) {
      itemDataHasFeature = true;
    }
    if (itemHasFeature || itemDataHasFeature) {
      let featuresArray = null;
      if (itemHasFeature) {
        featuresArray = item.features;
      } else {
        featuresArray = item.data.features;
      }
      for (const betaInfoEntry of featuresArray) {
        // OR each entry
        if (betaInfoEntry.hasOwnProperty('applicationID') && betaInfoEntry.hasOwnProperty('featureID') && betaInfoEntry.hasOwnProperty('featureVersion')) {
          if (this.allowFeature(acntID, betaInfoEntry.applicationID, betaInfoEntry.featureID, betaInfoEntry.featureVersion)) {
            return true;
          }
        }
      }
      return false; // return false if none of the feature entry has a true preference.
    } else {
      return true; // the widget does not have any beta feature inforamation, return true.
    }
  }
  /**
   * Filter out the nav array based on feature toggle enforcement.
   */
  filterNavList(acntID, navEntries) {
    let filteredNavEntries;
    filteredNavEntries = navEntries.filter(item => {
      return this.filterJsonEntry(acntID, item);
    });
    // children and children of children levels
    for (let i = 0; i < filteredNavEntries.length; i++) {
      filteredNavEntries[i] = this.filterNavDataBasedOnFeatureToggleEnforcement(acntID, filteredNavEntries[i]);
    }
    return filteredNavEntries;
  }
  /**
   *  Filter out the the children menu items of an nav object based on feature
   *  toggle enforcement that are not allowed. The check is based on their corresponding
   *  applicationID, featureID, and featureVersion values specified in the json files in
   *  assets/(dev|qa|staging|prod) of the Static libarary.
   *
   *  The filtering is done at most 2 levels
   *  - children of the top level
   *  - children of the children of the top level
   *  - children of the top_nav_children of the top level
   *
   *  Note: the function will not alter the navData. The result will be returned.
   */
  filterNavDataBasedOnFeatureToggleEnforcement(acntID, origNavData) {
    if (!acntID) {
      console.log('The acntID does not contain value in ' + 'filterNavDataBasedOnFeatureToggleEnforcement();');
      return origNavData;
    }
    const navData = JSON.parse(JSON.stringify(origNavData));
    if (navData.hasOwnProperty('children')) {
      const filteredChildren = navData.children.filter(item => {
        return this.filterJsonEntry(acntID, item);
      });
      navData.children = filteredChildren;
      for (const child of navData.children) {
        if (child.hasOwnProperty('children')) {
          const filtered = child.children.filter(item => {
            return this.filterJsonEntry(acntID, item);
          });
          child.children = filtered;
        }
      }
    }
    if (navData.hasOwnProperty('top_nav_children')) {
      for (const topNav of navData.top_nav_children) {
        if (topNav.hasOwnProperty('children')) {
          const filteredChildren = topNav.children.filter(item => {
            return this.filterJsonEntry(acntID, item);
          });
          topNav.children = filteredChildren;
        }
      }
      // keep only top nav that contains at least one entry
      navData.top_nav_children = navData.top_nav_children.filter(topNav => {
        return topNav.children.length > 0;
      });
    }
    return navData;
  }
  filterWidgetItems(acntID, widgets) {
    let filteredWidgets;
    filteredWidgets = widgets.filter(item => {
      return this.filterJsonEntry(acntID, item.data);
    });
    // children and children of children levels
    for (let i = 0; i < filteredWidgets.length; i++) {
      filteredWidgets[i] = this.filterWidgetItem(acntID, filteredWidgets[i]);
    }
    return filteredWidgets;
  }
  /**
   *  Filter out the widget item based on feature toggle enforcement that
   *  are not allowed. The check is based on their corresponding applicationID,
   *  featureID, and featureVersion values specified in the json files in
   *  assets/(dev|qa|staging|prod) of the Shell libarary.
   *
   *  The filtering is done at most 2 levels
   *  - children of the top level
   *  - children of the children of the top level
   */
  filterWidgetItem(acntID, origData) {
    if (!acntID) {
      console.log('The acntID does not contain value in filterWidgetItem();');
      return origData;
    }
    // use shallow copy to deal with a complex object
    const newData = {
      ...origData
    };
    let newDataHasChildren;
    let newDataDataHasChildren;
    if (newData.hasOwnProperty('children')) {
      newDataHasChildren = true;
    } else if (newData.data.hasOwnProperty('children')) {
      newDataDataHasChildren = true;
    }
    if (newDataHasChildren || newDataDataHasChildren) {
      let dataObj = newDataDataHasChildren ? newData.data : newData;
      const filteredChildren = dataObj.children.filter(item => {
        return this.filterJsonEntry(acntID, item);
      });
      dataObj.children = filteredChildren;
      for (const child of dataObj.children) {
        if (child.hasOwnProperty('children')) {
          const filtered = child.children.filter(item => {
            return this.filterJsonEntry(acntID, item);
          });
          child.children = filtered;
        }
      }
    }
    return newData;
  }
  /**
   * Used to notify subscribers that there is a preference change for given
   * acntID, applicationID, featureID, and featureVersion.hasOwnProperty
   *
   * data { acntID: val, applicationID: val, featureID: val, featureVersion: val,
   *        preference: val }
   */
  featureToggleChange(data) {
    this.featureToggleChangeSubject.next(data);
  }
  /**
   * Anytime we update the cache for an account
   * we want to ensure listeners are notified
   *
   * Used by wgc-navigation, esp the secondary-nav UI
   * to properly build the section based on which
   * features are turned on / off for the specific account
   *
   */
  featureToggleCacheChanged(data) {
    this.featureToggleCacheSubject.next(data);
  }
  /**
   * We want to check if the passed in account is
   * already in the feature toggle cache.
   *
   * This method is used in wgc-navigation to build the 2ndy nav
   * if the account is already in cache
   *
   */
  cacheHasFeatureEnforcementInfo(accountID) {
    return this.featureEnforcementCache.hasOwnProperty(accountID);
  }
  static {
    this.ɵfac = function WgFeatureToggleService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgFeatureToggleService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: WgFeatureToggleService,
      factory: WgFeatureToggleService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgFeatureToggleService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
class SessionService {
  constructor(http, featureToggleService) {
    this.http = http;
    this.featureToggleService = featureToggleService;
    this.sessionInfoUrl = 'loginmw/GetSessionInfo';
    this.headers = new HttpHeaders().set('Content-Type', 'application/json');
  }
  getSessionInfo() {
    if (this.sessionInfo) {
      return of(this.sessionInfo);
    } else if (this.sessionInfoObservable) {
      // request in progress
      return this.sessionInfoObservable;
    } else {
      const time = new Date().getTime();
      this.sessionInfoObservable = this.http.get(this._getURL('platform', 'login-mw') + this.sessionInfoUrl + '?t=' + time, {
        headers: this.headers
      }).pipe(tap(sessionInfo => {
        if (sessionInfo && sessionInfo.hasOwnProperty('pri_account_id')) {
          this.sessionInfo = sessionInfo;
        } else {
          this.sessionInfo = null;
        }
        if (sessionInfo && sessionInfo.hasOwnProperty('account_preferences')) {
          if (sessionInfo.account_preferences.hasOwnProperty('beta')) {
            this.featureToggleService.populateFeatureCache(sessionInfo.pri_account_id, sessionInfo.account_preferences['beta']);
          } else {
            console.log('No beta information.');
          }
        } else {
          console.log('No account_preferences information.');
        }
      }), share()); // If multiple subs on this HTTP, share the result to avoid multiple calls
      return this.sessionInfoObservable;
    }
  }
  getSessionInfoNonCache() {
    const time = new Date().getTime();
    return this.sessionInfoObservable = this.http.get(this._getURL('platform', 'login-mw') + this.sessionInfoUrl + '?t=' + time, {
      headers: this.headers
    }).pipe(share());
  }
  /* This method uses the sessionInfo.pri_account_id hence, it assumes that
   * getSessionInfo method had been called which should be the case since
   * getSessionInfo is always called first when loading any page in the UI.
   */
  canManageAnnouncements() {
    if (this.cacheResp) {
      return of(this.cacheResp);
    } else if (this.canManageAnnouncementsObs$) {
      return this.canManageAnnouncementsObs$;
    } else {
      const url = this._getURL('platform') + 'announcements/v1/' + this.sessionInfo.pri_account_id + '/allowed';
      this.canManageAnnouncementsObs$ = this.http.get(url).pipe(tap(response => {
        if (response && response.hasOwnProperty('allowed')) {
          this.cacheResp = response;
        } else {
          this.cacheResp = null;
        }
      }), share());
      return this.canManageAnnouncementsObs$;
    }
  }
  _getURL(service, override = '') {
    const env = getEnv();
    const options = {
      service: service,
      region: 'usa',
      override: override
    };
    if (window.location.host.indexOf('watchguard.com') !== -1) {
      options.override = '';
    }
    return newGuardUrl(options);
  }
  static {
    this.ɵfac = function SessionService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SessionService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(WgFeatureToggleService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SessionService,
      factory: SessionService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SessionService, [{
    type: Injectable
  }], () => [{
    type: i1.HttpClient
  }, {
    type: WgFeatureToggleService
  }], null);
})();
class RBACService {
  constructor(sessionService, http) {
    this.sessionService = sessionService;
    this.http = http;
    // Role constants that can be used here and others.
    this.SP_ROLE_OWNER_BITMASK = 0x00001;
    this.SP_ROLE_AUDITOR_BITMASK = 0x00002;
    this.SP_ROLE_SALES_BITMASK = 0x00004;
    this.SP_ROLE_HELPDESK_BITMASK = 0x00008;
    this.SUBS_ROLE_ADMIN_BITMASK = 0x10000;
    this.SUBS_ROLE_ANALYST_BITMASK = 0x20000;
    this.SUBS_ROLE_OBSERVER_BITMASK = 0x40000;
    this.rbacUrl = '/rbac/permissions-bitmasks.json';
  }
  /**
   * Returns the permissions file for RBAC.
   *
   * @returns Observable<any>
   * @memberof RBACService
   */
  getPermissions() {
    if (this.permissions) {
      return of(this.permissions);
    } else if (this.getPermissionsObservable) {
      return this.getPermissionsObservable;
    } else {
      this.getPermissionsObservable = this.http.get(this.rbacUrl).pipe(tap(response => {
        if (response) {
          this.permissions = response;
        }
      }), share()); // If multiple subs on this HTTP, share the result to avoid multiple calls
      return this.getPermissionsObservable;
    }
  }
  /**
   * Returns an observable that returns true if the current session user has permissions.
   *
   * Use this function if you want to ensure the permission file is loaded.
   * You may also call getPermissions() and then call hasPermission() if you do not want to use
   * the observable.
   *
   * 'app' refers to the application. Example: 'platform'
   *
   * 'permission' refers to the permission in the JSON. Example: 'canManageOwnAccount'
   *
   * Optionally provide the accountID for the account the user should be verified against.
   * Default is the user's own account.
   *
   * @param string app
   * @param string permission
   * @param string [accountID]
   * @returns Observable<boolean>
   * @memberof RBACService
   */
  hasPermissionObservable(app, permission, accountID) {
    return new Observable(observer => {
      this.getPermissions().subscribe(permissions => {
        this.sessionService.getSessionInfo().subscribe(sessionInfo => {
          observer.next(this.hasPermission(app, permission, accountID));
          observer.complete();
        }, err => {
          console.error('No session info loaded!');
          observer.next(false);
          observer.complete();
        });
      }, err => {
        console.error(`Unable to load permissions.`);
        observer.next(false);
        observer.complete();
      });
    });
  }
  /**
   * Returns true if the current session user has permissions.
   *
   * It is recommended that the permissions be loaded before calling this function.
   *
   * 'app' refers to the application. Example: 'platform'
   *
   * 'permission' refers to the permission in the JSON. Example: 'canManageOwnAccount'
   *
   * Optionally provide the accountID for the account the user should be verified against.
   * Default is the user's own account.
   *
   * @param string app
   * @param string permission
   * @param string [accountID]
   * @returns boolean
   * @memberof RBACService
   */
  hasPermission(app, permission, accountID) {
    let result = false;
    if (!app || !permission) {
      console.debug(`Unable to check ${app}:${permission}`);
    } else if (!this.permissions) {
      console.debug(`No permissions loaded.`);
    } else if (this.checkSession()) {
      const acntID = accountID || this.sessionService.sessionInfo.pri_account_id;
      const roles = this.permissions[app][permission];
      if (roles) {
        result = this.checkRoles(acntID, roles);
      }
    }
    return result;
  }
  // used by GranularRBACService
  hasRbacPermissionInRolepolicy(app, permissionName, rolePolicy) {
    let result = false;
    if (!app || !permissionName) {
      console.debug(`Unable to check ${app}:${permissionName}`);
    } else if (!this.permissions) {
      console.debug(`No permissions loaded.`);
    } else if (this.checkSession()) {
      const roles = this.permissions[app][permissionName];
      if (roles) {
        for (let i = 0; i < roles.length; i++) {
          const spRole = rolePolicy.role & 0x0F;
          const permission = parseInt(roles[i], 16);
          const spPermission = permission & 0x0F;
          if (spRole && spPermission) {
            // SP role
            if ((rolePolicy.role & permission) === permission) {
              result = true;
              break;
            }
          } else if (!spRole && !spPermission) {
            // Subscriber role
            if ((rolePolicy.role & permission) === permission) {
              result = true;
              break;
            }
          }
        }
      }
    }
    return result;
  }
  /**
   * Return true if it is one of SP roles, false if it is one of the Subcriber roles.
   *
   * @param role is the role num from the role_policy.role of the GetSessionInfo API's response.
   */
  isSpRole(role) {
    return Boolean(role & this.SP_ROLE_OWNER_BITMASK || role & this.SP_ROLE_AUDITOR_BITMASK || role & this.SP_ROLE_SALES_BITMASK || role & this.SP_ROLE_HELPDESK_BITMASK);
  }
  checkRoles(acntID, roles) {
    // Checks the existence of the roles in the role mapping
    let result = false;
    this.sessionService.sessionInfo.role_policy.forEach(role => {
      if (role.account_id === acntID) {
        for (let i = 0; i < roles.length; i++) {
          const spRole = role.role & 0x0F;
          const permission = parseInt(roles[i], 16);
          const spPermission = permission & 0x0F;
          if (spRole && spPermission) {
            // SP role
            if ((role.role & permission) === permission) {
              result = true;
              break;
            }
          } else if (!spRole && !spPermission) {
            // Subscriber role
            if ((role.role & permission) === permission) {
              result = true;
              break;
            }
          }
        }
        if (result) {
          return;
        }
      }
    });
    return result;
  }
  checkSession() {
    // Check if session exists
    if (this.sessionService.sessionInfo && this.sessionService.sessionInfo.role_policy) {
      return true;
    } else {
      console.debug('Warning: No valid session found.');
      return false;
    }
  }
  static {
    this.ɵfac = function RBACService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RBACService)(i0.ɵɵinject(SessionService), i0.ɵɵinject(i1.HttpClient));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RBACService,
      factory: RBACService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RBACService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: SessionService
  }, {
    type: i1.HttpClient
  }], null);
})();

// To store JWT token when drill down. It is populated as part the handling of SetAccountContextId.
class JwtTokenInfoService {
  constructor() {
    this.jwtTokenCache = {};
    this.resetCache();
  }
  resetCache() {
    this.jwtTokenCache = {};
  }
  populateCache(acntID, jwtToken) {
    if (!acntID) {
      return;
    }
    this.jwtTokenCache[acntID] = jwtToken;
  }
  getJwtToken(acntID) {
    if (!acntID) {
      return undefined;
    }
    return this.jwtTokenCache[acntID];
  }
  static {
    this.ɵfac = function JwtTokenInfoService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JwtTokenInfoService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: JwtTokenInfoService,
      factory: JwtTokenInfoService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JwtTokenInfoService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
const SP_ROLE_OWNER = "OWNER";
const SP_ROLE_AUDITOR = "AUDITOR";
const SP_ROLE_SALES = "SALES";
const SP_ROLE_HELPDESK = "HELPDESK";
const SUB_ROLE_ADMIN = "ADMIN";
const SUB_ROLE_ANALYST = "ANALYST";
const SUB_ROLE_OBSERVER = "OBSERVER";
const COR_CATE_ACCOUNT_ADMIN = 'account_administration';
const COR_CATE_SERVICE_PROVIDER_ADMIN = 'service_provider_administration';
const COR_CATE_SUBSCRIBER_ADMIN = 'subscriber_administration';
const COR_CATE_SYSTEM_ADMIN = 'system_administration';
const COR_CATE_AUTHPOINT = 'authpoint';
const COR_CATE_ENDPOINT = 'endpoint';
const COR_CATE_DEVICES = 'devices';
const COR_CATE_THREAT_SYNC = 'threat_sync';
const COR_CATE_FIRECLOUD = 'firecloud';
// COR categories are not considered applications/products.
const NON_APP_COR_CATES = [COR_CATE_ACCOUNT_ADMIN, COR_CATE_SERVICE_PROVIDER_ADMIN, COR_CATE_SUBSCRIBER_ADMIN, COR_CATE_SYSTEM_ADMIN];
class GranularRBACService {
  constructor(sessionService, rbacService, jwtTokenService, http) {
    this.sessionService = sessionService;
    this.rbacService = rbacService;
    this.jwtTokenService = jwtTokenService;
    this.http = http;
    this.granularRbacUrl = '/rbac/granular-rbac.json';
  }
  /**
   * Returns the granular_rbac.json file for Granular RBAC.
   *
   * @returns Observable<any>
   * @memberof GranularRBACService
   */
  loadGranularRBAC() {
    if (this.granularRbacInfo) {
      return of(this.granularRbacInfo);
    } else if (this.loadGranularRbacObservable) {
      return this.loadGranularRbacObservable;
    } else {
      this.loadGranularRbacObservable = this.http.get(this.granularRbacUrl).pipe(tap(response => {
        if (response) {
          this.granularRbacInfo = response;
        }
      }), share()); // If multiple subs on this HTTP, share the result to avoid multiple calls
      return this.loadGranularRbacObservable;
    }
  }
  checkSession() {
    // Check if session exists
    if (this.sessionService.sessionInfo && this.sessionService.sessionInfo.role_policy) {
      return true;
    } else {
      console.debug('Warning: No valid session found.');
      return false;
    }
  }
  useGranularRbacObservable() {
    return new Observable(observer => {
      this.loadGranularRBAC().pipe(take(1)).subscribe({
        next: granularRbacInfo => {
          this.sessionService.getSessionInfo().pipe(take(1)).subscribe({
            next: sessionInfo => {
              observer.next(this.useGranularRBAC());
              observer.complete();
            },
            error: err => {
              console.error('No session info loaded!');
              observer.next(false);
              observer.complete();
            }
          });
        },
        error: err => {
          console.error(`Unable to load granular_rbac.json.`);
          observer.next(false);
          observer.complete();
        }
      });
    });
  }
  useGranularRBAC(accountID) {
    let result = false;
    if (this.checkSession()) {
      const session = this.sessionService.sessionInfo;
      const acntID = accountID || this.sessionService.sessionInfo.pri_account_id;
      if (session && session.hasOwnProperty('role_policy')) {
        for (const rolePolicy of session.role_policy) {
          if (rolePolicy.account_id === acntID) {
            if (rolePolicy.hasOwnProperty('permissions')) {
              result = true;
              break;
            }
          }
        }
      }
    }
    return result;
  }
  // accountID, if not specified, use login account ID to get the role from JWT token.
  hasPermissionGranularRbacObservable(appV2, permissionV2, appV1, permissioinV1, accountID) {
    const apis = [this.loadGranularRBAC(), this.rbacService.getPermissions()];
    return new Observable(observer => {
      combineLatest(apis).pipe(take(1)).subscribe({
        next: results => {
          this.sessionService.getSessionInfo().pipe(take(1)).subscribe({
            next: sessionInfo => {
              let ret = false;
              // base role of login. It is used to determine the fallback to RBAC or not.
              let baseRoleNameOfLogin = '';
              for (const rolePolicy of this.sessionService.sessionInfo.role_policy) {
                if (rolePolicy.account_id === this.sessionService.sessionInfo.pri_account_id) {
                  baseRoleNameOfLogin = this.roleName(rolePolicy.role);
                }
              }
              let acntID = this.sessionService.sessionInfo.pri_account_id;
              let rolePolicies = this.sessionService.sessionInfo.role_policy;
              if (accountID && accountID !== acntID) {
                const rp = this.jwtTokenService.getJwtToken(accountID);
                if (rp) {
                  acntID = accountID;
                  rolePolicies = rp;
                }
              }
              if (!this.useGranularRBAC()) {
                // The operator does not have COR, use RBAC v1 with drilldown's role policy,
                // This is to support the inheritance's mapping.
                for (const rolePolicy of rolePolicies) {
                  if (rolePolicy.account_id === acntID) {
                    ret = this.rbacService.hasRbacPermissionInRolepolicy(appV1, permissioinV1, rolePolicy);
                    break;
                  }
                }
              } else {
                // the operator has COR
                for (const rolePolicy of rolePolicies) {
                  if (rolePolicy.account_id === acntID && rolePolicy?.permissions) {
                    let fallbackToRBAC = false;
                    // Note: if category does not exist or is off, do not check valid roles for fallbackToRBAC.
                    if (rolePolicy?.permissions[appV2]) {
                      fallbackToRBAC = !Boolean(rolePolicy.permissions && appV2 && permissionV2);
                      if (!fallbackToRBAC) {
                        // check if the permission is a valid premission of the login's base role.
                        if (this.granularRbacInfo?.permission_catalog && this.granularRbacInfo?.permission_catalog.hasOwnProperty(appV2) && this.granularRbacInfo?.permission_catalog[appV2].hasOwnProperty(permissionV2)) {
                          const validRoles = this.granularRbacInfo?.permission_catalog[appV2][permissionV2].valid_roles || [];
                          if (!validRoles.includes(baseRoleNameOfLogin)) {
                            fallbackToRBAC = true;
                          }
                        }
                      }
                    }
                    if (fallbackToRBAC) {
                      ret = this.rbacService.hasRbacPermissionInRolepolicy(appV1, permissioinV1, rolePolicy);
                    } else {
                      ret = this.checkPermissionGranularRBAC(appV2, permissionV2, rolePolicy);
                    }
                  }
                  if (ret) {
                    break;
                  }
                }
              }
              observer.next(ret);
              observer.complete();
            },
            error: err => {
              console.error('No session info loaded!');
              observer.next(false);
              observer.complete();
            }
          });
        },
        error: err => {
          console.error(`Unable to either load granular_rbac.json or permissions-bitmasks.json.`);
          observer.next(false);
          observer.complete();
        }
      });
    });
  }
  canAccessAppObservable(urlToGoTo, accountID) {
    return new Observable(observer => {
      this.loadGranularRBAC().pipe(take(1)).subscribe({
        next: granularRbacInfo => {
          this.sessionService.getSessionInfo().pipe(take(1)).subscribe({
            next: sessionInfo => {
              observer.next(this.canAccessApp(urlToGoTo));
              observer.complete();
            },
            error: err => {
              console.error('No session info loaded!');
              observer.next(false);
              observer.complete();
            }
          });
        },
        error: err => {
          console.error(`Unable to load granular_rbac.json.`);
          observer.next(false);
          observer.complete();
        }
      });
    });
  }
  // app is COR category like, 'service_provider_administration', 'threat_sync'.
  // Can use login's COR permissions to check. COR permissions are the same even in a drill down tenant account.
  blockAppObservable(app) {
    return new Observable(observer => {
      this.loadGranularRBAC().pipe(take(1)).subscribe({
        next: granularRbacInfo => {
          this.sessionService.getSessionInfo().pipe(take(1)).subscribe({
            next: sessionInfo => {
              let ret = false;
              const session = this.sessionService.sessionInfo;
              if (session && session.hasOwnProperty('role_policy')) {
                const acntID = this.sessionService.sessionInfo.pri_account_id;
                for (const rolePolicy of session.role_policy) {
                  if (rolePolicy?.account_id === acntID && rolePolicy?.permissions) {
                    if (!(rolePolicy?.permissions[app] > 0)) {
                      // 0 or undefined
                      ret = true;
                      break;
                    }
                  }
                }
              }
              observer.next(ret);
              observer.complete();
            },
            error: err => {
              console.error('No session info loaded!');
              observer.next(false);
              observer.complete();
            }
          });
        },
        error: err => {
          console.error(`Unable to load granular_rbac.json.`);
          observer.next(false);
          observer.complete();
        }
      });
    });
  }
  checkPermissionGranularRBAC(appV2, permissionV2, rolePolicy) {
    let result = false;
    if (appV2 && permissionV2) {
      let permissionBit = 0;
      // get the bit for permissionV2
      if (this.granularRbacInfo?.permission_catalog[appV2] && this.granularRbacInfo?.permission_catalog[appV2].hasOwnProperty(permissionV2) && this.granularRbacInfo?.permission_catalog[appV2][permissionV2].hasOwnProperty('bit_value')) {
        permissionBit = parseInt(this.granularRbacInfo?.permission_catalog[appV2][permissionV2].bit_value, 16);
      }
      if (rolePolicy?.permissions && rolePolicy?.permissions[appV2]) {
        if (permissionBit & rolePolicy.permissions[appV2]) {
          result = true;
        }
      }
    }
    return result;
  }
  // - The operator does not have COR, return false.
  // - check each categories (excluded service_provider_administration, 
  //   subscriber_administration, account_administration, and system_administration).
  //   If any has value of 0, return false.
  hasCorPermissionsForAllProductsObserverable(accountID) {
    return new Observable(observer => {
      this.loadGranularRBAC().pipe(take(1)).subscribe({
        next: granularRbacInfo => {
          this.sessionService.getSessionInfo().pipe(take(1)).subscribe({
            next: sessionInfo => {
              let ret = false;
              let acntID = this.sessionService.sessionInfo.pri_account_id;
              let rolePolicies = this.sessionService.sessionInfo.role_policy;
              if (accountID && accountID !== acntID) {
                const rp = this.jwtTokenService.getJwtToken(accountID);
                if (rp) {
                  acntID = accountID;
                  rolePolicies = rp;
                }
              }
              let found = undefined;
              for (const rolePolicy of rolePolicies) {
                if (rolePolicy.account_id === acntID) {
                  found = rolePolicy;
                  break;
                }
              }
              if (found) {
                if (!found.permissions) {
                  // The operator does not have COR, return false
                  ret = false;
                } else {
                  // the operator has COR
                  ret = true;
                  for (const [key, value] of Object.entries(found.permissions)) {
                    if (NON_APP_COR_CATES.includes(key)) {
                      continue;
                    }
                    if (value === 0) {
                      ret = false;
                      break;
                    }
                  }
                }
              }
              observer.next(ret);
              observer.complete();
            },
            error: err => {
              console.error('No session info loaded!');
              observer.next(false);
              observer.complete();
            }
          });
        },
        error: err => {
          console.error(`Unable to load granular_rbac.json.`);
          observer.next(false);
          observer.complete();
        }
      });
    });
  }
  // COR only. For old RBAC returns true.
  // It is ok to always use the role of the login's JWT token to check if COR is used.
  canAccessApp(urlToGoTo) {
    let result = true;
    if (this.checkSession()) {
      const acntID = this.sessionService.sessionInfo.pri_account_id;
      if (!this.useGranularRBAC(acntID)) {
        return true;
      }
      if (!urlToGoTo) {
        return true;
      }
      for (const rolePolicy of this.sessionService.sessionInfo.role_policy) {
        if (rolePolicy.account_id === acntID && rolePolicy?.permissions) {
          const urlsToCheck = this.getUrlsToCheck(rolePolicy.permissions);
          for (const url of urlsToCheck) {
            const regExp = new RegExp(url);
            if (regExp.test(urlToGoTo)) {
              return false;
            }
          }
        }
      }
    }
    return result;
  }
  getUrlsToCheck(appPermissions) {
    let ret = [];
    for (const app in this.granularRbacInfo?.applicationUrls) {
      const appPermissionVal = appPermissions[app];
      for (const perm in this.granularRbacInfo?.applicationUrls[app]) {
        let urls = this.granularRbacInfo.applicationUrls[app][perm];
        urls = Array.isArray(urls) ? urls : [];
        if (perm === '*') {
          if (!appPermissionVal) {
            // 0 or undefined
            ret = ret.concat(urls);
          }
        }
      }
    }
    ret = [...new Set(ret)]; // remove duplicates
    return ret;
  }
  roleName(role) {
    if (role & this.rbacService.SP_ROLE_OWNER_BITMASK) {
      return SP_ROLE_OWNER;
    } else if (role & this.rbacService.SP_ROLE_AUDITOR_BITMASK) {
      return SP_ROLE_AUDITOR;
    } else if (role & this.rbacService.SP_ROLE_SALES_BITMASK) {
      return SP_ROLE_SALES;
    } else if (role & this.rbacService.SP_ROLE_HELPDESK_BITMASK) {
      return SP_ROLE_HELPDESK;
    } else if (role & this.rbacService.SUBS_ROLE_ADMIN_BITMASK) {
      return SUB_ROLE_ADMIN;
    } else if (role & this.rbacService.SUBS_ROLE_ANALYST_BITMASK) {
      return SUB_ROLE_ANALYST;
    } else if (role & this.rbacService.SUBS_ROLE_OBSERVER_BITMASK) {
      return SUB_ROLE_OBSERVER;
    }
    return '';
  }
  static {
    this.ɵfac = function GranularRBACService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GranularRBACService)(i0.ɵɵinject(SessionService), i0.ɵɵinject(RBACService), i0.ɵɵinject(JwtTokenInfoService), i0.ɵɵinject(i1.HttpClient));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GranularRBACService,
      factory: GranularRBACService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GranularRBACService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: SessionService
  }, {
    type: RBACService
  }, {
    type: JwtTokenInfoService
  }, {
    type: i1.HttpClient
  }], null);
})();
class AccountManagementService {
  constructor(sessionService, featureToggleService, wgBaseService, activatedRoute, http, router, corService, jwtTokenService) {
    this.sessionService = sessionService;
    this.featureToggleService = featureToggleService;
    this.wgBaseService = wgBaseService;
    this.activatedRoute = activatedRoute;
    this.http = http;
    this.router = router;
    this.corService = corService;
    this.jwtTokenService = jwtTokenService;
    this.setAccountContextUrl = 'loginmw/SetAccountContext';
    this.accountContextIdCache = {};
    this.headerAccountNameSubject = new BehaviorSubject({
      accountName: '',
      accountID: ''
    });
    this.hasFirewanSettings = new BehaviorSubject(false);
    this.selectedAccountIdSubject = new BehaviorSubject(this.wgBaseService.getAccountId());
    this.tenantAccountIdSubject = new BehaviorSubject('');
    this.router.events.pipe(filter(event => event instanceof NavigationEnd), filter(event => /\/sp\/subscriber/.test(event.url) || /\/ss-tenant/.test(event.url) || /\/sp-tenant/.test(event.url)), switchMap(() => this.getLatestRouteParams().pipe(first$1()))).subscribe(params => {
      if (this.wgBaseService.getAccountId() && !params.account_id) {
        this.setAccountId('');
      } else if (params.account_id) {
        if (this.pageReloaded === undefined) {
          this.tenantAccountIdSubject.next(params.account_id);
          this.pageReloaded = false;
        } else {
          this.setAccountId(params.account_id);
        }
      }
    });
  }
  /**
   * This is need when using ActivatedRoute on a service
   * because when using it on a component Angular inject this object when the component is loaded
   * and for services it's injected when the service is created
   * so we need to get the latest ActivatedRoute manually
   */
  getLatestRouteParams() {
    let route = this.activatedRoute;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.params;
  }
  setAccountId(accountId) {
    this.cacheAccountId(accountId);
    this.selectedAccountIdSubject.next(accountId);
  }
  /**
   * Returns an observable with the cached accountId or the accountId from the session
   *
   * Use this function to get the current account id
   *
   * @returns Observable<string>
   */
  getAccountId() {
    if (this.wgBaseService.getAccountId()) {
      return of(this.wgBaseService.getAccountId());
    } else if (/\/sp\/subscriber/.test(location.pathname)) {
      // Check if it's on Subscriber view, if so retrieve the accountId manually from the URL.
      // It's needed when you access the Subscriber account directly (by pasting the URL)
      // Because the accountId will be only updated with the subscriber account after NavigateEnd
      // which happens after the ResolveStart
      const accountId = this.extractAccountId(location.pathname);
      this.cacheAccountId(accountId);
      return of(accountId);
    } else if (/\/sp-tenant/.test(location.pathname)) {
      // Check if it's on Subscriber view, if so retrieve the accountId manually from the URL.
      // It's needed when you access the Subscriber account directly (by pasting the URL)
      // Because the accountId will be only updated with the subscriber account after NavigateEnd
      // which happens after the ResolveStart
      // Checking for sp and ss tenant.
      // NOTE THIS WILL BE CLEANED UP AFTER SP NAV IS COMPLETED
      const accountId = this.extractSpAccountId(false, location.pathname);
      this.cacheAccountId(accountId);
      return of(accountId);
    } else if (/\/ss-tenant/.test(location.pathname)) {
      // Check if it's on Subscriber view, if so retrieve the accountId manually from the URL.
      // It's needed when you access the Subscriber account directly (by pasting the URL)
      // Because the accountId will be only updated with the subscriber account after NavigateEnd
      // which happens after the ResolveStart
      // Checking for sp and ss tenant.
      // NOTE THIS WILL BE CLEANED UP AFTER SP NAV IS COMPLETED
      const accountId = this.extractSpAccountId(true, location.pathname);
      this.cacheAccountId(accountId);
      return of(accountId);
    } else {
      return this.sessionService.getSessionInfo().pipe(map(({
        pri_account_id
      }) => {
        if (!this.wgBaseService.getAccountId()) {
          // Cache the pri_account_id only if the accountId is still empty
          // It avoids the accountId be replaced when the the setAccountId is called after the getAccountId
          this.cacheAccountId(pri_account_id);
        }
        return this.wgBaseService.getAccountId();
      }));
    }
  }
  extractAccountId(url) {
    const splitedURL = /sp\/subscriber\/\w+\/([\w-\._]+)\//.exec(url);
    return splitedURL && splitedURL[1];
  }
  extractSpAccountId(ssTenant, url) {
    let splitedURL = /ss-tenant\/\w+\/([\w-\._]+)\//.exec(url);
    if (ssTenant) {
      splitedURL = /sp-tenant\/\w+\/([\w-\._]+)\//.exec(url);
    }
    return splitedURL && splitedURL[1];
  }
  cacheAccountId(accountId) {
    this.wgBaseService.setAccountId(accountId);
  }
  changeUrlAccountId(currentAccountId, newAccountId) {
    // skip if it is the new SP nav
    const url = this.router.url;
    if (url.startsWith('/sp-overview/') || url.startsWith('/sp-tenant/') || url.startsWith('/ss-tenant')) {
      return;
    }
    if (currentAccountId !== newAccountId) {
      this.router.navigateByUrl(this.replaceOldAccountId(currentAccountId, newAccountId));
    }
  }
  /**
   * This method is used to change the accountId from the URL
   * when logged with a Service Provider and managing a Subscriber
   *
   * @param string currentAccountId account Id that was being managed
   * @param string newAccountId account id that will be managed
   *
   */
  replaceOldAccountId(currentAccountId, newAccountId) {
    // replace the currentAccount Id only if it exists
    // else just return the current url (that way user can navigate using
    // browser's back / forward buttons without loosing the header bar when in tenant view)
    if (/\/sp\/subscriber/.test(this.router.url) && !currentAccountId) {
      return this.router.url;
    }
    // Checking for sp and ss tenant.
    // NOTE THIS WILL BE CLEANED UP AFTER SP NAV IS COMPLETED
    if (/\/sp-tenant/.test(this.router.url) && !currentAccountId) {
      return this.router.url;
    }
    if (/\/ss-tenant/.test(this.router.url) && !currentAccountId) {
      return this.router.url;
    }
    return this.router.url.split('/').map((value, index) => {
      if (value === currentAccountId) {
        value = newAccountId;
      }
      return value;
    }).join('/');
  }
  /**
   * Returns the current context ID.
   *
   * @returns string The context ID.
   */
  getCurrentContextId() {
    return this.currentAccountContextId;
  }
  /**
   * Synchronous method for getting currently cached account context ID.
   * You should call setAccountContextId() before calling this method to cache the context.
   *
   * @param string targetAccountId
   * @returns string The context ID.
   */
  getAccountContextId(targetAccountId) {
    return this.accountContextIdCache[targetAccountId] || '';
  }
  /**
   * Returns an observable containing the account context ID. Will also update the cache if needed.
   *
   * If we already have the targetAccountId in cache, will not make API call.
   *
   * You can optionally provide the context ID to set if you have one.
   *
   * @param string targetAccountId
   * @param string contextId
   * @returns Observable<string> Observable containing the context ID.
   */
  setAccountContextId(targetAccountId, contextId) {
    let contextObservable;
    if (contextId !== undefined) {
      this.accountContextIdCache[targetAccountId] = contextId;
      this.currentAccountContextId = contextId;
      contextObservable = of(contextId);
    } else {
      if (this.accountContextIdCache[targetAccountId] !== undefined) {
        this.currentAccountContextId = this.accountContextIdCache[targetAccountId];
        contextObservable = of(this.accountContextIdCache[targetAccountId]);
      } else {
        if (this.activeAccountId !== targetAccountId) {
          this.contextObs = null;
        }
        if (this.contextObs) {
          return this.contextObs;
        }
        this.activeAccountId = targetAccountId;
        this.contextObs = this.setContext(targetAccountId);
        contextObservable = this.contextObs;
      }
    }
    return contextObservable;
  }
  setContext(targetAccountId) {
    const body = {
      target_account: targetAccountId
    };
    const url = newGuardUrl({
      service: 'platform'
    }) + this.setAccountContextUrl;
    const contextIdObs = this.http.post(url, body).pipe(tap(data => {
      if (data && data.hasOwnProperty('context_id')) {
        this.accountContextIdCache[targetAccountId] = data.context_id;
        this.currentAccountContextId = data.context_id;
      } else {
        this.currentAccountContextId = '';
      }
      if (data && data.hasOwnProperty('account_preferences')) {
        if (data.account_preferences.hasOwnProperty('beta')) {
          this.featureToggleService.populateFeatureCache(targetAccountId, data.account_preferences.beta);
        } else {
          console.error('No beta information.');
        }
      } else {
        console.error('No account_preferences information.');
      }
    }), map(data => {
      // Map to only the string value
      if (data && data.hasOwnProperty('context_id')) {
        return data.context_id;
      } else {
        return data;
      }
    }), share());
    let acntContextId = '';
    return contextIdObs.pipe(switchMap(data => {
      acntContextId = data;
      // always save the role_policy of drilldown in jwtToken cache
      return of(true);
    }), switchMap(getDrilldownJwtToken => {
      let apiToGetJwt = of(false);
      if (getDrilldownJwtToken && targetAccountId && !this.jwtTokenService.getJwtToken(targetAccountId)) {
        apiToGetJwt = this.sessionService.getSessionInfoNonCache();
      }
      return apiToGetJwt;
    }), switchMap(getSessionInfoNonCache => {
      if (getSessionInfoNonCache) {
        if (targetAccountId !== this.sessionService?.sessionInfo?.pri_account_id) {
          if (getSessionInfoNonCache?.role_policy) {
            this.jwtTokenService.populateCache(targetAccountId, getSessionInfoNonCache?.role_policy);
          }
        }
      }
      return of(acntContextId);
    }));
  }
  /**
   * Call this method when you want to clean up the cache (WCD-2741)
   * @param targetAccountId delegator account ID that needs to be removed from cache
   */
  removeAccountFromContextIdCache(targetAccountId) {
    if (this.accountContextIdCache && this.accountContextIdCache.hasOwnProperty(targetAccountId)) {
      // this.activeAccountId = ''; commented out because it causes duplicate calls to SetAccountContextId
      delete this.accountContextIdCache[targetAccountId];
    }
  }
  static {
    this.ɵfac = function AccountManagementService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AccountManagementService)(i0.ɵɵinject(SessionService), i0.ɵɵinject(WgFeatureToggleService), i0.ɵɵinject(WgBaseService), i0.ɵɵinject(i2$1.ActivatedRoute), i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2$1.Router), i0.ɵɵinject(GranularRBACService), i0.ɵɵinject(JwtTokenInfoService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AccountManagementService,
      factory: AccountManagementService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccountManagementService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: SessionService
  }, {
    type: WgFeatureToggleService
  }, {
    type: WgBaseService
  }, {
    type: i2$1.ActivatedRoute
  }, {
    type: i1.HttpClient
  }, {
    type: i2$1.Router
  }, {
    type: GranularRBACService
  }, {
    type: JwtTokenInfoService
  }], null);
})();
class AccountManagementModule {
  static {
    this.ɵfac = function AccountManagementModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AccountManagementModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: AccountManagementModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [AccountManagementService],
      imports: [WgSessionModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccountManagementModule, [{
    type: NgModule,
    args: [{
      imports: [WgSessionModule],
      providers: [AccountManagementService]
    }]
  }], null, null);
})();
class WgCalendarInfoModule {
  static {
    this.ɵfac = function WgCalendarInfoModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgCalendarInfoModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgCalendarInfoModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgCalendarInfoModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: []
    }]
  }], null, null);
})();

/**
 * A service that stores calendar preset info for a specific app
 * app can be logs or reports or notification/alerts
 *
 * Eg:
 * To make date selection presets for reports across, reports dashboard and reports side nav call setCalendarInfo
 * and pass in type='reports'
 * and calendarData {start:Date, end:date, userPresetSelection:number}
 *
 * When user switches between Dashboard report and report side nav call getCalendarInfo for type='reports'
 * and use that userPresetSelection to update wg-datetime-picker component accordingly.
 *
 */
class WgCalendarInfoService {
  constructor() {
    this.buildReportSideNavSubject = new BehaviorSubject(undefined);
  }
  setCalendarInfo(type, calendarData) {
    if (!this.dateObj) {
      this.dateObj = {};
    }
    this.dateObj[type] = calendarData;
  }
  getCalendarInfo(type) {
    if (this.dateObj && this.dateObj.hasOwnProperty(type)) {
      return this.dateObj[type];
    }
  }
  reBuildReportsSideNav(serviceData) {
    this.buildReportSideNavSubject.next(serviceData);
  }
  static {
    this.ɵfac = function WgCalendarInfoService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgCalendarInfoService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: WgCalendarInfoService,
      factory: WgCalendarInfoService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgCalendarInfoService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
var CALENDAR_PRESETS;
(function (CALENDAR_PRESETS) {
  CALENDAR_PRESETS[CALENDAR_PRESETS["TODAY"] = 0] = "TODAY";
  CALENDAR_PRESETS[CALENDAR_PRESETS["YESTERDAY"] = 1] = "YESTERDAY";
  CALENDAR_PRESETS[CALENDAR_PRESETS["LAST_24_HOURS"] = 2] = "LAST_24_HOURS";
  CALENDAR_PRESETS[CALENDAR_PRESETS["LAST_7_DAYS"] = 3] = "LAST_7_DAYS";
  CALENDAR_PRESETS[CALENDAR_PRESETS["LAST_14_DAYS"] = 4] = "LAST_14_DAYS";
  CALENDAR_PRESETS[CALENDAR_PRESETS["THIS_MONTH"] = 5] = "THIS_MONTH";
  CALENDAR_PRESETS[CALENDAR_PRESETS["LAST_MONTH"] = 6] = "LAST_MONTH";
  CALENDAR_PRESETS[CALENDAR_PRESETS["CUSTOM"] = 7] = "CUSTOM";
})(CALENDAR_PRESETS || (CALENDAR_PRESETS = {}));
;
const WIFI = 'WiFi';
const AUTHPOINT_LICENSES = [AUTHPOINT, AUTHPOINT_TRIAL, AUTHPOINT_NFR, AUTHPOINT_OVERAGE];
const AUTH_LICENSES = [AUTHPOINT, AUTHPOINT_TRIAL, AUTHPOINT_NFR, AUTHPOINT_OVERAGE, AUTHPOINT_TIS, AUTHPOINT_TIS_TRIAL, AUTHPOINT_TIS_NFR, AUTHPOINT_TIS_OVERAGE];
const FIREBOX_LICENSES = [FIREBOX, FIREBOX_DRL];
const HOST_SENSOR_LICENSES = [HOST_SENSOR];
const ACCESS_POINT_LICENSES = [ACCESS_POINT];
const WESS_LICENSES = [WESS_EPP, WESS_EPP_TRIAL, WESS_EPP_NFR, WESS_AD, WESS_AD_TRIAL, WESS_AD_NFR, WESS_AD360, WESS_AD360_TRIAL, WESS_AD360_NFR, WESS_AEPDR, WESS_AEPDR_TRIAL, WESS_AEPDR_NFR, WESS_EDR_CORE, WESS_EDR_CORE_NFR, WESS_AEDPR_OVERAGE, WESS_AD360_OVERAGE, WESS_AD_OVERAGE, WESS_EPP_OVERAGE, WESS_MODULE_ART, WESS_MODULE_ART_NFR, WESS_MODULE_FE, WESS_MODULE_FE_NFR, WESS_MODULE_PM, WESS_MODULE_PM_NFR, WESS_MODULE_DC, WESS_MODULE_DC_NFR, WESS_MODULE_SF, WESS_MODULE_SF_NFR, WESS_MODULE_MDR, WESS_MODULE_MDR_NFR, WESS_MODULE_Orion, WESS_MODULE_Orion_NFR];
const DNS_WATCH_LICENSES = [DNS_WATCH];
const FIREWAN_LICENSES = [FIREWAN, FIREWAN_TRIAL, FIREWAN_NFR, FIREWAN_OVERAGE];
const NDR_LICENSES = [NDR_NDR, NDR_NDR_TRIAL, NDR_NDR_NFR, NDR_NDR_OVERAGE];
const TSP_LICENSES = [TSP_SDR, TSP_SDR_TRIAL, TSP_SDR_NFR, TSP_SDR_OVERAGE];
const CMPL_LICENSES = [CMPL_REPORT, CMPL_REPORT_TRIAL, CMPL_REPORT_NFR, CMPL_REPORT_OVERAGE];
const THREATSYNC_LICENSES = [THREATSYNC];
const WGMDR_LICENSES = [MDR_DEF, MDR_DEF_NFR, MDR_DEF_OVERAGE, MDR_TOTAL, MDR_TOTAL_NFR, MDR_TOTAL_OVERAGE];
const TXDR_LICENSES = [TSP_TXDR, TSP_TXDR_NFR, TSP_TXDR_OVERAGE];
const TSPLUS_LICENSES = [NDR_NDR, NDR_NDR_TRIAL, NDR_NDR_NFR, NDR_NDR_OVERAGE, TSP_SDR, TSP_SDR_TRIAL, TSP_SDR_NFR, TSP_SDR_OVERAGE, CMPL_REPORT, CMPL_REPORT_TRIAL, CMPL_REPORT_NFR, CMPL_REPORT_OVERAGE, TSP_TXDR, TSP_TXDR_NFR, TSP_TXDR_OVERAGE];
const ALL_SERVICES = [AUTHPOINT, AUTH, HOST_SENSOR, FIREBOX, WIFI, ACCESS_POINT, WESS, DNS_WATCH, FIREWAN, NDR, CMPL, THREATSYNC, TSP, WGMDR, TXDR, TSPLUS];
const DEF_LIC_DATA = {
  expiry_date: '',
  status: 'none',
  hasLicense: false
};
const AUTHPOINT_GENERAL_SETTINGS_BASE_URL = newGuardUrl({
  service: 'aaas/settings/v1/accounts/:accountId/license',
  region: 'usa'
}).replace(/\/$/, '');
class LicenseManagementService {
  constructor(http, accountInfoService) {
    this.http = http;
    this.accountInfoService = accountInfoService;
    this.licenseStatusUrl = 'allocation-query-mw/GetLicenseStatus';
    this.cachedAcntIdLicInfo = {};
    this.licenseInfoObservables = {};
    this.headers = new HttpHeaders().set('Content-Type', 'application/json');
    this.licenseCacheSubject = new BehaviorSubject(false);
    this.licenseCache$ = this.licenseCacheSubject.asObservable();
  }
  getLicenseInfo(accountID, serviceName, parentID, changeAcntTypeInSubsView = true, accountType) {
    let tmpAcntType = accountType;
    let tmpAcntID = accountID;
    // WESS-817 applicable when an SP has logged in and select their
    // built in account or a tenant's built in account where account ID is same but
    // we need to indicate if user is looking at SP vs builtin account
    // subscriberView is set from unfied app's app.component before this method is invoked
    if (changeAcntTypeInSubsView && this.subscriberView && tmpAcntType !== 2) {
      tmpAcntType = 2;
      tmpAcntID = tmpAcntID + '_2';
    }
    if (!this.licenseInfoObservables) {
      this.licenseInfoObservables = {};
    }
    if (this.cachedAcntIdLicInfo && this.cachedAcntIdLicInfo.hasOwnProperty(tmpAcntID)) {
      // if accountID is in cache return it as Observable
      return this.getLicInfoFromCache(tmpAcntID, serviceName);
    } else if (this.licenseInfoObservables[tmpAcntID]) {
      // if this.licenseInfoObservable is set then
      // the request is in progress return the `Observable`
      // for the ongoing request
      return this.licenseInfoObservables[tmpAcntID];
    } else {
      let httpParams = new HttpParams();
      httpParams = httpParams.set('owner_id', accountID).set('parent_id', parentID);
      if (tmpAcntType) {
        httpParams = httpParams.set('account_type', String(tmpAcntType));
      }
      this.licenseInfoObservables[tmpAcntID] = this.http.get(this.getURL('platform', 'allocation-query-mw') + this.licenseStatusUrl, {
        headers: this.headers,
        params: httpParams
      }).pipe(map(serviceInfo => {
        if (serviceInfo.errors) {
          console.debug(`Could not retrieve license info for ${accountID} (${serviceName}): ${serviceInfo.errors[0].message}`);
          return this.getDefaults();
        } else {
          const serviceInfos = serviceInfo;
          if (!serviceInfos.hasOwnProperty(FIREWAN)) {
            serviceInfos[FIREWAN] = DEF_LIC_DATA;
          }
          // tslint:disable-next-line:forin
          for (const info in serviceInfos) {
            const licInfo = serviceInfos[info];
            licInfo.hasLicense = this.serviceHasLicense(serviceName, licInfo);
          }
          const licData = this.getLicenseByService(serviceInfo, serviceName);
          this.addLicInfoToCache(tmpAcntID, serviceInfo);
          return serviceInfo;
        }
      }), share() // If multiple subs on this HTTP, share the result to avoid multiple calls
      );
      return this.licenseInfoObservables[tmpAcntID];
    }
  }
  accountHasLicense(accountID, parentID, serviceName) {
    return this.getLicenseInfo(accountID, serviceName, parentID).pipe(map(info => {
      // check all licenses
      let hasLicense = false;
      if (serviceName === AUTHPOINT) {
        AUTHPOINT_LICENSES.forEach(license => {
          if (info && info[license] && info[license].hasLicense) {
            hasLicense = true;
          }
        });
      } else if (serviceName === AUTH) {
        AUTH_LICENSES.forEach(license => {
          if (info && info[license] && info[license].hasLicense) {
            hasLicense = true;
          }
        });
      } else if (serviceName === FIREBOX) {
        FIREBOX_LICENSES.forEach(license => {
          if (info && info[license] && info[license].hasLicense) {
            hasLicense = true;
          }
        });
      } else if (serviceName === HOST_SENSOR) {
        HOST_SENSOR_LICENSES.forEach(license => {
          if (info && info[license] && info[license].hasLicense) {
            hasLicense = true;
          }
        });
      } else if (serviceName === ACCESS_POINT) {
        ACCESS_POINT_LICENSES.forEach(license => {
          if (info && info[license] && info[license].hasLicense) {
            hasLicense = true;
          }
        });
      } else if (serviceName === WESS) {
        WESS_LICENSES.forEach(license => {
          if (info && info[license] && info[license].hasLicense) {
            hasLicense = true;
          }
        });
      } else if (serviceName === DNS_WATCH) {
        DNS_WATCH_LICENSES.forEach(license => {
          if (info && info[license] && info[license].hasLicense) {
            hasLicense = true;
          }
        });
      } else if (serviceName === FIREWAN) {
        FIREWAN_LICENSES.forEach(license => {
          if (info && info[license] && info[license].hasLicense) {
            hasLicense = true;
          }
        });
      } else if (serviceName === NDR) {
        NDR_LICENSES.forEach(license => {
          if (info && info[license] && info[license].hasLicense) {
            hasLicense = true;
          }
        });
      } else if (serviceName === CMPL) {
        CMPL_LICENSES.forEach(license => {
          if (info && info[license] && info[license].hasLicense) {
            hasLicense = true;
          }
        });
      } else if (serviceName === THREATSYNC) {
        THREATSYNC_LICENSES.forEach(license => {
          if (info && info[license] && info[license].hasLicense) {
            hasLicense = true;
          }
        });
      } else if (serviceName === TSP) {
        TSP_LICENSES.forEach(license => {
          if (info && info[license] && info[license].hasLicense) {
            hasLicense = true;
          }
        });
      } else if (serviceName === WGMDR) {
        WGMDR_LICENSES.forEach(license => {
          if (info && info[license] && info[license].hasLicense) {
            hasLicense = true;
          }
        });
      } else if (serviceName === TXDR) {
        TXDR_LICENSES.forEach(license => {
          if (info && info[license] && info[license].hasLicense) {
            hasLicense = true;
          }
        });
      } else if (serviceName === TSPLUS) {
        TSPLUS_LICENSES.forEach(license => {
          if (info && info[license] && info[license].hasLicense) {
            hasLicense = true;
          }
        });
      }
      return hasLicense;
    }), catchError(() => of(false)));
  }
  removeLicenseInfoFromCache(accountID) {
    if (this.cachedAcntIdLicInfo.hasOwnProperty(accountID)) {
      delete this.cachedAcntIdLicInfo[accountID];
    }
    if (this.cachedAcntIdLicInfo.hasOwnProperty(accountID + '_2')) {
      delete this.cachedAcntIdLicInfo[accountID + '_2'];
    }
  }
  /**
   *  For the passed in account ID, check if it has license
   *  for the passed in service. (Authpoint, dimension, tdr ) etc
   *  see
   *
   *  For productType is used for WESS and WGMDR service. The productType for
   *  WESS can be WESS product types like WESS_EPP, WESS_EPP_TRIAL, WESS_AD, WESS_AD_360, etc and
   *  for WGMDR it can be MDR_DEF, MDR_TOTAL, etc.
   *
   *   /wg-license-management/license-model.ts
   *
   *   Since the license API requires account type, we
   *   first call the getAccountInfo API
   *   then switch to the API we want getLicenseInfo
   *   finally we "piggy back" on our helper function serviceHasLicense
   *   to return an boolean Observable.
   */
  hasLicense(acntID, service, changeAcntTypeInSubsView = true, productType) {
    return this.accountInfoService.getAccountInfo(acntID).pipe(
    // tap((acntInfo: any) => console.log('AcntInfo: ', acntInfo)),
    switchMap(acntInfo => this.getLicenseInfo(acntID, service, 'parentID', changeAcntTypeInSubsView, acntInfo.type)),
    // tap((licInfo: any) => console.log('LicenseInfo: ', licInfo)),
    switchMap(licInfo => of(serviceHasLicense(service, licInfo, productType))) // , tap((resp: boolean) => console.log('Has License: ', resp))
    );
  }
  /**
   *  Filter out the the children menu items of an nav object based on licenses.
   *  The check is based on their corresponding values specified in the json files in
   *  assets/(dev|qa|staging|prod) of the Static libarary.
   *
   *  The filtering is done at most 2 levels
   *  - children of the top level
   *  - children of the children of the top level
   *  - children of the top_nav_children of the top level
   *
   *  Note: the function will not alter the navData. The result will be returned.
   */
  filterNavDataBasedOnLicense(acntID, origNavData) {
    if (!acntID) {
      console.debug('The acntID does not contain value in filterNavDataBasedOnLicense();');
      return origNavData;
    }
    const navData = JSON.parse(JSON.stringify(origNavData));
    if (navData.hasOwnProperty('children')) {
      const filteredChildren = navData.children.filter(item => {
        return this.checkItemLicense(acntID, item);
      });
      navData.children = filteredChildren;
      for (const child of navData.children) {
        if (child.hasOwnProperty('children')) {
          const filtered = child.children.filter(item => {
            return this.checkItemLicense(acntID, item);
          });
          child.children = filtered;
        }
      }
    }
    if (navData.hasOwnProperty('top_nav_children')) {
      for (const topNav of navData.top_nav_children) {
        if (topNav.hasOwnProperty('children')) {
          const filteredChildren = topNav.children.filter(item => {
            return this.checkItemLicense(acntID, item);
          });
          topNav.children = filteredChildren;
        }
      }
      // keep only top nav that contains at least one entry
      navData.top_nav_children = navData.top_nav_children.filter(topNav => {
        return topNav.children.length > 0;
      });
    }
    return navData;
  }
  /**
   * Inspect the dynamic widget or menu item object defined in json files (in Static) and
   * return true to keep and false to remove.
   *
   * Criteria:
   * - Search item for licenses fields. If either does not exist, return true to keep.
   */
  checkItemLicense(acntID, item) {
    const hasLicenses = item.hasOwnProperty('licenses') && item.licenses.length > 0;
    const hasLicensesOnData = item.hasOwnProperty('data') && item.data.hasOwnProperty('licenses') && item.data.licenses.length > 0;
    if (!acntID) {
      console.debug('The acntID does not contain value in checkItemLicense().');
      return !(hasLicenses || hasLicensesOnData);
    }
    const tmpAcntID = acntID + '_2';
    if (!this.cachedAcntIdLicInfo.hasOwnProperty(acntID)) {
      if (this.cachedAcntIdLicInfo.hasOwnProperty(tmpAcntID)) {
        acntID = tmpAcntID;
      } else {
        console.debug(`License info cache does not contain information of the acntID: ${acntID}`);
        return !(hasLicenses || hasLicensesOnData);
      }
    }
    if (hasLicenses || hasLicensesOnData) {
      const licenses = hasLicenses ? item.licenses : item.data.licenses;
      return licenses.some(license => this.cachedAcntIdLicInfo[acntID].hasOwnProperty(license) && this.cachedAcntIdLicInfo[acntID][license].hasLicense && this.cachedAcntIdLicInfo[acntID][license].status === 'valid');
    } else {
      return true; // the widget does not have licenses to check, return true.
    }
  }
  // -------------------------- Private methods ----------------------------------
  getDefaults() {
    const info = {};
    ALL_SERVICES.forEach(serviceName => {
      if (serviceName === AUTHPOINT) {
        info[AUTHPOINT] = DEF_LIC_DATA;
        info[AUTHPOINT_TRIAL] = DEF_LIC_DATA;
        info[AUTHPOINT_NFR] = DEF_LIC_DATA;
        info[AUTHPOINT_OVERAGE] = DEF_LIC_DATA;
      } else if (serviceName === AUTH) {
        info[AUTHPOINT] = DEF_LIC_DATA;
        info[AUTHPOINT_TRIAL] = DEF_LIC_DATA;
        info[AUTHPOINT_NFR] = DEF_LIC_DATA;
        info[AUTHPOINT_OVERAGE] = DEF_LIC_DATA;
        info[AUTHPOINT_TIS] = DEF_LIC_DATA;
        info[AUTHPOINT_TIS_TRIAL] = DEF_LIC_DATA;
        info[AUTHPOINT_TIS_NFR] = DEF_LIC_DATA;
        info[AUTHPOINT_TIS_OVERAGE] = DEF_LIC_DATA;
      } else if (serviceName === FIREBOX) {
        info[FIREBOX] = DEF_LIC_DATA;
        info[FIREBOX_DRL] = DEF_LIC_DATA;
      } else if (serviceName === HOST_SENSOR) {
        info[HOST_SENSOR] = DEF_LIC_DATA;
      } else if (serviceName === ACCESS_POINT) {
        info[ACCESS_POINT] = DEF_LIC_DATA;
      } else if (serviceName === WESS) {
        info[WESS_EPP] = DEF_LIC_DATA;
        info[WESS_EPP_TRIAL] = DEF_LIC_DATA;
        info[WESS_EPP_NFR] = DEF_LIC_DATA;
        info[WESS_AD] = DEF_LIC_DATA;
        info[WESS_AD_TRIAL] = DEF_LIC_DATA;
        info[WESS_AD_NFR] = DEF_LIC_DATA;
        info[WESS_AD360] = DEF_LIC_DATA;
        info[WESS_AD360_TRIAL] = DEF_LIC_DATA;
        info[WESS_AD360_NFR] = DEF_LIC_DATA;
        info[WESS_AEPDR] = DEF_LIC_DATA;
        info[WESS_AEPDR_TRIAL] = DEF_LIC_DATA;
        info[WESS_AEPDR_NFR] = DEF_LIC_DATA;
        info[WESS_EDR_CORE] = DEF_LIC_DATA;
        info[WESS_AD_OVERAGE] = DEF_LIC_DATA;
        info[WESS_AD360_OVERAGE] = DEF_LIC_DATA;
        info[WESS_AEDPR_OVERAGE] = DEF_LIC_DATA;
        info[WESS_EPP_OVERAGE] = DEF_LIC_DATA;
        info[WESS_EDR_CORE_NFR] = DEF_LIC_DATA;
        info[WESS_MODULE_ART] = DEF_LIC_DATA;
        info[WESS_MODULE_ART_NFR] = DEF_LIC_DATA;
        info[WESS_MODULE_DC] = DEF_LIC_DATA;
        info[WESS_MODULE_DC_NFR] = DEF_LIC_DATA;
        info[WESS_MODULE_FE] = DEF_LIC_DATA;
        info[WESS_MODULE_FE_NFR] = DEF_LIC_DATA;
        info[WESS_MODULE_PM] = DEF_LIC_DATA;
        info[WESS_MODULE_PM_NFR] = DEF_LIC_DATA;
        info[WESS_MODULE_SF] = DEF_LIC_DATA;
        info[WESS_MODULE_SF_NFR] = DEF_LIC_DATA;
        info[WESS_MODULE_MDR] = DEF_LIC_DATA;
        info[WESS_MODULE_MDR_NFR] = DEF_LIC_DATA;
        info[WESS_MODULE_Orion] = DEF_LIC_DATA;
        info[WESS_MODULE_Orion_NFR] = DEF_LIC_DATA;
      } else if (serviceName === DNS_WATCH) {
        info[DNS_WATCH] = DEF_LIC_DATA;
      } else if (serviceName === FIREWAN) {
        info[FIREWAN] = DEF_LIC_DATA;
        info[FIREWAN_TRIAL] = DEF_LIC_DATA;
        info[FIREWAN_NFR] = DEF_LIC_DATA;
        info[FIREWAN_OVERAGE] = DEF_LIC_DATA;
      } else if (serviceName === NDR) {
        info[NDR_NDR] = DEF_LIC_DATA;
        info[NDR_NDR_TRIAL] = DEF_LIC_DATA;
        info[NDR_NDR_NFR] = DEF_LIC_DATA;
        info[NDR_NDR_OVERAGE] = DEF_LIC_DATA;
      } else if (serviceName === CMPL) {
        info[CMPL_REPORT] = DEF_LIC_DATA;
        info[CMPL_REPORT_TRIAL] = DEF_LIC_DATA;
        info[CMPL_REPORT_NFR] = DEF_LIC_DATA;
        info[CMPL_REPORT_OVERAGE] = DEF_LIC_DATA;
      } else if (serviceName === THREATSYNC) {
        info[THREATSYNC] = DEF_LIC_DATA;
      } else if (serviceName === TSP) {
        info[TSP_SDR] = DEF_LIC_DATA;
        info[TSP_SDR_TRIAL] = DEF_LIC_DATA;
        info[TSP_SDR_NFR] = DEF_LIC_DATA;
        info[TSP_SDR_OVERAGE] = DEF_LIC_DATA;
      } else if (serviceName === WGMDR) {
        info[MDR_DEF] = DEF_LIC_DATA;
        info[MDR_DEF_NFR] = DEF_LIC_DATA;
        info[MDR_DEF_OVERAGE] = DEF_LIC_DATA;
        info[MDR_TOTAL] = DEF_LIC_DATA;
        info[MDR_TOTAL_NFR] = DEF_LIC_DATA;
        info[MDR_TOTAL_OVERAGE] = DEF_LIC_DATA;
      } else if (serviceName === TXDR) {
        info[TSP_TXDR] = DEF_LIC_DATA;
        info[TSP_TXDR_NFR] = DEF_LIC_DATA;
        info[TSP_TXDR_OVERAGE] = DEF_LIC_DATA;
      } else if (serviceName === TSPLUS) {
        info[NDR_NDR] = DEF_LIC_DATA;
        info[NDR_NDR_TRIAL] = DEF_LIC_DATA;
        info[NDR_NDR_NFR] = DEF_LIC_DATA;
        info[NDR_NDR_OVERAGE] = DEF_LIC_DATA;
        info[CMPL_REPORT] = DEF_LIC_DATA;
        info[CMPL_REPORT_TRIAL] = DEF_LIC_DATA;
        info[CMPL_REPORT_NFR] = DEF_LIC_DATA;
        info[CMPL_REPORT_OVERAGE] = DEF_LIC_DATA;
        info[TSP_SDR] = DEF_LIC_DATA;
        info[TSP_SDR_TRIAL] = DEF_LIC_DATA;
        info[TSP_SDR_NFR] = DEF_LIC_DATA;
        info[TSP_SDR_OVERAGE] = DEF_LIC_DATA;
        info[TSP_TXDR] = DEF_LIC_DATA;
        info[TSP_TXDR_NFR] = DEF_LIC_DATA;
        info[TSP_TXDR_OVERAGE] = DEF_LIC_DATA;
      } else {
        info[serviceName] = DEF_LIC_DATA;
      }
    });
    return info;
  }
  addLicInfoToCache(accountID, licInfo) {
    this.cachedAcntIdLicInfo[accountID] = licInfo;
    // Successfully updated the cache, now notify the
    // subject so that listeners can subscribe and do the needful
    this.licenseCacheSubject.next(true);
  }
  getLicInfoFromCache(accountID, serviceName) {
    const licInfo = this.getLicenseByService(this.cachedAcntIdLicInfo[accountID], serviceName);
    return of(licInfo);
  }
  // Get license info directly from cache and return the info immediately.
  //
  // It should be called after GetLicenseInfo() is called for that account first.
  // Otherwise, the cache might not have the account information.
  getLicFromCacheDirect(accountID, serviceName, changeAcntTypeInSubsView = true, accountType) {
    let tmpAcntType = accountType;
    let tmpAcntID = accountID;
    if (changeAcntTypeInSubsView && this.subscriberView && tmpAcntType !== 2) {
      tmpAcntType = 2;
      tmpAcntID = tmpAcntID + '_2';
    }
    if (this.cachedAcntIdLicInfo && this.cachedAcntIdLicInfo.hasOwnProperty(tmpAcntID)) {
      return this.getLicenseByService(this.cachedAcntIdLicInfo[tmpAcntID], serviceName);
    } else {
      return {};
    }
  }
  getLicenseByService(licInfos, serviceName) {
    const info = {};
    switch (serviceName) {
      case AUTHPOINT:
        info[AUTHPOINT] = licInfos[AUTHPOINT];
        info[AUTHPOINT_TRIAL] = licInfos[AUTHPOINT_TRIAL];
        info[AUTHPOINT_NFR] = licInfos[AUTHPOINT_NFR];
        info[AUTHPOINT_OVERAGE] = licInfos[AUTHPOINT_OVERAGE];
        break;
      case AUTH:
        info[AUTHPOINT] = licInfos[AUTHPOINT];
        info[AUTHPOINT_TRIAL] = licInfos[AUTHPOINT_TRIAL];
        info[AUTHPOINT_NFR] = licInfos[AUTHPOINT_NFR];
        info[AUTHPOINT_OVERAGE] = licInfos[AUTHPOINT_OVERAGE];
        info[AUTHPOINT_TIS] = licInfos[AUTHPOINT_TIS];
        info[AUTHPOINT_TIS_TRIAL] = licInfos[AUTHPOINT_TIS_TRIAL];
        info[AUTHPOINT_TIS_NFR] = licInfos[AUTHPOINT_TIS_NFR];
        info[AUTHPOINT_TIS_OVERAGE] = licInfos[AUTHPOINT_TIS_OVERAGE];
        break;
      case HOST_SENSOR:
        info[HOST_SENSOR] = licInfos[HOST_SENSOR];
        break;
      case FIREBOX:
        info[FIREBOX] = licInfos[FIREBOX];
        info[FIREBOX_DRL] = licInfos[FIREBOX_DRL];
        break;
      case ACCESS_POINT:
        info[ACCESS_POINT] = licInfos[ACCESS_POINT];
        break;
      case WESS:
        info[WESS_EPP] = licInfos[WESS_EPP];
        info[WESS_EPP_TRIAL] = licInfos[WESS_EPP_TRIAL];
        info[WESS_EPP_NFR] = licInfos[WESS_EPP_NFR];
        info[WESS_AD] = licInfos[WESS_AD];
        info[WESS_AD_TRIAL] = licInfos[WESS_AD_TRIAL];
        info[WESS_AD_NFR] = licInfos[WESS_AD_NFR];
        info[WESS_AD360] = licInfos[WESS_AD360];
        info[WESS_AD360_TRIAL] = licInfos[WESS_AD360_TRIAL];
        info[WESS_AD360_NFR] = licInfos[WESS_AD360_NFR];
        info[WESS_AEPDR] = licInfos[WESS_AEPDR];
        info[WESS_AEPDR_TRIAL] = licInfos[WESS_AEPDR_TRIAL];
        info[WESS_AEPDR_NFR] = licInfos[WESS_AEPDR_NFR];
        info[WESS_EDR_CORE] = licInfos[WESS_EDR_CORE];
        info[WESS_EDR_CORE_NFR] = licInfos[WESS_EDR_CORE_NFR];
        info[WESS_AD_OVERAGE] = licInfos[WESS_AD_OVERAGE];
        info[WESS_AD360_OVERAGE] = licInfos[WESS_AD360_OVERAGE];
        info[WESS_EPP_OVERAGE] = licInfos[WESS_EPP_OVERAGE];
        info[WESS_AEDPR_OVERAGE] = licInfos[WESS_AEDPR_OVERAGE];
        info[WESS_MODULE_ART] = licInfos[WESS_MODULE_ART];
        info[WESS_MODULE_ART_NFR] = licInfos[WESS_MODULE_ART_NFR];
        info[WESS_MODULE_DC] = licInfos[WESS_MODULE_DC];
        info[WESS_MODULE_DC_NFR] = licInfos[WESS_MODULE_DC_NFR];
        info[WESS_MODULE_FE] = licInfos[WESS_MODULE_FE];
        info[WESS_MODULE_FE_NFR] = licInfos[WESS_MODULE_FE_NFR];
        info[WESS_MODULE_PM] = licInfos[WESS_MODULE_PM];
        info[WESS_MODULE_PM_NFR] = licInfos[WESS_MODULE_PM_NFR];
        info[WESS_MODULE_SF] = licInfos[WESS_MODULE_SF];
        info[WESS_MODULE_SF_NFR] = licInfos[WESS_MODULE_SF_NFR];
        info[WESS_MODULE_MDR] = licInfos[WESS_MODULE_MDR];
        info[WESS_MODULE_MDR_NFR] = licInfos[WESS_MODULE_MDR_NFR];
        info[WESS_MODULE_Orion] = licInfos[WESS_MODULE_Orion];
        info[WESS_MODULE_Orion_NFR] = licInfos[WESS_MODULE_Orion_NFR];
        break;
      case WIFI:
        info[WIFI] = licInfos[WIFI];
        break;
      case DNS_WATCH:
        info[DNS_WATCH] = licInfos[DNS_WATCH];
        break;
      case FIREWAN:
        info[FIREWAN] = licInfos[FIREWAN] || DEF_LIC_DATA;
        info[FIREWAN_TRIAL] = licInfos[FIREWAN_TRIAL] || DEF_LIC_DATA;
        info[FIREWAN_NFR] = licInfos[FIREWAN_NFR] || DEF_LIC_DATA;
        info[FIREWAN_OVERAGE] = licInfos[FIREWAN_OVERAGE] || DEF_LIC_DATA;
        break;
      case NDR:
        info[NDR_NDR] = licInfos[NDR_NDR] || DEF_LIC_DATA;
        info[NDR_NDR_TRIAL] = licInfos[NDR_NDR_TRIAL] || DEF_LIC_DATA;
        info[NDR_NDR_NFR] = licInfos[NDR_NDR_NFR] || DEF_LIC_DATA;
        info[NDR_NDR_OVERAGE] = licInfos[NDR_NDR_OVERAGE] || DEF_LIC_DATA;
        break;
      case CMPL:
        info[CMPL_REPORT] = licInfos[CMPL_REPORT] || DEF_LIC_DATA;
        info[CMPL_REPORT_TRIAL] = licInfos[CMPL_REPORT_TRIAL] || DEF_LIC_DATA;
        info[CMPL_REPORT_NFR] = licInfos[CMPL_REPORT_NFR] || DEF_LIC_DATA;
        info[CMPL_REPORT_OVERAGE] = licInfos[CMPL_REPORT_OVERAGE] || DEF_LIC_DATA;
        break;
      case TSP:
        info[TSP_SDR] = licInfos[TSP_SDR] || DEF_LIC_DATA;
        info[TSP_SDR_TRIAL] = licInfos[TSP_SDR_TRIAL] || DEF_LIC_DATA;
        info[TSP_SDR_NFR] = licInfos[TSP_SDR_NFR] || DEF_LIC_DATA;
        info[TSP_SDR_OVERAGE] = licInfos[TSP_SDR_OVERAGE] || DEF_LIC_DATA;
        break;
      case WGMDR:
        info[MDR_DEF] = licInfos[MDR_DEF] || DEF_LIC_DATA;
        info[MDR_DEF_NFR] = licInfos[MDR_DEF_NFR] || DEF_LIC_DATA;
        info[MDR_DEF_OVERAGE] = licInfos[MDR_DEF_OVERAGE] || DEF_LIC_DATA;
        info[MDR_TOTAL] = licInfos[MDR_TOTAL] || DEF_LIC_DATA;
        info[MDR_TOTAL_NFR] = licInfos[MDR_TOTAL_NFR] || DEF_LIC_DATA;
        info[MDR_TOTAL_OVERAGE] = licInfos[MDR_TOTAL_OVERAGE] || DEF_LIC_DATA;
        break;
      case TXDR:
        info[TSP_TXDR] = licInfos[TSP_TXDR] || DEF_LIC_DATA;
        info[TSP_TXDR_NFR] = licInfos[TSP_TXDR_NFR] || DEF_LIC_DATA;
        info[TSP_TXDR_OVERAGE] = licInfos[TSP_TXDR_OVERAGE] || DEF_LIC_DATA;
        break;
      case TSPLUS:
        info[NDR_NDR] = licInfos[NDR_NDR] || DEF_LIC_DATA;
        info[NDR_NDR_TRIAL] = licInfos[NDR_NDR_TRIAL] || DEF_LIC_DATA;
        info[NDR_NDR_NFR] = licInfos[NDR_NDR_NFR] || DEF_LIC_DATA;
        info[NDR_NDR_OVERAGE] = licInfos[NDR_NDR_OVERAGE] || DEF_LIC_DATA;
        info[CMPL_REPORT] = licInfos[CMPL_REPORT] || DEF_LIC_DATA;
        info[CMPL_REPORT_TRIAL] = licInfos[CMPL_REPORT_TRIAL] || DEF_LIC_DATA;
        info[CMPL_REPORT_NFR] = licInfos[CMPL_REPORT_NFR] || DEF_LIC_DATA;
        info[CMPL_REPORT_OVERAGE] = licInfos[CMPL_REPORT_OVERAGE] || DEF_LIC_DATA;
        info[TSP_SDR] = licInfos[TSP_SDR] || DEF_LIC_DATA;
        info[TSP_SDR_TRIAL] = licInfos[TSP_SDR_TRIAL] || DEF_LIC_DATA;
        info[TSP_SDR_NFR] = licInfos[TSP_SDR_NFR] || DEF_LIC_DATA;
        info[TSP_SDR_OVERAGE] = licInfos[TSP_SDR_OVERAGE] || DEF_LIC_DATA;
        info[TSP_TXDR] = licInfos[TSP_TXDR] || DEF_LIC_DATA;
        info[TSP_TXDR_NFR] = licInfos[TSP_TXDR_NFR] || DEF_LIC_DATA;
        info[TSP_TXDR_OVERAGE] = licInfos[TSP_TXDR_OVERAGE] || DEF_LIC_DATA;
        break;
      case THREATSYNC:
        info[THREATSYNC] = licInfos[THREATSYNC] || DEF_LIC_DATA;
        break;
      default:
        console.debug(`Unknown service ${serviceName}`);
        break;
    }
    return info;
  }
  serviceHasLicense(serviceName, licenseInfo) {
    let hasLicense = false;
    if (licenseInfo.status === 'valid') {
      hasLicense = true;
    } else if (licenseInfo.status === 'none') {
      hasLicense = false;
    } else {
      // For now if expired, still setting as true; TODO: RAHUL REVISIT
      hasLicense = true;
    }
    return hasLicense;
  }
  getURL(service, override = '') {
    const env = getEnv();
    const options = {
      service,
      region: 'usa',
      override
    };
    if (window.location.host.indexOf('watchguard.com') !== -1) {
      options.override = '';
    }
    return newGuardUrl(options);
  }
  static {
    this.ɵfac = function LicenseManagementService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LicenseManagementService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(WgAccountInfoService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LicenseManagementService,
      factory: LicenseManagementService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LicenseManagementService, [{
    type: Injectable
  }], () => [{
    type: i1.HttpClient
  }, {
    type: WgAccountInfoService
  }], null);
})();
class WgLicenseManagementModule {
  static {
    this.ɵfac = function WgLicenseManagementModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgLicenseManagementModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgLicenseManagementModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [LicenseManagementService]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgLicenseManagementModule, [{
    type: NgModule,
    args: [{
      imports: [],
      providers: [LicenseManagementService]
    }]
  }], null, null);
})();
class AuthPointLicenseManagementService {
  constructor(appService, featureToggleService, httpClient) {
    this.appService = appService;
    this.featureToggleService = featureToggleService;
    this.httpClient = httpClient;
  }
  /**
   * Validate if account has AuthPoint Password Only Internal license.
   *
   * This is an AuthPoint Internal (fake) license created when account does not have AuthPoint license (term and TIS) and have:
   * WatchGuard Cloud directory domain service or
   * Entra ID domain service and a sync created: Authentication Domains: Azure Active Directory beta.
   *
   * Success request means that the account has AuthPoint Password Only Internal License.
   * 404 error means that the account doesn't have AuthPoint Password Only Internal License.
   */
  hasPasswordOnlyLicense(accountId) {
    const url = `${AUTHPOINT_GENERAL_SETTINGS_BASE_URL.replace(':accountId', accountId)}/PASSWORD_ONLY_INTERNAL`;
    return this.httpClient.get(url).pipe(switchMap(() => of(true)), catchError(error => error.status === 404 ? of(false) : throwError(() => error)));
  }
  /**
   * Validate if account has the AuthPoint Password Only Internal license and beta enabled.
   * This function is used on unified app guard (auth-guard.service) to determine if route can be allowed.
   */
  shouldEnableItemNavigation(accountId, item) {
    if (!item['password_only_license'].value) {
      return of(false);
    }
    return this.hasPasswordOnlyLicense(accountId).pipe(switchMap(hasPasswordOnlyLicense => {
      if (!hasPasswordOnlyLicense) {
        return of(false);
      }
      const hasBetaBeatures = item['password_only_license'].features.length > 0;
      if (!hasBetaBeatures) {
        return of(true);
      }
      const isBetaEnabled = this.validateBetaFeatures(accountId, item['password_only_license'].features);
      return of(isBetaEnabled);
    }), catchError(() => of(false)));
  }
  /**
   *  Filter the children menu items of a nav object based on password_only_license.
   *  The check is based on their corresponding values specified in the json files in
   *  assets/(dev|qa|staging|prod) of the Static library.
   *
   *  The filtering is done at most 2 levels
   *  - children of the top level
   *  - children of the children of the top level
   *  - children of the top_nav_children of the top level
   *
   *  Note: the function will not alter the navData. The result will be returned.
   */
  filterNavDataBasedOnPasswordOnlyLicense(accountId, origNavData) {
    const navData = JSON.parse(JSON.stringify(origNavData));
    if (navData.hasOwnProperty('children')) {
      const filteredChildren = navData.children.filter(item => {
        return this.checkPasswordOnlyItemLicense(accountId, item);
      });
      navData.children = filteredChildren;
      for (const child of navData.children) {
        if (child.hasOwnProperty('children')) {
          const filtered = child.children.filter(item => {
            return this.checkPasswordOnlyItemLicense(accountId, item);
          });
          child.children = filtered;
        }
      }
    }
    if (navData.hasOwnProperty('top_nav_children')) {
      for (const topNav of navData.top_nav_children) {
        if (topNav.hasOwnProperty('children')) {
          const filteredChildren = topNav.children.filter(item => {
            return this.checkPasswordOnlyItemLicense(accountId, item);
          });
          topNav.children = filteredChildren;
        }
      }
      // keep only top nav that contains at least one entry
      navData.top_nav_children = navData.top_nav_children.filter(topNav => {
        return topNav.children.length > 0;
      });
    }
    return navData;
  }
  /**
   * Inspect the dynamic widget or menu item object defined in json files (in Static) and
   * return true to keep and false to remove.
   *
   * Criteria:
   * Search item for password_only_license field.
   * If item does not have password_only_license property, returns false.
   * If value is false, returns false.
   * If value is true and there are no beta features, returns true.
   * If value is true and there are beta features, returns the beta feature validation.
   */
  checkPasswordOnlyItemLicense(accountId, item) {
    const passwordOnlyLicenseOnItem = item.hasOwnProperty('password_only_license');
    const passwordOnlyLicenseOnData = item.hasOwnProperty('data') && item.data.hasOwnProperty('password_only_license');
    if (!passwordOnlyLicenseOnItem && !passwordOnlyLicenseOnData) {
      return false;
    }
    const passwordOnlyLicense = passwordOnlyLicenseOnItem ? item['password_only_license'] : item.data['password_only_license'];
    if (!passwordOnlyLicense['value']) {
      return false;
    }
    const hasBetaFeatures = passwordOnlyLicense.hasOwnProperty('features') && passwordOnlyLicense.features.length > 0;
    if (!hasBetaFeatures) {
      return true;
    }
    return this.validateBetaFeatures(accountId, passwordOnlyLicense.features);
  }
  /**
   *  Filter the AuthPoint children menu items that needs to be shown for AuthPoint Password Only Internal license.
   */
  loadAuthEndpointsUnderPasswordOnlyLicense() {
    return this.appService.loadAuthData().pipe(switchMap(items => {
      items = JSON.parse(JSON.stringify(items));
      return of(Object.values(items).filter(item => item['password_only_license'] && item['password_only_license'].value));
    }));
  }
  /**
   *  Return the endpoint based on route.
   */
  getAuthPointPasswordOnlyItem(items, state, id) {
    const endpoint = id ? state.url?.split(id)[1] : state.url;
    if (!endpoint.includes(AUTH.toLowerCase())) {
      return undefined;
    }
    return items?.find(item => endpoint?.includes(item.route));
  }
  /**
   *  Validate beta features.
   */
  validateBetaFeatures(accountId, features) {
    for (const feature of features) {
      if (feature.hasOwnProperty('applicationID') && feature.hasOwnProperty('featureID') && feature.hasOwnProperty('featureVersion')) {
        const isBetaEnabled = this.featureToggleService.allowFeature(accountId, feature.applicationID, feature.featureID, feature.featureVersion);
        if (isBetaEnabled) {
          return true;
        }
      }
    }
    return false;
  }
  static {
    this.ɵfac = function AuthPointLicenseManagementService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AuthPointLicenseManagementService)(i0.ɵɵinject(AppContentLoaderService), i0.ɵɵinject(WgFeatureToggleService), i0.ɵɵinject(i1.HttpClient));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AuthPointLicenseManagementService,
      factory: AuthPointLicenseManagementService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthPointLicenseManagementService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: AppContentLoaderService
  }, {
    type: WgFeatureToggleService
  }, {
    type: i1.HttpClient
  }], null);
})();

/**
 * Simple directive that takes in a service name and an accountID
 * and checks if the passed in account ID has license for that service or not.
 *
 * Also emits the licenseInfo object so that user can use that info if needed
 *   - (Useful when user has to show text like No license etc)
 *
 * If accountID has license the element that hosts the directive is shown
 * else it is hidden.
 *
 * Usage:
 *
 *     <div [wgcHasLicense]="'WiFi'"
 *          [accountID]="acntId1.value"
 *          (hasLicense)="hasLicense('WiFi', $event)">
 *       Wifi has license
 *     </div>
 *
 *    Pass in a string of permission you wnt to check
 *    and service (platform, AuthPoint, 'Host Sensor', Dimension, WiFi)
 */
class HasLicenseDirective {
  constructor(elementRef, licMgmtService, acntInfoService) {
    this.elementRef = elementRef;
    this.licMgmtService = licMgmtService;
    this.acntInfoService = acntInfoService;
    this.hasLicense = new EventEmitter();
  }
  ngOnChanges(change) {
    /**
     *  In wg-license-management.service code was added to
     *  share multiple subscriptions for the same http request
     *  to avoid multiple calls.
     *
     *  That will not work if user is in tenant view and changes
     *  account ID. In that case since the licenseInfoObservable is
     *  still active, changing accountID will result is still using the
     *  previous account ID
     *
     *  We want the benefit of sharing http calls when accountID is same
     *  and we also want a new observable when account ID changes
     *
     *  Hence using this approach of storing the currentValue of accountID
     *  in service and if anytime that value has changed then we know
     *  user changed the accountID, at which point nullify the observable
     *  so that we call the API again only one time, since subsequent calls
     *  for the same account ID will still have an active observable.
     */
    if (change.accountID && change.accountID.currentValue) {
      if (change.accountID.currentValue !== this.licMgmtService.prevAccountID) {
        this.licMgmtService.prevAccountID = change.accountID.currentValue;
        this.licMgmtService.licenseInfoObservables = {};
      }
      this._checkLicenseInfo();
    }
  }
  ngOnDestroy() {
    if (this.licenseObservable$) {
      this.licenseObservable$.unsubscribe();
    }
  }
  _checkLicenseInfo() {
    this.elementRef.nativeElement.style.display = 'none';
    this.licenseObservable$ = this.acntInfoService.getAccountInfo(this.accountID).pipe(switchMap(info => this.licMgmtService.getLicenseInfo(this.accountID, this.serviceName, info.parent.id, true, this.accountType))).subscribe(serviceInfo => {
      let hasLicense = false;
      if (this.serviceName === WESS) {
        hasLicense = serviceInfo[WESS_EPP] && serviceInfo[WESS_EPP].hasLicense || serviceInfo[WESS_EPP_TRIAL] && serviceInfo[WESS_EPP_TRIAL].hasLicense || serviceInfo[WESS_EPP_NFR] && serviceInfo[WESS_EPP_NFR].hasLicense || serviceInfo[WESS_AD] && serviceInfo[WESS_AD].hasLicense || serviceInfo[WESS_AD_TRIAL] && serviceInfo[WESS_AD_TRIAL].hasLicense || serviceInfo[WESS_AD_NFR] && serviceInfo[WESS_AD_NFR].hasLicense || serviceInfo[WESS_AD360] && serviceInfo[WESS_AD360].hasLicense || serviceInfo[WESS_AD360_TRIAL] && serviceInfo[WESS_AD360_TRIAL].hasLicense || serviceInfo[WESS_AD360_NFR] && serviceInfo[WESS_AD360_NFR].hasLicense || serviceInfo[WESS_AEPDR] && serviceInfo[WESS_AEPDR].hasLicense || serviceInfo[WESS_AEPDR_TRIAL] && serviceInfo[WESS_AEPDR_TRIAL].hasLicense || serviceInfo[WESS_AEPDR_NFR] && serviceInfo[WESS_AEPDR_NFR].hasLicense || serviceInfo[WESS_EDR_CORE] && serviceInfo[WESS_EDR_CORE].hasLicense || serviceInfo[WESS_EDR_CORE_NFR] && serviceInfo[WESS_EDR_CORE_NFR].hasLicense || serviceInfo[WESS_AD_OVERAGE] && serviceInfo[WESS_AD_OVERAGE].hasLicense || serviceInfo[WESS_AD360_OVERAGE] && serviceInfo[WESS_AD360_OVERAGE].hasLicense || serviceInfo[WESS_EPP_OVERAGE] && serviceInfo[WESS_EPP_OVERAGE].hasLicense || serviceInfo[WESS_AEDPR_OVERAGE] && serviceInfo[WESS_AEDPR_OVERAGE].hasLicense;
      } else if (this.serviceName === AUTH) {
        hasLicense = serviceInfo[AUTHPOINT] && serviceInfo[AUTHPOINT].hasLicense || serviceInfo[AUTHPOINT_TRIAL] && serviceInfo[AUTHPOINT_TRIAL].hasLicense || serviceInfo[AUTHPOINT_NFR] && serviceInfo[AUTHPOINT_NFR].hasLicense || serviceInfo[AUTHPOINT_OVERAGE] && serviceInfo[AUTHPOINT_OVERAGE].hasLicense || serviceInfo[AUTHPOINT_TIS] && serviceInfo[AUTHPOINT_TIS].hasLicense || serviceInfo[AUTHPOINT_TIS_TRIAL] && serviceInfo[AUTHPOINT_TIS_TRIAL].hasLicense || serviceInfo[AUTHPOINT_TIS_NFR] && serviceInfo[AUTHPOINT_TIS_NFR].hasLicense || serviceInfo[AUTHPOINT_TIS_OVERAGE] && serviceInfo[AUTHPOINT_TIS_OVERAGE].hasLicense || serviceInfo[WESS_AD_OVERAGE] && serviceInfo[WESS_AD_OVERAGE].hasLicense || serviceInfo[WESS_AD360_OVERAGE] && serviceInfo[WESS_AD360_OVERAGE].hasLicense || serviceInfo[WESS_EPP_OVERAGE] && serviceInfo[WESS_EPP_OVERAGE].hasLicense || serviceInfo[WESS_AEDPR_OVERAGE] && serviceInfo[WESS_AEDPR_OVERAGE].hasLicense;
      } else if (this.serviceName === FIREWAN) {
        hasLicense = serviceInfo[FIREWAN] && serviceInfo[FIREWAN].hasLicense || serviceInfo[FIREWAN_TRIAL] && serviceInfo[FIREWAN_TRIAL].hasLicense || serviceInfo[FIREWAN_NFR] && serviceInfo[FIREWAN_NFR].hasLicense || serviceInfo[FIREWAN_OVERAGE] && serviceInfo[FIREWAN_OVERAGE].hasLicense;
      } else if (this.serviceName === NDR) {
        hasLicense = serviceInfo[NDR_NDR] && serviceInfo[NDR_NDR].hasLicense || serviceInfo[NDR_NDR_TRIAL] && serviceInfo[NDR_NDR_TRIAL].hasLicense || serviceInfo[NDR_NDR_NFR] && serviceInfo[NDR_NDR_NFR].hasLicense || serviceInfo[NDR_NDR_OVERAGE] && serviceInfo[NDR_NDR_OVERAGE].hasLicense;
      } else if (this.serviceName === CMPL) {
        hasLicense = serviceInfo[CMPL_REPORT] && serviceInfo[CMPL_REPORT].hasLicense || serviceInfo[CMPL_REPORT_TRIAL] && serviceInfo[CMPL_REPORT_TRIAL].hasLicense || serviceInfo[CMPL_REPORT_NFR] && serviceInfo[CMPL_REPORT_NFR].hasLicense || serviceInfo[CMPL_REPORT_OVERAGE] && serviceInfo[CMPL_REPORT_OVERAGE].hasLicense;
      } else if (this.serviceName === TSP) {
        hasLicense = serviceInfo[TSP_SDR] && serviceInfo[TSP_SDR].hasLicense || serviceInfo[TSP_SDR_TRIAL] && serviceInfo[TSP_SDR_TRIAL].hasLicense || serviceInfo[TSP_SDR_NFR] && serviceInfo[TSP_SDR_NFR].hasLicense || serviceInfo[TSP_SDR_OVERAGE] && serviceInfo[TSP_SDR_OVERAGE].hasLicense;
      } else if (this.serviceName === WGMDR) {
        hasLicense = serviceInfo[MDR_DEF] && serviceInfo[MDR_DEF].hasLicense || serviceInfo[MDR_DEF_NFR] && serviceInfo[MDR_DEF_NFR].hasLicense || serviceInfo[MDR_DEF_OVERAGE] && serviceInfo[MDR_DEF_OVERAGE].hasLicense || serviceInfo[MDR_TOTAL] && serviceInfo[MDR_TOTAL].hasLicense || serviceInfo[MDR_TOTAL_NFR] && serviceInfo[MDR_TOTAL_NFR].hasLicense || serviceInfo[MDR_TOTAL_OVERAGE] && serviceInfo[MDR_TOTAL_OVERAGE].hasLicense;
      } else if (this.serviceName === TXDR) {
        hasLicense = serviceInfo[TSP_TXDR] && serviceInfo[TSP_TXDR].hasLicense || serviceInfo[TSP_TXDR_NFR] && serviceInfo[TSP_TXDR_NFR].hasLicense || serviceInfo[TSP_TXDR_OVERAGE] && serviceInfo[TSP_TXDR_OVERAGE].hasLicense;
      } else if (this.serviceName === TSPLUS) {
        hasLicense = hasLicense = serviceInfo[NDR_NDR] && serviceInfo[NDR_NDR].hasLicense || serviceInfo[NDR_NDR_TRIAL] && serviceInfo[NDR_NDR_TRIAL].hasLicense || serviceInfo[NDR_NDR_NFR] && serviceInfo[NDR_NDR_NFR].hasLicense || serviceInfo[NDR_NDR_OVERAGE] && serviceInfo[NDR_NDR_OVERAGE].hasLicense || serviceInfo[CMPL_REPORT] && serviceInfo[CMPL_REPORT].hasLicense || serviceInfo[CMPL_REPORT_TRIAL] && serviceInfo[CMPL_REPORT_TRIAL].hasLicense || serviceInfo[CMPL_REPORT_NFR] && serviceInfo[CMPL_REPORT_NFR].hasLicense || serviceInfo[CMPL_REPORT_OVERAGE] && serviceInfo[CMPL_REPORT_OVERAGE].hasLicense || serviceInfo[TSP_SDR] && serviceInfo[TSP_SDR].hasLicense || serviceInfo[TSP_SDR_TRIAL] && serviceInfo[TSP_SDR_TRIAL].hasLicense || serviceInfo[TSP_SDR_NFR] && serviceInfo[TSP_SDR_NFR].hasLicense || serviceInfo[TSP_SDR_OVERAGE] && serviceInfo[TSP_SDR_OVERAGE].hasLicense || serviceInfo[TSP_TXDR] && serviceInfo[TSP_TXDR].hasLicense || serviceInfo[TSP_TXDR_NFR] && serviceInfo[TSP_TXDR_NFR].hasLicense || serviceInfo[TSP_TXDR_OVERAGE] && serviceInfo[TSP_TXDR_OVERAGE].hasLicense;
      } else {
        let trialLicData;
        let nfrLicData;
        let overageLicData;
        let drlLicData;
        const licData = serviceInfo[this.serviceName];
        if (this.serviceName === AUTHPOINT) {
          trialLicData = serviceInfo[AUTHPOINT_TRIAL];
          nfrLicData = serviceInfo[AUTHPOINT_NFR];
          overageLicData = serviceInfo[AUTHPOINT_OVERAGE];
        }
        if (this.serviceName === FIREWAN) {
          trialLicData = serviceInfo[FIREWAN_TRIAL];
        }
        if (this.serviceName === FIREBOX) {
          drlLicData = serviceInfo[FIREBOX_DRL];
        }
        hasLicense = licData.hasLicense || trialLicData !== undefined && trialLicData.hasLicense || nfrLicData !== undefined && nfrLicData.hasLicense || overageLicData !== undefined && overageLicData.hasLicense || drlLicData !== undefined && drlLicData.hasLicense;
      }
      this.elementRef.nativeElement.style.display = hasLicense ? 'block' : 'none';
      this.hasLicense.emit(serviceInfo);
    }, err => {
      this.elementRef.nativeElement.style.display = 'none';
      this.hasLicense.emit({});
    });
  }
  static {
    this.ɵfac = function HasLicenseDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HasLicenseDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(LicenseManagementService), i0.ɵɵdirectiveInject(WgAccountInfoService));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: HasLicenseDirective,
      selectors: [["", "wgcHasLicense", ""]],
      inputs: {
        serviceName: [0, "wgcHasLicense", "serviceName"],
        accountID: "accountID",
        accountType: "accountType"
      },
      outputs: {
        hasLicense: "hasLicense"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HasLicenseDirective, [{
    type: Directive,
    args: [{
      // eslint-disable-next-line @angular-eslint/directive-selector
      selector: '[wgcHasLicense]',
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: LicenseManagementService
  }, {
    type: WgAccountInfoService
  }], {
    serviceName: [{
      type: Input,
      args: ['wgcHasLicense']
    }],
    accountID: [{
      type: Input,
      args: ['accountID']
    }],
    accountType: [{
      type: Input,
      args: ['accountType']
    }],
    hasLicense: [{
      type: Output
    }]
  });
})();
class WgHasLicenseModule {
  static {
    this.ɵfac = function WgHasLicenseModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgHasLicenseModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgHasLicenseModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgHasLicenseModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [HasLicenseDirective],
      exports: [HasLicenseDirective]
    }]
  }], null, null);
})();

/**
 * Simple directive that takes in a permission string and a service
 * and checks if the current session has that permission or not.
 *
 * Also returns the permission so that user can use that info if needed
 *   - (Useful when user has to show text like View or Manage etc)
 *
 * If user has permission the element that hosts the directive is shown
 * else it is hidden.
 *
 * We have permissions.json file that has the following structure
 *
 * {
 *   <service_type>: {
 *     <action>: [List of role ids that can have access to this action]
 *   }
 * }
 *
 * Eg:
 * {
 *   'platform':
 *      'canManageChildAccounts': [1, 4],
 *      'canManageChildOperators': [1],
 * }
 *
 * Usage:
 *     Use it on your custom component or html elems like this
 *     <div [wgcHasPermisson]="canManageChildOperatorsPerm"
 *          [service]="service">
 *       <span>Yes</span>
 *     </div>
 *
 *    Pass in a string of permission you wnt to check
 *    and service (platform, authpoint, hostsensor, dimension)
 */
class HasPermissionDirective {
  constructor(elementRef, rbacService) {
    this.elementRef = elementRef;
    this.rbacService = rbacService;
    this.hasPermission = new EventEmitter();
    this.originalDisplayStyle = undefined;
  }
  ngOnChanges(change) {
    this._checkPermission();
  }
  ngOnDestroy() {
    if (this.permissionObservable$) {
      this.permissionObservable$.unsubscribe();
    }
  }
  _checkPermission() {
    if (this.originalDisplayStyle === undefined) {
      this.originalDisplayStyle = this.elementRef.nativeElement.style.display;
    }
    this.permissionObservable$ = this.rbacService.hasPermissionObservable(this.serviceName, this.permissionName).subscribe({
      next: hasPerm => {
        this.elementRef.nativeElement.style.display = hasPerm ? this.originalDisplayStyle : 'none';
        this.hasPermission.emit(hasPerm);
      },
      error: err => {
        this.elementRef.nativeElement.style.display = 'none';
        this.hasPermission.emit(false);
      }
    });
  }
  static {
    this.ɵfac = function HasPermissionDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HasPermissionDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(RBACService));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: HasPermissionDirective,
      selectors: [["", "wgcHasPermission", ""]],
      inputs: {
        permissionName: [0, "wgcHasPermission", "permissionName"],
        serviceName: [0, "service", "serviceName"]
      },
      outputs: {
        hasPermission: "hasPermission"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HasPermissionDirective, [{
    type: Directive,
    args: [{
      // eslint-disable-next-line @angular-eslint/directive-selector
      selector: '[wgcHasPermission]',
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: RBACService
  }], {
    permissionName: [{
      type: Input,
      args: ['wgcHasPermission']
    }],
    serviceName: [{
      type: Input,
      args: ['service']
    }],
    hasPermission: [{
      type: Output
    }]
  });
})();
/**
 * <span *ngIf="acntID"
 *  wgcHasPermissionV2
 *  [acntID]="acntID"
    [appV2]="'service_provider_administration'"
    [permissionV2]="'tenant_trials_management'"
    [appV1]="'platform'"
    [permissionV1]="'canManageTrialCenter'"
    (hasPermission)="canManageTrialCenter=$event">
   </span>

  Without acntID,
  <span
    wgcHasPermissionV2
    [appV2]="'service_provider_administration'"
    [permissionV2]="'tenant_trials_management'"
    [appV1]="'platform'"
    [permissionV1]="'canManageTrialCenter'"
    (hasPermission)="canManageTrialCenter=$event">
   </span>

  - acntID is optional. if not specified, use the role from the login account (current RBAC directive).
    If specified, use the role of the acntID. This is to deal with the drilldown to a tenant account.

  - The appV1 and permissionV1 are same as the service and wgcHasPermission properties, respectively, in the
    existing wgcHasPermission directive.

  - appV1 and permissionV1 are required.

  - if all properties (appV2, permissionV2, appV1, and permissionV1) are provided, the directive will use
    the new COR or existing RBAC enforcement depending on the operator who logged in has custom roles or not.

  - if only app1 and permissionV1 are provided, appV2 is '' or permissionV2 is '', the existing RBAC enforcement will be used.
 */
class HasPermissionV2Directive {
  constructor(elementRef, rbacService, granularRBACService) {
    this.elementRef = elementRef;
    this.rbacService = rbacService;
    this.granularRBACService = granularRBACService;
    // eslint-disable-next-line @angular-eslint/no-input-rename
    this.acntID = ''; // selected account ID. If not specified, use login account ID to get the role from JWT token.
    // eslint-disable-next-line @angular-eslint/no-input-rename
    this.appV2 = '';
    // eslint-disable-next-line @angular-eslint/no-input-rename
    this.permissionV2 = '';
    // eslint-disable-next-line @angular-eslint/no-input-rename
    this.appV1 = '';
    // eslint-disable-next-line @angular-eslint/no-input-rename
    this.permissionV1 = '';
    this.hasPermission = new EventEmitter();
    this.originalDisplayStyle = undefined;
  }
  ngOnChanges(change) {
    this._checkPermission();
  }
  _checkPermission() {
    if (this.originalDisplayStyle === undefined) {
      this.originalDisplayStyle = this.elementRef.nativeElement.style.display;
    }
    this.granularRBACService.hasPermissionGranularRbacObservable(this.appV2, this.permissionV2, this.appV1, this.permissionV1, this.acntID).pipe(take(1)).subscribe({
      next: hasPerm => {
        this.elementRef.nativeElement.style.display = hasPerm ? this.originalDisplayStyle : 'none';
        this.hasPermission.emit(hasPerm);
      },
      error: err => {
        this.elementRef.nativeElement.style.display = 'none';
        this.hasPermission.emit(false);
      }
    });
  }
  static {
    this.ɵfac = function HasPermissionV2Directive_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HasPermissionV2Directive)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(RBACService), i0.ɵɵdirectiveInject(GranularRBACService));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: HasPermissionV2Directive,
      selectors: [["", "wgcHasPermissionV2", ""]],
      inputs: {
        acntID: "acntID",
        appV2: "appV2",
        permissionV2: "permissionV2",
        appV1: "appV1",
        permissionV1: "permissionV1"
      },
      outputs: {
        hasPermission: "hasPermission"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HasPermissionV2Directive, [{
    type: Directive,
    args: [{
      // eslint-disable-next-line @angular-eslint/directive-selector
      selector: '[wgcHasPermissionV2]',
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: RBACService
  }, {
    type: GranularRBACService
  }], {
    acntID: [{
      type: Input,
      args: ['acntID']
    }],
    appV2: [{
      type: Input,
      args: ['appV2']
    }],
    permissionV2: [{
      type: Input,
      args: ['permissionV2']
    }],
    appV1: [{
      type: Input,
      args: ['appV1']
    }],
    permissionV1: [{
      type: Input,
      args: ['permissionV1']
    }],
    hasPermission: [{
      type: Output
    }]
  });
})();
class WgHasPermissionModule {
  static {
    this.ɵfac = function WgHasPermissionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgHasPermissionModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgHasPermissionModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgHasPermissionModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [HasPermissionDirective, HasPermissionV2Directive],
      exports: [HasPermissionDirective, HasPermissionV2Directive]
    }]
  }], null, null);
})();
class WgRbacModule {
  static {
    this.ɵfac = function WgRbacModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgRbacModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgRbacModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [RBACService, GranularRBACService],
      imports: [WgSessionModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgRbacModule, [{
    type: NgModule,
    args: [{
      imports: [WgSessionModule],
      providers: [RBACService, GranularRBACService]
    }]
  }], null, null);
})();

/**
 * Simple directive that takes in
 *   account ID (required),
 *   applicaiton identifier (required),
 *   feature identifier (optional),
 *   feature version (optional)
 *
 * then hide or show the corresponding html tag element based on the return
 * of allowFeature() of the WgFeatureToggleService.
 *
 * Usage:
 *     Use it on your custom component by enclosing it like below.
 *     <div [wgFeatureToggle]="accountID"
 *          [applicationID]="'application ID'"
 *          [featureID]="'feature ID'"
 *          [featureVersion]="'feature version'"
 *          (allowFeature)="allowFeature($event)">
 *        <wgc-api-management
 *           [accountID]="accountID">
 *        </wgc-api-management>
 *     </div>
 *
 *     Note: accountID is a variable. Enclose a string with ''.
 *
 *     The enclosed component's ngOnInit() will be always be called regardless
 *     the directive hides or shows the parent component. So this directive
 *     can be used to hide or show the enclosed component safely if there are no
 *     new API calls invoked from the ngOnInit().
 *
 *     If there is any new API call and you don't want it to be called when the
 *     it is hidden, there is an alternative way to do this like below,
 *
 *     <ng-container *ngIf="featureEnforcmentPublicCatalogUI">
 *       <wgc-api-management
 *         [accountID]="accountID">
 *       </wgc-api-management>
 *       <br><br><br>
 *     </ng-container>
 *
 *     If the featureEnforcmentPublicCatalogUI is false, the wgc-api-management will not
 *     be loaded in to the dom. As a result, the ngOnit() will not be called. The
 *     featureEnforcmentPublicCatalogUI is a variable which takes on the value of
 *     WgFeatureToggleService's allowFeature().
 */
class WgFeatureToggleDirective {
  constructor(elementRef, featureToggleService) {
    this.elementRef = elementRef;
    this.featureToggleService = featureToggleService;
    this.featureID = '';
    this.featureVersion = '';
    this.allowFeature = new EventEmitter();
  }
  ngOnChanges(change) {
    if (this.accountID && this.applicationID) {
      this.checkFeatureToggle();
    }
  }
  // hide or show the html tag based on the return value of
  // featureToggleService.allowFeature().
  checkFeatureToggle() {
    const featureAllowed = this.featureToggleService.allowFeature(this.accountID, this.applicationID, this.featureID, this.featureVersion);
    this.elementRef.nativeElement.style.display = featureAllowed ? 'block' : 'none';
    this.allowFeature.emit(featureAllowed);
  }
  static {
    this.ɵfac = function WgFeatureToggleDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgFeatureToggleDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(WgFeatureToggleService));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: WgFeatureToggleDirective,
      selectors: [["", "wgFeatureToggle", ""]],
      inputs: {
        accountID: [0, "wgFeatureToggle", "accountID"],
        applicationID: "applicationID",
        featureID: "featureID",
        featureVersion: "featureVersion"
      },
      outputs: {
        allowFeature: "allowFeature"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgFeatureToggleDirective, [{
    type: Directive,
    args: [{
      selector: '[wgFeatureToggle]',
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: WgFeatureToggleService
  }], {
    accountID: [{
      type: Input,
      args: ['wgFeatureToggle']
    }],
    applicationID: [{
      type: Input
    }],
    featureID: [{
      type: Input
    }],
    featureVersion: [{
      type: Input
    }],
    allowFeature: [{
      type: Output
    }]
  });
})();
class WgFeatureToggleModule {
  static {
    this.ɵfac = function WgFeatureToggleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgFeatureToggleModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgFeatureToggleModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgFeatureToggleModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [WgFeatureToggleDirective],
      exports: [WgFeatureToggleDirective]
    }]
  }], null, null);
})();
class SubProdModIdToLabelPipe {
  transform(id, ...args) {
    const idToLabelsMap = args[0];
    if (!idToLabelsMap) {
      return id;
    } else {
      return idToLabelsMap[id] || id;
    }
  }
  static {
    this.ɵfac = function SubProdModIdToLabelPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SubProdModIdToLabelPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "subProdModIdToLabel",
      type: SubProdModIdToLabelPipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubProdModIdToLabelPipe, [{
    type: Pipe,
    args: [{
      name: 'subProdModIdToLabel',
      standalone: false
    }]
  }], null, null);
})();
class WgProdDefModule {
  static {
    this.ɵfac = function WgProdDefModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgProdDefModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgProdDefModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [SubProdModIdToLabelPipe]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgProdDefModule, [{
    type: NgModule,
    args: [{
      declarations: [SubProdModIdToLabelPipe],
      exports: [SubProdModIdToLabelPipe],
      providers: [SubProdModIdToLabelPipe]
    }]
  }], null, null);
})();
const WidgetLicenseType = {
  TERM: 'term',
  SUBSCRIPTION: 'subscription',
  MIXED: 'mixed'
};
const WidgetType = {
  SUBSCR_LIC: 'subscription',
  TERM_LIC: 'term',
  NFR_LIC: 'nfr',
  TOT_LIC: 'total',
  ONBOARDING: 'onboarding'
};
const LICENSE_UNIT = {
  LICENSES: 'licenses',
  USERS: 'users',
  ENDPOINTS: 'endpoints'
};
const ProductDefType = {
  STANDALONE: 'standalone',
  BUNDLE: 'bundle'
};

/**
 * Service that deals with product definition files from Static:products directory.
 */
const TOP_DIR = 'products';
const MASTER_LIST_FILENAME = 'new_product_list.json';
const BASE_DEFN = 'base';
const BASE_FILE = 'base_product_def.json';
class WgProdDefService {
  constructor(http, featureToggle, licenseService) {
    this.http = http;
    this.featureToggle = featureToggle;
    this.licenseService = licenseService;
    this.prodDefInitializedSubject = new BehaviorSubject(false);
    this.prodPropertiesHash = {};
    this.prodDefFiles = [];
    this.prodDefContents = {};
  }
  // Components should subscribe to this so they know when all product definitions files have been loaded.
  isProdDefInitialized() {
    return this.prodDefInitializedSubject.asObservable();
  }
  // To load all the product definition related files. This should be called once when WGC starts.
  initProdDefFiles() {
    let env = getEnv();
    if (!env) {
      env = 'prod';
    }
    // load list file
    this.loadJsonData(TOP_DIR + '/' + MASTER_LIST_FILENAME).subscribe({
      next: data => {
        this.prodDefFiles.push({
          productName: BASE_DEFN,
          file: BASE_FILE,
          envs: ['dev', 'qa', 'staging', 'prod'],
          toLoad: true,
          loadedContent: false
        });
        if (data && data.products) {
          for (const product of data.products) {
            this.prodDefFiles.push({
              productName: product.productName,
              file: product.file,
              envs: product.envs,
              toLoad: product.envs && product.envs.includes(env),
              loadedContent: false
            });
          }
        }
        for (const product of this.prodDefFiles) {
          if (product.toLoad) {
            this.loadJsonData(TOP_DIR + '/' + product.file).subscribe({
              next: data => {
                product.loadedContent = true;
                if (data) {
                  this.prodDefContents[product.productName] = data;
                }
                let allLoaded = true;
                for (const entry of this.prodDefFiles) {
                  if (entry.toLoad && !entry.loadedContent) {
                    allLoaded = false;
                    break;
                  }
                }
                if (allLoaded) {
                  this.prodDefInitializedSubject.next(true);
                }
              },
              error: error => {
                product.loadedContent = true;
                console.error(`Failed to load ${product.file}.`);
                console.error(error);
              }
            });
          }
        }
      },
      error: error => {
        console.error(`Failed to load ${MASTER_LIST_FILENAME}.`);
        console.error(error);
      }
    });
  }
  // To get a list of all product names. Does not factor in beta toggle of product.
  getProductNames() {
    const ret = [];
    for (const entry of this.prodDefFiles) {
      if (entry.productName !== BASE_DEFN && entry.loadedContent) {
        ret.push(entry.productName);
      }
    }
    return ret;
  }
  // To get the product's properties section.
  getProductProperties(productName) {
    if (productName in this.prodPropertiesHash) {
      return this.prodPropertiesHash[productName];
    }
    const base = this.prodDefContents[BASE_DEFN];
    const product = this.prodDefContents[productName];
    const baseProps = base && base.properties ? base.properties : undefined;
    const productProps = product && product.properties ? product.properties : undefined;
    const props = {
      id: productProps.hasOwnProperty('id') ? productProps?.id : baseProps?.id,
      label: productProps.hasOwnProperty('label') ? productProps?.label : baseProps?.label,
      sassProduct: productProps.hasOwnProperty('sassProduct') ? productProps?.sassProduct : baseProps?.sassProduct,
      hasNFR: productProps.hasOwnProperty('hasNFR') ? productProps?.hasNFR : baseProps?.hasNFR,
      icon: productProps.hasOwnProperty('icon') ? productProps?.icon : baseProps?.icon,
      licenseUnit: productProps.hasOwnProperty('licenseUnit') ? productProps?.licenseUnit : baseProps?.licenseUnit,
      features: (productProps.hasOwnProperty('features') ? productProps?.features : baseProps?.features) || undefined,
      productType: productProps.hasOwnProperty('productType') ? productProps?.productType : baseProps?.productType,
      childBundledProducts: (productProps.hasOwnProperty('childBundledProducts') ? productProps.childBundledProducts : baseProps.childBundledProducts) || [],
      subProducts: (productProps.hasOwnProperty('subProducts') ? productProps.subProducts : baseProps.subProducts) || [],
      modules: (productProps.hasOwnProperty('modules') ? productProps.modules : baseProps.modules) || [],
      mainDashboardUI: (productProps.hasOwnProperty('mainDashboardUI') ? productProps.mainDashboardUI : baseProps.mainDashboardUI) || undefined,
      inventoryUI: (productProps.hasOwnProperty('inventoryUI') ? productProps.inventoryUI : baseProps.inventoryUI) || undefined,
      trialsUI: (productProps.hasOwnProperty('trialsUI') ? productProps.trialsUI : baseProps.trialsUI) || undefined
    };
    this.prodPropertiesHash[productName] = props;
    return props;
  }
  // To get an asset property for a given key.
  getProductAsset(productName, key) {
    const base = this.prodDefContents[BASE_DEFN];
    const product = this.prodDefContents[productName];
    const baseVal = base && base.assets ? base.assets[key] : undefined;
    const productVal = product && product.assets ? product.assets[key] : undefined;
    return productVal || baseVal;
  }
  // Other utilites that uses feature toggle to filter out products, subProducts, and modules.
  //
  // return an array of { productName, properties }
  getEnabledProducts(accountID, includeBundleProd = false) {
    let ret = [];
    const tmpProdDefProducts = this.getProductNames();
    for (const productName of tmpProdDefProducts) {
      const properties = this.getProductProperties(productName);
      if (!includeBundleProd && properties.productType === ProductDefType.BUNDLE) {
        continue;
      }
      // cbeck the features toggle for the rest
      if (properties.features && properties.features.length > 0) {
        for (const feature of properties.features) {
          if (feature.hasOwnProperty('applicationID') && feature.hasOwnProperty('featureID') && feature.hasOwnProperty('featureVersion')) {
            if (this.featureToggle.allowFeature(accountID, feature.applicationID, feature.featureID, feature.featureVersion)) {
              ret.push({
                productName,
                properties
              });
              break;
            }
          }
        }
      } else {
        ret.push({
          productName,
          properties
        });
      }
    }
    // if the includeBundleProd flag is true
    // exclude standalone products that are parts a enabled bundle product.
    if (includeBundleProd) {
      const allEnabledProds = [...ret];
      let childBundledProds = [];
      for (const prod of allEnabledProds) {
        if (prod?.properties || prod.properties.productType === ProductDefType.BUNDLE && prod.properties.childBundledProducts) {
          childBundledProds = childBundledProds.concat(prod.properties.childBundledProducts);
        }
      }
      ret = [];
      for (const prod of allEnabledProds) {
        let toExclude = false;
        if (prod?.properties && (!prod.properties.productType || prod.properties.productType === ProductDefType.STANDALONE)) {
          if (childBundledProds.includes(prod.productName)) {
            toExclude = true;
          }
        }
        if (!toExclude) {
          ret.push(prod);
        }
      }
    }
    return ret;
  }
  getEnabledBundleTypeProducts(accountID) {
    const ret = [];
    const tmpProdDefProducts = this.getProductNames();
    for (const productName of tmpProdDefProducts) {
      const properties = this.getProductProperties(productName);
      if (!properties || properties.productType !== ProductDefType.BUNDLE) {
        continue;
      }
      if (properties.features && properties.features.length > 0) {
        for (const feature of properties.features) {
          if (feature.hasOwnProperty('applicationID') && feature.hasOwnProperty('featureID') && feature.hasOwnProperty('featureVersion')) {
            if (this.featureToggle.allowFeature(accountID, feature.applicationID, feature.featureID, feature.featureVersion)) {
              ret.push({
                productName,
                properties
              });
              break;
            }
          }
        }
      } else {
        ret.push({
          productName,
          properties
        });
      }
    }
    return ret;
  }
  // If the productName is not a bundle product, use the resource type directly.
  // if the productName is a bundle product, use the id value of product that the license belongs to.
  // 
  // For example, if the product is ThreatSync+ bundle product and license is NDR_NDR,
  // return NDR as the resouce type.
  getResourceTypeFromLicense(accountID, productName, license) {
    const prodDefProperties = this.getProductProperties(productName);
    const resourceType = prodDefProperties.id;
    const isBundleProd = prodDefProperties.productType === ProductDefType.BUNDLE;
    if (!isBundleProd) {
      return resourceType;
    }
    let ret = undefined;
    const allStandaloneProds = this.getEnabledProducts(accountID, false);
    for (const prod of allStandaloneProds) {
      const subProds = this.getEnabledSubProducts(accountID, prod?.productName);
      if (subProds) {
        for (const subProd of subProds) {
          if (subProd?.id === license) {
            ret = prod.properties.id;
            break;
          }
        }
      }
      if (ret) {
        break;
      }
    }
    return ret;
  }
  // filter out the subProducts whose beta feature toggles are disabled.
  getEnabledSubProducts(accountID, productName) {
    const ret = [];
    const props = this.getProductProperties(productName);
    if (props && props.subProducts) {
      for (const subProduct of props.subProducts) {
        if (subProduct.features && subProduct.features.length > 0) {
          for (const feature of subProduct.features) {
            if (feature.hasOwnProperty('applicationID') && feature.hasOwnProperty('featureID') && feature.hasOwnProperty('featureVersion')) {
              if (this.featureToggle.allowFeature(accountID, feature.applicationID, feature.featureID, feature.featureVersion)) {
                ret.push(subProduct);
                break;
              }
            }
          }
        } else {
          ret.push(subProduct);
        }
      }
    }
    const isBundleProd = props.productType === ProductDefType.BUNDLE;
    if (isBundleProd) {
      const childProdNames = props?.childBundledProducts;
      if (childProdNames) {
        for (const childProdName of childProdNames) {
          const subProducts = this.getEnabledSubProducts(accountID, childProdName);
          for (const subProduct of subProducts) {
            ret.push(subProduct);
          }
        }
      }
    }
    return ret;
  }
  // filter out the modules whose beta feature toggles are disabled.
  getEnabledModules(accountID, productName) {
    const ret = [];
    const props = this.getProductProperties(productName);
    if (props && props.modules) {
      for (const module of props.modules) {
        if (module.features && module.features.length > 0) {
          for (const feature of module.features) {
            if (feature.hasOwnProperty('applicationID') && feature.hasOwnProperty('featureID') && feature.hasOwnProperty('featureVersion')) {
              if (this.featureToggle.allowFeature(accountID, feature.applicationID, feature.featureID, feature.featureVersion)) {
                ret.push(module);
                break;
              }
            }
          }
        } else {
          ret.push(module);
        }
      }
    }
    const isBundleProd = props.productType === ProductDefType.BUNDLE;
    if (isBundleProd) {
      const childProdNames = props?.childBundledProducts;
      if (childProdNames) {
        for (const childProdName of childProdNames) {
          const modules = this.getEnabledModules(accountID, childProdName);
          for (const module of modules) {
            ret.push(module);
          }
        }
      }
    }
    return ret;
  }
  // check if the productName is valid in Template system. Factor in beta toggle.
  isValidProductName(accountID, productName) {
    // no bundle products in the list.
    // array of { productName, properties }
    const allStandaloneProds = this.getEnabledProducts(accountID, false);
    // this list contains bundle products and standalone products. Note: it does not include standalone 
    // products which are  part of bundle products.
    // array of { productName, properties }
    const allIncludingBundleProds = this.getEnabledProducts(accountID, true);
    const allProdNames = [];
    for (const entry of allStandaloneProds) {
      allProdNames.push(entry.productName);
    }
    for (const entry of allIncludingBundleProds) {
      allProdNames.push(entry.productName);
    }
    return allProdNames.includes(productName);
  }
  // Observable return true/false
  // Similar to hasLicense() of LicenseManagementService (wg-session).
  // THe difference is that this Observerable factors in the beta toggle whereas
  // the one in LicenseManagementService does not.
  hasLicense(accountID, productName) {
    if (!this.isValidProductName(accountID, productName)) {
      return of(false);
    }
    let retObs = of(false);
    const props = this.getProductProperties(productName);
    if (!props.productType || props.productType === ProductDefType.STANDALONE) {
      const subProducts = this.getEnabledSubProducts(accountID, productName);
      const modules = this.getEnabledModules(accountID, productName);
      retObs = this.licenseService.getLicenseInfo(accountID, props.id, 'parentID').pipe(map(response => {
        let hasLicense = false;
        for (const entry of [...subProducts, ...modules]) {
          if (this.checkLicense(entry.id, response)) {
            hasLicense = true;
            break;
          }
        }
        return hasLicense;
      }), catchError(error => {
        return of(false);
      }));
    } else if (props.productType === ProductDefType.BUNDLE) {
      const childProdNames = props?.childBundledProducts;
      const allLicenses = [];
      const licenseApis = [];
      if (childProdNames) {
        for (const childProdName of childProdNames) {
          if (this.isValidProductName(accountID, childProdName)) {
            const props = this.getProductProperties(childProdName);
            licenseApis.push(this.licenseService.getLicenseInfo(accountID, props.id, 'parentID'));
            const licenses = [];
            allLicenses.push(licenses);
            const subProducts = this.getEnabledSubProducts(accountID, childProdName);
            const modules = this.getEnabledModules(accountID, childProdName);
            for (const subProduct of subProducts) {
              licenses.push(subProduct.id);
            }
            for (const module of modules) {
              licenses.push(module.id);
            }
          }
        }
      }
      if (licenseApis.length > 0) {
        retObs = combineLatest(licenseApis).pipe(map(responses => {
          let hasLicense = false;
          for (let i = 0; i < responses.length; i++) {
            if (responses[i] && allLicenses[i]) {
              for (const lic of allLicenses[i]) {
                if (this.checkLicense(lic, responses[i])) {
                  hasLicense = true;
                  break;
                }
              }
            }
            if (hasLicense) {
              break;
            }
          }
          return hasLicense;
        }), catchError(error => {
          return of(false);
        }));
      }
    }
    return retObs;
  }
  // return internal IDs of enabled subProducts and modules.
  getEnabledSubProdModIds(accountID, productName) {
    const subProducts = this.getEnabledSubProducts(accountID, productName);
    const modules = this.getEnabledModules(accountID, productName);
    const allLicenses = [];
    for (const subProduct of subProducts) {
      allLicenses.push(subProduct.id);
    }
    for (const module of modules) {
      allLicenses.push(module.id);
    }
    const props = this.getProductProperties(productName);
    const isBundleProd = props.productType === ProductDefType.BUNDLE;
    if (isBundleProd) {
      const childProdNames = props?.childBundledProducts;
      if (childProdNames) {
        for (const childProdName of childProdNames) {
          const subProducts = this.getEnabledSubProducts(accountID, childProdName);
          const modules = this.getEnabledModules(accountID, childProdName);
          for (const subProduct of subProducts) {
            allLicenses.push(subProduct.id);
          }
          for (const module of modules) {
            allLicenses.push(module.id);
          }
        }
      }
    }
    return allLicenses;
  }
  // return a dict, key is id and value is the corresponding label (string resouce id)
  getEnabledSubProdModLabels(accountID, productName) {
    const dict = {};
    const subProducts = this.getEnabledSubProducts(accountID, productName);
    const modules = this.getEnabledModules(accountID, productName);
    for (const subProduct of subProducts) {
      dict[subProduct.id] = subProduct.label;
    }
    for (const module of modules) {
      dict[module.id] = module.label;
    }
    const props = this.getProductProperties(productName);
    const isBundleProd = props.productType === ProductDefType.BUNDLE;
    if (isBundleProd) {
      const childProdNames = props?.childBundledProducts;
      if (childProdNames) {
        for (const childProdName of childProdNames) {
          const subProducts = this.getEnabledSubProducts(accountID, childProdName);
          const modules = this.getEnabledModules(accountID, childProdName);
          for (const subProduct of subProducts) {
            dict[subProduct.id] = subProduct.label;
          }
          for (const module of modules) {
            dict[module.id] = module.label;
          }
        }
      }
    }
    return dict;
  }
  // return an arry of toggleOff params of subProducts
  getSubProductToggleOffParams(accountID, productName) {
    const ret = [];
    const props = this.getProductProperties(productName);
    if (props && props.subProducts) {
      for (const subProduct of props.subProducts) {
        if (subProduct.features && subProduct.features.length > 0) {
          for (const feature of subProduct.features) {
            if (feature.hasOwnProperty('applicationID') && feature.hasOwnProperty('featureID') && feature.hasOwnProperty('featureVersion')) {
              if (!this.featureToggle.allowFeature(accountID, feature.applicationID, feature.featureID, feature.featureVersion)) {
                if (subProduct.toggleOffParam) {
                  ret.push(subProduct.toggleOffParam);
                }
              }
            }
          }
        }
      }
    }
    const isBundleProd = props.productType === ProductDefType.BUNDLE;
    if (isBundleProd) {
      const childProdNames = props?.childBundledProducts;
      if (childProdNames) {
        for (const childProdName of childProdNames) {
          const params = this.getSubProductToggleOffParams(accountID, childProdName);
          for (const param of params) {
            ret.push(param);
          }
        }
      }
    }
    return ret;
  }
  // return an arry of toggleOff params of modules
  getModuleToggleOffParams(accountID, productName) {
    const ret = [];
    const props = this.getProductProperties(productName);
    if (props && props.modules) {
      for (const module of props.modules) {
        if (module.features && module.features.length > 0) {
          for (const feature of module.features) {
            if (feature.hasOwnProperty('applicationID') && feature.hasOwnProperty('featureID') && feature.hasOwnProperty('featureVersion')) {
              if (!this.featureToggle.allowFeature(accountID, feature.applicationID, feature.featureID, feature.featureVersion)) {
                if (module.toggleOffParam) {
                  ret.push(module.toggleOffParam);
                }
              }
            }
          }
        }
      }
    }
    const isBundleProd = props.productType === ProductDefType.BUNDLE;
    if (isBundleProd) {
      const childProdNames = props?.childBundledProducts;
      if (childProdNames) {
        for (const childProdName of childProdNames) {
          const params = this.getModuleToggleOffParams(accountID, childProdName);
          for (const childProdName of childProdNames) {
            const params = this.getSubProductToggleOffParams(accountID, childProdName);
            for (const param of params) {
              ret.push(param);
            }
          }
        }
      }
    }
    return ret;
  }
  // return a comma separated toggleOff params of subProducts and modules
  getSubProdModToggleOffParams(accountID, productName) {
    const subProdsToggleOff = this.getSubProductToggleOffParams(accountID, productName);
    const modulesToggleOff = this.getModuleToggleOffParams(accountID, productName);
    const combined = [...subProdsToggleOff, ...modulesToggleOff];
    return combined.join();
  }
  loadJsonData(filename) {
    return this.http.get(filename).pipe(catchError(error => {
      const msg = `Error loading JSON data from ${filename}: ${error.message}`;
      console.error(error.error);
      return throwError(new Error(msg));
    }));
  }
  showMaindashboardUI(accountID, productName) {
    const props = this.getProductProperties(productName);
    const uiSection = props?.mainDashboardUI;
    return this.showUiSection(accountID, props, uiSection);
  }
  showInventoryUI(accountID, productName) {
    const props = this.getProductProperties(productName);
    const uiSection = props?.inventoryUI;
    return this.showUiSection(accountID, props, uiSection);
  }
  showTrialsUI(accountID, productName) {
    const props = this.getProductProperties(productName);
    const uiSection = props?.trialsUI;
    return this.showUiSection(accountID, props, uiSection);
  }
  showUiSection(accountID, props, uiSection) {
    let ret = true;
    if (props && uiSection) {
      if (!uiSection.expose) {
        ret = false;
      } else {
        if (uiSection.features && uiSection.features.length > 0) {
          ret = false;
          for (const feature of uiSection.features) {
            if (feature.hasOwnProperty('applicationID') && feature.hasOwnProperty('featureID') && feature.hasOwnProperty('featureVersion')) {
              if (this.featureToggle.allowFeature(accountID, feature.applicationID, feature.featureID, feature.featureVersion)) {
                ret = true;
                break;
              }
            }
          }
        }
      }
    }
    return ret;
  }
  checkLicense(licenseType, licenseInfo) {
    if (licenseInfo.hasOwnProperty(licenseType) && licenseInfo[licenseType]?.hasLicense && licenseInfo[licenseType]?.status === 'valid') {
      return true;
    }
    const nfrLicense = `${licenseType}_NFR`;
    if (licenseInfo.hasOwnProperty(nfrLicense) && licenseInfo[nfrLicense]?.hasLicense && licenseInfo[nfrLicense]?.status === 'valid') {
      return true;
    }
    const overageLicense = `${licenseType}_Overage`;
    if (licenseInfo.hasOwnProperty(overageLicense) && licenseInfo[overageLicense]?.hasLicense && licenseInfo[overageLicense]?.status === 'valid') {
      return true;
    }
    const trialLicense = `${licenseType}_Trial`;
    if (licenseInfo.hasOwnProperty(trialLicense) && licenseInfo[trialLicense]?.hasLicense && licenseInfo[trialLicense]?.status === 'valid') {
      return true;
    }
    return false;
  }
  static {
    this.ɵfac = function WgProdDefService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgProdDefService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(WgFeatureToggleService), i0.ɵɵinject(LicenseManagementService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: WgProdDefService,
      factory: WgProdDefService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgProdDefService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: WgFeatureToggleService
  }, {
    type: LicenseManagementService
  }], null);
})();
class AuthDomainManagementService {
  constructor(http, appService) {
    this.http = http;
    this.appService = appService;
    // specific to authentication domain section
    this.AUTHENTICATION_DOMAIN_APP_ID = "authentication-domains";
    this.AUTHENTICATOIN_DOMAIN_FEATURE_ID = "authentication-domains";
    this.AUTHENTICATION_DOMAIN_FEATURE_VERSION = "1.0.0";
    this.headers = new HttpHeaders().set("Content-Type", "application/json").set("feature_info", JSON.stringify(this.authDomainFeatureInfo()));
  }
  /**
   *  Filter out the the children menu items of an nav object based on auth domain server types.
   *  The check is based on their corresponding values specified in the json files in
   *  assets/(dev|qa|staging|prod) of the Static library.
   *
   *  The filtering is done at most 2 levels
   *  - children of the top level
   *  - children of the children of the top level
   *  - children of the top_nav_children of the top level
   *
   *  Note: the function will not alter the navData. The result will be returned.
   */
  filterNavDataBasedOnAuthDomainServer(acntID, origNavData, authDomainList = []) {
    if (!acntID) {
      console.debug("The acntID does not contain value in filterNavDataBasedOnAuthDomainServer();");
      return origNavData;
    }
    const navData = JSON.parse(JSON.stringify(origNavData));
    if (navData.hasOwnProperty("children")) {
      const filteredChildren = navData.children.filter(item => {
        return this.checkAuthDomainServer(acntID, item, authDomainList);
      });
      navData.children = filteredChildren;
      for (const child of navData.children) {
        if (child.hasOwnProperty("children")) {
          const filtered = child.children.filter(item => {
            return this.checkAuthDomainServer(acntID, item, authDomainList);
          });
          child.children = filtered;
        }
      }
    }
    if (navData.hasOwnProperty("top_nav_children")) {
      for (const topNav of navData.top_nav_children) {
        if (topNav.hasOwnProperty("children")) {
          const filteredChildren = topNav.children.filter(item => {
            return this.checkAuthDomainServer(acntID, item, authDomainList);
          });
          topNav.children = filteredChildren;
        }
      }
      // keep only top nav that contains at least one entry
      navData.top_nav_children = navData.top_nav_children.filter(topNav => {
        return topNav.children.length > 0;
      });
    }
    return navData;
  }
  /**
   * Inspect the dynamic widget or menu item object defined in json files (in Static) and
   * return false to keep and true to remove.
   *
   * Criteria:
   * - Search item for authDomains fields. If either does not exist, return false to keep.
   */
  checkAuthDomainServer(acntID, item, authDomainList) {
    const hasServers = item.hasOwnProperty("auth_domain_servers") && item.auth_domain_servers.length > 0;
    const hasServersOnData = item.hasOwnProperty("data") && item.data.hasOwnProperty("auth_domain_servers") && item.data.auth_domain_servers.length > 0;
    if (!acntID) {
      console.debug("The acntID does not contain value in checkAuthDomainServer().");
      return !(hasServers || hasServersOnData);
    }
    if (hasServers || hasServersOnData) {
      const auth_domain_servers = hasServers ? item.auth_domain_servers : item.data.auth_domain_servers;
      return auth_domain_servers.some(authDomain => authDomainList?.includes(authDomain));
    } else {
      return false; // the widget does not have auth_domain_servers to check, return false.
    }
  }
  getGuardApiUrl(override = "") {
    const options = {
      region: "usa",
      override,
      service: "unifiedid"
    };
    if (window.location.host.indexOf("watchguard.com") !== -1) {
      options.override = "";
    }
    return newGuardApiUrl(options);
  }
  handleError(error) {
    const errMsg = error.message ? error.message : error.status ? `${error.status} - ${error.statusText}` : "Server error";
    return throwError(errMsg);
  }
  authDomainFeatureInfo() {
    return {
      application_id: this.AUTHENTICATION_DOMAIN_APP_ID,
      feature_version: this.AUTHENTICATION_DOMAIN_FEATURE_VERSION,
      feature_id: this.AUTHENTICATOIN_DOMAIN_FEATURE_ID
    };
  }
  /**
   * Fetch the Authentication Domains registered for Account ID mentioned in the request data
   * @param requestData : JSON request including Account Id to fetch the authentication domains from host repository
   */
  getDomains(requestData) {
    const url = `${this.getGuardApiUrl()}${API_CONSTANTS$1.unifiedIdConfigBaseUrl}/config/Search`;
    return this.http.post(url, requestData, {
      headers: this.headers
    }).pipe(catchError(this.handleError));
  }
  authDomainUrlExist(auth_domain_endPoints, state, id) {
    if (state.url?.includes(AUTH.toLowerCase())) {
      const endpoint = id ? state.url?.split(id)[1] : state.url;
      return auth_domain_endPoints?.some(url => endpoint?.includes(url));
    } else {
      return false;
    }
  }
  loadAuthData() {
    return this.appService.loadAuthData().pipe(switchMap(res => {
      res = JSON.parse(JSON.stringify(res));
      return of(Object.values(res).filter(item => item.auth_domain_servers?.includes('watchguard_cloud_directory')).map(item => item.route));
    }));
  }
  static {
    this.ɵfac = function AuthDomainManagementService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AuthDomainManagementService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(AppContentLoaderService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AuthDomainManagementService,
      factory: AuthDomainManagementService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthDomainManagementService, [{
    type: Injectable
  }], () => [{
    type: i1.HttpClient
  }, {
    type: AppContentLoaderService
  }], null);
})();
class WgAuthDomainManagementModule {
  static {
    this.ɵfac = function WgAuthDomainManagementModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgAuthDomainManagementModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgAuthDomainManagementModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [AuthDomainManagementService]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgAuthDomainManagementModule, [{
    type: NgModule,
    args: [{
      imports: [],
      providers: [AuthDomainManagementService]
    }]
  }], null, null);
})();
class HighlightPipe {
  transform(originalValue, textToHighlight) {
    if (!textToHighlight) {
      return originalValue;
    }
    // normalize text
    textToHighlight = this.normalizeString(textToHighlight);
    const normalizedValue = this.normalizeString(originalValue);
    const regex = new RegExp(textToHighlight, 'gi');
    let highlightedValue = originalValue;
    let regexResults = regex.exec(normalizedValue);
    while (regexResults) {
      const originalSubstring = originalValue.substr(regexResults.index, regexResults[0].length);
      highlightedValue = highlightedValue.replace(new RegExp(originalSubstring, 'gi'), `<b>${originalSubstring}</b>`);
      regexResults = regex.exec(normalizedValue);
    }
    return highlightedValue;
  }
  normalizeString(string) {
    return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  }
  static {
    this.ɵfac = function HighlightPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HighlightPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "highlight",
      type: HighlightPipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HighlightPipe, [{
    type: Pipe,
    args: [{
      name: 'highlight',
      standalone: false
    }]
  }], null, null);
})();

/**
 * @license
 * Copyright WatchGuard Technologies Inc. All Rights Reserved.
 *
 * This module exports WgDropdownComponent that renders a dropdown widget, lets user pick an
 * option and returns the selected option.
 *
 */
const WGDROPDOWN_ASYNC_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => WgDropdownAsyncComponent),
  multi: true
};
class WgDropdownAsyncComponent {
  set dropdownMenu(dropdownMenu) {
    if (this._dropdownMenu !== dropdownMenu) {
      this._dropdownMenu = dropdownMenu;
      this.scrollToActiveItem();
    }
  }
  constructor(elementRef, globalEventService) {
    this.elementRef = elementRef;
    this.globalEventService = globalEventService;
    // TODO - ControlValueAccessor
    this.hostClassWgDropdown = true;
    this.isDisabled = false;
    this.isInvalid = false;
    this.showSuggestion = false;
    this.placeHolderText = '';
    this.typeahead = false;
    this.label = 'name';
    this.selectedEvent = new EventEmitter();
    this.inputValue = '';
    this.ie11KeyMap = {
      down: 'arrowdown',
      up: 'arrowup',
      esc: 'escape'
    };
  }
  ngOnDestroy() {
    this.documentClickUnsubscribe();
    if (this.dataSource) {
      this.dataSource.disconnect();
    }
  }
  closeDropDown(event) {
    if (event.close) {
      this.toggleDropdown(false);
    }
  }
  getHeight() {
    const maxHeight = 340;
    const itemHeight = 34;
    const itemsHeight = this.dataSource.getDataLength() * itemHeight;
    const finalHeight = itemsHeight > maxHeight ? maxHeight : itemsHeight;
    return finalHeight + 'px';
  }
  inputChanged() {
    this.selectedEvent.emit(null);
    this.hoveredItemId = null;
    this.activeItemId = null;
    this.dataSource.setFilter(this.inputValue);
    this.toggleDropdown(true);
  }
  itemHovered(item, index) {
    if (!item || this.isDisabled) {
      return;
    }
    this.hoveredItemId = item.id;
  }
  ngOnChanges(changes) {
    if (changes.dataSource) {
      //TODO - DataSource change
      this.isLoading$ = this.dataSource.getLoadingStream().pipe(debounceTime(200), distinctUntilChanged(), tap(isLoading => {
        if (!isLoading) {
          setTimeout(() => this._dropdownMenu && this._dropdownMenu.checkViewportSize());
        }
      }), shareReplay(1));
    }
  }
  itemBlurred() {
    this.hoveredItemId = null;
  }
  itemSelected(item, event) {
    event && event.preventDefault();
    if (this.isDisabled || !item) {
      event && event.stopImmediatePropagation();
      return;
    }
    this.hoveredItemId = item.id;
    this.inputValue = item[this.label];
    this.toggleDropdown(false);
    this.selectedEvent.emit(item);
    this.activeItemId = item.id;
    this.dataSource.setFilter('');
  }
  keydown(event) {
    let key = event.key.toLowerCase();
    key = this.ie11KeyMap[key] || key;
    switch (key) {
      case 'arrowup':
        event.preventDefault();
        this.setPreviousIndex();
        this.toggleDropdown(true);
        break;
      case 'arrowdown':
        event.preventDefault();
        this.setNextIndex();
        this.toggleDropdown(true);
        break;
      case 'enter':
        if (this.hoveredItemId) {
          const hoveredItem = this.dataSource.getItemById(this.hoveredItemId);
          this.itemSelected(hoveredItem);
        } else {
          this.toggleDropdown(true);
        }
        break;
      case 'tab':
      case 'escape':
        this.toggleDropdown(false);
        break;
    }
  }
  setNextIndex() {
    const hoveredItemIndex = this.dataSource.getItemIndexById(this.hoveredItemId);
    if (hoveredItemIndex < this.dataSource.getDataLength() - 1) {
      const hoveredItem = this.dataSource.getItemByIndex(hoveredItemIndex + 1);
      this.hoveredItemId = hoveredItem.id;
    } else {
      const hoveredItem = this.dataSource.getItemByIndex(0);
      this.hoveredItemId = hoveredItem.id;
    }
    this.scrollToActiveItem();
  }
  setPreviousIndex() {
    const hoveredItemIndex = this.dataSource.getItemIndexById(this.hoveredItemId);
    if (hoveredItemIndex > 0) {
      const hoveredItem = this.dataSource.getItemByIndex(hoveredItemIndex - 1);
      this.hoveredItemId = hoveredItem.id;
    } else {
      const hoveredItem = this.dataSource.getItemByIndex(this.dataSource.getDataLength() - 1);
      this.hoveredItemId = hoveredItem.id;
    }
    this.scrollToActiveItem();
  }
  toggleDropdown(toggleTo = !this.showSuggestion) {
    if (this.isDisabled) {
      return;
    }
    this.showSuggestion = toggleTo;
    if (this.showSuggestion) {
      this.documentClickSubscribe();
      setTimeout(() => {
        this._dropdownMenu && this._dropdownMenu.checkViewportSize();
      });
    } else {
      this.documentClickUnsubscribe();
    }
  }
  documentClickSubscribe() {
    if (!this.documentClick$ || this.documentClick$.closed) {
      this.documentClick$ = this.globalEventService.documentClicked.subscribe(event => {
        const eventTarget = event.target;
        if (eventTarget && !this.elementRef.nativeElement.contains(eventTarget)) {
          this.toggleDropdown(false);
        }
      });
    }
  }
  documentClickUnsubscribe() {
    if (this.documentClick$) {
      this.documentClick$.unsubscribe();
    }
  }
  scrollToActiveItem() {
    if (this._dropdownMenu) {
      const id = this.hoveredItemId || this.activeItemId;
      const index = this.dataSource.getItemIndexById(id);
      this._dropdownMenu.scrollToIndex(index - 3);
    }
  }
  static {
    this.ɵfac = function WgDropdownAsyncComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgDropdownAsyncComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(GlobalEventService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgDropdownAsyncComponent,
      selectors: [["wg-dropdown-async"]],
      viewQuery: function WgDropdownAsyncComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c33, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdownMenu = _t.first);
        }
      },
      hostVars: 8,
      hostBindings: function WgDropdownAsyncComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("wg-dropdown", ctx.hostClassWgDropdown)("disabled", ctx.isDisabled)("invalid", ctx.isInvalid)("show-dropdown", ctx.showSuggestion);
        }
      },
      inputs: {
        isDisabled: "isDisabled",
        isInvalid: "isInvalid",
        userSelection: "userSelection",
        dataSource: "dataSource",
        placeHolderText: "placeHolderText",
        typeahead: "typeahead",
        label: "label"
      },
      outputs: {
        selectedEvent: "selectedEvent"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([WGDROPDOWN_ASYNC_VALUE_ACCESSOR]), i0.ɵɵNgOnChangesFeature],
      decls: 14,
      vars: 30,
      consts: [["dropdownMenu", ""], [1, "dropdown", 3, "keydown"], [1, "input-group", 3, "clickOutside"], ["autocomplete", "off", "type", "text", 1, "form-control", 3, "click", "input", "ngModelChange", "title", "placeholder", "readonly", "disabled", "ngModel"], [1, "input-group-append"], ["tabindex", "-1", "type", "button", 1, "btn", "btn-primary", 3, "click", "disabled"], ["name", "expanded"], ["itemSize", "34", 1, "dropdown-menu"], ["href", "#", "class", "dropdown-item", 3, "hover", "active", "disabled", "title", "innerHTML", "click", "mouseenter", "mouseleave", 4, "cdkVirtualFor", "cdkVirtualForOf"], ["class", "dropdown-menu show", 4, "ngIf"], ["href", "#", 1, "dropdown-item", 3, "click", "mouseenter", "mouseleave", "title", "innerHTML"], [1, "dropdown-menu", "show"], [1, "dropdown-item", "disabled", 3, "click"]],
      template: function WgDropdownAsyncComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 1);
          i0.ɵɵlistener("keydown", function WgDropdownAsyncComponent_Template_div_keydown_0_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.keydown($event));
          });
          i0.ɵɵelementStart(1, "div", 2);
          i0.ɵɵlistener("clickOutside", function WgDropdownAsyncComponent_Template_div_clickOutside_1_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.closeDropDown($event));
          });
          i0.ɵɵelementStart(2, "input", 3);
          i0.ɵɵpipe(3, "translate");
          i0.ɵɵpipe(4, "translate");
          i0.ɵɵlistener("click", function WgDropdownAsyncComponent_Template_input_click_2_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.toggleDropdown());
          })("input", function WgDropdownAsyncComponent_Template_input_input_2_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.inputChanged());
          });
          i0.ɵɵtwoWayListener("ngModelChange", function WgDropdownAsyncComponent_Template_input_ngModelChange_2_listener($event) {
            i0.ɵɵrestoreView(_r1);
            i0.ɵɵtwoWayBindingSet(ctx.inputValue, $event) || (ctx.inputValue = $event);
            return i0.ɵɵresetView($event);
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "div", 4)(6, "button", 5);
          i0.ɵɵlistener("click", function WgDropdownAsyncComponent_Template_button_click_6_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.toggleDropdown());
          });
          i0.ɵɵelement(7, "wg-icon", 6);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(8, "cdk-virtual-scroll-viewport", 7, 0);
          i0.ɵɵpipe(10, "async");
          i0.ɵɵtemplate(11, WgDropdownAsyncComponent_a_11_Template, 4, 15, "a", 8);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(12, WgDropdownAsyncComponent_div_12_Template, 4, 3, "div", 9);
          i0.ɵɵpipe(13, "async");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵclassProp("disabled", ctx.isDisabled)("invalid", ctx.isInvalid);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("ng-invalid", ctx.isInvalid);
          i0.ɵɵproperty("title", i0.ɵɵpipeBind1(3, 22, ctx.placeHolderText))("placeholder", i0.ɵɵpipeBind1(4, 24, ctx.placeHolderText))("readonly", !ctx.typeahead)("disabled", ctx.isDisabled);
          i0.ɵɵtwoWayProperty("ngModel", ctx.inputValue);
          i0.ɵɵadvance(4);
          i0.ɵɵclassProp("btn-danger", ctx.isInvalid);
          i0.ɵɵproperty("disabled", ctx.isDisabled);
          i0.ɵɵadvance(2);
          i0.ɵɵstyleProp("display", ctx.showSuggestion && i0.ɵɵpipeBind1(10, 26, ctx.isLoading$) === false ? "block" : "none")("height", ctx.getHeight());
          i0.ɵɵclassProp("show", ctx.showSuggestion);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("cdkVirtualForOf", ctx.dataSource);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(13, 28, ctx.isLoading$) && ctx.showSuggestion);
        }
      },
      dependencies: [i1$2.NgIf, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgModel, WgIconComponent, i5.CdkFixedSizeVirtualScroll, i5.CdkVirtualForOf, i5.CdkVirtualScrollViewport, i1$2.AsyncPipe, i1$1.TranslatePipe, HighlightPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgDropdownAsyncComponent, [{
    type: Component,
    args: [{
      selector: 'wg-dropdown-async',
      providers: [WGDROPDOWN_ASYNC_VALUE_ACCESSOR],
      standalone: false,
      template: "<div class=\"dropdown\"\n    (keydown)=\"keydown($event)\">\n  <div class=\"input-group\"\n      (clickOutside)=\"closeDropDown($event)\"\n      [class.disabled]=\"isDisabled\"\n      [class.invalid]=\"isInvalid\">\n    <input autocomplete=\"off\"\n      class=\"form-control\"\n      type=\"text\"\n      [title]=\"placeHolderText | translate\"\n      [placeholder]=\"placeHolderText | translate\"\n      [readonly]=\"!typeahead\"\n      [disabled]=\"isDisabled\"\n      [class.ng-invalid]=\"isInvalid\"\n      (click)=\"toggleDropdown()\"\n      (input)=\"inputChanged()\"\n      [(ngModel)]=\"inputValue\">\n    <div class=\"input-group-append\">\n      <button tabindex=\"-1\"\n              class=\"btn btn-primary\"\n              type=\"button\"\n              [disabled]=\"isDisabled\"\n              [class.btn-danger]=\"isInvalid\"\n              (click)=\"toggleDropdown()\">\n        <wg-icon name=\"expanded\"></wg-icon>\n      </button>\n    </div>\n  </div>\n  <cdk-virtual-scroll-viewport\n    itemSize=\"34\"\n    class=\"dropdown-menu\"\n    #dropdownMenu\n    [style.display]=\"showSuggestion && (isLoading$ | async) === false ? 'block' : 'none'\"\n    [class.show]=\"showSuggestion\"\n    [style.height]=\"getHeight()\">\n    <a *cdkVirtualFor=\"let item of dataSource; let index = index\"\n      href=\"#\"\n      class=\"dropdown-item\"\n      [class.hover]=\"item.id === hoveredItemId\"\n      [class.active]=\"item.id === activeItemId\"\n      [class.disabled]=\"!item || !item[label]\"\n      [title]=\"(item && item[label] || 'ui_common_loading') | translate\"\n      [innerHTML]=\"(item && item[label] || 'ui_common_loading') | translate | highlight:(item && item[label] && inputValue)\"\n      (click)=\"itemSelected(item, $event)\"\n      (mouseenter)=\"itemHovered(item, index)\"\n      (mouseleave)=\"itemBlurred()\">\n    </a>\n  </cdk-virtual-scroll-viewport>\n\n  <div *ngIf=\"(isLoading$ | async) && showSuggestion\" class=\"dropdown-menu show\">\n    <a (click)=\"$event.stopImmediatePropagation()\" class=\"dropdown-item disabled\">{{ 'ui_common_loading' | translate }}</a>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: GlobalEventService
  }], {
    hostClassWgDropdown: [{
      type: HostBinding,
      args: ['class.wg-dropdown']
    }],
    isDisabled: [{
      type: HostBinding,
      args: ['class.disabled']
    }, {
      type: Input
    }],
    isInvalid: [{
      type: HostBinding,
      args: ['class.invalid']
    }, {
      type: Input
    }],
    showSuggestion: [{
      type: HostBinding,
      args: ['class.show-dropdown']
    }],
    userSelection: [{
      type: Input
    }],
    dataSource: [{
      type: Input
    }],
    placeHolderText: [{
      type: Input
    }],
    typeahead: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    selectedEvent: [{
      type: Output
    }],
    dropdownMenu: [{
      type: ViewChild,
      args: ['dropdownMenu']
    }]
  });
})();

/**
 * @license
 * Copyright WatchGuard Technologies Inc. All Rights Reserved.
 *
 * This module exports WgDropdownComponent that renders a dropdown widget, lets user pick an
 * option and returns the selected option.
 *
 */
const REGEXP_KEY_CHAR = new RegExp('[a-z0-9]');
const MAX_SEARCH_HITS = 100;
const SEARCH_DEBOUNCE_TIME = 500;
const WGDROPDOWN_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => WgDropdownComponent),
  multi: true
};
class WgDropdownComponent {
  get isValidClass() {
    return this.isInvalid ? 'error-input' : '';
  }
  constructor(changeDetectorRef, globalEventService, elementRef, translateService) {
    this.changeDetectorRef = changeDetectorRef;
    this.globalEventService = globalEventService;
    this.elementRef = elementRef;
    this.translateService = translateService;
    this.hostClassWgDropdown = true;
    this.isDisabled = false;
    this.isInvalid = false;
    this.showSuggestion = false;
    this.typeahead = false;
    this.searchMode = false;
    this.searchModeShowAllWhenEmpty = false; // application when searchMode is true
    this.searchModeIgnoreIdWhenSearch = false; // application when searchMode is true,
    // if true, ignore id, just consider only val when search
    this.translateValues = true;
    this.selectedEvent = new EventEmitter();
    this.inputEvent = new EventEmitter();
    this.maxSearchHits = MAX_SEARCH_HITS;
    this.searchBarDebouncer = new Subject();
    // control value accessor functions
    this.onChange = _ => {};
    this.onTouched = () => {};
  }
  ngOnDestroy() {
    this.documentClickUnsubscribe();
    if (this.searchBarSub$) {
      this.searchBarSub$.unsubscribe();
    }
  }
  ngOnInit() {
    this.searchBarSub$ = this.searchBarDebouncer.pipe(debounceTime(SEARCH_DEBOUNCE_TIME)).subscribe(searchTxt => {
      this.inputEvent.emit(this.inputValue);
      this.filterValues(this.inputValue);
      // if the search bar text has changed, clear the selected item
      this.selectedItem = null;
      this.activateItem(null);
      this.selectedEvent.emit(null);
      this.onChange(null);
      if (this.inputValue.length > 0) {
        this.toggleDropdown(true);
      } else {
        if (this.searchMode && this.searchModeShowAllWhenEmpty) {
          // if input is blank, serchMode and serchModeShowAllWhenEmpty are true,
          // show all entries in the dropdown.
          this.toggleDropdown(true);
        } else {
          this.toggleDropdown(false);
        }
      }
      this.changeDetectorRef.detectChanges();
    });
  }
  ngOnChanges(changes) {
    // if title present, the view of the dropdown
    // would be set to value of the title
    if (this.title) {
      this.translateService.get(this.title).subscribe(translation => {
        this.inputValue = translation;
        this.changeDetectorRef.detectChanges();
      });
    }
    let userSelectionId;
    if (changes.hasOwnProperty('userSelection')) {
      if (!this.searchMode) {
        this.filterValues();
      }
      const name = changes.userSelection;
      if (!name.currentValue) {
        this.inputValue = '';
        this.selectedItem = undefined;
        this.changeDetectorRef.detectChanges();
      } else {
        userSelectionId = name.currentValue.id;
      }
    }
    if (changes.hasOwnProperty('dropdownList')) {
      this.filterValues();
      if (this.userSelection && userSelectionId === undefined) {
        userSelectionId = this.userSelection.id;
      }
    }
    if (userSelectionId !== undefined && userSelectionId !== null) {
      this.itemSelected(undefined, this.items.find(item => item.id === userSelectionId));
    }
    if (this.searchMode && this.searchModeShowAllWhenEmpty && (changes.hasOwnProperty('dropdownList') || changes.hasOwnProperty('userSelection'))) {
      if (this.searchBarSub$) {
        this.onSearchBarChange();
      } else {
        // give it a little more time for searchBarDebouncer to be setup.
        setTimeout(() => {
          this.onSearchBarChange();
        }, SEARCH_DEBOUNCE_TIME);
      }
    }
  }
  blur() {
    if (this.showSuggestion) {
      this.toggleDropdown();
    }
  }
  closeDropDown(event) {
    if (event.close) {
      this.toggleDropdown(false);
    }
  }
  onSearchBarChange() {
    this.searchBarDebouncer.next(this.inputValue);
  }
  inputFocus(event) {
    const target = event.target;
    if (!target || !this.typeahead) {
      return;
    }
    target.select();
  }
  itemHovered(event, item, hovered) {
    event.preventDefault();
    event.stopPropagation();
    if (this.isDisabled || item.separator === true || item.categoryLabel) {
      return;
    }
    if (hovered) {
      this.hoverItem(item);
    } else {
      item.hover = false;
    }
  }
  itemSelected(event, item) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.isDisabled || item.separator === true || item.categoryLabel) {
        return;
      }
    }
    if (item) {
      // if title present, dropdown is not a filter. So don't
      // change the view of dropdown
      if (!this.title) {
        this.activateItem(item);
        this.selectedItem = item;
        const selectedItemVal = `${this.selectedItem.val}`;
        this.translateService.get([selectedItemVal]).subscribe(translations => {
          this.inputValue = translations[selectedItemVal];
          this.changeDetectorRef.detectChanges();
        });
      }
      this.toggleDropdown(false);
      this.selectedEvent.emit(item);
      this.onChange(item);
      this.filterValues(undefined);
      this.changeDetectorRef.detectChanges();
    }
  }
  keydown(event) {
    let key = event.key.toLowerCase();
    // IE11 fix
    if (key === 'down') {
      key = 'arrowdown';
    }
    if (key === 'up') {
      key = 'arrowup';
    }
    if (key === 'esc') {
      key = 'escape';
    }
    let hoverItemIndex;
    switch (key) {
      case 'arrowup':
      case 'arrowdown':
        event.preventDefault();
        event.stopPropagation();
        const searchableItems = this.items.filter((item, index) => {
          return !item.separator && !item.categoryLabel;
        });
        if (!searchableItems || searchableItems.length === 0) {
          return;
        }
        hoverItemIndex = searchableItems.findIndex(item => {
          return item.hover === true;
        });
        if (hoverItemIndex === -1) {
          hoverItemIndex = searchableItems.findIndex(item => {
            return item.active === true;
          });
        }
        if (key === 'arrowup' && (hoverItemIndex === -1 || hoverItemIndex === 0)) {
          this.hoverItem(searchableItems[searchableItems.length - 1], true);
        } else if (key === 'arrowup') {
          this.hoverItem(searchableItems[hoverItemIndex - 1], true);
        } else if (key === 'arrowdown' && (hoverItemIndex === -1 || hoverItemIndex === searchableItems.length - 1)) {
          this.hoverItem(searchableItems[0], true);
        } else if (key === 'arrowdown') {
          this.hoverItem(searchableItems[hoverItemIndex + 1], true);
        }
        if (!this.showSuggestion) {
          this.clickToggleDropdown(); // will be ignored in searchMode
        }
        break;
      case 'enter':
        if (!this.showSuggestion) {
          this.clickToggleDropdown(); // will be ignored in searchMode
          return;
        }
        hoverItemIndex = this.items.findIndex(item => {
          return !item.separator && !item.categoryLabel && item.hover === true;
        });
        if (hoverItemIndex !== -1) {
          this.itemSelected(undefined, this.items[hoverItemIndex]);
        }
        break;
      case 'tab':
        if (this.inputEvent.observers.length === 0 && (!this.selectedItem || !this.selectedItem.val || this.selectedItem.val.length === 0 || !this.inputValue || this.inputValue.toLowerCase() !== this.translateService.instant(this.selectedItem.val).toLowerCase())) {
          // clear the value when tab key is pressed only if dropdown is not used as <input>
          this.inputValue = '';
          this.changeDetectorRef.detectChanges();
        }
        if (this.showSuggestion) {
          this.toggleDropdown();
        }
        break;
      case 'escape':
        if (this.showSuggestion) {
          this.toggleDropdown();
        }
        break;
      default:
        if (!this.typeahead) {
          if (!this.showSuggestion) {
            this.toggleDropdown();
          }
          if (event.key.length === 1 && REGEXP_KEY_CHAR.test(key)) {
            hoverItemIndex = this.items.findIndex(item => {
              return !item.separator && !item.categoryLabel && item.hover === true && item.val && item.val.toLowerCase().startsWith(key);
            });
            let itemMatch = this.items.find((item, index) => {
              return !item.separator && !item.categoryLabel && !item.hover && index > hoverItemIndex && item.val && item.val.toLowerCase().startsWith(event.key.toLowerCase());
            });
            if (itemMatch) {
              this.hoverItem(itemMatch, true);
            }
          }
        }
    }
  }
  clickToggleDropdown() {
    if (this.searchMode) {
      return;
    }
    this.toggleDropdown();
  }
  toggleDropdown(show) {
    if (this.isDisabled) {
      return;
    }
    this.showSuggestion = show !== undefined ? show : !this.showSuggestion;
    this.changeDetectorRef.detectChanges();
    if (this.showSuggestion) {
      this.documentClickSubscribe();
      if (!this.typeahead) {
        this.dropdownMenu.nativeElement.focus();
      }
      this.scrollToActiveItem();
    } else {
      this.documentClickUnsubscribe();
    }
  }
  // ControlValueAccessor interface implementation
  writeValue(initItem) {
    if (initItem) {
      const userSelectionId = initItem.id;
      this.itemSelected(undefined, this.items.find(item => item.id === userSelectionId));
    }
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled) {
    this.isDisabled = isDisabled;
  }
  clearInputValue() {
    this.inputValue = '';
    this.selectedItem = undefined;
    if (this.searchMode && this.searchModeShowAllWhenEmpty) {
      this.onSearchBarChange();
    } else {
      this.toggleDropdown(false);
      this.changeDetectorRef.detectChanges();
    }
  }
  activateItem(itemToActivate) {
    this.dropdownList.forEach(item => {
      item.active = false;
    });
    this.items.forEach(item => {
      item.active = false;
    });
    if (!itemToActivate) {
      return;
    }
    itemToActivate.active = true;
    const originalItem = this.dropdownList.find(findItem => findItem.id === itemToActivate.id);
    if (originalItem) {
      originalItem.active = true;
    }
    this.scrollToActiveItem();
  }
  createItemLabel(value, escapedTypeAheadValue) {
    if (!value || value.length === 0 || !escapedTypeAheadValue || escapedTypeAheadValue.length === 0) {
      return value;
    }
    let label = new String(value).toString();
    label = this.escpHtml(label);
    const regexp = new RegExp(escapedTypeAheadValue, 'gi');
    label = label.replace(regexp, str => {
      return '<span class="match">' + str + '</span>';
    });
    return label;
  }
  escpHtml(label) {
    if (label) {
      let returnStr = label.replace(/>/g, '&gt;');
      returnStr = returnStr.replace(/</g, '&lt;');
      return returnStr;
    } else {
      return '';
    }
  }
  documentClickSubscribe() {
    if (!this.documentClick$ || this.documentClick$.closed) {
      this.documentClick$ = this.globalEventService.documentClicked.subscribe(event => {
        const eventTarget = event.target;
        if (eventTarget && !this.elementRef.nativeElement.contains(eventTarget)) {
          // need to NOT call toggleDropdown(false) when searchMode and serchModeShowAllWhenEmpty are true.
          // So that the dropdown underneath the input is open when the dialog with this dropdown is being
          // shown.
          if (!(this.searchMode && this.searchModeShowAllWhenEmpty)) {
            this.toggleDropdown(false);
          }
        }
      });
    }
  }
  documentClickUnsubscribe() {
    if (this.documentClick$) {
      this.documentClick$.unsubscribe();
    }
  }
  filterValues(typeaheadValue) {
    this.items = [];
    if (!this.dropdownList || this.dropdownList.length === 0) {
      this.items = [];
    } else {
      let escapedTypeAheadValue = typeaheadValue;
      if (escapedTypeAheadValue) {
        escapedTypeAheadValue = escapedTypeAheadValue.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        escapedTypeAheadValue = this.escpHtml(escapedTypeAheadValue);
      }
      for (const item of this.dropdownList) {
        if (item.separator || item.categoryLabel) {
          this.items.push(item);
        } else if (!this.typeahead || typeaheadValue === undefined || item.val.toLowerCase().indexOf(typeaheadValue.toLowerCase()) !== -1 || (!this.searchMode || !this.searchModeIgnoreIdWhenSearch) && item.id.toString().toLowerCase().indexOf(typeaheadValue.toLocaleLowerCase()) !== -1) {
          this.items.push(Object.assign({}, item, {
            label: this.createItemLabel(item.val, escapedTypeAheadValue)
          }));
        }
        if (this.searchMode && this.items.length >= MAX_SEARCH_HITS) {
          break;
        }
      }
    }
  }
  hoverItem(itemToHover, scrollToItem) {
    this.items.forEach(item => {
      item.hover = false;
    });
    itemToHover.hover = true;
    if (scrollToItem) {
      this.scrollToHoveredItem();
    }
  }
  scrollToActiveItem() {
    this.scrollToItem('.active');
  }
  scrollToHoveredItem() {
    this.scrollToItem('.hover');
  }
  scrollToItem(className) {
    setTimeout(() => {
      if (this.showSuggestion) {
        this.changeDetectorRef.detectChanges();
        let item = this.dropdownMenu.nativeElement.querySelector(className);
        if (item) {
          this.dropdownMenu.nativeElement.scrollTop = item.offsetTop - 100;
        }
      }
    });
  }
  static {
    this.ɵfac = function WgDropdownComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgDropdownComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(GlobalEventService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgDropdownComponent,
      selectors: [["wg-dropdown"]],
      viewQuery: function WgDropdownComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c33, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdownMenu = _t.first);
        }
      },
      hostVars: 8,
      hostBindings: function WgDropdownComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("wg-dropdown", ctx.hostClassWgDropdown)("disabled", ctx.isDisabled)("invalid", ctx.isInvalid)("show-dropdown", ctx.showSuggestion);
        }
      },
      inputs: {
        isDisabled: "isDisabled",
        isInvalid: "isInvalid",
        placeHolderText: "placeHolderText",
        title: "title",
        userSelection: "userSelection",
        dropdownList: "dropdownList",
        typeahead: "typeahead",
        searchMode: "searchMode",
        searchModeShowAllWhenEmpty: "searchModeShowAllWhenEmpty",
        searchModeIgnoreIdWhenSearch: "searchModeIgnoreIdWhenSearch",
        translateValues: "translateValues"
      },
      outputs: {
        selectedEvent: "selectedEvent",
        inputEvent: "inputEvent"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([WGDROPDOWN_VALUE_ACCESSOR]), i0.ɵɵNgOnChangesFeature],
      decls: 12,
      vars: 27,
      consts: [["dropdownMenu", ""], [1, "dropdown", 3, "keydown"], [1, "input-group", 3, "click"], [4, "ngIf"], ["type", "text", "autocomplete", "off", 1, "form-control", 3, "input", "focus", "ngModelChange", "title", "ngModel", "placeholder", "readonly", "disabled", "ngClass"], [1, "input-group-append"], ["type", "button", "tabindex", "-1", 1, "btn", "btn-primary", 3, "disabled", "ngClass"], ["name", "expanded", 4, "ngIf"], ["name", "search", "class", "size-16", 4, "ngIf"], ["name", "close", "class", "size-16", 3, "click", 4, "ngIf"], ["class", "dropdown-menu", 3, "ngClass", 4, "ngIf"], [1, "input-group-prepend"], [3, "name"], ["name", "expanded"], ["name", "search", 1, "size-16"], ["name", "close", 1, "size-16", 3, "click"], [1, "dropdown-menu", 3, "ngClass"], ["class", "wg-px-20", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "wg-px-20"], ["class", "dropdown-item d-flex flex-row text-uppercase", 3, "class", 4, "ngIf"], ["href", "#", "class", "dropdown-item d-flex flex-row", 3, "class", "ngClass", "title", "mousedown", "mouseenter", "mouseleave", 4, "ngIf"], [1, "dropdown-item", "d-flex", "flex-row", "text-uppercase"], [1, "text-uppercase"], ["href", "#", 1, "dropdown-item", "d-flex", "flex-row", 3, "mousedown", "mouseenter", "mouseleave", "ngClass", "title"], ["class", "text-truncate", 3, "innerHTML", 4, "ngIf"], ["class", "table-status-label", 4, "ngIf"], [1, "text-truncate", 3, "innerHTML"], [1, "table-status-label"]],
      template: function WgDropdownComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 1);
          i0.ɵɵlistener("keydown", function WgDropdownComponent_Template_div_keydown_0_listener($event) {
            return ctx.keydown($event);
          });
          i0.ɵɵelementStart(1, "div", 2);
          i0.ɵɵlistener("click", function WgDropdownComponent_Template_div_click_1_listener() {
            return ctx.clickToggleDropdown();
          });
          i0.ɵɵtemplate(2, WgDropdownComponent_ng_container_2_Template, 3, 4, "ng-container", 3);
          i0.ɵɵelementStart(3, "input", 4);
          i0.ɵɵpipe(4, "translate");
          i0.ɵɵpipe(5, "translate");
          i0.ɵɵlistener("input", function WgDropdownComponent_Template_input_input_3_listener() {
            return ctx.onSearchBarChange();
          })("focus", function WgDropdownComponent_Template_input_focus_3_listener($event) {
            return ctx.inputFocus($event);
          });
          i0.ɵɵtwoWayListener("ngModelChange", function WgDropdownComponent_Template_input_ngModelChange_3_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.inputValue, $event) || (ctx.inputValue = $event);
            return $event;
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "div", 5)(7, "button", 6);
          i0.ɵɵtemplate(8, WgDropdownComponent_wg_icon_8_Template, 1, 0, "wg-icon", 7)(9, WgDropdownComponent_wg_icon_9_Template, 1, 0, "wg-icon", 8)(10, WgDropdownComponent_wg_icon_10_Template, 1, 0, "wg-icon", 9);
          i0.ɵɵelementEnd()()();
          i0.ɵɵtemplate(11, WgDropdownComponent_div_11_Template, 4, 5, "div", 10);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵclassProp("disabled", ctx.isDisabled)("invalid", ctx.isInvalid)("has-icon", ctx.selectedItem == null ? null : ctx.selectedItem.icon);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.searchMode && (ctx.selectedItem == null ? null : ctx.selectedItem.icon));
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(4, 19, ctx.placeHolderText));
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(5, 21, ctx.placeHolderText));
          i0.ɵɵtwoWayProperty("ngModel", ctx.inputValue);
          i0.ɵɵproperty("readonly", !ctx.typeahead)("disabled", ctx.isDisabled)("ngClass", i0.ɵɵpureFunction1(23, _c34, ctx.isInvalid));
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("disabled", ctx.isDisabled)("ngClass", i0.ɵɵpureFunction1(25, _c35, ctx.isInvalid));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.searchMode);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.searchMode && !ctx.inputValue);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.searchMode && ctx.inputValue);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showSuggestion);
        }
      },
      dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgModel, WgIconComponent, i1$1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgDropdownComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      selector: 'wg-dropdown',
      providers: [WGDROPDOWN_VALUE_ACCESSOR],
      standalone: false,
      template: "<div class=\"dropdown\"\n    (keydown)=\"keydown($event)\">\n  <div class=\"input-group\"\n      [class.disabled]=\"isDisabled\"\n      [class.invalid]=\"isInvalid\"\n      [class.has-icon]=\"selectedItem?.icon\"\n      (click)=\"clickToggleDropdown()\">\n    <ng-container *ngIf=\"!searchMode && selectedItem?.icon\">\n      <div class=\"input-group-prepend\">\n        <wg-icon [name]=\"selectedItem.icon\" class=\"{{ selectedItem.iconColorClass }}\"></wg-icon>\n      </div>\n    </ng-container>\n    <input\n      title=\"{{placeHolderText | translate }}\"\n      class=\"form-control\" type=\"text\"\n      (input)=\"onSearchBarChange()\"\n      (focus)=\"inputFocus($event)\"\n      [(ngModel)]=\"inputValue\"\n      placeholder=\"{{placeHolderText | translate }}\"\n      [readonly]=\"!typeahead\"\n      [disabled]=\"isDisabled\"\n      [ngClass]=\"{ 'ng-invalid': isInvalid }\"\n      autocomplete=\"off\">\n    <div class=\"input-group-append\">\n      <button [disabled]=\"isDisabled\"\n              [ngClass]=\"{ 'btn-danger': isInvalid }\"\n              class=\"btn btn-primary\"\n              type=\"button\"\n              tabindex=\"-1\">\n        <wg-icon *ngIf=\"!searchMode\" name=\"expanded\"></wg-icon>\n        <wg-icon *ngIf=\"searchMode && !inputValue\" name=\"search\" class=\"size-16\"></wg-icon>\n        <wg-icon *ngIf=\"searchMode && inputValue\" name=\"close\" class=\"size-16\" (click)=\"clearInputValue()\"></wg-icon>\n      </button>\n    </div>\n  </div>\n  <div #dropdownMenu class=\"dropdown-menu\" [ngClass]=\"{ show: showSuggestion }\" *ngIf=\"showSuggestion\">\n    <div *ngIf=\"searchMode && items.length >= maxSearchHits\" class=\"wg-px-20\">\n      <small>{{ \"enter_more_chars_to_search\" | translate: { count: maxSearchHits } }}</small>\n    </div>\n    <ng-container *ngFor=\"let item of items\">\n      <a *ngIf=\"item.categoryLabel\"\n        class=\"dropdown-item d-flex flex-row text-uppercase\"\n        [class]=\"item.cssClass\">\n        <label class=\"text-uppercase\">{{ item.val | translate }}</label>\n      </a>\n      <a *ngIf=\"!item.categoryLabel\"\n        href=\"#\"\n        class=\"dropdown-item d-flex flex-row\"\n        [class]=\"item.cssClass\"\n        [ngClass]=\"{ separator: item.separator, hover: item.hover, active: item.active }\"\n        (mousedown)=\"itemSelected($event, item)\"\n        (mouseenter)=\"itemHovered($event, item, true)\"\n        (mouseleave)=\"itemHovered($event, item, false)\"\n        title=\"{{ item.val | translate }}\">\n        <ng-container *ngIf=\"item.icon\">\n          <wg-icon [name]=\"item.icon\" class=\"wg-mr-5 {{ item.iconColorClass }}\"></wg-icon>\n        </ng-container>\n        <span class=\"text-truncate\" *ngIf=\"translateValues\" [innerHTML]=\"item.label ? (item.label | translate) : ''\"></span>\n        <span class=\"text-truncate\" *ngIf=\"!translateValues\" [innerHTML]=\"item.label ? (item.label) : ''\"></span>\n        <span class=\"table-status-label\" *ngIf=\"item.tag\">{{ item.tag | translate }}</span>\n      </a>\n    </ng-container>\n\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: GlobalEventService
  }, {
    type: i0.ElementRef
  }, {
    type: i1$1.TranslateService
  }], {
    hostClassWgDropdown: [{
      type: HostBinding,
      args: ['class.wg-dropdown']
    }],
    isDisabled: [{
      type: HostBinding,
      args: ['class.disabled']
    }, {
      type: Input
    }],
    isInvalid: [{
      type: HostBinding,
      args: ['class.invalid']
    }, {
      type: Input
    }],
    showSuggestion: [{
      type: HostBinding,
      args: ['class.show-dropdown']
    }],
    placeHolderText: [{
      type: Input
    }],
    title: [{
      type: Input
    }],
    userSelection: [{
      type: Input
    }],
    dropdownList: [{
      type: Input
    }],
    typeahead: [{
      type: Input
    }],
    searchMode: [{
      type: Input
    }],
    searchModeShowAllWhenEmpty: [{
      type: Input
    }],
    searchModeIgnoreIdWhenSearch: [{
      type: Input
    }],
    translateValues: [{
      type: Input
    }],
    selectedEvent: [{
      type: Output
    }],
    inputEvent: [{
      type: Output
    }],
    dropdownMenu: [{
      type: ViewChild,
      args: ['dropdownMenu']
    }]
  });
})();
class WgDropdownModule {
  static {
    this.ɵfac = function WgDropdownModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgDropdownModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgDropdownModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FormsModule, TranslateModule, WgIconModule, ScrollingModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgDropdownModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FormsModule, TranslateModule, WgIconModule, ScrollingModule],
      declarations: [WgDropdownComponent, WgDropdownAsyncComponent, HighlightPipe],
      exports: [WgDropdownComponent, WgDropdownAsyncComponent]
    }]
  }], null, null);
})();

/**
 * An abstract class currently used for both the wg-dropdown-menu and the wg-dropdown-mega-menu
 * as they both share a lot of similar code
 */
class AbstractWgDropdownMenuComponent {
  constructor(changeDetectorRef, elementRef, globalEventService) {
    this.changeDetectorRef = changeDetectorRef;
    this.elementRef = elementRef;
    this.globalEventService = globalEventService;
    this.alignment = 'right';
    this.showMenu = false;
    this.showMenuChange = new EventEmitter();
    this.icon = 'expanded';
  }
  ngAfterViewInit() {
    this.documentClick$ = this.globalEventService.documentClicked.subscribe(event => {
      const eventTarget = event.target;
      if (eventTarget && !this.elementRef.nativeElement.contains(eventTarget)) {
        this.toggleDropdown(false);
      }
    });
  }
  ngOnDestroy() {
    if (this.documentClick$) {
      this.documentClick$.unsubscribe();
    }
  }
  onDropdownMenuClick(event) {
    const target = event ? event.target : null;
    if (target && target.tagName && target.tagName.toLowerCase() === 'a' && this.showMenu) {
      this.setShowMenu(false);
    }
  }
  toggleDropdown(show) {
    this.setShowMenu(show !== undefined ? show : !this.showMenu);
  }
  setShowMenu(showMenu) {
    this.showMenu = showMenu;
    this.changeDetectorRef.markForCheck();
    this.showMenuChange.emit(showMenu);
  }
  static {
    this.ɵfac = function AbstractWgDropdownMenuComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AbstractWgDropdownMenuComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(GlobalEventService));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: AbstractWgDropdownMenuComponent,
      viewQuery: function AbstractWgDropdownMenuComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c33, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menuElementRef = _t.first);
        }
      },
      inputs: {
        alignment: "alignment",
        label: "label",
        showMenu: "showMenu"
      },
      outputs: {
        showMenuChange: "showMenuChange"
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AbstractWgDropdownMenuComponent, [{
    type: Directive
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: i0.ElementRef
  }, {
    type: GlobalEventService
  }], {
    alignment: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    showMenu: [{
      type: Input
    }],
    showMenuChange: [{
      type: Output
    }],
    menuElementRef: [{
      type: ViewChild,
      args: ['dropdownMenu']
    }]
  });
})();
class DropdownDataSource extends DataSource {
  // The default size is 100 which means the amount of data fetched from the backend per each request done, it can be customized as well
  constructor(fetchData, pageSize = 100) {
    super();
    this.fetchData = fetchData;
    this.pageSize = pageSize;
    this.fetchedPages = new Set();
    this.dataStream = new BehaviorSubject([]);
    this.paginatorStream = new BehaviorSubject({
      start: 0,
      end: this.pageSize
    });
    this.filterStream = new BehaviorSubject('');
    this.isLoadingStream = new BehaviorSubject(false);
    this.subscription = new Subscription();
    this.resetData = () => {
      this.dataStream.next([]);
      this.paginatorStream.next({
        start: 0,
        end: this.pageSize
      });
      this.fetchedPages = new Set();
    };
    this.dispatchPagesToBeRetrieved = ([page, filter]) => {
      let startPage = Math.floor(page.start / this.pageSize);
      const endPage = Math.floor((page.end - 1) / this.pageSize);
      const result = [];
      while (startPage <= endPage) {
        result.push({
          pageNumber: startPage,
          filter
        });
        startPage += 1;
      }
      return result;
    };
    this.fetchEachPageSimultaneously = ({
      pageNumber,
      filter
    }) => {
      // In case of the page is already loaded in the cache it should not call the backend
      if (this.fetchedPages.has(pageNumber)) {
        return of();
      }
      this.fetchedPages.add(pageNumber);
      return this.fetchData({
        pageNumber,
        pageSize: this.pageSize,
        filter
      }).pipe(retry(3),
      // 'TakeUntil' operator will be in charge to cancel ongoing request whenever the user type in new values in the filter
      takeUntil$1(this.filterStream.pipe(skip(1))),
      // Skiping the first event because we are dealing with BehaviourSubject
      map(fetchedData => ({
        fetchedData,
        pageNumber
      })), catchError(error => {
        this.fetchedPages.delete(pageNumber);
        console.error(error);
        return EMPTY; // Creates an Observable that emits no items to the Observer and immediately emits a complete notification
      }));
    };
    const subscription = combineLatest(this.paginatorStream, this.filterStream.pipe(debounceTime(300), distinctUntilChanged(), tap(this.resetData),
    // Whenever the user type in the cache and the pages should be cleaned
    tap(() => this.isLoadingStream.next(true)))).pipe(
    // Each page will be transformed into events in the stream
    switchMap(this.dispatchPagesToBeRetrieved),
    // Here will gathers all events and process them individually by making the calls to the backend
    mergeMap(this.fetchEachPageSimultaneously), tap(({
      fetchedData,
      pageNumber
    }) => {
      // In order to keep the previous data cached, it just refreshes the array with the total length when it is empty
      if (!this.dataStream.value.length) {
        this.dataStream.next(new Array(fetchedData.totalElements));
      }
      // Merge fetched data coming from the backend into the cached data
      const cachedDataCopy = [...this.dataStream.value];
      cachedDataCopy.splice(pageNumber * this.pageSize, this.pageSize, ...fetchedData.content);
      this.dataStream.next(cachedDataCopy);
    }), tap(() => this.isLoadingStream.next(false)), catchError(error => {
      this.isLoadingStream.next(false);
      throw error;
    })).subscribe();
    this.subscription.add(subscription);
  }
  getDataLength() {
    return this.dataStream.value.length;
  }
  getLoadingStream() {
    return this.isLoadingStream.asObservable();
  }
  setFilter(filter) {
    this.filterStream.next(filter);
  }
  connect(collectionViewer) {
    this.subscription.add(collectionViewer.viewChange.subscribe(range => {
      this.paginatorStream.next(range);
    }));
    return this.dataStream;
  }
  disconnect() {
    this.subscription.unsubscribe();
    this.dataStream.complete();
    this.paginatorStream.complete();
    this.filterStream.complete();
    this.isLoadingStream.complete();
  }
  getItemById(id) {
    return this.dataStream.value.find(item => item?.id === id);
  }
  getItemIndexById(id) {
    return this.dataStream.value.findIndex(item => item?.id === id);
  }
  getItemByIndex(index) {
    return this.dataStream.value[index];
  }
}
const GRID_ROW_HEIGHT = 5;
class WgDropdownMegaMenuComponent extends AbstractWgDropdownMenuComponent {
  constructor(changeDetectorRef, elementRef, globalEventService) {
    super(changeDetectorRef, elementRef, globalEventService);
    this.changeDetectorRef = changeDetectorRef;
    this.elementRef = elementRef;
    this.globalEventService = globalEventService;
  }
  ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  ngOnDestroy() {
    super.ngOnDestroy();
  }
  onDropdownMenuClick(event) {
    const target = event ? event.target : null;
    if (target && target.tagName && target.tagName.toLowerCase() === 'a' && this.showMenu) {
      this.setShowMenu(false);
    }
  }
  toggleDropdown(show) {
    super.toggleDropdown(show);
    if (this.showMenu) {
      this.calculateColumns();
      this.calculateGridStyles();
    }
  }
  calculateColumns() {
    if (this.manualColumns) {
      this.columns = this.manualColumns + 0;
    } else {
      const element = this.menuElementRef.nativeElement;
      this.columns = Math.min(element.querySelectorAll('ul').length, 3);
    }
  }
  /**
   * This is needed in order to have sections (<ul>) reflow into open positions
   * to better layout the content
   */
  calculateGridStyles() {
    const element = this.menuElementRef.nativeElement;
    const GRID_ROW_GAP = parseInt(getComputedStyle(element).gridRowGap, 10);
    for (let childrenIndex = 0; childrenIndex < element.children.length; childrenIndex++) {
      const child = element.children.item(childrenIndex);
      child.style.gridRow = 'span ' + Math.ceil((child.offsetHeight + GRID_ROW_GAP) / (GRID_ROW_HEIGHT + GRID_ROW_GAP));
    }
    element.style.gridTemplateColumns = `repeat(${this.columns}, 1fr)`;
    element.style.gridTemplateRows = GRID_ROW_HEIGHT + 'px';
    element.style.gridAutoRows = GRID_ROW_HEIGHT + 'px';
  }
  static {
    this.ɵfac = function WgDropdownMegaMenuComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgDropdownMegaMenuComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(GlobalEventService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgDropdownMegaMenuComponent,
      selectors: [["wg-dropdown-mega-menu"]],
      inputs: {
        manualColumns: [0, "columns", "manualColumns"]
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 8,
      vars: 8,
      consts: [["dropdownMenu", ""], [1, "dropdown"], [1, "dropdown-toggle", 3, "click"], [1, "size-24", 3, "name"], [1, "dropdown-menu", 3, "click", "ngClass", "hidden"]],
      template: function WgDropdownMegaMenuComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "h5", 1)(1, "a", 2);
          i0.ɵɵlistener("click", function WgDropdownMegaMenuComponent_Template_a_click_1_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.toggleDropdown());
          });
          i0.ɵɵtext(2);
          i0.ɵɵpipe(3, "translate");
          i0.ɵɵelement(4, "wg-icon", 3);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "div", 4, 0);
          i0.ɵɵlistener("click", function WgDropdownMegaMenuComponent_Template_div_click_5_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onDropdownMenuClick($event));
          });
          i0.ɵɵprojection(7);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, ctx.label), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("name", ctx.icon);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c39, ctx.alignment === "right"))("hidden", !ctx.showMenu);
        }
      },
      dependencies: [i1$2.NgClass, WgIconComponent, i1$1.TranslatePipe],
      styles: ["wg-dropdown-mega-menu h5{display:inline-block}wg-dropdown-mega-menu a{align-items:center;display:inline-flex}wg-dropdown-mega-menu .dropdown-toggle:after{display:none}wg-dropdown-mega-menu .dropdown-menu{display:block}wg-dropdown-mega-menu .dropdown .dropdown-menu{display:grid;grid-gap:15px 30px;max-height:999999px;padding:30px;white-space:nowrap}wg-dropdown-mega-menu .dropdown .dropdown-menu[hidden]{display:grid!important;left:-999999px;visibility:hidden}wg-dropdown-mega-menu .dropdown .dropdown-menu>ul{list-style:none;width:150px;margin:0;padding-left:0}wg-dropdown-mega-menu .dropdown .dropdown-menu>ul>li+li{margin-top:5px}wg-dropdown-mega-menu .dropdown .dropdown-menu>ul>li>h5{margin:15px 0 5px}wg-dropdown-mega-menu .dropdown .dropdown-menu>ul>li a,wg-dropdown-mega-menu .dropdown .dropdown-menu>ul>li a.dropdown-item{display:inline-block;font-weight:400;line-height:1.1;padding:0;white-space:normal;width:auto}wg-dropdown-mega-menu .dropdown .dropdown-menu>ul>li:first-child>h5{margin-top:0}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgDropdownMegaMenuComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      selector: 'wg-dropdown-mega-menu',
      standalone: false,
      template: "<h5 class=\"dropdown\">\n  <a class=\"dropdown-toggle\" (click)=\"toggleDropdown()\">\n    {{ label | translate }}\n    <wg-icon [name]=\"icon\" class=\"size-24\"></wg-icon>\n  </a>\n\n  <div #dropdownMenu class=\"dropdown-menu\"\n      (click)=\"onDropdownMenuClick($event)\"\n      [ngClass]=\"{ 'dropdown-menu-right': alignment === 'right' }\"\n      [hidden]=\"!showMenu\">\n    <ng-content></ng-content>\n  </div>\n</h5>\n\n",
      styles: ["wg-dropdown-mega-menu h5{display:inline-block}wg-dropdown-mega-menu a{align-items:center;display:inline-flex}wg-dropdown-mega-menu .dropdown-toggle:after{display:none}wg-dropdown-mega-menu .dropdown-menu{display:block}wg-dropdown-mega-menu .dropdown .dropdown-menu{display:grid;grid-gap:15px 30px;max-height:999999px;padding:30px;white-space:nowrap}wg-dropdown-mega-menu .dropdown .dropdown-menu[hidden]{display:grid!important;left:-999999px;visibility:hidden}wg-dropdown-mega-menu .dropdown .dropdown-menu>ul{list-style:none;width:150px;margin:0;padding-left:0}wg-dropdown-mega-menu .dropdown .dropdown-menu>ul>li+li{margin-top:5px}wg-dropdown-mega-menu .dropdown .dropdown-menu>ul>li>h5{margin:15px 0 5px}wg-dropdown-mega-menu .dropdown .dropdown-menu>ul>li a,wg-dropdown-mega-menu .dropdown .dropdown-menu>ul>li a.dropdown-item{display:inline-block;font-weight:400;line-height:1.1;padding:0;white-space:normal;width:auto}wg-dropdown-mega-menu .dropdown .dropdown-menu>ul>li:first-child>h5{margin-top:0}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: i0.ElementRef
  }, {
    type: GlobalEventService
  }], {
    manualColumns: [{
      type: Input,
      args: ['columns']
    }]
  });
})();
class WgDropdownMegaMenuModule {
  static {
    this.ɵfac = function WgDropdownMegaMenuModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgDropdownMegaMenuModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgDropdownMegaMenuModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, TranslateModule, WgIconModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgDropdownMegaMenuModule, [{
    type: NgModule,
    args: [{
      declarations: [WgDropdownMegaMenuComponent],
      exports: [WgDropdownMegaMenuComponent],
      imports: [CommonModule, TranslateModule, WgIconModule]
    }]
  }], null, null);
})();
class WgDropdownMenuComponent extends AbstractWgDropdownMenuComponent {
  constructor(changeDetectorRef, elementRef, globalEventService) {
    super(changeDetectorRef, elementRef, globalEventService);
    this.changeDetectorRef = changeDetectorRef;
    this.elementRef = elementRef;
    this.globalEventService = globalEventService;
  }
  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.fixMenuItemCssClasses();
  }
  fixMenuItemCssClasses() {
    if (this.menuElementRef) {
      const menuItems = this.menuElementRef.nativeElement.querySelectorAll('a');
      for (let index = 0; index < menuItems.length; index++) {
        menuItems[index].classList.add('dropdown-item');
      }
    }
  }
  static {
    this.ɵfac = function WgDropdownMenuComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgDropdownMenuComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(GlobalEventService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgDropdownMenuComponent,
      selectors: [["wg-dropdown-menu"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 8,
      vars: 8,
      consts: [["dropdownMenu", ""], [1, "dropdown"], [1, "dropdown-toggle", 3, "click"], [1, "size-24", 3, "name"], [1, "dropdown-menu", 3, "click", "ngClass", "hidden"]],
      template: function WgDropdownMenuComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "h5", 1)(1, "a", 2);
          i0.ɵɵlistener("click", function WgDropdownMenuComponent_Template_a_click_1_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.toggleDropdown());
          });
          i0.ɵɵtext(2);
          i0.ɵɵpipe(3, "translate");
          i0.ɵɵelement(4, "wg-icon", 3);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "div", 4, 0);
          i0.ɵɵlistener("click", function WgDropdownMenuComponent_Template_div_click_5_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onDropdownMenuClick($event));
          });
          i0.ɵɵprojection(7);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, ctx.label), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("name", ctx.icon);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c39, ctx.alignment === "right"))("hidden", !ctx.showMenu);
        }
      },
      dependencies: [i1$2.NgClass, WgIconComponent, i1$1.TranslatePipe],
      styles: ["h5[_ngcontent-%COMP%]{display:inline-block;margin-bottom:0}a[_ngcontent-%COMP%]{align-items:center;display:inline-flex}.dropdown-toggle[_ngcontent-%COMP%]:after{display:none}.dropdown-menu[_ngcontent-%COMP%]{display:block}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgDropdownMenuComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      selector: 'wg-dropdown-menu',
      standalone: false,
      template: "<h5 class=\"dropdown\">\n  <a class=\"dropdown-toggle\" (click)=\"toggleDropdown()\">\n    {{ label | translate }}\n    <wg-icon [name]=\"icon\" class=\"size-24\"></wg-icon>\n  </a>\n\n  <div #dropdownMenu class=\"dropdown-menu\"\n      (click)=\"onDropdownMenuClick($event)\"\n      [ngClass]=\"{ 'dropdown-menu-right': alignment === 'right' }\"\n      [hidden]=\"!showMenu\">\n    <ng-content></ng-content>\n  </div>\n</h5>\n\n",
      styles: ["h5{display:inline-block;margin-bottom:0}a{align-items:center;display:inline-flex}.dropdown-toggle:after{display:none}.dropdown-menu{display:block}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: i0.ElementRef
  }, {
    type: GlobalEventService
  }], null);
})();
class WgDropdownMenuModule {
  static {
    this.ɵfac = function WgDropdownMenuModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgDropdownMenuModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgDropdownMenuModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, TranslateModule, WgIconModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgDropdownMenuModule, [{
    type: NgModule,
    args: [{
      declarations: [WgDropdownMenuComponent],
      exports: [WgDropdownMenuComponent],
      imports: [CommonModule, TranslateModule, WgIconModule]
    }]
  }], null, null);
})();
class WgButtonDropdownMenuComponent extends AbstractWgDropdownMenuComponent {
  constructor(changeDetectorRef, elementRef, globalEventService) {
    super(changeDetectorRef, elementRef, globalEventService);
    this.changeDetectorRef = changeDetectorRef;
    this.elementRef = elementRef;
    this.globalEventService = globalEventService;
    this.color = 'primary';
    this.disabled = false;
    this.icon = 'expanded';
    this.variant = 'basic';
  }
  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.fixMenuItemCssClasses();
  }
  fixMenuItemCssClasses() {
    if (this.menuElementRef) {
      const menuItems = this.menuElementRef.nativeElement.querySelectorAll('a');
      for (let index = 0; index < menuItems.length; index++) {
        menuItems[index].classList.add('dropdown-item');
      }
    }
  }
  static {
    this.ɵfac = function WgButtonDropdownMenuComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgButtonDropdownMenuComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(GlobalEventService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgButtonDropdownMenuComponent,
      selectors: [["wg-button-dropdown-menu"]],
      inputs: {
        color: "color",
        disabled: "disabled",
        icon: "icon",
        variant: "variant"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 5,
      vars: 12,
      consts: [["dropdownMenu", ""], [1, "dropdown", 3, "ngClass"], ["iconPosition", "end", 1, "dropdown-toggle", 3, "click", "color", "icon", "label", "variant", "disabled"], [1, "dropdown-menu", 3, "click", "ngClass", "hidden"]],
      template: function WgButtonDropdownMenuComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 1)(1, "wg-button", 2);
          i0.ɵɵlistener("click", function WgButtonDropdownMenuComponent_Template_wg_button_click_1_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.toggleDropdown());
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(2, "div", 3, 0);
          i0.ɵɵlistener("click", function WgButtonDropdownMenuComponent_Template_div_click_2_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onDropdownMenuClick($event));
          });
          i0.ɵɵprojection(4);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c40, ctx.disabled));
          i0.ɵɵadvance();
          i0.ɵɵproperty("color", ctx.color)("icon", ctx.icon)("label", ctx.label)("variant", ctx.variant)("disabled", ctx.disabled);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c39, ctx.alignment === "right"))("hidden", !ctx.showMenu);
        }
      },
      dependencies: [i1$2.NgClass, WgButtonComponent],
      styles: ["wg-button-dropdown-menu{display:inline-block}wg-button-dropdown-menu div.dropdown{display:inline-block;margin-bottom:0}wg-button-dropdown-menu div.dropdown button{align-items:center;display:inline-flex}wg-button-dropdown-menu div.dropdown .dropdown-toggle:after{display:none}wg-button-dropdown-menu div.dropdown .dropdown-menu{display:block}wg-button-dropdown-menu div.dropdown.disabled button[disabled]{opacity:.4}wg-button-dropdown-menu div.dropdown.disabled button[disabled].btn-primary{background-color:#367b88;border:0 none;color:#fff}wg-button-dropdown-menu div.dropdown.disabled button[disabled].btn-primary svg,wg-button-dropdown-menu div.dropdown.disabled button[disabled].btn-primary path{fill:#fff}wg-button-dropdown-menu div.dropdown.disabled button[disabled].btn-secondary{background-color:#fff;border:1px solid #367b88;color:#367b88}wg-button-dropdown-menu div.dropdown.disabled button[disabled].btn-secondary svg,wg-button-dropdown-menu div.dropdown.disabled button[disabled].btn-secondary path{fill:#367b88}wg-button-dropdown-menu div.dropdown.disabled button[disabled].btn-danger{background-color:#cf0000;border:0 none;color:#fff}wg-button-dropdown-menu div.dropdown.disabled button[disabled].btn-danger svg,wg-button-dropdown-menu div.dropdown.disabled button[disabled].btn-danger path{fill:#fff}wg-button-dropdown-menu+wg-button-dropdown-menu,button+wg-button-dropdown-menu{margin-left:10px}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgButtonDropdownMenuComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      selector: 'wg-button-dropdown-menu',
      standalone: false,
      template: "<div class=\"dropdown\" [ngClass]=\"{ disabled: disabled }\">\n  <wg-button class=\"dropdown-toggle\"\n             [color]=\"color\"\n             [icon]=\"icon\"\n             iconPosition=\"end\"\n             [label]=\"label\"\n             [variant]=\"variant\"\n             (click)=\"toggleDropdown()\"\n             [disabled]=\"disabled\">\n  </wg-button>\n\n  <div #dropdownMenu class=\"dropdown-menu\"\n      (click)=\"onDropdownMenuClick($event)\"\n      [ngClass]=\"{ 'dropdown-menu-right': alignment === 'right' }\"\n      [hidden]=\"!showMenu\">\n    <ng-content></ng-content>\n  </div>\n</div>\n",
      styles: ["wg-button-dropdown-menu{display:inline-block}wg-button-dropdown-menu div.dropdown{display:inline-block;margin-bottom:0}wg-button-dropdown-menu div.dropdown button{align-items:center;display:inline-flex}wg-button-dropdown-menu div.dropdown .dropdown-toggle:after{display:none}wg-button-dropdown-menu div.dropdown .dropdown-menu{display:block}wg-button-dropdown-menu div.dropdown.disabled button[disabled]{opacity:.4}wg-button-dropdown-menu div.dropdown.disabled button[disabled].btn-primary{background-color:#367b88;border:0 none;color:#fff}wg-button-dropdown-menu div.dropdown.disabled button[disabled].btn-primary svg,wg-button-dropdown-menu div.dropdown.disabled button[disabled].btn-primary path{fill:#fff}wg-button-dropdown-menu div.dropdown.disabled button[disabled].btn-secondary{background-color:#fff;border:1px solid #367b88;color:#367b88}wg-button-dropdown-menu div.dropdown.disabled button[disabled].btn-secondary svg,wg-button-dropdown-menu div.dropdown.disabled button[disabled].btn-secondary path{fill:#367b88}wg-button-dropdown-menu div.dropdown.disabled button[disabled].btn-danger{background-color:#cf0000;border:0 none;color:#fff}wg-button-dropdown-menu div.dropdown.disabled button[disabled].btn-danger svg,wg-button-dropdown-menu div.dropdown.disabled button[disabled].btn-danger path{fill:#fff}wg-button-dropdown-menu+wg-button-dropdown-menu,button+wg-button-dropdown-menu{margin-left:10px}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: i0.ElementRef
  }, {
    type: GlobalEventService
  }], {
    color: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    icon: [{
      type: Input
    }],
    variant: [{
      type: Input
    }]
  });
})();
class WgButtonDropdownMenuModule {
  static {
    this.ɵfac = function WgButtonDropdownMenuModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgButtonDropdownMenuModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgButtonDropdownMenuModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, TranslateModule, WgButtonModule, WgIconModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgButtonDropdownMenuModule, [{
    type: NgModule,
    args: [{
      declarations: [WgButtonDropdownMenuComponent],
      exports: [WgButtonDropdownMenuComponent],
      imports: [CommonModule, TranslateModule, WgButtonModule, WgIconModule]
    }]
  }], null, null);
})();
class Notification {
  constructor(type = NotificationType.Info, message, keepAfterRouteChange = false, autohideOptions = {}, id, title, messageLinkRoute, messageLinkLabel, messageLinkClickedCallback, customTemplate) {
    this.type = type;
    this.message = message;
    this.keepAfterRouteChange = keepAfterRouteChange;
    this.autohide = autohideOptions.autohide || false;
    this.autohideTimeout = autohideOptions.timeout || AUTOHIDE_BANNER_MILLISECONDS;
    this.id = id;
    this.title = title;
    this.messageLinkRoute = messageLinkRoute;
    this.messageLinkLabel = messageLinkLabel;
    this.messageLinkClickedCallback = messageLinkClickedCallback;
    this.customTemplate = customTemplate;
  }
  get type() {
    return this._type;
  }
  set type(type) {
    if (type === undefined || type === null) {
      this._type = NotificationType.Info;
    } else {
      this._type = type;
    }
    this.typeClass = NotificationType[type.valueOf()].toLowerCase();
  }
  messageLinkClicked() {
    if (this.messageLinkClickedCallback) {
      this.messageLinkClickedCallback();
    }
  }
}
class ClearSettings {
  constructor(type, clearKeepAfterRouteChange) {
    this.type = type;
    this.clearKeepAfterRouteChange = clearKeepAfterRouteChange;
  }
}
var NotificationType;
(function (NotificationType) {
  NotificationType[NotificationType["Info"] = 0] = "Info";
  NotificationType[NotificationType["Success"] = 1] = "Success";
  NotificationType[NotificationType["Warn"] = 2] = "Warn";
  NotificationType[NotificationType["Error"] = 3] = "Error";
})(NotificationType || (NotificationType = {}));
const AUTOHIDE_BANNER_MILLISECONDS = 5000;
class WgInlineNotificationComponent {
  constructor() {
    this.type = 'info';
    // eslint-disable-next-line @angular-eslint/no-input-rename
    this.allowClose = false;
    // eslint-disable-next-line @angular-eslint/no-output-native
    this.close = new EventEmitter();
    this.messageLinkClick = new EventEmitter();
    this.icon = 'circle-info';
    this.show = true;
  }
  ngOnChanges(changes) {
    if (changes.type !== undefined) {
      if (changes.type.currentValue === 'error') {
        this.icon = 'circle-exclamation';
      } else if (changes.type.currentValue === 'warn') {
        this.icon = 'attention-line';
      } else if (changes.type.currentValue === 'success') {
        this.icon = 'circle-check-line';
      } else {
        this.icon = 'circle-info';
      }
    }
  }
  getNotification() {
    let notificationType;
    if (this.type === 'error') {
      notificationType = NotificationType.Error;
    } else if (this.type === 'warn') {
      notificationType = NotificationType.Warn;
    } else if (this.type === 'success') {
      notificationType = NotificationType.Success;
    } else {
      notificationType = NotificationType.Info;
    }
    return new Notification(notificationType, this.message, undefined, undefined, this.notificationId, this.title, this.messageLinkRoute, this.messageLinkLabel);
  }
  messageLinkClicked() {
    this.messageLinkClick.emit(this.getNotification());
  }
  removeNotification() {
    this.show = false;
    this.close.emit(this.getNotification());
  }
  static {
    this.ɵfac = function WgInlineNotificationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgInlineNotificationComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgInlineNotificationComponent,
      selectors: [["wg-inline-notification"]],
      inputs: {
        notificationId: "notificationId",
        message: "message",
        title: "title",
        type: "type",
        allowClose: [0, "allow-close", "allowClose"],
        messageLinkRoute: "messageLinkRoute",
        messageLinkLabel: "messageLinkLabel",
        messageLinkLabelOnNewLine: "messageLinkLabelOnNewLine",
        customTemplate: "customTemplate"
      },
      outputs: {
        close: "close",
        messageLinkClick: "messageLinkClick"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 1,
      vars: 1,
      consts: [[3, "class", 4, "ngIf"], [3, "name"], [4, "ngIf"], [4, "ngTemplateOutlet"], [1, "notification-text"], [3, "routerLink", "click", 4, "ngIf"], ["class", "notification-close-link", 3, "click", 4, "ngIf"], [3, "click", "routerLink"], [1, "notification-close-link", 3, "click"], ["name", "close"]],
      template: function WgInlineNotificationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, WgInlineNotificationComponent_div_0_Template, 4, 9, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.show);
        }
      },
      dependencies: [i1$2.NgIf, i1$2.NgTemplateOutlet, i2$1.RouterLink, WgIconComponent, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgInlineNotificationComponent, [{
    type: Component,
    args: [{
      selector: 'wg-inline-notification',
      standalone: false,
      template: "<div class=\"notification {{ type }}\" *ngIf=\"show\">\n  <wg-icon class=\"notification-icon {{ type }}\"\n           [name]=\"icon\">\n  </wg-icon>\n\n  <ng-container *ngIf=\"customTemplate\">\n    <ng-container \n      *ngTemplateOutlet=\"customTemplate\">\n    </ng-container>\n  </ng-container>\n  <ng-container *ngIf=\"!customTemplate\">\n    <h5 *ngIf=\"title\">{{ title | translate }}</h5>\n    <span class=\"notification-text\">\n      {{ message | translate }}\n      <ng-container *ngIf=\"messageLinkLabel && messageLinkLabelOnNewLine\">\n        <br><br>\n      </ng-container>\n      <a [routerLink]=\"messageLinkRoute\" *ngIf=\"messageLinkLabel\" (click)=\"messageLinkClicked()\">{{ messageLinkLabel | translate }}</a>\n    </span>\n    <a class=\"notification-close-link\"\n      (click)=\"removeNotification()\"\n      *ngIf=\"allowClose\">\n      <wg-icon name=\"close\"></wg-icon>\n    </a>\n  </ng-container>\n</div>\n"
    }]
  }], () => [], {
    notificationId: [{
      type: Input
    }],
    message: [{
      type: Input
    }],
    title: [{
      type: Input
    }],
    type: [{
      type: Input
    }],
    allowClose: [{
      type: Input,
      args: ['allow-close']
    }],
    messageLinkRoute: [{
      type: Input
    }],
    messageLinkLabel: [{
      type: Input
    }],
    messageLinkLabelOnNewLine: [{
      type: Input
    }],
    customTemplate: [{
      type: Input
    }],
    close: [{
      type: Output
    }],
    messageLinkClick: [{
      type: Output
    }]
  });
})();
class WgInlineNotificationModule {
  static {
    this.ɵfac = function WgInlineNotificationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgInlineNotificationModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgInlineNotificationModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, RouterModule, TranslateModule, WgIconModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgInlineNotificationModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, TranslateModule, WgIconModule],
      declarations: [WgInlineNotificationComponent],
      exports: [WgInlineNotificationComponent]
    }]
  }], null, null);
})();
class WgNotificationsService {
  constructor(router) {
    this.router = router;
    this.notificationSubject = new Subject();
    this.clearNotificationsSubject = new Subject();
    // clear alert messages on route change unless 'keepAfterRouteChange' flag is true
    router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.clear(undefined);
      }
    });
  }
  clear(type, clearKeepAfterRouteChange = false) {
    this.clearNotificationsSubject.next(new ClearSettings(type, clearKeepAfterRouteChange));
  }
  success(message, keepAfterRouteChange = false, autohideOptions, messageLinkRoute, messageLinkLabel) {
    if (!autohideOptions) {
      autohideOptions = {
        autohide: true,
        timeout: AUTOHIDE_BANNER_MILLISECONDS
      };
    }
    this.notify(NotificationType.Success, message, keepAfterRouteChange, autohideOptions, messageLinkRoute, messageLinkLabel);
  }
  custom(customTemplate, notificationType = NotificationType.Info, keepAfterRouteChange = false, autohideOptions, messageLinkRoute, messageLinkLabel, messageLinkClickedCallback) {
    this.notify(notificationType, null, keepAfterRouteChange, autohideOptions, messageLinkRoute, messageLinkLabel, messageLinkClickedCallback, customTemplate);
  }
  info(message, keepAfterRouteChange = false, autohideOptions, messageLinkRoute, messageLinkLabel, messageLinkClickedCallback) {
    this.notify(NotificationType.Info, message, keepAfterRouteChange, autohideOptions, messageLinkRoute, messageLinkLabel, messageLinkClickedCallback);
  }
  error(message, keepAfterRouteChange = false, autohideOptions, messageLinkRoute, messageLinkLabel, messageLinkClickedCallback) {
    this.notify(NotificationType.Error, message, keepAfterRouteChange, autohideOptions, messageLinkRoute, messageLinkLabel, messageLinkClickedCallback);
  }
  warn(message, keepAfterRouteChange = false, autohideOptions, messageLinkRoute, messageLinkLabel, messageLinkClickedCallback) {
    this.notify(NotificationType.Warn, message, keepAfterRouteChange, autohideOptions, messageLinkRoute, messageLinkLabel, messageLinkClickedCallback);
  }
  notify(type, message, keepAfterRouteChange = false, autohideOptions, messageLinkRoute, messageLinkLabel, messageLinkClickedCallback, customTemplate) {
    if (message && message.trim() !== '') {
      const notification = new Notification(type, message, keepAfterRouteChange, autohideOptions, undefined, undefined, messageLinkRoute, messageLinkLabel, messageLinkClickedCallback);
      this.notificationSubject.next(notification);
    }
    if (customTemplate) {
      const notification = new Notification(type, message, keepAfterRouteChange, autohideOptions, undefined, undefined, messageLinkRoute, messageLinkLabel, messageLinkClickedCallback, customTemplate);
      this.notificationSubject.next(notification);
    }
  }
  static {
    this.ɵfac = function WgNotificationsService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgNotificationsService)(i0.ɵɵinject(i2$1.Router));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: WgNotificationsService,
      factory: WgNotificationsService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgNotificationsService, [{
    type: Injectable
  }], () => [{
    type: i2$1.Router
  }], null);
})();

/**
 * @license
 * Copyright WatchGuard Technologies Inc. All Rights Reserved.
 *
 * This module exports the WgNotificationsComponent
 *
 */
class WgNotificationsComponent {
  constructor(notificationService) {
    this.notificationService = notificationService;
    this.notifications = [];
    this.notificationTypes = NotificationType;
  }
  ngOnDestroy() {
    this.clearNotificationsSubscription.unsubscribe();
    this.notificationSubscription.unsubscribe();
  }
  ngOnInit() {
    this.notificationSubscription = this.notificationService.notificationSubject.subscribe(notification => {
      const notificationWrapper = new NotificationWrapper(notification);
      this.notifications.push(notificationWrapper);
      setTimeout(() => {
        notificationWrapper.fadeIn = true;
      });
      const index = this.notifications.length - 1;
      if (notificationWrapper.autohide) {
        // Hide the notification banner for messages
        notificationWrapper.timeout = setTimeout(() => {
          this.hideNotification(notificationWrapper);
        }, notificationWrapper.autohideTimeout);
      }
    });
    this.clearNotificationsSubscription = this.notificationService.clearNotificationsSubject.subscribe(clearSettings => {
      if (this.notifications.length > 0) {
        for (let i = this.notifications.length - 1; i >= 0; i--) {
          if ((clearSettings.type === undefined || clearSettings.type === null || clearSettings.type === this.notifications[i].type) && (this.notifications[i].keepAfterRouteChange === false || clearSettings.clearKeepAfterRouteChange === true)) {
            this.notifications.splice(i, 1);
          }
        }
      }
    });
  }
  hideNotification(notificationWrapper) {
    if (notificationWrapper.fadeOut === true) {
      return;
    }
    notificationWrapper.fadeIn = false;
    notificationWrapper.fadeOut = true;
    if (notificationWrapper.timeout !== undefined) {
      clearTimeout(notificationWrapper.timeout);
      notificationWrapper.timeout = undefined;
    }
    setTimeout(() => {
      const index = this.notifications.indexOf(notificationWrapper);
      if (index >= 0) {
        this.notifications.splice(index, 1);
      }
    }, 500); // this number should match the milliseconds for the fade out animation
  }
  messageLinkClicked(event) {
    event.messageLinkClicked();
  }
  static {
    this.ɵfac = function WgNotificationsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgNotificationsComponent)(i0.ɵɵdirectiveInject(WgNotificationsService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgNotificationsComponent,
      selectors: [["wg-notifications"]],
      standalone: false,
      decls: 2,
      vars: 0,
      consts: [[3, "class", "fade-in", "fade-out"], ["name", "circle-info", 3, "class"], ["name", "circle-check-line", 3, "class"], ["name", "circle-exclamation", 3, "class"], ["name", "attention-line", 3, "class"], ["name", "circle-info"], ["name", "circle-check-line"], ["name", "circle-exclamation"], ["name", "attention-line"], [4, "ngTemplateOutlet"], [1, "notification-text"], [3, "routerLink", "click", 4, "ngIf"], [1, "notification-close-link", 3, "click"], ["name", "close"], [3, "click", "routerLink"]],
      template: function WgNotificationsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵrepeaterCreate(0, WgNotificationsComponent_For_1_Template, 7, 9, "div", 0, i0.ɵɵrepeaterTrackByIndex);
        }
        if (rf & 2) {
          i0.ɵɵrepeater(ctx.notifications);
        }
      },
      dependencies: [i1$2.NgIf, i1$2.NgTemplateOutlet, i2$1.RouterLink, WgIconComponent, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgNotificationsComponent, [{
    type: Component,
    args: [{
      selector: 'wg-notifications',
      standalone: false,
      template: "@for (notification of notifications; track $index) {\n  <div class=\"notification {{ notification.typeClass }}\"\n      [class.fade-in]=\"notification.fadeIn\"\n      [class.fade-out]=\"notification.fadeOut\">\n\n    @switch (notification.type) {\n      @case (notificationTypes.Info) {\n        <wg-icon class=\"notification-icon {{ notification.typeClass }}\" name=\"circle-info\"></wg-icon>\n      }\n      @case (notificationTypes.Success) {\n        <wg-icon class=\"notification-icon {{ notification.typeClass }}\" name=\"circle-check-line\"></wg-icon>\n      }\n      @case (notificationTypes.Error) {\n        <wg-icon class=\"notification-icon {{ notification.typeClass }}\" name=\"circle-exclamation\"></wg-icon>\n      }\n      @case (notificationTypes.Warn) {\n        <wg-icon class=\"notification-icon {{ notification.typeClass }}\" name=\"attention-line\"></wg-icon>\n      }\n    }\n\n    @if (notification.customTemplate) {\n      <ng-container *ngTemplateOutlet=\"notification.customTemplate\"></ng-container>\n    } @else {\n      <span class=\"notification-text\">\n        {{ notification.message | translate }}\n        <a [routerLink]=\"notification.messageLinkRoute\" *ngIf=\"notification.messageLinkLabel\" (click)=\"messageLinkClicked(notification)\">{{ notification.messageLinkLabel | translate }}</a>\n      </span>\n      <a class=\"notification-close-link\"\n        (click)=\"hideNotification(notification)\">\n        <wg-icon name=\"close\"></wg-icon>\n      </a>\n    }\n  </div>\n}\n"
    }]
  }], () => [{
    type: WgNotificationsService
  }], null);
})();
class NotificationWrapper extends Notification {
  constructor(notification) {
    super(notification.type, notification.message, notification.keepAfterRouteChange, {
      autohide: notification.autohide,
      timeout: notification.autohideTimeout
    }, undefined, undefined, notification.messageLinkRoute, notification.messageLinkLabel, notification.messageLinkClickedCallback, notification.customTemplate);
    this.fadeIn = false;
    this.fadeOut = false;
  }
}
class WgNotificationsModule {
  static {
    this.ɵfac = function WgNotificationsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgNotificationsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgNotificationsModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, RouterModule, TranslateModule, WgIconModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgNotificationsModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, TranslateModule, WgIconModule],
      declarations: [WgNotificationsComponent],
      exports: [WgNotificationsComponent]
    }]
  }], null, null);
})();
const STATUS_TEXT = {
  IN_PROGRESS: 'in_progress',
  IN_QUEUE: 'queued',
  READY_TO_DOWNLOAD: 'ready_to_download',
  FAILED: 'failed'
};
const DOWNLOAD_FORMAT = {
  PDF: 'pdf',
  CSV: 'csv',
  ZIP: 'zip'
};
var AsyncReportServices;
(function (AsyncReportServices) {
  AsyncReportServices[AsyncReportServices["inventory"] = 0] = "inventory";
  AsyncReportServices[AsyncReportServices["threatsync"] = 1] = "threatsync";
})(AsyncReportServices || (AsyncReportServices = {}));
const DefaultConfigurations = {
  "threatsync": {
    "name": "threatsync",
    "labels": {
      "generic_error_msg": "generic_error_msg",
      "async_download_reports": "async_download_reports",
      "async_reports_error_msg": "async_reports_error_msg",
      "async_reports_error_title": "async_reports_error_title",
      "async_report_errors_title": "async_report_errors_title",
      "async_report_ready_to_download": "async_report_ready_to_download",
      "async_number_reports_ready_to_download": "async_number_reports_ready_to_download",
      "async_reports_available_for_1_day_notification": "async_reports_available_for_1_day_notification"
    },
    "endpoints": {
      "baseUrl": "visibility-reports/v2",
      "status": "{baseUrl}/{accountId}/reports/async/status",
      "download": "{baseUrl}/{accountId}/reports/async/action"
    },
    "services": {
      "serviceLabel": "threat_sync",
      "serviceV2Label": "ThreatSyncV2",
      "managePermissionLBL": "canManageThreatSync",
      "guardUrlService": "dimension",
      "withCloud": true
    },
    "useGuardApi": false,
    "preAccountId": "",
    "isPresignedUrl": false,
    "isMultipleToasterApproach": false
  },
  "inventory": {
    "name": "inventory",
    "labels": {
      "generic_error_msg": "generic_error_msg",
      "async_download_reports": "async_download_reports_IF",
      "async_reports_error_msg": "file_download_error_message_IF",
      "async_reports_error_title": "async_reports_error_title",
      "async_report_errors_title": "async_report_errors_title",
      "async_report_ready_to_download": "your_report_ready_to_download_IF",
      "async_number_reports_ready_to_download": "your_report_ready_to_download_IF",
      "async_reports_available_for_1_day_notification": "exported_csv_available_notification_IF"
    },
    "endpoints": {
      "baseUrl": "inventory-fwk-mw/v1/asyncreports/allocations/summary",
      "status": "{baseUrl}/status",
      "singleStatus": "{baseUrl}/{requestId}/status",
      "download": "{baseUrl}/{requestId}/{operation}"
    },
    "services": {
      "serviceLabel": "",
      "serviceV2Label": "",
      "managePermissionLBL": "",
      "guardUrlService": "",
      "withCloud": false
    },
    "useGuardApi": true,
    "preAccountId": "",
    "isPresignedUrl": true,
    "isMultipleToasterApproach": true
  }
};
class WgAsyncReportsService {
  constructor(http) {
    this.http = http;
    this.positionHolder = [];
    this.statusPollingSub$ = [];
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
  }
  // To poll status api at specific interval
  asyncReportStatusPolling(intervalNum, accountId, guardUrlParam, baseUrl, endpoint, withCloud, useGuardApi) {
    return interval(intervalNum).pipe(switchMap$1(() => this.fetchAsyncReportStatus(accountId, guardUrlParam, baseUrl, endpoint, withCloud, useGuardApi)));
  }
  // Status check api
  fetchAsyncReportStatus(accountId, guardUrlParam, baseUrl, endpoint, withCloud, useGuardApi) {
    const url = this.formatUrl(accountId, guardUrlParam, baseUrl, endpoint, withCloud, '', '', useGuardApi);
    return this.http.get(url, {
      headers: this.headers
    });
  }
  // if !isMultiToaster: for downloading reports
  downloadAsyncReports(accountId, body, guardUrlParam, baseUrl, endpoint, withCloud, useGuardApi) {
    const url = this.formatUrl(accountId, guardUrlParam, baseUrl, endpoint, withCloud, null, null, useGuardApi);
    return this.http.post(url, body, {
      headers: this.headers,
      observe: 'response',
      responseType: 'blob'
    });
  }
  // if isMultiToaster: for downloading reports (XDR)
  opeartionOnAsyncReports(accountId, guardUrlParam, baseUrl, endpoint, withCloud, requestId, operation, useGuardApi) {
    const url = this.formatUrl(accountId, guardUrlParam, baseUrl, endpoint, withCloud, requestId, operation, useGuardApi);
    return this.http.get(url, {
      headers: this.headers
    });
  }
  getPresignedUrl(accountId, body, guardUrlParam, baseUrl, endpoint, useGuardApi) {
    const url = this.formatUrl(accountId, guardUrlParam, baseUrl, endpoint, null, null, null, useGuardApi);
    return this.http.get(url, {
      headers: this.headers
    });
  }
  getGuardUrl(service, override = '', withCloud, useGuardApi) {
    const options = {
      service,
      region: 'usa',
      override,
      withCloud
    };
    if (window.location.host.indexOf('watchguard.com') !== -1) {
      options.override = '';
    }
    return useGuardApi ? newGuardApiUrl(options) : newGuardUrl(options);
  }
  // Check if reports are ready and instruct to stop polling
  isReportReady(statusData) {
    return statusData.length ? statusData.every(statusObj => statusObj.status === STATUS_TEXT.READY_TO_DOWNLOAD || statusObj.status === STATUS_TEXT.FAILED) : true;
  }
  // Replace actual entity values with actual values as per config
  formatUrl(accountId, guardUrlParam, baseUrl, endpoint, withCloud, requestId, operation, useGuardApi) {
    const url = `${this.getGuardUrl(guardUrlParam, '', withCloud, useGuardApi)}${baseUrl}`;
    endpoint = endpoint.replace("{baseUrl}", url)?.replace("{accountId}", accountId)?.replace("{requestId}", requestId)?.replace("{operation}", operation);
    return endpoint;
  }
  // As per the selected service get default configuration for async reports
  getReportConfig(service) {
    return DefaultConfigurations[service];
  }
  // Get list of all active services for async reports
  getActiveServices() {
    return AsyncReportServices;
  }
  static {
    this.ɵfac = function WgAsyncReportsService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgAsyncReportsService)(i0.ɵɵinject(i1.HttpClient));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: WgAsyncReportsService,
      factory: WgAsyncReportsService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgAsyncReportsService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }], null);
})();
const SPACE_CONST = 10;
const WIDTH_CONST = 140;
const ERROR_WIDTH = 80;
const POLLING_DELAY = 10000;
class WgAsyncReportsComponent {
  constructor(baseService, translateService, granularRBACService, notificationService, asyncReportsNotificationService) {
    this.baseService = baseService;
    this.translateService = translateService;
    this.granularRBACService = granularRBACService;
    this.notificationService = notificationService;
    this.asyncReportsNotificationService = asyncReportsNotificationService;
    this.isErrToasterHidden = true;
    this.servicesCount = 0;
    this.config = [];
    this.statusData = [];
    this.notificationObjects = [];
    this.errorNotificationObject = [];
  }
  ngOnChanges(changes) {
    // Check first time if any reports are ready or in-progress for threatsync
    // Continue polling if any in-progress tasks else stop
    // this is to get the default configuration based on the current service, ex: threatsync, inventory etc
    if (changes?.inProgressService?.currentValue && this.preAccountId && this.inProgressServicesEnum) {
      this.servicesCount = Object.keys(this.inProgressServicesEnum).filter(key => isNaN(Number(key)))?.length;
      const index = this.inProgressServicesEnum[this.inProgressService];
      this.config = this.config ?? [];
      const inProgressService = changes?.inProgressService?.currentValue;
      this.config[index] = DefaultConfigurations[inProgressService];
      if (this.config[index]) {
        // Set Default strings
        this.errorMsg = this.config[index]?.labels?.async_reports_error_msg;
        this.config[index].preAccountId = this.preAccountId;
        this.checkPollReports();
        // Check first time if any reports are ready or in-progress
        // Continue polling if any in-progress tasks else stop
        this.selfInitiateFirstStatusCheck(this.config[index].name);
      }
    }
  }
  ngOnDestroy() {
    this.asyncReportsNotificationService.statusPollingSub$[this.getCurrentIndex(this.inProgressService, this.inProgressServicesEnum)]?.unsubscribe();
  }
  checkPollReports() {
    // Recieve notification to check status
    this.baseService.asyncReportGenerationInitiated$.subscribe(serviceName => {
      const config = DefaultConfigurations[serviceName];
      const index = this.getCurrentIndex(config.name, this.inProgressServicesEnum);
      this.config[index] = config;
      if (config?.services?.serviceLabel && config?.services?.managePermissionLBL) {
        this.granularRBACService.hasPermissionGranularRbacObservable(config.services.serviceLabel, config.services.serviceLabel, config.services.serviceV2Label, config.services.managePermissionLBL, config.preAccountId).subscribe(hasPermission => {
          if (hasPermission) {
            this.pollForStatus(config, index);
          }
        });
      } else {
        this.pollForStatus(config, index);
      }
    });
  }
  selfInitiateFirstStatusCheck(serviceName) {
    this.baseService.asyncReportGenerationInitiated(serviceName);
  }
  pollForStatus(config, index) {
    this.asyncReportsNotificationService.statusPollingSub$[index]?.unsubscribe();
    this.asyncReportsNotificationService.statusPollingSub$[index] = this.asyncReportsNotificationService.asyncReportStatusPolling(POLLING_DELAY, this.preAccountId, config.services.guardUrlService, config.endpoints.baseUrl, config.endpoints.status, config.services.withCloud, config.useGuardApi).subscribe({
      next: statusData => {
        this.stopPollingIfComplete(statusData, index);
        this.statusData[index] = [];
        // Filter out only valid/required status objects 
        this.statusData[index] = statusData.filter(status => status.status === STATUS_TEXT.IN_PROGRESS || status.status === STATUS_TEXT.IN_QUEUE || status.status === STATUS_TEXT.READY_TO_DOWNLOAD || status.status === STATUS_TEXT.FAILED);
        // Add unique id to each status object for identification in the form of '1_threatsync' ...
        this.statusData[index] = this.statusData[index]?.map((data, index) => {
          return {
            ...data,
            id: `${index + 1}_${config.name}`,
            index: this.inProgressServicesEnum[config.name]
          };
        });
        if (this.statusData[index]?.length) {
          // For single toster condition -> ex: threatsync
          if (!config.isMultipleToasterApproach) {
            // Success toasters to showcase downlaod option with file Url
            const readyForDownloadObjects = statusData.filter(statusObj => statusObj.status === STATUS_TEXT.READY_TO_DOWNLOAD);
            const numberOfReports = readyForDownloadObjects.length;
            if (numberOfReports) {
              this.notificationObjects[index] = [];
              this.notificationObjects[index] = [{
                id: this.statusData[index][0].id,
                title: numberOfReports === 1 ? this.translateService.instant(config.labels.async_report_ready_to_download) : `${numberOfReports} ${this.translateService.instant(config.labels.async_number_reports_ready_to_download)}`,
                message: this.translateService.instant(config.labels.async_reports_available_for_1_day_notification),
                type: "success",
                isMultiToaster: config.isMultipleToasterApproach,
                index: this.inProgressServicesEnum[config.name],
                downloadMessage: config?.labels?.async_download_reports
              }];
            }
          } else {
            // Success toasters to showcase downlaod option with presigned Url
            const readyForDownloadObjects = this.statusData[index]?.filter(statusObj => statusObj.status === STATUS_TEXT.READY_TO_DOWNLOAD);
            this.notificationObjects[index] = [];
            if (readyForDownloadObjects?.length) {
              this.notificationObjects[index] = readyForDownloadObjects.map((successStatus, secIndex) => {
                return {
                  id: successStatus.id,
                  requestId: successStatus.request_id || successStatus.requestId,
                  title: `${this.translateService.instant(config.labels.async_number_reports_ready_to_download)}`,
                  message: this.translateService.instant(config.labels.async_reports_available_for_1_day_notification),
                  type: "success",
                  isMultiToaster: config.isMultipleToasterApproach,
                  index: this.inProgressServicesEnum[config.name],
                  downloadMessage: config?.labels?.async_download_reports
                };
              });
            }
          }
          // Error toaster to showcase number of reports failed. 
          this.numberOfFailedReports = this.statusData[index]?.filter(statusObj => statusObj.status === STATUS_TEXT.FAILED)?.length ?? 0;
          if (this.numberOfFailedReports) {
            this.failedErrorTitle = `
          ${this.numberOfFailedReports} ${this.numberOfFailedReports === 1 ? this.translateService.instant(config.labels.async_reports_error_title) : this.translateService.instant(config.labels.async_report_errors_title)}`;
          }
          this.isErrToasterHidden = true;
          // making error toaster state for each service
          this.errorNotificationObject[index] = [{
            id: `${Math.floor(Math.random() * (999 - 101 + 1)) + 101}_${this.inProgressService}`,
            positionVariable: "",
            title: this.failedErrorTitle,
            message: "",
            type: "error",
            numberOfFailedReports: this.numberOfFailedReports,
            isMultiToaster: config.isMultipleToasterApproach,
            index: this.inProgressServicesEnum[config.name]
          }];
          if (this.notificationObjects[index]?.length) {
            this.notificationObjects[index] = this.addPositionToSuccessToaster(this.notificationObjects[index], index);
          }
          const isEmpty = this.errorNotificationObject.some((_, index) => !(index in this.errorNotificationObject));
          if (index === this.servicesCount - 1 && !isEmpty) {
            this.errorNotificationObject = this.addPositionToErrorToaster(this.errorNotificationObject, this.notificationObjects[index], index);
            this.isErrToasterHidden = false;
          } else {
            this.isErrToasterHidden = !isEmpty;
          }
          // Check if no status available or all are completed, stop polling
          this.isToasterHidden = false;
        }
      },
      error: () => this.notificationService.error(this.translateService.instant(this.config[index].labels.generic_error_msg))
    });
  }
  // If user closes notification without downloading
  reportNotificationClosed(currentNotificationObj) {
    const index = currentNotificationObj.index;
    // Stop polling logic if all reports have failed or ready to download status
    this.stopPollingIfComplete(this.statusData[index], index);
    if (!currentNotificationObj.isMultiToaster) {
      // If not multi toaster, call download
      this.callIgnore(STATUS_TEXT.READY_TO_DOWNLOAD, currentNotificationObj);
    } else {
      // If multi toaster, check if operation is download or ignore and call api
      this.callIgnore(null, currentNotificationObj);
    }
  }
  errorNotificationClosed(errNotification) {
    const index = errNotification.index;
    this.stopPollingIfComplete(this.statusData[index], index);
    if (!errNotification.isMultiToaster) {
      this.callIgnore(STATUS_TEXT.FAILED, errNotification);
      this.numberOfFailedReports = 0;
    } else {
      this.callIgnore(null, errNotification);
    }
  }
  stopPollingIfComplete(statusData, index) {
    if (!statusData?.length || this.asyncReportsNotificationService.isReportReady(statusData)) {
      this.asyncReportsNotificationService.statusPollingSub$[index]?.unsubscribe();
    }
  }
  callIgnore(status, notification) {
    const index = notification.index;
    if (!notification.isMultiToaster) {
      const ignoreObjects = this.transformUrlOnClose(this.statusData[index], status);
      this.asyncReportsNotificationService.downloadAsyncReports(this.preAccountId, ignoreObjects[0], this.config[index].services.guardUrlService, this.config[index].endpoints.baseUrl, this.config[index].endpoints.download, this.config[index].services.withCloud, this.config[index].useGuardApi).subscribe({
        next: () => {
          this.removeClosedNotification(notification);
        },
        error: () => this.notificationService.error(this.translateService.instant(this.config[index].labels.generic_error_msg))
      });
    } else {
      const requestId = this.getRequestId(notification, index);
      if (requestId) {
        this.asyncReportsNotificationService.opeartionOnAsyncReports(this.preAccountId, this.config[index].services.guardUrlService, this.config[index].endpoints.baseUrl, this.config[index].endpoints.download, this.config[index].services.withCloud, requestId, 'dismiss', this.config[index].useGuardApi).subscribe({
          next: () => {
            this.removeClosedNotification(notification);
          },
          error: () => this.notificationService.error(this.translateService.instant(this.config[index].labels.generic_error_msg))
        });
      }
    }
  }
  removeClosedNotification(notification) {
    Array.from({
      length: this.servicesCount
    }, (_, index) => index).forEach(index => {
      this.notificationObjects[index] = this.notificationObjects[index]?.filter(obj => obj.id !== notification.id);
      this.errorNotificationObject[index] = this.errorNotificationObject[index]?.filter(errObj => errObj.id !== notification.id);
    });
  }
  reportNotificationLinkClicked(notificationObject) {
    const index = notificationObject.index;
    if (!notificationObject?.isMultiToaster) {
      const readyObjects = this.transformUrl(this.statusData[index]);
      readyObjects.forEach(readyObj => {
        this.asyncReportsNotificationService.downloadAsyncReports(this.preAccountId, readyObj, this.config[index].services.guardUrlService, this.config[index].endpoints.baseUrl, this.config[index].endpoints.download, this.config[index].services.withCloud, this.config[index].useGuardApi).subscribe({
          next: response => {
            const contentDisposition = response.headers.get('content-disposition');
            if (!contentDisposition) return;
            const contentType = response.headers.get('content-type')?.split('/')[1];
            const filename = contentDisposition.split('filename=')[1].replace(/"|\.zip|\.pdf/g, '');
            downloadFile(response.body, filename, contentType === DOWNLOAD_FORMAT.PDF ? DOWNLOAD_FORMAT.PDF : DOWNLOAD_FORMAT.ZIP);
            this.notificationObjects = [];
          },
          error: () => this.notificationService.error(this.translateService.instant(this.config[index].labels.generic_error_msg))
        });
      });
    } else {
      // If we need to call action api
      const requestId = this.getRequestId(notificationObject, index);
      if (requestId) {
        this.asyncReportsNotificationService.opeartionOnAsyncReports(this.preAccountId, this.config[index].services.guardUrlService, this.config[index].endpoints.baseUrl, this.config[index].endpoints.download, this.config[index].services.withCloud, requestId, 'download', this.config[index].useGuardApi).subscribe({
          next: data => {
            this.saveFile(data.presigned_url, this.getFileNameFromUrl(data.presigned_url));
            this.notificationObjects[index] = this.notificationObjects[index].filter(notification => notification.id !== notificationObject.id);
          },
          error: () => this.notificationService.error(this.translateService.instant(this.config[index].labels.generic_error_msg))
        });
      }
    }
  }
  saveFile(url, fileName) {
    // Create a link element for downloading
    const link = document.createElement('a');
    link.style.display = 'none'; // to keep it hidden
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link); // Append the link to the DOM
    link.click(); // Trigger the download
    document.body.removeChild(link); // Remove the link to clean up
  }
  getFileNameFromUrl(url) {
    // Extract the file name from the URL (after the last '/')
    return url.substring(url.lastIndexOf('/') + 1).split('?')[0];
  }
  getRequestId(notificationObject, index) {
    return this.statusData[index].find(status => notificationObject.id === status.id)?.requestId;
  }
  transformUrl(statusData) {
    const readyObjects = statusData.filter(statusObj => statusObj.status === STATUS_TEXT.READY_TO_DOWNLOAD);
    return readyObjects.map(readyObj => {
      return {
        download: readyObj.file_path
      };
    });
  }
  transformUrlOnClose(statusData, statusToIgnore) {
    const readyObjects = statusData.filter(statusObj => statusObj.status === statusToIgnore).map(statusObj => statusObj.file_path);
    return [{
      "ignore": readyObjects
    }];
  }
  getNotificationPosition(index, len) {
    let positionHolder = this.asyncReportsNotificationService.positionHolder;
    if (!positionHolder) {
      positionHolder = [];
    }
    if (!positionHolder[index]) {
      positionHolder[index] = [];
    }
    let startPosition = SPACE_CONST;
    // Check the last position of all previous services
    for (let i = 0; i < index; i++) {
      if (positionHolder[i]?.length) {
        const lastPosition = positionHolder[i]?.at(-1);
        startPosition = Math.max(startPosition, lastPosition + WIDTH_CONST + SPACE_CONST);
      }
    }
    // Calculate positions for the current service
    positionHolder[index] = Array.from({
      length: len
    }, (_, i) => {
      return startPosition + i * (WIDTH_CONST + SPACE_CONST);
    });
    // Handle subsequent services if needed
    if (index < positionHolder.length - 1) {
      this.asyncReportsNotificationService.positionHolder[index + 1] = this.getNotificationPosition(index + 1, positionHolder[index + 1].length);
    }
    this.asyncReportsNotificationService.positionHolder[index] = positionHolder[index];
    return positionHolder[index];
  }
  addPositionToSuccessToaster(notificationObjects, index) {
    const positionVariables = this.getNotificationPosition(index, notificationObjects?.length);
    notificationObjects = notificationObjects?.map((notificationObj, index) => {
      return {
        ...notificationObj,
        positionVariable: `${positionVariables[index]}px`
      };
    });
    return notificationObjects;
  }
  addPositionToErrorToaster(errorObjects, notificationObject, index) {
    const positionVariable = notificationObject[this.notificationObjects[index].length - 1]?.positionVariable; // get previous position of last success toaster
    let newPosition = Number(positionVariable.split('px')[0]);
    let newErrorObject = [];
    errorObjects.forEach((errorObjCollection, outerInd) => {
      errorObjCollection.forEach((errorobj, innerInd) => {
        if (innerInd === 0 && outerInd === 0) {
          newPosition = newPosition + SPACE_CONST + WIDTH_CONST;
        } else {
          newPosition = newPosition + ERROR_WIDTH;
        }
        newErrorObject[outerInd] = [{
          ...errorobj,
          positionVariable: `${newPosition}px`
        }];
      });
    });
    return newErrorObject;
  }
  getCurrentIndex(inProgressService, inProgressServicesEnum) {
    return inProgressServicesEnum[inProgressService];
  }
  static {
    this.ɵfac = function WgAsyncReportsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgAsyncReportsComponent)(i0.ɵɵdirectiveInject(WgBaseService), i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(GranularRBACService), i0.ɵɵdirectiveInject(WgNotificationsService), i0.ɵɵdirectiveInject(WgAsyncReportsService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgAsyncReportsComponent,
      selectors: [["wgc-async-reports"]],
      inputs: {
        inProgressServicesEnum: "inProgressServicesEnum",
        preAccountId: "preAccountId",
        inProgressService: "inProgressService"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 2,
      vars: 2,
      consts: [["myTemplate", ""], ["class", "wrapper", 4, "ngIf"], [4, "ngIf"], [1, "wrapper"], [4, "ngFor", "ngForOf"], ["class", "notification-container", 3, "ngStyle", 4, "ngIf"], [1, "notification-container", 3, "ngStyle"], [3, "customTemplate", "type"], [1, "notification-text"], [1, "mt-3"], [3, "click"], [1, "notification-close-link", 3, "click"], ["name", "exit-line"], [3, "title", "message", "type", "allow-close", "close", 4, "ngIf"], [3, "close", "title", "message", "type", "allow-close"]],
      template: function WgAsyncReportsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, WgAsyncReportsComponent_div_0_Template, 2, 1, "div", 1)(1, WgAsyncReportsComponent_div_1_Template, 2, 1, "div", 2);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.notificationObjects == null ? null : ctx.notificationObjects.length);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", (ctx.errorNotificationObject == null ? null : ctx.errorNotificationObject.length) && !ctx.isErrToasterHidden);
        }
      },
      dependencies: [i1$2.NgForOf, i1$2.NgIf, i1$2.NgStyle, WgIconComponent, WgInlineNotificationComponent, i1$1.TranslatePipe],
      styles: [".notification-container[_ngcontent-%COMP%]{width:461px;position:fixed;right:55px;z-index:20000;display:inline-block}.notification-container[_ngcontent-%COMP%]   .notification-text[_ngcontent-%COMP%]{display:inline-block;min-height:38px}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgAsyncReportsComponent, [{
    type: Component,
    args: [{
      selector: 'wgc-async-reports',
      standalone: false,
      template: "<div class=\"wrapper\" *ngIf=\"notificationObjects?.length\">\n  <div *ngFor=\"let notifications of notificationObjects; let i = index\">\n    <div *ngFor=\"let notification of notifications\">\n\n      <div *ngIf=\"notification['type'] === 'success'\"\n        [ngStyle]=\"{ bottom: notification.positionVariable }\" \n        class=\"notification-container\">\n        <wg-inline-notification \n          [customTemplate]=\"myTemplate\" \n          [type]=\"'success'\">\n        </wg-inline-notification>\n\n        <!-- Inline ng-template specific to this loop -->\n        <ng-template #myTemplate>\n          <span *ngIf=\"!isToasterHidden\">\n            <h5 *ngIf=\"notificationObjects.length\">{{ notification.title }}</h5>\n            <span class=\"notification-text\">\n              {{ notification.message }}\n            </span>\n            <div class=\"mt-3\">\n              <a (click)=\"reportNotificationLinkClicked(notification)\">\n                {{ notification.downloadMessage | translate }}\n              </a>\n            </div>\n            <a class=\"notification-close-link\" (click)=\"reportNotificationClosed(notification)\">\n              <wg-icon name=\"exit-line\"></wg-icon>\n            </a>\n          </span>\n        </ng-template>\n      </div>\n    </div>\n    \n  </div>\n  \n</div>\n\n<div *ngIf=\"errorNotificationObject?.length && !isErrToasterHidden\">\n  <div *ngFor=\"let errNotifications of errorNotificationObject; let i = index\">\n    <div *ngFor=\"let notification of errNotifications\">\n      <div [ngStyle]=\"{ bottom: notification.positionVariable }\" class=\"notification-container\">\n        <wg-inline-notification *ngIf=\"notification.numberOfFailedReports\"\n          [title]=\"notification.title\"\n          [message]=\"notification.message\"\n          [type]=\"notification.type\"\n          [allow-close]=\"true\"\n          (close)=\"errorNotificationClosed(notification)\">\n        </wg-inline-notification>\n      </div>\n    </div>\n  </div>\n</div>\n",
      styles: [".notification-container{width:461px;position:fixed;right:55px;z-index:20000;display:inline-block}.notification-container .notification-text{display:inline-block;min-height:38px}\n"]
    }]
  }], () => [{
    type: WgBaseService
  }, {
    type: i1$1.TranslateService
  }, {
    type: GranularRBACService
  }, {
    type: WgNotificationsService
  }, {
    type: WgAsyncReportsService
  }], {
    inProgressServicesEnum: [{
      type: Input
    }],
    preAccountId: [{
      type: Input
    }],
    inProgressService: [{
      type: Input
    }]
  });
})();
function HttpLoaderFactory(http) {
  return new TranslateHttpLoader(http);
}
class WgAsyncReportsModule {
  static {
    this.ɵfac = function WgAsyncReportsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgAsyncReportsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgAsyncReportsModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideHttpClient(withInterceptorsFromDi())],
      imports: [CommonModule, WgIconModule, TranslateModule, WgNotificationsModule, WgInlineNotificationModule, TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      })]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgAsyncReportsModule, [{
    type: NgModule,
    args: [{
      declarations: [WgAsyncReportsComponent],
      exports: [WgAsyncReportsComponent],
      imports: [CommonModule, WgIconModule, TranslateModule, WgNotificationsModule, WgInlineNotificationModule, TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      })],
      providers: [provideHttpClient(withInterceptorsFromDi())]
    }]
  }], null, null);
})();
var ImageCropperImageFormat;
(function (ImageCropperImageFormat) {
  ImageCropperImageFormat["JPEG"] = "jpeg";
  ImageCropperImageFormat["PNG"] = "png";
})(ImageCropperImageFormat || (ImageCropperImageFormat = {}));
var ImageCropperOutputFormat;
(function (ImageCropperOutputFormat) {
  ImageCropperOutputFormat["BASE64"] = "base64";
  ImageCropperOutputFormat["BLOB"] = "blob";
})(ImageCropperOutputFormat || (ImageCropperOutputFormat = {}));

/**
 * @param inputLabel Translated key of file upload input
 * @param image Base64 or Blob of the cropped image
 * @param imageDescription Translated key of image description to be shown above the image
 * @param imageMaxSize Image max size (in bytes)
 * @param imageFormat Output Image format (png, jpeg)
 * @param outputFormat Output format (blob, base64)
 * @param aspectRatio The width/height ratio
 * @param maintainAspectRatio Keep width and height of cropped image equal according to the aspectRatio
 * @param containWithinAspectRatio When set to true, padding will be added around the image to make it fit to the aspect ratio
 * @param cropperMinWidth The cropper cannot be made smaller than this number of pixels in width (in px)
 * @param cropperMinHeight The cropper cannot be made smaller than this number of pixels in height (in px)
 * It will be ignored if maintainAspectRatio is set
 * @param cropperMaxWidth The cropper cannot be made bigger than this number of pixels in width (in px)
 * @param cropperMaxHeight The cropper cannot be made bigger than this number of pixels in height (in px)
 * @param dialogClosed Event emitted when the crop dialog is closed
 * @param imageSaved Event emitted when image is saved
 * @param loadImageFailed Event emitted when the load of the image failed
 */
class WgImageCropperComponent {
  constructor(translateService, notificationService) {
    this.translateService = translateService;
    this.notificationService = notificationService;
    this.imageFormat = ImageCropperImageFormat.PNG;
    this.outputFormat = ImageCropperOutputFormat.BLOB;
    this.aspectRatio = 1;
    this.maintainAspectRatio = true;
    this.containWithinAspectRatio = false;
    this.cropperMinWidth = 0;
    this.cropperMinHeight = 0;
    this.cropperMaxWidth = 0;
    this.cropperMaxHeight = 0;
    this.dialogClosed = new EventEmitter();
    this.imageSaved = new EventEmitter();
    this.loadImageFailed = new EventEmitter();
    this.isDialogOpen = false;
    this.showLoading = false;
    this.imageChangedEvent = '';
    this.droppedImage = '';
    this.croppedImage = '';
  }
  onImageChanged(event) {
    const file = event.originalEvent instanceof DragEvent ? event.files[0] : event.target.files[0];
    if (!this.isValidFile(file)) {
      return;
    }
    this.isDialogOpen = true;
    this.showLoading = true;
    this.croppedImage = '';
    if (event.originalEvent instanceof DragEvent) {
      const reader = new FileReader();
      reader.readAsDataURL(event.files[0]);
      reader.onload = _ => {
        this.droppedImage = reader.result.toString();
        this.showLoading = false;
      };
    } else {
      this.imageChangedEvent = event;
    }
  }
  onImageLoaded() {
    this.showLoading = false;
  }
  onImageCropped(event) {
    this.croppedImage = event.base64;
  }
  onLoadImageFailed() {
    this.showLoading = false;
    this.isDialogOpen = false;
    this.loadImageFailed.emit();
  }
  onDialogClosed() {
    this.isDialogOpen = false;
    this.dialogClosed.emit();
  }
  onImageSaved() {
    this.isDialogOpen = false;
    this.image = this.croppedImage;
    const image = this.outputFormat === ImageCropperOutputFormat.BASE64 ? this.croppedImage : base64ToFile(this.croppedImage);
    this.imageSaved.emit(image);
  }
  clearImage() {
    this.image = null;
  }
  isValidFile(file) {
    if (file.type.match(/(\.|\/)(jpe?g|png)$/) == null) {
      this.notificationService.error(this.translateService.instant('image_cropper_invalid_file_type_error_msg'));
      return false;
    }
    if (file.size > this.imageMaxSize) {
      if (this.imageMaxSizeErrorMessage) {
        this.notificationService.error(this.translateService.instant(this.imageMaxSizeErrorMessage));
      } else {
        this.notificationService.error(this.translateService.instant('image_cropper_invalid_file_size_error_msg', {
          maxSize: this.imageMaxSize
        }));
      }
      return false;
    }
    return true;
  }
  static {
    this.ɵfac = function WgImageCropperComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgImageCropperComponent)(i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(WgNotificationsService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgImageCropperComponent,
      selectors: [["wg-image-cropper"]],
      inputs: {
        inputLabel: "inputLabel",
        image: "image",
        imageDescription: "imageDescription",
        imageMaxSizeErrorMessage: "imageMaxSizeErrorMessage",
        imageMaxSize: "imageMaxSize",
        imageFormat: "imageFormat",
        outputFormat: "outputFormat",
        aspectRatio: "aspectRatio",
        maintainAspectRatio: "maintainAspectRatio",
        containWithinAspectRatio: "containWithinAspectRatio",
        cropperMinWidth: "cropperMinWidth",
        cropperMinHeight: "cropperMinHeight",
        cropperMaxWidth: "cropperMaxWidth",
        cropperMaxHeight: "cropperMaxHeight"
      },
      outputs: {
        dialogClosed: "dialogClosed",
        imageSaved: "imageSaved",
        loadImageFailed: "loadImageFailed"
      },
      standalone: false,
      decls: 29,
      vars: 28,
      consts: [["uploader", ""], ["imageCropperContainer", ""], ["hiddenfileselect", ""], [1, "form-group"], ["for", "icon"], [1, "card", "card-body", "card-image"], ["class", "image-description-container fs-block", 4, "ngIf"], [1, "image", "fs-block"], [3, "src", 4, "ngIf"], ["id", "icon", "name", "icon", "styleClass", "wg-file-upload", "url", "/", 3, "onSelect"], ["pTemplate", "content"], [3, "dialogClosedEvent", "showDialog"], ["dialog-title", ""], ["dialog-content", ""], [1, "form-group", "image-cropper-container"], ["output", "base64", 3, "imageLoaded", "imageCropped", "loadImageFailed", "imageChangedEvent", "format", "aspectRatio", "maintainAspectRatio", "containWithinAspectRatio", "cropperMinWidth", "cropperMinHeight", "cropperMaxWidth", "cropperMaxHeight", "imageBase64"], [3, "scale", "modal", "ovelayElement", 4, "ngIf"], ["dialog-footer", ""], [1, "ui-dialog-buttonpane", "ui-widget-content", "ui-helper-clearfix"], ["type", "button", 1, "btn", "ft-btn-close-dialog", 3, "click"], ["type", "button", 1, "btn", "btn-primary", "ft-btn-save-image", 3, "click"], [1, "image-description-container", "fs-block"], [1, "text-center"], [3, "src"], [1, "ft-upload-img-icon", 3, "click"], ["id", "uploadConfigFile", "name", "cloud-upload"], [1, "drag-and-drop-label"], [1, "ft-upload-img-link", 3, "click"], ["id", "hiddeninput", "type", "file", 3, "change"], [3, "scale", "modal", "ovelayElement"]],
      template: function WgImageCropperComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div")(1, "div", 3)(2, "label", 4);
          i0.ɵɵtext(3);
          i0.ɵɵpipe(4, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "div", 5);
          i0.ɵɵtemplate(6, WgImageCropperComponent_div_6_Template, 4, 3, "div", 6);
          i0.ɵɵelementStart(7, "p", 7);
          i0.ɵɵtemplate(8, WgImageCropperComponent_img_8_Template, 1, 1, "img", 8);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(9, "p-fileUpload", 9, 0);
          i0.ɵɵlistener("onSelect", function WgImageCropperComponent_Template_p_fileUpload_onSelect_9_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onImageChanged($event));
          });
          i0.ɵɵtemplate(11, WgImageCropperComponent_ng_template_11_Template, 10, 6, "ng-template", 10);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(12, "wg-dialog", 11);
          i0.ɵɵlistener("dialogClosedEvent", function WgImageCropperComponent_Template_wg_dialog_dialogClosedEvent_12_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onDialogClosed());
          });
          i0.ɵɵelementStart(13, "div", 12);
          i0.ɵɵtext(14);
          i0.ɵɵpipe(15, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(16, "div", 13)(17, "div", 14, 1)(19, "image-cropper", 15);
          i0.ɵɵlistener("imageLoaded", function WgImageCropperComponent_Template_image_cropper_imageLoaded_19_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onImageLoaded());
          })("imageCropped", function WgImageCropperComponent_Template_image_cropper_imageCropped_19_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onImageCropped($event));
          })("loadImageFailed", function WgImageCropperComponent_Template_image_cropper_loadImageFailed_19_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onLoadImageFailed());
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(20, WgImageCropperComponent_wg_loader_20_Template, 1, 3, "wg-loader", 16);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(21, "div", 17)(22, "div", 18)(23, "button", 19);
          i0.ɵɵlistener("click", function WgImageCropperComponent_Template_button_click_23_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onDialogClosed());
          });
          i0.ɵɵtext(24);
          i0.ɵɵpipe(25, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(26, "button", 20);
          i0.ɵɵlistener("click", function WgImageCropperComponent_Template_button_click_26_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onImageSaved());
          });
          i0.ɵɵtext(27);
          i0.ɵɵpipe(28, "translate");
          i0.ɵɵelementEnd()()()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 20, ctx.inputLabel));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.imageDescription);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.image);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("showDialog", ctx.isDialogOpen);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 22, "image_cropper_dialog_title"));
          i0.ɵɵadvance(5);
          i0.ɵɵstyleProp("display", !ctx.showLoading ? null : "none");
          i0.ɵɵproperty("imageChangedEvent", ctx.imageChangedEvent)("format", ctx.imageFormat)("aspectRatio", ctx.aspectRatio)("maintainAspectRatio", ctx.maintainAspectRatio)("containWithinAspectRatio", ctx.containWithinAspectRatio)("cropperMinWidth", ctx.cropperMinWidth)("cropperMinHeight", ctx.cropperMinHeight)("cropperMaxWidth", ctx.cropperMaxWidth)("cropperMaxHeight", ctx.cropperMaxHeight)("imageBase64", ctx.droppedImage);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showLoading);
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(25, 24, "cancel_lbl"), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(28, 26, "save_lbl"), " ");
        }
      },
      dependencies: [i1$2.NgIf, i4.ImageCropperComponent, i2$2.FileUpload, i3.PrimeTemplate, LoaderComponent, WgDialogComponent, WgIconComponent, i1$1.TranslatePipe],
      styles: [".card-image[_ngcontent-%COMP%]{padding:0}.card-image[_ngcontent-%COMP%]   div.image-description-container[_ngcontent-%COMP%]{align-items:center;display:flex;margin:15px}.card-image[_ngcontent-%COMP%]   div.image-description-container[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{height:100%;width:100%}.card-image[_ngcontent-%COMP%]   .image[_ngcontent-%COMP%]{margin:15px}.card-image[_ngcontent-%COMP%]   p.image[_ngcontent-%COMP%]{align-items:center;display:flex;height:150px}.card-image[_ngcontent-%COMP%]   p.image[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{border:1px dashed #b5b5b5;margin:0 auto;max-height:100%;max-width:100%}.drag-and-drop-label[_ngcontent-%COMP%]{white-space:pre-wrap}.image-cropper-container[_ngcontent-%COMP%]{align-items:center;display:flex;height:400px}.image-cropper-container[_ngcontent-%COMP%]   image-cropper[_ngcontent-%COMP%]{border:1px dotted #d4d4d4;max-height:100%;max-width:100%}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgImageCropperComponent, [{
    type: Component,
    args: [{
      selector: 'wg-image-cropper',
      standalone: false,
      template: "<div>\n  <div class=\"form-group\">\n    <label for=\"icon\">{{ inputLabel | translate }}</label>\n    <div class=\"card card-body card-image\">\n      <div *ngIf=\"imageDescription\" class=\"image-description-container fs-block\">\n        <p class=\"text-center\">\n          {{ imageDescription | translate }}\n        </p>\n      </div>\n      <p class=\"image fs-block\">\n        <img *ngIf=\"image\" [src]=\"image\">\n      </p>\n\n      <p-fileUpload\n        #uploader\n        id=\"icon\"\n        name=\"icon\"\n        styleClass=\"wg-file-upload\"\n        url=\"/\"\n        (onSelect)=\"onImageChanged($event)\">\n        <ng-template pTemplate=\"content\">\n          <a class=\"ft-upload-img-icon\" (click)=\"hiddenfileselect.click()\">\n            <wg-icon id=\"uploadConfigFile\" name=\"cloud-upload\"></wg-icon>\n          </a>\n          <p class=\"drag-and-drop-label\">{{ 'image_cropper_drap_and_drop_label' | translate }}</p>\n          <a class=\"ft-upload-img-link\" (click)=\"hiddenfileselect.click()\">\n            {{ 'image_cropper_select_file_label' | translate }}\n          </a>\n          <input\n            #hiddenfileselect\n            id=\"hiddeninput\"\n            type=\"file\"\n            (change)=\"onImageChanged($event)\"/>\n        </ng-template>\n      </p-fileUpload>\n    </div>\n  </div>\n\n  <wg-dialog [showDialog]=\"isDialogOpen\" (dialogClosedEvent)=\"onDialogClosed()\">\n    <div dialog-title>{{ 'image_cropper_dialog_title' | translate }}</div>\n\n    <div dialog-content>\n      <div #imageCropperContainer class=\"form-group image-cropper-container\">\n        <image-cropper\n          output=\"base64\"\n          [imageChangedEvent]=\"imageChangedEvent\"\n          [format]=\"imageFormat\"\n          [aspectRatio]=\"aspectRatio\"\n          [maintainAspectRatio]=\"maintainAspectRatio\"\n          [containWithinAspectRatio]=\"containWithinAspectRatio\"\n          [cropperMinWidth]=\"cropperMinWidth\"\n          [cropperMinHeight]=\"cropperMinHeight\"\n          [cropperMaxWidth]=\"cropperMaxWidth\"\n          [cropperMaxHeight]=\"cropperMaxHeight\"\n          [imageBase64]=\"droppedImage\"\n          [style.display]=\"!showLoading ? null : 'none'\"\n          (imageLoaded)=\"onImageLoaded()\"\n          (imageCropped)=\"onImageCropped($event)\"\n          (loadImageFailed)=\"onLoadImageFailed()\">\n        </image-cropper>\n        <wg-loader\n          *ngIf=\"showLoading\"\n          [scale]=\"1\"\n          [modal]=\"true\"\n          [ovelayElement]=\"imageCropperContainer\">\n        </wg-loader>\n      </div>\n    </div>\n\n    <div dialog-footer>\n      <div class=\"ui-dialog-buttonpane ui-widget-content ui-helper-clearfix\">\n        <button type=\"button\" class=\"btn ft-btn-close-dialog\" (click)=\"onDialogClosed()\" >\n          {{ 'cancel_lbl' | translate }}\n        </button>\n        <button type=\"button\" class=\"btn btn-primary ft-btn-save-image\" (click)=\"onImageSaved()\">\n          {{ 'save_lbl' | translate }}\n        </button>\n      </div>\n    </div>\n  </wg-dialog>\n</div>\n",
      styles: [".card-image{padding:0}.card-image div.image-description-container{align-items:center;display:flex;margin:15px}.card-image div.image-description-container p{height:100%;width:100%}.card-image .image{margin:15px}.card-image p.image{align-items:center;display:flex;height:150px}.card-image p.image img{border:1px dashed #b5b5b5;margin:0 auto;max-height:100%;max-width:100%}.drag-and-drop-label{white-space:pre-wrap}.image-cropper-container{align-items:center;display:flex;height:400px}.image-cropper-container image-cropper{border:1px dotted #d4d4d4;max-height:100%;max-width:100%}\n"]
    }]
  }], () => [{
    type: i1$1.TranslateService
  }, {
    type: WgNotificationsService
  }], {
    inputLabel: [{
      type: Input
    }],
    image: [{
      type: Input
    }],
    imageDescription: [{
      type: Input
    }],
    imageMaxSizeErrorMessage: [{
      type: Input
    }],
    imageMaxSize: [{
      type: Input
    }],
    imageFormat: [{
      type: Input
    }],
    outputFormat: [{
      type: Input
    }],
    aspectRatio: [{
      type: Input
    }],
    maintainAspectRatio: [{
      type: Input
    }],
    containWithinAspectRatio: [{
      type: Input
    }],
    cropperMinWidth: [{
      type: Input
    }],
    cropperMinHeight: [{
      type: Input
    }],
    cropperMaxWidth: [{
      type: Input
    }],
    cropperMaxHeight: [{
      type: Input
    }],
    dialogClosed: [{
      type: Output
    }],
    imageSaved: [{
      type: Output
    }],
    loadImageFailed: [{
      type: Output
    }]
  });
})();
class WgImageCropperModule {
  static {
    this.ɵfac = function WgImageCropperModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgImageCropperModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgImageCropperModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, ImageCropperComponent, FileUploadModule, LoaderModule, TranslateModule, WgDialogModule, WgIconModule, WgNotificationsModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgImageCropperModule, [{
    type: NgModule,
    args: [{
      declarations: [WgImageCropperComponent],
      imports: [CommonModule, ImageCropperComponent, FileUploadModule, LoaderModule, TranslateModule, WgDialogModule, WgIconModule, WgNotificationsModule],
      exports: [WgImageCropperComponent]
    }]
  }], null, null);
})();

/*
 * Public API Surface of wg-ng-core
 */
/*
 * Public API Surface of wg-badge
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ACCESS_POINT, ACCESS_POINT_LICENSES, ACCOUNT_MGMT_ROOT, ADD_ACTION, ADD_TENANT_ACTION, ADMINISTRATION_NAV, ADMINISTRATION_ROOT, ALL_SERVICES, API_CONSTANTS$1 as API_CONSTANTS, APP_ACCOUNT_MGMT_DATA_API, APP_ADMINISTRATION_DATA_API, APP_ASSETS_API, APP_AUTH_DATA_API, APP_AUTH_REP_DATA_API, APP_FB_CONFIGURATION_DATA_API, APP_FB_DATA_API, APP_FIREWAN_CONFIGURE_DATA_API, APP_FIREWAN_MONITOR_DATA_API, APP_INVENTORY_DATA_API, APP_NDR_CONFIGURE_DATA_API, APP_NDR_MONITOR_DATA_API, APP_NOTIFICATIONS_DATA_API, APP_SHELL_DATA_API, APP_TDR_CONFIGURE_DATA_API, APP_TDR_MONITOR_DATA_API, APP_THREATSYNC_CONFIGURE_DATA_API, APP_THREATSYNC_MONITOR_DATA_API, APP_WHITELIST_DATA_API, AP_CONFIGURATION_WIDGETS, AUTH, AUTHPOINT, AUTHPOINT_GENERAL_SETTINGS_BASE_URL, AUTHPOINT_LICENSES, AUTHPOINT_NFR, AUTHPOINT_OVERAGE, AUTHPOINT_SUBSCRIPTION, AUTHPOINT_TIS, AUTHPOINT_TIS_NFR, AUTHPOINT_TIS_OVERAGE, AUTHPOINT_TIS_TRIAL, AUTHPOINT_TRIAL, AUTH_CONFIGURE_NAV, AUTH_LICENSES, AUTH_MONITOR_NAV, AUTH_REP_ROOT, AUTH_ROOT, AUTOHIDE_BANNER_MILLISECONDS, AbstractWgDropdownMenuComponent, AccountGroupMgrService, AccountManagementModule, AccountManagementService, AppAssetManager, AppContentLoaderService, AppObservableService, AuthDomainManagementService, AuthPointLicenseManagementService, AutofocusDirective, BackendOperatorSettingsService, BlankSpaceValidatorDirective, BlankSpaceValidatorService, CALENDAR_PRESETS, CHILDREN, CMPL, CMPL_LICENSES, CMPL_REPORT, CMPL_REPORT_NFR, CMPL_REPORT_OVERAGE, CMPL_REPORT_TRIAL, COMP_LOCATION_BOTTOM, COMP_LOCATION_CENTER, COMP_LOCATION_LEFT, COMP_LOCATION_RIGHT, COMP_LOCATION_ROOT, COMP_LOCATION_TOP, CONTENT_BREAKPOINT_CLASS, COR_CATE_ACCOUNT_ADMIN, COR_CATE_AUTHPOINT, COR_CATE_DEVICES, COR_CATE_ENDPOINT, COR_CATE_FIRECLOUD, COR_CATE_SERVICE_PROVIDER_ADMIN, COR_CATE_SUBSCRIBER_ADMIN, COR_CATE_SYSTEM_ADMIN, COR_CATE_THREAT_SYNC, CURRENT_VERSION, ClearSettings, ClickOutsideDirective, ColumnSizeClassDirective, ColumnSizeClassModule, CommaifyPipe, ComponentManager, ComponentStateLayerDirective, ContentBreakpointService, Continents, CountryCode3ToNamePipe, CssVersionDirective, CssVersionService, DEFAULTS, DEFAULT_APP_LOGO, DEFAULT_LANG, DEF_LIC_DATA, DEV_STATIC_URL, DNS_WATCH, DNS_WATCH_LICENSES, DatabaseMockHandler, DateTimeDescPipe, DeviceBannerComponent, DeviceBannerModule, DeviceService, DropdownDataSource, EqualValidatorDirective, EscapeHtmlPipe, FB_CONFIGURATION_WIDGETS, FB_CONFIGURE_NAV, FB_MONITOR_NAV, FB_ROOT, FB_ROOT_DEVICE_SUMMARY, FIREBOX, FIREBOX_DRL, FIREBOX_LICENSES, FIREWAN, FIREWAN_CONFIGURE_NAV, FIREWAN_CONFIGURE_ROOT, FIREWAN_DASHBOARD, FIREWAN_LICENSES, FIREWAN_MONITOR_NAV, FIREWAN_MONITOR_ROOT, FIREWAN_NFR, FIREWAN_OVERAGE, FIREWAN_TRIAL, FOR_BETA, FOR_GA, FormatBandwidthPipe, FormatBytesPipe, FormatHitsPipe, GET_ACTION, GeographyService, GlobalEventService, GranularRBACService, GroupMgrSrvService, HOST_SENSOR, HOST_SENSOR_LICENSES, HasLicenseDirective, HasPermissionDirective, HasPermissionV2Directive, HelpService, HighlightPipe$2 as HighlightPipe, HttpLoaderFactory, HttpMockRequestInterceptor, INVENTORY_NAV, INVENTORY_ROOT, INVENTORY_ROOT_NAV_OVERVIEW, INVENTORY_ROOT_TENANT_NAV_ACCESS_POINT, INVENTORY_ROOT_TENANT_NAV_FB, INVENTORY_ROOT_TENANT_NAV_OVERVIEW, ImageCropperImageFormat, ImageCropperOutputFormat, JsonMockHandler, JwtTokenInfoService, LICENSE_UNIT, LIST_ACTION, LOCALE_BUNDLE_MAP, LayoutTscComponent, LayoutTscModule, LeftNavService, LicenseManagementService, LoaderComponent, LoaderModule, LoaderService, LocalStorageOperatorSettingsService, LocaleResolverService, MDR_DEF, MDR_DEF_NFR, MDR_DEF_OVERAGE, MDR_TOTAL, MDR_TOTAL_NFR, MDR_TOTAL_OVERAGE, MainContentComponent, MainContentModule, MockHandler, MockUrlList, NDR, NDR_CONFIGURE_NAV, NDR_CONFIGURE_ROOT, NDR_LICENSES, NDR_MONITOR_NAV, NDR_MONITOR_ROOT, NDR_NDR, NDR_NDR_NFR, NDR_NDR_OVERAGE, NDR_NDR_TRIAL, NON_APP_COR_CATES, NOTIFICATIONS_ROOT, NoLicenseComponent, NoLicenseModule, Notification, NotificationType, NotificationWrapper, OPTIONAL, OVERVIEW_DASHBOARD_CONFIGURE_AUTH, OVERVIEW_DASHBOARD_CONFIGURE_FB, OVERVIEW_DASHBOARD_CONFIGURE_TDR, OVERVIEW_DASHBOARD_MONITOR_AUTH, OVERVIEW_DASHBOARD_MONITOR_FB, OVERVIEW_DASHBOARD_MONITOR_FIREWAN, OVERVIEW_DASHBOARD_MONITOR_TDR, OnlyNumber, OperatorSettingsService, POSITION, ProductDefType, QR_SIZE_MAP, RAPID_DEPLOY_HELP_CONTEXT_ID, RBACService, RELEASE, REMOVE_ACTION, ROOT, ROOT_ADMINISTRATION, ROOT_CONFIGURE_SERVICES, ROOT_DASHBOARD, ROOT_REPORTS, ROOT_SP_ADMINISTRATION, ROOT_SP_DASHBOARD, RangeValidator, RangeValidatorService, RemoveColumnPipe, SHELL_LEFT, SHELL_PRIMARY, SHELL_TOP, SP_ROLE_AUDITOR, SP_ROLE_HELPDESK, SP_ROLE_OWNER, SP_ROLE_SALES, SP_TENANT_DASHBOARD_CONFIGURE_AUTH, SP_TENANT_DASHBOARD_CONFIGURE_FB, SP_TENANT_DASHBOARD_CONFIGURE_TDR, SP_TENANT_DASHBOARD_MONITOR_AUTH, SP_TENANT_DASHBOARD_MONITOR_FB, SP_TENANT_DASHBOARD_MONITOR_TDR, STATIC_URL_REGEXP, SUB_ROLE_ADMIN, SUB_ROLE_ANALYST, SUB_ROLE_OBSERVER, SUPPORTED_LOCALES, SYSTEM_KEYS, SafeHtmlPipe, ScreenService, SecLeftNavChanges, SecLeftNavService, SessionService, ShowErrorsComponent, SortOrder, StaticMockHandler, SubProdModIdToLabelPipe, TDR_CONFIGURE_NAV, TDR_CONFIGURE_ROOT, TDR_MONITOR_NAV, TDR_MONITOR_ROOT, THREATSYNC, THREATSYNC_CONFIGURE_NAV, THREATSYNC_CONFIGURE_ROOT, THREATSYNC_LICENSES, THREATSYNC_MONITOR_NAV, THREATSYNC_MONITOR_ROOT, TIMEZONES, TOP_NAV_CHILDREN, TSP, TSPLUS, TSPLUS_LICENSES, TSP_LICENSES, TSP_SDR, TSP_SDR_NFR, TSP_SDR_OVERAGE, TSP_SDR_TRIAL, TSP_TXDR, TSP_TXDR_NFR, TSP_TXDR_OVERAGE, TXDR, TXDR_LICENSES, TitleCasePipe, UPDATE_ACTION, UPGRADE_ACTION, UniqueValidator, UrlPatternValidatorDirective, UrlPatternValidatorService, UtcToLocalPipe, VERIFICATION_CODE_HELP_CONTEXT_ID, ValidatorModule, WATCHGUARD_CLOUD_DIRECTORY, WESS, WESS_AD, WESS_AD360, WESS_AD360_NFR, WESS_AD360_OVERAGE, WESS_AD360_TRIAL, WESS_AD_NFR, WESS_AD_OVERAGE, WESS_AD_TRIAL, WESS_AEDPR_OVERAGE, WESS_AEPDR, WESS_AEPDR_NFR, WESS_AEPDR_TRIAL, WESS_EDR_CORE, WESS_EDR_CORE_NFR, WESS_EPP, WESS_EPPPLUS, WESS_EPPPLUS_NFR, WESS_EPPPLUS_TRIAL, WESS_EPP_NFR, WESS_EPP_OVERAGE, WESS_EPP_TRIAL, WESS_LICENSES, WESS_MODULE_ART, WESS_MODULE_ART_NFR, WESS_MODULE_DC, WESS_MODULE_DC_NFR, WESS_MODULE_FE, WESS_MODULE_FE_NFR, WESS_MODULE_MDR, WESS_MODULE_MDR_NFR, WESS_MODULE_Orion, WESS_MODULE_Orion_NFR, WESS_MODULE_PM, WESS_MODULE_PM_NFR, WESS_MODULE_SF, WESS_MODULE_SF_NFR, WGDROPDOWN_ASYNC_VALUE_ACCESSOR, WGDROPDOWN_VALUE_ACCESSOR, WGMDR, WGMDR_LICENSES, WGSelectorModule, WG_ROUTE_ANIMATIONS, WIFI, WgAccountInfoModule, WgAccountInfoService, WgAsyncReportsComponent, WgAsyncReportsModule, WgAsyncReportsService, WgAuthDomainManagementModule, WgAutofocusModule, WgBadgeComponent, WgBaseService, WgBlockEmojiDirective, WgBlockEmojiModule, WgBreadcrumbsComponent, WgBreadcrumbsModule, WgBreadcrumbsService, WgButtonComponent, WgButtonDropdownMenuComponent, WgButtonDropdownMenuModule, WgButtonModule, WgCalendarInfoModule, WgCalendarInfoService, WgCardComponent, WgCardModule, WgChipsComponent, WgChipsModule, WgClickOutsideModule, WgColors, WgConfirmDialogComponent, WgConfirmDialogModule, WgConfirmProgressDialogComponent, WgConfirmProgressDialogModule, WgContainerQueryDirective, WgContainerQueryModule, WgCssColors, WgDialogComponent, WgDialogModule, WgDialogNavButtonsDirective, WgDialogService, WgDirectiveModule, WgDividerComponent, WgDividerOrientation, WgDropdownAsyncComponent, WgDropdownComponent, WgDropdownMegaMenuComponent, WgDropdownMegaMenuModule, WgDropdownMenuComponent, WgDropdownMenuModule, WgDropdownModule, WgDynamicConfirmDialog, WgDynamicDialog, WgExpanderComponent, WgExpanderModule, WgFeatureToggleDirective, WgFeatureToggleModule, WgFeatureToggleService, WgFileUploadComponent, WgFileUploadModule, WgFlexibleGridDirective, WgFlexibleGridModule, WgHListComponent, WgHListLabelComponent, WgHListLinkComponent, WgHasLicenseModule, WgHasPermissionModule, WgHideShowPasswordComponent, WgHideShowPasswordModule, WgIconComponent, WgIconModule, WgIconService, WgIconSizeInPixels, WgIconSizes, WgImageCropperComponent, WgImageCropperModule, WgImagesModule, WgInfoPopoverComponent, WgInfoPopoverModule, WgInlineNotificationComponent, WgInlineNotificationModule, WgLabelValueComponent, WgLicenseManagementModule, WgLinkComponent, WgLocalizedImageComponent, WgNotificationsComponent, WgNotificationsModule, WgNotificationsService, WgOnlyNumberModule, WgPanelComponent, WgPanelContentComponent, WgPanelHeaderComponent, WgPanelHeaderLeftComponent, WgPanelHeaderRightComponent, WgPanelModule, WgPipesModule, WgProdDefModule, WgProdDefService, WgProgressBarComponent, WgProgressComponent, WgProgressModule, WgQrcodeBannerComponent, WgQrcodeComponent, WgQrcodeModule, WgRadioComponent, WgRadioModule, WgRbacModule, WgRefreshComponent, WgRefreshModule, WgRefreshService, WgSchedulerComponent, WgSchedulerResizerType, WgSelectButtonComponent, WgSelectButtonModule, WgSelectorComponent, WgServicesModule, WgSessionModule, WgSlideInPanelComponent, WgSlideInPanelContainerComponent, WgSlideInPanelContainerModule, WgSlideInPanelContentComponent, WgSlideInPanelExpanderComponent, WgSlideInPanelModule, WgSlideInPanelTitleComponent, WgTimeFormatValidatorDirective, WgTimeFormatValidatorService, WgTimeInputDirective, WgTimeInputModule, WgToggleComponent, WgToggleModule, WgTooltipDirective, WgTooltipModule, WgWidgetPanelComponent, WgWidgetPanelModule, WidgetDirective, WidgetItem, WidgetLicenseType, WidgetType, XSSPatternValidatorDirective, XSSPatternValidatorService, areSame, blockedCharacters, commaify, convertDevIdForObjs, createCSVFile, cyrb64Hash, deepCopy, deepCopyArray, diffList, downloadCSVFile, downloadFile, elemPresentInArray, extractMultipleValues, extractValues, fade, filterList, findInList, fixMainCssUrls, getDynamicUiWidgets, getEnv, getFolkloreBaseApi, getHelpContextURLById, getLicenseStatus, getLicenseStatusByDays, getRegion, getWindowHeight, getWindowResizeObservable, getWindowWidth, guardURL, hasAlphaNumSpecial, hasInvalidChars, hasValidLength, idHasPrefix, isAP, isCluster, isElementInViewport, isEmpty, isInt, isNum, isNumber, isValidDate, isValidUserPassword, merge, newGuardApiUrl, newGuardUrl, parseToken, resetElems, resolveObjDevToDevId, scrollIntoViewAndFocus, serviceHasLicense, slideOverLeftEnterAnimation, slideOverLeftEnterParams, slideOverLeftLeaveAnimation, slideOverLeftLeaveParams, stripIdPrefix, uniqueList, validEmailFieldSimple, validUsernameSimple, wgRouteAnimations };
